import './index.css';var Ro = (e) => {
  throw TypeError(e);
};
var da = (e, t, n) => t.has(e) || Ro("Cannot " + n);
var B = (e, t, n) => (da(e, t, "read from private field"), n ? n.call(e) : t.get(e)), j1 = (e, t, n) => t.has(e) ? Ro("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), _1 = (e, t, n, r) => (da(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n), $1 = (e, t, n) => (da(e, t, "access private method"), n);
var Jr = (e, t, n, r) => ({
  set _(a) {
    _1(e, t, a, n);
  },
  get _() {
    return B(e, t, r);
  }
});
import * as o from "react";
import l1, { createContext as o2, useCallback as W1, useContext as D1, useState as r1, useEffect as u1, useMemo as Xe, useRef as V1, useLayoutEffect as _n, forwardRef as V, useImperativeHandle as J5, Children as No, cloneElement as W6, isValidElement as fa, memo as e4, createElement as U6, Fragment as z6 } from "react";
import t4, { createPortal as q6 } from "react-dom";
var n4 = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function $6(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ei = { exports: {} }, hr = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ho;
function Y6() {
  if (Ho) return hr;
  Ho = 1;
  var e = l1, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(s, c, p) {
    var h, u = {}, m = null, d = null;
    p !== void 0 && (m = "" + p), c.key !== void 0 && (m = "" + c.key), c.ref !== void 0 && (d = c.ref);
    for (h in c) r.call(c, h) && !i.hasOwnProperty(h) && (u[h] = c[h]);
    if (s && s.defaultProps) for (h in c = s.defaultProps, c) u[h] === void 0 && (u[h] = c[h]);
    return { $$typeof: t, type: s, key: m, ref: d, props: u, _owner: a.current };
  }
  return hr.Fragment = n, hr.jsx = l, hr.jsxs = l, hr;
}
var pr = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Oo;
function K6() {
  return Oo || (Oo = 1, process.env.NODE_ENV !== "production" && function() {
    var e = l1, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), h = Symbol.for("react.suspense_list"), u = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), d = Symbol.for("react.offscreen"), v = Symbol.iterator, x = "@@iterator";
    function k(y) {
      if (y === null || typeof y != "object")
        return null;
      var P = v && y[v] || y[x];
      return typeof P == "function" ? P : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function T(y) {
      {
        for (var P = arguments.length, F = new Array(P > 1 ? P - 1 : 0), t1 = 1; t1 < P; t1++)
          F[t1 - 1] = arguments[t1];
        L("error", y, F);
      }
    }
    function L(y, P, F) {
      {
        var t1 = I.ReactDebugCurrentFrame, w1 = t1.getStackAddendum();
        w1 !== "" && (P += "%s", F = F.concat([w1]));
        var L1 = F.map(function(g1) {
          return String(g1);
        });
        L1.unshift("Warning: " + P), Function.prototype.apply.call(console[y], console, L1);
      }
    }
    var S = !1, E = !1, j = !1, g = !1, w = !1, C;
    C = Symbol.for("react.module.reference");
    function b(y) {
      return !!(typeof y == "string" || typeof y == "function" || y === r || y === i || w || y === a || y === p || y === h || g || y === d || S || E || j || typeof y == "object" && y !== null && (y.$$typeof === m || y.$$typeof === u || y.$$typeof === l || y.$$typeof === s || y.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      y.$$typeof === C || y.getModuleId !== void 0));
    }
    function M(y, P, F) {
      var t1 = y.displayName;
      if (t1)
        return t1;
      var w1 = P.displayName || P.name || "";
      return w1 !== "" ? F + "(" + w1 + ")" : F;
    }
    function R(y) {
      return y.displayName || "Context";
    }
    function O(y) {
      if (y == null)
        return null;
      if (typeof y.tag == "number" && T("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof y == "function")
        return y.displayName || y.name || null;
      if (typeof y == "string")
        return y;
      switch (y) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case h:
          return "SuspenseList";
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case s:
            var P = y;
            return R(P) + ".Consumer";
          case l:
            var F = y;
            return R(F._context) + ".Provider";
          case c:
            return M(y, y.render, "ForwardRef");
          case u:
            var t1 = y.displayName || null;
            return t1 !== null ? t1 : O(y.type) || "Memo";
          case m: {
            var w1 = y, L1 = w1._payload, g1 = w1._init;
            try {
              return O(g1(L1));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var N = Object.assign, H = 0, Z, z, K, D, W, q, e1;
    function o1() {
    }
    o1.__reactDisabledLog = !0;
    function c1() {
      {
        if (H === 0) {
          Z = console.log, z = console.info, K = console.warn, D = console.error, W = console.group, q = console.groupCollapsed, e1 = console.groupEnd;
          var y = {
            configurable: !0,
            enumerable: !0,
            value: o1,
            writable: !0
          };
          Object.defineProperties(console, {
            info: y,
            log: y,
            warn: y,
            error: y,
            group: y,
            groupCollapsed: y,
            groupEnd: y
          });
        }
        H++;
      }
    }
    function v1() {
      {
        if (H--, H === 0) {
          var y = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: N({}, y, {
              value: Z
            }),
            info: N({}, y, {
              value: z
            }),
            warn: N({}, y, {
              value: K
            }),
            error: N({}, y, {
              value: D
            }),
            group: N({}, y, {
              value: W
            }),
            groupCollapsed: N({}, y, {
              value: q
            }),
            groupEnd: N({}, y, {
              value: e1
            })
          });
        }
        H < 0 && T("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var m1 = I.ReactCurrentDispatcher, $;
    function n1(y, P, F) {
      {
        if ($ === void 0)
          try {
            throw Error();
          } catch (w1) {
            var t1 = w1.stack.trim().match(/\n( *(at )?)/);
            $ = t1 && t1[1] || "";
          }
        return `
` + $ + y;
      }
    }
    var d1 = !1, f1;
    {
      var M1 = typeof WeakMap == "function" ? WeakMap : Map;
      f1 = new M1();
    }
    function Y(y, P) {
      if (!y || d1)
        return "";
      {
        var F = f1.get(y);
        if (F !== void 0)
          return F;
      }
      var t1;
      d1 = !0;
      var w1 = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L1;
      L1 = m1.current, m1.current = null, c1();
      try {
        if (P) {
          var g1 = function() {
            throw Error();
          };
          if (Object.defineProperty(g1.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(g1, []);
            } catch (Y1) {
              t1 = Y1;
            }
            Reflect.construct(y, [], g1);
          } else {
            try {
              g1.call();
            } catch (Y1) {
              t1 = Y1;
            }
            y.call(g1.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Y1) {
            t1 = Y1;
          }
          y();
        }
      } catch (Y1) {
        if (Y1 && t1 && typeof Y1.stack == "string") {
          for (var p1 = Y1.stack.split(`
`), X1 = t1.stack.split(`
`), y1 = p1.length - 1, H1 = X1.length - 1; y1 >= 1 && H1 >= 0 && p1[y1] !== X1[H1]; )
            H1--;
          for (; y1 >= 1 && H1 >= 0; y1--, H1--)
            if (p1[y1] !== X1[H1]) {
              if (y1 !== 1 || H1 !== 1)
                do
                  if (y1--, H1--, H1 < 0 || p1[y1] !== X1[H1]) {
                    var T1 = `
` + p1[y1].replace(" at new ", " at ");
                    return y.displayName && T1.includes("<anonymous>") && (T1 = T1.replace("<anonymous>", y.displayName)), typeof y == "function" && f1.set(y, T1), T1;
                  }
                while (y1 >= 1 && H1 >= 0);
              break;
            }
        }
      } finally {
        d1 = !1, m1.current = L1, v1(), Error.prepareStackTrace = w1;
      }
      var Ce = y ? y.displayName || y.name : "", Ge = Ce ? n1(Ce) : "";
      return typeof y == "function" && f1.set(y, Ge), Ge;
    }
    function P1(y, P, F) {
      return Y(y, !1);
    }
    function J1(y) {
      var P = y.prototype;
      return !!(P && P.isReactComponent);
    }
    function I1(y, P, F) {
      if (y == null)
        return "";
      if (typeof y == "function")
        return Y(y, J1(y));
      if (typeof y == "string")
        return n1(y);
      switch (y) {
        case p:
          return n1("Suspense");
        case h:
          return n1("SuspenseList");
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case c:
            return P1(y.render);
          case u:
            return I1(y.type, P, F);
          case m: {
            var t1 = y, w1 = t1._payload, L1 = t1._init;
            try {
              return I1(L1(w1), P, F);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, ve = {}, oe = I.ReactDebugCurrentFrame;
    function x1(y) {
      if (y) {
        var P = y._owner, F = I1(y.type, y._source, P ? P.type : null);
        oe.setExtraStackFrame(F);
      } else
        oe.setExtraStackFrame(null);
    }
    function ae(y, P, F, t1, w1) {
      {
        var L1 = Function.call.bind(ce);
        for (var g1 in y)
          if (L1(y, g1)) {
            var p1 = void 0;
            try {
              if (typeof y[g1] != "function") {
                var X1 = Error((t1 || "React class") + ": " + F + " type `" + g1 + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof y[g1] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X1.name = "Invariant Violation", X1;
              }
              p1 = y[g1](P, g1, t1, F, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (y1) {
              p1 = y1;
            }
            p1 && !(p1 instanceof Error) && (x1(w1), T("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", t1 || "React class", F, g1, typeof p1), x1(null)), p1 instanceof Error && !(p1.message in ve) && (ve[p1.message] = !0, x1(w1), T("Failed %s type: %s", F, p1.message), x1(null));
          }
      }
    }
    var ke = Array.isArray;
    function Ie(y) {
      return ke(y);
    }
    function ye(y) {
      {
        var P = typeof Symbol == "function" && Symbol.toStringTag, F = P && y[Symbol.toStringTag] || y.constructor.name || "Object";
        return F;
      }
    }
    function Ye(y) {
      try {
        return Ne(y), !1;
      } catch {
        return !0;
      }
    }
    function Ne(y) {
      return "" + y;
    }
    function K1(y) {
      if (Ye(y))
        return T("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ye(y)), Ne(y);
    }
    var be = I.ReactCurrentOwner, He = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Oe, Pe;
    function Ze(y) {
      if (ce.call(y, "ref")) {
        var P = Object.getOwnPropertyDescriptor(y, "ref").get;
        if (P && P.isReactWarning)
          return !1;
      }
      return y.ref !== void 0;
    }
    function Re(y) {
      if (ce.call(y, "key")) {
        var P = Object.getOwnPropertyDescriptor(y, "key").get;
        if (P && P.isReactWarning)
          return !1;
      }
      return y.key !== void 0;
    }
    function ne(y, P) {
      typeof y.ref == "string" && be.current;
    }
    function A1(y, P) {
      {
        var F = function() {
          Oe || (Oe = !0, T("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", P));
        };
        F.isReactWarning = !0, Object.defineProperty(y, "key", {
          get: F,
          configurable: !0
        });
      }
    }
    function ze(y, P) {
      {
        var F = function() {
          Pe || (Pe = !0, T("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", P));
        };
        F.isReactWarning = !0, Object.defineProperty(y, "ref", {
          get: F,
          configurable: !0
        });
      }
    }
    var _e = function(y, P, F, t1, w1, L1, g1) {
      var p1 = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: y,
        key: P,
        ref: F,
        props: g1,
        // Record the component responsible for creating this element.
        _owner: L1
      };
      return p1._store = {}, Object.defineProperty(p1._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(p1, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: t1
      }), Object.defineProperty(p1, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w1
      }), Object.freeze && (Object.freeze(p1.props), Object.freeze(p1)), p1;
    };
    function De(y, P, F, t1, w1) {
      {
        var L1, g1 = {}, p1 = null, X1 = null;
        F !== void 0 && (K1(F), p1 = "" + F), Re(P) && (K1(P.key), p1 = "" + P.key), Ze(P) && (X1 = P.ref, ne(P, w1));
        for (L1 in P)
          ce.call(P, L1) && !He.hasOwnProperty(L1) && (g1[L1] = P[L1]);
        if (y && y.defaultProps) {
          var y1 = y.defaultProps;
          for (L1 in y1)
            g1[L1] === void 0 && (g1[L1] = y1[L1]);
        }
        if (p1 || X1) {
          var H1 = typeof y == "function" ? y.displayName || y.name || "Unknown" : y;
          p1 && A1(g1, H1), X1 && ze(g1, H1);
        }
        return _e(y, p1, X1, w1, t1, be.current, g1);
      }
    }
    var je = I.ReactCurrentOwner, Se = I.ReactDebugCurrentFrame;
    function se(y) {
      if (y) {
        var P = y._owner, F = I1(y.type, y._source, P ? P.type : null);
        Se.setExtraStackFrame(F);
      } else
        Se.setExtraStackFrame(null);
    }
    var xe;
    xe = !1;
    function Le(y) {
      return typeof y == "object" && y !== null && y.$$typeof === t;
    }
    function Ee() {
      {
        if (je.current) {
          var y = O(je.current.type);
          if (y)
            return `

Check the render method of \`` + y + "`.";
        }
        return "";
      }
    }
    function Z1(y) {
      return "";
    }
    var C1 = {};
    function Q(y) {
      {
        var P = Ee();
        if (!P) {
          var F = typeof y == "string" ? y : y.displayName || y.name;
          F && (P = `

Check the top-level render call using <` + F + ">.");
        }
        return P;
      }
    }
    function a1(y, P) {
      {
        if (!y._store || y._store.validated || y.key != null)
          return;
        y._store.validated = !0;
        var F = Q(P);
        if (C1[F])
          return;
        C1[F] = !0;
        var t1 = "";
        y && y._owner && y._owner !== je.current && (t1 = " It was passed a child from " + O(y._owner.type) + "."), se(y), T('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', F, t1), se(null);
      }
    }
    function B1(y, P) {
      {
        if (typeof y != "object")
          return;
        if (Ie(y))
          for (var F = 0; F < y.length; F++) {
            var t1 = y[F];
            Le(t1) && a1(t1, P);
          }
        else if (Le(y))
          y._store && (y._store.validated = !0);
        else if (y) {
          var w1 = k(y);
          if (typeof w1 == "function" && w1 !== y.entries)
            for (var L1 = w1.call(y), g1; !(g1 = L1.next()).done; )
              Le(g1.value) && a1(g1.value, P);
        }
      }
    }
    function ie(y) {
      {
        var P = y.type;
        if (P == null || typeof P == "string")
          return;
        var F;
        if (typeof P == "function")
          F = P.propTypes;
        else if (typeof P == "object" && (P.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        P.$$typeof === u))
          F = P.propTypes;
        else
          return;
        if (F) {
          var t1 = O(P);
          ae(F, y.props, "prop", t1, y);
        } else if (P.PropTypes !== void 0 && !xe) {
          xe = !0;
          var w1 = O(P);
          T("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w1 || "Unknown");
        }
        typeof P.getDefaultProps == "function" && !P.getDefaultProps.isReactClassApproved && T("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function A(y) {
      {
        for (var P = Object.keys(y.props), F = 0; F < P.length; F++) {
          var t1 = P[F];
          if (t1 !== "children" && t1 !== "key") {
            se(y), T("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", t1), se(null);
            break;
          }
        }
        y.ref !== null && (se(y), T("Invalid attribute `ref` supplied to `React.Fragment`."), se(null));
      }
    }
    var G = {};
    function U(y, P, F, t1, w1, L1) {
      {
        var g1 = b(y);
        if (!g1) {
          var p1 = "";
          (y === void 0 || typeof y == "object" && y !== null && Object.keys(y).length === 0) && (p1 += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X1 = Z1();
          X1 ? p1 += X1 : p1 += Ee();
          var y1;
          y === null ? y1 = "null" : Ie(y) ? y1 = "array" : y !== void 0 && y.$$typeof === t ? (y1 = "<" + (O(y.type) || "Unknown") + " />", p1 = " Did you accidentally export a JSX literal instead of a component?") : y1 = typeof y, T("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", y1, p1);
        }
        var H1 = De(y, P, F, w1, L1);
        if (H1 == null)
          return H1;
        if (g1) {
          var T1 = P.children;
          if (T1 !== void 0)
            if (t1)
              if (Ie(T1)) {
                for (var Ce = 0; Ce < T1.length; Ce++)
                  B1(T1[Ce], y);
                Object.freeze && Object.freeze(T1);
              } else
                T("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              B1(T1, y);
        }
        if (ce.call(P, "key")) {
          var Ge = O(y), Y1 = Object.keys(P).filter(function(ua) {
            return ua !== "key";
          }), u2 = Y1.length > 0 ? "{key: someKey, " + Y1.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!G[Ge + u2]) {
            var z2 = Y1.length > 0 ? "{" + Y1.join(": ..., ") + ": ...}" : "{}";
            T(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, u2, Ge, z2, Ge), G[Ge + u2] = !0;
          }
        }
        return y === r ? A(H1) : ie(H1), H1;
      }
    }
    function s1(y, P, F) {
      return U(y, P, F, !0);
    }
    function E1(y, P, F) {
      return U(y, P, F, !1);
    }
    var O1 = E1, R1 = s1;
    pr.Fragment = r, pr.jsx = O1, pr.jsxs = R1;
  }()), pr;
}
process.env.NODE_ENV === "production" ? ei.exports = Y6() : ei.exports = K6();
var f = ei.exports;
const Be = 88495267, D2 = 3252498, Fe = 3247783, _2 = 3543805, Q6 = {
  counters: {
    tmr: {
      proxy_gen: [
        Fe,
        _2
      ]
    },
    ym: [
      Be
    ]
  },
  reachGoal: {
    tmr: {
      proxy_gen: [
        Fe
      ]
    },
    ym: Be
  }
}, X6 = {
  counters: {
    tmr: {
      proxy_gen: [
        Fe,
        _2,
        D2
      ]
    },
    ym: [
      Be,
      96133379
    ]
  },
  reachGoal: {
    tmr: {
      proxy_gen: [
        Fe
      ]
    },
    ym: Be
  }
}, J6 = {
  counters: {
    tmr: {
      proxy_gen: [
        Fe,
        _2
      ]
    },
    ym: [
      Be
    ]
  },
  reachGoal: {
    tmr: {
      proxy_gen: [
        Fe
      ]
    },
    ym: Be
  }
}, el = {
  counters: {
    tmr: {
      proxy_gen: [
        Fe,
        _2,
        D2
      ]
    },
    ym: [
      Be,
      90571057
    ]
  },
  reachGoal: {
    tmr: {
      proxy_gen: [
        Fe
      ]
    },
    ym: Be
  }
}, tl = {
  counters: {
    tmr: {
      proxy_gen: [
        Fe,
        D2,
        3299536
      ]
    },
    ym: [
      Be,
      96133357
    ]
  },
  reachGoal: {
    tmr: {
      proxy_gen: [
        Fe,
        D2,
        3299536
      ]
    },
    ym: Be
  }
}, nl = {
  counters: {
    tmr: {
      proxy_gen: [
        Fe,
        _2,
        D2,
        3295687
      ]
    },
    ym: [
      Be,
      93678783
    ]
  }
}, rl = {
  counters: {
    tmr: {
      proxy_gen: [
        Fe,
        _2,
        3252495
      ]
    },
    ym: [
      Be,
      53417758
    ]
  },
  reachGoal: {
    tmr: {
      proxy_gen: [
        Fe,
        3252495
      ]
    },
    ym: Be
  }
}, al = {
  counters: {
    tmr: {
      proxy_gen: [
        Fe,
        _2,
        D2
      ]
    },
    ym: [
      Be,
      96244114
    ]
  },
  reachGoal: {
    tmr: {
      proxy_gen: [
        Fe,
        D2
      ]
    },
    ym: Be
  }
}, il = {
  counters: {
    tmr: {
      proxy_gen: [
        Fe,
        _2,
        D2
      ]
    },
    ym: [
      Be,
      96133365
    ]
  }
}, ol = {
  counters: {
    tmr: {
      proxy_gen: [
        Fe,
        3543807,
        3252494
      ]
    },
    ym: [
      Be,
      96661035
    ]
  },
  reachGoal: {
    tmr: {
      proxy_gen: [
        Fe,
        3252494
      ]
    },
    ym: Be
  }
}, sl = {
  counters: {
    tmr: {
      proxy_gen: [
        Fe
      ]
    },
    ym: [
      Be,
      96133357
    ]
  },
  reachGoal: {
    tmr: {
      proxy_gen: [
        Fe
      ]
    },
    ym: Be
  }
}, ll = {
  counters: {
    tmr: {
      proxy_gen: [
        Fe,
        _2,
        3252497,
        3385732
      ]
    },
    ym: [
      Be,
      96133340
    ]
  },
  reachGoal: {
    tmr: {
      proxy_gen: [
        Fe,
        3252497
      ]
    },
    ym: Be
  },
  formatters: {
    formatTMRReachGoalParams: (e) => {
      const {
        action: t,
        label: n,
        additionalData: r,
        category: a = "media"
      } = e || {}, i = r || n;
      return {
        category: a,
        action: t,
        ...i && { label: i }
      };
    },
    formatYMReachGoalParams: (e) => {
      const { action: t, label: n, category: r = "media" } = e || {}, a = n ? `_${n}` : "";
      return {
        vkplay_events: {
          vkplay_events: `${r}_${t}${a}`
        }
      };
    }
  }
};
function jo(e, t) {
  return typeof t == "string" || typeof t == "number" ? e.push(t) : e = e.concat(t), e;
}
function e0(e, t) {
  if (e && t) {
    let n = [];
    return n = jo(n, e), n = jo(n, t), [...new Set(n)];
  }
  return e || t;
}
const Ki = {
  base: Q6,
  eva: J6,
  store: al,
  media: ll,
  pvp: rl,
  market: tl,
  support: il,
  mini: nl,
  community: X6,
  lts: el,
  live: ol,
  partner: sl
}, ti = (e) => Ki[e].counters, cl = (e) => Ki[e].reachGoal, ul = (e) => Ki[e].formatters || {}, r4 = (e, t) => {
  var n, r, a, i, l, s;
  const c = ti(e);
  if (!c)
    return null;
  if (t) {
    const p = ti(t);
    return p ? {
      tmr: {
        ...!!((n = c.tmr) != null && n.base) && {
          base: e0(c.tmr.base, (r = p.tmr) == null ? void 0 : r.base)
        },
        ...!!((a = c.tmr) != null && a.proxy) && {
          proxy: e0(c.tmr.proxy, (i = p.tmr) == null ? void 0 : i.proxy)
        },
        ...!!((l = c.tmr) != null && l.proxy_gen) && {
          proxy_gen: e0(c.tmr.proxy_gen, (s = p.tmr) == null ? void 0 : s.proxy_gen)
        }
      },
      ym: e0(c.ym, p.ym)
    } : c;
  }
  return c;
};
var ni = { exports: {} }, kn = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var ha, Po;
function a4() {
  if (Po) return ha;
  Po = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var l = {}, s = 0; s < 10; s++)
        l["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(l).map(function(h) {
        return l[h];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var p = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(h) {
        p[h] = h;
      }), Object.keys(Object.assign({}, p)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return ha = a() ? Object.assign : function(i, l) {
    for (var s, c = r(i), p, h = 1; h < arguments.length; h++) {
      s = Object(arguments[h]);
      for (var u in s)
        t.call(s, u) && (c[u] = s[u]);
      if (e) {
        p = e(s);
        for (var m = 0; m < p.length; m++)
          n.call(s, p[m]) && (c[p[m]] = s[p[m]]);
      }
    }
    return c;
  }, ha;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Do;
function dl() {
  if (Do) return kn;
  Do = 1, a4();
  var e = l1, t = 60103;
  if (kn.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var n = Symbol.for;
    t = n("react.element"), kn.Fragment = n("react.fragment");
  }
  var r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = Object.prototype.hasOwnProperty, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(s, c, p) {
    var h, u = {}, m = null, d = null;
    p !== void 0 && (m = "" + p), c.key !== void 0 && (m = "" + c.key), c.ref !== void 0 && (d = c.ref);
    for (h in c) a.call(c, h) && !i.hasOwnProperty(h) && (u[h] = c[h]);
    if (s && s.defaultProps) for (h in c = s.defaultProps, c) u[h] === void 0 && (u[h] = c[h]);
    return { $$typeof: t, type: s, key: m, ref: d, props: u, _owner: r.current };
  }
  return kn.jsx = l, kn.jsxs = l, kn;
}
var Vo = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Bo;
function fl() {
  return Bo || (Bo = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var t = l1, n = a4(), r = 60103, a = 60106;
      e.Fragment = 60107;
      var i = 60108, l = 60114, s = 60109, c = 60110, p = 60112, h = 60113, u = 60120, m = 60115, d = 60116, v = 60121, x = 60122, k = 60117, I = 60129, T = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var L = Symbol.for;
        r = L("react.element"), a = L("react.portal"), e.Fragment = L("react.fragment"), i = L("react.strict_mode"), l = L("react.profiler"), s = L("react.provider"), c = L("react.context"), p = L("react.forward_ref"), h = L("react.suspense"), u = L("react.suspense_list"), m = L("react.memo"), d = L("react.lazy"), v = L("react.block"), x = L("react.server.block"), k = L("react.fundamental"), L("react.scope"), L("react.opaque.id"), I = L("react.debug_trace_mode"), L("react.offscreen"), T = L("react.legacy_hidden");
      }
      var S = typeof Symbol == "function" && Symbol.iterator, E = "@@iterator";
      function j(A) {
        if (A === null || typeof A != "object")
          return null;
        var G = S && A[S] || A[E];
        return typeof G == "function" ? G : null;
      }
      var g = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function w(A) {
        {
          for (var G = arguments.length, U = new Array(G > 1 ? G - 1 : 0), s1 = 1; s1 < G; s1++)
            U[s1 - 1] = arguments[s1];
          C("error", A, U);
        }
      }
      function C(A, G, U) {
        {
          var s1 = g.ReactDebugCurrentFrame, E1 = s1.getStackAddendum();
          E1 !== "" && (G += "%s", U = U.concat([E1]));
          var O1 = U.map(function(R1) {
            return "" + R1;
          });
          O1.unshift("Warning: " + G), Function.prototype.apply.call(console[A], console, O1);
        }
      }
      var b = !1;
      function M(A) {
        return !!(typeof A == "string" || typeof A == "function" || A === e.Fragment || A === l || A === I || A === i || A === h || A === u || A === T || b || typeof A == "object" && A !== null && (A.$$typeof === d || A.$$typeof === m || A.$$typeof === s || A.$$typeof === c || A.$$typeof === p || A.$$typeof === k || A.$$typeof === v || A[0] === x));
      }
      function R(A, G, U) {
        var s1 = G.displayName || G.name || "";
        return A.displayName || (s1 !== "" ? U + "(" + s1 + ")" : U);
      }
      function O(A) {
        return A.displayName || "Context";
      }
      function N(A) {
        if (A == null)
          return null;
        if (typeof A.tag == "number" && w("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof A == "function")
          return A.displayName || A.name || null;
        if (typeof A == "string")
          return A;
        switch (A) {
          case e.Fragment:
            return "Fragment";
          case a:
            return "Portal";
          case l:
            return "Profiler";
          case i:
            return "StrictMode";
          case h:
            return "Suspense";
          case u:
            return "SuspenseList";
        }
        if (typeof A == "object")
          switch (A.$$typeof) {
            case c:
              var G = A;
              return O(G) + ".Consumer";
            case s:
              var U = A;
              return O(U._context) + ".Provider";
            case p:
              return R(A, A.render, "ForwardRef");
            case m:
              return N(A.type);
            case v:
              return N(A._render);
            case d: {
              var s1 = A, E1 = s1._payload, O1 = s1._init;
              try {
                return N(O1(E1));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var H = 0, Z, z, K, D, W, q, e1;
      function o1() {
      }
      o1.__reactDisabledLog = !0;
      function c1() {
        {
          if (H === 0) {
            Z = console.log, z = console.info, K = console.warn, D = console.error, W = console.group, q = console.groupCollapsed, e1 = console.groupEnd;
            var A = {
              configurable: !0,
              enumerable: !0,
              value: o1,
              writable: !0
            };
            Object.defineProperties(console, {
              info: A,
              log: A,
              warn: A,
              error: A,
              group: A,
              groupCollapsed: A,
              groupEnd: A
            });
          }
          H++;
        }
      }
      function v1() {
        {
          if (H--, H === 0) {
            var A = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: n({}, A, {
                value: Z
              }),
              info: n({}, A, {
                value: z
              }),
              warn: n({}, A, {
                value: K
              }),
              error: n({}, A, {
                value: D
              }),
              group: n({}, A, {
                value: W
              }),
              groupCollapsed: n({}, A, {
                value: q
              }),
              groupEnd: n({}, A, {
                value: e1
              })
            });
          }
          H < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var m1 = g.ReactCurrentDispatcher, $;
      function n1(A, G, U) {
        {
          if ($ === void 0)
            try {
              throw Error();
            } catch (E1) {
              var s1 = E1.stack.trim().match(/\n( *(at )?)/);
              $ = s1 && s1[1] || "";
            }
          return `
` + $ + A;
        }
      }
      var d1 = !1, f1;
      {
        var M1 = typeof WeakMap == "function" ? WeakMap : Map;
        f1 = new M1();
      }
      function Y(A, G) {
        if (!A || d1)
          return "";
        {
          var U = f1.get(A);
          if (U !== void 0)
            return U;
        }
        var s1;
        d1 = !0;
        var E1 = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var O1;
        O1 = m1.current, m1.current = null, c1();
        try {
          if (G) {
            var R1 = function() {
              throw Error();
            };
            if (Object.defineProperty(R1.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(R1, []);
              } catch (p1) {
                s1 = p1;
              }
              Reflect.construct(A, [], R1);
            } else {
              try {
                R1.call();
              } catch (p1) {
                s1 = p1;
              }
              A.call(R1.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (p1) {
              s1 = p1;
            }
            A();
          }
        } catch (p1) {
          if (p1 && s1 && typeof p1.stack == "string") {
            for (var y = p1.stack.split(`
`), P = s1.stack.split(`
`), F = y.length - 1, t1 = P.length - 1; F >= 1 && t1 >= 0 && y[F] !== P[t1]; )
              t1--;
            for (; F >= 1 && t1 >= 0; F--, t1--)
              if (y[F] !== P[t1]) {
                if (F !== 1 || t1 !== 1)
                  do
                    if (F--, t1--, t1 < 0 || y[F] !== P[t1]) {
                      var w1 = `
` + y[F].replace(" at new ", " at ");
                      return typeof A == "function" && f1.set(A, w1), w1;
                    }
                  while (F >= 1 && t1 >= 0);
                break;
              }
          }
        } finally {
          d1 = !1, m1.current = O1, v1(), Error.prepareStackTrace = E1;
        }
        var L1 = A ? A.displayName || A.name : "", g1 = L1 ? n1(L1) : "";
        return typeof A == "function" && f1.set(A, g1), g1;
      }
      function P1(A, G, U) {
        return Y(A, !1);
      }
      function J1(A) {
        var G = A.prototype;
        return !!(G && G.isReactComponent);
      }
      function I1(A, G, U) {
        if (A == null)
          return "";
        if (typeof A == "function")
          return Y(A, J1(A));
        if (typeof A == "string")
          return n1(A);
        switch (A) {
          case h:
            return n1("Suspense");
          case u:
            return n1("SuspenseList");
        }
        if (typeof A == "object")
          switch (A.$$typeof) {
            case p:
              return P1(A.render);
            case m:
              return I1(A.type, G, U);
            case v:
              return P1(A._render);
            case d: {
              var s1 = A, E1 = s1._payload, O1 = s1._init;
              try {
                return I1(O1(E1), G, U);
              } catch {
              }
            }
          }
        return "";
      }
      var ce = {}, ve = g.ReactDebugCurrentFrame;
      function oe(A) {
        if (A) {
          var G = A._owner, U = I1(A.type, A._source, G ? G.type : null);
          ve.setExtraStackFrame(U);
        } else
          ve.setExtraStackFrame(null);
      }
      function x1(A, G, U, s1, E1) {
        {
          var O1 = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var R1 in A)
            if (O1(A, R1)) {
              var y = void 0;
              try {
                if (typeof A[R1] != "function") {
                  var P = Error((s1 || "React class") + ": " + U + " type `" + R1 + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof A[R1] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw P.name = "Invariant Violation", P;
                }
                y = A[R1](G, R1, s1, U, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (F) {
                y = F;
              }
              y && !(y instanceof Error) && (oe(E1), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", s1 || "React class", U, R1, typeof y), oe(null)), y instanceof Error && !(y.message in ce) && (ce[y.message] = !0, oe(E1), w("Failed %s type: %s", U, y.message), oe(null));
            }
        }
      }
      var ae = g.ReactCurrentOwner, ke = Object.prototype.hasOwnProperty, Ie = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, ye, Ye;
      function Ne(A) {
        if (ke.call(A, "ref")) {
          var G = Object.getOwnPropertyDescriptor(A, "ref").get;
          if (G && G.isReactWarning)
            return !1;
        }
        return A.ref !== void 0;
      }
      function K1(A) {
        if (ke.call(A, "key")) {
          var G = Object.getOwnPropertyDescriptor(A, "key").get;
          if (G && G.isReactWarning)
            return !1;
        }
        return A.key !== void 0;
      }
      function be(A, G) {
        typeof A.ref == "string" && ae.current;
      }
      function He(A, G) {
        {
          var U = function() {
            ye || (ye = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", G));
          };
          U.isReactWarning = !0, Object.defineProperty(A, "key", {
            get: U,
            configurable: !0
          });
        }
      }
      function Oe(A, G) {
        {
          var U = function() {
            Ye || (Ye = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", G));
          };
          U.isReactWarning = !0, Object.defineProperty(A, "ref", {
            get: U,
            configurable: !0
          });
        }
      }
      var Pe = function(A, G, U, s1, E1, O1, R1) {
        var y = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: r,
          // Built-in properties that belong on the element
          type: A,
          key: G,
          ref: U,
          props: R1,
          // Record the component responsible for creating this element.
          _owner: O1
        };
        return y._store = {}, Object.defineProperty(y._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(y, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: s1
        }), Object.defineProperty(y, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: E1
        }), Object.freeze && (Object.freeze(y.props), Object.freeze(y)), y;
      };
      function Ze(A, G, U, s1, E1) {
        {
          var O1, R1 = {}, y = null, P = null;
          U !== void 0 && (y = "" + U), K1(G) && (y = "" + G.key), Ne(G) && (P = G.ref, be(G, E1));
          for (O1 in G)
            ke.call(G, O1) && !Ie.hasOwnProperty(O1) && (R1[O1] = G[O1]);
          if (A && A.defaultProps) {
            var F = A.defaultProps;
            for (O1 in F)
              R1[O1] === void 0 && (R1[O1] = F[O1]);
          }
          if (y || P) {
            var t1 = typeof A == "function" ? A.displayName || A.name || "Unknown" : A;
            y && He(R1, t1), P && Oe(R1, t1);
          }
          return Pe(A, y, P, E1, s1, ae.current, R1);
        }
      }
      var Re = g.ReactCurrentOwner, ne = g.ReactDebugCurrentFrame;
      function A1(A) {
        if (A) {
          var G = A._owner, U = I1(A.type, A._source, G ? G.type : null);
          ne.setExtraStackFrame(U);
        } else
          ne.setExtraStackFrame(null);
      }
      var ze;
      ze = !1;
      function _e(A) {
        return typeof A == "object" && A !== null && A.$$typeof === r;
      }
      function De() {
        {
          if (Re.current) {
            var A = N(Re.current.type);
            if (A)
              return `

Check the render method of \`` + A + "`.";
          }
          return "";
        }
      }
      function je(A) {
        return "";
      }
      var Se = {};
      function se(A) {
        {
          var G = De();
          if (!G) {
            var U = typeof A == "string" ? A : A.displayName || A.name;
            U && (G = `

Check the top-level render call using <` + U + ">.");
          }
          return G;
        }
      }
      function xe(A, G) {
        {
          if (!A._store || A._store.validated || A.key != null)
            return;
          A._store.validated = !0;
          var U = se(G);
          if (Se[U])
            return;
          Se[U] = !0;
          var s1 = "";
          A && A._owner && A._owner !== Re.current && (s1 = " It was passed a child from " + N(A._owner.type) + "."), A1(A), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', U, s1), A1(null);
        }
      }
      function Le(A, G) {
        {
          if (typeof A != "object")
            return;
          if (Array.isArray(A))
            for (var U = 0; U < A.length; U++) {
              var s1 = A[U];
              _e(s1) && xe(s1, G);
            }
          else if (_e(A))
            A._store && (A._store.validated = !0);
          else if (A) {
            var E1 = j(A);
            if (typeof E1 == "function" && E1 !== A.entries)
              for (var O1 = E1.call(A), R1; !(R1 = O1.next()).done; )
                _e(R1.value) && xe(R1.value, G);
          }
        }
      }
      function Ee(A) {
        {
          var G = A.type;
          if (G == null || typeof G == "string")
            return;
          var U;
          if (typeof G == "function")
            U = G.propTypes;
          else if (typeof G == "object" && (G.$$typeof === p || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          G.$$typeof === m))
            U = G.propTypes;
          else
            return;
          if (U) {
            var s1 = N(G);
            x1(U, A.props, "prop", s1, A);
          } else if (G.PropTypes !== void 0 && !ze) {
            ze = !0;
            var E1 = N(G);
            w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E1 || "Unknown");
          }
          typeof G.getDefaultProps == "function" && !G.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function Z1(A) {
        {
          for (var G = Object.keys(A.props), U = 0; U < G.length; U++) {
            var s1 = G[U];
            if (s1 !== "children" && s1 !== "key") {
              A1(A), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", s1), A1(null);
              break;
            }
          }
          A.ref !== null && (A1(A), w("Invalid attribute `ref` supplied to `React.Fragment`."), A1(null));
        }
      }
      function C1(A, G, U, s1, E1, O1) {
        {
          var R1 = M(A);
          if (!R1) {
            var y = "";
            (A === void 0 || typeof A == "object" && A !== null && Object.keys(A).length === 0) && (y += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var P = je();
            P ? y += P : y += De();
            var F;
            A === null ? F = "null" : Array.isArray(A) ? F = "array" : A !== void 0 && A.$$typeof === r ? (F = "<" + (N(A.type) || "Unknown") + " />", y = " Did you accidentally export a JSX literal instead of a component?") : F = typeof A, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", F, y);
          }
          var t1 = Ze(A, G, U, E1, O1);
          if (t1 == null)
            return t1;
          if (R1) {
            var w1 = G.children;
            if (w1 !== void 0)
              if (s1)
                if (Array.isArray(w1)) {
                  for (var L1 = 0; L1 < w1.length; L1++)
                    Le(w1[L1], A);
                  Object.freeze && Object.freeze(w1);
                } else
                  w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Le(w1, A);
          }
          return A === e.Fragment ? Z1(t1) : Ee(t1), t1;
        }
      }
      function Q(A, G, U) {
        return C1(A, G, U, !0);
      }
      function a1(A, G, U) {
        return C1(A, G, U, !1);
      }
      var B1 = a1, ie = Q;
      e.jsx = B1, e.jsxs = ie;
    }();
  }(Vo)), Vo;
}
process.env.NODE_ENV === "production" ? ni.exports = dl() : ni.exports = fl();
var hl = ni.exports;
const Fo = ({
  path: e,
  ...t
}) => {
  (window[e] || (window[e] = [])).push(t);
}, W0 = ({ countersData: e, event: t, ids: n }) => {
  Object.entries(n).forEach(([r, a]) => {
    const i = e.find(({ type: l }) => l === r);
    if (i) {
      if (Array.isArray(a)) {
        a.forEach((l) => {
          Fo({ path: i.path, id: l, ...t });
        });
        return;
      }
      Fo({ path: i.path, id: a, ...t });
    }
  });
}, pl = {
  // Common counter
  base: {
    id: "topmailru-code",
    src: "https://top-fwz1.mail.ru/js/code.js",
    path: "_tmr"
  },
  // Generative proxy counter
  proxy_gen: {
    id: "tsmg-gen-code",
    src: "https://vkplay.ru/tsmg_gen.js",
    path: "_tmr_vkp_gen"
  },
  // Proxy counter
  proxy: {
    id: "tsmg_store",
    src: "https://vkplay.ru/tsmg.js",
    path: "_tmr_vkp"
  }
}, ml = (e) => {
  const { type: t = "base", onLoad: n } = e || {}, { id: r, src: a, path: i } = pl[t], l = () => {
    n && n({ type: t, path: i });
  };
  if (document.getElementById(r))
    return l(), { type: t, path: i };
  const s = document.createElement("script");
  s.type = "text/javascript", s.async = !0, s.id = r, s.src = a, s.onload = l, s.onerror = l;
  const c = () => {
    var p;
    const h = document.getElementsByTagName("script")[0];
    h ? (p = h.parentNode) == null || p.insertBefore(s, h) : document.head.append(s);
  };
  return window.opera && window.opera.toString() === "[object Opera]" ? document.addEventListener("DOMContentLoaded", c, !1) : c(), { type: t, path: i };
}, Cl = ["base", "proxy", "proxy_gen"], gl = (e) => {
  const { types: t, onLoad: n } = e || {};
  return t ? (typeof t == "boolean" ? Cl : t).map((r) => ml({ type: r, onLoad: n })) : [];
}, pa = () => {
}, vl = {
  id: "ym",
  src: "https://mc.yandex.ru/metrika/tag.js"
}, wl = (e) => {
  var t;
  const { onLoad: n } = e || {}, { id: r, src: a } = vl, i = () => {
    n && n();
  };
  for (let p = 0; p < document.scripts.length; p++)
    if (document.scripts[p].src === a) {
      i();
      return;
    }
  window[r] || (window[r] = (...p) => {
    const h = window[r];
    h && (h.a = h.a || [], h.a.push(p));
  });
  const l = window[r];
  l && (l.l = Number(/* @__PURE__ */ new Date()));
  const s = document.createElement("script");
  s.type = "text/javascript", s.id = r, s.async = !0, s.src = a, s.onload = i, s.onerror = i;
  const c = document.getElementsByTagName("script")[0];
  c ? (t = c.parentNode) == null || t.insertBefore(s, c) : document.head.appendChild(s);
}, Zo = {
  clickmap: !0,
  accurateTrackBounce: !0,
  trackLinks: !0,
  webvisor: !1
}, yl = ({
  ids: e,
  onLoad: t
}) => {
  wl({ onLoad: t });
  const { ym: n } = window;
  n && (Array.isArray(e) ? e.forEach((r) => {
    n(r, "init", Zo);
  }) : n(e, "init", Zo));
}, Go = (e) => e, Wo = (e) => {
  const t = V1();
  return _n(() => {
    t.current = e;
  }), W1((...n) => t.current && t.current(...n), []);
}, bl = (e, t = {}) => {
  const {
    formatTMRReachGoalParams: n = Go,
    formatYMReachGoalParams: r = Go
  } = ul(e), a = Wo(
    t.formatTMRReachGoalParams || n
  ), i = Wo(
    t.formatTMRReachGoalParams || r
  );
  return {
    formatTMRReachGoalParams: a,
    formatYMReachGoalParams: i
  };
}, i4 = o2({
  tmrCountersData: [],
  project: "base",
  setUser: pa,
  initCounters: pa,
  setIsAnalyticsAllowed: pa,
  formatters: {}
}), _l = ({
  children: e,
  project: t = "base",
  extraProject: n,
  onLoad: r,
  init: a = "auto",
  isAnalyticsAllowed: i = !0,
  formatters: l
}) => {
  const [s, c] = r1(), [p, h] = r1(i), [u, m] = r1([]), d = bl(t, l), v = W1((T) => {
    c(T);
  }, []), x = W1((T) => {
    h(T);
  }, []), k = W1(() => {
    const T = r4(t, n);
    if (T) {
      if (T.tmr) {
        const L = Object.keys(T.tmr), S = gl({
          types: L,
          onLoad: r
        });
        m(S);
      }
      T.ym && yl({
        ids: T.ym,
        onLoad: r
      });
    }
  }, [t]);
  u1(() => {
    a === "manual" || !p || k();
  }, [t, p]);
  const I = Xe(() => ({
    tmrCountersData: u,
    project: t,
    extraProject: n,
    userId: s,
    isAnalyticsAllowed: p,
    setUser: v,
    setIsAnalyticsAllowed: x,
    initCounters: k,
    formatters: {
      formatYMReachGoalParams: d.formatYMReachGoalParams,
      formatTMRReachGoalParams: d.formatTMRReachGoalParams
    }
  }), [
    u,
    t,
    n,
    s,
    v,
    x,
    k,
    d.formatYMReachGoalParams,
    d.formatTMRReachGoalParams
  ]);
  return /* @__PURE__ */ hl.jsx(i4.Provider, { value: I, children: e });
}, Qi = () => {
  const e = D1(i4);
  if (e === void 0)
    throw new Error("useAnalytics must be used within a AnalyticsProvider");
  return e;
}, xl = ({ countersData: e, ids: t, options: n }) => {
  const { userid: r, params: a } = n || {}, i = {
    type: "pageView",
    ...n,
    ...(a || r) && {
      params: {
        ...a || {},
        ...r && { VKPlayID: r }
      }
    }
  };
  W0({ countersData: e, ids: t, event: i });
}, Ll = ({
  countersData: e,
  ids: t,
  goal: n,
  value: r,
  parameters: a = {}
}) => {
  const i = {
    type: "reachGoal",
    goal: n,
    ...r && { value: r },
    ...a
  };
  W0({ countersData: e, ids: t, event: i });
}, El = ({ params: e, countersData: t, ids: n }) => {
  W0({ countersData: t, ids: n, event: { type: "setUserParams", params: e } });
}, Ml = ({ userId: e, countersData: t, ids: n }) => {
  W0({ countersData: t, ids: n, event: { type: "setUserID", userid: e } });
}, U0 = ({ ids: e, callback: t }) => {
  if (Array.isArray(e)) {
    e.forEach((n) => {
      t(n);
    });
    return;
  }
  t(e);
}, kl = [
  "hit",
  "reachGoal",
  "setUserID",
  "userParams",
  "extLink",
  "file",
  "addFileExtension",
  "firstPartyParams",
  "firstPartyParamsHashed",
  "notBounce",
  "params"
], z0 = (...e) => {
  !window.ym || !kl.includes(e[1]) || window.ym(...e);
}, Sl = ({ ids: e, url: t, options: n }) => {
  U0({ ids: e, callback: (r) => {
    z0(r, "hit", t, n);
  } });
}, Al = ({ ids: e, params: t }) => {
  U0({ ids: e, callback: (n) => {
    z0(n, "params", t);
  } });
}, Tl = ({ ids: e, userId: t }) => {
  U0({ ids: e, callback: (n) => {
    z0(n, "setUserID", t);
  } });
}, Il = ({ ids: e, parameters: t }) => {
  U0({ ids: e, callback: (n) => {
    z0(n, "userParams", t);
  } });
}, Rl = ({
  counterIds: e,
  userId: t,
  tmrCountersData: n
}) => W1(({
  url: r,
  referrer: a,
  title: i,
  device: l,
  gender: s,
  age: c,
  params: p,
  version: h,
  start: u = (/* @__PURE__ */ new Date()).getTime()
}) => {
  e && (e.tmr && xl({
    countersData: n,
    ids: e.tmr,
    options: {
      start: u,
      url: r,
      referrer: a,
      title: i,
      device: l,
      userid: t,
      gender: s,
      age: c,
      params: p,
      version: h
    }
  }), e.ym && Sl({
    ids: e.ym,
    url: r,
    options: {
      title: i,
      params: {
        ...p || {},
        referrer: a,
        device: l,
        userid: t,
        gender: s,
        age: c,
        params: p,
        version: h
      }
    }
  }));
}, [e, n, t]), Nl = ({
  counterIds: e,
  userId: t,
  tmrCountersData: n,
  formatters: r
}) => W1(({
  goal: a = "vkplay",
  params: i,
  value: l,
  ...s
}) => {
  if (!e)
    return;
  const {
    formatYMReachGoalParams: c,
    formatTMRReachGoalParams: p
  } = r;
  if (e.tmr) {
    const h = {
      params: p && i ? { url: window.location.href, ...p(i) } : i,
      ...s
    };
    Ll({
      countersData: n,
      ids: e.tmr,
      goal: a,
      ...l && { value: l },
      ...Object.keys(h).length > 0 && { parameters: h }
    });
  }
  if (e.ym) {
    const h = c && i ? c(i) : i;
    h && Al({
      ids: e.ym,
      params: h
    });
  }
}, [e, n, t]), Hl = ({
  tmrCountersData: e,
  counterIds: t,
  onSetUser: n
}) => W1((r) => {
  t && (n(r), t.tmr && (Ml({
    userId: r,
    countersData: e,
    ids: t.tmr
  }), El({
    params: { VKPlayID: r },
    countersData: e,
    ids: t.tmr
  })), t.ym && (Tl({
    userId: `${r}`,
    ids: t.ym
  }), Il({
    parameters: { VKPlayID: r },
    ids: t.ym
  })));
}, [e]), le = () => {
  const {
    tmrCountersData: e,
    project: t,
    extraProject: n,
    userId: r,
    setUser: a,
    formatters: i
  } = Qi(), l = ti(t), s = r4(t, n), c = cl(t), p = Rl({
    userId: r,
    counterIds: s || l,
    tmrCountersData: e
  }), h = Hl({
    counterIds: s || l,
    tmrCountersData: e,
    onSetUser: a
  }), u = Nl({
    counterIds: c || l,
    tmrCountersData: e,
    formatters: i,
    userId: r
  });
  return { pushSetUser: h, pushPageView: p, pushReachGoal: u };
};
var Ol = Object.defineProperty, jl = (e, t, n) => t in e ? Ol(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, t0 = (e, t, n) => jl(e, typeof t != "symbol" ? t + "" : t, n);
function Pl(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ri = { exports: {} }, mr = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Uo;
function Dl() {
  if (Uo) return mr;
  Uo = 1;
  var e = l1, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(s, c, p) {
    var h, u = {}, m = null, d = null;
    p !== void 0 && (m = "" + p), c.key !== void 0 && (m = "" + c.key), c.ref !== void 0 && (d = c.ref);
    for (h in c) r.call(c, h) && !i.hasOwnProperty(h) && (u[h] = c[h]);
    if (s && s.defaultProps) for (h in c = s.defaultProps, c) u[h] === void 0 && (u[h] = c[h]);
    return { $$typeof: t, type: s, key: m, ref: d, props: u, _owner: a.current };
  }
  return mr.Fragment = n, mr.jsx = l, mr.jsxs = l, mr;
}
var n0 = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zo;
function Vl() {
  return zo || (zo = 1, process.env.NODE_ENV !== "production" && function() {
    var e = l1, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), h = Symbol.for("react.suspense_list"), u = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), d = Symbol.for("react.offscreen"), v = Symbol.iterator, x = "@@iterator";
    function k(y) {
      if (y === null || typeof y != "object")
        return null;
      var P = v && y[v] || y[x];
      return typeof P == "function" ? P : null;
    }
    var I = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function T(y) {
      {
        for (var P = arguments.length, F = new Array(P > 1 ? P - 1 : 0), t1 = 1; t1 < P; t1++)
          F[t1 - 1] = arguments[t1];
        L("error", y, F);
      }
    }
    function L(y, P, F) {
      {
        var t1 = I.ReactDebugCurrentFrame, w1 = t1.getStackAddendum();
        w1 !== "" && (P += "%s", F = F.concat([w1]));
        var L1 = F.map(function(g1) {
          return String(g1);
        });
        L1.unshift("Warning: " + P), Function.prototype.apply.call(console[y], console, L1);
      }
    }
    var S = !1, E = !1, j = !1, g = !1, w = !1, C;
    C = Symbol.for("react.module.reference");
    function b(y) {
      return !!(typeof y == "string" || typeof y == "function" || y === r || y === i || w || y === a || y === p || y === h || g || y === d || S || E || j || typeof y == "object" && y !== null && (y.$$typeof === m || y.$$typeof === u || y.$$typeof === l || y.$$typeof === s || y.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      y.$$typeof === C || y.getModuleId !== void 0));
    }
    function M(y, P, F) {
      var t1 = y.displayName;
      if (t1)
        return t1;
      var w1 = P.displayName || P.name || "";
      return w1 !== "" ? F + "(" + w1 + ")" : F;
    }
    function R(y) {
      return y.displayName || "Context";
    }
    function O(y) {
      if (y == null)
        return null;
      if (typeof y.tag == "number" && T("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof y == "function")
        return y.displayName || y.name || null;
      if (typeof y == "string")
        return y;
      switch (y) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case p:
          return "Suspense";
        case h:
          return "SuspenseList";
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case s:
            var P = y;
            return R(P) + ".Consumer";
          case l:
            var F = y;
            return R(F._context) + ".Provider";
          case c:
            return M(y, y.render, "ForwardRef");
          case u:
            var t1 = y.displayName || null;
            return t1 !== null ? t1 : O(y.type) || "Memo";
          case m: {
            var w1 = y, L1 = w1._payload, g1 = w1._init;
            try {
              return O(g1(L1));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var N = Object.assign, H = 0, Z, z, K, D, W, q, e1;
    function o1() {
    }
    o1.__reactDisabledLog = !0;
    function c1() {
      {
        if (H === 0) {
          Z = console.log, z = console.info, K = console.warn, D = console.error, W = console.group, q = console.groupCollapsed, e1 = console.groupEnd;
          var y = {
            configurable: !0,
            enumerable: !0,
            value: o1,
            writable: !0
          };
          Object.defineProperties(console, {
            info: y,
            log: y,
            warn: y,
            error: y,
            group: y,
            groupCollapsed: y,
            groupEnd: y
          });
        }
        H++;
      }
    }
    function v1() {
      {
        if (H--, H === 0) {
          var y = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: N({}, y, {
              value: Z
            }),
            info: N({}, y, {
              value: z
            }),
            warn: N({}, y, {
              value: K
            }),
            error: N({}, y, {
              value: D
            }),
            group: N({}, y, {
              value: W
            }),
            groupCollapsed: N({}, y, {
              value: q
            }),
            groupEnd: N({}, y, {
              value: e1
            })
          });
        }
        H < 0 && T("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var m1 = I.ReactCurrentDispatcher, $;
    function n1(y, P, F) {
      {
        if ($ === void 0)
          try {
            throw Error();
          } catch (w1) {
            var t1 = w1.stack.trim().match(/\n( *(at )?)/);
            $ = t1 && t1[1] || "";
          }
        return `
` + $ + y;
      }
    }
    var d1 = !1, f1;
    {
      var M1 = typeof WeakMap == "function" ? WeakMap : Map;
      f1 = new M1();
    }
    function Y(y, P) {
      if (!y || d1)
        return "";
      {
        var F = f1.get(y);
        if (F !== void 0)
          return F;
      }
      var t1;
      d1 = !0;
      var w1 = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L1;
      L1 = m1.current, m1.current = null, c1();
      try {
        if (P) {
          var g1 = function() {
            throw Error();
          };
          if (Object.defineProperty(g1.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(g1, []);
            } catch (Y1) {
              t1 = Y1;
            }
            Reflect.construct(y, [], g1);
          } else {
            try {
              g1.call();
            } catch (Y1) {
              t1 = Y1;
            }
            y.call(g1.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Y1) {
            t1 = Y1;
          }
          y();
        }
      } catch (Y1) {
        if (Y1 && t1 && typeof Y1.stack == "string") {
          for (var p1 = Y1.stack.split(`
`), X1 = t1.stack.split(`
`), y1 = p1.length - 1, H1 = X1.length - 1; y1 >= 1 && H1 >= 0 && p1[y1] !== X1[H1]; )
            H1--;
          for (; y1 >= 1 && H1 >= 0; y1--, H1--)
            if (p1[y1] !== X1[H1]) {
              if (y1 !== 1 || H1 !== 1)
                do
                  if (y1--, H1--, H1 < 0 || p1[y1] !== X1[H1]) {
                    var T1 = `
` + p1[y1].replace(" at new ", " at ");
                    return y.displayName && T1.includes("<anonymous>") && (T1 = T1.replace("<anonymous>", y.displayName)), typeof y == "function" && f1.set(y, T1), T1;
                  }
                while (y1 >= 1 && H1 >= 0);
              break;
            }
        }
      } finally {
        d1 = !1, m1.current = L1, v1(), Error.prepareStackTrace = w1;
      }
      var Ce = y ? y.displayName || y.name : "", Ge = Ce ? n1(Ce) : "";
      return typeof y == "function" && f1.set(y, Ge), Ge;
    }
    function P1(y, P, F) {
      return Y(y, !1);
    }
    function J1(y) {
      var P = y.prototype;
      return !!(P && P.isReactComponent);
    }
    function I1(y, P, F) {
      if (y == null)
        return "";
      if (typeof y == "function")
        return Y(y, J1(y));
      if (typeof y == "string")
        return n1(y);
      switch (y) {
        case p:
          return n1("Suspense");
        case h:
          return n1("SuspenseList");
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case c:
            return P1(y.render);
          case u:
            return I1(y.type, P, F);
          case m: {
            var t1 = y, w1 = t1._payload, L1 = t1._init;
            try {
              return I1(L1(w1), P, F);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, ve = {}, oe = I.ReactDebugCurrentFrame;
    function x1(y) {
      if (y) {
        var P = y._owner, F = I1(y.type, y._source, P ? P.type : null);
        oe.setExtraStackFrame(F);
      } else
        oe.setExtraStackFrame(null);
    }
    function ae(y, P, F, t1, w1) {
      {
        var L1 = Function.call.bind(ce);
        for (var g1 in y)
          if (L1(y, g1)) {
            var p1 = void 0;
            try {
              if (typeof y[g1] != "function") {
                var X1 = Error((t1 || "React class") + ": " + F + " type `" + g1 + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof y[g1] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X1.name = "Invariant Violation", X1;
              }
              p1 = y[g1](P, g1, t1, F, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (y1) {
              p1 = y1;
            }
            p1 && !(p1 instanceof Error) && (x1(w1), T("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", t1 || "React class", F, g1, typeof p1), x1(null)), p1 instanceof Error && !(p1.message in ve) && (ve[p1.message] = !0, x1(w1), T("Failed %s type: %s", F, p1.message), x1(null));
          }
      }
    }
    var ke = Array.isArray;
    function Ie(y) {
      return ke(y);
    }
    function ye(y) {
      {
        var P = typeof Symbol == "function" && Symbol.toStringTag, F = P && y[Symbol.toStringTag] || y.constructor.name || "Object";
        return F;
      }
    }
    function Ye(y) {
      try {
        return Ne(y), !1;
      } catch {
        return !0;
      }
    }
    function Ne(y) {
      return "" + y;
    }
    function K1(y) {
      if (Ye(y))
        return T("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ye(y)), Ne(y);
    }
    var be = I.ReactCurrentOwner, He = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Oe, Pe;
    function Ze(y) {
      if (ce.call(y, "ref")) {
        var P = Object.getOwnPropertyDescriptor(y, "ref").get;
        if (P && P.isReactWarning)
          return !1;
      }
      return y.ref !== void 0;
    }
    function Re(y) {
      if (ce.call(y, "key")) {
        var P = Object.getOwnPropertyDescriptor(y, "key").get;
        if (P && P.isReactWarning)
          return !1;
      }
      return y.key !== void 0;
    }
    function ne(y, P) {
      typeof y.ref == "string" && be.current;
    }
    function A1(y, P) {
      {
        var F = function() {
          Oe || (Oe = !0, T("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", P));
        };
        F.isReactWarning = !0, Object.defineProperty(y, "key", {
          get: F,
          configurable: !0
        });
      }
    }
    function ze(y, P) {
      {
        var F = function() {
          Pe || (Pe = !0, T("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", P));
        };
        F.isReactWarning = !0, Object.defineProperty(y, "ref", {
          get: F,
          configurable: !0
        });
      }
    }
    var _e = function(y, P, F, t1, w1, L1, g1) {
      var p1 = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: y,
        key: P,
        ref: F,
        props: g1,
        // Record the component responsible for creating this element.
        _owner: L1
      };
      return p1._store = {}, Object.defineProperty(p1._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(p1, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: t1
      }), Object.defineProperty(p1, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w1
      }), Object.freeze && (Object.freeze(p1.props), Object.freeze(p1)), p1;
    };
    function De(y, P, F, t1, w1) {
      {
        var L1, g1 = {}, p1 = null, X1 = null;
        F !== void 0 && (K1(F), p1 = "" + F), Re(P) && (K1(P.key), p1 = "" + P.key), Ze(P) && (X1 = P.ref, ne(P, w1));
        for (L1 in P)
          ce.call(P, L1) && !He.hasOwnProperty(L1) && (g1[L1] = P[L1]);
        if (y && y.defaultProps) {
          var y1 = y.defaultProps;
          for (L1 in y1)
            g1[L1] === void 0 && (g1[L1] = y1[L1]);
        }
        if (p1 || X1) {
          var H1 = typeof y == "function" ? y.displayName || y.name || "Unknown" : y;
          p1 && A1(g1, H1), X1 && ze(g1, H1);
        }
        return _e(y, p1, X1, w1, t1, be.current, g1);
      }
    }
    var je = I.ReactCurrentOwner, Se = I.ReactDebugCurrentFrame;
    function se(y) {
      if (y) {
        var P = y._owner, F = I1(y.type, y._source, P ? P.type : null);
        Se.setExtraStackFrame(F);
      } else
        Se.setExtraStackFrame(null);
    }
    var xe;
    xe = !1;
    function Le(y) {
      return typeof y == "object" && y !== null && y.$$typeof === t;
    }
    function Ee() {
      {
        if (je.current) {
          var y = O(je.current.type);
          if (y)
            return `

Check the render method of \`` + y + "`.";
        }
        return "";
      }
    }
    function Z1(y) {
      return "";
    }
    var C1 = {};
    function Q(y) {
      {
        var P = Ee();
        if (!P) {
          var F = typeof y == "string" ? y : y.displayName || y.name;
          F && (P = `

Check the top-level render call using <` + F + ">.");
        }
        return P;
      }
    }
    function a1(y, P) {
      {
        if (!y._store || y._store.validated || y.key != null)
          return;
        y._store.validated = !0;
        var F = Q(P);
        if (C1[F])
          return;
        C1[F] = !0;
        var t1 = "";
        y && y._owner && y._owner !== je.current && (t1 = " It was passed a child from " + O(y._owner.type) + "."), se(y), T('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', F, t1), se(null);
      }
    }
    function B1(y, P) {
      {
        if (typeof y != "object")
          return;
        if (Ie(y))
          for (var F = 0; F < y.length; F++) {
            var t1 = y[F];
            Le(t1) && a1(t1, P);
          }
        else if (Le(y))
          y._store && (y._store.validated = !0);
        else if (y) {
          var w1 = k(y);
          if (typeof w1 == "function" && w1 !== y.entries)
            for (var L1 = w1.call(y), g1; !(g1 = L1.next()).done; )
              Le(g1.value) && a1(g1.value, P);
        }
      }
    }
    function ie(y) {
      {
        var P = y.type;
        if (P == null || typeof P == "string")
          return;
        var F;
        if (typeof P == "function")
          F = P.propTypes;
        else if (typeof P == "object" && (P.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        P.$$typeof === u))
          F = P.propTypes;
        else
          return;
        if (F) {
          var t1 = O(P);
          ae(F, y.props, "prop", t1, y);
        } else if (P.PropTypes !== void 0 && !xe) {
          xe = !0;
          var w1 = O(P);
          T("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w1 || "Unknown");
        }
        typeof P.getDefaultProps == "function" && !P.getDefaultProps.isReactClassApproved && T("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function A(y) {
      {
        for (var P = Object.keys(y.props), F = 0; F < P.length; F++) {
          var t1 = P[F];
          if (t1 !== "children" && t1 !== "key") {
            se(y), T("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", t1), se(null);
            break;
          }
        }
        y.ref !== null && (se(y), T("Invalid attribute `ref` supplied to `React.Fragment`."), se(null));
      }
    }
    var G = {};
    function U(y, P, F, t1, w1, L1) {
      {
        var g1 = b(y);
        if (!g1) {
          var p1 = "";
          (y === void 0 || typeof y == "object" && y !== null && Object.keys(y).length === 0) && (p1 += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X1 = Z1();
          X1 ? p1 += X1 : p1 += Ee();
          var y1;
          y === null ? y1 = "null" : Ie(y) ? y1 = "array" : y !== void 0 && y.$$typeof === t ? (y1 = "<" + (O(y.type) || "Unknown") + " />", p1 = " Did you accidentally export a JSX literal instead of a component?") : y1 = typeof y, T("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", y1, p1);
        }
        var H1 = De(y, P, F, w1, L1);
        if (H1 == null)
          return H1;
        if (g1) {
          var T1 = P.children;
          if (T1 !== void 0)
            if (t1)
              if (Ie(T1)) {
                for (var Ce = 0; Ce < T1.length; Ce++)
                  B1(T1[Ce], y);
                Object.freeze && Object.freeze(T1);
              } else
                T("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              B1(T1, y);
        }
        if (ce.call(P, "key")) {
          var Ge = O(y), Y1 = Object.keys(P).filter(function(ua) {
            return ua !== "key";
          }), u2 = Y1.length > 0 ? "{key: someKey, " + Y1.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!G[Ge + u2]) {
            var z2 = Y1.length > 0 ? "{" + Y1.join(": ..., ") + ": ...}" : "{}";
            T(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, u2, Ge, z2, Ge), G[Ge + u2] = !0;
          }
        }
        return y === r ? A(H1) : ie(H1), H1;
      }
    }
    function s1(y, P, F) {
      return U(y, P, F, !0);
    }
    function E1(y, P, F) {
      return U(y, P, F, !1);
    }
    var O1 = E1, R1 = s1;
    n0.Fragment = r, n0.jsx = O1, n0.jsxs = R1;
  }()), n0;
}
process.env.NODE_ENV === "production" ? ri.exports = Dl() : ri.exports = Vl();
var i1 = ri.exports, o4 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var i = "", l = 0; l < arguments.length; l++) {
        var s = arguments[l];
        s && (i = a(i, r(s)));
      }
      return i;
    }
    function r(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return n.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var l = "";
      for (var s in i)
        t.call(i, s) && i[s] && (l = a(l, s));
      return l;
    }
    function a(i, l) {
      return l ? i ? i + " " + l : i + l : i;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(o4);
var Bl = o4.exports;
const Q1 = /* @__PURE__ */ Pl(Bl), Fl = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 21, viewBox: "0 0 20 21", fill: "none", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M10 3.16797C9.35567 3.16797 8.83333 3.6903 8.83333 4.33464V9.0013H4.16667C3.56836 9.0013 3.07524 9.45168 3.00785 10.0319L3 10.168C3 10.8123 3.52233 11.3346 4.16667 11.3346H8.83333V16.0013C8.83333 16.5996 9.28371 17.0927 9.86394 17.1601L10 17.168C10.6443 17.168 11.1667 16.6456 11.1667 16.0013V11.3346H15.8333C16.4316 11.3346 16.9248 10.8843 16.9922 10.304L17 10.168C17 9.52364 16.4777 9.0013 15.8333 9.0013H11.1667V4.33464C11.1667 3.73633 10.7163 3.24321 10.1361 3.17582L10 3.16797Z", fill: "currentColor" })), Zl = V(Fl), Gl = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", { id: "add_square_outline_28" }, /* @__PURE__ */ o.createElement("path", { id: "â³ Icon Color", d: "M17.924 3C19.8822 3.02068 20.8787 3.2317 21.912 3.78431C22.9011 4.31328 23.6833 5.09549 24.2123 6.08458C24.7649 7.11786 24.9759 8.11438 24.9966 10.0726V17.924C24.9759 19.8822 24.7649 20.8787 24.2123 21.912C23.6833 22.9011 22.9011 23.6833 21.912 24.2123C20.8787 24.7649 19.8822 24.9759 17.924 24.9966H10.0726C8.11438 24.9759 7.11786 24.7649 6.08458 24.2123C5.09549 23.6833 4.31328 22.9011 3.78431 21.912C3.2317 20.8787 3.02068 19.8822 3 17.924V10.0726C3.02068 8.11438 3.2317 7.11786 3.78431 6.08458C4.31328 5.09549 5.09549 4.31328 6.08458 3.78431C7.11786 3.2317 8.11438 3.02068 10.0726 3H17.924ZM17.5886 4.99829H10.408L9.85062 5.00317C8.37134 5.03122 7.70897 5.18363 7.02777 5.54793C6.38723 5.8905 5.8905 6.38723 5.54793 7.02777C5.18363 7.70897 5.03122 8.37134 5.00317 9.85062L4.99829 10.408V17.5886L5.00317 18.146C5.03122 19.6252 5.18363 20.2876 5.54793 20.9688C5.8905 21.6094 6.38723 22.1061 7.02777 22.4486C7.70897 22.813 8.37134 22.9654 9.85062 22.9934L10.408 22.9983H17.5886L18.146 22.9934C19.6252 22.9654 20.2876 22.813 20.9688 22.4486C21.6094 22.1061 22.1061 21.6094 22.4486 20.9688C22.813 20.2876 22.9654 19.6252 22.9934 18.146L22.9983 17.5886V10.408L22.9934 9.85062C22.9654 8.37134 22.813 7.70897 22.4486 7.02777C22.1061 6.38723 21.6094 5.8905 20.9688 5.54793C20.2876 5.18363 19.6252 5.03122 18.146 5.00317L17.5886 4.99829ZM14 9C14.5523 9 15 9.44772 15 10V13H18C18.5523 13 19 13.4477 19 14C19 14.5523 18.5523 15 18 15H15V18C15 18.5523 14.5523 19 14 19C13.4477 19 13 18.5523 13 18V15H10C9.44772 15 9 14.5523 9 14C9 13.4477 9.44772 13 10 13H13V10C13 9.44772 13.4477 9 14 9Z" }))), Wl = V(Gl), Ul = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 3C10.4142 3 10.75 3.33579 10.75 3.75V9.24999L16.25 9.25C16.6642 9.25 17 9.58579 17 10C17 10.4142 16.6642 10.75 16.25 10.75L10.75 10.75V16.25C10.75 16.6642 10.4142 17 10 17C9.58581 17 9.25002 16.6642 9.25002 16.25V10.75H3.75C3.33579 10.75 3 10.4142 3 9.99999C3 9.58578 3.33579 9.24999 3.75 9.24999H9.25002V3.75C9.25002 3.33579 9.58581 3 10 3Z", fill: "inherit" })), zl = V(Ul), ql = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { className: "svg-substrate", cx: 12, cy: 12, r: 11, fill: "transparent" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM5 11.4446C5 13.0724 6.31958 14.392 7.94736 14.392H8.68421C8.68421 15.4855 9.08827 16.6034 9.67723 17.3101C10.068 17.779 10.7649 17.8424 11.2339 17.4516C11.7028 17.0608 11.7662 16.3639 11.3754 15.895C11.1178 15.5858 10.8947 14.9687 10.8947 14.392H12.633C12.7972 14.392 12.8567 14.3749 12.9168 14.3428C12.9768 14.3107 13.0239 14.2636 13.0561 14.2035C13.0882 14.1435 13.1053 14.0839 13.1053 13.9197V8.96957C13.1053 8.80534 13.0882 8.74579 13.0561 8.68575C13.0239 8.62571 12.9768 8.57859 12.9168 8.54648C12.8567 8.51437 12.7972 8.49727 12.633 8.49727H7.94736C6.31958 8.49727 5 9.81686 5 11.4446ZM19 7.147C19 6.97825 18.95 6.81328 18.8564 6.67287C18.5946 6.2801 18.0639 6.17396 17.6711 6.43581L14.8116 8.34216C14.7186 8.40416 14.6888 8.43106 14.6599 8.46595C14.6311 8.50084 14.6108 8.53866 14.5978 8.58202C14.5848 8.62537 14.5789 8.66514 14.5789 8.77691L14.5797 14.1714C14.5816 14.2402 14.5874 14.2726 14.5978 14.3073C14.6108 14.3506 14.6311 14.3884 14.6599 14.4233C14.6888 14.4582 14.7186 14.4851 14.8116 14.5471L17.6711 16.4535C17.8115 16.5471 17.9765 16.597 18.1453 16.597C18.6173 16.597 19 16.2143 19 15.7423V7.147Z", fill: "inherit" })), $l = V(ql), Yl = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M3.94737 10.392C2.31958 10.392 1 9.07243 1 7.44464C1 5.81685 2.31958 4.49727 3.94737 4.49727H8.63297C8.7972 4.49727 8.85675 4.51437 8.91679 4.54648C8.97683 4.57859 9.02395 4.62571 9.05605 4.68575C9.08816 4.74579 9.10526 4.80534 9.10526 4.96957V9.91972C9.10526 10.0839 9.08816 10.1435 9.05605 10.2035C9.02395 10.2636 8.97683 10.3107 8.91679 10.3428C8.85675 10.3749 8.7972 10.392 8.63297 10.392H6.89474C6.89474 10.9687 7.11777 11.5858 7.3754 11.895C7.76618 12.3639 7.70283 13.0608 7.23389 13.4516C6.76495 13.8424 6.06801 13.779 5.67723 13.3101C5.08828 12.6034 4.68421 11.4855 4.68421 10.392H3.94737ZM14.8564 2.67287C14.9501 2.81328 15 2.97825 15 3.147V11.7423C15 12.2143 14.6173 12.597 14.1453 12.597C13.9765 12.597 13.8115 12.5471 13.6711 12.4535L10.8116 10.5471C10.7186 10.4851 10.6888 10.4582 10.6599 10.4233C10.6311 10.3884 10.6108 10.3506 10.5978 10.3073C10.5874 10.2726 10.5816 10.2402 10.5797 10.1714L10.5789 4.77691C10.5789 4.66514 10.5848 4.62537 10.5978 4.58202C10.6108 4.53866 10.6311 4.50084 10.6599 4.46595C10.6888 4.43106 10.7186 4.40416 10.8116 4.34216L13.6711 2.43581C14.0639 2.17396 14.5946 2.2801 14.8564 2.67287Z", fill: "inherit" })), Kl = V(Yl), Ql = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M10.75 14L14.7328 10.2069C15.0327 9.92123 15.5074 9.93281 15.7931 10.2328C16.0788 10.5327 16.0672 11.0074 15.7672 11.2931L10.5172 16.2931C10.2276 16.569 9.77241 16.569 9.48276 16.2931L4.23276 11.2931C3.93281 11.0074 3.92123 10.5327 4.2069 10.2328C4.49256 9.93281 4.9673 9.92123 5.26724 10.2069L9.25 14L9.25 4.25C9.25 3.83579 9.58579 3.5 10 3.5C10.4142 3.5 10.75 3.83579 10.75 4.25L10.75 14Z", fill: "inherit" })), Xl = V(Ql), Jl = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.5 7.54875C11.4985 7.7899 11.4034 8.0192 11.2382 8.1804L7.35349 11.9706L11.2427 15.824C11.406 15.9858 11.4993 16.2145 11.5 16.4545C11.5007 16.6946 11.4086 16.9239 11.2462 17.0868L10.5625 17.7725C10.2617 18.0742 9.79822 18.0761 9.49535 17.7767L4.25798 12.5995C4.09298 12.4364 3.99926 12.2051 4 11.9629C4.00074 11.7206 4.09588 11.49 4.26186 11.3281L9.49923 6.21953C9.80243 5.92378 10.2632 5.92725 10.5625 6.22753L11.2462 6.91325C11.4094 7.07689 11.5015 7.30759 11.5 7.54875ZM20 7.54875C19.9985 7.7899 19.9034 8.0192 19.7382 8.1804L15.8535 11.9706L19.7427 15.824C19.906 15.9858 19.9993 16.2145 20 16.4545C20.0007 16.6946 19.9086 16.9239 19.7462 17.0868L19.0625 17.7725C18.7617 18.0742 18.2982 18.0761 17.9953 17.7767L12.758 12.5995C12.593 12.4364 12.4993 12.2051 12.5 11.9629C12.5007 11.7206 12.5959 11.49 12.7619 11.3281L17.9992 6.21953C18.3024 5.92378 18.7632 5.92725 19.0625 6.22753L19.7462 6.91325C19.9094 7.07689 20.0015 7.30759 20 7.54875Z", fill: "inherit" })), e9 = V(Jl), t9 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.5675 3.90361C13.1691 3.52114 12.5361 3.53406 12.1536 3.93247L3.15361 13.3075C2.78213 13.6944 2.78213 14.3056 3.15361 14.6925L12.1536 24.0675C12.5361 24.4659 13.1691 24.4789 13.5675 24.0964C13.9659 23.7139 13.9789 23.0809 13.5964 22.6825L6.22122 15H24.125C24.6773 15 25.125 14.5523 25.125 14C25.125 13.4477 24.6773 13 24.125 13H6.22122L13.5964 5.31753C13.9789 4.91912 13.9659 4.28609 13.5675 3.90361Z", fill: "currentColor" })), n9 = V(t9), r9 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.20971 4.54456L5.00762 2.14837C5.39688 1.81501 5.99791 2.09159 5.99791 2.60409V4.25031H9.13481C9.2395 4.2503 9.30607 4.2503 9.36448 4.25174C11.8965 4.31389 13.9343 6.35175 13.9965 8.88373C13.9979 8.94215 13.9979 9.00871 13.9979 9.11341V9.1372C13.9979 9.2419 13.9979 9.30846 13.9965 9.36688C13.9343 11.8989 11.8965 13.9367 9.36448 13.9989C9.30611 14.0003 9.23959 14.0003 9.13502 14.0003H5.74791C5.3337 14.0003 4.99791 13.6645 4.99791 13.2503C4.99791 12.8361 5.3337 12.5003 5.74791 12.5003H9.12291C9.24342 12.5003 9.29012 12.5002 9.32767 12.4993C11.0601 12.4568 12.4544 11.0625 12.4969 9.33006C12.4979 9.29251 12.4979 9.24582 12.4979 9.12531C12.4979 9.00479 12.4979 8.9581 12.4969 8.92055C12.4544 7.18813 11.0601 5.79381 9.32767 5.75128C9.29012 5.75036 9.24342 5.75031 9.12291 5.75031H5.99791V7.39646C5.99791 7.90896 5.39688 8.18555 5.00763 7.85218L2.20972 5.456C1.9301 5.21653 1.93009 4.78404 2.20971 4.54456Z", fill: "currentColor" })), a9 = V(r9), i9 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.4325 3.90361C14.8309 3.52114 15.4639 3.53406 15.8464 3.93247L24.8464 13.3075C25.2179 13.6944 25.2179 14.3056 24.8464 14.6925L15.8464 24.0675C15.4639 24.4659 14.8309 24.4789 14.4325 24.0964C14.0341 23.7139 14.0211 23.0809 14.4036 22.6825L21.7788 15H3.875C3.32272 15 2.875 14.5523 2.875 14C2.875 13.4477 3.32272 13 3.875 13H21.7788L14.4036 5.31753C14.0211 4.91912 14.0341 4.28609 14.4325 3.90361Z", fill: "currentColor" })), o9 = V(i9), s9 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { id: "â³ Icon Color", fillRule: "evenodd", clipRule: "evenodd", d: "M10 18.5C14.6944 18.5 18.5 14.6944 18.5 10C18.5 5.30558 14.6944 1.5 10 1.5C5.30558 1.5 1.5 5.30558 1.5 10C1.5 14.6944 5.30558 18.5 10 18.5ZM14.3911 15.4518C13.1902 16.4202 11.6628 17 10 17C6.13401 17 3 13.866 3 10C3 8.33717 3.57979 6.80976 4.54824 5.6089L14.3911 15.4518ZM15.4518 14.3911L5.6089 4.54824C6.80976 3.57979 8.33717 3 10 3C13.866 3 17 6.13401 17 10C17 11.6628 16.4202 13.1902 15.4518 14.3911Z" })), l9 = V(s9), c9 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 57, height: 57, viewBox: "0 0 57 57", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M38.753 9.851a1.5 1.5 0 0 0 1.79 1.14 1.5 1.5 0 0 0 1.14-1.79l-1.06-4.75a1.5 1.5 0 0 0-1.79-1.14 1.5 1.5 0 0 0-1.14 1.79l1.06 4.75zM47.013 11.751l3.79-3.73a1.5 1.5 0 0 0-2.1-2.14l-3.79 3.73a1.5 1.5 0 0 0 2.1 2.14zM52.613 16.141l-5.16-1.56c-.79-.24-1.63.21-1.87 1-.24.79.21 1.63 1 1.87l5.16 1.56c.79.24 1.63-.21 1.87-1 .24-.79-.21-1.63-1-1.87zM36.303 10.961c-.58-.55-1.49-.54-2.06 0l-4.45 4.25c-2.08-.81-4.33-1.28-6.69-1.28-10.43.01-18.91 8.72-18.91 19.42 0 10.7 8.48 19.41 18.91 19.41s18.91-8.71 18.91-19.41c0-2.82-.6-5.5-1.66-7.92l4.44-4.37c.29-.29.45-.68.45-1.09 0-.41-.18-.8-.47-1.08l-8.46-7.95-.01.02zm-13.2 38.8c-8.77 0-15.91-7.36-15.91-16.41s7.14-16.41 15.91-16.41 15.91 7.36 15.91 16.41-7.14 16.41-15.91 16.41zm15.77-27.09a19.322 19.322 0 0 0-6.22-6.05l2.63-2.51 6.29 5.9-2.69 2.65-.01.01z" }), /* @__PURE__ */ o.createElement("path", { d: "M16.333 22.571c-2.74 1.28-4.59 3.89-5.54 6.59-.95 2.68-1.11 5.75-.11 8.14a1.5 1.5 0 0 0 1.96.8 1.5 1.5 0 0 0 .8-1.96c-.63-1.5-.61-3.77.17-5.98.77-2.2 2.19-4.03 3.98-4.87a1.499 1.499 0 0 0-1.26-2.72z" })), u9 = V(c9), d9 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.31739 1.5H10.6826C11.6351 1.49999 12.3956 1.49999 13.0099 1.55018C13.6399 1.60165 14.1818 1.70963 14.6795 1.96322C15.4791 2.37068 16.1293 3.02085 16.5368 3.82054C16.7904 4.31824 16.8984 4.86012 16.9498 5.49013C17 6.10439 17 6.86493 17 7.81737V14.3871C17 15.1634 17 15.7979 16.9556 16.2876C16.9118 16.7707 16.8159 17.268 16.5041 17.6561C16.0729 18.1929 15.4197 18.5027 14.7312 18.4969C14.2333 18.4927 13.7875 18.2523 13.3858 17.9806C12.9784 17.705 12.4872 17.3036 11.8861 16.8123L11.0441 16.1242C10.765 15.8961 10.5869 15.7512 10.442 15.6497C10.3049 15.5536 10.2405 15.5281 10.203 15.5175C10.0702 15.4802 9.92977 15.4802 9.79702 15.5175C9.75946 15.5281 9.69513 15.5536 9.55801 15.6497C9.41314 15.7512 9.23499 15.8961 8.95589 16.1242L8.11389 16.8123C7.51279 17.3036 7.02155 17.705 6.61422 17.9806C6.21249 18.2523 5.76673 18.4927 5.26883 18.4969C4.58035 18.5027 3.92713 18.1929 3.49592 17.6561C3.18408 17.268 3.08819 16.7707 3.04439 16.2876C2.99998 15.7979 2.99999 15.1635 3 14.3871V7.81739C2.99999 6.86494 2.99999 6.1044 3.05018 5.49013C3.10165 4.86012 3.20963 4.31824 3.46322 3.82054C3.87068 3.02085 4.52085 2.37068 5.32054 1.96322C5.81824 1.70963 6.36012 1.60165 6.99013 1.55018C7.6044 1.49999 8.36495 1.49999 9.31739 1.5Z", fill: "currentColor" }))), f9 = V(d9), h9 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 21, height: 20, viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.5003 2.14288C13.1333 2.14288 11.2146 4.06166 11.2146 6.4286C11.2146 8.79553 13.1333 10.7143 15.5003 10.7143C17.8672 10.7143 19.786 8.79553 19.786 6.4286C19.786 4.06166 17.8672 2.14288 15.5003 2.14288ZM17.4862 5.15693C17.277 4.94772 16.9378 4.94772 16.7286 5.15693L14.9646 6.92098L14.2719 6.22836C14.0627 6.01915 13.7235 6.01915 13.5143 6.22836C13.3051 6.43757 13.3051 6.77677 13.5143 6.98598L14.5858 8.05741C14.795 8.26661 15.1342 8.26661 15.3434 8.05741L17.4862 5.91455C17.6954 5.70534 17.6954 5.36614 17.4862 5.15693Z", fill: "currentColor" }), /* @__PURE__ */ o.createElement("path", { d: "M11.7203 2.14312C11.5676 2.14288 11.4095 2.14288 11.2458 2.14288H9.75474C8.78114 2.14288 8.00683 2.14287 7.38212 2.19391C6.74241 2.24618 6.19693 2.35551 5.69746 2.61C4.89106 3.02088 4.23542 3.67652 3.82454 4.48292C3.57005 4.98239 3.46072 5.52787 3.40845 6.16758C3.35741 6.79228 3.35742 7.56656 3.35742 8.54014V14.7153C3.35741 15.4345 3.3574 16.0237 3.39892 16.4798C3.44002 16.9314 3.53013 17.3954 3.82007 17.7617C4.22253 18.2702 4.8336 18.5691 5.48205 18.5746C5.94919 18.5785 6.37075 18.3648 6.75248 18.12C7.13803 17.8727 7.60308 17.511 8.17078 17.0694L9.53552 16.008C10.0896 15.5771 10.2089 15.5014 10.3136 15.473C10.4359 15.4399 10.5647 15.4399 10.687 15.473C10.7917 15.5014 10.911 15.5771 11.465 16.008L12.8297 17.0694C13.3975 17.511 13.8625 17.8727 14.2481 18.12C14.6298 18.3648 15.0514 18.5785 15.5185 18.5746C16.167 18.5691 16.778 18.2702 17.1805 17.7617C17.4704 17.3954 17.5605 16.9314 17.6016 16.4798C17.6432 16.0237 17.6432 15.4345 17.6431 14.7153V11.7275C16.9814 11.9954 16.2581 12.1429 15.5003 12.1429C12.3444 12.1429 9.78599 9.58451 9.78599 6.4286C9.78599 4.72202 10.5341 3.19018 11.7203 2.14312Z", fill: "currentColor" })), p9 = V(h9), m9 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", { id: "bookmark_outline_24" }, /* @__PURE__ */ o.createElement("path", { id: "â³ Icon Color", fillRule: "evenodd", clipRule: "evenodd", d: "M14.7785 4H17.2228C18.6309 3.99999 19.7607 3.99998 20.6744 4.07463C21.6132 4.15134 22.429 4.31281 23.181 4.69594C24.3824 5.30811 25.3592 6.28492 25.9714 7.48637C26.3545 8.23832 26.516 9.05411 26.5927 9.99296C26.6673 10.9066 26.6673 12.0364 26.6673 13.4445V23.5973C26.6673 24.6274 26.6674 25.4831 26.6067 26.1488C26.5467 26.8076 26.4134 27.5179 25.9646 28.0873C25.3533 28.863 24.4244 29.3212 23.4368 29.3344C22.7119 29.344 22.0671 29.0176 21.5078 28.6643C20.9427 28.3074 20.2636 27.7866 19.4462 27.1598L17.2898 25.5062C16.4801 24.8853 16.3384 24.8047 16.2268 24.7748C16.0786 24.7351 15.9227 24.7351 15.7745 24.7748C15.6629 24.8047 15.5213 24.8853 14.7115 25.5062L12.5552 27.1597C11.7377 27.7866 11.0586 28.3074 10.4935 28.6643C9.93421 29.0176 9.2894 29.344 8.56448 29.3344C7.57691 29.3212 6.64806 28.863 6.03668 28.0873C5.5879 27.5179 5.45459 26.8076 5.39458 26.1488C5.33395 25.4831 5.33396 24.6274 5.33399 23.5973L5.33399 13.4445C5.33398 12.0364 5.33397 10.9066 5.40862 9.99296C5.48532 9.05411 5.64679 8.23832 6.02993 7.48637C6.6421 6.28492 7.61891 5.30811 8.82036 4.69594C9.57231 4.31281 10.3881 4.15134 11.3269 4.07463C12.2406 3.99998 13.3704 3.99999 14.7785 4ZM11.5224 6.46666C10.732 6.53124 10.2672 6.65234 9.90994 6.83436C9.16008 7.21643 8.55042 7.82609 8.16835 8.57595C7.98633 8.93317 7.86523 9.39796 7.80064 10.1884C7.73492 10.9928 7.73399 12.0245 7.73399 13.4963V23.5381C7.73399 24.6426 7.73518 25.3877 7.78468 25.9311C7.83496 26.483 7.92169 26.6018 7.92169 26.6018C8.08491 26.8089 8.33278 26.9311 8.59643 26.9346C8.59643 26.9346 8.74328 26.9311 9.21189 26.6352C9.67322 26.3438 10.2652 25.8913 11.1416 25.2193L13.2511 23.6017C13.2961 23.5671 13.3409 23.5327 13.3855 23.4984C13.9702 23.0482 14.5172 22.627 15.1537 22.4565C15.7085 22.3079 16.2928 22.3079 16.8476 22.4565C17.4841 22.627 18.0311 23.0482 18.6158 23.4984C18.6604 23.5327 18.7052 23.5671 18.7502 23.6017L20.8597 25.2193C21.7361 25.8913 22.3281 26.3438 22.7894 26.6352C23.258 26.9311 23.4051 26.9346 23.4051 26.9346C23.6687 26.9311 23.9165 26.8087 24.0797 26.6017C24.0797 26.6017 24.1663 26.483 24.2166 25.9311C24.2661 25.3877 24.2673 24.6426 24.2673 23.5381V13.4963C24.2673 12.0245 24.2664 10.9928 24.2007 10.1884C24.1361 9.39796 24.015 8.93317 23.833 8.57595C23.4509 7.82609 22.8412 7.21643 22.0914 6.83436C21.7341 6.65234 21.2694 6.53124 20.4789 6.46666C19.6745 6.40093 18.6428 6.4 17.171 6.4H14.8303C13.3585 6.4 12.3268 6.40093 11.5224 6.46666Z" }))), C9 = V(m9), g9 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.31739 1.50024H10.6826C11.6351 1.50024 12.3956 1.50023 13.0099 1.55042C13.6399 1.60189 14.1818 1.70988 14.6795 1.96347C15.4791 2.37093 16.1293 3.0211 16.5368 3.82078C16.7904 4.31848 16.8984 4.86036 16.9498 5.49038C17 6.10464 17 6.86518 17 7.81761V14.3874C17 15.1637 17 15.7981 16.9556 16.2879C16.9118 16.7709 16.8159 17.2682 16.5041 17.6564C16.0729 18.1931 15.4197 18.5029 14.7312 18.4972C14.2333 18.493 13.7875 18.2525 13.3858 17.9808C12.9784 17.7053 12.4872 17.3038 11.8861 16.8126L11.0441 16.1245C10.765 15.8964 10.5869 15.7514 10.442 15.6499C10.3049 15.5539 10.2405 15.5283 10.203 15.5178C10.0702 15.4805 9.92977 15.4805 9.79702 15.5178C9.75946 15.5283 9.69513 15.5539 9.55801 15.6499C9.41314 15.7514 9.23499 15.8964 8.95589 16.1245L8.11389 16.8126C7.51279 17.3038 7.02155 17.7053 6.61422 17.9808C6.21249 18.2525 5.76673 18.493 5.26883 18.4972C4.58035 18.5029 3.92713 18.1931 3.49592 17.6564C3.18408 17.2682 3.08819 16.7709 3.04439 16.2879C2.99998 15.7981 2.99999 15.1637 3 14.3874V7.81763C2.99999 6.86519 2.99999 6.10464 3.05018 5.49038C3.10165 4.86036 3.20963 4.31848 3.46322 3.82078C3.87068 3.0211 4.52085 2.37093 5.32054 1.96347C5.81824 1.70988 6.36012 1.60189 6.99013 1.55042C7.6044 1.50023 8.36495 1.50024 9.31739 1.50024Z", fill: "white" })), v9 = V(g9), w9 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM7.47826 6.00143C9.06165 5.97956 10.3071 6.20641 11.5 6.78761V18.3207C10.5972 17.7559 9.71119 17.5195 8.53955 17.4776L8.51307 17.4767H8.51303C7.98611 17.4578 7.55357 17.4424 7.21295 17.4077C6.87328 17.3732 6.53105 17.3125 6.23108 17.1501C5.7792 16.9054 5.47319 16.5883 5.24482 16.128C5.09858 15.8332 5.04666 15.5192 5.02293 15.2028C4.99998 14.8966 4.99999 14.5189 5 14.0709V14.0709V8.57148V8.57147C4.99998 8.28657 4.99996 8.02723 5.01885 7.80848C5.03945 7.56987 5.08578 7.32494 5.20888 7.08084C5.38652 6.72861 5.69822 6.41258 6.04796 6.23009C6.46412 6.01296 6.91936 6.00782 7.37682 6.00266L7.47826 6.00143ZM15.4604 17.4776C14.2888 17.5195 13.4028 17.7559 12.5 18.3207V6.7876C13.6929 6.20641 14.9384 5.97956 16.5217 6.00143L16.6232 6.00266C17.0806 6.00782 17.5359 6.01296 17.952 6.23009C18.3018 6.41258 18.6135 6.72861 18.7911 7.08084C18.9142 7.32494 18.9606 7.56987 18.9812 7.80848C19 8.02722 19 8.28654 19 8.57143V8.5715V14.0709C19 14.519 19 14.8966 18.9771 15.2028C18.9533 15.5192 18.9014 15.8332 18.7552 16.128C18.5268 16.5883 18.2208 16.9054 17.7689 17.1501C17.4689 17.3125 17.1267 17.3732 16.787 17.4077C16.4464 17.4424 16.0139 17.4578 15.487 17.4767H15.4869L15.4604 17.4776Z", fill: "inherit" })), y9 = V(w9), b9 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 57, height: 57, viewBox: "0 0 57 57", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24.97 6.518a8.18 8.18 0 0 0-7.12 4.145l-.38.669-.765.08a9.396 9.396 0 0 0-8.392 9.343c0 1.49.345 2.896.961 4.146a9.93 9.93 0 0 1 6.012-2.014 9.94 9.94 0 0 1 4.275.96 1.5 1.5 0 0 1-1.287 2.71A6.974 6.974 0 1 0 12.603 39.3l1.383.577-.576 1.383a3.342 3.342 0 0 0 4.194 4.439l1.379-.484.52 1.367a4.555 4.555 0 0 0 7.599 1.475V6.798a8.196 8.196 0 0 0-2.132-.28zm5.132.28v41.259a4.538 4.538 0 0 0 3.342 1.461 4.547 4.547 0 0 0 3.615-1.785 6.335 6.335 0 0 1-2.694-5.189 1.5 1.5 0 1 1 3 0 3.342 3.342 0 1 0 6.43-1.284 1.5 1.5 0 0 1 .806-1.96 6.976 6.976 0 0 0 3.516-9.638 12.354 12.354 0 0 1-8.62 3.488 1.5 1.5 0 0 1 0-3 9.395 9.395 0 0 0 1.002-18.737 1.5 1.5 0 0 1-1.146-.75 8.18 8.18 0 0 0-7.12-4.145c-.738 0-1.453.098-2.131.28zm20.005 20.368a9.933 9.933 0 0 1 1.784 5.694 9.969 9.969 0 0 1-4.933 8.608 6.342 6.342 0 0 1-7.03 7.371 7.548 7.548 0 0 1-6.484 3.68 7.525 7.525 0 0 1-4.842-1.757 7.525 7.525 0 0 1-4.842 1.756 7.548 7.548 0 0 1-6.485-3.679 6.342 6.342 0 0 1-7.03-7.371 9.969 9.969 0 0 1-4.932-8.608c0-2.117.66-4.08 1.784-5.695a12.343 12.343 0 0 1-1.785-6.41c0-6.142 4.467-11.239 10.33-12.223 2-3.019 5.43-5.014 9.328-5.014 1.27 0 2.492.212 3.632.603a11.172 11.172 0 0 1 3.631-.603c3.899 0 7.33 1.995 9.33 5.014 5.862.984 10.328 6.081 10.328 12.223a12.324 12.324 0 0 1-1.785 6.41zM22.238 14.1a1.5 1.5 0 0 1 .301 2.1 7.543 7.543 0 0 1-6.047 3.028 1.5 1.5 0 0 1 0-3c1.49 0 2.813-.715 3.646-1.827a1.5 1.5 0 0 1 2.1-.3zm13.5.327a1.5 1.5 0 0 1 1.698 1.272 6.984 6.984 0 0 0 4.91 5.687 1.5 1.5 0 1 1-.856 2.876 9.983 9.983 0 0 1-7.024-8.138 1.5 1.5 0 0 1 1.273-1.697zm-20.54 17.928a1.5 1.5 0 0 1 2.05-.547 12.412 12.412 0 0 1 5.889 7.982 1.5 1.5 0 0 1-2.926.664 9.413 9.413 0 0 0-4.465-6.05 1.5 1.5 0 0 1-.548-2.049z" })), _9 = V(b9), x9 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM9.76245 6.36664L4.225 7.11846L4.23005 11.7229L9.76487 11.6915L9.76245 6.36664ZM9.76411 17.6345L9.75981 12.305L4.22898 12.2693L4.22929 16.8759L9.76411 17.6345ZM17.7733 5.2L10.4311 6.26829V11.6819L17.7733 11.6238V5.2ZM17.7733 18.75L17.775 12.3551L10.4208 12.3432L10.4311 17.7169L17.7733 18.75Z", fill: "currentColor" })), L9 = V(x9), E9 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M1.2251 3.11846L6.76255 2.36664L6.76497 7.6915L1.23016 7.72292L1.2251 3.11846ZM6.75991 8.30503L6.76421 13.6345L1.2294 12.8759L1.22909 8.26928L6.75991 8.30503ZM7.43118 2.26829L14.7734 1.2V7.62378L7.43118 7.68189V2.26829ZM14.7751 8.35515L14.7734 14.75L7.43116 13.7169L7.42088 8.34317L14.7751 8.35515Z", fill: "currentColor" })), M9 = V(E9), k9 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { cx: 4, cy: 12, r: 2, fill: "inherit" }), /* @__PURE__ */ o.createElement("circle", { cx: 12, cy: 12, r: 2, fill: "inherit" }), /* @__PURE__ */ o.createElement("circle", { cx: 20, cy: 12, r: 2, fill: "inherit" })), S9 = V(k9), A9 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { className: "svg-substrate", cx: 12, cy: 12, r: 11, fill: "transparent" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM8.15564 5.50001C8.3494 5.50001 8.49406 5.53482 8.61628 5.60018C8.7385 5.66555 8.83443 5.76147 8.89979 5.88369C8.96516 6.00591 8.99997 6.15057 8.99997 6.34433V6.49901L15 6.50001V6.34433C15 6.15057 15.0348 6.00591 15.1001 5.88369C15.1655 5.76147 15.2614 5.66555 15.3836 5.60018C15.5059 5.53482 15.6505 5.50001 15.8443 5.50001H15.9056C16.0994 5.50001 16.2441 5.53482 16.3663 5.60018C16.4885 5.66555 16.5844 5.76147 16.6498 5.88369C16.7152 6.00591 16.75 6.15057 16.75 6.34433L16.7503 6.62825C17.0363 6.6945 17.2504 6.7858 17.4652 6.90071C17.9541 7.16217 18.3378 7.54585 18.5993 8.03474C18.8607 8.52363 19 9.00856 19 10.3458V14.6542C19 15.9915 18.8607 16.4764 18.5993 16.9653C18.3378 17.4542 17.9541 17.8378 17.4652 18.0993C16.9763 18.3608 16.4914 18.5 15.1541 18.5H8.84579C7.50851 18.5 7.02359 18.3608 6.5347 18.0993C6.04581 17.8378 5.66213 17.4542 5.40066 16.9653C5.1392 16.4764 4.99997 15.9915 4.99997 14.6542V10.3458C4.99997 9.00856 5.1392 8.52363 5.40066 8.03474C5.66213 7.54585 6.04581 7.16217 6.5347 6.90071C6.74979 6.78567 6.96412 6.6943 7.2506 6.62803L7.24997 6.34433C7.24997 6.15057 7.28478 6.00591 7.35014 5.88369C7.41551 5.76147 7.51143 5.66555 7.63365 5.60018C7.75587 5.53482 7.90053 5.50001 8.09429 5.50001H8.15564ZM16.4167 10.25H7.58323C7.29348 10.25 7.18842 10.2802 7.08249 10.3368C6.97657 10.3935 6.89343 10.4766 6.83678 10.5825C6.78823 10.6733 6.75912 10.7635 6.7518 10.9699L6.74997 11.0833V15.2555C6.74997 15.7675 6.80317 15.9532 6.90313 16.1404C7.00309 16.3277 7.14982 16.4747 7.33685 16.5751C7.5031 16.6643 7.66818 16.7166 8.06239 16.7279L8.22141 16.7302L16.0974 16.7475C16.6926 16.7475 17.1808 16.299 17.2432 15.7228L17.25 15.5975V11.0833C17.25 10.7935 17.2198 10.6885 17.1631 10.5825C17.1065 10.4766 17.0234 10.3935 16.9174 10.3368C16.8115 10.2802 16.7064 10.25 16.4167 10.25ZM14.4614 11.5H15.0385C15.3728 11.5 15.4941 11.5348 15.6163 11.6002C15.7385 11.6655 15.8344 11.7615 15.8998 11.8837C15.9652 12.0059 16 12.1271 16 12.4615V13.0386C16 13.3729 15.9652 13.4941 15.8998 13.6163C15.8344 13.7385 15.7385 13.8345 15.6163 13.8998C15.4941 13.9652 15.3728 14 15.0385 14H14.4614C14.1271 14 14.0059 13.9652 13.8836 13.8998C13.7614 13.8345 13.6655 13.7385 13.6001 13.6163C13.5348 13.4941 13.5 13.3729 13.5 13.0386V12.4615C13.5 12.1271 13.5348 12.0059 13.6001 11.8837C13.6655 11.7615 13.7614 11.6655 13.8836 11.6002C14.0059 11.5348 14.1271 11.5 14.4614 11.5Z", fill: "inherit" })), T9 = V(A9), I9 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.61632 1.60018C4.49409 1.53482 4.34944 1.50001 4.15567 1.50001H4.09433C3.90056 1.50001 3.7559 1.53482 3.63368 1.60018C3.51146 1.66555 3.41554 1.76147 3.35017 1.88369C3.28481 2.00591 3.25 2.15057 3.25 2.34433L3.25063 2.62803C2.96415 2.6943 2.74982 2.78567 2.53473 2.90071C2.04584 3.16217 1.66216 3.54585 1.4007 4.03474C1.13924 4.52363 1 5.00856 1 6.34584V10.6542C1 11.9915 1.13924 12.4764 1.4007 12.9653C1.66216 13.4542 2.04584 13.8378 2.53473 14.0993C3.02362 14.3608 3.50855 14.5 4.84583 14.5H11.1542C12.4915 14.5 12.9764 14.3608 13.4653 14.0993C13.9542 13.8378 14.3378 13.4542 14.5993 12.9653C14.8608 12.4764 15 11.9915 15 10.6542V6.34584C15 5.00856 14.8608 4.52363 14.5993 4.03474C14.3378 3.54585 13.9542 3.16217 13.4653 2.90071C13.2504 2.7858 13.0363 2.6945 12.7503 2.62826L12.75 2.34433C12.75 2.15057 12.7152 2.00591 12.6498 1.88369C12.5845 1.76147 12.4885 1.66555 12.3663 1.60018C12.2441 1.53482 12.0994 1.50001 11.9057 1.50001H11.8443C11.6506 1.50001 11.5059 1.53482 11.3837 1.60018C11.2615 1.66555 11.1655 1.76147 11.1002 1.88369C11.0348 2.00591 11 2.15057 11 2.34433V2.50001L5 2.49901V2.34433C5 2.15057 4.96519 2.00591 4.89982 1.88369C4.83446 1.76147 4.73854 1.66555 4.61632 1.60018ZM3.58326 6.25001H12.4167C12.7065 6.25001 12.8115 6.28018 12.9175 6.33683C13.0234 6.39348 13.1065 6.47661 13.1632 6.58253C13.2198 6.68846 13.25 6.79353 13.25 7.08327V11.5975L13.2433 11.7228C13.1808 12.299 12.6926 12.7475 12.0975 12.7475L4.22145 12.7302L4.06243 12.7279C3.66822 12.7166 3.50314 12.6643 3.33688 12.5751C3.14985 12.4747 3.00313 12.3277 2.90317 12.1404C2.8032 11.9532 2.75 11.7675 2.75 11.2555V7.08327L2.75184 6.96986C2.75916 6.76349 2.78826 6.67333 2.83682 6.58253C2.89347 6.47661 2.9766 6.39348 3.08253 6.33683C3.18845 6.28018 3.29352 6.25001 3.58326 6.25001ZM11.0385 7.50001H10.4615C10.1271 7.50001 10.0059 7.53482 9.88368 7.60018C9.76146 7.66555 9.66554 7.76147 9.60017 7.88369C9.53481 8.00591 9.5 8.12715 9.5 8.46146V9.03855C9.5 9.37287 9.53481 9.4941 9.60017 9.61632C9.66554 9.73855 9.76146 9.83447 9.88368 9.89983C10.0059 9.9652 10.1271 10 10.4615 10H11.0385C11.3729 10 11.4941 9.9652 11.6163 9.89983C11.7385 9.83447 11.8345 9.73855 11.8998 9.61632C11.9652 9.4941 12 9.37287 12 9.03855V8.46146C12 8.12715 11.9652 8.00591 11.8998 7.88369C11.8345 7.76147 11.7385 7.66555 11.6163 7.60018C11.4941 7.53482 11.3729 7.50001 11.0385 7.50001Z", fill: "inherit" })), R9 = V(I9), N9 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M6.29289 6.29289C6.68342 5.90237 7.31658 5.90237 7.70711 6.29289L14 12.585L20.2929 6.29289C20.6534 5.93241 21.2206 5.90468 21.6129 6.2097L21.7071 6.29289C22.0976 6.68342 22.0976 7.31658 21.7071 7.70711L15.415 14L21.7071 20.2929C22.0676 20.6534 22.0953 21.2206 21.7903 21.6129L21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L14 15.415L7.70711 21.7071C7.34662 22.0676 6.77939 22.0953 6.3871 21.7903L6.29289 21.7071C5.90237 21.3166 5.90237 20.6834 6.29289 20.2929L12.585 14L6.29289 7.70711C5.93241 7.34662 5.90468 6.77939 6.2097 6.3871L6.29289 6.29289Z", fill: "inherit" })), H9 = V(N9), O9 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M3.52514 2.4643C3.23225 2.17141 2.75738 2.17141 2.46448 2.4643C2.17159 2.75719 2.17159 3.23207 2.46448 3.52496L4.93936 5.99983L2.46448 8.47471C2.17159 8.7676 2.17159 9.24247 2.46448 9.53537C2.75738 9.82826 3.23225 9.82826 3.52514 9.53537L6.00002 7.06049L8.47489 9.53537C8.76778 9.82826 9.24266 9.82826 9.53555 9.53537C9.82844 9.24247 9.82844 8.7676 9.53555 8.47471L7.06068 5.99983L9.53555 3.52496C9.82844 3.23207 9.82844 2.75719 9.53555 2.4643C9.24266 2.17141 8.76778 2.17141 8.47489 2.4643L6.00002 4.93917L3.52514 2.4643Z" })), j9 = V(O9), P9 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { cx: 8, cy: 8, r: 7.5, fill: "#3391FF" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.2156 5.22331C12.5206 5.50368 12.5405 5.97813 12.2601 6.28304L8.00028 10.9157C7.86346 11.0645 7.67236 11.1518 7.4703 11.1578C7.26825 11.1637 7.07234 11.0879 6.92699 10.9474L4.15066 8.26414C3.85282 7.97629 3.84472 7.50148 4.13258 7.20364C4.42044 6.90579 4.89525 6.8977 5.19309 7.18556L7.41654 9.33447L11.1559 5.26775C11.4363 4.96284 11.9107 4.94295 12.2156 5.22331Z", fill: "white" })), D9 = V(P9), V9 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", { clipPath: "url(#clip0_1036_7838)" }, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM11.9363 6.7365C12.2878 6.38503 12.2878 5.81518 11.9363 5.46371C11.5848 5.11224 11.015 5.11224 10.6635 5.46371L6.9 9.22723L5.33903 7.66626C4.98756 7.31479 4.41771 7.31479 4.06624 7.66626C3.71477 8.01773 3.71477 8.58758 4.06624 8.93905L6.26361 11.1364C6.43239 11.3052 6.66131 11.4 6.9 11.4C7.1387 11.4 7.36762 11.3052 7.5364 11.1364L11.9363 6.7365Z" })), /* @__PURE__ */ o.createElement("defs", null, /* @__PURE__ */ o.createElement("clipPath", { id: "clip0_1036_7838" }, /* @__PURE__ */ o.createElement("rect", { width: 16, height: 16, fill: "white" })))), B9 = V(V9), F9 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M14.9632 9.26373C15.3147 8.91225 15.8845 8.91225 16.236 9.26373C16.5875 9.6152 16.5875 10.185 16.236 10.5365L11.636 15.1365C11.2845 15.488 10.7147 15.488 10.3632 15.1365L7.76321 12.5365C7.41174 12.185 7.41174 11.6152 7.76321 11.2637C8.11468 10.9123 8.68453 10.9123 9.036 11.2637L10.9996 13.2273L14.9632 9.26373Z" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.9996 2.1001C17.4667 2.1001 21.8996 6.53297 21.8996 12.0001C21.8996 17.4672 17.4667 21.9001 11.9996 21.9001C6.53249 21.9001 2.09961 17.4672 2.09961 12.0001C2.09961 6.53298 6.53249 2.1001 11.9996 2.1001ZM11.9996 3.9001C7.5256 3.9001 3.89961 7.52609 3.89961 12.0001C3.89961 16.4741 7.52561 20.1001 11.9996 20.1001C16.4736 20.1001 20.0996 16.4741 20.0996 12.0001C20.0996 7.52609 16.4736 3.9001 11.9996 3.9001Z" })), Z9 = V(F9), G9 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { className: "svg-substrate", cx: 12, cy: 12, r: 11, fill: "transparent" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM18.5219 9.84228C19.1616 9.19946 19.159 8.15978 18.5162 7.52009C17.8734 6.8804 16.8337 6.88294 16.194 7.52576L10.6245 13.1225L7.65662 10.7905C6.94354 10.2302 5.91126 10.3541 5.35096 11.0672C4.79066 11.7802 4.91452 12.8125 5.6276 13.3728L9.7438 16.6071C10.3986 17.1216 11.3348 17.0645 11.9222 16.4742L18.5219 9.84228Z", fill: "inherit" })), W9 = V(G9), U9 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M14.4174 2.00069C14.0174 2.01401 13.6385 2.18282 13.3611 2.47122C10.418 5.42069 8.17038 7.88408 5.43884 10.6719L2.52922 8.21365C2.37483 8.0831 2.1962 7.98431 2.00356 7.92292C1.81092 7.86153 1.60806 7.83875 1.4066 7.85589C1.20515 7.87303 1.00905 7.92974 0.829553 8.02279C0.650055 8.11585 0.490681 8.24341 0.360562 8.39816C0.230444 8.55291 0.132139 8.73181 0.0712794 8.92462C0.0104197 9.11743 -0.0117981 9.32034 0.0058984 9.52175C0.0235949 9.72316 0.080858 9.91911 0.174407 10.0983C0.267956 10.2776 0.395952 10.4366 0.551063 10.5663L4.54579 13.9465C4.83971 14.194 5.21572 14.3225 5.59968 14.3065C5.98364 14.2905 6.34767 14.1312 6.61998 13.86C9.92944 10.5435 12.2853 7.89444 15.5313 4.64144C15.7542 4.42595 15.9068 4.14808 15.9689 3.8443C16.031 3.54052 15.9997 3.22506 15.8792 2.93937C15.7587 2.65369 15.5546 2.41114 15.2937 2.24361C15.0328 2.07607 14.7273 1.9914 14.4174 2.00069Z", fill: "currentColor" })), z9 = V(U9), q9 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.5162 3.5201C15.159 4.15978 15.1616 5.19946 14.5219 5.84228L7.92225 12.4742C7.33485 13.0645 6.3986 13.1216 5.74381 12.6071L1.6276 9.37281C0.914516 8.81251 0.790664 7.78024 1.35096 7.06716C1.91126 6.35408 2.94354 6.23022 3.65662 6.79052L6.62452 9.12254L12.194 3.52576C12.8337 2.88294 13.8734 2.88041 14.5162 3.5201Z", fill: "inherit" })), $9 = V(q9), Y9 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.435974 2.18404C0 3.03969 0 4.15979 0 6.4V13.6C0 15.8402 0 16.9603 0.435974 17.816C0.819467 18.5686 1.43139 19.1805 2.18404 19.564C3.03969 20 4.15979 20 6.4 20H13.6C15.8402 20 16.9603 20 17.816 19.564C18.5686 19.1805 19.1805 18.5686 19.564 17.816C20 16.9603 20 15.8402 20 13.6V6.4C20 4.15979 20 3.03969 19.564 2.18404C19.1805 1.43139 18.5686 0.819467 17.816 0.435974C16.9603 0 15.8402 0 13.6 0H6.4C4.15979 0 3.03969 0 2.18404 0.435974C1.43139 0.819467 0.819467 1.43139 0.435974 2.18404ZM16.2071 7.20711C16.5976 6.81658 16.5976 6.18342 16.2071 5.79289C15.8166 5.40237 15.1834 5.40237 14.7929 5.79289L8 12.5858L5.20711 9.79289C4.81658 9.40237 4.18342 9.40237 3.79289 9.79289C3.40237 10.1834 3.40237 10.8166 3.79289 11.2071L7.29289 14.7071C7.68342 15.0976 8.31658 15.0976 8.70711 14.7071L16.2071 7.20711Z" })), K9 = V(Y9), Q9 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", { id: "chevron_12" }, /* @__PURE__ */ o.createElement("path", { id: "â³ Icon Color", fillRule: "evenodd", clipRule: "evenodd", d: "M10.2364 3.8637C10.5879 4.21517 10.5879 4.78502 10.2364 5.13649L6.6364 8.73649C6.28492 9.08797 5.71508 9.08797 5.3636 8.73649L1.7636 5.13649C1.41213 4.78502 1.41213 4.21517 1.7636 3.8637C2.11508 3.51223 2.68492 3.51223 3.0364 3.8637L6 6.82731L8.9636 3.8637C9.31508 3.51223 9.88492 3.51223 10.2364 3.8637Z" }))), X9 = V(Q9), J9 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 16, viewBox: "0 0 20 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.21917 5.87534C4.56418 5.44408 5.19347 5.37416 5.62473 5.71917L10 9.21941L14.3753 5.71917C14.8066 5.37416 15.4359 5.44408 15.7809 5.87534C16.1259 6.3066 16.056 6.9359 15.6247 7.28091L10.6247 11.2809C10.2595 11.5731 9.74056 11.5731 9.37534 11.2809L4.37534 7.28091C3.94408 6.9359 3.87416 6.3066 4.21917 5.87534Z", fill: "inherit" })), e8 = V(J9), t8 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M12 13.6983L6.64021 9.2318C6.21593 8.87824 5.58537 8.93556 5.2318 9.35984C4.87824 9.78412 4.93556 10.4147 5.35984 10.7682L11.3598 15.7682C11.7307 16.0773 12.2694 16.0773 12.6402 15.7682L18.6402 10.7682C19.0645 10.4147 19.1218 9.78412 18.7682 9.35984C18.4147 8.93556 17.7841 8.87824 17.3598 9.2318L12 13.6983Z", fill: "inherit" })), n8 = V(t8), r8 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 33, height: 32, viewBox: "0 0 33 32", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29.0448 9.45939C29.5329 9.94754 29.5329 10.739 29.0448 11.2272L17.7311 22.5409C17.4967 22.7753 17.1787 22.907 16.8472 22.907C16.5157 22.907 16.1977 22.7753 15.9633 22.5409L4.64979 11.227C4.16165 10.7388 4.16166 9.94734 4.64982 9.45919C5.13799 8.97105 5.92944 8.97106 6.41759 9.45922L16.8472 19.8892L27.277 9.45939C27.7652 8.97123 28.5566 8.97123 29.0448 9.45939Z", fill: "inherit" })), a8 = V(r8), i8 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", { id: "chevron_down_small_24" }, /* @__PURE__ */ o.createElement("path", { id: "â³ Icon Color", fillRule: "evenodd", clipRule: "evenodd", d: "M17.7364 9.26399C17.3849 8.91252 16.8151 8.91252 16.4636 9.264L12 13.7276L7.53639 9.26399C7.18492 8.91252 6.61507 8.91252 6.2636 9.264C5.91213 9.61547 5.91213 10.1853 6.2636 10.5368L11.3636 15.6368C11.7151 15.9883 12.285 15.9883 12.6364 15.6368L17.7364 10.5368C18.0879 10.1853 18.0879 9.61546 17.7364 9.26399Z" }))), o8 = V(i8), s8 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { id: "â³ Icon Color", d: "M15.8839 18.1161C16.372 18.6043 16.372 19.3957 15.8839 19.8839C15.3957 20.372 14.6043 20.372 14.1161 19.8839L7.11612 12.8839C6.62796 12.3957 6.62796 11.6043 7.11612 11.1161L14.1161 4.11612C14.6043 3.62796 15.3957 3.62796 15.8839 4.11612C16.372 4.60427 16.372 5.39573 15.8839 5.88388L9.76777 12L15.8839 18.1161Z" })), l8 = V(s8), c8 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.29291 4.29289C7.68343 3.90237 8.31659 3.90237 8.70712 4.29289L13.7071 9.29289C13.8947 9.48043 14 9.73478 14 10C14 10.2652 13.8947 10.5196 13.7071 10.7071L8.70711 15.7071C8.31658 16.0976 7.68342 16.0976 7.29289 15.7071C6.90237 15.3166 6.90237 14.6834 7.29289 14.2929L11.5858 10L7.29291 5.70711C6.90238 5.31658 6.90238 4.68342 7.29291 4.29289Z" })), u8 = V(c8), d8 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.14645 2.64645C4.34171 2.45118 4.65829 2.45118 4.85355 2.64645L7.85355 5.64645C8.04882 5.84171 8.04882 6.15829 7.85355 6.35355L4.85355 9.35355C4.65829 9.54882 4.34171 9.54882 4.14645 9.35355C3.95118 9.15829 3.95118 8.84171 4.14645 8.64645L6.79289 6L4.14645 3.35355C3.95118 3.15829 3.95118 2.84171 4.14645 2.64645Z", fill: "inherit" })), f8 = V(d8), h8 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 25, viewBox: "0 0 24 25", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M15.5858 12.1057L8.29289 4.81282C7.90237 4.4223 7.90237 3.78913 8.29289 3.39861C8.68342 3.00808 9.31658 3.00808 9.70711 3.39861L17.7071 11.3986C18.0976 11.7891 18.0976 12.4223 17.7071 12.8128L9.70711 20.8128C9.31658 21.2033 8.68342 21.2033 8.29289 20.8128C7.90237 20.4223 7.90237 19.7891 8.29289 19.3986L15.5858 12.1057Z", fill: "inherit" })), p8 = V(h8), m8 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 48, height: 48, viewBox: "0 0 48 48", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.4632 36.584C18.0618 37.1566 19.0113 37.1355 19.584 36.5368L30.584 25.0368C31.1387 24.4569 31.1387 23.5431 30.584 22.9632L19.584 11.4632C19.0113 10.8645 18.0618 10.8434 17.4632 11.416C16.8645 11.9887 16.8434 12.9382 17.416 13.5368L27.4243 24L17.416 34.4632C16.8434 35.0618 16.8645 36.0113 17.4632 36.584Z", fill: "inherit" })), C8 = V(m8), g8 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.33942 1.20893C4.63231 0.916035 5.10719 0.916035 5.40008 1.20893L11.6606 7.46948C11.9535 7.76237 11.9535 8.23724 11.6606 8.53014L5.40008 14.7907C5.10719 15.0836 4.63231 15.0836 4.33942 14.7907C4.04653 14.4978 4.04653 14.0229 4.33942 13.73L10.0696 7.99981L4.33942 2.26959C4.04653 1.97669 4.04653 1.50182 4.33942 1.20893Z" })), v8 = V(g8), w8 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.26399 6.26361C8.91252 6.61508 8.91252 7.18493 9.264 7.5364L13.7276 12L9.26399 16.4636C8.91252 16.8151 8.91252 17.3849 9.264 17.7364C9.61547 18.0879 10.1853 18.0879 10.5368 17.7364L15.6368 12.6364C15.9883 12.2849 15.9883 11.715 15.6368 11.3636L10.5368 6.2636C10.1853 5.91213 9.61546 5.91213 9.26399 6.26361Z" })), y8 = V(w8), b8 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", { id: "chevron_12" }, /* @__PURE__ */ o.createElement("path", { id: "â³ Icon Color", fillRule: "evenodd", clipRule: "evenodd", d: "M1.7636 8.1363C1.41213 7.78483 1.41213 7.21498 1.7636 6.86351L5.3636 3.26351C5.71508 2.91203 6.28492 2.91203 6.6364 3.26351L10.2364 6.86351C10.5879 7.21498 10.5879 7.78483 10.2364 8.1363C9.88492 8.48777 9.31508 8.48777 8.9636 8.1363L6 5.17269L3.0364 8.1363C2.68492 8.48777 2.11508 8.48777 1.7636 8.1363Z" }))), _8 = V(b8), x8 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { id: "â³ Icon Color", d: "M12 10.3017L6.64018 14.7682C6.2159 15.1218 5.58534 15.0645 5.23177 14.6402C4.87821 14.2159 4.93553 13.5853 5.35981 13.2318L11.3598 8.23178C11.7307 7.92274 12.2693 7.92274 12.6402 8.23178L18.6402 13.2318C19.0645 13.5853 19.1218 14.2159 18.7682 14.6402C18.4147 15.0645 17.7841 15.1218 17.3598 14.7682L12 10.3017Z" })), L8 = V(x8), E8 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.7474 5.83268H8.55295C7.04951 5.83268 5.83073 7.05146 5.83073 8.55491V8.74935H4.08073C3.4364 8.74935 2.91406 9.27168 2.91406 9.91602C2.91406 10.5603 3.4364 11.0827 4.08073 11.0827H5.83073V12.8327H4.08073C3.4364 12.8327 2.91406 13.355 2.91406 13.9993C2.91406 14.6437 3.4364 15.166 4.08073 15.166H5.83073V16.916H4.08073C3.4364 16.916 2.91406 17.4384 2.91406 18.0827C2.91406 18.727 3.4364 19.2493 4.08073 19.2493H5.83073V19.4438C5.83073 20.9472 7.04951 22.166 8.55295 22.166H8.7474V23.916C8.7474 24.5603 9.26973 25.0827 9.91406 25.0827C10.5584 25.0827 11.0807 24.5603 11.0807 23.916V22.166H12.8307V23.916C12.8307 24.5603 13.3531 25.0827 13.9974 25.0827C14.6417 25.0827 15.1641 24.5603 15.1641 23.916V22.166H16.9141V23.916C16.9141 24.5603 17.4364 25.0827 18.0807 25.0827C18.7251 25.0827 19.2474 24.5603 19.2474 23.916V22.166H19.4418C20.9453 22.166 22.1641 20.9472 22.1641 19.4438V19.2493H23.9141C24.5584 19.2493 25.0807 18.727 25.0807 18.0827C25.0807 17.4384 24.5584 16.916 23.9141 16.916H22.1641V15.166H23.9141C24.5584 15.166 25.0807 14.6437 25.0807 13.9993C25.0807 13.355 24.5584 12.8327 23.9141 12.8327H22.1641V11.0827H23.9141C24.5584 11.0827 25.0807 10.5603 25.0807 9.91602C25.0807 9.27168 24.5584 8.74935 23.9141 8.74935H22.1641V8.5549C22.1641 7.05146 20.9453 5.83268 19.4418 5.83268H19.2474V4.08268C19.2474 3.43835 18.7251 2.91602 18.0807 2.91602C17.4364 2.91602 16.9141 3.43835 16.9141 4.08268V5.83268H15.1641V4.08268C15.1641 3.43835 14.6417 2.91602 13.9974 2.91602C13.3531 2.91602 12.8307 3.43835 12.8307 4.08268V5.83268H11.0807V4.08268C11.0807 3.43835 10.5584 2.91602 9.91406 2.91602C9.26973 2.91602 8.7474 3.43835 8.7474 4.08268V5.83268ZM9.33073 8.16602C8.6864 8.16602 8.16406 8.68835 8.16406 9.33268V11.666C8.16406 12.3103 8.6864 12.8327 9.33073 12.8327H11.6641C12.3084 12.8327 12.8307 12.3103 12.8307 11.666V9.33268C12.8307 8.68835 12.3084 8.16602 11.6641 8.16602H9.33073Z" })), M8 = V(E8), k8 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M8.5 4.75C8.5 4.33579 8.16421 4 7.75 4C7.33579 4 7 4.33579 7 4.75V8.75C7 9.05642 7.18641 9.33203 7.47081 9.4461L9.97523 10.4506C10.3597 10.6048 10.7963 10.4181 10.9505 10.0337C11.1047 9.64924 10.9181 9.21259 10.5336 9.0584L8.5 8.24274V4.75Z", fill: "inherit" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM2.5 8C2.5 4.96243 4.96243 2.5 8 2.5C11.0376 2.5 13.5 4.96243 13.5 8C13.5 11.0376 11.0376 13.5 8 13.5C4.96243 13.5 2.5 11.0376 2.5 8Z", fill: "inherit" })), S8 = V(k8), A8 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M12.7364 3.2636C13.0879 3.61508 13.0879 4.18492 12.7364 4.5364L9.273 8L12.7364 11.4636C13.0586 11.7858 13.0854 12.2915 12.817 12.6442L12.7364 12.7364C12.3849 13.0879 11.8151 13.0879 11.4636 12.7364L8 9.273L4.5364 12.7364C4.18492 13.0879 3.61508 13.0879 3.2636 12.7364C2.91213 12.3849 2.91213 11.8151 3.2636 11.4636L6.727 8L3.2636 4.5364C2.94142 4.21421 2.91457 3.70853 3.18306 3.35577L3.2636 3.2636C3.61508 2.91213 4.18492 2.91213 4.5364 3.2636L8 6.727L11.4636 3.2636C11.8151 2.91213 12.3849 2.91213 12.7364 3.2636Z", fill: "currentColor" })), T8 = V(A8), I8 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.71967 6.71967C7.01256 6.42678 7.48744 6.42678 7.78033 6.71967L12 10.9393L16.2197 6.71967C16.5126 6.42678 16.9874 6.42678 17.2803 6.71967C17.5732 7.01256 17.5732 7.48744 17.2803 7.78033L13.0607 12L17.2803 16.2197C17.5732 16.5126 17.5732 16.9874 17.2803 17.2803C16.9874 17.5732 16.5126 17.5732 16.2197 17.2803L12 13.0607L7.78033 17.2803C7.48744 17.5732 7.01256 17.5732 6.71967 17.2803C6.42678 16.9874 6.42678 16.5126 6.71967 16.2197L10.9393 12L6.71967 7.78033C6.42678 7.48744 6.42678 7.01256 6.71967 6.71967Z" })), R8 = V(I8), N8 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { className: "svg-substrate", cx: 12, cy: 12, r: 11, fill: "transparent" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM8.06251 17.5C6.37114 17.5 5.00001 16.0636 5.00001 14.2917C5.00001 12.8591 5.8962 11.6459 7.13327 11.2337C7.34378 11.1636 7.44903 11.1285 7.49846 11.0875C7.55323 11.0422 7.57071 11.0183 7.59745 10.9524C7.62158 10.8929 7.62318 10.7883 7.62638 10.579C7.65985 8.3879 9.40731 6.50001 11.5625 6.50001C13.426 6.50001 14.9872 7.85619 15.3957 9.67784C15.4385 9.86839 15.4598 9.96367 15.4942 10.0159C15.5314 10.0725 15.5548 10.0943 15.6139 10.1272C15.6686 10.1576 15.769 10.1725 15.9699 10.2022C17.6609 10.4524 19 11.9959 19 13.8333C19 15.8584 17.433 17.5 15.5 17.5H8.06251Z", fill: "inherit" })), H8 = V(N8), O8 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.8292 5.80293C8.38025 5.80293 6.44633 7.71596 6.44633 10.0135C6.44633 10.2627 6.46877 10.5061 6.5116 10.7423C6.58796 11.1631 6.3575 11.5796 5.96034 11.7385C4.67951 12.2509 3.80488 13.4585 3.80488 14.8401C3.80488 16.6672 5.3446 18.1989 7.3073 18.1989H15.8186C18.2676 18.1989 20.2015 16.2859 20.2015 13.9884C20.2015 11.7336 18.3396 9.84977 15.9554 9.77981C15.5474 9.76784 15.1985 9.48275 15.1055 9.08529C14.6701 7.22501 12.9364 5.80293 10.8292 5.80293ZM4.64633 10.0135C4.64633 6.66604 7.44288 4.00293 10.8292 4.00293C13.5151 4.00293 15.8231 5.6733 16.669 8.03439C19.6604 8.43581 22.0015 10.926 22.0015 13.9884C22.0015 17.3358 19.205 19.9989 15.8186 19.9989H7.3073C4.40723 19.9989 2.00488 17.7171 2.00488 14.8401C2.00488 12.9181 3.08166 11.2577 4.65713 10.3712C4.64996 10.2528 4.64633 10.1335 4.64633 10.0135Z" })), j8 = V(O8), P8 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.29739 6.75106C6.29739 5.01928 7.61462 3.64757 9.2017 3.64757C10.5614 3.64757 11.7214 4.65197 12.0277 6.03128C12.1126 6.41389 12.4459 6.68108 12.8239 6.66969C12.849 6.66894 12.8742 6.66855 12.8995 6.66855C14.3295 6.66855 15.913 7.90501 15.913 9.46995C15.913 10.9279 14.8777 12.1038 13.5807 12.2547C13.1452 12.3054 12.8317 12.713 12.8806 13.1652C12.9294 13.6173 13.322 13.9427 13.7575 13.892C15.877 13.6454 17.5 11.7463 17.5 9.46995C17.5 7.20615 15.4988 5.31242 13.3969 5.05161C12.753 3.27564 11.1262 2 9.2017 2C6.70428 2 4.71036 4.1449 4.71036 6.75106C4.71036 6.77244 4.7105 6.79378 4.71076 6.81509C3.68163 7.49723 2.5 8.70566 2.5 10.0741C2.5 12.1798 4.11186 13.9189 6.138 13.9189H6.35133C6.78958 13.9189 7.14485 13.5501 7.14485 13.0951C7.14485 12.6402 6.78958 12.2713 6.35133 12.2713H6.138C5.0222 12.2713 4.08703 11.3054 4.08703 10.0741C4.08703 9.15335 5.11754 8.37411 5.8523 8.04539C6.17887 7.89929 6.37194 7.54547 6.32476 7.17957C6.30674 7.03988 6.29739 6.89686 6.29739 6.75106ZM10.8486 10.1503C10.8486 9.69533 10.4933 9.3265 10.0551 9.3265C9.61685 9.3265 9.26158 9.69533 9.26158 10.1503V16.1874L7.88253 14.7558C7.57264 14.434 7.07022 14.434 6.76033 14.7558C6.45045 15.0775 6.45045 15.5991 6.76033 15.9208L9.494 18.7587C9.80388 19.0804 10.3063 19.0804 10.6162 18.7587L13.3532 15.9172C13.6631 15.5955 13.6631 15.0739 13.3532 14.7522C13.0434 14.4305 12.5409 14.4305 12.231 14.7522L10.8486 16.1874V10.1503Z", fill: "inherit" })), D8 = V(P8), V8 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 10.2917C1 12.0636 2.37113 13.5 4.0625 13.5H11.5C13.433 13.5 15 11.8584 15 9.83334C15 7.99594 13.6609 6.45242 11.9699 6.20219C11.769 6.17246 11.6686 6.1576 11.6139 6.12717C11.5548 6.09427 11.5314 6.07248 11.4942 6.01595C11.4598 5.96367 11.4384 5.86839 11.3957 5.67784C10.9871 3.85619 9.426 2.50001 7.5625 2.50001C5.4073 2.50001 3.65984 4.3879 3.62637 6.57896C3.62317 6.78827 3.62157 6.89292 3.59743 6.9524C3.5707 7.0183 3.55321 7.04217 3.49845 7.08753C3.44902 7.12848 3.34376 7.16355 3.13326 7.2337C1.89619 7.6459 1 8.85914 1 10.2917Z", fill: "inherit" })), B8 = V(V8), F8 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 36, height: 36, viewBox: "0 0 36 36", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M18 0C27.9411 0 36 8.05887 36 18C36 27.9411 27.9411 36 18 36C8.05887 36 0 27.9411 0 18C0 8.05887 8.05887 0 18 0ZM26.8262 21.8535C24.7955 24.2393 21.5972 25.7773 18 25.7773C14.3967 25.7773 11.1941 24.2338 9.16309 21.8408C9.12885 22.0389 9.11134 22.2405 9.11133 22.4443C9.11133 25.5126 13.0908 28 18 28C22.9092 28 26.8887 25.5126 26.8887 22.4443C26.8887 22.2405 26.8711 22.0389 26.8369 21.8408L26.8262 21.8535ZM26.8262 17.4092C24.7955 19.795 21.5972 21.333 18 21.333C14.3967 21.333 11.1941 19.7894 9.16309 17.3965C9.12885 17.5946 9.11133 17.7962 9.11133 18C9.11133 21.0682 13.0908 23.5557 18 23.5557C22.9092 23.5557 26.8887 21.0682 26.8887 18C26.8887 17.7962 26.8712 17.5946 26.8369 17.3965L26.8262 17.4092ZM18 8C13.0908 8 9.11133 10.4874 9.11133 13.5557C9.11138 16.6239 13.0908 19.1113 18 19.1113C22.9092 19.1113 26.8886 16.6239 26.8887 13.5557C26.8887 10.4874 22.9092 8.00001 18 8Z" })), Z8 = V(F8), G8 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 36, height: 36, viewBox: "0 0 36 36", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M30.3673 23.3757C30.4152 23.6531 30.4398 23.9348 30.4398 24.2201C30.4398 28.514 24.8703 31.995 18 31.995C11.1297 31.995 5.56018 28.514 5.56018 24.2201C5.56018 23.9348 5.58477 23.6531 5.63269 23.3757C8.47511 26.7246 12.9572 28.885 18 28.885C23.0343 28.885 27.5098 26.7319 30.3517 23.393L30.3673 23.3757ZM30.3673 17.1558C30.4152 17.4332 30.4398 17.7149 30.4398 18.0002C30.4398 22.2941 24.8703 25.7751 18 25.7751C11.1297 25.7751 5.56018 22.2941 5.56018 18.0002C5.56018 17.7149 5.58477 17.4332 5.63269 17.1558C8.47511 20.5047 12.9572 22.6651 18 22.6651C23.0343 22.6651 27.5098 20.512 30.3517 17.1731L30.3673 17.1558ZM18 4.00537C24.8703 4.00537 30.4398 7.48631 30.4398 11.7803C30.4398 16.0742 24.8703 19.5551 18 19.5551C11.1297 19.5551 5.56018 16.0742 5.56018 11.7803C5.56018 7.48631 11.1297 4.00537 18 4.00537Z" })), W8 = V(G8), U8 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { className: "svg-substrate", cx: 12, cy: 12, r: 11, fill: "transparent" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM15.4999 10.372C15.4999 7.88839 13.1494 5.875 10.2499 5.875C7.35042 5.875 4.99991 7.88839 4.99991 10.372C4.99991 11.5438 5.5231 12.6109 6.38084 13.4111C6.27786 13.8966 6.11214 14.5184 5.69665 15.2767L5.60711 15.4379C5.54256 15.5526 5.584 15.6975 5.69968 15.7615C5.75301 15.791 5.81568 15.7993 5.87491 15.7845C7.12604 15.4733 7.95592 14.8436 8.55127 14.3844C9.08406 14.5404 9.65545 14.625 10.2499 14.625C13.1494 14.625 15.4999 12.8557 15.4999 10.372ZM13.8513 16.9566C12.4498 16.9566 11.1791 16.5261 10.2507 15.7917C13.5265 15.7913 16.6666 13.7383 16.6666 10.372C16.6666 9.8172 16.5799 9.28846 16.4197 8.79279C17.9619 9.57079 18.9999 11.0279 18.9999 12.6971C18.9999 13.8707 18.4868 14.9394 17.6457 15.7408C17.7466 16.227 17.8932 16.8498 18.3007 17.6092L18.3885 17.7707C18.4518 17.8856 18.4112 18.0307 18.2977 18.0948C18.2454 18.1244 18.184 18.1326 18.1259 18.1179C16.9026 17.8071 16.1059 17.1794 15.5225 16.7198L15.5171 16.7156C14.9946 16.8718 14.4343 16.9566 13.8513 16.9566Z", fill: "inherit" })), z8 = V(U8), q8 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M6.25 1.875C9.1495 1.875 11.5 3.88839 11.5 6.37203C11.5 8.85567 9.1495 10.625 6.25 10.625C5.65554 10.625 5.08415 10.5404 4.55136 10.3844C3.956 10.8436 3.12613 11.4733 1.875 11.7845C1.81577 11.7993 1.75309 11.791 1.69977 11.7615C1.58409 11.6975 1.54265 11.5526 1.6072 11.4379L1.69673 11.2767C2.11223 10.5184 2.27795 9.89655 2.38092 9.41106C1.52319 8.61086 1 7.54378 1 6.37203C1 3.88839 3.35051 1.875 6.25 1.875Z", fill: "inherit" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.25079 11.7917C7.17918 12.5261 8.44988 12.9566 9.85137 12.9566C10.4344 12.9566 10.9947 12.8718 11.5172 12.7156L11.5226 12.7198C12.106 13.1794 12.9027 13.8071 14.126 14.1179C14.184 14.1326 14.2455 14.1244 14.2978 14.0948C14.4112 14.0307 14.4519 13.8856 14.3886 13.7707L14.3008 13.6092C13.8933 12.8498 13.7467 12.227 13.6457 11.7408C14.4869 10.9394 15 9.87065 15 8.69711C15 7.02791 13.962 5.57079 12.4198 4.79279C12.58 5.28846 12.6667 5.81719 12.6667 6.37203C12.6667 9.73828 9.52656 11.7913 6.25079 11.7917Z", fill: "inherit" })), $8 = V(q8), Y8 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M21 22C21.5523 22 22 21.5523 22 21C22 20.4477 21.5523 20 21 20C20.4477 20 20 20.4477 20 21C20 21.5523 20.4477 22 21 22Z", fill: "#E4E9EC" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24 8.7587V11.1783C24.1219 11.2175 24.2427 11.2662 24.362 11.327C24.9265 11.6146 25.3854 12.0735 25.673 12.638C25.8658 13.0164 25.9371 13.4096 25.9694 13.805C26 14.1796 26 14.6343 26 15.1615V20.8385C26 21.3657 26 21.8205 25.9694 22.195C25.9371 22.5904 25.8658 22.9836 25.673 23.362C25.3854 23.9265 24.9265 24.3854 24.362 24.673C23.9836 24.8658 23.5904 24.9371 23.195 24.9694C22.8205 25 22.3658 25 21.8387 25H20.1615C19.6344 25 19.1795 25 18.805 24.9694C18.4096 24.9371 18.0164 24.8658 17.638 24.673C17.3056 24.5036 17.0097 24.2748 16.7639 24H6C5.44772 24 5 23.5523 5 23C5 22.4477 5.44772 22 6 22H12V19H7.75873C6.95374 19 6.28938 19 5.74817 18.9558C5.18608 18.9099 4.66937 18.8113 4.18404 18.564C3.43139 18.1805 2.81947 17.5686 2.43597 16.816C2.18868 16.3306 2.09012 15.8139 2.04419 15.2518C1.99998 14.7106 1.99999 14.0463 2 13.2413V8.75868C1.99999 7.95372 1.99998 7.28937 2.04419 6.74818C2.09012 6.18608 2.18868 5.66937 2.43597 5.18404C2.81947 4.43139 3.43139 3.81947 4.18404 3.43598C4.66937 3.18868 5.18608 3.09012 5.74818 3.04419C6.28937 2.99998 6.95372 2.99999 7.75868 3H18.2413C19.0463 2.99999 19.7106 2.99998 20.2518 3.0442C20.8139 3.09012 21.3306 3.18869 21.816 3.43598C22.5686 3.81947 23.1805 4.43139 23.564 5.18404C23.8113 5.66938 23.9099 6.18608 23.9558 6.74818C24 7.28937 24 7.95373 24 8.7587ZM22 8.8V11L20.1615 11C19.6343 11 19.1795 11 18.805 11.0306C18.4096 11.0629 18.0164 11.1342 17.638 11.327C17.0735 11.6146 16.6146 12.0735 16.327 12.638C16.1342 13.0164 16.0629 13.4096 16.0306 13.805C16 14.1795 16 14.6343 16 15.1615L16 17L7.8 17C6.94342 17 6.36113 16.9992 5.91104 16.9625C5.47262 16.9266 5.24842 16.8617 5.09202 16.782C4.71569 16.5903 4.40973 16.2843 4.21799 15.908C4.1383 15.7516 4.07337 15.5274 4.03755 15.089C4.00078 14.6389 4 14.0566 4 13.2V8.8C4 7.94342 4.00078 7.36113 4.03755 6.91104C4.07337 6.47262 4.1383 6.24842 4.21799 6.09202C4.40973 5.7157 4.71569 5.40973 5.09202 5.21799C5.24842 5.1383 5.47262 5.07337 5.91104 5.03755C6.36113 5.00078 6.94342 5 7.8 5L18.2 5C19.0566 5 19.6389 5.00078 20.089 5.03755C20.5274 5.07337 20.7516 5.1383 20.908 5.21799C21.2843 5.40974 21.5903 5.7157 21.782 6.09202C21.8617 6.24842 21.9266 6.47262 21.9624 6.91104C21.9992 7.36113 22 7.94342 22 8.8ZM14 19H16L16 20.8385C16 21.2774 16 21.666 16.0176 22H14V19ZM18.9678 13.0239C18.6962 13.0461 18.5955 13.0838 18.546 13.109C18.3578 13.2049 18.2049 13.3578 18.109 13.546C18.0838 13.5955 18.0461 13.6962 18.0239 13.9678C18.0008 14.2512 18 14.6234 18 15.2V20.8C18 21.3766 18.0008 21.7488 18.0239 22.0322C18.0461 22.3038 18.0838 22.4045 18.109 22.454C18.2049 22.6422 18.3578 22.7951 18.546 22.891C18.5955 22.9162 18.6962 22.9539 18.9678 22.9761C19.2512 22.9992 19.6234 23 20.2 23H21.8C22.3766 23 22.7488 22.9992 23.0322 22.9761C23.3038 22.9539 23.4045 22.9162 23.454 22.891C23.6422 22.7951 23.7951 22.6422 23.891 22.454C23.9162 22.4045 23.9539 22.3038 23.9761 22.0322C23.9992 21.7488 24 21.3766 24 20.8V15.2C24 14.6234 23.9992 14.2512 23.9761 13.9678C23.9539 13.6962 23.9162 13.5955 23.891 13.546C23.7951 13.3578 23.6422 13.2049 23.454 13.109C23.4045 13.0838 23.3038 13.0461 23.0322 13.0239C22.7488 13.0008 22.3766 13 21.8 13H20.2C19.6234 13 19.2512 13.0008 18.9678 13.0239Z", fill: "#E4E9EC" })), K8 = V(Y8), Q8 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.95437 4.02059H14.4144C14.3944 3.95059 14.3744 3.87059 14.3544 3.80059C14.1144 3.13059 13.5844 2.60059 12.9144 2.36059C12.5044 2.21059 12.0444 2.21059 11.5444 2.21059H11.2144C9.05437 2.21059 7.72437 2.21059 6.62437 2.61059C4.76437 3.28059 3.30437 4.74059 2.63437 6.60059C2.23437 7.70059 2.23438 9.03059 2.23438 11.1906V13.8306C2.23438 14.1406 2.23437 14.4106 2.24437 14.6406C2.26437 14.8806 2.29438 15.1306 2.39438 15.3906C2.63438 16.0206 3.13437 16.5106 3.76437 16.7606C3.85438 16.8006 3.94437 16.8206 4.03437 16.8406V11.4106C4.03437 8.96059 4.04437 7.98059 4.32437 7.22059C4.81437 5.87059 5.88438 4.80059 7.23438 4.31059C7.82438 4.10059 8.54437 4.04059 9.95437 4.03059V4.02059Z", fill: "currentColor" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.1344 14.1906C19.6344 14.1906 19.2344 14.5906 19.2344 15.0906V17.9306C19.2344 18.5006 19.2344 18.8706 19.2144 19.1506C19.1944 19.4206 19.1544 19.5406 19.1244 19.6006C19.0144 19.8106 18.8444 19.9906 18.6344 20.0906C18.5744 20.1206 18.4544 20.1606 18.1844 20.1806C17.9044 20.2006 17.5344 20.2006 16.9644 20.2006H10.1244C9.55438 20.2006 9.18438 20.2006 8.90438 20.1806C8.63438 20.1606 8.51437 20.1206 8.45437 20.0906C8.24437 19.9806 8.06437 19.8106 7.96438 19.6006C7.93437 19.5406 7.89437 19.4206 7.87437 19.1506C7.85437 18.8706 7.85437 18.5006 7.85437 17.9306V10.0906C7.85437 9.52059 7.85437 9.15059 7.87437 8.87059C7.89437 8.60059 7.93437 8.48059 7.96438 8.42059C8.07438 8.21059 8.24437 8.03059 8.45437 7.93059C8.51437 7.90059 8.63438 7.86059 8.90438 7.84059C9.18438 7.82059 9.55438 7.82059 10.1244 7.82059H12.0644C12.5644 7.82059 12.9644 7.42059 12.9644 6.92059C12.9644 6.42059 12.5644 6.02059 12.0644 6.02059H10.0844C9.56438 6.02059 9.12437 6.02059 8.75437 6.05059C8.37437 6.08059 7.99437 6.15059 7.64437 6.33059C7.08437 6.61059 6.62438 7.07059 6.34438 7.63059C6.16438 7.99059 6.09437 8.36059 6.06437 8.74059C6.03437 9.10059 6.03437 9.55059 6.03437 10.0706V17.9806C6.03437 18.5006 6.03437 18.9406 6.06437 19.3106C6.09437 19.6906 6.16438 20.0706 6.34438 20.4206C6.62438 20.9806 7.08437 21.4406 7.64437 21.7206C8.00437 21.9006 8.37437 21.9706 8.75437 22.0006C9.11438 22.0306 9.56438 22.0306 10.0844 22.0306H16.9944C17.5144 22.0306 17.9544 22.0306 18.3244 22.0006C18.7044 21.9706 19.0844 21.9006 19.4344 21.7206C19.9944 21.4406 20.4544 20.9806 20.7344 20.4206C20.9144 20.0606 20.9844 19.6906 21.0144 19.3106C21.0444 18.9506 21.0444 18.5006 21.0444 17.9806V15.1006C21.0444 14.6006 20.6444 14.2006 20.1444 14.2006L20.1344 14.1906Z", fill: "currentColor" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.0011 3.00002C16.2397 3.00002 14.0011 5.23859 14.0011 8.00002C14.0011 10.7614 16.2397 13 19.0011 13C21.7625 13 24.0011 10.7614 24.0011 8.00002C24.0011 5.23859 21.7625 3.00002 19.0011 3.00002ZM21.7814 6.21969C21.4885 5.92679 21.0137 5.92679 20.7208 6.21969L18.2511 8.68935L17.2814 7.71969C16.9885 7.42679 16.5137 7.42679 16.2208 7.71969C15.9279 8.01258 15.9279 8.48745 16.2208 8.78035L17.7208 10.2803C18.0137 10.5732 18.4885 10.5732 18.7814 10.2803L21.7814 7.28035C22.0743 6.98745 22.0743 6.51258 21.7814 6.21969Z", fill: "currentColor" })), X8 = V(Q8), J8 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.99922 12.3L3.99923 12.0761V12L3.99925 12C3.9996 10.53 4.0046 9.4531 4.07457 8.59665C4.14836 7.69349 4.28991 7.11508 4.52784 6.6481C4.99283 5.73551 5.73478 4.99356 6.64737 4.52857C7.11434 4.29064 7.69276 4.1491 8.59592 4.0753C9.5096 4.00065 10.6742 3.99995 12.2992 3.99995H13.5993L13.7352 4H16.8116C16.7747 3.83635 16.7201 3.67221 16.6377 3.51038C16.4076 3.05879 16.0404 2.69163 15.5888 2.46154C15.2804 2.30437 14.9635 2.24836 14.6577 2.22338C14.3706 2.19992 14.0241 2.19993 13.6326 2.19995H13.6326L13.5993 2.19995H12.2992L12.2591 2.19995C10.6829 2.19995 9.44488 2.19994 8.44935 2.28128C7.43486 2.36417 6.5932 2.53598 5.83019 2.92476C4.57891 3.56232 3.56159 4.57964 2.92403 5.83092C2.53525 6.59393 2.36344 7.4356 2.28055 8.45008C2.19921 9.44561 2.19922 10.6837 2.19922 12.2598L2.19922 12.3V13.6L2.19922 13.6333V13.6333V13.6334C2.1992 14.0248 2.19919 14.3713 2.22265 14.6584C2.24763 14.9642 2.30364 15.2811 2.46081 15.5895C2.6909 16.0411 3.05806 16.4083 3.50965 16.6384C3.67147 16.7208 3.8356 16.7754 3.99923 16.8123V13.6795L3.99922 13.6V12.3ZM10.0792 5.99998L10.0444 5.99998H10.0444C9.52347 5.99996 9.07987 5.99995 8.71548 6.02923C8.33275 6.05999 7.96017 6.12732 7.60299 6.3058C7.04122 6.5865 6.58574 7.04197 6.30504 7.60374C6.12657 7.96093 6.05924 8.3335 6.02848 8.71623C5.9992 9.08063 5.99921 9.52422 5.99922 10.0452V10.0452L5.99922 10.08V17.92L5.99922 17.9548V17.9548C5.99921 18.4757 5.9992 18.9193 6.02848 19.2837C6.05924 19.6664 6.12657 20.039 6.30504 20.3962C6.58574 20.958 7.04122 21.4134 7.60299 21.6941C7.96017 21.8726 8.33275 21.9399 8.71548 21.9707C9.07985 22 9.52341 22 10.0443 22H10.0444H10.0792H16.9192H16.954H16.9541C17.475 22 17.9186 22 18.283 21.9707C18.6657 21.9399 19.0383 21.8726 19.3955 21.6941C19.9572 21.4134 20.4127 20.958 20.6934 20.3962C20.8719 20.039 20.9392 19.6664 20.97 19.2837C20.9993 18.9193 20.9992 18.4757 20.9992 17.9548V17.92V10.08V10.0452C20.9992 9.52422 20.9993 9.08063 20.97 8.71623C20.9392 8.3335 20.8719 7.96093 20.6934 7.60374C20.4127 7.04197 19.9572 6.5865 19.3955 6.3058C19.0383 6.12732 18.6657 6.05999 18.283 6.02923C17.9186 5.99995 17.475 5.99996 16.954 5.99998H16.954L16.9192 5.99998H10.0792ZM8.40755 7.91598C8.47246 7.88354 8.58624 7.84542 8.85966 7.82345C9.14332 7.80066 9.51401 7.79998 10.0792 7.79998H16.9192C17.4844 7.79998 17.8551 7.80066 18.1388 7.82345C18.4122 7.84542 18.526 7.88354 18.5909 7.91598C18.804 8.02245 18.9768 8.19522 19.0832 8.4083C19.1157 8.47321 19.1538 8.587 19.1758 8.86041C19.1986 9.14407 19.1992 9.51476 19.1992 10.08V17.92C19.1992 18.4852 19.1986 18.8559 19.1758 19.1395C19.1538 19.4129 19.1157 19.5267 19.0832 19.5916C18.9768 19.8047 18.804 19.9775 18.5909 20.084C18.526 20.1164 18.4122 20.1545 18.1388 20.1765C17.8551 20.1993 17.4844 20.2 16.9192 20.2H10.0792C9.51401 20.2 9.14332 20.1993 8.85966 20.1765C8.58624 20.1545 8.47246 20.1164 8.40755 20.084C8.19446 19.9775 8.0217 19.8047 7.91523 19.5916C7.88279 19.5267 7.84467 19.4129 7.8227 19.1395C7.7999 18.8559 7.79922 18.4852 7.79922 17.92V10.08C7.79922 9.51476 7.7999 9.14407 7.8227 8.86041C7.84467 8.587 7.88279 8.47321 7.91523 8.4083C8.0217 8.19522 8.19446 8.02245 8.40755 7.91598Z", fill: "currentColor" })), e7 = V(J8), t7 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 21, height: 20, viewBox: "0 0 21 20", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M17.6785 4.69513C18.1072 5.12197 18.1072 5.81401 17.6785 6.24085L8.53219 15.3049C8.10357 15.7317 7.40863 15.7317 6.98 15.3049L3.32147 11.7058C2.89284 11.2789 2.89284 10.5869 3.32147 10.1601C3.75009 9.73323 4.44503 9.73323 4.87365 10.1601L7.7561 12.9863L16.1263 4.69513C16.555 4.26829 17.2499 4.26829 17.6785 4.69513Z", fill: "inherit" })), n7 = V(t7), r7 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 29, height: 28, viewBox: "0 0 29 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", { clipPath: "url(#clip0_3284_275489)" }, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.314453 0H28.3145V28H0.314453V0Z", fill: "#005430" }), /* @__PURE__ */ o.createElement("path", { d: "M25.3129 11.2907C25.3098 10.7754 25.1099 9.38754 25.0592 8.92194C25.0086 8.45633 24.9575 8.03393 24.9699 7.93502C24.9819 7.83957 25.1288 8.06773 25.2065 8.08618C25.2466 8.07813 25.2287 7.93403 25.1557 7.81097C25.1063 7.72741 24.9379 7.41494 24.8357 7.23185C24.7876 7.14519 24.7769 7.09492 24.7537 7.08428C24.7307 7.07363 24.5447 7.44886 24.5651 7.49046C24.6158 7.56672 24.6506 7.60312 24.6585 7.73781C24.6666 7.8725 24.7362 8.83416 24.825 9.56309C24.8918 10.113 25.0384 11.2977 25.0436 12.0343C25.0451 12.2746 25.0185 12.5037 24.9865 12.5994C24.9044 12.7496 24.7761 12.8852 24.2983 13.1647C23.7613 13.4791 23.0448 13.7406 22.7368 13.9157C22.5453 14.0249 22.6088 14.0395 22.7755 13.9917C22.9418 13.9439 23.8017 13.7908 24.2195 13.6143C24.6117 13.4481 24.8662 13.1702 25.0594 12.7648C25.298 12.2635 25.3163 11.8381 25.3129 11.2907Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M23.6502 7.37686C23.6917 7.36077 24.0355 7.34306 24.128 7.36213C24.0672 7.44904 23.6551 7.64142 23.6533 7.6767C23.6646 7.70047 23.938 7.63275 24.0242 7.59512C24.0806 7.5612 24.1182 7.50871 24.16 7.46513C24.2586 7.35173 24.3754 7.1414 24.346 7.11503C24.2982 7.07244 23.8297 7.09894 23.7679 7.10772C23.7266 7.11367 23.6216 7.30184 23.6023 7.35012C23.5834 7.3984 23.6087 7.39296 23.6502 7.37686Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M24.3524 10.4295C24.424 10.1868 24.4417 9.89245 24.3442 9.58258C24.244 9.26355 23.9952 9.06907 23.8158 8.96941L23.7838 9.27655C23.7838 9.27655 24.0354 9.40159 24.2075 9.71641C24.3165 9.91609 24.3619 10.1985 24.2758 10.5133C24.2614 10.5914 24.3173 10.5483 24.3524 10.4295Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M21.6905 11.9711C21.755 11.7526 21.7708 11.4876 21.6833 11.2086C21.593 10.9212 21.369 10.746 21.2074 10.6567L21.1785 10.9331C21.1785 10.9331 21.405 11.0458 21.56 11.329C21.6582 11.5086 21.6989 11.7633 21.6217 12.0467C21.6088 12.1167 21.659 12.0781 21.6905 11.9711Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M12.4494 7.78765C12.553 7.97718 12.596 8.24558 12.5144 8.54455C12.5008 8.6187 12.5535 8.57797 12.5872 8.46507C12.6549 8.23481 12.6718 7.95502 12.5791 7.66051C12.4839 7.35733 12.2476 7.17274 12.0771 7.07829L12.047 7.36995C12.047 7.36995 12.286 7.48868 12.4494 7.78765Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M6.21099 7.88715C6.29803 8.09117 6.30392 8.36662 6.16332 8.6568C6.13601 8.72972 6.20256 8.69518 6.25839 8.58612C6.37248 8.36316 6.43648 8.08412 6.37864 7.77586C6.31932 7.45894 6.08124 7.24291 5.90302 7.12592L5.82214 7.41548C5.82214 7.41548 6.07374 7.56553 6.21099 7.88715Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M7.93547 12.4467C8.04607 12.2414 8.09213 12.1032 8.14127 11.8601C8.18425 11.6462 8.18707 11.3991 8.17153 11.1475C8.50254 11.0126 8.89701 10.7886 9.02957 10.7722C8.93892 11.0834 9.1553 11.4193 9.59235 11.3754C9.62583 11.7274 9.65448 12.0365 9.67189 12.2199C9.70751 12.5957 9.70215 13.0694 9.70108 13.1517C9.69961 13.2344 9.75946 13.2188 9.82092 13.0346C9.90287 12.788 9.92818 12.144 9.89845 11.7181C9.89135 11.6116 9.8793 11.4679 9.86471 11.3041C10.148 11.173 10.1952 10.92 10.3011 10.8121C10.3967 11.147 10.9229 11.1925 11.0853 11.1208C11.2867 11.0318 11.3527 10.8717 11.4046 10.5002C11.4565 10.1288 11.3052 9.97924 11.2511 9.93876C11.2458 9.98369 11.114 10.4202 11.114 10.4202C11.114 10.4202 11.2389 10.5522 11.2452 10.617C11.1435 10.7091 10.9288 10.7148 10.7486 10.6562C10.5682 10.5975 10.5129 10.4895 10.5236 10.4171C10.5341 10.3444 10.602 10.2783 10.6042 10.1898C10.6063 10.1013 10.5638 10.1269 10.4916 10.2053C10.4195 10.2838 10.3729 10.3543 10.273 10.5228C10.1913 10.6606 10.0587 10.8287 9.82494 10.8768C9.78638 10.4722 9.74232 10.0418 9.71287 9.77138C9.69747 9.62864 9.54361 8.39512 9.53263 8.25708C9.52313 8.13688 9.50532 7.99513 9.50826 7.92852C9.51121 7.87554 9.54442 7.89658 9.59584 7.95204C9.64739 8.00738 9.7375 8.10394 9.75304 8.09639C9.80552 8.07064 9.75183 7.91032 9.68314 7.76672C9.61458 7.62274 9.38052 7.05476 9.33138 7.03136C9.30607 7.01947 9.14807 7.36908 9.1387 7.43791C9.1632 7.48099 9.22721 7.54871 9.22948 7.74134C9.23029 7.79507 9.26483 8.30165 9.31277 8.78062C9.35468 9.20364 9.41025 9.605 9.41561 9.65167C9.45377 9.97453 9.5001 10.4296 9.54415 10.877C9.29041 10.8287 9.22292 10.6614 9.22855 10.5659C9.23497 10.4582 9.28358 10.3366 9.26028 10.3092C9.21141 10.2798 8.92057 10.4424 8.51499 10.617C8.4009 10.6661 8.27236 10.7187 8.13672 10.7686C8.10137 10.4637 8.05477 10.1737 8.03603 9.952L8.03375 9.92737C8.30048 9.91016 8.51887 9.77547 8.61823 9.64721C8.74235 9.48689 8.82912 9.15697 8.83756 8.90417C8.84599 8.65113 8.64179 8.1885 8.59319 8.04143C8.54418 7.89423 8.51887 7.79222 8.51459 7.74134C8.51017 7.69046 8.62492 7.80027 8.69709 7.82181C8.74597 7.83159 8.7291 7.72574 8.66938 7.65307C8.61006 7.58065 8.28923 7.09375 8.26674 7.12792C8.25294 7.14798 8.1244 7.50612 8.11596 7.56097C8.16658 7.59439 8.22576 7.6865 8.22991 7.77477C8.2342 7.86303 8.3049 8.25114 8.38323 8.4668C8.46183 8.68245 8.62921 9.09619 8.63978 9.20996C8.52021 9.29426 8.24799 9.437 7.97872 9.42846C7.93265 9.05112 7.87427 8.61288 7.84307 8.30252C7.83102 8.18256 7.83022 8.05455 7.83209 7.9877C7.83357 7.93471 7.87173 7.94202 7.92422 7.99649C7.97697 8.05096 8.05785 8.13019 8.07446 8.1245C8.11061 8.11249 8.07928 7.99228 8.00764 7.84954C7.936 7.7068 7.65133 7.10304 7.60138 7.08051C7.57608 7.06899 7.4486 7.40808 7.44057 7.47728C7.46601 7.52011 7.53122 7.58635 7.53765 7.77898C7.54274 7.93236 7.61745 8.68406 7.68146 9.34613C7.41499 9.20835 7.32407 9.01138 7.29114 8.68072C7.2681 8.45021 7.26583 8.02558 7.18361 7.6704C7.13728 7.4696 7.03967 7.26558 6.92398 7.15726C6.8964 7.22399 6.77321 7.63364 6.77321 7.63364C6.81338 7.75124 6.93831 8.14727 6.93402 8.49044C6.92987 8.83361 6.90282 9.1691 6.51826 9.40023C6.13396 9.63149 5.55752 9.53951 5.41519 9.17876C5.27285 8.81776 5.58926 7.91268 5.58511 7.699C5.58082 7.48533 5.54266 7.45586 5.45335 7.49114C5.36417 7.52643 5.18166 7.73243 5.02446 8.06755C4.86726 8.40292 4.79737 8.81826 4.70806 9.10064C4.61901 9.38303 4.47641 9.66912 4.25574 9.65328C4.03507 9.63768 3.9163 9.43576 3.84841 9.14372C3.78039 8.85144 3.82203 8.46655 3.84051 8.36788C3.88657 8.12078 3.77985 8.17141 3.71451 8.5594C3.67407 8.7987 3.6339 9.18086 3.77624 9.58085C3.91831 9.98085 4.16053 10.13 4.37277 10.0789C4.58513 10.028 4.77179 9.52997 4.83767 9.30627C4.90342 9.08294 5.1976 8.09095 5.36417 8.04217C5.38747 8.15396 5.23469 8.51434 5.18581 8.93587C5.13707 9.3574 5.25075 9.92365 5.78582 10.0216C6.32089 10.1196 6.6839 9.77262 6.81552 9.53171C6.94728 9.29042 7.00874 9.03751 7.0236 8.91012C7.04074 9.23348 7.26141 9.73845 7.69003 9.88243L7.73421 9.89518C7.76059 10.1599 7.80357 10.5054 7.84307 10.8682C7.75965 10.894 7.67543 10.9173 7.59161 10.9373C7.5809 10.9025 7.56911 10.8685 7.55479 10.8372C7.42396 10.5558 7.20745 10.2964 6.90738 10.3144C6.60088 10.3326 6.26666 10.7416 6.28126 11.0403C6.2909 11.2412 6.4015 11.4061 6.80374 11.4483C6.98745 11.4678 7.18254 11.4474 7.38406 11.4034C7.41245 11.4865 7.43039 11.5691 7.4324 11.6443C7.30493 11.7934 6.25019 12.5889 5.46044 12.6654C4.6707 12.7418 4.42981 12.3278 4.42191 11.9122C4.41602 11.596 4.60616 11.2805 4.73979 11.0621C4.931 10.9222 5.08793 10.7473 5.18702 10.6123C5.21393 10.6289 5.23951 10.6443 5.26388 10.6585C5.35828 10.7134 5.3959 10.7953 5.3959 10.7953C5.41331 10.7686 5.49445 10.6225 5.46272 10.5511C5.44812 10.5335 5.37676 10.4895 5.29093 10.4374C5.38104 10.2128 5.37984 9.98865 5.26307 9.93876C5.13252 9.88317 4.96206 10.0377 4.88855 10.1319C4.85039 10.1809 4.8358 10.2365 4.83553 10.2832C4.83499 10.3432 4.86325 10.3974 4.93314 10.4457C5.00277 10.4932 5.06744 10.5363 5.12824 10.5752C4.95564 10.7564 4.54778 11.022 4.29818 11.178C4.28895 11.1551 4.25239 11.1792 4.20325 11.2371L4.13563 11.2789C3.93652 11.4007 3.45903 11.6682 3.36516 11.7337C3.27117 11.7993 3.33008 11.7874 3.36516 11.7728C3.43144 11.737 3.51848 11.6937 3.61623 11.6459C3.75468 11.5782 3.91576 11.5016 4.07323 11.4247C4.02663 11.5037 3.97843 11.596 3.93572 11.6968C3.74785 12.1404 3.44417 13.0597 4.10108 13.6128C4.72961 14.1423 5.80992 13.9409 6.70585 13.3906C7.60192 12.8402 7.79541 12.6467 7.93547 12.4467ZM5.01429 10.2599C4.98322 10.237 4.97894 10.2064 5.00424 10.1851C5.03651 10.1576 5.07776 10.1316 5.12462 10.1228C5.22397 10.1044 5.26361 10.2185 5.22371 10.3963C5.14819 10.3501 5.07052 10.3016 5.01429 10.2599ZM7.0694 11.0097C6.6132 11.0118 6.59217 10.929 6.60074 10.876C6.60918 10.8233 6.75125 10.6786 6.93148 10.774C7.00767 10.8145 7.0935 10.8992 7.1729 11.0055C7.13782 11.0081 7.10327 11.0095 7.0694 11.0097ZM5.67214 13.4088C4.81022 13.644 3.96946 13.2796 3.91858 12.5579C3.87961 12.0069 4.0806 11.5917 4.21021 11.3577C4.3338 11.2966 4.45056 11.2371 4.54711 11.1839C4.32148 11.5473 4.18946 12.0339 4.2777 12.4462C4.37759 12.9131 4.78384 13.1963 5.47169 13.1049C6.15271 13.0146 7.07355 12.3669 7.33465 12.1227C7.41419 12.0345 7.46668 11.9551 7.53818 11.7931C7.56764 11.7266 7.60902 11.6389 7.62441 11.5397C7.63446 11.4751 7.63981 11.406 7.64102 11.3357C7.72096 11.3118 7.8013 11.2851 7.88217 11.2563C7.90962 11.552 7.92984 11.8434 7.93105 12.0954C7.50672 12.5931 6.53406 13.1735 5.67214 13.4088Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M20.7483 11.5169C20.7191 11.0341 20.6486 10.1602 20.6093 9.71688C20.5745 9.32234 20.506 8.78159 20.456 8.30559C20.4434 8.18575 20.442 8.07099 20.4434 8.00426C20.4448 7.95153 20.4976 7.97183 20.5504 8.02605C20.6031 8.08027 20.6856 8.14836 20.7011 8.14007C20.7527 8.11333 20.691 7.98111 20.6185 7.83887C20.5461 7.69638 20.2589 7.10698 20.2089 7.08457C20.1835 7.07318 20.0489 7.42625 20.0411 7.49545C20.0668 7.53804 20.1326 7.60402 20.1397 7.79665C20.1469 7.98941 20.2443 8.87555 20.3146 9.59222C20.3633 10.0904 20.4262 10.9032 20.472 11.5162C20.4698 11.5172 20.5153 12.0989 20.5202 12.1642C20.5484 12.5406 20.5338 13.0141 20.5309 13.0963C20.5279 13.1789 20.5883 13.1645 20.6531 12.9813C20.7191 12.7943 20.7567 12.3766 20.7618 11.9995L20.7483 11.5169Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M18.301 9.82684C18.2126 9.85383 18.0739 9.76036 18.0844 9.56439C18.0941 9.38736 18.1699 9.22159 18.1991 9.11698C18.2392 8.97264 18.2395 8.83349 18.2055 8.91235C18.1289 9.08863 17.9863 9.42945 17.9568 9.66071C17.9272 9.89196 18.0022 10.041 18.1041 10.0919C18.2311 10.1556 18.3225 10.0545 18.3844 9.90545C18.4438 9.76272 18.4326 9.59608 18.3913 9.63533C18.3568 9.6763 18.3439 9.8136 18.301 9.82684Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M17.0305 10.5385C17.0774 10.414 17.0884 10.2919 17.0523 10.3589C16.9711 10.5089 16.8188 10.7989 16.7742 11.0003C16.7298 11.2017 16.7837 11.338 16.8694 11.3896C16.9763 11.4543 17.0643 11.3714 17.1308 11.2445C17.1944 11.1231 17.1976 10.9756 17.1585 11.0076C17.1248 11.0413 17.1024 11.161 17.0639 11.1698C16.9837 11.1875 16.8693 11.0959 16.8941 10.924C16.9166 10.7693 16.9965 10.6285 17.0305 10.5385Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M13.3311 13.1671C13.4094 13.04 13.4484 12.9081 13.394 12.9747C13.2727 13.1235 13.043 13.4123 12.9504 13.6242C12.858 13.836 12.8875 13.9951 12.9698 14.0675C13.0725 14.1579 13.187 14.0836 13.287 13.9574C13.383 13.8365 13.4189 13.676 13.3687 13.7034C13.3246 13.7342 13.2743 13.8609 13.23 13.8632C13.1388 13.8677 13.0335 13.7462 13.0981 13.5633C13.1565 13.3981 13.2744 13.2592 13.3311 13.1671Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M19.8169 9.45646C19.7271 9.47899 19.5943 9.37834 19.6165 9.18311C19.6367 9.00695 19.7225 8.84539 19.7578 8.74264C19.8068 8.6004 19.8152 8.46162 19.7765 8.53837C19.6897 8.7107 19.5269 9.04347 19.4834 9.27299C19.4399 9.50239 19.5056 9.65503 19.6044 9.71111C19.7276 9.78093 19.8246 9.68487 19.8955 9.53903C19.9634 9.39964 19.9624 9.23276 19.9186 9.26989C19.8818 9.30926 19.8607 9.44556 19.8169 9.45646Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M19.7895 11.8517C19.9124 11.9216 20.0099 11.8255 20.0806 11.6797C20.1484 11.5403 20.1474 11.3734 20.1039 11.4105C20.0668 11.4496 20.0458 11.5862 20.002 11.5971C19.9122 11.6195 19.7791 11.519 19.8016 11.3237C19.8218 11.1476 19.9075 10.9859 19.9428 10.8833C19.9917 10.741 20.0001 10.602 19.9616 10.679C19.8745 10.8513 19.712 11.1841 19.6685 11.4134C19.6249 11.643 19.6907 11.7957 19.7895 11.8517Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M21.3605 8.79195C21.4197 8.61987 21.4299 8.45187 21.383 8.54485C21.2778 8.75332 21.0809 9.15591 21.0282 9.43384C20.9757 9.71152 21.0553 9.8961 21.1749 9.96407C21.3237 10.0485 21.4414 9.93225 21.5272 9.75596C21.609 9.58722 21.6078 9.38506 21.5551 9.43025C21.5105 9.47766 21.4849 9.64256 21.4319 9.65581C21.3234 9.68304 21.1623 9.56135 21.1895 9.32514C21.214 9.11196 21.3178 8.91649 21.3605 8.79195Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M8.80535 11.7673C8.90216 11.5576 8.93724 11.3476 8.86601 11.4594C8.70653 11.7096 8.40619 12.194 8.30363 12.5372C8.20092 12.8805 8.27698 13.1217 8.41824 13.2206C8.59446 13.3434 8.75768 13.2102 8.8885 12.9984C9.0137 12.7952 9.03861 12.5408 8.96643 12.5917C8.90417 12.6462 8.85034 12.8509 8.78205 12.8617C8.64173 12.8837 8.45534 12.7126 8.52041 12.4186C8.57933 12.1533 8.73546 11.9191 8.80535 11.7673Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M22.3615 13.8477C22.4356 13.7869 23.0808 13.4394 23.1995 13.3688C23.1995 13.3688 23.321 13.1707 23.2846 13.1497C23.248 13.1286 23.0125 13.3428 22.866 13.3488C22.7194 13.3547 22.5187 13.247 22.5122 13.1587C22.5312 13.0921 22.7076 12.9921 22.7713 12.988C22.8351 12.9843 22.8247 13.1294 22.846 13.1471C22.8673 13.1645 22.9521 13.0469 22.9628 12.9979C22.9732 12.949 22.9645 12.7442 22.8479 12.7736C22.6633 12.8203 22.3848 13.1627 22.353 13.2704C22.321 13.3783 22.4931 13.4723 22.6187 13.5234C22.608 13.5274 22.5142 13.5725 22.4549 13.6311C22.4549 13.6311 22.3912 13.7026 22.3615 13.8477Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M20.1616 14.2773C20.2358 14.2166 20.8809 13.8693 20.9997 13.7985C20.9997 13.7985 21.1214 13.6004 21.0847 13.5794C21.0482 13.5583 20.8126 13.7725 20.6662 13.7784C20.5195 13.7844 20.3188 13.6767 20.3124 13.5884C20.3314 13.5218 20.5078 13.4218 20.5715 13.4179C20.6352 13.414 20.6249 13.5589 20.6462 13.5765C20.6675 13.5942 20.7523 13.4766 20.763 13.4276C20.7734 13.3787 20.7644 13.1739 20.6481 13.2033C20.4634 13.2502 20.1849 13.5924 20.1532 13.7003C20.1212 13.808 20.2932 13.902 20.4186 13.9531C20.4081 13.9571 20.3144 14.002 20.2551 14.0608C20.2551 14.0608 20.1913 14.1323 20.1616 14.2773Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M15.2065 8.04882C15.2643 8.11604 15.6432 8.59749 15.9401 8.90018C16.2368 9.20311 16.7455 9.69335 17.1192 10.0293C17.1915 10.0945 17.2683 10.165 17.3463 10.2384C17.4406 10.9622 17.5496 11.8831 17.5954 12.2639C17.6405 12.6389 17.6472 13.1124 17.6481 13.1949C17.6489 13.2774 17.7084 13.2606 17.7649 13.0753C17.8407 12.8266 17.8494 12.1826 17.8092 11.7572C17.7843 11.4945 17.7255 11.0024 17.6686 10.5487C17.8893 10.7667 18.0978 10.983 18.2382 11.1449C18.4965 11.4421 18.7139 11.6663 18.8463 11.9858C18.94 12.2119 18.9305 12.3918 18.9689 12.4273C19.0021 12.458 19.0388 12.1875 18.9979 11.9252C18.9314 11.4992 18.8404 11.3186 18.2935 10.7104C18.0849 10.4779 17.8393 10.2348 17.5993 10.0077C17.59 9.93761 17.5816 9.87274 17.574 9.81517C17.5549 9.67293 17.3696 8.44312 17.355 8.30533C17.3426 8.18537 17.3207 8.04412 17.3225 7.97739C17.3238 7.92428 17.3576 7.94495 17.4106 7.99918C17.4634 8.05328 17.5557 8.14798 17.5714 8.13969C17.6231 8.11295 17.5655 7.95411 17.4931 7.81162C17.4209 7.66938 17.1723 7.10659 17.1223 7.08431C17.097 7.07292 16.948 7.42587 16.9403 7.49495C16.9662 7.53754 17.0318 7.60389 17.0389 7.79627C17.0409 7.85 17.0886 8.35584 17.1484 8.83345C17.2014 9.25548 17.2671 9.65572 17.2739 9.70202L17.2742 9.70561C17.0266 9.4798 16.8084 9.28804 16.6762 9.16758C16.3668 8.88644 15.6837 8.21929 15.6562 8.11939C15.6501 8.08782 15.7031 8.10725 15.8006 8.12285C15.8985 8.13857 15.9855 8.17188 15.9698 8.12384C15.9627 8.10119 15.9252 8.04523 15.8319 7.98754C15.7384 7.92973 15.499 7.77993 15.3209 7.67396C15.1425 7.56811 15.0541 7.47935 15.0173 7.50473C14.999 7.51723 15.0152 7.87984 15.026 7.92502C15.0705 7.92886 15.1489 7.98135 15.2065 8.04882Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M15.6941 7.39651C15.7674 7.38041 16.1144 7.3892 16.2404 7.4157C16.1877 7.45234 15.8326 7.63172 15.7624 7.67443C15.6926 7.71727 15.675 7.74203 15.71 7.73782C15.8118 7.70959 16.0412 7.67443 16.1511 7.61712C16.2548 7.56859 16.4314 7.33188 16.5001 7.24362C16.5684 7.15535 16.5684 7.11128 16.5509 7.08763C16.4808 7.0495 16.0285 7.01125 15.8103 7.06535C15.75 7.10632 15.6319 7.32458 15.6144 7.37001C15.597 7.4157 15.6209 7.4126 15.6941 7.39651Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M17.6244 7.36907C17.6836 7.35607 17.9633 7.36312 18.0647 7.38442C18.0222 7.414 17.7362 7.5586 17.6797 7.59326C17.6231 7.62756 17.609 7.64761 17.6373 7.64414C17.7194 7.62161 17.9043 7.59326 17.9928 7.54684C18.0762 7.50772 18.2185 7.31695 18.2738 7.24601C18.3289 7.1747 18.3289 7.1393 18.3148 7.12036C18.2586 7.08928 17.894 7.05858 17.7182 7.10228C17.6694 7.13521 17.5745 7.31113 17.5604 7.34777C17.5461 7.38442 17.5655 7.38206 17.6244 7.36907Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M19.1937 7.34758C19.2526 7.33458 19.5323 7.34164 19.6337 7.36293C19.5915 7.39252 19.3053 7.53712 19.2487 7.57153C19.1923 7.60607 19.1783 7.62613 19.2065 7.62266C19.2886 7.60013 19.4879 7.57153 19.5764 7.52535C19.6599 7.48623 19.7589 7.29546 19.8142 7.22428C19.8695 7.15322 19.8695 7.11756 19.8551 7.09887C19.7989 7.0678 19.4629 7.0371 19.2874 7.08055C19.2387 7.11373 19.1435 7.28964 19.1294 7.32629C19.1153 7.36293 19.1345 7.36058 19.1937 7.34758Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M18.2147 8.11162C18.1218 8.25795 18.2383 8.37605 18.2807 8.49428C18.2234 8.54665 18.1353 8.49886 18.1059 8.45293C18.0432 8.35872 18.0642 8.16671 17.9904 8.13712C17.9716 8.18899 17.9592 8.24656 17.9592 8.24656C17.9592 8.24656 18.0154 8.37791 18.0013 8.46482C17.9923 8.51731 17.946 8.57859 17.8848 8.57982C17.7217 8.58379 17.8021 8.34238 17.7391 8.20558C17.7263 8.23901 17.717 8.27491 17.702 8.30623C17.7135 8.34189 17.7198 8.3919 17.7217 8.42074C17.7255 8.47806 17.7209 8.53984 17.7307 8.58874C17.7442 8.65794 17.7826 8.70387 17.8413 8.70833C17.9631 8.71798 18.0187 8.61932 18.037 8.53835C18.0581 8.62093 18.2192 8.71192 18.2984 8.61053C18.4034 8.47682 18.3194 8.36231 18.2656 8.23653C18.2268 8.14356 18.238 8.08253 18.2147 8.11162Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M13.6372 7.72512C13.6457 7.78529 13.6766 7.82639 13.7271 7.83258C13.8313 7.84582 13.884 7.763 13.9037 7.69417C13.9175 7.7661 14.0522 7.85077 14.1255 7.76684C14.2223 7.65579 14.1552 7.55378 14.1147 7.44323C14.0858 7.36128 14.0983 7.30928 14.0768 7.33342C13.9898 7.45549 14.0847 7.56233 14.1157 7.66594C14.0637 7.70853 13.9902 7.66384 13.9669 7.62336C13.9174 7.53955 13.9444 7.37502 13.8826 7.34642C13.8638 7.39049 13.8506 7.43939 13.8506 7.43939C13.8506 7.43939 13.8925 7.5549 13.8761 7.62905C13.8661 7.67399 13.8234 7.72487 13.7703 7.72351C13.6299 7.72042 13.7105 7.51565 13.6626 7.39545C13.6501 7.42355 13.6403 7.45437 13.6257 7.48037C13.6342 7.51182 13.6372 7.5549 13.6372 7.58003C13.6383 7.62955 13.6314 7.68229 13.6372 7.72512Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M16.9609 13.3935C16.9766 13.3686 17.0111 13.3003 17.0024 13.2536C16.9937 13.2069 16.9365 13.0122 16.8255 12.9634C16.7152 12.9147 16.6317 13.0169 16.5788 13.1592L16.5421 13.1583C16.5334 13.1793 16.5224 13.2108 16.5137 13.2676C16.5014 13.3497 16.4781 13.4025 16.3373 13.5303C16.219 13.6373 15.8355 13.8942 15.587 14.0149C15.3382 14.1358 15.1591 14.2402 15.0931 14.2719C15.0274 14.3031 15.0465 14.3147 15.1123 14.295C15.1779 14.2754 15.5081 14.1691 15.6397 14.1149C15.7711 14.0603 15.9318 13.9705 16.1254 13.8449C16.3407 13.7052 16.4694 13.5656 16.5126 13.4418C16.5434 13.3535 16.5513 13.3182 16.5513 13.3182C16.5513 13.3182 16.6322 13.366 16.7694 13.3973C16.9062 13.4288 16.945 13.4186 16.9609 13.3935ZM16.7753 13.1168C16.8363 13.14 16.8733 13.2063 16.8843 13.2466C16.8144 13.2482 16.6858 13.2126 16.631 13.1879C16.6639 13.1241 16.7212 13.0965 16.7753 13.1168Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M15.5034 13.5321C15.3125 13.5056 14.8314 13.4325 14.7137 13.1532C14.8125 13.0091 15.2676 12.8266 15.8378 12.6559C16.4079 12.4855 17.0037 12.2644 17.1638 12.1577C17.1989 12.1458 17.2668 12.1494 17.2668 12.1494C17.2954 12.0669 17.4386 11.7769 17.4476 11.7163C17.2882 11.7253 16.306 11.7975 15.8698 11.8209C15.4333 11.8444 14.5927 11.8387 14.3125 11.8356C14.4843 11.7121 14.8921 11.4709 15.4748 11.2651C15.5503 11.2384 15.6202 11.2143 15.6854 11.1925C15.7339 11.2789 15.7699 11.3643 15.7774 11.4387C15.8145 11.4006 15.8423 11.2742 15.833 11.1444C16.1727 11.036 16.3477 11.0001 16.4232 10.9797C16.4709 10.9179 16.5554 10.6681 16.568 10.4865C16.5172 10.394 16.3583 10.2788 16.2169 10.1799C16.022 10.0439 15.812 9.92528 15.6023 9.97715C15.3156 10.0475 15.2581 10.5741 15.325 10.6858C15.3462 10.7211 15.3967 10.7836 15.4563 10.8607C15.2469 10.943 15.0278 11.0398 14.8347 11.1416C14.4047 11.3681 13.9245 11.616 13.7844 11.8543L13.7443 11.8739C13.733 11.8964 13.6444 12.2652 13.6315 12.3049C13.721 12.3018 14.3889 12.3031 14.854 12.2886C15.3189 12.2737 15.7255 12.259 15.8847 12.259C15.6489 12.3148 15.0309 12.5445 14.8532 12.6795C14.6755 12.815 14.5639 13.0208 14.5609 13.3738C14.3953 13.3089 14.0874 13.1607 13.8251 12.8059C13.5327 12.4105 13.5932 12.0038 13.4762 11.4702C13.3061 10.6957 12.943 10.0418 12.7168 9.84172C12.6406 10.1151 12.6309 10.3211 12.6309 10.3211C12.6309 10.3211 12.9142 10.9475 13.0576 11.3473C13.201 11.7473 13.3235 12.1414 13.3175 12.2297C13.1994 12.4886 12.5003 13.0311 11.9177 13.3487C11.3652 13.6497 10.8785 13.6822 10.706 13.4678C10.6722 13.4259 10.6491 13.3764 10.6362 13.3203C10.7111 13.2853 10.7864 13.25 10.8635 13.2147C11.3603 12.9884 12.2426 12.512 12.4493 12.2621C12.6724 11.9592 12.6693 11.5327 12.5385 11.2885C12.4082 11.0445 12.2039 10.762 12.1879 10.6621C12.1755 10.615 12.3206 10.6813 12.4063 10.6858C12.4478 10.6827 12.4271 10.6268 12.338 10.5386C12.2668 10.4683 11.9914 10.2401 11.8861 10.1511C11.8597 10.1284 11.8401 10.1376 11.8347 10.1615C11.8142 10.2526 11.7723 10.4477 11.7561 10.544L11.7673 10.5926C11.7976 10.6105 11.8324 10.6307 11.8493 10.6811C11.8731 10.7525 11.9565 10.9518 12.0933 11.2034C12.2302 11.4548 12.4281 11.7324 12.4476 11.8725C12.2866 12.0778 11.475 12.5149 10.6845 12.8751C10.7334 12.7236 10.8105 12.5523 10.9128 12.362C10.9418 12.3298 10.9684 12.2901 10.993 12.2453C11.0719 12.1012 11.0795 11.925 11.0317 11.9623C10.9907 12.0017 10.9613 12.1447 10.9144 12.1544C10.8184 12.1741 10.6837 12.062 10.7176 11.8571C10.7482 11.6723 10.847 11.5054 10.8898 11.3986C10.9489 11.2508 10.9651 11.1047 10.9203 11.1842C10.8195 11.3617 10.6303 11.7056 10.5721 11.9459C10.5143 12.1858 10.5758 12.3499 10.6771 12.4134C10.715 12.4375 10.7513 12.4451 10.7859 12.4404C10.7165 12.5723 10.6308 12.7343 10.5683 12.9274C10.2504 13.0696 9.94107 13.1968 9.68506 13.2884C8.76476 13.6178 8.10891 13.8119 7.65016 13.956L7.63222 13.9641C7.66597 13.855 7.66141 13.7619 7.62526 13.7899C7.58429 13.8296 7.55496 13.9726 7.5081 13.982C7.41209 14.0017 7.27739 13.8898 7.31113 13.6848C7.34193 13.4999 7.44074 13.3333 7.48346 13.2264C7.54237 13.0787 7.55871 12.9323 7.51399 13.0119C7.41303 13.1895 7.22396 13.5334 7.16585 13.7735C7.10787 14.0136 7.16933 14.1776 7.27056 14.2413C7.39669 14.3205 7.50421 14.2233 7.5867 14.073L7.61562 14.0112C7.64427 14.0112 7.69261 14.0045 7.76478 13.9885C7.97501 13.9412 8.50057 13.8649 9.22323 13.7707C9.7583 13.7011 10.1277 13.5542 10.4848 13.3906C10.4832 13.4301 10.4828 13.4704 10.4846 13.5118C10.504 14.0022 10.8254 14.1406 11.2648 14.0489C11.6887 13.9599 12.2799 13.5711 12.6342 13.3089C13.0037 13.0356 13.2168 12.7913 13.2712 12.7062C13.3697 12.4973 13.3968 12.2665 13.4035 12.1577C13.4358 12.4576 13.4619 12.8725 13.7455 13.2285C14.0066 13.556 14.5416 14.0131 15.548 14.0256C15.5514 13.9059 15.5034 13.5321 15.5034 13.5321ZM15.4369 10.4936C15.581 10.332 15.8884 10.4377 16.1191 10.6427C16.0009 10.6704 15.8403 10.7198 15.6632 10.7831C15.5579 10.6562 15.4405 10.5339 15.4369 10.4936Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M9.77889 8.27554C9.84423 8.24571 10.0441 8.15583 10.2596 8.0303C10.4746 7.90563 10.6767 7.7546 10.7755 7.6542C10.8134 7.6157 10.8471 7.58561 10.8687 7.54984C10.9332 7.57658 10.9777 7.60431 11.0054 7.6152C11.0471 7.6313 11.1026 7.65445 11.1388 7.53585C11.1748 7.41737 11.127 7.34087 11.0566 7.2495C10.997 7.17287 10.9024 7.05774 10.8257 7.02914C10.7606 7.00475 10.7297 7.15009 10.7396 7.1465H10.7831L10.7916 7.15059C10.702 7.19577 10.6326 7.33641 10.6257 7.3858C10.6186 7.43953 10.6288 7.47915 10.7573 7.5122L10.809 7.52743C10.7017 7.65445 10.5018 7.7858 10.3656 7.87889C10.1724 8.01136 9.89819 8.17687 9.82013 8.22466C9.74207 8.2722 9.74863 8.28718 9.77889 8.27554ZM10.9401 7.34235L10.947 7.27884C11.0374 7.38184 11.1045 7.5044 11.0978 7.52173C11.0563 7.52508 11.0046 7.4867 10.9142 7.44808C10.9243 7.41737 10.9327 7.38345 10.9401 7.34235ZM10.6806 7.34248C10.68 7.32316 10.7149 7.26943 10.7885 7.24009C10.862 7.21051 10.8945 7.29308 10.901 7.3936L10.8792 7.43384L10.8129 7.41094C10.7427 7.39039 10.6953 7.37875 10.6806 7.34248Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M14.5979 10.2155C14.7039 10.1454 14.9954 9.93498 15.1608 9.79707C15.2758 9.70125 15.4109 9.56012 15.5026 9.44078C15.5602 9.47804 15.6139 9.51109 15.6628 9.53982C15.7571 9.59491 15.795 9.67661 15.795 9.67661C15.8124 9.64987 15.8935 9.50354 15.8618 9.43236C15.8428 9.40909 15.7268 9.34137 15.6083 9.26882C15.6684 9.13388 15.7512 8.90052 15.6327 8.81882C15.5313 8.74949 15.3603 8.86425 15.2812 9.01318C15.2158 9.13648 15.2074 9.24109 15.3321 9.32676C15.3671 9.3509 15.4008 9.37368 15.4337 9.39534C15.308 9.53288 15.0763 9.73641 14.9115 9.87494C14.7067 10.0463 14.5131 10.2143 14.4794 10.2544L14.4696 10.27C14.4249 10.1454 14.4371 10.0686 14.4039 10.1099C14.2605 10.3348 14.4401 10.5171 14.5055 10.6991C14.4171 10.7793 14.2817 10.7056 14.2363 10.6354C14.1397 10.4901 14.1719 10.195 14.0588 10.1493C14.0296 10.229 14.0106 10.3178 14.0106 10.3178C14.0106 10.3178 14.0967 10.5199 14.0749 10.6534C14.0613 10.7341 13.9898 10.8286 13.896 10.8302C13.6448 10.8366 13.7686 10.465 13.6717 10.2545C13.652 10.3061 13.6379 10.3613 13.6144 10.4091C13.6322 10.4645 13.642 10.5412 13.6445 10.5857C13.6509 10.6739 13.6437 10.7686 13.6586 10.8444C13.6793 10.9509 13.7385 11.0217 13.8289 11.0282C14.0162 11.0435 14.1018 10.8912 14.1302 10.767C14.1624 10.894 14.4106 11.0337 14.5325 10.8779C14.6942 10.6721 14.5648 10.4958 14.4822 10.3022L14.4724 10.277C14.4839 10.2811 14.5272 10.2622 14.5979 10.2155ZM15.3306 9.05626C15.3927 8.94101 15.5235 8.93123 15.5628 8.99164C15.594 9.03967 15.5965 9.13339 15.5496 9.2323C15.4342 9.15988 15.3313 9.08894 15.3306 9.05626Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M10.5086 9.48291C10.2879 9.46731 10.1692 9.26515 10.1013 8.97311C10.0333 8.68107 10.0749 8.29594 10.0934 8.19727C10.1119 8.09873 10.0078 8.14961 9.96738 8.38891C9.92721 8.62796 9.88677 9.01025 10.0291 9.41049C10.1712 9.81023 10.4134 9.95941 10.6256 9.90828C10.8379 9.8574 11.0247 9.35936 11.0905 9.13591C11.1563 8.91233 11.4505 8.00056 11.617 7.95153C11.6403 8.06332 11.4876 8.34372 11.4387 8.76526C11.3901 9.18679 11.4747 9.73967 12.0098 9.83772C12.5448 9.93589 12.9078 9.58876 13.0395 9.34748C13.1712 9.10657 13.2327 8.85328 13.2475 8.72601C13.2647 9.0495 13.4854 9.55459 13.914 9.69857C14.3281 9.83772 14.6445 9.71033 14.7843 9.52996C14.9085 9.36976 15.0095 9.03984 15.0183 8.7868C15.0267 8.534 14.8082 8.07137 14.7593 7.92405C14.7103 7.7771 14.685 7.67509 14.6807 7.62421C14.6765 7.57333 14.7913 7.68314 14.8635 7.70468C14.9123 7.71446 14.8952 7.60861 14.8357 7.53594C14.7764 7.46352 14.4553 6.97662 14.4328 7.01054C14.419 7.03085 14.2905 7.38899 14.2821 7.44384C14.3329 7.47726 14.3919 7.56937 14.3963 7.65763C14.4003 7.7459 14.4853 8.13401 14.5639 8.34967C14.6425 8.56532 14.7953 8.97905 14.806 9.09283C14.6532 9.20053 14.3091 9.33757 13.9823 9.19867C13.6554 9.05928 13.5511 8.85736 13.5151 8.49661C13.492 8.2661 13.4898 7.84148 13.4076 7.48642C13.3612 7.28575 13.2636 7.08173 13.1477 6.9734C13.1203 7.03988 12.9972 7.44978 12.9972 7.44978C13.0373 7.56739 13.1623 7.96342 13.1582 8.30658C13.1538 8.6495 13.1268 8.98512 12.7422 9.21638C12.3579 9.44763 11.8104 9.35552 11.6681 8.99465C11.5257 8.63391 11.8421 7.82229 11.838 7.60861C11.8337 7.39494 11.7953 7.36535 11.7062 7.40075C11.617 7.43604 11.4343 7.64204 11.2773 7.97716C11.1201 8.31253 11.0504 8.64765 10.9609 8.93003C10.8719 9.21241 10.7293 9.49851 10.5086 9.48291Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M4.10137 8.23161C4.37292 8.21192 4.60242 8.00605 4.66174 7.95133C4.72119 7.89624 4.75319 7.81416 4.71061 7.84536C4.39648 8.12576 3.97617 8.13368 3.9526 8.08651C3.96331 8.03947 4.07392 7.96296 4.23527 7.85526C4.33328 7.78977 4.42059 7.72837 4.48593 7.64134L4.50374 7.64443C4.62331 7.67068 4.76136 7.72292 4.80354 7.68108C4.87223 7.61336 4.88134 7.50244 4.80689 7.38285C4.74396 7.28133 4.5972 7.18687 4.46973 7.11866C4.34252 7.05082 4.31788 7.15914 4.30155 7.19777C4.28588 7.23379 4.29231 7.2645 4.31922 7.26524C4.27825 7.32107 4.24906 7.393 4.23835 7.45242C4.23138 7.4908 4.23701 7.52224 4.25267 7.54812C4.25723 7.55542 4.28079 7.58427 4.32538 7.60135L4.38068 7.61856C4.28548 7.70645 4.17581 7.77529 4.11824 7.81007C4.01433 7.87284 3.89114 7.98265 3.85298 8.09617C3.81468 8.21006 3.82955 8.25129 4.10137 8.23161ZM4.5814 7.43063L4.59184 7.3727V7.33556C4.67794 7.3982 4.81559 7.5168 4.80716 7.58786C4.75266 7.57548 4.64875 7.55356 4.55007 7.52819C4.56265 7.4986 4.57296 7.46616 4.5814 7.43063ZM4.32619 7.44871C4.26285 7.3982 4.32458 7.34781 4.38068 7.31538C4.45312 7.27353 4.49557 7.30807 4.53266 7.41788C4.51967 7.44933 4.50146 7.4799 4.48004 7.50924C4.42367 7.49179 4.34426 7.46381 4.32619 7.44871Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M4.91596 11.2985C4.8379 11.3662 4.80764 11.5866 4.82357 11.5998C4.83937 11.6131 5.08334 11.6954 5.1215 11.7132L5.13891 11.6469C5.25513 11.7512 5.38395 12.2719 5.4126 12.2734C5.44126 12.2748 5.48277 12.2145 5.50995 12.0762C5.53499 11.948 5.56003 11.7561 5.58614 11.5998C5.61051 11.4568 5.6484 11.375 5.73436 11.3587C5.82046 11.3426 5.8842 11.4529 5.90643 11.5279C5.90643 11.5279 5.96682 11.3837 5.97967 11.294C5.96534 11.2469 5.83144 11.0691 5.72164 11.1279C5.61171 11.1868 5.54289 11.4363 5.52066 11.5923C5.4983 11.748 5.48116 11.9411 5.45411 11.9721C5.42572 11.8391 5.33481 11.6012 5.22501 11.4675C5.10155 11.3177 4.9572 11.2627 4.91596 11.2985Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M3.87531 11.0327C3.9772 11.0047 4.20658 10.9696 4.31637 10.9122C4.41988 10.8637 4.59649 10.627 4.66505 10.5387C4.73348 10.4505 4.73361 10.4062 4.7162 10.3828C4.64617 10.3444 4.19372 10.3064 3.97546 10.3605C3.91521 10.4012 3.79724 10.6195 3.77983 10.6651C3.76216 10.7106 3.78626 10.7077 3.85937 10.6916C3.93261 10.6753 4.27982 10.6841 4.40542 10.7106C4.35306 10.7475 3.99796 10.9268 3.92779 10.9696C3.8579 11.0121 3.84022 11.0371 3.87531 11.0327Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M24.9115 12.2947C24.901 12.0302 24.7714 11.624 24.2787 11.0008C24.1086 10.7856 23.8693 10.5056 23.6169 10.2188C23.61 10.121 23.603 10.0316 23.5967 9.95483C23.5636 9.56004 23.4516 8.75461 23.4034 8.27848C23.3916 8.1584 23.3906 8.03064 23.3924 7.96391C23.3941 7.91092 23.4323 7.91798 23.4848 7.97245C23.5373 8.0268 23.6181 8.10615 23.635 8.10071C23.6709 8.08833 23.6397 7.96812 23.5681 7.82563C23.4966 7.68289 23.2262 7.10562 23.1765 7.08321C23.151 7.07182 23.0235 7.41078 23.0156 7.48011C23.0409 7.52269 23.1062 7.58893 23.1125 7.78168C23.1192 7.97431 23.2355 9.11201 23.3023 9.82893L23.3059 9.86892C22.9286 9.44763 22.5732 9.06349 22.427 8.90775C22.4017 8.88076 22.3738 8.85006 22.3438 8.81713C22.32 8.62536 22.298 8.44264 22.2829 8.29173C22.2706 8.17189 22.2698 8.04388 22.2719 7.97716C22.2731 7.9243 22.3115 7.93148 22.364 7.98595C22.4168 8.04029 22.4974 8.11965 22.5143 8.11395C22.5502 8.10182 22.519 7.98161 22.4472 7.83887C22.3758 7.69614 22.094 7.10562 22.044 7.08321C22.0187 7.07182 21.8853 7.43777 21.8774 7.5066C21.903 7.54944 21.9682 7.61567 21.9746 7.80842C21.9772 7.89025 21.9985 8.13834 22.0269 8.45143C21.7767 8.15419 21.5318 7.84296 21.5144 7.7797C21.5083 7.7485 21.5612 7.76769 21.659 7.78354C21.7565 7.79914 21.848 7.82848 21.8323 7.78019C21.8249 7.75779 21.7877 7.70183 21.6944 7.64389C21.6009 7.58608 21.3615 7.43628 21.1834 7.33056C21.0049 7.22471 20.9166 7.1357 20.8797 7.16108C20.8615 7.17358 20.8777 7.53644 20.8882 7.58137C20.933 7.58546 21.0159 7.61876 21.0687 7.68933C21.122 7.75989 21.4631 8.23825 21.733 8.56173C21.8106 8.65483 21.9322 8.79918 22.0745 8.96581C22.1024 9.26379 22.1316 9.57168 22.1557 9.82893C22.2104 10.4157 22.4073 11.9633 22.4092 12.4663C22.2639 12.6026 21.9667 12.7928 21.6611 12.7967C21.3554 12.8006 21.1877 12.7201 21.0645 12.4928C21.0265 12.4224 20.9911 12.3516 20.9561 12.2874C20.8728 12.135 20.6869 12.0495 20.5078 12.0915L20.4804 12.0988L20.4317 12.1222C20.3104 12.1857 20.1849 12.2921 20.0623 12.4573C19.8502 12.7438 19.7147 13.0545 19.5577 13.3236C19.3942 13.6039 19.2688 13.792 18.982 13.747C18.78 13.7153 18.6267 13.5421 18.5322 13.3291C18.7977 13.1454 18.9905 12.9057 19.1315 12.5735C19.3151 12.1418 19.3806 11.6552 19.3643 11.108C19.3486 10.593 19.1139 9.3814 19.0519 8.91703C18.99 8.45242 18.9011 8.07112 18.9114 7.97196C18.921 7.87626 19.0734 8.10157 19.1515 8.11841C19.1914 8.1095 19.17 7.96577 19.0942 7.84432C19.0428 7.76175 18.8799 7.38615 18.7733 7.20503C18.7233 7.11936 18.7112 7.06972 18.6879 7.05957C18.6649 7.04904 18.4875 7.42799 18.5089 7.46921C18.5614 7.54424 18.5973 7.58001 18.6082 7.71446C18.6195 7.8489 18.7411 8.83582 18.8474 9.56264C18.9275 10.1111 19.1043 11.1073 19.1271 11.8436C19.1346 12.0839 19.1003 12.2564 19.0706 12.3527C18.9943 12.5002 18.8699 12.6642 18.4328 12.9753C18.3654 12.5356 18.4387 12.1785 18.3747 12.1454C18.3026 12.1532 18.291 12.3581 18.2829 12.6109C18.2789 12.7277 18.2839 12.8893 18.3059 13.063C17.7691 13.4218 17.06 13.7485 16.7269 13.9229C16.5316 14.0254 16.602 14.0493 16.7674 13.9982C16.9327 13.9468 17.8415 13.7085 18.3267 13.4534L18.3789 13.4244C18.4035 13.5099 18.4334 13.5928 18.4701 13.6691C18.6333 14.0083 18.8665 14.2098 19.1192 14.1901C19.3317 14.1737 19.4858 13.9463 19.6203 13.6751C19.7562 13.4005 19.9858 12.8791 20.211 12.6851C20.2975 12.6103 20.387 12.5511 20.474 12.5156C20.474 12.5156 20.6279 12.4642 20.7694 12.5567C20.8202 12.5901 20.858 12.6377 20.882 12.6909C20.9379 12.8131 21.0039 12.9686 21.1388 13.0988C21.3766 13.3278 21.7591 13.2805 22.0459 13.1473C22.3323 13.014 22.4785 12.806 22.5423 12.5589C22.651 12.1362 22.6336 11.703 22.6128 11.3182C22.5888 10.8791 22.5187 10.4303 22.4788 9.95483C22.4659 9.80194 22.4409 9.58925 22.4121 9.35862C22.6914 9.68099 22.9814 10.0082 23.1574 10.1871C23.218 10.2489 23.2821 10.3174 23.3478 10.3899C23.4003 11.1096 23.4508 12.0102 23.4774 12.3882C23.5038 12.7648 23.4868 13.2382 23.4837 13.3205C23.4805 13.4029 23.5263 13.3887 23.592 13.206C23.6801 12.9608 23.7354 12.3176 23.7162 11.8912C23.7046 11.6377 23.6793 11.1757 23.652 10.7387C23.8688 10.9963 24.0746 11.2564 24.2085 11.432C24.4466 11.7437 24.6652 12.1144 24.7417 12.3456C24.818 12.5771 24.8265 12.6457 24.8413 12.6869C24.8562 12.7282 24.9219 12.5593 24.9115 12.2947Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M20.8912 21.1004C20.8697 21.0389 20.8039 20.9938 20.7251 20.9938C20.6464 20.9938 20.5806 21.0389 20.559 21.1004H19.8133C19.8058 21.0177 19.8131 20.9346 19.8365 20.8536L21.3761 20.8526L21.419 20.9249C21.4577 20.99 21.5066 21.0489 21.5633 21.1004L20.8912 21.1004ZM21.9104 20.385H20.0603C20.2025 20.2824 20.2771 20.1326 20.2571 19.9812C20.2443 19.8857 20.1497 19.8144 20.0344 19.8047H19.9765C19.8362 19.8184 19.7344 19.9195 19.7492 20.0306L19.7549 20.0733L19.7617 20.139C19.7692 20.2214 19.762 20.3043 19.7387 20.385H6.0636C6.26666 20.6804 6.6369 20.8616 7.0367 20.8613L19.5155 20.8537C19.3728 20.9564 19.2979 21.1065 19.3181 21.2582C19.3329 21.3693 19.4584 21.4484 19.5987 21.4347C19.7388 21.421 19.8406 21.3198 19.8259 21.2086L19.8203 21.1661H20.5536C20.5665 21.2376 20.638 21.2926 20.7251 21.2926C20.8122 21.2926 20.8837 21.2376 20.8967 21.1661H21.6427V21.1643C21.7985 21.2749 21.9964 21.3384 22.2058 21.3384C22.4028 21.3384 22.5625 21.2015 22.5625 21.0326V20.9442C22.5625 20.6355 22.2706 20.385 21.9104 20.385", fill: "white" })), /* @__PURE__ */ o.createElement("defs", null, /* @__PURE__ */ o.createElement("clipPath", { id: "clip0_3284_275489" }, /* @__PURE__ */ o.createElement("rect", { x: 0.314453, width: 28, height: 28, rx: 14, fill: "white" })))), a7 = V(r7), i7 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 29, height: 28, viewBox: "0 0 29 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", { clipPath: "url(#clip0_265_1548)" }, /* @__PURE__ */ o.createElement("path", { d: "M0.314453 13.999C0.314453 15.7115 0.622508 17.3519 1.18524 18.8686L14.3145 20.086L27.4437 18.8686C28.0064 17.3519 28.3145 15.7115 28.3145 13.999C28.3145 12.2866 28.0064 10.6462 27.4437 9.12951L14.3145 7.91211L1.18524 9.12951C0.622508 10.6462 0.314453 12.2866 0.314453 13.999H0.314453Z", fill: "#FFDA44" }), /* @__PURE__ */ o.createElement("path", { d: "M14.3145 28C22.0464 28 28.3145 21.732 28.3145 14C28.3145 6.26801 22.0464 0 14.3145 0C6.58247 0 0.314453 6.26801 0.314453 14C0.314453 21.732 6.58247 28 14.3145 28Z", fill: "#EE1C25" }), /* @__PURE__ */ o.createElement("path", { d: "M28.3145 14C28.3145 21.7319 22.0464 28 14.3145 28C6.58252 28 0.314453 21.7319 0.314453 14", fill: "#D80027" }), /* @__PURE__ */ o.createElement("g", { clipPath: "url(#clip1_265_1548)" }, /* @__PURE__ */ o.createElement("path", { d: "M0 4H49V41H0V4Z", fill: "#EE1C25" }), /* @__PURE__ */ o.createElement("path", { d: "M5.88002 17.6899L9.18748 7.69995L12.4949 17.6899L3.67505 11.585H14.6999L5.88002 17.6899Z", fill: "#FFFF00" }), /* @__PURE__ */ o.createElement("path", { d: "M20.2256 7.89144L16.8218 8.65087L19.0922 5.98713L18.8696 9.57218L16.9807 6.39833L20.2256 7.89144Z", fill: "#FFFF00" }), /* @__PURE__ */ o.createElement("path", { d: "M23.6608 12.2747L20.2309 11.6456L23.3497 10.0769L21.7635 13.2944L21.245 9.63136L23.6608 12.2747Z", fill: "#FFFF00" }), /* @__PURE__ */ o.createElement("path", { d: "M23.1601 18.4241L20.2833 16.4413L23.7664 16.2897L21.0147 18.5761L22.0252 15.0187L23.1601 18.4241Z", fill: "#FFFF00" }), /* @__PURE__ */ o.createElement("path", { d: "M18.8335 22.4415L16.9406 19.4938L20.2116 20.7084L16.7963 21.7473L19.0931 18.8589L18.8335 22.4415Z", fill: "#FFFF00" }))), /* @__PURE__ */ o.createElement("defs", null, /* @__PURE__ */ o.createElement("clipPath", { id: "clip0_265_1548" }, /* @__PURE__ */ o.createElement("rect", { x: 0.314453, width: 28, height: 28, rx: 14, fill: "white" })), /* @__PURE__ */ o.createElement("clipPath", { id: "clip1_265_1548" }, /* @__PURE__ */ o.createElement("rect", { width: 49, height: 37, fill: "white", transform: "translate(0 4)" })))), o7 = V(i7), s7 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 29, height: 28, viewBox: "0 0 29 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", { clipPath: "url(#clip0_64_2724)" }, /* @__PURE__ */ o.createElement("path", { d: "M14.3145 28C22.0464 28 28.3145 21.732 28.3145 14C28.3145 6.26801 22.0464 0 14.3145 0C6.58247 0 0.314453 6.26801 0.314453 14C0.314453 21.732 6.58247 28 14.3145 28Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M3.2067 5.47656C2.10698 6.90735 1.27776 8.55645 0.794922 10.348H8.07809L3.2067 5.47656Z", fill: "#0052B4" }), /* @__PURE__ */ o.createElement("path", { d: "M27.8319 10.3479C27.3491 8.55645 26.5198 6.90735 25.4201 5.47656L20.5488 10.3479H27.8319Z", fill: "#0052B4" }), /* @__PURE__ */ o.createElement("path", { d: "M0.794922 17.6523C1.27781 19.4438 2.10704 21.0929 3.2067 22.5236L8.07793 17.6523H0.794922Z", fill: "#0052B4" }), /* @__PURE__ */ o.createElement("path", { d: "M22.8342 2.89425C21.4034 1.79454 19.7544 0.965312 17.9629 0.482422V7.76554L22.8342 2.89425Z", fill: "#0052B4" }), /* @__PURE__ */ o.createElement("path", { d: "M5.79102 25.1056C7.2218 26.2053 8.87091 27.0345 10.6624 27.5174V20.2344L5.79102 25.1056Z", fill: "#0052B4" }), /* @__PURE__ */ o.createElement("path", { d: "M10.6623 0.482422C8.87085 0.965312 7.22175 1.79454 5.79102 2.8942L10.6623 7.76548V0.482422Z", fill: "#0052B4" }), /* @__PURE__ */ o.createElement("path", { d: "M17.9629 27.5174C19.7543 27.0345 21.4034 26.2053 22.8342 25.1057L17.9629 20.2344V27.5174Z", fill: "#0052B4" }), /* @__PURE__ */ o.createElement("path", { d: "M20.5488 17.6523L25.4201 22.5237C26.5198 21.093 27.3491 19.4438 27.8319 17.6523H20.5488Z", fill: "#0052B4" }), /* @__PURE__ */ o.createElement("path", { d: "M28.1959 12.1739H16.1406L16.1406 0.118508C15.5428 0.0406875 14.9334 0 14.3145 0C13.6954 0 13.0861 0.0406875 12.4884 0.118508V12.1738L0.432961 12.1739C0.355141 12.7717 0.314453 13.3811 0.314453 14C0.314453 14.619 0.355141 15.2283 0.432961 15.8261H12.4883L12.4883 27.8815C13.0861 27.9593 13.6954 28 14.3145 28C14.9334 28 15.5428 27.9594 16.1405 27.8815V15.8262L28.1959 15.8261C28.2738 15.2283 28.3145 14.619 28.3145 14C28.3145 13.3811 28.2738 12.7717 28.1959 12.1739Z", fill: "#D80027" }), /* @__PURE__ */ o.createElement("path", { d: "M17.9666 17.6522L24.2139 23.8994C24.5013 23.6122 24.7753 23.3119 25.0369 23.0006L19.6883 17.6521H17.9666V17.6522Z", fill: "#D80027" }), /* @__PURE__ */ o.createElement("path", { d: "M10.6634 17.6523H10.6632L4.41602 23.8996C4.70323 24.1869 5.00352 24.461 5.3148 24.7225L10.6634 19.3739V17.6523Z", fill: "#D80027" }), /* @__PURE__ */ o.createElement("path", { d: "M10.662 10.3471V10.3469L4.41473 4.09961C4.12741 4.38683 3.85331 4.68712 3.5918 4.9984L8.9404 10.347H10.662V10.3471Z", fill: "#D80027" }), /* @__PURE__ */ o.createElement("path", { d: "M17.9668 10.3476L24.2141 4.10023C23.9269 3.8129 23.6266 3.5388 23.3153 3.27734L17.9668 8.62595V10.3476Z", fill: "#D80027" })), /* @__PURE__ */ o.createElement("defs", null, /* @__PURE__ */ o.createElement("clipPath", { id: "clip0_64_2724" }, /* @__PURE__ */ o.createElement("rect", { x: 0.314453, width: 28, height: 28, rx: 12, fill: "white" })))), l7 = V(s7), c7 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 29, height: 28, viewBox: "0 0 29 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", { clipPath: "url(#clip0_64_2745)" }, /* @__PURE__ */ o.createElement("path", { d: "M14.3145 28C22.0464 28 28.3145 21.732 28.3145 14C28.3145 6.26801 22.0464 0 14.3145 0C6.58247 0 0.314453 6.26801 0.314453 14C0.314453 21.732 6.58247 28 14.3145 28Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M28.3121 14.0003C28.3121 7.9808 24.5129 2.8492 19.1816 0.871094V27.1296C24.5129 25.1514 28.3121 20.0198 28.3121 14.0003Z", fill: "#D80027" }), /* @__PURE__ */ o.createElement("path", { d: "M0.314453 14.0003C0.314453 20.0198 4.11376 25.1514 9.44491 27.1295V0.871094C4.11376 2.8492 0.314453 7.9808 0.314453 14.0003Z", fill: "#0052B4" })), /* @__PURE__ */ o.createElement("defs", null, /* @__PURE__ */ o.createElement("clipPath", { id: "clip0_64_2745" }, /* @__PURE__ */ o.createElement("rect", { x: 0.314453, width: 28, height: 28, rx: 12, fill: "white" })))), u7 = V(c7), d7 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 29, height: 28, viewBox: "0 0 29 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", { clipPath: "url(#clip0_265_1384)" }, /* @__PURE__ */ o.createElement("path", { d: "M1.18555 18.8697C3.16365 24.2008 8.29525 28.0001 14.3148 28.0001C20.3343 28.0001 25.4659 24.2008 27.444 18.8697L14.3148 17.6523L1.18555 18.8697Z", fill: "#FFDA44" }), /* @__PURE__ */ o.createElement("path", { d: "M14.3148 0C8.29525 0 3.16365 3.79925 1.18555 9.13046L14.3148 10.3478L27.444 9.13041C25.4659 3.79925 20.3343 0 14.3148 0Z", fill: "black" }), /* @__PURE__ */ o.createElement("path", { d: "M1.18524 9.13086C0.622508 10.6475 0.314453 12.2879 0.314453 14.0004C0.314453 15.7129 0.622508 17.3533 1.18524 18.8699H27.4437C28.0065 17.3533 28.3145 15.7129 28.3145 14.0004C28.3145 12.2879 28.0065 10.6475 27.4437 9.13086H1.18524Z", fill: "#D80027" })), /* @__PURE__ */ o.createElement("defs", null, /* @__PURE__ */ o.createElement("clipPath", { id: "clip0_265_1384" }, /* @__PURE__ */ o.createElement("rect", { x: 0.314453, width: 28, height: 28, rx: 12, fill: "white" })))), f7 = V(d7), h7 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 29, height: 28, viewBox: "0 0 29 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", { clipPath: "url(#clip0_64_2741)" }, /* @__PURE__ */ o.createElement("path", { d: "M19.1841 27.1289C24.5153 25.1508 28.3146 20.0192 28.3146 13.9997C28.3146 7.98019 24.5153 2.84859 19.1841 0.870485L17.9668 13.9997L19.1841 27.1289Z", fill: "#CE2B37" }), /* @__PURE__ */ o.createElement("path", { d: "M0.314453 13.9997C0.314453 20.0192 4.1137 25.1508 9.44491 27.1289L10.6623 13.9997L9.44486 0.870485C4.1137 2.84859 0.314452 7.98019 0.314453 13.9997Z", fill: "#009246" }), /* @__PURE__ */ o.createElement("path", { d: "M9.44531 27.1292C10.962 27.6919 12.6024 28 14.3149 28C16.0273 28 17.6677 27.6919 19.1844 27.1292L19.1844 0.870735C17.6677 0.308 16.0273 -2.87709e-07 14.3149 -2.12854e-07C12.6024 -1.37999e-07 10.962 0.308 9.44531 0.870789L9.44531 27.1292Z", fill: "white" })), /* @__PURE__ */ o.createElement("defs", null, /* @__PURE__ */ o.createElement("clipPath", { id: "clip0_64_2741" }, /* @__PURE__ */ o.createElement("rect", { x: 0.314453, y: 28, width: 28, height: 28, rx: 12, transform: "rotate(-90 0.314453 28)", fill: "white" })))), p7 = V(h7), m7 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 29, height: 28, viewBox: "0 0 29 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", { clipPath: "url(#clip0_64_2754)" }, /* @__PURE__ */ o.createElement("path", { d: "M0.314453 13.999C0.314453 15.7115 0.622508 17.3519 1.18524 18.8686L14.3145 20.086L27.4437 18.8686C28.0064 17.3519 28.3145 15.7115 28.3145 13.999C28.3145 12.2866 28.0064 10.6462 27.4437 9.12951L14.3145 7.91211L1.18524 9.12951C0.622508 10.6462 0.314453 12.2866 0.314453 13.999H0.314453Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M14.3145 28C22.0464 28 28.3145 21.732 28.3145 14C28.3145 6.26801 22.0464 0 14.3145 0C6.58247 0 0.314453 6.26801 0.314453 14C0.314453 21.732 6.58247 28 14.3145 28Z", fill: "white" }), /* @__PURE__ */ o.createElement("circle", { cx: 14.3145, cy: 14, r: 8, fill: "#BC002D" })), /* @__PURE__ */ o.createElement("defs", null, /* @__PURE__ */ o.createElement("clipPath", { id: "clip0_64_2754" }, /* @__PURE__ */ o.createElement("rect", { x: 0.314453, width: 28, height: 28, rx: 12, fill: "white" })))), C7 = V(m7), g7 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", { id: "Kazakhstan", clipPath: "url(#clip0_885_54080)" }, /* @__PURE__ */ o.createElement("path", { id: "Vector", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z", fill: "#338AF3" }), /* @__PURE__ */ o.createElement("path", { id: "Vector_2", d: "M18.783 12.1304H5.21777C5.21777 13.0669 6.03345 13.826 6.96987 13.826H6.91343C6.91343 14.7625 7.67257 15.5217 8.60909 15.5217C8.60909 16.4582 9.36823 17.2173 10.3047 17.2173H13.6961C14.6326 17.2173 15.3917 16.4582 15.3917 15.5217C16.3282 15.5217 17.0874 14.7625 17.0874 13.826H17.0309C17.9673 13.826 18.783 13.0669 18.783 12.1304Z", fill: "#FFDA44" }), /* @__PURE__ */ o.createElement("path", { id: "Vector_3", d: "M16.696 9.91309C16.696 12.5064 14.5937 14.6087 12.0003 14.6087C9.40698 14.6087 7.30469 12.5064 7.30469 9.91309", fill: "#338AF3" }), /* @__PURE__ */ o.createElement("path", { id: "Vector_4", d: "M15.5864 9.91287L14.1208 10.6023L14.9012 12.0216L13.3098 11.7172L13.1082 13.3248L11.9997 12.1424L10.8912 13.3248L10.6896 11.7172L9.09821 12.0215L9.87859 10.6022L8.41309 9.91287L9.87863 9.22352L9.09821 7.8042L10.6896 8.1086L10.8913 6.50098L11.9997 7.6834L13.1082 6.50098L13.3098 8.1086L14.9013 7.8042L14.1209 9.22357L15.5864 9.91287Z", fill: "#FFDA44" })), /* @__PURE__ */ o.createElement("defs", null, /* @__PURE__ */ o.createElement("clipPath", { id: "clip0_885_54080" }, /* @__PURE__ */ o.createElement("rect", { width: 24, height: 24, fill: "white" })))), v7 = V(g7), w7 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 29, height: 28, viewBox: "0 0 29 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", { clipPath: "url(#clip0_3275_270594)" }, /* @__PURE__ */ o.createElement("path", { d: "M14.3145 28C22.0464 28 28.3145 21.732 28.3145 14C28.3145 6.26801 22.0464 0 14.3145 0C6.58247 0 0.314453 6.26801 0.314453 14C0.314453 21.732 6.58247 28 14.3145 28Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M5.65259 5.26562L2.35288 10.0384L5.65259 5.26562ZM3.59027 10.8339L6.88998 6.06109L3.59027 10.8339ZM8.12737 6.85656L4.82766 11.6294L8.12737 6.85656ZM20.5013 21.7053L22.0137 19.5177L20.5013 21.7053ZM22.2886 19.12L23.801 16.9325L22.2886 19.12ZM25.0384 17.7279L23.526 19.9155L25.0384 17.7279ZM23.2511 20.3132L21.7387 22.5007L23.2511 20.3132ZM22.9761 23.2962L24.4884 21.1087L22.9761 23.2962ZM24.7634 20.7109L26.2758 18.5234L24.7634 20.7109Z", fill: "black" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.94052 9.7728L5.24023 5L6.06516 5.53031L2.76545 10.3031L1.94052 9.7728ZM7.30255 6.32578L4.00284 11.0986L3.17791 10.5683L6.47763 5.79547L7.30255 6.32578ZM4.41531 11.3637L7.71502 6.59093L8.53995 7.12124L5.24023 11.894L4.41531 11.3637ZM24.2136 17.1971L22.7012 19.3847L21.8763 18.8544L23.3886 16.6668L24.2136 17.1971ZM23.1137 19.6498L24.626 17.4623L25.451 17.9926L23.9386 20.1801L23.1137 19.6498ZM26.6884 18.7881L25.176 20.9756L24.3511 20.4453L25.8634 18.2578L26.6884 18.7881ZM22.4262 19.7824L20.9139 21.9699L20.0889 21.4396L21.6013 19.2521L22.4262 19.7824ZM21.3263 22.2351L22.8387 20.0476L23.6636 20.5779L22.1513 22.7654L21.3263 22.2351ZM24.901 21.3733L23.3886 23.5609L22.5637 23.0306L24.0761 20.843L24.901 21.3733Z", fill: "black" }), /* @__PURE__ */ o.createElement("path", { d: "M2.35278 18.5234L5.6525 23.2962L2.35278 18.5234ZM6.88989 22.5008L5.37752 20.3132L6.88989 22.5008ZM5.10254 19.9155L3.59018 17.728L5.10254 19.9155ZM4.82757 16.9325L8.12728 21.7053L4.82757 16.9325ZM23.8009 11.6294L22.2885 9.44186L23.8009 11.6294ZM22.0136 9.04413L20.5012 6.8566L22.0136 9.04413ZM21.7386 6.06113L25.0383 10.8339L21.7386 6.06113ZM26.2757 10.0385L24.7633 7.85093L26.2757 10.0385ZM24.4884 7.4532L22.976 5.26567L24.4884 7.4532Z", fill: "black" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.24026 23.5599L1.94055 18.7871L2.76548 18.2568L6.06519 23.0296L5.24026 23.5599ZM4.00287 17.4613L5.51524 19.6489L4.69031 20.1792L3.17794 17.9916L4.00287 17.4613ZM7.71505 21.969L4.41534 17.1962L5.24026 16.6659L8.53998 21.4387L7.71505 21.969ZM20.9139 6.58996L22.4263 8.77749L21.6013 9.3078L20.089 7.12027L20.9139 6.58996ZM24.6261 11.0976L21.3264 6.3248L22.1513 5.79449L25.451 10.5673L24.6261 11.0976ZM23.3887 4.99903L24.901 7.18656L24.0761 7.71687L22.5638 5.52934L23.3887 4.99903ZM5.79022 20.0466L7.30258 22.2341L6.47766 22.7644L4.96529 20.5769L5.79022 20.0466ZM22.7012 9.17522L24.2136 11.3628L23.3887 11.8931L21.8763 9.70554L22.7012 9.17522ZM25.176 7.58429L26.6884 9.77183L25.8635 10.3021L24.3511 8.1146L25.176 7.58429Z", fill: "black" }), /* @__PURE__ */ o.createElement("path", { d: "M16.773 15.8608C16.1108 16.8159 15.0867 17.4825 13.9259 17.7138C12.7651 17.9452 11.5627 17.7225 10.5833 17.0946C9.60383 16.4667 8.92754 15.4851 8.70318 14.3657C8.47882 13.2464 8.72477 12.081 9.38693 11.1259C10.2698 9.85239 11.6353 8.96364 13.183 8.65514C14.7308 8.34664 16.3339 8.64366 17.6399 9.48085C18.9458 10.318 19.8475 11.6268 20.1467 13.1193C20.4458 14.6118 20.1179 16.1656 19.235 17.4391", fill: "#CD2E3A" }), /* @__PURE__ */ o.createElement("path", { d: "M14.3222 14.2714C14.7639 13.6343 15.447 13.1897 16.2212 13.0353C16.9955 12.881 17.7974 13.0296 18.4507 13.4484C19.104 13.8672 19.5551 14.522 19.7047 15.2686C19.8544 16.0152 19.6903 16.7926 19.2487 17.4297C18.3654 18.7038 16.9992 19.593 15.4507 19.9017C13.9022 20.2104 12.2983 19.9132 10.9917 19.0756C9.68512 18.2379 8.78295 16.9284 8.48366 15.4352C8.18436 13.9419 8.51246 12.3872 9.39577 11.113C8.95412 11.7501 8.79007 12.5275 8.93971 13.2741C9.08936 14.0207 9.54045 14.6755 10.1937 15.0943C10.847 15.5131 11.649 15.6617 12.4232 15.5074C13.1975 15.353 13.8806 14.9084 14.3222 14.2714Z", fill: "#0047A0" })), /* @__PURE__ */ o.createElement("defs", null, /* @__PURE__ */ o.createElement("clipPath", { id: "clip0_3275_270594" }, /* @__PURE__ */ o.createElement("rect", { x: 0.314453, width: 28, height: 28, rx: 14, fill: "white" })))), y7 = V(w7), b7 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 29, height: 28, viewBox: "0 0 29 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", { clipPath: "url(#clip0_265_1407)" }, /* @__PURE__ */ o.createElement("path", { d: "M0.314453 13.999C0.314453 15.7115 0.622508 17.3519 1.18524 18.8686L14.3145 20.086L27.4437 18.8686C28.0064 17.3519 28.3145 15.7115 28.3145 13.999C28.3145 12.2866 28.0064 10.6462 27.4437 9.12951L14.3145 7.91211L1.18524 9.12951C0.622508 10.6462 0.314453 12.2866 0.314453 13.999H0.314453Z", fill: "#FFDA44" }), /* @__PURE__ */ o.createElement("path", { d: "M14.3145 28C22.0464 28 28.3145 21.732 28.3145 14C28.3145 6.26801 22.0464 0 14.3145 0C6.58247 0 0.314453 6.26801 0.314453 14C0.314453 21.732 6.58247 28 14.3145 28Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M28.3145 14C28.3145 21.7319 22.0464 28 14.3145 28C6.58252 28 0.314453 21.7319 0.314453 14", fill: "#D80027" }), /* @__PURE__ */ o.createElement("path", { d: "M13 0H35V28H13V0Z", fill: "#FF0000" }), /* @__PURE__ */ o.createElement("path", { d: "M-2 0H13V28H-2V0Z", fill: "#006600" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.8041 17.8617C15.9199 17.8033 7.30406 12.425 7.24573 11.5617L7.71823 10.7742C8.57573 12.0167 17.3841 17.2492 18.2532 17.0625L17.8041 17.8617Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.61919 10.6632C7.45003 11.1182 9.87086 12.6115 12.7759 14.3848C15.6867 16.1523 18.195 17.2432 18.3759 17.0915L18.4634 16.9282C18.4284 16.9865 18.3467 17.004 18.2125 16.9632C17.425 16.7357 15.3775 15.7965 12.84 14.2565C10.2967 12.7165 8.09169 11.299 7.74753 10.6982C7.7207 10.6418 7.70865 10.5796 7.71253 10.5173H7.70086L7.63086 10.6457L7.61919 10.6632ZM17.845 17.8848C17.8159 17.9432 17.7517 17.9432 17.6409 17.9315C16.9409 17.8557 14.8059 16.8173 12.28 15.3065C9.34003 13.5448 6.91336 11.9465 7.18169 11.5265L7.25169 11.3982L7.26336 11.404C7.03003 12.1157 12.0525 14.9857 12.35 15.1723C15.255 16.969 17.705 18.0248 17.9209 17.7507L17.845 17.8848Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.945 12.0865C14.8234 12.069 17.145 11.8298 18.4867 11.2932L18.195 10.8265C17.4075 11.264 15.0742 11.5557 12.9275 11.5965C10.3959 11.5732 8.60502 11.334 7.70669 10.7332L7.43835 11.2348C9.08335 11.9348 10.775 12.0807 12.945 12.0865Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.5626 11.3048C18.5159 11.3807 17.6409 11.6782 16.3576 11.8998C15.2263 12.0713 14.0834 12.1551 12.9392 12.1507C11.843 12.1548 10.7477 12.0846 9.66089 11.9407C8.31339 11.7307 7.61922 11.439 7.35672 11.334L7.42089 11.2057C8.16172 11.4973 8.86172 11.6723 9.67839 11.8007C10.7572 11.9463 11.8447 12.0184 12.9334 12.0165C14.0717 12.0177 15.2084 11.9338 16.3342 11.7657C17.6467 11.5498 18.3642 11.2757 18.4692 11.1532L18.5626 11.3107V11.3048ZM18.3059 10.8323C18.1659 10.949 17.4542 11.1998 16.2059 11.3982C15.1279 11.5541 14.0401 11.6321 12.9509 11.6315C11.6676 11.6315 10.6117 11.5382 9.81255 11.4215C8.54089 11.2582 7.86422 10.9548 7.61922 10.8732L7.69505 10.7448C7.88755 10.844 8.53505 11.1065 9.82422 11.2873C10.8606 11.4261 11.9053 11.4924 12.9509 11.4857C14.0323 11.486 15.1124 11.408 16.1826 11.2523C17.4367 11.0773 18.1134 10.7623 18.2184 10.6807L18.3059 10.8323ZM6.76755 14.3498C7.92255 14.974 10.4951 15.2832 12.9276 15.3065C15.1442 15.3123 18.0259 14.9682 19.1051 14.3965L19.0759 13.7723C18.7376 14.2973 15.6459 14.8048 12.9042 14.7873C10.1626 14.764 7.61339 14.344 6.76172 13.7957V14.3498", fill: "#FFFF00" }), /* @__PURE__ */ o.createElement("path", { d: "M6.76755 14.3498C7.92255 14.974 10.4951 15.2832 12.9276 15.3065C15.1442 15.3123 18.0259 14.9682 19.1051 14.3965L19.0759 13.7723C18.7376 14.2973 15.6459 14.8048 12.9042 14.7873C10.1626 14.764 7.61339 14.344 6.76172 13.7957V14.3498M18.5626 11.3048C18.5159 11.3807 17.6409 11.6782 16.3576 11.8998C15.2263 12.0713 14.0834 12.1551 12.9392 12.1507C11.843 12.1548 10.7477 12.0846 9.66089 11.9407C8.31339 11.7307 7.61922 11.439 7.35672 11.334L7.42089 11.2057C8.16172 11.4973 8.86172 11.6723 9.67839 11.8007C10.7572 11.9463 11.8447 12.0184 12.9334 12.0165C14.0717 12.0177 15.2084 11.9338 16.3342 11.7657C17.6467 11.5498 18.3642 11.2757 18.4692 11.1532L18.5626 11.3107V11.3048ZM18.3059 10.8323C18.1659 10.949 17.4542 11.1998 16.2059 11.3982C15.1279 11.5541 14.0401 11.6321 12.9509 11.6315C11.6676 11.6315 10.6117 11.5382 9.81255 11.4215C8.54089 11.2582 7.86422 10.9548 7.61922 10.8732L7.69505 10.7448C7.88755 10.844 8.53505 11.1065 9.82422 11.2873C10.8606 11.4261 11.9053 11.4924 12.9509 11.4857C14.0323 11.486 15.1124 11.408 16.1826 11.2523C17.4367 11.0773 18.1134 10.7623 18.2184 10.6807L18.3059 10.8323Z", stroke: "black", strokeWidth: 0.1, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.1633 14.2624V14.4083C19 14.6066 17.985 14.8983 16.7133 15.1083C15.4499 15.2899 14.1746 15.3757 12.8983 15.3649C11.6881 15.3753 10.4789 15.2914 9.28165 15.1141C8.38831 15.0109 7.51537 14.7749 6.69165 14.4141V14.2449C7.25748 14.6183 8.78582 14.8983 9.29915 14.9799C10.2208 15.1199 11.405 15.2249 12.8983 15.2249C14.4675 15.2249 15.7217 15.1141 16.69 14.9683C17.6058 14.8341 18.9066 14.4899 19.1633 14.2624ZM19.1633 13.7374V13.8833C19 14.0758 17.985 14.3674 16.7133 14.5774C15.4501 14.761 14.1748 14.8487 12.8983 14.8399C11.6882 14.8471 10.4792 14.7632 9.28165 14.5891C8.38831 14.4859 7.51537 14.2499 6.69165 13.8891V13.7141C7.25748 14.0933 8.79165 14.3674 9.29915 14.4491C10.4908 14.6237 11.694 14.7075 12.8983 14.6999C14.4675 14.6999 15.7275 14.5833 16.69 14.4374C17.6058 14.3091 18.9066 13.9649 19.1633 13.7374ZM12.9217 17.7508C10.2617 17.7391 7.98082 17.0274 7.49665 16.9108L7.84665 17.4591C9.48285 18.0386 11.2094 18.3211 12.945 18.2933C14.9692 18.2349 16.7367 18.0774 17.9792 17.4708L18.3408 16.8991C17.495 17.3016 14.6075 17.7508 12.9158 17.7508", fill: "#FFFF00" }), /* @__PURE__ */ o.createElement("path", { d: "M12.9217 17.7508C10.2617 17.7391 7.98082 17.0274 7.49665 16.9108L7.84665 17.4591C9.48285 18.0386 11.2094 18.3211 12.945 18.2933C14.9692 18.2349 16.7367 18.0774 17.9792 17.4708L18.3408 16.8991C17.495 17.3016 14.6075 17.7508 12.9158 17.7508M19.1633 14.2624V14.4083C19 14.6066 17.985 14.8983 16.7133 15.1083C15.4499 15.2899 14.1746 15.3757 12.8983 15.3649C11.6881 15.3753 10.4789 15.2914 9.28165 15.1141C8.38831 15.0109 7.51537 14.7749 6.69165 14.4141V14.2449C7.25748 14.6183 8.78582 14.8983 9.29915 14.9799C10.2208 15.1199 11.405 15.2249 12.8983 15.2249C14.4675 15.2249 15.7217 15.1141 16.69 14.9683C17.6058 14.8341 18.9066 14.4899 19.1633 14.2624ZM19.1633 13.7374V13.8833C19 14.0758 17.985 14.3674 16.7133 14.5774C15.4501 14.761 14.1748 14.8487 12.8983 14.8399C11.6882 14.8471 10.4792 14.7632 9.28165 14.5891C8.38831 14.4859 7.51537 14.2499 6.69165 13.8891V13.7141C7.25748 14.0933 8.79165 14.3674 9.29915 14.4491C10.4908 14.6237 11.694 14.7075 12.8983 14.6999C14.4675 14.6999 15.7275 14.5833 16.69 14.4374C17.6058 14.3091 18.9066 13.9649 19.1633 13.7374Z", stroke: "black", strokeWidth: 0.1, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.1191 17.3424C18.066 17.4211 18.0115 17.4989 17.9558 17.5757C17.3724 17.7857 16.4391 18.0074 16.0541 18.0657C15.021 18.2582 13.9725 18.3559 12.9216 18.3574C10.5649 18.3224 8.6341 17.8616 7.72994 17.4649L7.6541 17.3424L7.66577 17.3191L7.78827 17.3716C9.44845 17.921 11.1846 18.2064 12.9333 18.2174C14.0299 18.2174 15.1208 18.0949 16.0016 17.9374C17.3549 17.6632 17.9033 17.4591 18.0724 17.3657L18.1133 17.3424H18.1191ZM18.4283 16.8291C18.3899 16.8974 18.351 16.9655 18.3116 17.0332C17.9966 17.1499 17.1449 17.3949 15.9024 17.5699C15.0858 17.6807 14.5783 17.7916 12.9508 17.8207C11.0903 17.8021 9.24126 17.5273 7.45577 17.0041L7.3916 16.8582C9.20568 17.3596 11.075 17.6339 12.9566 17.6749C14.4441 17.6457 15.0799 17.5349 15.8908 17.4241C17.3374 17.2024 18.0666 16.9574 18.2824 16.8932C18.2826 16.8894 18.2826 16.8855 18.2824 16.8816L18.4341 16.8232L18.4283 16.8291Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.4634 13.86C18.4692 15.61 17.5709 17.185 16.8534 17.8733C15.7937 18.9069 14.3785 19.4955 12.8984 19.5183C11.1309 19.5475 9.46839 18.3983 9.01923 17.8908C8.01439 16.8252 7.4425 15.4236 7.41506 13.9592C7.52006 12.0458 8.27256 10.7158 9.35756 9.8C10.4116 8.93233 11.7374 8.46353 13.1026 8.47583C13.8995 8.51447 14.6795 8.71915 15.3927 9.07676C16.1059 9.43436 16.7366 9.93701 17.2442 10.5525C17.9734 11.4392 18.2942 12.4017 18.4634 13.86ZM12.9101 7.875C14.5419 7.87495 16.1077 8.52 17.2659 9.66953C18.4242 10.8191 19.0811 12.3798 19.0934 14.0117C19.0934 14.8214 18.9339 15.6232 18.624 16.3712C18.3142 17.1193 17.86 17.799 17.2875 18.3716C16.7149 18.9441 16.0352 19.3983 15.2871 19.7082C14.5391 20.018 13.7373 20.1775 12.9276 20.1775C12.1179 20.1775 11.3161 20.018 10.568 19.7082C9.81993 19.3983 9.14021 18.9441 8.56766 18.3716C7.99511 17.799 7.54094 17.1193 7.23107 16.3712C6.92121 15.6232 6.76173 14.8214 6.76173 14.0117C6.75589 10.6283 9.5209 7.875 12.9101 7.875Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.9275 7.8457C16.3225 7.8457 19.0875 10.6107 19.0875 14.0057C19.0875 17.4007 16.3225 20.1657 12.9333 20.1657C9.54415 20.1657 6.77332 17.4007 6.77332 14.0057C6.77332 10.6107 9.53832 7.8457 12.9333 7.8457H12.9275ZM6.90165 13.9999C6.90165 17.3132 9.62582 20.0257 12.9275 20.0257C16.2291 20.0257 18.9533 17.3132 18.9533 13.9999C18.9533 10.6865 16.2291 7.97404 12.9275 7.97404C9.62582 7.97404 6.90165 10.6865 6.90165 13.9999Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.9333 8.35913C14.4279 8.36375 15.86 8.95953 16.9169 10.0164C17.9737 11.0733 18.5695 12.5053 18.5741 14C18.5695 15.4951 17.9739 16.9278 16.9172 17.9856C15.8605 19.0434 14.4285 19.6405 12.9333 19.6466C9.84165 19.6466 7.29248 17.1033 7.29248 14C7.29862 12.5058 7.8949 11.0746 8.95143 10.0181C10.008 8.96155 11.4392 8.36527 12.9333 8.35913ZM7.42665 14C7.42665 17.0333 9.91165 19.5066 12.9333 19.5066C15.955 19.5066 18.44 17.0275 18.44 14C18.44 10.9666 15.955 8.4933 12.9333 8.4933C11.4747 8.49944 10.0777 9.08158 9.0463 10.1129C8.01493 11.1443 7.43279 12.5414 7.42665 14Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.1842 7.81665H12.6533V20.2008H13.1783L13.1842 7.81665Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.1258 7.74658H13.26V20.2707H13.1317V7.74658H13.1258ZM12.6008 7.74658H12.7408V20.2707H12.6067V7.74658H12.6008Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.0933 14.245V13.79L18.72 13.44L16.6025 12.88L13.5575 12.5708L9.88247 12.7575L7.26914 13.3758L6.74414 13.7666V14.2275L8.07997 13.6266L11.2533 13.1308H14.3041L16.5441 13.3758L18.0958 13.7491L19.0933 14.245Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.9333 13.055C14.3858 13.055 15.7916 13.1892 16.9175 13.405C18.0725 13.6383 18.8833 13.93 19.1633 14.2508V14.4142C18.825 14.0058 17.7341 13.7142 16.8883 13.5392C15.78 13.3292 14.38 13.1892 12.9275 13.1892C11.405 13.1892 9.98165 13.3408 8.88498 13.5508C8.00998 13.7258 6.83748 14.0758 6.69165 14.4142V14.245C6.76748 14.0117 7.64248 13.6617 8.86748 13.4108C9.96998 13.195 11.3933 13.055 12.9275 13.055H12.9333ZM12.9333 12.5242C14.2692 12.5215 15.6026 12.6386 16.9175 12.8742C18.0725 13.1075 18.8833 13.3992 19.1633 13.7258V13.8833C18.825 13.4808 17.7341 13.1833 16.8883 13.0142C15.78 12.7983 14.38 12.6642 12.9275 12.6642C11.5736 12.6599 10.2223 12.7809 8.89082 13.0258C8.04498 13.1833 6.82582 13.545 6.69165 13.8833V13.72C6.77332 13.4867 7.65998 13.1192 8.86748 12.8858C9.97582 12.67 11.3933 12.5242 12.9333 12.5242ZM12.8983 9.82916C15.1908 9.81749 17.1917 10.15 18.1075 10.6167L18.44 11.2C17.6467 10.7683 15.4883 10.325 12.9042 10.3833C10.7983 10.4008 8.54665 10.6167 7.42082 11.2233L7.81748 10.5583C8.74498 10.0742 10.9267 9.82916 12.8983 9.82916Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.9333 10.3075C14.1303 10.2873 15.3268 10.3712 16.5092 10.5583C17.4425 10.7333 18.335 10.99 18.4633 11.13L18.5625 11.305C18.2533 11.1066 17.4775 10.8791 16.4858 10.6925C15.4942 10.5058 14.2283 10.4416 12.9275 10.4475C11.4517 10.4416 10.3025 10.5175 9.32251 10.6925C8.64694 10.7871 7.99104 10.99 7.38 11.2933L7.47917 11.1125C7.82917 10.9375 8.37167 10.7216 9.29334 10.5525C10.3142 10.3658 11.475 10.3133 12.9333 10.3075ZM12.9333 9.78246C14.1817 9.77079 15.4183 9.84079 16.3808 10.0158C17.0044 10.1084 17.6079 10.3056 18.1658 10.5991L18.3117 10.8325C18.0667 10.5583 17.145 10.2958 16.3225 10.1558C15.3658 9.98663 14.1817 9.92246 12.9333 9.91079C11.7713 9.90043 10.6104 9.98628 9.4625 10.1675C8.8623 10.2511 8.27936 10.4303 7.73584 10.6983L7.86417 10.5058C8.20251 10.3308 8.75084 10.1675 9.43917 10.0333C10.5946 9.84974 11.7635 9.76388 12.9333 9.77663V9.78246ZM15.99 16.5666C14.9789 16.3916 13.9534 16.3134 12.9275 16.3333C9.10667 16.38 7.87584 17.1208 7.72417 17.3425L7.4325 16.8758C8.4125 16.1758 10.4892 15.7791 12.9508 15.8141C14.2283 15.8375 15.3308 15.925 16.2525 16.1058L15.99 16.5725", fill: "#FFFF00" }), /* @__PURE__ */ o.createElement("path", { d: "M15.99 16.5666C14.9789 16.3916 13.9534 16.3134 12.9275 16.3333C9.10667 16.38 7.87584 17.1208 7.72417 17.3425L7.4325 16.8758C8.4125 16.1758 10.4892 15.7791 12.9508 15.8141C14.2283 15.8375 15.3308 15.925 16.2525 16.1058L15.99 16.5725M12.9333 10.3075C14.1303 10.2873 15.3268 10.3712 16.5092 10.5583C17.4425 10.7333 18.335 10.99 18.4633 11.13L18.5625 11.305C18.2533 11.1066 17.4775 10.8791 16.4858 10.6925C15.4942 10.5058 14.2283 10.4416 12.9275 10.4475C11.4517 10.4416 10.3025 10.5175 9.32251 10.6925C8.64694 10.7871 7.99104 10.99 7.38 11.2933L7.47917 11.1125C7.82917 10.9375 8.37167 10.7216 9.29334 10.5525C10.3142 10.3658 11.475 10.3133 12.9333 10.3075ZM12.9333 9.78246C14.1817 9.77079 15.4183 9.84079 16.3808 10.0158C17.0044 10.1084 17.6079 10.3056 18.1658 10.5991L18.3117 10.8325C18.0667 10.5583 17.145 10.2958 16.3225 10.1558C15.3658 9.98663 14.1817 9.92246 12.9333 9.91079C11.7713 9.90043 10.6104 9.98628 9.4625 10.1675C8.8623 10.2511 8.27936 10.4303 7.73584 10.6983L7.86417 10.5058C8.20251 10.3308 8.75084 10.1675 9.43917 10.0333C10.5946 9.84974 11.7635 9.76388 12.9333 9.77663V9.78246Z", stroke: "black", strokeWidth: 0.1, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.91 16.2691C13.9717 16.2866 15.01 16.3274 16.0192 16.5141L15.9492 16.6424C15.0159 16.4674 14.0125 16.4091 12.9159 16.4091C11.4984 16.3974 10.075 16.5316 8.83253 16.8874C8.4417 16.9983 7.7942 17.2491 7.7242 17.4591L7.6542 17.3424C7.67753 17.2141 8.06253 16.9574 8.79753 16.7591C10.2209 16.3508 11.5509 16.2749 12.91 16.2691ZM12.9567 15.7324C14.0773 15.7313 15.1958 15.8289 16.2992 16.0241L16.2234 16.1583C15.1459 15.9606 14.0521 15.8649 12.9567 15.8724C11.545 15.8724 10.0459 15.9774 8.68086 16.3741C8.24336 16.5024 7.4792 16.7824 7.45586 16.9983L7.38586 16.8699C7.39753 16.6716 8.0567 16.4091 8.6517 16.2399C10.0225 15.8374 11.5275 15.7383 12.9567 15.7324Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.3815 16.9457L17.9265 17.6632L16.6024 16.4907L13.184 14.1865L9.32237 12.069L7.32153 11.3865L7.74737 10.5932L7.8932 10.5173L9.1357 10.8265L13.2424 12.944L15.6107 14.4373L17.5999 15.8665L18.4107 16.7998L18.3815 16.9457Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.25161 11.404C7.60161 11.1707 10.1799 12.314 12.8866 13.9474C15.5758 15.5807 18.1541 17.424 17.9208 17.7682L17.8449 17.8907L17.8099 17.9199C17.8158 17.914 17.8566 17.8615 17.8099 17.739C17.6933 17.3599 15.8616 15.9015 12.8341 14.0699C9.87661 12.314 7.41495 11.2524 7.17578 11.5557L7.25161 11.404ZM18.4749 16.9399C18.6966 16.4965 16.3049 14.694 13.3358 12.9382C10.3024 11.2174 8.10911 10.2024 7.70661 10.5057L7.62495 10.6749C7.62495 10.6807 7.62495 10.6632 7.64828 10.6457C7.71828 10.5874 7.84078 10.5874 7.89328 10.5874C8.58161 10.599 10.5474 11.5032 13.3066 13.084C14.5199 13.784 18.4166 16.2924 18.3991 16.9924C18.3991 17.0507 18.4049 17.0624 18.3816 17.0974L18.4808 16.9457L18.4749 16.9399Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { d: "M9.2373 14.6864C9.23823 15.1694 9.33494 15.6475 9.52185 16.0928C9.70876 16.5382 9.98215 16.9421 10.3262 17.2811C10.6661 17.6262 11.0708 17.9006 11.5172 18.0886C11.9636 18.2765 12.4428 18.3743 12.9271 18.3762C13.9073 18.3762 14.8474 17.9867 15.5404 17.2936C15.8833 16.9527 16.1554 16.5474 16.3412 16.1011C16.527 15.6548 16.6228 15.1761 16.6231 14.6927V9.76464L9.2373 9.7522V14.6864Z", fill: "white", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M9.37427 14.6927C9.37558 15.1561 9.46863 15.6145 9.64804 16.0417C9.82746 16.4689 10.0897 16.8563 10.4196 17.1816C11.0821 17.8476 11.9816 18.2235 12.9209 18.227C13.8586 18.2275 14.7582 17.856 15.4223 17.1941C15.7511 16.8683 16.0122 16.4806 16.1905 16.0534C16.3688 15.6263 16.4609 15.1681 16.4614 14.7052V9.91406H9.38671V14.6927M15.049 11.3514V14.3941L15.0427 14.7114C15.0448 14.9894 14.9908 15.2649 14.8839 15.5215C14.777 15.7781 14.6194 16.0105 14.4205 16.2047C14.0248 16.6018 13.4877 16.8256 12.9272 16.827C12.3423 16.827 11.8258 16.5781 11.4401 16.1923C11.043 15.7966 10.8192 15.2595 10.8178 14.699V11.339L15.049 11.3514Z", fill: "#FF0000" }), /* @__PURE__ */ o.createElement("path", { d: "M9.37427 14.6927C9.37558 15.1561 9.46863 15.6145 9.64804 16.0417C9.82746 16.4689 10.0897 16.8563 10.4196 17.1816C11.0821 17.8476 11.9816 18.2235 12.9209 18.227C13.8586 18.2275 14.7582 17.856 15.4223 17.1941C15.7511 16.8683 16.0122 16.4806 16.1905 16.0534C16.3688 15.6263 16.4609 15.1681 16.4614 14.7052V9.91406H9.38671V14.6927M15.049 11.3514V14.3941L15.0427 14.7114C15.0448 14.9894 14.9908 15.2649 14.8839 15.5215C14.777 15.7781 14.6194 16.0105 14.4205 16.2047C14.0248 16.6018 13.4877 16.8256 12.9272 16.827C12.3423 16.827 11.8258 16.5781 11.4401 16.1923C11.043 15.7966 10.8192 15.2595 10.8178 14.699V11.339L15.049 11.3514Z", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M9.83459 11.1646C9.84082 10.8223 10.0835 10.7415 10.0835 10.7415C10.0897 10.7415 10.351 10.8286 10.351 11.1708H9.83459", fill: "#FFFF00" }), /* @__PURE__ */ o.createElement("path", { d: "M9.62312 10.7477L9.57956 11.1397H9.84089C9.84089 10.8161 10.0898 10.7663 10.0898 10.7663C10.096 10.7663 10.3387 10.8348 10.3449 11.1397H10.6062L10.5565 10.7415H9.62312V10.7477ZM9.56089 11.1459H10.6187C10.6373 11.1459 10.656 11.1646 10.656 11.1895C10.656 11.2206 10.6373 11.2392 10.6187 11.2392H9.56089C9.54223 11.2392 9.52356 11.2206 9.52356 11.1895C9.52356 11.1646 9.54223 11.1459 9.56712 11.1459H9.56089Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M9.94656 11.1398C9.94656 10.9344 10.0897 10.8784 10.0897 10.8784C10.0897 10.8784 10.2328 10.9407 10.2328 11.1398H9.94656ZM9.58567 10.5798H10.5999C10.6186 10.5798 10.6372 10.6047 10.6372 10.6295C10.6372 10.6482 10.6186 10.6669 10.5999 10.6669H9.58567C9.56701 10.6669 9.54834 10.6482 9.54834 10.6233C9.54834 10.6047 9.56701 10.586 9.58567 10.586V10.5798ZM9.61056 10.6731H10.5688C10.5875 10.6731 10.6061 10.6918 10.6061 10.7167C10.6061 10.7415 10.5875 10.7602 10.5688 10.7602H9.60434C9.57945 10.7602 9.56701 10.7415 9.56701 10.7167C9.56701 10.6918 9.57945 10.6731 9.60434 10.6731H9.61056ZM9.92167 10.0135H9.99634V10.0633H10.0523V10.0135H10.1332V10.0695H10.1892V10.0073H10.2639V10.1318C10.2639 10.1567 10.2515 10.1691 10.2328 10.1691H9.95901C9.94034 10.1691 9.92167 10.1567 9.92167 10.138V10.0135ZM10.2079 10.1815L10.2266 10.5798H9.95901L9.97767 10.1753H10.2079", fill: "#FFFF00" }), /* @__PURE__ */ o.createElement("path", { d: "M10.2079 10.1815L10.2266 10.5798H9.95901L9.97767 10.1753H10.2079M9.94656 11.1398C9.94656 10.9344 10.0897 10.8784 10.0897 10.8784C10.0897 10.8784 10.2328 10.9407 10.2328 11.1398H9.94656ZM9.58567 10.5798H10.5999C10.6186 10.5798 10.6372 10.6047 10.6372 10.6295C10.6372 10.6482 10.6186 10.6669 10.5999 10.6669H9.58567C9.56701 10.6669 9.54834 10.6482 9.54834 10.6233C9.54834 10.6047 9.56701 10.586 9.58567 10.586V10.5798ZM9.61056 10.6731H10.5688C10.5875 10.6731 10.6061 10.6918 10.6061 10.7167C10.6061 10.7415 10.5875 10.7602 10.5688 10.7602H9.60434C9.57945 10.7602 9.56701 10.7415 9.56701 10.7167C9.56701 10.6918 9.57945 10.6731 9.60434 10.6731H9.61056ZM9.92167 10.0135H9.99634V10.0633H10.0523V10.0135H10.1332V10.0695H10.1892V10.0073H10.2639V10.1318C10.2639 10.1567 10.2515 10.1691 10.2328 10.1691H9.95901C9.94034 10.1691 9.92167 10.1567 9.92167 10.138V10.0135Z", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M9.88439 10.3682V10.5797H9.6355V10.3682H9.88439Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M10.5439 10.3682V10.5797H10.295V10.3682H10.5439Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M9.59192 10.2065H9.66659V10.2688H9.72259V10.2065H9.79725V10.2688H9.85325V10.2065H9.92792V10.331C9.92792 10.3559 9.91548 10.3683 9.89681 10.3683H9.62925C9.61935 10.3683 9.60986 10.3644 9.60285 10.3574C9.59585 10.3504 9.59192 10.3409 9.59192 10.331V10.2065Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M10.2515 10.2065H10.3261V10.2688H10.3821V10.2065H10.4568V10.2688H10.5128V10.2065H10.5875V10.331C10.5875 10.3559 10.575 10.3683 10.5564 10.3683H10.2888C10.2789 10.3683 10.2694 10.3644 10.2624 10.3574C10.2554 10.3504 10.2515 10.3409 10.2515 10.331V10.2065Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M10.0648 10.3058C10.0648 10.2685 10.1208 10.2685 10.1208 10.3058V10.4054H10.0648V10.3058Z", fill: "black" }), /* @__PURE__ */ o.createElement("path", { d: "M9.73499 10.4428C9.73499 10.4055 9.78476 10.4055 9.78476 10.4428V10.5175H9.73499V10.4428Z", fill: "black" }), /* @__PURE__ */ o.createElement("path", { d: "M10.3945 10.4428C10.3945 10.4055 10.4443 10.4055 10.4443 10.4428V10.5175H10.3945V10.4428Z", fill: "black" }), /* @__PURE__ */ o.createElement("path", { d: "M9.83459 14.0454C9.84082 13.7032 10.0835 13.6223 10.0835 13.6223C10.0897 13.6223 10.351 13.7094 10.351 14.0516H9.83459", fill: "#FFFF00" }), /* @__PURE__ */ o.createElement("path", { d: "M9.62312 13.6285L9.57956 14.0205H9.84089C9.84089 13.697 10.0898 13.6472 10.0898 13.6472C10.096 13.6472 10.3387 13.7156 10.3449 14.0205H10.6062L10.5565 13.6223H9.62312V13.6285ZM9.56089 14.0268H10.6187C10.6373 14.0268 10.656 14.0454 10.656 14.0703C10.656 14.1014 10.6373 14.1201 10.6187 14.1201H9.56089C9.54223 14.1201 9.52356 14.1014 9.52356 14.0703C9.52356 14.0454 9.54223 14.0268 9.56712 14.0268H9.56089Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M9.94656 14.0206C9.94656 13.8153 10.0897 13.7593 10.0897 13.7593C10.0897 13.7593 10.2328 13.8215 10.2328 14.0206H9.94656ZM9.58567 13.4606H10.5999C10.6186 13.4606 10.6372 13.4855 10.6372 13.5104C10.6372 13.5291 10.6186 13.5477 10.5999 13.5477H9.58567C9.56701 13.5477 9.54834 13.5291 9.54834 13.5042C9.54834 13.4855 9.56701 13.4669 9.58567 13.4669V13.4606ZM9.61056 13.554H10.5688C10.5875 13.554 10.6061 13.5726 10.6061 13.5975C10.6061 13.6224 10.5875 13.6411 10.5688 13.6411H9.60434C9.57945 13.6411 9.56701 13.6224 9.56701 13.5975C9.56701 13.5726 9.57945 13.554 9.60434 13.554H9.61056ZM9.92167 12.8944H9.99634V12.9442H10.0523V12.8944H10.1332V12.9504H10.1892V12.8882H10.2639V13.0126C10.2639 13.0375 10.2515 13.05 10.2328 13.05H9.95901C9.94034 13.05 9.92167 13.0375 9.92167 13.0189V12.8944ZM10.2079 13.0624L10.2266 13.4606H9.95901L9.97767 13.0562H10.2079", fill: "#FFFF00" }), /* @__PURE__ */ o.createElement("path", { d: "M10.2079 13.0624L10.2266 13.4606H9.95901L9.97767 13.0562H10.2079M9.94656 14.0206C9.94656 13.8153 10.0897 13.7593 10.0897 13.7593C10.0897 13.7593 10.2328 13.8215 10.2328 14.0206H9.94656ZM9.58567 13.4606H10.5999C10.6186 13.4606 10.6372 13.4855 10.6372 13.5104C10.6372 13.5291 10.6186 13.5477 10.5999 13.5477H9.58567C9.56701 13.5477 9.54834 13.5291 9.54834 13.5042C9.54834 13.4855 9.56701 13.4669 9.58567 13.4669V13.4606ZM9.61056 13.554H10.5688C10.5875 13.554 10.6061 13.5726 10.6061 13.5975C10.6061 13.6224 10.5875 13.6411 10.5688 13.6411H9.60434C9.57945 13.6411 9.56701 13.6224 9.56701 13.5975C9.56701 13.5726 9.57945 13.554 9.60434 13.554H9.61056ZM9.92167 12.8944H9.99634V12.9442H10.0523V12.8944H10.1332V12.9504H10.1892V12.8882H10.2639V13.0126C10.2639 13.0375 10.2515 13.05 10.2328 13.05H9.95901C9.94034 13.05 9.92167 13.0375 9.92167 13.0189V12.8944Z", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M9.88439 13.249V13.4606H9.6355V13.249H9.88439Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M10.5439 13.249V13.4606H10.295V13.249H10.5439Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M9.59192 13.0874H9.66659V13.1496H9.72259V13.0874H9.79725V13.1496H9.85325V13.0874H9.92792V13.2118C9.92792 13.2367 9.91548 13.2492 9.89681 13.2492H9.62925C9.61935 13.2492 9.60986 13.2452 9.60285 13.2382C9.59585 13.2312 9.59192 13.2217 9.59192 13.2118V13.0874Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M10.2515 13.0874H10.3261V13.1496H10.3821V13.0874H10.4568V13.1496H10.5128V13.0874H10.5875V13.2118C10.5875 13.2367 10.575 13.2492 10.5564 13.2492H10.2888C10.2789 13.2492 10.2694 13.2452 10.2624 13.2382C10.2554 13.2312 10.2515 13.2217 10.2515 13.2118V13.0874Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M10.0648 13.1867C10.0648 13.1494 10.1208 13.1494 10.1208 13.1867V13.2862H10.0648V13.1867Z", fill: "black" }), /* @__PURE__ */ o.createElement("path", { d: "M9.73499 13.3237C9.73499 13.2863 9.78476 13.2863 9.78476 13.3237V13.3983H9.73499V13.3237Z", fill: "black" }), /* @__PURE__ */ o.createElement("path", { d: "M10.3945 13.3237C10.3945 13.2863 10.4443 13.2863 10.4443 13.3237V13.3983H10.3945V13.3237Z", fill: "black" }), /* @__PURE__ */ o.createElement("path", { d: "M10.9575 17.0481C10.719 16.8026 10.8326 16.5734 10.8326 16.5734C10.837 16.569 11.0829 16.4449 11.3258 16.6861L10.9619 17.0525", fill: "#FFFF00" }), /* @__PURE__ */ o.createElement("path", { d: "M10.5127 16.9044L10.7601 17.2116L10.9443 17.0261C10.7147 16.7981 10.8548 16.5865 10.8548 16.5865C10.8591 16.582 11.0787 16.4581 11.2994 16.6685L11.4836 16.4831L11.1659 16.2378L10.5083 16.9001L10.5127 16.9044ZM10.7514 17.2292L11.4967 16.4786C11.5099 16.4654 11.5363 16.4653 11.554 16.4828C11.576 16.5048 11.5761 16.5311 11.563 16.5444L10.8176 17.295C10.8045 17.3082 10.7781 17.3083 10.756 17.2864C10.7383 17.2688 10.7382 17.2424 10.7558 17.2248L10.7514 17.2292Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M11.0187 16.9509C10.873 16.8063 10.9341 16.6652 10.9341 16.6652C10.9341 16.6652 11.0791 16.6075 11.2204 16.7478L11.0187 16.9509ZM10.3671 16.8124L11.0817 16.0928C11.0949 16.0795 11.1257 16.0838 11.1434 16.1013C11.1566 16.1145 11.1567 16.1409 11.1435 16.1541L10.4289 16.8738C10.4157 16.887 10.3893 16.8871 10.3717 16.8696C10.3584 16.8564 10.3583 16.8301 10.3715 16.8168L10.3671 16.8124ZM10.4508 16.8605L11.126 16.1806C11.1392 16.1674 11.1656 16.1673 11.1832 16.1848C11.2009 16.2023 11.201 16.2287 11.1878 16.242L10.5083 16.9263C10.4907 16.944 10.4687 16.9397 10.451 16.9221C10.4334 16.9046 10.4289 16.8826 10.4464 16.8649L10.4508 16.8605ZM10.202 16.175L10.2547 16.122L10.29 16.1571L10.3294 16.1174L10.2941 16.0823L10.3511 16.0249L10.3909 16.0644L10.4303 16.0246L10.3862 15.9808L10.4388 15.9278L10.5271 16.0155C10.5447 16.033 10.5448 16.0506 10.5316 16.0639L10.3387 16.2581C10.3256 16.2714 10.3036 16.2759 10.2904 16.2627L10.202 16.175ZM10.5229 16.0903L10.8187 16.3577L10.6301 16.5475L10.3563 16.2493L10.5185 16.0859", fill: "#FFFF00" }), /* @__PURE__ */ o.createElement("path", { d: "M10.5229 16.0903L10.8187 16.3577L10.6301 16.5475L10.3563 16.2493L10.5185 16.0859M11.0187 16.9509C10.873 16.8063 10.9341 16.6652 10.9341 16.6652C10.9341 16.6652 11.0791 16.6075 11.2204 16.7478L11.0187 16.9509ZM10.3671 16.8124L11.0817 16.0928C11.0949 16.0795 11.1257 16.0838 11.1434 16.1013C11.1566 16.1145 11.1567 16.1409 11.1435 16.1541L10.4289 16.8738C10.4157 16.887 10.3893 16.8871 10.3717 16.8696C10.3584 16.8564 10.3583 16.8301 10.3715 16.8168L10.3671 16.8124ZM10.4508 16.8605L11.126 16.1806C11.1392 16.1674 11.1656 16.1673 11.1832 16.1848C11.2009 16.2023 11.201 16.2287 11.1878 16.242L10.5083 16.9263C10.4907 16.944 10.4687 16.9397 10.451 16.9221C10.4334 16.9046 10.4289 16.8826 10.4464 16.8649L10.4508 16.8605ZM10.202 16.175L10.2547 16.122L10.29 16.1571L10.3294 16.1174L10.2941 16.0823L10.3511 16.0249L10.3909 16.0644L10.4303 16.0246L10.3862 15.9808L10.4388 15.9278L10.5271 16.0155C10.5447 16.033 10.5448 16.0506 10.5316 16.0639L10.3387 16.2581C10.3256 16.2714 10.3036 16.2759 10.2904 16.2627L10.202 16.175Z", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M10.4275 16.4516L10.5776 16.6006L10.4022 16.7772L10.2521 16.6282L10.4275 16.4516Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M10.8922 15.9836L11.0423 16.1326L10.8669 16.3092L10.7168 16.1602L10.8922 15.9836Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M10.1067 16.5449L10.1593 16.4919L10.2035 16.5358L10.2429 16.496L10.1988 16.4522L10.2514 16.3992L10.2955 16.4431L10.335 16.4033L10.2908 16.3595L10.3434 16.3065L10.4317 16.3942C10.4494 16.4117 10.4495 16.4293 10.4363 16.4426L10.2478 16.6324C10.2408 16.6395 10.2313 16.6434 10.2214 16.6435C10.2115 16.6435 10.202 16.6396 10.195 16.6326L10.1067 16.5449Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M10.5713 16.0771L10.6239 16.0242L10.6681 16.068L10.7075 16.0283L10.6634 15.9844L10.716 15.9314L10.7601 15.9753L10.7996 15.9356L10.7554 15.8917L10.808 15.8387L10.8963 15.9264C10.914 15.944 10.9141 15.9616 10.9009 15.9748L10.7124 16.1647C10.7054 16.1717 10.6959 16.1756 10.686 16.1757C10.6761 16.1757 10.6666 16.1718 10.6596 16.1648L10.5713 16.0771Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M10.5105 16.2797C10.484 16.2534 10.5234 16.2137 10.5499 16.24L10.6206 16.3102L10.5811 16.3499L10.5105 16.2797Z", fill: "black" }), /* @__PURE__ */ o.createElement("path", { d: "M10.3752 16.6101C10.3487 16.5838 10.3838 16.5484 10.4103 16.5747L10.4633 16.6274L10.4282 16.6627L10.3752 16.6101Z", fill: "black" }), /* @__PURE__ */ o.createElement("path", { d: "M10.8399 16.1423C10.8134 16.116 10.8485 16.0807 10.875 16.107L10.928 16.1596L10.8929 16.1949L10.8399 16.1423Z", fill: "black" }), /* @__PURE__ */ o.createElement("path", { d: "M12.6783 11.1646C12.6846 10.8223 12.9272 10.7415 12.9272 10.7415C12.9335 10.7415 13.1948 10.8286 13.1948 11.1708H12.6783", fill: "#FFFF00" }), /* @__PURE__ */ o.createElement("path", { d: "M12.4667 10.7477L12.4232 11.1397H12.6845C12.6845 10.8161 12.9334 10.7663 12.9334 10.7663C12.9396 10.7663 13.1823 10.8348 13.1885 11.1397H13.4499L13.4001 10.7415H12.4667V10.7477ZM12.4045 11.1459H13.4623C13.481 11.1459 13.4996 11.1646 13.4996 11.1895C13.4996 11.2206 13.481 11.2392 13.4623 11.2392H12.4045C12.3859 11.2392 12.3672 11.2206 12.3672 11.1895C12.3672 11.1646 12.3859 11.1459 12.4107 11.1459H12.4045Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M12.7903 11.1398C12.7903 10.9344 12.9334 10.8784 12.9334 10.8784C12.9334 10.8784 13.0765 10.9407 13.0765 11.1398H12.7903ZM12.4294 10.5798H13.4436C13.4623 10.5798 13.481 10.6047 13.481 10.6295C13.481 10.6482 13.4623 10.6669 13.4436 10.6669H12.4294C12.4108 10.6669 12.3921 10.6482 12.3921 10.6233C12.3921 10.6047 12.4108 10.586 12.4294 10.586V10.5798ZM12.4543 10.6731H13.4125C13.4312 10.6731 13.4499 10.6918 13.4499 10.7167C13.4499 10.7415 13.4312 10.7602 13.4125 10.7602H12.4481C12.4232 10.7602 12.4108 10.7415 12.4108 10.7167C12.4108 10.6918 12.4232 10.6731 12.4481 10.6731H12.4543ZM12.7654 10.0135H12.8401V10.0633H12.8961V10.0135H12.977V10.0695H13.033V10.0073H13.1076V10.1318C13.1076 10.1567 13.0952 10.1691 13.0765 10.1691H12.8028C12.7841 10.1691 12.7654 10.1567 12.7654 10.138V10.0135ZM13.0516 10.1815L13.0703 10.5798H12.8028L12.8214 10.1753H13.0516", fill: "#FFFF00" }), /* @__PURE__ */ o.createElement("path", { d: "M13.0516 10.1815L13.0703 10.5798H12.8028L12.8214 10.1753H13.0516M12.7903 11.1398C12.7903 10.9344 12.9334 10.8784 12.9334 10.8784C12.9334 10.8784 13.0765 10.9407 13.0765 11.1398H12.7903ZM12.4294 10.5798H13.4436C13.4623 10.5798 13.481 10.6047 13.481 10.6295C13.481 10.6482 13.4623 10.6669 13.4436 10.6669H12.4294C12.4108 10.6669 12.3921 10.6482 12.3921 10.6233C12.3921 10.6047 12.4108 10.586 12.4294 10.586V10.5798ZM12.4543 10.6731H13.4125C13.4312 10.6731 13.4499 10.6918 13.4499 10.7167C13.4499 10.7415 13.4312 10.7602 13.4125 10.7602H12.4481C12.4232 10.7602 12.4108 10.7415 12.4108 10.7167C12.4108 10.6918 12.4232 10.6731 12.4481 10.6731H12.4543ZM12.7654 10.0135H12.8401V10.0633H12.8961V10.0135H12.977V10.0695H13.033V10.0073H13.1076V10.1318C13.1076 10.1567 13.0952 10.1691 13.0765 10.1691H12.8028C12.7841 10.1691 12.7654 10.1567 12.7654 10.138V10.0135Z", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M12.728 10.3682V10.5797H12.4791V10.3682H12.728Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M13.3876 10.3682V10.5797H13.1387V10.3682H13.3876Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M12.4357 10.2065H12.5103V10.2688H12.5663V10.2065H12.641V10.2688H12.697V10.2065H12.7717V10.331C12.7717 10.3559 12.7592 10.3683 12.7406 10.3683H12.473C12.4631 10.3683 12.4536 10.3644 12.4466 10.3574C12.4396 10.3504 12.4357 10.3409 12.4357 10.331V10.2065Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M13.0952 10.2065H13.1699V10.2688H13.2259V10.2065H13.3005V10.2688H13.3565V10.2065H13.4312V10.331C13.4312 10.3559 13.4188 10.3683 13.4001 10.3683H13.1325C13.1226 10.3683 13.1132 10.3644 13.1061 10.3574C13.0991 10.3504 13.0952 10.3409 13.0952 10.331V10.2065Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M12.9084 10.3058C12.9084 10.2685 12.9644 10.2685 12.9644 10.3058V10.4054H12.9084V10.3058Z", fill: "black" }), /* @__PURE__ */ o.createElement("path", { d: "M12.5786 10.4428C12.5786 10.4055 12.6284 10.4055 12.6284 10.4428V10.5175H12.5786V10.4428Z", fill: "black" }), /* @__PURE__ */ o.createElement("path", { d: "M13.2383 10.4428C13.2383 10.4055 13.2881 10.4055 13.2881 10.4428V10.5175H13.2383V10.4428Z", fill: "black" }), /* @__PURE__ */ o.createElement("path", { d: "M16.0194 11.1646C16.0132 10.8223 15.7705 10.7415 15.7705 10.7415C15.7643 10.7415 15.503 10.8286 15.503 11.1708H16.0194", fill: "#FFFF00" }), /* @__PURE__ */ o.createElement("path", { d: "M16.231 10.7477L16.2746 11.1397H16.0132C16.0132 10.8161 15.7643 10.7663 15.7643 10.7663C15.7581 10.7663 15.5155 10.8348 15.5092 11.1397H15.2479L15.2977 10.7415H16.231V10.7477ZM16.2932 11.1459H15.2355C15.2168 11.1459 15.1981 11.1646 15.1981 11.1895C15.1981 11.2206 15.2168 11.2392 15.2355 11.2392H16.2932C16.3119 11.2392 16.3306 11.2206 16.3306 11.1895C16.3306 11.1646 16.3119 11.1459 16.287 11.1459H16.2932Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M15.9073 11.1398C15.9073 10.9344 15.7642 10.8784 15.7642 10.8784C15.7642 10.8784 15.6211 10.9407 15.6211 11.1398H15.9073ZM16.2682 10.5798H15.254C15.2353 10.5798 15.2166 10.6047 15.2166 10.6295C15.2166 10.6482 15.2353 10.6669 15.254 10.6669H16.2682C16.2869 10.6669 16.3055 10.6482 16.3055 10.6233C16.3055 10.6047 16.2869 10.586 16.2682 10.586V10.5798ZM16.2433 10.6731H15.2851C15.2664 10.6731 15.2478 10.6918 15.2478 10.7167C15.2478 10.7415 15.2664 10.7602 15.2851 10.7602H16.2495C16.2744 10.7602 16.2869 10.7415 16.2869 10.7167C16.2869 10.6918 16.2744 10.6731 16.2495 10.6731H16.2433ZM15.9322 10.0135H15.8575V10.0633H15.8015V10.0135H15.7207V10.0695H15.6647V10.0073H15.59V10.1318C15.59 10.1567 15.6024 10.1691 15.6211 10.1691H15.8949C15.9135 10.1691 15.9322 10.1567 15.9322 10.138V10.0135ZM15.646 10.1815L15.6273 10.5798H15.8949L15.8762 10.1753H15.646", fill: "#FFFF00" }), /* @__PURE__ */ o.createElement("path", { d: "M15.646 10.1815L15.6273 10.5798H15.8949L15.8762 10.1753H15.646M15.9073 11.1398C15.9073 10.9344 15.7642 10.8784 15.7642 10.8784C15.7642 10.8784 15.6211 10.9407 15.6211 11.1398H15.9073ZM16.2682 10.5798H15.254C15.2353 10.5798 15.2166 10.6047 15.2166 10.6295C15.2166 10.6482 15.2353 10.6669 15.254 10.6669H16.2682C16.2869 10.6669 16.3055 10.6482 16.3055 10.6233C16.3055 10.6047 16.2869 10.586 16.2682 10.586V10.5798ZM16.2433 10.6731H15.2851C15.2664 10.6731 15.2478 10.6918 15.2478 10.7167C15.2478 10.7415 15.2664 10.7602 15.2851 10.7602H16.2495C16.2744 10.7602 16.2869 10.7415 16.2869 10.7167C16.2869 10.6918 16.2744 10.6731 16.2495 10.6731H16.2433ZM15.9322 10.0135H15.8575V10.0633H15.8015V10.0135H15.7207V10.0695H15.6647V10.0073H15.59V10.1318C15.59 10.1567 15.6024 10.1691 15.6211 10.1691H15.8949C15.9135 10.1691 15.9322 10.1567 15.9322 10.138V10.0135Z", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M15.9696 10.3682V10.5797H16.2185V10.3682H15.9696Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M15.3101 10.3682V10.5797H15.559V10.3682H15.3101Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M16.2621 10.2065H16.1874V10.2688H16.1314V10.2065H16.0568V10.2688H16.0008V10.2065H15.9261V10.331C15.9261 10.3559 15.9385 10.3683 15.9572 10.3683H16.2248C16.2347 10.3683 16.2441 10.3644 16.2512 10.3574C16.2582 10.3504 16.2621 10.3409 16.2621 10.331V10.2065Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M15.6025 10.2065H15.5279V10.2688H15.4719V10.2065H15.3972V10.2688H15.3412V10.2065H15.2665V10.331C15.2665 10.3559 15.279 10.3683 15.2976 10.3683H15.5652C15.5751 10.3683 15.5846 10.3644 15.5916 10.3574C15.5986 10.3504 15.6025 10.3409 15.6025 10.331V10.2065Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M15.7892 10.3058C15.7892 10.2685 15.7332 10.2685 15.7332 10.3058V10.4054H15.7892V10.3058Z", fill: "black" }), /* @__PURE__ */ o.createElement("path", { d: "M16.1189 10.4428C16.1189 10.4055 16.0691 10.4055 16.0691 10.4428V10.5175H16.1189V10.4428Z", fill: "black" }), /* @__PURE__ */ o.createElement("path", { d: "M15.4594 10.4428C15.4594 10.4055 15.4096 10.4055 15.4096 10.4428V10.5175H15.4594V10.4428Z", fill: "black" }), /* @__PURE__ */ o.createElement("path", { d: "M16.0194 14.0454C16.0132 13.7032 15.7705 13.6223 15.7705 13.6223C15.7643 13.6223 15.503 13.7094 15.503 14.0516H16.0194", fill: "#FFFF00" }), /* @__PURE__ */ o.createElement("path", { d: "M16.231 13.6285L16.2746 14.0205H16.0132C16.0132 13.697 15.7643 13.6472 15.7643 13.6472C15.7581 13.6472 15.5155 13.7156 15.5092 14.0205H15.2479L15.2977 13.6223H16.231V13.6285ZM16.2932 14.0268H15.2355C15.2168 14.0268 15.1981 14.0454 15.1981 14.0703C15.1981 14.1014 15.2168 14.1201 15.2355 14.1201H16.2932C16.3119 14.1201 16.3306 14.1014 16.3306 14.0703C16.3306 14.0454 16.3119 14.0268 16.287 14.0268H16.2932Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M15.9073 14.0206C15.9073 13.8153 15.7642 13.7593 15.7642 13.7593C15.7642 13.7593 15.6211 13.8215 15.6211 14.0206H15.9073ZM16.2682 13.4606H15.254C15.2353 13.4606 15.2166 13.4855 15.2166 13.5104C15.2166 13.5291 15.2353 13.5477 15.254 13.5477H16.2682C16.2869 13.5477 16.3055 13.5291 16.3055 13.5042C16.3055 13.4855 16.2869 13.4669 16.2682 13.4669V13.4606ZM16.2433 13.554H15.2851C15.2664 13.554 15.2478 13.5726 15.2478 13.5975C15.2478 13.6224 15.2664 13.6411 15.2851 13.6411H16.2495C16.2744 13.6411 16.2869 13.6224 16.2869 13.5975C16.2869 13.5726 16.2744 13.554 16.2495 13.554H16.2433ZM15.9322 12.8944H15.8575V12.9442H15.8015V12.8944H15.7207V12.9504H15.6647V12.8882H15.59V13.0126C15.59 13.0375 15.6024 13.05 15.6211 13.05H15.8949C15.9135 13.05 15.9322 13.0375 15.9322 13.0189V12.8944ZM15.646 13.0624L15.6273 13.4606H15.8949L15.8762 13.0562H15.646", fill: "#FFFF00" }), /* @__PURE__ */ o.createElement("path", { d: "M15.646 13.0624L15.6273 13.4606H15.8949L15.8762 13.0562H15.646M15.9073 14.0206C15.9073 13.8153 15.7642 13.7593 15.7642 13.7593C15.7642 13.7593 15.6211 13.8215 15.6211 14.0206H15.9073ZM16.2682 13.4606H15.254C15.2353 13.4606 15.2166 13.4855 15.2166 13.5104C15.2166 13.5291 15.2353 13.5477 15.254 13.5477H16.2682C16.2869 13.5477 16.3055 13.5291 16.3055 13.5042C16.3055 13.4855 16.2869 13.4669 16.2682 13.4669V13.4606ZM16.2433 13.554H15.2851C15.2664 13.554 15.2478 13.5726 15.2478 13.5975C15.2478 13.6224 15.2664 13.6411 15.2851 13.6411H16.2495C16.2744 13.6411 16.2869 13.6224 16.2869 13.5975C16.2869 13.5726 16.2744 13.554 16.2495 13.554H16.2433ZM15.9322 12.8944H15.8575V12.9442H15.8015V12.8944H15.7207V12.9504H15.6647V12.8882H15.59V13.0126C15.59 13.0375 15.6024 13.05 15.6211 13.05H15.8949C15.9135 13.05 15.9322 13.0375 15.9322 13.0189V12.8944Z", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M15.9696 13.249V13.4606H16.2185V13.249H15.9696Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M15.3101 13.249V13.4606H15.559V13.249H15.3101Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M16.2621 13.0874H16.1874V13.1496H16.1314V13.0874H16.0568V13.1496H16.0008V13.0874H15.9261V13.2118C15.9261 13.2367 15.9385 13.2492 15.9572 13.2492H16.2248C16.2347 13.2492 16.2441 13.2452 16.2512 13.2382C16.2582 13.2312 16.2621 13.2217 16.2621 13.2118V13.0874Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M15.6025 13.0874H15.5279V13.1496H15.4719V13.0874H15.3972V13.1496H15.3412V13.0874H15.2665V13.2118C15.2665 13.2367 15.279 13.2492 15.2976 13.2492H15.5652C15.5751 13.2492 15.5846 13.2452 15.5916 13.2382C15.5986 13.2312 15.6025 13.2217 15.6025 13.2118V13.0874Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M15.7892 13.1867C15.7892 13.1494 15.7332 13.1494 15.7332 13.1867V13.2862H15.7892V13.1867Z", fill: "black" }), /* @__PURE__ */ o.createElement("path", { d: "M16.1189 13.3237C16.1189 13.2863 16.0691 13.2863 16.0691 13.3237V13.3983H16.1189V13.3237Z", fill: "black" }), /* @__PURE__ */ o.createElement("path", { d: "M15.4594 13.3237C15.4594 13.2863 15.4096 13.2863 15.4096 13.3237V13.3983H15.4594V13.3237Z", fill: "black" }), /* @__PURE__ */ o.createElement("path", { d: "M14.8964 17.0481C15.1349 16.8026 15.0213 16.5734 15.0213 16.5734C15.0169 16.569 14.7709 16.4449 14.5281 16.6861L14.892 17.0525", fill: "#FFFF00" }), /* @__PURE__ */ o.createElement("path", { d: "M15.3413 16.9044L15.0939 17.2116L14.9097 17.0261C15.1393 16.7981 14.9993 16.5865 14.9993 16.5865C14.9949 16.582 14.7753 16.4581 14.5546 16.6685L14.3704 16.4831L14.6881 16.2378L15.3457 16.9001L15.3413 16.9044ZM15.1026 17.2292L14.3573 16.4786C14.3441 16.4654 14.3177 16.4653 14.3 16.4828C14.278 16.5048 14.2779 16.5311 14.291 16.5444L15.0364 17.295C15.0495 17.3082 15.0759 17.3083 15.098 17.2864C15.1157 17.2688 15.1158 17.2424 15.0982 17.2248L15.1026 17.2292Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M14.8352 16.9509C14.9809 16.8063 14.9198 16.6652 14.9198 16.6652C14.9198 16.6652 14.7748 16.6075 14.6335 16.7478L14.8352 16.9509ZM15.4868 16.8124L14.7722 16.0928C14.759 16.0795 14.7282 16.0838 14.7105 16.1013C14.6973 16.1145 14.6972 16.1409 14.7103 16.1541L15.425 16.8738C15.4382 16.887 15.4646 16.8871 15.4822 16.8696C15.4955 16.8564 15.4956 16.8301 15.4824 16.8168L15.4868 16.8124ZM15.403 16.8605L14.7279 16.1806C14.7147 16.1674 14.6883 16.1673 14.6706 16.1848C14.653 16.2023 14.6529 16.2287 14.666 16.242L15.3456 16.9263C15.3632 16.944 15.3852 16.9397 15.4028 16.9221C15.4205 16.9046 15.425 16.8826 15.4074 16.8649L15.403 16.8605ZM15.6518 16.175L15.5992 16.122L15.5639 16.1571L15.5244 16.1174L15.5598 16.0823L15.5028 16.0249L15.463 16.0644L15.4236 16.0246L15.4677 15.9808L15.4151 15.9278L15.3268 16.0155C15.3091 16.033 15.3091 16.0506 15.3222 16.0639L15.5151 16.2581C15.5283 16.2714 15.5503 16.2759 15.5635 16.2627L15.6518 16.175ZM15.3309 16.0903L15.0352 16.3577L15.2238 16.5475L15.4976 16.2493L15.3354 16.0859", fill: "#FFFF00" }), /* @__PURE__ */ o.createElement("path", { d: "M15.3309 16.0903L15.0352 16.3577L15.2238 16.5475L15.4976 16.2493L15.3354 16.0859M14.8352 16.9509C14.9809 16.8063 14.9198 16.6652 14.9198 16.6652C14.9198 16.6652 14.7748 16.6075 14.6335 16.7478L14.8352 16.9509ZM15.4868 16.8124L14.7722 16.0928C14.759 16.0795 14.7282 16.0838 14.7105 16.1013C14.6973 16.1145 14.6972 16.1409 14.7103 16.1541L15.425 16.8738C15.4382 16.887 15.4646 16.8871 15.4822 16.8696C15.4955 16.8564 15.4956 16.8301 15.4824 16.8168L15.4868 16.8124ZM15.403 16.8605L14.7279 16.1806C14.7147 16.1674 14.6883 16.1673 14.6706 16.1848C14.653 16.2023 14.6529 16.2287 14.666 16.242L15.3456 16.9263C15.3632 16.944 15.3852 16.9397 15.4028 16.9221C15.4205 16.9046 15.425 16.8826 15.4074 16.8649L15.403 16.8605ZM15.6518 16.175L15.5992 16.122L15.5639 16.1571L15.5244 16.1174L15.5598 16.0823L15.5028 16.0249L15.463 16.0644L15.4236 16.0246L15.4677 15.9808L15.4151 15.9278L15.3268 16.0155C15.3091 16.033 15.3091 16.0506 15.3222 16.0639L15.5151 16.2581C15.5283 16.2714 15.5503 16.2759 15.5635 16.2627L15.6518 16.175Z", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M15.4266 16.4516L15.2764 16.6006L15.4518 16.7772L15.6019 16.6282L15.4266 16.4516Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M14.9618 15.9836L14.8117 16.1326L14.9871 16.3092L15.1372 16.1602L14.9618 15.9836Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M15.7474 16.5449L15.6948 16.4919L15.6507 16.5358L15.6112 16.496L15.6554 16.4522L15.6028 16.3992L15.5586 16.4431L15.5191 16.4033L15.5633 16.3595L15.5107 16.3065L15.4224 16.3942C15.4047 16.4117 15.4047 16.4293 15.4178 16.4426L15.6063 16.6324C15.6133 16.6395 15.6228 16.6434 15.6327 16.6435C15.6426 16.6435 15.6521 16.6396 15.6591 16.6326L15.7474 16.5449Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M15.2827 16.0771L15.2301 16.0242L15.186 16.068L15.1465 16.0283L15.1906 15.9844L15.138 15.9314L15.0939 15.9753L15.0544 15.9356L15.0986 15.8917L15.046 15.8387L14.9577 15.9264C14.94 15.944 14.9399 15.9616 14.9531 15.9748L15.1416 16.1647C15.1486 16.1717 15.1581 16.1756 15.168 16.1757C15.1779 16.1757 15.1874 16.1718 15.1944 16.1648L15.2827 16.0771Z", fill: "#FFFF00", stroke: "black", strokeWidth: 0.1 }), /* @__PURE__ */ o.createElement("path", { d: "M15.3435 16.2797C15.37 16.2534 15.3306 16.2137 15.3041 16.24L15.2334 16.3102L15.2729 16.3499L15.3435 16.2797Z", fill: "black" }), /* @__PURE__ */ o.createElement("path", { d: "M15.4788 16.6101C15.5053 16.5838 15.4702 16.5484 15.4437 16.5747L15.3907 16.6274L15.4258 16.6627L15.4788 16.6101Z", fill: "black" }), /* @__PURE__ */ o.createElement("path", { d: "M15.0141 16.1423C15.0406 16.116 15.0055 16.0807 14.979 16.107L14.926 16.1596L14.9611 16.1949L15.0141 16.1423Z", fill: "black" }), /* @__PURE__ */ o.createElement("path", { d: "M12.4729 14.1512C12.4718 14.2826 12.5207 14.4094 12.6098 14.5059C12.6514 14.5524 12.7022 14.5897 12.7589 14.6154C12.8157 14.6411 12.8773 14.6547 12.9396 14.6553C13.0703 14.6553 13.1885 14.593 13.2694 14.5059C13.3584 14.4094 13.4074 14.2826 13.4063 14.1512V13.4792H12.4729V14.1512Z", fill: "#003399" }), /* @__PURE__ */ o.createElement("path", { d: "M12.6907 13.8278C12.7423 13.8278 12.7841 13.786 12.7841 13.7344C12.7841 13.6829 12.7423 13.6411 12.6907 13.6411C12.6392 13.6411 12.5974 13.6829 12.5974 13.7344C12.5974 13.786 12.6392 13.8278 12.6907 13.8278Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M13.2072 13.8278C13.2588 13.8278 13.3006 13.786 13.3006 13.7344C13.3006 13.6829 13.2588 13.6411 13.2072 13.6411C13.1557 13.6411 13.1139 13.6829 13.1139 13.7344C13.1139 13.786 13.1557 13.8278 13.2072 13.8278Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M12.9459 14.0766C12.9974 14.0766 13.0392 14.0348 13.0392 13.9832C13.0392 13.9317 12.9974 13.8899 12.9459 13.8899C12.8943 13.8899 12.8525 13.9317 12.8525 13.9832C12.8525 14.0348 12.8943 14.0766 12.9459 14.0766Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M12.6907 14.338C12.7423 14.338 12.7841 14.2962 12.7841 14.2447C12.7841 14.1932 12.7423 14.1514 12.6907 14.1514C12.6392 14.1514 12.5974 14.1932 12.5974 14.2447C12.5974 14.2962 12.6392 14.338 12.6907 14.338Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M13.2072 14.338C13.2588 14.338 13.3006 14.2962 13.3006 14.2447C13.3006 14.1932 13.2588 14.1514 13.2072 14.1514C13.1557 14.1514 13.1139 14.1932 13.1139 14.2447C13.1139 14.2962 13.1557 14.338 13.2072 14.338Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M12.4729 12.5336C12.4718 12.6649 12.5207 12.7917 12.6098 12.8882C12.6514 12.9347 12.7022 12.972 12.7589 12.9977C12.8157 13.0234 12.8773 13.037 12.9396 13.0376C13.0703 13.0376 13.1885 12.9754 13.2694 12.8882C13.3584 12.7917 13.4074 12.6649 13.4063 12.5336V11.8616H12.4729V12.5336Z", fill: "#003399" }), /* @__PURE__ */ o.createElement("path", { d: "M12.6907 12.2101C12.7423 12.2101 12.7841 12.1683 12.7841 12.1168C12.7841 12.0652 12.7423 12.0234 12.6907 12.0234C12.6392 12.0234 12.5974 12.0652 12.5974 12.1168C12.5974 12.1683 12.6392 12.2101 12.6907 12.2101Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M13.2072 12.2101C13.2588 12.2101 13.3006 12.1683 13.3006 12.1168C13.3006 12.0652 13.2588 12.0234 13.2072 12.0234C13.1557 12.0234 13.1139 12.0652 13.1139 12.1168C13.1139 12.1683 13.1557 12.2101 13.2072 12.2101Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M12.9459 12.4589C12.9974 12.4589 13.0392 12.4171 13.0392 12.3656C13.0392 12.314 12.9974 12.2722 12.9459 12.2722C12.8943 12.2722 12.8525 12.314 12.8525 12.3656C12.8525 12.4171 12.8943 12.4589 12.9459 12.4589Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M12.6907 12.7204C12.7423 12.7204 12.7841 12.6786 12.7841 12.627C12.7841 12.5755 12.7423 12.5337 12.6907 12.5337C12.6392 12.5337 12.5974 12.5755 12.5974 12.627C12.5974 12.6786 12.6392 12.7204 12.6907 12.7204Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M13.2072 12.7204C13.2588 12.7204 13.3006 12.6786 13.3006 12.627C13.3006 12.5755 13.2588 12.5337 13.2072 12.5337C13.1557 12.5337 13.1139 12.5755 13.1139 12.627C13.1139 12.6786 13.1557 12.7204 13.2072 12.7204Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M11.1786 14.1512C11.1775 14.2826 11.2264 14.4094 11.3155 14.5059C11.3571 14.5524 11.4078 14.5897 11.4646 14.6154C11.5214 14.6411 11.5829 14.6547 11.6453 14.6553C11.7759 14.6553 11.8942 14.593 11.9751 14.5059C12.0641 14.4094 12.1131 14.2826 12.1119 14.1512V13.4792H11.1786V14.1512Z", fill: "#003399" }), /* @__PURE__ */ o.createElement("path", { d: "M11.3963 13.8278C11.4479 13.8278 11.4896 13.786 11.4896 13.7344C11.4896 13.6829 11.4479 13.6411 11.3963 13.6411C11.3448 13.6411 11.303 13.6829 11.303 13.7344C11.303 13.786 11.3448 13.8278 11.3963 13.8278Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M11.9128 13.8278C11.9643 13.8278 12.0061 13.786 12.0061 13.7344C12.0061 13.6829 11.9643 13.6411 11.9128 13.6411C11.8612 13.6411 11.8195 13.6829 11.8195 13.7344C11.8195 13.786 11.8612 13.8278 11.9128 13.8278Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M11.6514 14.0766C11.703 14.0766 11.7448 14.0348 11.7448 13.9832C11.7448 13.9317 11.703 13.8899 11.6514 13.8899C11.5999 13.8899 11.5581 13.9317 11.5581 13.9832C11.5581 14.0348 11.5999 14.0766 11.6514 14.0766Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M11.3963 14.338C11.4479 14.338 11.4896 14.2962 11.4896 14.2447C11.4896 14.1932 11.4479 14.1514 11.3963 14.1514C11.3448 14.1514 11.303 14.1932 11.303 14.2447C11.303 14.2962 11.3448 14.338 11.3963 14.338Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M11.9128 14.338C11.9643 14.338 12.0061 14.2962 12.0061 14.2447C12.0061 14.1932 11.9643 14.1514 11.9128 14.1514C11.8612 14.1514 11.8195 14.1932 11.8195 14.2447C11.8195 14.2962 11.8612 14.338 11.9128 14.338Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M13.7671 14.1512C13.766 14.2826 13.8149 14.4094 13.904 14.5059C13.9456 14.5524 13.9963 14.5897 14.0531 14.6154C14.1099 14.6411 14.1714 14.6547 14.2338 14.6553C14.3644 14.6553 14.4827 14.593 14.5636 14.5059C14.6526 14.4094 14.7016 14.2826 14.7004 14.1512V13.4792H13.7671V14.1512Z", fill: "#003399" }), /* @__PURE__ */ o.createElement("path", { d: "M13.9848 13.8278C14.0364 13.8278 14.0781 13.786 14.0781 13.7344C14.0781 13.6829 14.0364 13.6411 13.9848 13.6411C13.9333 13.6411 13.8915 13.6829 13.8915 13.7344C13.8915 13.786 13.9333 13.8278 13.9848 13.8278Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M14.5013 13.8278C14.5528 13.8278 14.5946 13.786 14.5946 13.7344C14.5946 13.6829 14.5528 13.6411 14.5013 13.6411C14.4497 13.6411 14.408 13.6829 14.408 13.7344C14.408 13.786 14.4497 13.8278 14.5013 13.8278Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M14.2399 14.0766C14.2915 14.0766 14.3333 14.0348 14.3333 13.9832C14.3333 13.9317 14.2915 13.8899 14.2399 13.8899C14.1884 13.8899 14.1466 13.9317 14.1466 13.9832C14.1466 14.0348 14.1884 14.0766 14.2399 14.0766Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M13.9848 14.338C14.0364 14.338 14.0781 14.2962 14.0781 14.2447C14.0781 14.1932 14.0364 14.1514 13.9848 14.1514C13.9333 14.1514 13.8915 14.1932 13.8915 14.2447C13.8915 14.2962 13.9333 14.338 13.9848 14.338Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M14.5013 14.338C14.5528 14.338 14.5946 14.2962 14.5946 14.2447C14.5946 14.1932 14.5528 14.1514 14.5013 14.1514C14.4497 14.1514 14.408 14.1932 14.408 14.2447C14.408 14.2962 14.4497 14.338 14.5013 14.338Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M12.4729 15.7567C12.4718 15.888 12.5207 16.0149 12.6098 16.1114C12.6514 16.1579 12.7022 16.1951 12.7589 16.2208C12.8157 16.2466 12.8773 16.2601 12.9396 16.2607C13.0703 16.2607 13.1885 16.1985 13.2694 16.1114C13.3584 16.0149 13.4074 15.888 13.4063 15.7567V15.0847H12.4729V15.7567Z", fill: "#003399" }), /* @__PURE__ */ o.createElement("path", { d: "M12.6907 15.433C12.7423 15.433 12.7841 15.3912 12.7841 15.3397C12.7841 15.2881 12.7423 15.2463 12.6907 15.2463C12.6392 15.2463 12.5974 15.2881 12.5974 15.3397C12.5974 15.3912 12.6392 15.433 12.6907 15.433Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M13.2072 15.433C13.2588 15.433 13.3006 15.3912 13.3006 15.3397C13.3006 15.2881 13.2588 15.2463 13.2072 15.2463C13.1557 15.2463 13.1139 15.2881 13.1139 15.3397C13.1139 15.3912 13.1557 15.433 13.2072 15.433Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M12.9459 15.6818C12.9974 15.6818 13.0392 15.64 13.0392 15.5885C13.0392 15.5369 12.9974 15.4951 12.9459 15.4951C12.8943 15.4951 12.8525 15.5369 12.8525 15.5885C12.8525 15.64 12.8943 15.6818 12.9459 15.6818Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M12.6907 15.9433C12.7423 15.9433 12.7841 15.9015 12.7841 15.8499C12.7841 15.7984 12.7423 15.7566 12.6907 15.7566C12.6392 15.7566 12.5974 15.7984 12.5974 15.8499C12.5974 15.9015 12.6392 15.9433 12.6907 15.9433Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M13.2072 15.9433C13.2588 15.9433 13.3006 15.9015 13.3006 15.8499C13.3006 15.7984 13.2588 15.7566 13.2072 15.7566C13.1557 15.7566 13.1139 15.7984 13.1139 15.8499C13.1139 15.9015 13.1557 15.9433 13.2072 15.9433Z", fill: "white" })), /* @__PURE__ */ o.createElement("defs", null, /* @__PURE__ */ o.createElement("clipPath", { id: "clip0_265_1407" }, /* @__PURE__ */ o.createElement("rect", { x: 0.314453, width: 28, height: 28, rx: 14, fill: "white" })))), _7 = V(b7), x7 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 29, height: 28, viewBox: "0 0 29 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", { clipPath: "url(#clip0_64_2720)" }, /* @__PURE__ */ o.createElement("rect", { x: 0.314453, width: 28, height: 9.33333, fill: "white" }), /* @__PURE__ */ o.createElement("rect", { x: 0.314453, y: 9.33398, width: 28, height: 9.33333, fill: "#0137A1" }), /* @__PURE__ */ o.createElement("rect", { x: 0.314453, y: 18.666, width: 28, height: 9.33333, fill: "#CF291E" })), /* @__PURE__ */ o.createElement("defs", null, /* @__PURE__ */ o.createElement("clipPath", { id: "clip0_64_2720" }, /* @__PURE__ */ o.createElement("rect", { x: 0.314453, width: 28, height: 28, rx: 14, fill: "white" })))), L7 = V(x7), E7 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 29, height: 28, viewBox: "0 0 29 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", { clipPath: "url(#clip0_64_2749)" }, /* @__PURE__ */ o.createElement("path", { d: "M0.314453 13.999C0.314453 15.7115 0.622508 17.3519 1.18524 18.8686L14.3145 20.086L27.4437 18.8686C28.0064 17.3519 28.3145 15.7115 28.3145 13.999C28.3145 12.2866 28.0064 10.6462 27.4437 9.12951L14.3145 7.91211L1.18524 9.12951C0.622508 10.6462 0.314453 12.2866 0.314453 13.999H0.314453Z", fill: "#FFDA44" }), /* @__PURE__ */ o.createElement("path", { d: "M27.444 9.13046C25.4659 3.7993 20.3343 0 14.3148 0C8.29525 0 3.16365 3.7993 1.18555 9.13046H27.444Z", fill: "#D80027" }), /* @__PURE__ */ o.createElement("path", { d: "M1.18555 18.8691C3.16365 24.2003 8.29525 27.9996 14.3148 27.9996C20.3343 27.9996 25.4659 24.2003 27.444 18.8691H1.18555Z", fill: "#D80027" })), /* @__PURE__ */ o.createElement("defs", null, /* @__PURE__ */ o.createElement("clipPath", { id: "clip0_64_2749" }, /* @__PURE__ */ o.createElement("rect", { x: 0.314453, width: 28, height: 28, rx: 12, fill: "white" })))), M7 = V(E7), k7 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 29, height: 28, viewBox: "0 0 29 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", { clipPath: "url(#clip0_3275_270766)" }, /* @__PURE__ */ o.createElement("path", { d: "M14.6289 28C22.3609 28 28.6289 21.732 28.6289 14C28.6289 6.26801 22.3609 0 14.6289 0C6.89692 0 0.628906 6.26801 0.628906 14C0.628906 21.732 6.89692 28 14.6289 28Z", fill: "#E30A17" }), /* @__PURE__ */ o.createElement("path", { d: "M15.2571 14L21.3145 11.9429L17.5705 17.3287V10.6713L21.3145 16.0571L15.2571 14ZM15.67 17.7431C14.8942 19.0247 13.7411 20.0082 12.3844 20.5457C11.0276 21.0832 9.54057 21.1455 8.147 20.7233C6.75344 20.3011 5.52874 19.4173 4.65721 18.2048C3.78567 16.9922 3.31445 15.5166 3.31445 14C3.31445 12.4834 3.78567 11.0078 4.65721 9.79525C5.52874 8.58272 6.75344 7.69886 8.147 7.27668C9.54057 6.8545 11.0276 6.91683 12.3844 7.4543C13.7411 7.99176 14.8942 8.97529 15.67 10.2569C14.9455 9.41414 13.9935 8.82096 12.9397 8.55567C11.8859 8.29038 10.7799 8.36546 9.76777 8.77099C8.75565 9.17652 7.88502 9.89342 7.27086 10.827C6.6567 11.7606 6.32791 12.867 6.32791 14C6.32791 15.133 6.6567 16.2394 7.27086 17.173C7.88502 18.1066 8.75565 18.8235 9.76777 19.229C10.7799 19.6345 11.8859 19.7096 12.9397 19.4443C13.9935 19.179 14.9455 18.5859 15.67 17.7431Z", fill: "white" })), /* @__PURE__ */ o.createElement("defs", null, /* @__PURE__ */ o.createElement("clipPath", { id: "clip0_3275_270766" }, /* @__PURE__ */ o.createElement("rect", { x: 0.314453, width: 28, height: 28, rx: 12, fill: "white" })))), S7 = V(k7), A7 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { className: "svg-substrate", cx: 12, cy: 12, r: 11, fill: "transparent" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM10.3516 5.5H13.6483C14.0057 5.49999 14.3094 5.49998 14.5604 5.52271C14.8263 5.54678 15.0769 5.59916 15.3173 5.72959C15.6748 5.92363 15.9889 6.26619 16.1512 6.63917C16.2926 6.96398 16.308 7.30728 16.2859 7.69757C16.6236 7.63724 16.9771 7.66888 17.287 7.77472C17.9338 7.99558 18.5 8.5735 18.5 9.47222C18.5 10.3214 17.9937 11.0933 17.3358 11.6298C16.78 12.0831 16.0636 12.4147 15.302 12.5122C15.2101 12.7302 15.1118 12.9376 15.0069 13.1335C14.6166 13.8623 14.1156 14.4618 13.4982 14.8344C13.5161 15.1343 13.5597 15.3387 13.6086 15.4818C13.6691 15.6589 13.7441 15.7622 13.8254 15.8529C13.8587 15.8902 13.8873 15.9193 13.9227 15.9554L13.9228 15.9554C13.9414 15.9744 13.962 15.9954 13.9862 16.0205C14.0476 16.0843 14.1244 16.1675 14.1947 16.2702C14.3507 16.4982 14.4375 16.7669 14.4375 17.1188L14.4375 17.9583C14.4375 18.2575 14.195 18.5 13.8958 18.5H10.1042C9.80502 18.5 9.56251 18.2575 9.56251 17.9583L9.5625 17.1188C9.5625 16.7669 9.64927 16.4982 9.80528 16.2702C9.87558 16.1675 9.95243 16.0843 10.0138 16.0205C10.038 15.9954 10.0586 15.9744 10.0773 15.9554C10.1127 15.9193 10.1413 15.8902 10.1746 15.8529C10.2559 15.7622 10.3309 15.6588 10.3914 15.4818C10.4403 15.3387 10.4839 15.1343 10.5018 14.8344C9.88433 14.4618 9.38333 13.8623 8.99301 13.1335C8.8881 12.9376 8.78977 12.7302 8.69789 12.5122C7.93637 12.4147 7.21998 12.0831 6.66418 11.6298C6.00627 11.0933 5.5 10.3214 5.5 9.47222C5.5 8.5735 6.06618 7.99558 6.71299 7.77472C7.02293 7.66889 7.37631 7.63724 7.71406 7.69755C7.69191 7.30727 7.70732 6.96398 7.84871 6.63917C8.01107 6.26619 8.32515 5.92363 8.68267 5.72959C8.92299 5.59916 9.17367 5.54678 9.43953 5.52271C9.69052 5.49998 9.99427 5.49999 10.3516 5.5ZM15.7168 11.3079C16.0585 11.1911 16.3795 11.0119 16.6512 10.7903C17.1556 10.3789 17.4167 9.88688 17.4167 9.47222C17.4167 9.10704 17.2155 8.89504 16.9369 8.79993C16.6191 8.6914 16.31 8.77167 16.1745 8.90717C16.0729 9.76784 15.9213 10.5759 15.7168 11.3079ZM7.8254 8.90724C7.92708 9.76788 8.07864 10.5759 8.28311 11.3079C7.94144 11.1911 7.62052 11.0118 7.34885 10.7903C6.84443 10.3789 6.58334 9.88688 6.58334 9.47222C6.58334 9.10704 6.78452 8.89504 7.06306 8.79993C7.3809 8.6914 7.6899 8.77174 7.8254 8.90724Z", fill: "inherit" })), T7 = V(A7), I7 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.64832 1.5H6.3516C5.99426 1.49999 5.69051 1.49998 5.43953 1.52271C5.17367 1.54678 4.92299 1.59916 4.68267 1.72959C4.32514 1.92363 4.01106 2.26619 3.84871 2.63917C3.70732 2.96398 3.6919 3.30727 3.71406 3.69756C3.37631 3.63724 3.02292 3.66889 2.71299 3.77472C2.06618 3.99558 1.5 4.5735 1.5 5.47222C1.5 6.32145 2.00627 7.09329 2.66417 7.62983C3.21998 8.08311 3.93636 8.41469 4.69789 8.51216C4.78977 8.73016 4.8881 8.93758 4.99301 9.13346C5.38333 9.8623 5.88433 10.4618 6.5018 10.8344C6.4839 11.1343 6.44025 11.3387 6.39138 11.4818C6.33091 11.6589 6.25588 11.7622 6.17461 11.8529C6.14126 11.8902 6.11269 11.9193 6.07727 11.9554C6.05861 11.9744 6.03801 11.9954 6.01384 12.0205C5.95243 12.0843 5.87557 12.1675 5.80528 12.2702C5.64927 12.4982 5.5625 12.7669 5.5625 13.1188L5.56251 13.9583C5.56251 14.2575 5.80502 14.5 6.10417 14.5H9.89582C10.195 14.5 10.4375 14.2575 10.4375 13.9583L10.4375 13.1188C10.4375 12.7669 10.3507 12.4982 10.1947 12.2702C10.1244 12.1675 10.0476 12.0843 9.98615 12.0205C9.96198 11.9954 9.94141 11.9744 9.92275 11.9554C9.88732 11.9193 9.85873 11.8902 9.82539 11.8529C9.74411 11.7622 9.66909 11.6589 9.60862 11.4818C9.55975 11.3387 9.51609 11.1343 9.49819 10.8344C10.1156 10.4618 10.6166 9.86227 11.0069 9.13346C11.1118 8.93758 11.2101 8.73017 11.302 8.51217C12.0636 8.41472 12.78 8.08312 13.3358 7.62983C13.9937 7.09329 14.5 6.32145 14.5 5.47222C14.5 4.5735 13.9338 3.99558 13.287 3.77472C12.977 3.66888 12.6236 3.63724 12.2859 3.69757C12.308 3.30728 12.2926 2.96398 12.1512 2.63917C11.9889 2.26619 11.6748 1.92363 11.3172 1.72959C11.0769 1.59916 10.8263 1.54678 10.5604 1.52271C10.3094 1.49998 10.0057 1.49999 9.64832 1.5ZM12.6511 6.79029C12.3795 7.01187 12.0585 7.19111 11.7168 7.30793C11.9213 6.5759 12.0728 5.76784 12.1745 4.90717C12.31 4.77167 12.6191 4.6914 12.9369 4.79993C13.2155 4.89504 13.4167 5.10704 13.4167 5.47222C13.4167 5.88688 13.1556 6.37892 12.6511 6.79029ZM4.28311 7.3079C4.07863 6.5759 3.92708 5.76788 3.8254 4.90724C3.6899 4.77174 3.3809 4.6914 3.06305 4.79993C2.78451 4.89504 2.58333 5.10704 2.58333 5.47222C2.58333 5.88688 2.84443 6.37892 3.34885 6.79029C3.62052 7.01185 3.94144 7.19108 4.28311 7.3079Z", fill: "inherit" })), R7 = V(I7), N7 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.48438 2C6.8727 2 7.1875 2.31603 7.1875 2.70588V2.9475C7.5559 2.94117 7.96568 2.94117 8.42255 2.94118H11.5774C12.0343 2.94117 12.4441 2.94117 12.8125 2.9475V2.70588C12.8125 2.31603 13.1273 2 13.5156 2C13.9039 2 14.2188 2.31603 14.2188 2.70588V3.04067C14.6202 3.10144 14.9834 3.20268 15.3245 3.37715C16.0742 3.76064 16.6837 4.37257 17.0657 5.12521C17.3035 5.59363 17.4047 6.10364 17.453 6.6966C17.5 7.27472 17.5 7.99053 17.5 8.88694V12.0542C17.5 12.9507 17.5 13.6665 17.453 14.2446C17.4047 14.8375 17.3035 15.3475 17.0657 15.816C16.6837 16.5686 16.0742 17.1805 15.3245 17.564C14.8579 17.8027 14.3499 17.9043 13.7592 17.9528C13.1834 18 12.4704 18 11.5775 18H8.42253C7.52963 18 6.81662 18 6.24075 17.9528C5.65011 17.9043 5.1421 17.8027 4.67551 17.564C3.9258 17.1805 3.31627 16.5686 2.93427 15.816C2.69653 15.3475 2.5953 14.8375 2.54704 14.2446C2.49999 13.6665 2.49999 12.9506 2.5 12.0542V8.88695C2.49999 7.99054 2.49999 7.27473 2.54704 6.6966C2.5953 6.10364 2.69653 5.59363 2.93427 5.12521C3.31627 4.37257 3.9258 3.76064 4.67551 3.37715C5.01659 3.20268 5.3798 3.10144 5.78125 3.04067V2.70588C5.78125 2.31603 6.09605 2 6.48438 2ZM5.78125 4.4749C5.59091 4.51625 5.44242 4.56931 5.31393 4.63504C4.82883 4.88318 4.43442 5.27913 4.18725 5.76614C4.06735 6.00237 3.98977 6.30591 3.94862 6.81156C3.92912 7.05113 3.9186 7.32204 3.91291 7.63765H16.0871C16.0814 7.32204 16.0709 7.05113 16.0514 6.81156C16.0102 6.30591 15.9326 6.00237 15.8128 5.76614C15.5656 5.27913 15.1712 4.88318 14.6861 4.63504C14.5576 4.56931 14.4091 4.51625 14.2188 4.4749V4.58824C14.2188 4.97808 13.9039 5.29412 13.5156 5.29412C13.1273 5.29412 12.8125 4.97808 12.8125 4.58824V4.35946C12.4546 4.35309 12.0392 4.35294 11.5469 4.35294H8.45313C7.96075 4.35294 7.54536 4.35309 7.1875 4.35946V4.58824C7.1875 4.97808 6.8727 5.29412 6.48438 5.29412C6.09605 5.29412 5.78125 4.97808 5.78125 4.58824V4.4749ZM16.0938 9.04941H3.90625V12.0235C3.90625 12.9576 3.9068 13.6157 3.94862 14.1296C3.98977 14.6353 4.06735 14.9388 4.18725 15.175C4.43442 15.662 4.82883 16.058 5.31393 16.3061C5.54924 16.4265 5.85159 16.5044 6.35526 16.5457C6.86715 16.5877 7.52269 16.5882 8.45313 16.5882H11.5469C12.4773 16.5882 13.1329 16.5877 13.6447 16.5457C14.1484 16.5044 14.4508 16.4265 14.6861 16.3061C15.1712 16.058 15.5656 15.662 15.8128 15.175C15.9326 14.9388 16.0102 14.6353 16.0514 14.1296C16.0932 13.6157 16.0938 12.9576 16.0938 12.0235V9.04941Z", fill: "inherit" })), H7 = V(N7), O7 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.83711 4H2.75C2.33579 4 2 4.33579 2 4.75C2 5.16421 2.33579 5.5 2.75 5.5H3.29544L4.20208 14.7477C4.25341 15.2714 4.29613 15.7072 4.35919 16.0622C4.42502 16.4328 4.52185 16.7732 4.71166 17.0901C5.00647 17.5823 5.44066 17.976 5.95928 18.2214C6.29319 18.3794 6.64142 18.4426 7.01669 18.4719C7.37612 18.5 7.814 18.5 8.34018 18.5H11.6599C12.186 18.5 12.6239 18.5 12.9833 18.4719C13.3586 18.4426 13.7068 18.3794 14.0408 18.2214C14.5594 17.976 14.9936 17.5823 15.2884 17.0901C15.4782 16.7732 15.575 16.4328 15.6408 16.0622C15.7039 15.7072 15.7466 15.2714 15.798 14.7477L16.7046 5.5H17.25C17.6642 5.5 18 5.16421 18 4.75C18 4.33579 17.6642 4 17.25 4H13.1629C12.8241 2.56638 11.537 1.5 10 1.5C8.46305 1.5 7.17593 2.56638 6.83711 4ZM8.41825 4H11.5818C11.3009 3.40891 10.6979 3 10 3C9.30207 3 8.6991 3.40891 8.41825 4ZM15.1974 5.5H4.80263L5.69209 14.5725C5.74699 15.1324 5.78449 15.5095 5.83607 15.7999C5.88602 16.0811 5.94015 16.222 5.9985 16.3194C6.14082 16.557 6.35042 16.7471 6.6008 16.8655C6.70344 16.9141 6.84893 16.9542 7.13369 16.9765C7.42768 16.9995 7.80663 17 8.36926 17H11.6308C12.1934 17 12.5724 16.9995 12.8664 16.9765C13.1511 16.9542 13.2966 16.9141 13.3992 16.8655C13.6496 16.7471 13.8592 16.557 14.0015 16.3194C14.0599 16.222 14.114 16.0811 14.164 15.7999C14.2155 15.5095 14.2531 15.1324 14.3079 14.5725L15.1974 5.5ZM12.3122 7.50246C12.725 7.53684 13.0318 7.89934 12.9974 8.31213L12.4974 14.315C12.463 14.7277 12.1005 15.0345 11.6877 15.0001C11.2749 14.9657 10.9682 14.6032 11.0026 14.1905L11.5026 8.18762C11.537 7.77484 11.8995 7.46808 12.3122 7.50246ZM7.68776 7.50247C8.10055 7.46808 8.46305 7.77484 8.49743 8.18762L8.99743 14.1905C9.03181 14.6032 8.72506 14.9657 8.31227 15.0001C7.89949 15.0345 7.53699 14.7277 7.50261 14.315L7.00261 8.31213C6.96823 7.89935 7.27498 7.53685 7.68776 7.50247Z", fill: "inherit" })), j7 = V(O7), P7 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.04136 3H1.74988C1.33566 3 0.999878 3.33579 0.999878 3.75C0.999878 4.16421 1.33566 4.5 1.74988 4.5H2.29731L3.03554 11.6983C3.07221 12.0561 3.10403 12.3665 3.15054 12.6219C3.19987 12.8928 3.27471 13.1592 3.42729 13.4122C3.6565 13.7922 3.99297 14.0959 4.39437 14.2851C4.66156 14.4111 4.9342 14.4584 5.20876 14.4798C5.46757 14.5 5.77961 14.5 6.13922 14.5H9.86057C10.2202 14.5 10.5322 14.5 10.791 14.4798C11.0656 14.4584 11.3382 14.4111 11.6054 14.2851C12.0068 14.0959 12.3433 13.7922 12.5725 13.4122C12.7251 13.1593 12.7999 12.8929 12.8492 12.6219C12.8957 12.3665 12.9276 12.0562 12.9642 11.6984L13.7026 4.5H14.2499C14.6641 4.5 14.9999 4.16421 14.9999 3.75C14.9999 3.33579 14.6641 3 14.2499 3H10.9584C10.7204 1.58114 9.48638 0.5 7.99988 0.5C6.51338 0.5 5.2794 1.58114 5.04136 3ZM6.58523 3H9.41453C9.20861 2.4174 8.65299 2 7.99988 2C7.34677 2 6.79115 2.4174 6.58523 3ZM12.1947 4.5H3.80518L4.52494 11.5183C4.56519 11.9108 4.59152 12.1623 4.62627 12.3532C4.65936 12.5349 4.69079 12.6027 4.7117 12.6374C4.78811 12.7641 4.90027 12.8653 5.03407 12.9284C5.07069 12.9456 5.14134 12.97 5.3255 12.9844C5.51892 12.9995 5.77186 13 6.16633 13H9.83346C10.2279 13 10.4809 12.9995 10.6743 12.9844C10.8584 12.97 10.9291 12.9456 10.9657 12.9284C11.0995 12.8653 11.2117 12.7641 11.2881 12.6374C11.309 12.6027 11.3404 12.5349 11.3735 12.3532C11.4083 12.1623 11.4346 11.9108 11.4748 11.5184L12.1947 4.5ZM6.21243 5.50094C6.62612 5.48025 6.97826 5.79885 6.99894 6.21255L7.24894 11.2125C7.26963 11.6262 6.95103 11.9784 6.53733 11.9991C6.12363 12.0197 5.7715 11.7011 5.75081 11.2875L5.50081 6.28745C5.48013 5.87376 5.79873 5.52162 6.21243 5.50094ZM9.78733 5.50094C10.201 5.52162 10.5196 5.87376 10.4989 6.28745L10.2489 11.2875C10.2283 11.7011 9.87612 12.0197 9.46243 11.9991C9.04873 11.9784 8.73013 11.6262 8.75081 11.2125L9.00081 6.21255C9.0215 5.79885 9.37363 5.48025 9.78733 5.50094Z", fill: "inherit" })), D7 = V(P7), V7 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M8.552 17.88H7L11.64 3H13.192L8.552 17.88Z", fill: "#3F4042" })), B7 = V(V7), F7 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { className: "svg-substrate", cx: 12, cy: 12, r: 11, fill: "transparent" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12.5019 5.31971C12.303 4.89343 11.6968 4.89343 11.4979 5.31971L10.2135 8.07179C9.77325 9.0151 9.015 9.77334 8.07169 10.2136L5.31961 11.498C4.89334 11.6969 4.89334 12.3031 5.31961 12.502L8.0717 13.7864C9.01501 14.2267 9.77325 14.9849 10.2135 15.9282L11.4979 18.6803C11.6968 19.1066 12.303 19.1066 12.5019 18.6803L13.7863 15.9282C14.2266 14.9849 14.9848 14.2267 15.9281 13.7864L18.6802 12.502C19.1065 12.3031 19.1065 11.6969 18.6802 11.498L15.9281 10.2136C14.9848 9.77334 14.2266 9.0151 13.7863 8.07178L12.5019 5.31971Z", fill: "inherit" })), Z7 = V(F7), G7 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M7.49798 1.31971C7.69693 0.893432 8.30307 0.893431 8.50202 1.3197L9.78642 4.07179C10.2267 5.0151 10.9849 5.77334 11.9282 6.21358L14.6803 7.49798C15.1066 7.69693 15.1066 8.30307 14.6803 8.50202L11.9282 9.78642C10.9849 10.2267 10.2267 10.9849 9.78642 11.9282L8.50202 14.6803C8.30307 15.1066 7.69693 15.1066 7.49798 14.6803L6.21358 11.9282C5.77334 10.9849 5.0151 10.2267 4.07179 9.78642L1.31971 8.50202C0.893432 8.30307 0.893431 7.69693 1.3197 7.49798L4.07179 6.21358C5.0151 5.77334 5.77334 5.0151 6.21358 4.07179L7.49798 1.31971Z", fill: "inherit" })), W7 = V(G7), U7 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { cx: 10, cy: 10, r: 10, fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M8.84927 4.38092C8.64863 4.6347 8.58478 5.00253 8.45708 5.73818L8.36235 6.28394C8.36181 6.28678 8.36131 6.28967 8.36075 6.29292L7.51514 11.1643C7.38744 11.8999 7.32359 12.2677 7.42668 12.5759C7.44831 12.6406 7.47496 12.7035 7.50621 12.7641C7.60597 12.9574 7.75297 13.1274 7.93595 13.2591C8.20913 13.4556 8.59928 13.5255 9.37957 13.6653L12.4471 14.2147C13.2274 14.3544 13.6175 14.4243 13.9404 14.3345C14.2244 14.2556 14.4725 14.0928 14.649 13.8696C14.8496 13.6158 14.9134 13.248 15.0411 12.5123L15.9831 7.08615C16.1108 6.3505 16.1746 5.98268 16.0715 5.6745C15.9808 5.40341 15.8026 5.16429 15.5623 4.9914C15.2891 4.79485 14.8989 4.72497 14.1186 4.58521L11.0512 4.0358C10.2708 3.89603 9.88069 3.82615 9.5578 3.91594C9.27378 3.99492 9.02575 4.15769 8.84927 4.38092Z", fill: "inherit" }), /* @__PURE__ */ o.createElement("path", { d: "M6.92863 6.45883C6.9792 6.57769 6.9506 6.74247 6.8934 7.07202L6.21572 10.9759C6.15832 11.3064 6.10184 11.6314 6.07786 11.9116C6.05131 12.2218 6.05154 12.593 6.18354 12.9877C6.36553 13.5317 6.71772 13.9961 7.17456 14.3247C7.4995 14.5585 7.84235 14.6765 8.14463 14.755C8.42349 14.8274 8.75934 14.8875 9.11441 14.9511L10.498 15.1989C10.5527 15.2087 10.5718 15.2759 10.5274 15.3092C10.2761 15.4978 9.91392 15.5605 9.18961 15.6858L7.46185 15.9847C6.73756 16.11 6.37538 16.1726 6.07336 16.0797C5.80769 15.998 5.57422 15.8346 5.40642 15.613C5.21566 15.3611 5.15046 14.9994 5.02007 14.276L4.02407 8.7501C3.89368 8.02669 3.82848 7.66499 3.91964 7.3643C3.99983 7.0998 4.16206 6.86797 4.38309 6.70203C4.63436 6.51339 4.99652 6.45074 5.72083 6.32544L6.08439 6.26254C6.41397 6.20553 6.57876 6.17702 6.69759 6.22767C6.80157 6.27198 6.88437 6.35482 6.92863 6.45883Z", fill: "inherit" })), z7 = V(U7), q7 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 18.75C14.83 18.75 18.75 14.83 18.75 10C18.75 5.17 14.83 1.25 10 1.25C5.17 1.25 1.25 5.17 1.25 10C1.25 14.83 5.17 18.75 10 18.75ZM14.28 8.35C14.57 8.06 14.57 7.58 14.28 7.29C13.99 7 13.51 7 13.22 7.29L8.75 11.76L6.78 9.79C6.49 9.5 6.01 9.5 5.72 9.79C5.43 10.08 5.43 10.56 5.72 10.85L8.22 13.35C8.36 13.49 8.55 13.57 8.75 13.57C8.95 13.57 9.14 13.49 9.28 13.35L14.28 8.35Z", fill: "inherit" })), $7 = V(q7), Y7 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { id: "â³ Icon Color", d: "M11 18.5858L5.70711 13.2929C5.31658 12.9024 4.68342 12.9024 4.29289 13.2929C3.90237 13.6834 3.90237 14.3166 4.29289 14.7071L10.2929 20.7071C10.6834 21.0976 11.3166 21.0976 11.7071 20.7071L23.7071 8.70711C24.0976 8.31658 24.0976 7.68342 23.7071 7.29289C23.3166 6.90237 22.6834 6.90237 22.2929 7.29289L11 18.5858Z" })), K7 = V(Y7), Q7 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { id: "Ellipse 2726", cx: 7, cy: 14, r: 2 }), /* @__PURE__ */ o.createElement("circle", { id: "Ellipse 2727", cx: 14, cy: 14, r: 2 }), /* @__PURE__ */ o.createElement("circle", { id: "Ellipse 2728", cx: 21, cy: 14, r: 2 })), X7 = V(Q7), J7 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { className: "svg-substrate", cx: 12, cy: 12, r: 11, fill: "transparent" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12.0001 5C12.6214 5 13.1251 5.4701 13.1251 6.05V11.2151L14.5796 9.85754C15.0189 9.44749 15.7313 9.44749 16.1706 9.85754C16.6099 10.2676 16.6099 10.9324 16.1706 11.3425L12.7956 14.4925C12.3563 14.9025 11.6439 14.9025 11.2046 14.4925L7.8296 11.3425C7.39026 10.9324 7.39026 10.2676 7.8296 9.85754C8.26894 9.44749 8.98125 9.44749 9.42059 9.85754L10.8751 11.2151V6.05C10.8751 5.4701 11.3788 5 12.0001 5ZM6.0001 17.95C6.0001 17.3701 6.50378 16.9 7.1251 16.9H16.8751C17.4964 16.9 18.0001 17.3701 18.0001 17.95C18.0001 18.5299 17.4964 19 16.8751 19H7.1251C6.50378 19 6.0001 18.5299 6.0001 17.95Z", fill: "inherit" })), ec = V(J7), tc = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 17.75C4 17.3358 4.33579 17 4.75 17H15.25C15.6642 17 16 17.3358 16 17.75C16 18.1642 15.6642 18.5 15.25 18.5H4.75C4.33579 18.5 4 18.1642 4 17.75Z", fill: "inherit" }), /* @__PURE__ */ o.createElement("path", { d: "M10.7493 2.72581C10.7493 2.32495 10.4138 2 9.99999 2C9.58614 2 9.25066 2.32495 9.25066 2.72581L9.25065 12.4478L5.28033 8.47751C4.98744 8.18462 4.51256 8.18462 4.21967 8.47751C3.92678 8.7704 3.92678 9.24528 4.21967 9.53817L9.46499 14.7835C9.75789 15.0764 10.2328 15.0764 10.5257 14.7835L15.7815 9.52765C16.0744 9.23475 16.0744 8.75988 15.7815 8.46698C15.4886 8.17409 15.0137 8.17409 14.7209 8.46698L10.7493 12.4385L10.7493 2.72581Z", fill: "inherit" })), nc = V(tc), rc = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M21 22C21.5523 22 22 22.4477 22 23C22 23.5523 21.5523 24 21 24H7C6.44772 24 6 23.5523 6 23C6 22.4477 6.44772 22 7 22H21ZM14 2C14.5523 2 15 2.44772 15 3V16.585L20.2929 11.2929C20.6834 10.9024 21.3166 10.9024 21.7071 11.2929C22.0976 11.6834 22.0976 12.3166 21.7071 12.7071L14.7071 19.7071C14.3166 20.0976 13.6834 20.0976 13.2929 19.7071L6.29289 12.7071C5.90237 12.3166 5.90237 11.6834 6.29289 11.2929C6.68342 10.9024 7.31658 10.9024 7.70711 11.2929L13 16.585V3C13 2.44772 13.4477 2 14 2Z" })), ac = V(rc), ic = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.125 2.05C9.125 1.4701 8.62132 1 8 1C7.37868 1 6.875 1.4701 6.875 2.05V7.21508L5.4205 5.85754C4.98116 5.44749 4.26884 5.44749 3.8295 5.85754C3.39017 6.26759 3.39017 6.93241 3.8295 7.34246L7.2045 10.4925C7.64384 10.9025 8.35616 10.9025 8.7955 10.4925L12.1705 7.34246C12.6098 6.93241 12.6098 6.26759 12.1705 5.85754C11.7312 5.44749 11.0188 5.44749 10.5795 5.85754L9.125 7.21508V2.05ZM3.125 12.9C2.50368 12.9 2 13.3701 2 13.95C2 14.5299 2.50368 15 3.125 15H12.875C13.4963 15 14 14.5299 14 13.95C14 13.3701 13.4963 12.9 12.875 12.9H3.125Z", fill: "inherit" })), oc = V(ic), sc = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { className: "svg-substrate", cx: 12, cy: 12, r: 11, fill: "transparent" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12.4674 5.6251L18.4951 9.07808C18.8172 9.26262 18.9996 9.60992 19 9.9684L18.9998 14.2343C18.9998 14.5709 18.7386 14.8437 18.4164 14.8437C18.0943 14.8437 17.8331 14.5709 17.8331 14.2343L17.8329 11.238L16.6663 11.9058L12.4979 14.3014C12.1896 14.4783 11.8105 14.4781 11.5023 14.3011L6.5 11.4272L5.50493 10.8592C5.03414 10.5895 4.86177 9.97213 5.11993 9.4803C5.20897 9.31065 5.34255 9.17111 5.50493 9.07808L11.5326 5.6251C11.8237 5.4583 12.1763 5.4583 12.4674 5.6251ZM12.4787 15.6664L16.6664 13.3849L16.6665 14.4374C16.6665 16.7129 14.5533 18.5 12 18.5C9.4467 18.5 7.3335 16.7129 7.3335 14.4374L7.3334 13.3818L11.5214 15.6662C11.8198 15.8289 12.1803 15.829 12.4787 15.6664Z", fill: "inherit" })), lc = V(sc), cc = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M14.4951 5.07808L8.46744 1.6251C8.17626 1.4583 7.82374 1.4583 7.53257 1.6251L1.50493 5.07808C1.34255 5.17111 1.20897 5.31065 1.11993 5.48029C0.861773 5.97213 1.03414 6.58947 1.50493 6.85916L2.5 7.42722L7.50227 10.3011C7.81051 10.4781 8.18957 10.4783 8.49794 10.3014L12.6663 7.90585L13.8329 7.23796L13.8331 10.2343C13.8331 10.5709 14.0943 10.8437 14.4164 10.8437C14.7386 10.8437 14.9998 10.5709 14.9998 10.2343L15 5.9684C14.9996 5.60992 14.8172 5.26262 14.4951 5.07808Z", fill: "inherit" }), /* @__PURE__ */ o.createElement("path", { d: "M12.6664 9.38487L8.4787 11.6664C8.1803 11.829 7.81975 11.8289 7.52143 11.6662L3.3334 9.38179L3.3335 10.4374C3.3335 12.7129 5.4467 14.5 8 14.5C10.5533 14.5 12.6665 12.7129 12.6665 10.4374L12.6664 9.38487Z", fill: "inherit" })), uc = V(cc), dc = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 28, height: 28, viewBox: "0 0 28 28", fill: "none", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M26.0741 19.0654C25.3626 21.0512 21.2711 26.6876 14.0852 26.6877C3.87997 26.6879 -2.45258 14.2442 4.00063 6.41039C13.8359 -5.52904 28.8544 5.93112 26.4875 15.4448", stroke: "#A7DD00", strokeWidth: 1.50373, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { d: "M10.6328 19.4307C11.4509 21.0501 15.365 22.3636 17.1774 19.4307H10.6328Z", stroke: "#A7DD00", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { d: "M7.86532 10.1047L9.998 11.9996L11.1725 9.72147", stroke: "#A7DD00", strokeWidth: 3, strokeLinecap: "round" }), /* @__PURE__ */ o.createElement("path", { d: "M17.1781 10.1051L19.002 12L20.4854 9.72197", stroke: "#A7DD00", strokeWidth: 3, strokeLinecap: "round" })), fc = V(dc), hc = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 129, height: 128, viewBox: "0 0 129 128", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M20.4352 29.4375C12.9588 38.9562 8.5 50.9574 8.5 64C8.5 94.9279 33.5721 120 64.5 120C95.4279 120 120.5 94.9279 120.5 64C120.5 33.0721 95.4279 8 64.5 8C51.8539 8 40.1868 12.1918 30.8125 19.2618", stroke: "#A7DD00", strokeWidth: 7, strokeLinecap: "round" }), /* @__PURE__ */ o.createElement("path", { d: "M44.7344 53.3232L46.3404 47.5286", stroke: "#A7DD00", strokeWidth: 7, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { d: "M54.8444 80.8046C57.9185 79.3994 68.0546 77.9525 73.8454 80.8046", stroke: "#A7DD00", strokeWidth: 7, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { d: "M79.25 49.6787L81.0822 56.2203", stroke: "#A7DD00", strokeWidth: 7, strokeLinecap: "round", strokeLinejoin: "round" })), pc = V(hc), mc = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M6.5597 3.09222C8.20067 2.25619 15.0441 -0.453344 20.2966 2.96039C29.7021 9.07335 28.1393 22.3513 18.6961 25.5212C4.30385 30.3524 -3.06056 14.2603 4.24191 5.88568", stroke: "#BBBDBE", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { d: "M8.28125 13.4463H9.08789", stroke: "#BBBDBE", strokeWidth: 3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { d: "M17.9609 13.4463H18.7676", stroke: "#BBBDBE", strokeWidth: 3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { d: "M16.4177 8.52627C16.4177 8.52627 17.5815 7.65454 18.8572 7.67912C20.1329 7.7037 20.8956 7.97272 20.8956 7.97272", stroke: "#BBBDBE", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { d: "M6.69655 10.3226C8.03701 10.2069 9.94798 10.3628 11.0367 11.3267", stroke: "#BBBDBE", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { d: "M11.521 19.9731C12.3775 19.5818 15.2013 19.179 16.8146 19.9731", stroke: "#BBBDBE", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })), Cc = V(mc), gc = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 129, height: 128, viewBox: "0 0 129 128", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M20.4352 29.4375C12.9588 38.9562 8.5 50.9574 8.5 64C8.5 94.9279 33.5721 120 64.5 120C95.4279 120 120.5 94.9279 120.5 64C120.5 33.0721 95.4279 8 64.5 8C51.8539 8 40.1868 12.1918 30.8125 19.2618", stroke: "#A7DD00", strokeWidth: 7, strokeLinecap: "round" }), /* @__PURE__ */ o.createElement("path", { d: "M39.5 63.625H43.875", stroke: "#A7DD00", strokeWidth: 7, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { d: "M86.375 63.625H90.75", stroke: "#A7DD00", strokeWidth: 7, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { d: "M78.239 44.7675C78.239 44.7675 82.6074 48.6599 87.7304 48.997C92.8534 49.334 96.0033 48.516 96.0033 48.516", stroke: "#A7DD00", strokeWidth: 7, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { d: "M28.4171 52.0707C34.1947 52.4956 42.4423 51.7957 47.171 47.8363", stroke: "#A7DD00", strokeWidth: 7, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { d: "M50.8965 89.7012C55.6225 89.7001 69.1995 89.7012 78.2751 89.7012", stroke: "#A7DD00", strokeWidth: 7, strokeLinecap: "round", strokeLinejoin: "round" })), vc = V(gc), wc = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 28, height: 29, viewBox: "0 0 28 29", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M12.2992 27.5901C10.4487 27.1239 3.26123 24.5731 1.48956 18.3284C-1.68296 7.14621 8.58833 -2.1501 18.1184 1.81375C32.6432 7.85502 27.42 25.4332 16.0123 26.9903", stroke: "#FC9700", strokeWidth: 1.61538, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { d: "M9.78125 10.625L10.0294 10.9205", stroke: "#FC9700", strokeWidth: 3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { d: "M18.1406 10.625L18.3888 10.9205", stroke: "#FC9700", strokeWidth: 3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { d: "M8.94531 18.1475C11.8433 18.1475 16.5288 18.1475 19.8112 18.1475", stroke: "#FC9700", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })), yc = V(wc), bc = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" }), /* @__PURE__ */ o.createElement("path", { d: "M8.72726 5.60604C8.72726 4.86966 9.29708 4.27271 9.99999 4.27271C10.7029 4.27271 11.2727 4.86966 11.2727 5.60604V9.69695C11.2727 10.4333 10.7029 11.0303 9.99999 11.0303C9.29708 11.0303 8.72726 10.4333 8.72726 9.69695V5.60604Z", fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M8.72726 14.3939C8.72726 13.6575 9.29708 13.0606 9.99999 13.0606C10.7029 13.0606 11.2727 13.6575 11.2727 14.3939C11.2727 15.1303 10.7029 15.7273 9.99999 15.7273C9.29708 15.7273 8.72726 15.1303 8.72726 14.3939Z", fill: "white" })), _c = V(bc), xc = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", { id: "Frame 2131327168" }, /* @__PURE__ */ o.createElement("g", { id: "Vector" }, /* @__PURE__ */ o.createElement("path", { d: "M5.72726 2.60604C5.72726 1.86966 6.29708 1.27271 6.99999 1.27271C7.7029 1.27271 8.27272 1.86966 8.27272 2.60604V6.69695C8.27272 7.43333 7.7029 8.03028 6.99999 8.03028C6.29708 8.03028 5.72726 7.43333 5.72726 6.69695V2.60604Z" }), /* @__PURE__ */ o.createElement("path", { d: "M5.72726 11.3939C5.72726 10.6575 6.29708 10.0606 6.99999 10.0606C7.7029 10.0606 8.27272 10.6575 8.27272 11.3939C8.27272 12.1303 7.7029 12.7273 6.99999 12.7273C6.29708 12.7273 5.72726 12.1303 5.72726 11.3939Z" })))), Lc = V(xc), Ec = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM10.69 6.76159C10.6892 6.80402 10.6919 6.85483 10.6973 6.95643L11.0355 13.3821C11.0523 13.7021 11.0607 13.8621 11.1284 13.9836C11.1879 14.0905 11.2787 14.1767 11.3887 14.2305C11.5135 14.2917 11.6757 14.2917 12 14.2917C12.3243 14.2917 12.4865 14.2917 12.6113 14.2305C12.7213 14.1767 12.8121 14.0905 12.8716 13.9836C12.9393 13.8621 12.9477 13.7021 12.9645 13.3821L13.3027 6.95643C13.3081 6.85483 13.3108 6.80402 13.31 6.76159C13.2987 6.1402 12.8149 5.63024 12.195 5.58633C12.1526 5.58333 12.1017 5.58333 12 5.58333C11.8983 5.58333 11.8474 5.58333 11.805 5.58633C11.1851 5.63024 10.7013 6.1402 10.69 6.76159ZM12 15.6667C11.2406 15.6667 10.625 16.2823 10.625 17.0417C10.625 17.8011 11.2406 18.4167 12 18.4167C12.7594 18.4167 13.375 17.8011 13.375 17.0417C13.375 16.2823 12.7594 15.6667 12 15.6667Z" })), Mc = V(Ec), kc = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 0.667969C8.91286 0.667969 8.04798 1.57956 8.10512 2.6652L8.59659 12.0031C8.6155 12.3624 8.62495 12.5421 8.67962 12.6872C8.78756 12.9737 9.02078 13.1949 9.31255 13.2877C9.46034 13.3346 9.64023 13.3346 10 13.3346C10.3598 13.3346 10.5397 13.3346 10.6875 13.2877C10.9792 13.1949 11.2124 12.9737 11.3204 12.6872C11.375 12.5421 11.3845 12.3624 11.4034 12.0031L11.8949 2.6652C11.952 1.57956 11.0871 0.667969 10 0.667969ZM10 15.3346C8.89543 15.3346 8 16.2301 8 17.3346C8 18.4392 8.89543 19.3346 10 19.3346C11.1046 19.3346 12 18.4392 12 17.3346C12 16.2301 11.1046 15.3346 10 15.3346Z", fill: "currentColor" })), Sc = V(kc), Ac = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.14641 3.63436C5.90856 3.22676 6.65822 3.1001 8.22787 3.1001H10.1001C10.5971 3.1001 11.0001 3.50304 11.0001 4.0001C11.0001 4.49715 10.5971 4.9001 10.1001 4.9001H8.22787C6.7412 4.9001 6.35727 5.02804 5.99528 5.22163C5.65944 5.40124 5.40124 5.65944 5.22163 5.99528C5.02804 6.35727 4.9001 6.7412 4.9001 8.22787V15.7723C4.9001 17.259 5.02804 17.6429 5.22163 18.0049C5.40124 18.3408 5.65944 18.599 5.99528 18.7786C6.35727 18.9722 6.7412 19.1001 8.22787 19.1001H15.7723C17.259 19.1001 17.6429 18.9722 18.0049 18.7786C18.3408 18.599 18.599 18.3408 18.7786 18.0049C18.9722 17.6429 19.1001 17.259 19.1001 15.7723V13.9001C19.1001 13.403 19.503 13.0001 20.0001 13.0001C20.4972 13.0001 20.9001 13.403 20.9001 13.9001V15.7723C20.9001 17.342 20.7734 18.0916 20.3658 18.8538C20.0185 19.5033 19.5033 20.0185 18.8538 20.3658C18.0916 20.7734 17.342 20.9001 15.7723 20.9001H8.22787C6.65822 20.9001 5.90856 20.7734 5.14641 20.3658C4.49687 20.0185 3.98174 19.5033 3.63436 18.8538C3.22676 18.0916 3.1001 17.342 3.1001 15.7723V8.22787C3.1001 6.65822 3.22676 5.90856 3.63436 5.14641C3.98174 4.49687 4.49687 3.98174 5.14641 3.63436Z" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.0001 4.0001C14.0001 3.50304 14.403 3.1001 14.9001 3.1001H20.0001C20.4972 3.1001 20.9001 3.50304 20.9001 4.0001V9.1001C20.9001 9.59715 20.4972 10.0001 20.0001 10.0001C19.5031 10.0001 19.1001 9.59715 19.1001 9.1001V6.17289L12.5365 12.7365C12.185 13.088 11.6152 13.088 11.2637 12.7365C10.9123 12.385 10.9123 11.8152 11.2637 11.4637L17.8273 4.9001H14.9001C14.403 4.9001 14.0001 4.49715 14.0001 4.0001Z" })), Tc = V(Ac), Ic = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM15.3143 7.08594C15.3143 7.08594 21.2186 9.31451 18.8267 16.0002C18.8267 16.0002 22.1715 15.0145 22.1715 12.2288C22.1715 12.2288 28.2812 19.0859 19.4247 24.9145C19.4247 24.9145 14.6286 23.2859 14.6286 17.7145C14.6286 17.7145 10.8653 19.7717 13.2572 24.2288C13.2572 24.2288 7.77148 22.6859 7.77148 18.2288C7.77148 16.5574 8.06303 14.8859 11.0529 12.6574C11.417 12.386 11.7912 12.1391 12.1595 11.8961C13.7951 10.8169 15.3143 9.81446 15.3143 7.08594Z", fill: "white" })), Rc = V(Ic), Nc = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.5339 11.9998C18.5238 3.64265 11.1434 0.856934 11.1434 0.856934C11.1434 5.03551 8.29302 5.97544 5.81667 7.82122C2.07928 10.6069 1.71484 12.6962 1.71484 14.7855C1.71484 20.3569 8.57199 22.2855 8.57199 22.2855C5.58207 16.7141 10.2863 14.1426 10.2863 14.1426C10.2863 21.1069 16.2814 23.1426 16.2814 23.1426C27.352 15.8569 19.7148 7.28551 19.7148 7.28551C19.7148 10.7676 15.5339 11.9998 15.5339 11.9998Z" })), Hc = V(Nc), Oc = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { className: "svg-substrate", cx: 12, cy: 12, r: 11, fill: "transparent" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM11.1721 18.1578C10.0852 19.3303 9.47761 18.9976 9.88229 17.3916L10.7522 13.9062C10.7534 13.9014 10.7545 13.8966 10.7553 13.8917C10.7784 13.7648 10.6928 13.6436 10.564 13.6208L8.46031 13.2493C6.97386 12.9941 6.29748 11.975 7.58261 10.5698C8.16899 9.9578 8.59429 9.50756 8.85851 9.2191C9.61636 8.39175 10.7242 7.16828 12.1819 5.54869C13.1965 4.4034 13.8729 4.69608 13.467 6.31221L12.6199 9.75615C12.6189 9.76028 12.618 9.76444 12.6172 9.76862C12.5934 9.89533 12.6784 10.0171 12.807 10.0405L15.0082 10.4422C16.5295 10.6974 16.794 11.7182 15.7377 12.9886L11.1721 18.1578Z", fill: "inherit" })), jc = V(Oc), Pc = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M5.88226 13.3916C5.47759 14.9976 6.08516 15.3303 7.17207 14.1578L11.7377 8.9886C12.794 7.71815 12.5294 6.69741 11.0082 6.44223L8.80693 6.04054C8.67834 6.01707 8.59339 5.89533 8.61721 5.76861C8.618 5.76443 8.6189 5.76027 8.61991 5.75614L9.46702 2.3122C9.87283 0.696076 9.19646 0.403397 8.1819 1.54868C6.72414 3.16827 5.61633 4.39175 4.85848 5.2191C4.59426 5.50755 4.16896 5.95779 3.58258 6.56982C2.29746 7.97499 2.97383 8.99407 4.46028 9.24925L6.56402 9.62085C6.69275 9.64358 6.7784 9.76484 6.75532 9.89169C6.75443 9.89657 6.75339 9.90143 6.75218 9.90624L5.88226 13.3916Z", fill: "inherit" })), Dc = V(Pc), Vc = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.67452 5.0001C9.2113 5.0001 9.3167 5.00653 9.40502 5.02773C9.50706 5.05223 9.6046 5.09263 9.69407 5.14746C9.77152 5.19492 9.85059 5.26491 10.2302 5.64447L11.3556 6.76995L11.4145 6.82889C11.702 7.11688 11.9554 7.37079 12.2609 7.55802C12.5293 7.72251 12.822 7.84372 13.1281 7.91721C13.4765 8.00087 13.8353 8.00053 14.2422 8.00015L14.3255 8.0001H19.4C20.3966 8.0001 21.0839 8.00088 21.6174 8.04447C22.1392 8.0871 22.4251 8.16565 22.635 8.27259C23.1054 8.51227 23.4878 8.89472 23.7275 9.36513C23.8776 9.65976 23.962 10.0788 23.988 11.0276C24.0032 11.5796 24.463 12.0149 25.0151 11.9997C25.5672 11.9846 26.0024 11.5247 25.9873 10.9726C25.9605 9.99842 25.8792 9.18258 25.5095 8.45714C25.0781 7.61041 24.3897 6.922 23.543 6.49057C23.0041 6.21603 22.4257 6.10384 21.7802 6.05111C21.1557 6.00008 20.3864 6.00009 19.4421 6.0001L14.3255 6.0001C13.7887 6.0001 13.6833 5.99367 13.595 5.97247C13.4929 5.94798 13.3954 5.90757 13.3059 5.85274C13.2285 5.80528 13.1494 5.7353 12.7698 5.35574L11.6444 4.23025L11.5855 4.1713C11.298 3.88332 11.0446 3.62941 10.7391 3.44218C10.4707 3.2777 10.178 3.15648 9.87191 3.08299C9.52347 2.99934 9.16472 2.99967 8.75782 3.00005L8.67452 3.0001L8.55785 3.0001C7.61355 3.00009 6.84431 3.00008 6.21978 3.05111C5.5743 3.10384 4.99586 3.21603 4.45704 3.49057C3.61031 3.922 2.9219 4.61041 2.49047 5.45714C2.21593 5.99596 2.10374 6.5744 2.05101 7.21988C1.99998 7.8444 1.99999 8.61364 2 9.55793V17.4423C1.99999 18.3865 1.99998 19.1558 2.05101 19.7803C2.10374 20.4258 2.21593 21.0042 2.49047 21.5431C2.9219 22.3898 3.61031 23.0782 4.45704 23.5096C4.99586 23.7842 5.5743 23.8964 6.21978 23.9491C6.8443 24.0001 7.61354 24.0001 8.55783 24.0001H18C18.5523 24.0001 19 23.5524 19 23.0001C19 22.4478 18.5523 22.0001 18 22.0001H8.6C7.60341 22.0001 6.91611 21.9993 6.38264 21.9557C5.86085 21.9131 5.5749 21.8346 5.36502 21.7276C4.89462 21.4879 4.51217 21.1055 4.27248 20.6351C4.16555 20.4252 4.087 20.1393 4.04436 19.6175C4.00078 19.084 4 18.3967 4 17.4001V9.6001C4 8.60351 4.00078 7.91621 4.04436 7.38274C4.087 6.86095 4.16555 6.575 4.27248 6.36513C4.51217 5.89472 4.89462 5.51227 5.36502 5.27259C5.5749 5.16565 5.86085 5.0871 6.38264 5.04447C6.91611 5.00088 7.60341 5.0001 8.6 5.0001H8.67452ZM21 24.0001C21 24.5524 21.4477 25.0001 22 25.0001C22.5523 25.0001 23 24.5524 23 24.0001L23 16.4143L25.2952 18.7096C25.6858 19.1001 26.3189 19.1001 26.7095 18.7096C27.1 18.319 27.1 17.6859 26.7095 17.2953L22.7071 13.293C22.3166 12.9025 21.6834 12.9025 21.2929 13.293L17.2955 17.2904C16.9049 17.6809 16.9049 18.3141 17.2955 18.7046C17.686 19.0952 18.3192 19.0952 18.7097 18.7046L21 16.4143L21 24.0001Z", fill: "#E4E9EC" })), Bc = V(Vc), Fc = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M11.066 22.2831H7.98336C6.02318 22.2831 5.04309 22.2831 4.2944 21.9016C3.63583 21.5661 3.1004 21.0306 2.76484 20.3721C2.38336 19.6234 2.38336 18.6433 2.38336 16.6831V10.0461C2.38336 8.18369 2.38336 7.25248 2.72871 6.53383C3.07301 5.81737 3.65093 5.23945 4.36738 4.89516C5.08604 4.5498 6.01725 4.5498 7.87967 4.5498C8.25124 4.5498 8.43703 4.5498 8.61393 4.58674C8.79133 4.62377 8.9619 4.68813 9.11954 4.77752C9.27674 4.86666 9.41621 4.9894 9.69516 5.23487L11.0402 6.41845C11.3336 6.67671 11.4804 6.80583 11.6468 6.89787C11.7944 6.9795 11.953 7.03936 12.1178 7.07559C12.3035 7.11644 12.499 7.11644 12.8899 7.11644H18.0167C19.9769 7.11644 20.9569 7.11644 21.7056 7.49792C22.3642 7.83348 22.8996 8.36891 23.2352 9.02748C23.4921 9.5316 23.5754 9.92696 23.6028 10.8695", stroke: "white", strokeWidth: 1.8, strokeLinecap: "round" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.5 14H18.6429C15.1607 14 14 16.8421 14 19.6842C14 21.3421 14.4643 23 15.8571 23C16.4651 23 16.8077 22.5036 17.1938 21.9442C17.6923 21.222 18.2633 20.3947 19.5714 20.3947H20.5H20.5H21.4286C22.7367 20.3947 23.3077 21.222 23.8062 21.9442C24.1923 22.5036 24.5349 23 25.1429 23C26.5357 23 27 21.3421 27 19.6842C27 16.8421 25.8393 14 22.3571 14H20.5H20.5ZM22.3571 17.7895C22.3571 17.5279 22.565 17.3158 22.8214 17.3158H24.6786C24.935 17.3158 25.1429 17.5279 25.1429 17.7895C25.1429 18.0511 24.935 18.2632 24.6786 18.2632H22.8214C22.565 18.2632 22.3571 18.0511 22.3571 17.7895ZM16.7857 16.8421C16.7857 16.5805 16.9936 16.3684 17.25 16.3684C17.5064 16.3684 17.7143 16.5805 17.7143 16.8421V17.3158H18.1786C18.435 17.3158 18.6429 17.5279 18.6429 17.7895C18.6429 18.0511 18.435 18.2632 18.1786 18.2632H17.7143V18.7368C17.7143 18.9985 17.5064 19.2105 17.25 19.2105C16.9936 19.2105 16.7857 18.9985 16.7857 18.7368V18.2632H16.3214C16.065 18.2632 15.8571 18.0511 15.8571 17.7895C15.8571 17.5279 16.065 17.3158 16.3214 17.3158H16.7857V16.8421Z", fill: "#E4E9EC" })), Zc = V(Fc), Gc = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { className: "svg-substrate", cx: 12, cy: 12, r: 11, fill: "transparent" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM18.9999 14.3333C18.9999 12.5833 18.7082 7.33334 15.4999 7.33334H8.4999C5.29156 7.33334 4.9999 12.5833 4.9999 14.3333C4.9999 16.0833 5.29156 16.6667 6.45823 16.6667C7.11293 16.6667 7.74162 15.7901 8.31933 14.9846C8.81035 14.3 9.26454 13.6667 9.66656 13.6667H14.3361C14.7386 13.6667 15.194 14.3016 15.6859 14.9872C16.2632 15.792 16.8906 16.6667 17.5416 16.6667C18.7082 16.6667 18.9999 16.0833 18.9999 14.3333ZM8.83607 8.83334H9.00274L9.06265 8.83871C9.21815 8.86693 9.33607 9.00303 9.33607 9.16667L9.3359 10H10.1694C10.3535 10 10.5027 10.1492 10.5027 10.3333V10.5L10.4974 10.5599C10.4691 10.7154 10.333 10.8333 10.1694 10.8333H9.3359L9.33607 11.6667C9.33607 11.8508 9.18683 12 9.00274 12H8.83607L8.77615 11.9946C8.62065 11.9664 8.50274 11.8303 8.50274 11.6667L8.50256 10.8333H7.6694C7.48531 10.8333 7.33607 10.6841 7.33607 10.5V10.3333L7.34144 10.2734C7.36967 10.1179 7.50576 10 7.6694 10H8.50256L8.50274 9.16667C8.50274 8.98258 8.65198 8.83334 8.83607 8.83334ZM15.0027 11.1667H15.1694C15.3535 11.1667 15.5027 11.3159 15.5027 11.5V11.6667C15.5027 11.8508 15.3535 12 15.1694 12H15.0027C14.8186 12 14.6694 11.8508 14.6694 11.6667V11.5C14.6694 11.3159 14.8186 11.1667 15.0027 11.1667ZM13.8361 10H14.0027C14.1868 10 14.3361 10.1492 14.3361 10.3333V10.5C14.3361 10.6841 14.1868 10.8333 14.0027 10.8333H13.8361C13.652 10.8333 13.5027 10.6841 13.5027 10.5V10.3333C13.5027 10.1492 13.652 10 13.8361 10ZM16.1694 10H16.3361C16.5202 10 16.6694 10.1492 16.6694 10.3333V10.5C16.6694 10.6841 16.5202 10.8333 16.3361 10.8333H16.1694C15.9853 10.8333 15.8361 10.6841 15.8361 10.5V10.3333C15.8361 10.1492 15.9853 10 16.1694 10ZM15.0027 8.83334H15.1694C15.3535 8.83334 15.5027 8.98258 15.5027 9.16667V9.33334C15.5027 9.51744 15.3535 9.66667 15.1694 9.66667H15.0027C14.8186 9.66667 14.6694 9.51744 14.6694 9.33334V9.16667C14.6694 8.98258 14.8186 8.83334 15.0027 8.83334Z", fill: "inherit" })), Wc = V(Gc), Uc = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.8001 4.7998H12.0001H10.2001C7.41981 4.7998 5.106 5.31699 3.50716 6.91311C1.91225 8.5053 1.22461 10.9757 1.20013 14.3934C1.19326 15.3531 1.26537 16.7726 1.74627 17.9822C1.99053 18.5965 2.35915 19.2057 2.92275 19.6638C3.50096 20.1337 4.23012 20.3998 5.10011 20.3998C6.05884 20.3998 6.74794 20.0076 7.27312 19.4761C7.64618 19.0986 7.96794 18.6089 8.239 18.1964L8.23901 18.1964C8.3066 18.0936 8.37104 17.9955 8.43234 17.9052C8.77313 17.4029 9.09902 16.9944 9.53111 16.6993C9.94414 16.4172 10.5135 16.1998 11.4001 16.1998H12.0001H12.6001C13.4867 16.1998 14.0561 16.4172 14.4691 16.6993C14.9012 16.9944 15.2271 17.4029 15.5679 17.9052C15.6292 17.9955 15.6936 18.0936 15.7612 18.1964L15.7612 18.1964L15.7612 18.1965L15.7612 18.1965L15.7613 18.1965C16.0323 18.609 16.354 19.0986 16.7271 19.4761C17.2523 20.0076 17.9414 20.3998 18.9001 20.3998C19.7701 20.3998 20.4993 20.1337 21.0775 19.6638C21.6411 19.2057 22.0097 18.5965 22.2539 17.9822C22.7348 16.7726 22.807 15.3531 22.8001 14.3934C22.7756 10.9757 22.088 8.5053 20.4931 6.91311C18.8942 5.31699 16.5804 4.7998 13.8001 4.7998ZM12.6001 14.3998H12.0001H11.4001C10.1867 14.3998 9.25608 14.7074 8.51598 15.2128C7.79495 15.7052 7.31459 16.3467 6.94288 16.8945C6.84357 17.0408 6.75462 17.1755 6.67232 17.3001L6.6723 17.3002C6.41868 17.6842 6.2283 17.9726 5.99273 18.211C5.73978 18.467 5.49138 18.5998 5.10011 18.5998C4.6201 18.5998 4.29758 18.4616 4.05808 18.267C3.80397 18.0604 3.58883 17.7445 3.41892 17.3171C3.07148 16.4433 2.99359 15.3128 3.00009 14.4063C3.02335 11.1579 3.68572 9.27827 4.77887 8.18698C5.8681 7.09961 7.58041 6.5998 10.2001 6.5998H12.0001H13.8001C16.4198 6.5998 18.1321 7.09961 19.2213 8.18698C20.3145 9.27827 20.9769 11.1579 21.0001 14.4063C21.0066 15.3128 20.9287 16.4433 20.5813 17.3171C20.4114 17.7445 20.1962 18.0604 19.9421 18.267C19.7026 18.4616 19.3801 18.5998 18.9001 18.5998C18.5088 18.5998 18.2604 18.467 18.0075 18.211C17.7719 17.9726 17.5815 17.6843 17.3279 17.3002L17.3279 17.3002L17.3279 17.3001L17.3278 17.3C17.2455 17.1754 17.1566 17.0408 17.0573 16.8945C16.6856 16.3467 16.2053 15.7052 15.4842 15.2128C14.7441 14.7074 13.8135 14.3998 12.6001 14.3998ZM8.7 8.9998C8.7 8.50275 8.29706 8.0998 7.8 8.0998C7.30294 8.0998 6.9 8.50275 6.9 8.9998V9.8998H6C5.50294 9.8998 5.1 10.3027 5.1 10.7998C5.1 11.2969 5.50294 11.6998 6 11.6998H6.9V12.5998C6.9 13.0969 7.30294 13.4998 7.8 13.4998C8.29706 13.4998 8.7 13.0969 8.7 12.5998V11.6998H9.6C10.0971 11.6998 10.5 11.2969 10.5 10.7998C10.5 10.3027 10.0971 9.8998 9.6 9.8998H8.7V8.9998ZM15 9.8998C14.5029 9.8998 14.1 10.3027 14.1 10.7998C14.1 11.2969 14.5029 11.6998 15 11.6998H17.4C17.8971 11.6998 18.3 11.2969 18.3 10.7998C18.3 10.3027 17.8971 9.8998 17.4 9.8998H15Z", fill: "inherit" })), zc = V(Uc), qc = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { id: "â³ Icon Color", d: "M18 5C24.3714 5 27 9.96513 27 16C27 20.4811 25.7404 23 23 23C21.8591 23 21.1032 22.5189 20.2418 21.5066L20.0789 21.3106C19.987 21.1975 19.627 20.7421 19.5364 20.6306L19.3798 20.4421C18.5017 19.4108 17.7721 19 16.5 19H11.5C10.2279 19 9.49826 19.4108 8.62024 20.4421L8.46361 20.6306C8.37298 20.7421 8.01296 21.1975 7.92108 21.3106L7.75821 21.5066C6.89678 22.5189 6.14092 23 5 23C2.25929 23 1 20.4814 1 16C1 9.96513 3.6286 5 10 5H18ZM18 7H10C5.07728 7 3 10.9238 3 16C3 19.5186 3.74071 21 5 21C5.42046 21 5.73067 20.8059 6.23779 20.2076L6.79499 19.5146L7.08767 19.1572C8.32064 17.7074 9.54425 17 11.5 17H16.5C18.4558 17 19.6794 17.7074 20.9123 19.1572L21.0886 19.3694L21.7622 20.2076C22.2693 20.8059 22.5795 21 23 21C24.2591 21 25 19.5183 25 16C25 10.9238 22.9227 7 18 7ZM9.51227 9.5C9.70349 9.5 9.86037 9.53713 9.99074 9.60685C10.1211 9.67658 10.2234 9.77889 10.2931 9.90926C10.3629 10.0396 10.4 10.1965 10.4 10.3877L10.399 11.599L11.6123 11.6C11.8035 11.6 11.9604 11.6371 12.0907 11.7069C12.2211 11.7766 12.3234 11.8789 12.3931 12.0093C12.4629 12.1396 12.5 12.2965 12.5 12.4877V12.5123C12.5 12.7035 12.4629 12.8604 12.3931 12.9907C12.3234 13.1211 12.2211 13.2234 12.0907 13.2931C11.9604 13.3629 11.8035 13.4 11.6123 13.4L10.399 13.399L10.4 14.6123C10.4 14.8035 10.3629 14.9604 10.2931 15.0907C10.2234 15.2211 10.1211 15.3234 9.99074 15.3931C9.86037 15.4629 9.70349 15.5 9.51227 15.5H9.48773C9.29651 15.5 9.13963 15.4629 9.00926 15.3931C8.87889 15.3234 8.77658 15.2211 8.70685 15.0907C8.63713 14.9604 8.6 14.8035 8.6 14.6123L8.599 13.399L7.38773 13.4C7.19651 13.4 7.03963 13.3629 6.90926 13.2931C6.77889 13.2234 6.67658 13.1211 6.60685 12.9907C6.53713 12.8604 6.5 12.7035 6.5 12.5123V12.4877C6.5 12.2965 6.53713 12.1396 6.60685 12.0093C6.67658 11.8789 6.77889 11.7766 6.90926 11.7069C7.03963 11.6371 7.19651 11.6 7.38773 11.6L8.599 11.599L8.6 10.3877C8.6 10.1965 8.63713 10.0396 8.70685 9.90926C8.77658 9.77889 8.87889 9.67658 9.00926 9.60685C9.13963 9.53713 9.29651 9.5 9.48773 9.5H9.51227ZM18.5736 13.5C18.8112 13.5 18.9604 13.5371 19.0907 13.6069C19.2211 13.6766 19.3234 13.7789 19.3931 13.9093C19.4629 14.0396 19.5 14.1888 19.5 14.4264V14.5736C19.5 14.8112 19.4629 14.9604 19.3931 15.0907C19.3234 15.2211 19.2211 15.3234 19.0907 15.3931C18.9604 15.4629 18.8112 15.5 18.5736 15.5H18.4264C18.1888 15.5 18.0396 15.4629 17.9093 15.3931C17.7789 15.3234 17.6766 15.2211 17.6069 15.0907C17.5371 14.9604 17.5 14.8112 17.5 14.5736V14.4264C17.5 14.1888 17.5371 14.0396 17.6069 13.9093C17.6766 13.7789 17.7789 13.6766 17.9093 13.6069C18.0396 13.5371 18.1888 13.5 18.4264 13.5H18.5736ZM16.5736 11.5C16.8112 11.5 16.9604 11.5371 17.0907 11.6069C17.2211 11.6766 17.3234 11.7789 17.3931 11.9093C17.4629 12.0396 17.5 12.1888 17.5 12.4264V12.5736C17.5 12.8112 17.4629 12.9604 17.3931 13.0907C17.3234 13.2211 17.2211 13.3234 17.0907 13.3931C16.9604 13.4629 16.8112 13.5 16.5736 13.5H16.4264C16.1888 13.5 16.0396 13.4629 15.9093 13.3931C15.7789 13.3234 15.6766 13.2211 15.6069 13.0907C15.5371 12.9604 15.5 12.8112 15.5 12.5736V12.4264C15.5 12.1888 15.5371 12.0396 15.6069 11.9093C15.6766 11.7789 15.7789 11.6766 15.9093 11.6069C16.0396 11.5371 16.1888 11.5 16.4264 11.5H16.5736ZM20.5736 11.5C20.8112 11.5 20.9604 11.5371 21.0907 11.6069C21.2211 11.6766 21.3234 11.7789 21.3931 11.9093C21.4629 12.0396 21.5 12.1888 21.5 12.4264V12.5736C21.5 12.8112 21.4629 12.9604 21.3931 13.0907C21.3234 13.2211 21.2211 13.3234 21.0907 13.3931C20.9604 13.4629 20.8112 13.5 20.5736 13.5H20.4264C20.1888 13.5 20.0396 13.4629 19.9093 13.3931C19.7789 13.3234 19.6766 13.2211 19.6069 13.0907C19.5371 12.9604 19.5 12.8112 19.5 12.5736V12.4264C19.5 12.1888 19.5371 12.0396 19.6069 11.9093C19.6766 11.7789 19.7789 11.6766 19.9093 11.6069C20.0396 11.5371 20.1888 11.5 20.4264 11.5H20.5736ZM18.5736 9.5C18.8112 9.5 18.9604 9.53713 19.0907 9.60685C19.2211 9.67658 19.3234 9.77889 19.3931 9.90926C19.4629 10.0396 19.5 10.1888 19.5 10.4264V10.5736C19.5 10.8112 19.4629 10.9604 19.3931 11.0907C19.3234 11.2211 19.2211 11.3234 19.0907 11.3931C18.9604 11.4629 18.8112 11.5 18.5736 11.5H18.4264C18.1888 11.5 18.0396 11.4629 17.9093 11.3931C17.7789 11.3234 17.6766 11.2211 17.6069 11.0907C17.5371 10.9604 17.5 10.8112 17.5 10.5736V10.4264C17.5 10.1888 17.5371 10.0396 17.6069 9.90926C17.6766 9.77889 17.7789 9.67658 17.9093 9.60685C18.0396 9.53713 18.1888 9.5 18.4264 9.5H18.5736Z" })), $c = V(qc), Yc = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M11.5 3.33334C14.7083 3.33334 15 8.58334 15 10.3333C15 12.0833 14.7083 12.6667 13.5417 12.6667C12.3362 12.6667 11.2112 9.66668 10.3362 9.66668H5.66667C4.79167 9.66668 3.66951 12.6667 2.45833 12.6667C1.29167 12.6667 1 12.0833 1 10.3333C1 8.58334 1.29167 3.33334 4.5 3.33334H11.5ZM5.00284 4.83334H4.83618C4.65208 4.83334 4.50284 4.98258 4.50284 5.16668L4.50267 6.00001H3.66951C3.50587 6.00001 3.36977 6.11793 3.34155 6.27343L3.33618 6.33334V6.50001C3.33618 6.6841 3.48541 6.83334 3.66951 6.83334H4.50267L4.50284 7.66668C4.50284 7.83032 4.62076 7.96642 4.77626 7.99464L4.83618 8.00001H5.00284C5.18694 8.00001 5.33618 7.85077 5.33618 7.66668L5.336 6.83334H6.16951C6.33315 6.83334 6.46925 6.71543 6.49747 6.55993L6.50284 6.50001V6.33334C6.50284 6.14925 6.3536 6.00001 6.16951 6.00001H5.336L5.33618 5.16668C5.33618 5.00304 5.21826 4.86694 5.06276 4.83871L5.00284 4.83334ZM11.1695 7.16668H11.0028C10.8187 7.16668 10.6695 7.31592 10.6695 7.50001V7.66668C10.6695 7.85077 10.8187 8.00001 11.0028 8.00001H11.1695C11.3536 8.00001 11.5028 7.85077 11.5028 7.66668V7.50001C11.5028 7.31592 11.3536 7.16668 11.1695 7.16668ZM10.0028 6.00001H9.83618C9.65208 6.00001 9.50284 6.14925 9.50284 6.33334V6.50001C9.50284 6.6841 9.65208 6.83334 9.83618 6.83334H10.0028C10.1869 6.83334 10.3362 6.6841 10.3362 6.50001V6.33334C10.3362 6.14925 10.1869 6.00001 10.0028 6.00001ZM12.3362 6.00001H12.1695C11.9854 6.00001 11.8362 6.14925 11.8362 6.33334V6.50001C11.8362 6.6841 11.9854 6.83334 12.1695 6.83334H12.3362C12.5203 6.83334 12.6695 6.6841 12.6695 6.50001V6.33334C12.6695 6.14925 12.5203 6.00001 12.3362 6.00001ZM11.1695 4.83334H11.0028C10.8187 4.83334 10.6695 4.98258 10.6695 5.16668V5.33334C10.6695 5.51744 10.8187 5.66668 11.0028 5.66668H11.1695C11.3536 5.66668 11.5028 5.51744 11.5028 5.33334V5.16668C11.5028 4.98258 11.3536 4.83334 11.1695 4.83334Z", fill: "inherit" })), Kc = V(Yc), Qc = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { cx: 8, cy: 8, r: 8, fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M10.4 4.7998C12.6 4.7998 12.8 8.3998 12.8 9.5998C12.8 10.7998 12.6 11.1998 11.8 11.1998C10.9733 11.1998 10.2019 9.14266 9.6019 9.14266H6.39995C5.79995 9.14266 5.03047 11.1998 4.19995 11.1998C3.39995 11.1998 3.19995 10.7998 3.19995 9.5998C3.19995 8.3998 3.39995 4.7998 5.59995 4.7998H10.4ZM5.94476 5.82838H5.83047C5.70424 5.82838 5.6019 5.93071 5.6019 6.05695L5.60178 6.62838H5.03047C4.91826 6.62838 4.82494 6.70923 4.80558 6.81586L4.8019 6.85695V6.97123C4.8019 7.09747 4.90424 7.1998 5.03047 7.1998H5.60178L5.6019 7.77123C5.6019 7.88344 5.68276 7.97677 5.78939 7.99612L5.83047 7.99981H5.94476C6.07099 7.99981 6.17333 7.89747 6.17333 7.77123L6.17321 7.1998H6.74476C6.85697 7.1998 6.95029 7.11895 6.96965 7.01232L6.97333 6.97123V6.85695C6.97333 6.73071 6.87099 6.62838 6.74476 6.62838H6.17321L6.17333 6.05695C6.17333 5.94474 6.09247 5.85141 5.98584 5.83206L5.94476 5.82838ZM10.1733 7.42838H10.059C9.93281 7.42838 9.83047 7.53071 9.83047 7.65695V7.77123C9.83047 7.89747 9.93281 7.99981 10.059 7.99981H10.1733C10.2996 7.99981 10.4019 7.89747 10.4019 7.77123V7.65695C10.4019 7.53071 10.2996 7.42838 10.1733 7.42838ZM9.37333 6.62838H9.25904C9.13281 6.62838 9.03047 6.73071 9.03047 6.85695V6.97123C9.03047 7.09747 9.13281 7.1998 9.25904 7.1998H9.37333C9.49957 7.1998 9.6019 7.09747 9.6019 6.97123V6.85695C9.6019 6.73071 9.49957 6.62838 9.37333 6.62838ZM10.9733 6.62838H10.859C10.7328 6.62838 10.6305 6.73071 10.6305 6.85695V6.97123C10.6305 7.09747 10.7328 7.1998 10.859 7.1998H10.9733C11.0996 7.1998 11.2019 7.09747 11.2019 6.97123V6.85695C11.2019 6.73071 11.0996 6.62838 10.9733 6.62838ZM10.1733 5.82838H10.059C9.93281 5.82838 9.83047 5.93071 9.83047 6.05695V6.17123C9.83047 6.29747 9.93281 6.3998 10.059 6.3998H10.1733C10.2996 6.3998 10.4019 6.29747 10.4019 6.17123V6.05695C10.4019 5.93071 10.2996 5.82838 10.1733 5.82838Z", fill: "inherit" })), Xc = V(Qc), Jc = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { id: "â³ Icon Color", d: "M16.9623 2.9494C18.5728 2.99954 19.62 3.88559 20.1722 5.55594L20.2597 5.84159L20.3273 6.09732C20.3519 6.19581 20.3826 6.30068 20.4185 6.40959L20.495 6.62207L20.5403 6.64474L20.6323 6.61434L20.8105 6.54609L21.0183 6.45565C22.9034 5.57806 24.3535 5.74093 25.5343 7.03856L25.7012 7.23167L26.7948 8.58701C27.7694 9.87014 27.7398 11.2416 26.7892 12.7219L26.6223 12.9696L26.4661 13.1832C26.4037 13.266 26.3402 13.3579 26.2769 13.4566L26.1824 13.6095L26.1376 13.6861L26.143 13.7127L26.2652 13.7934L26.4339 13.8953L26.6384 14.0064C28.4905 14.9516 29.255 16.1945 28.96 17.9213L28.9107 18.1713L28.5852 19.5822C28.3744 20.4953 28.2089 20.9276 27.5575 21.5207C26.9248 22.0969 26.2028 22.3348 25.2488 22.4137L24.9555 22.4328L24.6911 22.4412C24.5885 22.443 24.4782 22.4494 24.3628 22.4601L24.1216 22.4887L24.1392 22.6786L24.157 22.8063L24.2 23.0446C24.631 25.0789 24.1461 26.4552 22.6161 27.3138L22.3904 27.433L20.8238 28.1937C19.3544 28.8546 18.0247 28.5173 16.7962 27.2581L16.5923 27.0397L16.4194 26.8395C16.352 26.7592 16.276 26.6758 16.1931 26.5911L16.0639 26.4634L15.9976 26.4021L15.8754 26.5184L15.7354 26.6624L15.5785 26.8395C14.3086 28.351 12.9682 28.8936 11.3436 28.2617L11.1095 28.1635L9.70763 27.4821L9.29119 27.269C8.65645 26.9224 8.30024 26.5904 7.95216 25.8554C7.58571 25.0815 7.56109 24.3215 7.73873 23.3445L7.79796 23.0446C7.81917 22.9445 7.83772 22.836 7.85322 22.7214L7.87765 22.4927L7.87231 22.4874L7.73408 22.4689L7.53875 22.4514L7.30689 22.4412C5.22784 22.4036 3.99589 21.6215 3.5034 19.9376L3.43807 19.6908L3.04929 17.9933C2.73586 16.4128 3.36363 15.1931 4.86696 14.2793L5.12561 14.1298L5.35956 14.0064C5.45126 13.9596 5.54789 13.9053 5.64729 13.8448L5.85364 13.7101L5.85898 13.6847L5.77558 13.5409L5.66783 13.374L5.53185 13.1832C4.28149 11.5217 4.13931 10.0694 5.16308 8.64458L5.31727 8.4412L6.41562 7.08971C7.46809 5.86968 8.81574 5.61343 10.4613 6.2355L10.7384 6.3473L10.9797 6.45565C11.0705 6.49792 11.1698 6.53955 11.2755 6.57968L11.4563 6.6434L11.5043 6.62074L11.5491 6.50255L11.6093 6.31862L11.6706 6.09732C12.1495 4.18202 13.1163 3.10675 14.8564 2.96251L15.1103 2.94824L16.9623 2.9494ZM16.8876 5.34824H15.1103L14.9244 5.36186C14.543 5.41153 14.2939 5.6174 14.0542 6.47076L13.999 6.6794L13.9237 6.95375C13.7837 7.42377 13.5722 7.95269 13.2998 8.4662C12.7604 8.65949 12.2478 8.90905 11.77 9.21035C11.2077 9.09636 10.6715 8.92917 10.2241 8.74424L9.7574 8.53767C9.42552 8.39551 9.17695 8.32298 8.97996 8.30534L8.86771 8.30122C8.63089 8.30617 8.47453 8.40343 8.32347 8.55802L8.23288 8.65738L7.1807 9.95369L7.05442 10.1208C6.80989 10.4733 6.77331 10.7875 7.31424 11.5547L7.6185 11.9758C7.90104 12.3888 8.18435 12.8978 8.41567 13.4444C8.2431 13.9567 8.12101 14.4923 8.05558 15.0463C7.61042 15.4316 7.13607 15.7618 6.70405 16.0072L6.2477 16.2514C5.4252 16.7038 5.32032 17.0023 5.38561 17.4262L5.40345 17.5264L5.77717 19.1536L5.83114 19.356C5.95831 19.7657 6.18343 19.988 7.12101 20.0341L7.63746 20.0534C8.13206 20.0845 8.70141 20.1732 9.26825 20.3252C9.56795 20.7906 9.91459 21.2228 10.3031 21.6151C10.3253 22.3173 10.2603 23.0017 10.1458 23.5421C9.87769 24.8076 10.1273 25.0114 10.6572 25.2747L12.1586 26.0049C12.3177 26.0764 12.4599 26.1247 12.6076 26.1228L12.6971 26.1154C12.9385 26.0785 13.2057 25.8996 13.5909 25.4691L13.9346 25.0759C14.2769 24.7042 14.7141 24.31 15.1993 23.9599L15.5966 23.9895L15.999 23.9994L16.4014 23.9893L16.7989 23.9588C17.2839 24.3098 17.7211 24.7042 18.0634 25.0759L18.4071 25.4691C18.8403 25.9535 19.1244 26.1193 19.3903 26.1228L19.4785 26.1181C19.5566 26.109 19.6344 26.0872 19.7153 26.0566L19.8394 26.0049L21.3408 25.2747L21.5259 25.1766C21.925 24.9439 22.0868 24.6494 21.8521 23.5421C21.7376 23.0017 21.6727 22.3173 21.6965 21.6153C22.0834 21.2228 22.43 20.7906 22.73 20.323C23.2973 20.1727 23.8664 20.0844 24.3607 20.0534L24.8769 20.0341C25.9588 19.9809 26.0921 19.6931 26.2208 19.1536L26.5721 17.6318C26.6929 17.0905 26.6993 16.7734 25.7503 16.2514L25.2939 16.0072C24.8618 15.7617 24.3875 15.4314 23.9427 15.0452C23.8769 14.4923 23.7549 13.9567 23.5816 13.4433C23.8135 12.8976 24.0969 12.3888 24.3795 11.9758L24.6837 11.5547C25.2246 10.7875 25.1881 10.4733 24.9435 10.1208L24.8836 10.0386L23.8344 8.73991C23.6465 8.51139 23.4889 8.34779 23.2316 8.30956L23.1302 8.30122C22.9171 8.29676 22.6388 8.36708 22.2406 8.53767L21.7741 8.74415C21.327 8.92893 20.7913 9.09578 20.2295 9.20826C19.7498 8.9088 19.2361 8.65876 18.6955 8.46741C18.4361 7.97347 18.2311 7.46611 18.0914 7.01044L17.9401 6.45768C17.6843 5.5545 17.4171 5.38515 16.9893 5.3534L16.8876 5.34824ZM15.999 10.9327C18.7972 10.9327 21.0656 13.2012 21.0656 15.9994C21.0656 18.7976 18.7972 21.0661 15.999 21.0661C13.2007 21.0661 10.9323 18.7976 10.9323 15.9994C10.9323 13.2012 13.2007 10.9327 15.999 10.9327ZM15.999 13.3327C14.5262 13.3327 13.3323 14.5266 13.3323 15.9994C13.3323 17.4722 14.5262 18.6661 15.999 18.6661C17.4717 18.6661 18.6656 17.4722 18.6656 15.9994C18.6656 14.5266 17.4717 13.3327 15.999 13.3327Z" })), eu = V(Jc), tu = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { className: "svg-substrate", cx: 12, cy: 12, r: 11, fill: "transparent" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM8.45905 5.43607C7.51487 6.38024 7.86894 8.97673 11.9997 8.97673C11.9997 4.84596 9.40322 4.49189 8.45905 5.43607ZM15.5404 5.43294C14.5962 4.48876 11.9997 4.84596 11.9997 8.97673C16.1305 8.97673 16.4845 6.37711 15.5404 5.43294ZM10.8453 14.1605C11.1368 14.1605 11.2425 14.1909 11.3491 14.2479C11.4557 14.3049 11.5393 14.3885 11.5963 14.4951C11.6533 14.6017 11.6837 14.7074 11.6837 14.9989V18.1616C11.6837 18.4532 11.6533 18.5589 11.5963 18.6654C11.5393 18.772 11.4557 18.8557 11.3491 18.9127C11.2425 18.9697 11.1368 19 10.8453 19H8.97871C8.39567 19 8.18424 18.9393 7.97109 18.8253C7.75794 18.7113 7.59066 18.544 7.47666 18.3309C7.36267 18.1177 7.30196 17.9063 7.30196 17.3233V14.9989C7.30196 14.7074 7.33232 14.6017 7.38931 14.4951C7.44631 14.3885 7.52995 14.3049 7.63653 14.2479C7.7431 14.1909 7.84881 14.1605 8.14033 14.1605H10.8453ZM12.6973 14.2228C12.8039 14.1658 12.9096 14.1355 13.2011 14.1355H15.9061C16.1976 14.1355 16.3033 14.1658 16.4099 14.2228C16.5164 14.2798 16.6001 14.3635 16.6571 14.47C16.7141 14.5766 16.7444 14.6823 16.7444 14.9738V17.2982C16.7444 17.8813 16.6837 18.0927 16.5697 18.3058C16.4557 18.519 16.2884 18.6863 16.0753 18.8003C15.8621 18.9143 15.6507 18.975 15.0677 18.975H13.2011C12.9096 18.975 12.8039 18.9446 12.6973 18.8876C12.5907 18.8306 12.5071 18.747 12.4501 18.6404C12.3931 18.5338 12.3627 18.4281 12.3627 18.1366V14.9738C12.3627 14.6823 12.3931 14.5766 12.4501 14.47C12.5071 14.3635 12.5907 14.2798 12.6973 14.2228ZM16.2967 9.52487C16.8225 9.52487 17.0353 9.58397 17.2427 9.69493C17.4502 9.80589 17.6131 9.96873 17.724 10.1762C17.835 10.3837 17.8941 10.5965 17.8941 11.1222V12.5284C17.8941 12.8121 17.8645 12.915 17.809 13.0188C17.7536 13.1225 17.6721 13.2039 17.5684 13.2594C17.4647 13.3149 17.3618 13.3444 17.078 13.3444H13.1718C12.888 13.3444 12.7851 13.3149 12.6814 13.2594C12.5776 13.2039 12.4962 13.1225 12.4407 13.0188C12.3852 12.915 12.3557 12.8121 12.3557 12.5284V10.341C12.3557 10.0572 12.3852 9.95428 12.4407 9.85054C12.4962 9.7468 12.5776 9.66538 12.6814 9.6099C12.7851 9.55442 12.888 9.52487 13.1718 9.52487H16.2967ZM6.7573 9.69493C6.96478 9.58397 7.17754 9.52487 7.70331 9.52487H10.8283C11.112 9.52487 11.2149 9.55442 11.3187 9.6099C11.4224 9.66538 11.5038 9.7468 11.5593 9.85054C11.6148 9.95428 11.6443 10.0572 11.6443 10.341V12.5284C11.6443 12.8121 11.6148 12.915 11.5593 13.0188C11.5038 13.1225 11.4224 13.2039 11.3187 13.2594C11.2149 13.3149 11.112 13.3444 10.8283 13.3444H6.92204C6.63827 13.3444 6.53537 13.3149 6.43163 13.2594C6.32789 13.2039 6.24647 13.1225 6.19099 13.0188C6.13551 12.915 6.10596 12.8121 6.10596 12.5284V11.1222C6.10596 10.5965 6.16505 10.3837 6.27602 10.1762C6.38698 9.96873 6.54981 9.80589 6.7573 9.69493Z", fill: "inherit" })), nu = V(tu), ru = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.97548 3.71544C8.32654 3.36439 8.9555 3.25404 9.64396 3.78842C10.222 4.23706 10.8266 5.17244 11.008 6.74799C9.43244 6.56655 8.49707 5.96193 8.04844 5.38393C7.51406 4.69546 7.62442 4.06649 7.97548 3.71544ZM11.9962 3.71649C11.6635 3.13799 11.2555 2.66576 10.7936 2.30726C9.51339 1.31352 7.79863 1.24066 6.64966 2.38961C5.5007 3.53855 5.57353 5.25332 6.56725 6.5336C6.62518 6.60822 6.68607 6.68144 6.7499 6.75317L6.62801 6.7532C6.04476 6.7532 5.75314 6.78082 5.50833 6.8132C3.82741 6.9782 2.50481 8.30982 2.28247 9.99074C2.19781 10.6308 2.19117 11.3649 2.27599 12.0062C2.40105 12.9516 2.96117 13.7553 3.75009 14.2111V14.6346V15.1461C3.75009 17.4563 3.75009 18.6114 4.19969 19.4938C4.59517 20.27 5.22621 20.901 6.00238 21.2965C6.88477 21.7461 8.03988 21.7461 10.3501 21.7461H13.6501C15.9603 21.7461 17.1154 21.7461 17.9978 21.2965C18.774 20.901 19.405 20.27 19.8005 19.4938C20.2501 18.6114 20.2501 17.4563 20.2501 15.1461V14.6346V14.2111C21.039 13.7553 21.5991 12.9516 21.7242 12.0062C21.809 11.3649 21.8024 10.6308 21.7177 9.99074C21.4954 8.30982 20.1769 6.98041 18.4918 6.81145C18.247 6.77906 17.9534 6.74992 17.3702 6.74992L17.2453 6.74996C17.3081 6.67926 17.3681 6.60711 17.4251 6.5336C18.4189 5.25332 18.4917 3.53855 17.3427 2.38961C16.1938 1.24066 14.479 1.31352 13.1988 2.30726C12.7369 2.66576 12.3289 3.13799 11.9962 3.71649ZM16.0169 3.71544C15.6659 3.36439 15.0369 3.25404 14.3484 3.78842C13.7704 4.23706 13.1658 5.17244 12.9844 6.74799C14.56 6.56655 15.4953 5.96193 15.944 5.38393C16.4783 4.69546 16.368 4.06649 16.0169 3.71544ZM6.62801 8.60749H11.0626V12.7378H5.75243C5.22595 12.7378 5.14515 12.7337 5.10256 12.728C4.59828 12.6613 4.2015 12.2646 4.1348 11.7603C4.07141 11.281 4.07789 10.7158 4.14127 10.2366C4.25245 9.39616 4.91375 8.73486 5.75421 8.62368C5.84576 8.61157 5.98489 8.60749 6.62801 8.60749ZM12.9376 12.7378V8.60749H17.3722C18.0153 8.60749 18.1544 8.61157 18.246 8.62368C19.0864 8.73486 19.7477 9.39616 19.8589 10.2366C19.9223 10.7158 19.9288 11.281 19.8654 11.7603C19.7987 12.2646 19.4019 12.6613 18.8976 12.728C18.855 12.7337 18.7742 12.7378 18.2477 12.7378H12.9376ZM5.62509 14.6346H11.0626V19.8711H10.3501C9.16404 19.8711 8.38727 19.8696 7.79348 19.8211C7.22158 19.7744 6.98643 19.6935 6.85361 19.6258C6.43025 19.4101 6.08604 19.0659 5.87033 18.6426C5.80265 18.5097 5.72179 18.2746 5.67506 17.7027C5.62655 17.1089 5.62509 16.3321 5.62509 15.1461V14.6346ZM12.9376 14.6346V19.8711H13.6501C14.8361 19.8711 15.6129 19.8696 16.2067 19.8211C16.7786 19.7744 17.0138 19.6935 17.1466 19.6258C17.5699 19.4101 17.9141 19.0659 18.1299 18.6426C18.1975 18.5097 18.2784 18.2746 18.3251 17.7027C18.3736 17.1089 18.3751 16.3321 18.3751 15.1461V14.6346H12.9376Z", fill: "inherit" })), au = V(ru), iu = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M7.9997 4.97673C3.86893 4.97673 3.51487 2.38024 4.45904 1.43607C5.40322 0.491893 7.9997 0.845959 7.9997 4.97673ZM11.5404 1.43294C12.4845 2.37711 12.1305 4.97673 7.9997 4.97673C7.9997 0.845959 10.5962 0.488762 11.5404 1.43294Z", fill: "inherit" }), /* @__PURE__ */ o.createElement("path", { d: "M6.84529 10.1605C7.13681 10.1605 7.24252 10.1909 7.3491 10.2479C7.45567 10.3049 7.53931 10.3885 7.59631 10.4951C7.65331 10.6017 7.68366 10.7074 7.68366 10.9989V14.1616C7.68366 14.4532 7.65331 14.5589 7.59631 14.6654C7.53931 14.772 7.45567 14.8557 7.3491 14.9127C7.24252 14.9697 7.13681 15 6.84529 15H4.9787C4.39566 15 4.18424 14.9393 3.97109 14.8253C3.75794 14.7113 3.59065 14.544 3.47666 14.3309C3.36267 14.1177 3.30196 13.9063 3.30196 13.3233V10.9989C3.30196 10.7074 3.33231 10.6017 3.38931 10.4951C3.44631 10.3885 3.52995 10.3049 3.63652 10.2479C3.7431 10.1909 3.84881 10.1605 4.14033 10.1605H6.84529Z", fill: "inherit" }), /* @__PURE__ */ o.createElement("path", { d: "M9.20109 10.1355C8.90957 10.1355 8.80386 10.1658 8.69728 10.2228C8.59071 10.2798 8.50707 10.3635 8.45007 10.47C8.39307 10.5766 8.36272 10.6823 8.36272 10.9738V14.1366C8.36272 14.4281 8.39307 14.5338 8.45007 14.6404C8.50707 14.747 8.59071 14.8306 8.69728 14.8876C8.80386 14.9446 8.90957 14.975 9.20109 14.975H11.0677C11.6507 14.975 11.8621 14.9143 12.0753 14.8003C12.2884 14.6863 12.4557 14.519 12.5697 14.3058C12.6837 14.0927 12.7444 13.8813 12.7444 13.2982V10.9738C12.7444 10.6823 12.7141 10.5766 12.6571 10.47C12.6001 10.3635 12.5164 10.2798 12.4099 10.2228C12.3033 10.1658 12.1976 10.1355 11.906 10.1355H9.20109Z", fill: "inherit" }), /* @__PURE__ */ o.createElement("path", { d: "M12.2967 5.52488C12.8225 5.52488 13.0353 5.58397 13.2427 5.69493C13.4502 5.80589 13.6131 5.96873 13.724 6.17621C13.835 6.38369 13.8941 6.59646 13.8941 7.12222V8.52837C13.8941 8.81213 13.8645 8.91504 13.809 9.01878C13.7536 9.12252 13.6721 9.20394 13.5684 9.25942C13.4647 9.3149 13.3618 9.34445 13.078 9.34445H9.17178C8.88801 9.34445 8.7851 9.3149 8.68136 9.25942C8.57762 9.20394 8.49621 9.12252 8.44072 9.01878C8.38524 8.91504 8.3557 8.81213 8.3557 8.52837V6.34095C8.3557 6.05718 8.38524 5.95428 8.44072 5.85054C8.49621 5.7468 8.57762 5.66538 8.68136 5.6099C8.7851 5.55442 8.88801 5.52488 9.17178 5.52488H12.2967Z", fill: "inherit" }), /* @__PURE__ */ o.createElement("path", { d: "M3.7033 5.52488C3.17754 5.52488 2.96477 5.58397 2.75729 5.69493C2.54981 5.80589 2.38698 5.96873 2.27601 6.17621C2.16505 6.38369 2.10596 6.59646 2.10596 7.12222V8.52837C2.10596 8.81213 2.1355 8.91504 2.19098 9.01878C2.24647 9.12252 2.32788 9.20394 2.43162 9.25942C2.53537 9.3149 2.63827 9.34445 2.92204 9.34445H6.82826C7.11202 9.34445 7.21493 9.3149 7.31867 9.25942C7.42241 9.20394 7.50382 9.12252 7.55931 9.01878C7.61479 8.91504 7.64433 8.81213 7.64433 8.52837V6.34095C7.64433 6.05718 7.61479 5.95428 7.55931 5.85054C7.50382 5.7468 7.42241 5.66538 7.31867 5.6099C7.21493 5.55442 7.11202 5.52488 6.82826 5.52488H3.7033Z", fill: "inherit" })), ou = V(iu), su = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.119 4.17358C9.18427 4.7334 6.70424 6.57524 5.28393 9.09413H9.86376C10.4326 7.20496 11.2542 5.54032 12.119 4.17358ZM11.4176 11.0941H17.4224C17.9747 11.0941 18.4224 10.6464 18.4224 10.0941C18.4224 9.96701 18.3987 9.84543 18.3554 9.73357C17.7794 7.81177 16.8807 5.80655 15.9392 4.18292C19.3429 4.84965 22.1297 7.24235 23.3483 10.4147L23.3615 10.4492C23.5576 10.9655 24.1351 11.225 24.6514 11.0289C25.1677 10.8328 25.4272 10.2553 25.2311 9.73896L25.2153 9.69752C23.4857 5.19479 19.1201 1.99609 14.005 1.99609C7.37482 1.99609 2 7.37092 2 14.0011C2 19.1271 5.21224 23.5003 9.73008 25.2223C10.2461 25.4191 10.824 25.1602 11.0207 24.6441C11.2174 24.128 10.9585 23.5502 10.4424 23.3535C8.24785 22.517 6.42431 20.9307 5.28401 18.9083H9.5C10.0523 18.9083 10.5 18.4606 10.5 17.9083C10.5 17.356 10.0523 16.9083 9.5 16.9083H4.42894C4.14998 15.9882 4 15.0121 4 14.0011C4 12.9901 4.14996 12.0141 4.42886 11.0941H9.37977C9.23955 11.8585 9.14512 12.651 9.10758 13.4678L9.10398 13.5504C9.10242 13.5883 9.10277 13.6229 9.10422 13.6545C9.10495 13.6703 9.10594 13.6846 9.10675 13.6951C9.12418 14.232 9.56499 14.662 10.1062 14.662C10.6585 14.662 11.1062 14.2143 11.1062 13.662C11.1062 13.6352 11.1054 13.6107 11.1042 13.5883L11.1055 13.5596C11.1446 12.7079 11.254 11.884 11.4176 11.0941ZM14.036 4.89307C14.7531 6.08372 15.4782 7.57495 16.0346 9.09413H11.9638C12.5144 7.47395 13.2649 6.05072 14.036 4.89307ZM19.5 26.5005C23.366 26.5005 26.5 23.3665 26.5 19.5005C26.5 15.6345 23.366 12.5005 19.5 12.5005C15.634 12.5005 12.5 15.6345 12.5 19.5005C12.5 23.3665 15.634 26.5005 19.5 26.5005ZM22.9571 17.4576C23.3476 17.0671 23.3476 16.4339 22.9571 16.0434C22.5666 15.6529 21.9334 15.6529 21.5429 16.0434L19.5 18.0863L17.4571 16.0434C17.0666 15.6529 16.4334 15.6529 16.0429 16.0434C15.6524 16.4339 15.6524 17.0671 16.0429 17.4576L18.0858 19.5005L16.0429 21.5434C15.6524 21.9339 15.6524 22.5671 16.0429 22.9576C16.4334 23.3481 17.0666 23.3481 17.4571 22.9576L19.5 20.9147L21.5429 22.9576C21.9334 23.3481 22.5666 23.3481 22.9571 22.9576C23.3476 22.5671 23.3476 21.9339 22.9571 21.5434L20.9142 19.5005L22.9571 17.4576Z", fill: "inherit" })), lu = V(su), cu = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M13.9991 25.6673C13.8628 25.6673 13.7235 25.6649 13.5848 25.66L13.5498 25.6587L13.5394 25.658L13.5126 25.6572C13.4891 25.6562 13.4656 25.6552 13.4422 25.6541C13.3543 25.6499 13.2676 25.6449 13.1811 25.6388C13.1427 25.6362 13.1038 25.6333 13.065 25.6302C13.065 25.6302 13.0654 25.6302 13.0658 25.6303C13.0431 25.6285 13.0202 25.6266 12.9973 25.6246C12.8916 25.6156 12.7866 25.6052 12.6821 25.5934C12.6739 25.5925 12.6658 25.5916 12.6576 25.5906C12.6501 25.5898 12.6427 25.5889 12.6354 25.5881C12.6064 25.5847 12.5774 25.5812 12.5484 25.5776C6.79168 24.8621 2.33594 19.9517 2.33594 14.0007C2.33594 8.04957 6.79168 3.13919 12.549 2.42365C12.5492 2.42448 12.5488 2.42411 12.5484 2.42373L12.6178 2.41531C12.7436 2.40044 12.87 2.38756 12.9969 2.37672L12.5484 2.42373C12.7157 2.40294 12.884 2.38568 13.0533 2.37205C13.1834 2.36157 13.3144 2.35321 13.446 2.34703C13.4861 2.34515 13.5255 2.3435 13.5649 2.34204C13.6313 2.33959 13.699 2.33766 13.7668 2.33632L13.6646 2.33879C13.7761 2.33561 13.888 2.33401 14.0003 2.33398L14.0014 2.33398H14.0026C14.135 2.33398 14.2669 2.33619 14.3982 2.34056L14.0026 2.33398C14.1651 2.33398 14.3269 2.33731 14.4878 2.34389L14.0026 2.33398C14.191 2.33398 14.3783 2.33845 14.5644 2.34727C14.6247 2.35013 14.6842 2.35341 14.7436 2.35713C14.7845 2.3597 14.8252 2.36247 14.8659 2.36544C14.9089 2.36859 14.9504 2.37185 14.9919 2.37534C15.023 2.37795 15.0542 2.38069 15.0853 2.38356C15.2225 2.39618 15.3589 2.41118 15.4946 2.4285C15.5096 2.43041 15.5244 2.43233 15.5391 2.43427C15.6857 2.45354 15.8316 2.47558 15.9767 2.5003C15.9899 2.50255 16.0034 2.50488 16.0169 2.50723C21.5 3.46128 25.6693 8.24408 25.6693 14.0007C25.6693 20.129 20.9441 25.1537 14.9383 25.6303C14.9387 25.6295 14.9391 25.6299 14.9394 25.6303L14.8668 25.6347C14.8665 25.6351 14.8662 25.6355 14.8659 25.6359L14.7424 25.6442C14.6842 25.6479 14.6258 25.6511 14.5674 25.6539L14.4734 25.658L14.4494 25.658L14.4362 25.6594C14.4192 25.66 14.4022 25.6606 14.3852 25.6612C14.2583 25.6653 14.1307 25.6673 14.0026 25.6673H13.9991ZM16.35 18.6686L11.5181 18.6687C11.9473 20.6408 12.6781 22.4205 13.6281 23.9097C13.7443 23.9147 13.8604 23.917 13.9769 23.9173C15.0222 22.4582 15.8437 20.672 16.35 18.6686ZM22.7547 18.6676L18.1485 18.6681C17.7278 20.5011 17.0658 22.1908 16.2127 23.6697C19.0466 23.0254 21.4198 21.1657 22.7547 18.6676ZM9.73203 18.6682L5.25054 18.6676C6.52732 21.057 8.75398 22.8624 11.4261 23.5793C10.6645 22.1072 10.0854 20.45 9.73203 18.6682ZM9.62504 11.0839L4.52183 11.0839C4.23846 12.0061 4.08594 12.9856 4.08594 14.0007C4.08594 15.0162 4.23859 15.9961 4.52219 16.9186L9.46321 16.9185C9.37937 16.1567 9.33594 15.3772 9.33594 14.584C9.33594 13.381 9.43583 12.2096 9.62504 11.0839ZM16.7022 11.0841L11.4008 11.084C11.1956 12.1998 11.0859 13.3721 11.0859 14.584C11.0859 15.3808 11.1333 16.1606 11.2241 16.9184L16.702 16.9184C16.8442 15.9793 16.9193 15.0035 16.9193 14.0007C16.9193 12.9982 16.8442 12.0229 16.7022 11.0841ZM23.4834 11.0839L18.4697 11.0849C18.6008 12.0298 18.6693 13.0044 18.6693 14.0007C18.6693 14.9973 18.6007 15.9723 18.4696 16.9176L23.483 16.9186C23.7666 15.9961 23.9193 15.0162 23.9193 14.0007C23.9193 12.9856 23.7668 12.0061 23.4834 11.0839ZM12.199 4.24868L11.9689 4.29272C9.05605 4.89984 6.61209 6.78486 5.24992 9.33486L9.99975 9.33415C10.4935 7.44828 11.2457 5.72726 12.199 4.24868ZM14.2107 4.42035L14.0706 4.60733C13.1082 5.93599 12.3322 7.53945 11.8129 9.33399L16.3503 9.33392C15.8824 7.4817 15.145 5.81512 14.2107 4.42035ZM16.2116 4.33092L16.2425 4.38351C17.0814 5.85028 17.733 7.52233 18.1487 9.33432L22.7553 9.33486C21.4205 6.83617 19.0471 4.97597 16.2116 4.33092Z" })), uu = V(cu), du = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M14.0026 12.8333C14.0026 14.122 12.9579 15.1667 11.6693 15.1667C10.3806 15.1667 9.33594 14.122 9.33594 12.8333C9.33594 11.5447 10.3806 10.5 11.6693 10.5C12.9579 10.5 14.0026 11.5447 14.0026 12.8333Z" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.33594 4.66667C2.33594 4.02233 2.85827 3.5 3.5026 3.5H5.2526C5.89694 3.5 6.41927 4.02233 6.41927 4.66667V5.83333H24.5026C25.1469 5.83333 25.6693 6.35567 25.6693 7V18.6667C25.6693 19.311 25.1469 19.8333 24.5026 19.8333H6.41927V21C6.41927 21.6443 5.89694 22.1667 5.2526 22.1667C4.60827 22.1667 4.08594 21.6443 4.08594 21V5.83333H3.5026C2.85827 5.83333 2.33594 5.311 2.33594 4.66667ZM16.3359 12.8333C16.3359 15.4107 14.2466 17.5 11.6693 17.5C9.09194 17.5 7.0026 15.4107 7.0026 12.8333C7.0026 10.256 9.09194 8.16667 11.6693 8.16667C14.2466 8.16667 16.3359 10.256 16.3359 12.8333ZM18.6693 9.33333H22.7526V11.6667H18.6693V9.33333ZM22.7526 14H18.6693V16.3333H22.7526V14Z" }), /* @__PURE__ */ o.createElement("path", { d: "M9.33594 22.1667C8.69161 22.1667 8.16927 22.689 8.16927 23.3333C8.16927 23.9777 8.69161 24.5 9.33594 24.5H21.5859C22.2303 24.5 22.7526 23.9777 22.7526 23.3333C22.7526 22.689 22.2303 22.1667 21.5859 22.1667H9.33594Z" })), fu = V(du), hu = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.8346 2.33398C21.7676 2.33398 23.3346 3.90099 23.3346 5.83398L23.3346 22.1673C23.3346 24.1003 21.7676 25.6673 19.8346 25.6673H8.16797C6.23497 25.6673 4.66797 24.1003 4.66797 22.1673V5.83398C4.66797 3.90099 6.23497 2.33398 8.16797 2.33398H19.8346ZM17.5013 11.6673C17.5013 13.6003 15.9343 15.1673 14.0013 15.1673C13.3478 15.1673 12.7362 14.9882 12.2128 14.6765L14.7482 12.5636C15.2432 12.1511 15.3101 11.4155 14.8976 10.9205C14.4851 10.4255 13.7494 10.3586 13.2544 10.7711L10.7187 12.8842C10.5781 12.5052 10.5013 12.0952 10.5013 11.6673C10.5013 9.73432 12.0683 8.16732 14.0013 8.16732C15.9343 8.16732 17.5013 9.73432 17.5013 11.6673ZM19.8346 11.6673C19.8346 14.889 17.223 17.5007 14.0013 17.5007C10.7796 17.5007 8.16797 14.889 8.16797 11.6673C8.16797 8.44566 10.7796 5.83398 14.0013 5.83398C17.223 5.83398 19.8346 8.44566 19.8346 11.6673ZM10.5013 21.0007C10.5013 21.645 9.97897 22.1673 9.33464 22.1673C8.6903 22.1673 8.16797 21.645 8.16797 21.0007C8.16797 20.3563 8.6903 19.834 9.33464 19.834C9.97897 19.834 10.5013 20.3563 10.5013 21.0007ZM19.8346 21.0007C19.8346 21.645 19.3123 22.1673 18.668 22.1673C18.0236 22.1673 17.5013 21.645 17.5013 21.0007C17.5013 20.3563 18.0236 19.834 18.668 19.834C19.3123 19.834 19.8346 20.3563 19.8346 21.0007Z" })), pu = V(hu), mu = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", { id: "help_outline_24" }, /* @__PURE__ */ o.createElement("g", { id: "â³ Icon Color" }, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.57126 6.57223C8.9828 4.16069 12.3178 2.66699 15.9993 2.66699C19.6809 2.66699 23.0159 4.16069 25.4274 6.57223C27.839 8.98378 29.3327 12.3188 29.3327 16.0003C29.3327 19.6819 27.839 23.0169 25.4274 25.4284C23.0159 27.84 19.6809 29.3337 15.9993 29.3337C12.3178 29.3337 8.9828 27.84 6.57126 25.4284C4.15971 23.0169 2.66602 19.6819 2.66602 16.0003C2.66602 12.3188 4.15971 8.98378 6.57126 6.57223ZM15.9993 5.06699C12.9799 5.06699 10.2482 6.28943 8.26832 8.26929C6.28846 10.2491 5.06601 12.9808 5.06601 16.0003C5.06601 19.0198 6.28846 21.7515 8.26832 23.7314C10.2482 25.7112 12.9799 26.9337 15.9993 26.9337C19.0188 26.9337 21.7505 25.7112 23.7304 23.7314C25.7102 21.7515 26.9327 19.0198 26.9327 16.0003C26.9327 12.9808 25.7102 10.2491 23.7304 8.26929C21.7505 6.28943 19.0188 5.06699 15.9993 5.06699Z" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.9749 10.7877C14.6369 11.0471 14.4302 11.3656 14.3614 11.6328C14.1962 12.2746 13.542 12.661 12.9002 12.4958C12.2584 12.3306 11.872 11.6764 12.0372 11.0345C12.2644 10.1516 12.8365 9.40343 13.5138 8.88367C14.1932 8.36239 15.0698 8.00033 15.9993 8.00033C18.1348 8.00033 19.9993 9.86482 19.9993 12.0003C19.9993 13.8277 18.9989 14.9614 18.2855 15.7428C17.4876 16.6167 17.1993 16.9572 17.1993 17.467C17.1993 18.1297 16.6621 18.667 15.9993 18.667C15.3366 18.667 14.7993 18.1297 14.7993 17.467C14.7993 15.9696 15.7449 14.9521 16.3642 14.2857C16.4164 14.2295 16.4663 14.1758 16.5131 14.1245C17.1997 13.3725 17.5993 12.8396 17.5993 12.0003C17.5993 11.1903 16.8093 10.4003 15.9993 10.4003C15.6863 10.4003 15.3109 10.5299 14.9749 10.7877Z" }), /* @__PURE__ */ o.createElement("path", { d: "M17.5993 22.1337C17.5993 23.0173 16.883 23.7337 15.9993 23.7337C15.1157 23.7337 14.3993 23.0173 14.3993 22.1337C14.3993 21.25 15.1157 20.5337 15.9993 20.5337C16.883 20.5337 17.5993 21.25 17.5993 22.1337Z" })))), Cu = V(mu), gu = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", { id: "hide_outline_24" }, /* @__PURE__ */ o.createElement("g", { id: "â³ Icon Color" }, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.5932 6.41057C11.0968 6.43599 10.6738 6.05418 10.6483 5.55777C10.6229 5.06136 11.0047 4.63834 11.5011 4.61292C14.2597 4.47167 17.075 5.56613 19.15 7.11404C20.125 7.84138 20.9375 8.66754 21.5063 9.50954C22.0753 10.3518 22.4001 11.2096 22.4001 12.0001C22.4001 12.9404 21.9361 13.981 21.1579 14.9661C20.8498 15.3562 20.2838 15.4226 19.8938 15.1145C19.5038 14.8063 19.4374 14.2404 19.7455 13.8503C20.1554 13.3315 20.6001 12.6826 20.6001 12.0001C20.6001 11.6877 20.4616 11.1787 20.0147 10.5171C19.5787 9.87162 18.9177 9.18643 18.0737 8.55683C16.2387 7.18794 13.9052 6.29218 11.5932 6.41057Z", fill: "currentColor" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.8502 16.8861C6.80033 18.3408 9.40034 19.4001 12.0001 19.4001C13.9673 19.4001 15.9299 18.7932 17.6043 17.8771L18.8637 19.1365C19.2152 19.488 19.785 19.488 20.1365 19.1365C20.488 18.785 20.488 18.2152 20.1365 17.8637L6.63649 4.3637C6.28502 4.01223 5.71517 4.01223 5.3637 4.3637C5.01223 4.71517 5.01223 5.28502 5.3637 5.63649L6.04763 6.32042C5.62895 6.56611 5.22825 6.83203 4.8502 7.11404C3.87518 7.84138 3.06265 8.66754 2.49389 9.50954C1.92492 10.3518 1.6001 11.2096 1.6001 12.0001C1.6001 12.7905 1.92492 13.6483 2.49389 14.4906C3.06265 15.3326 3.87518 16.1588 4.8502 16.8861ZM10.4001 12.0001C10.4001 12.8837 11.1164 13.6001 12.0001 13.6001C12.3724 13.6001 12.7146 13.4735 12.9869 13.2597L10.7404 11.0132C10.5267 11.2855 10.4001 11.6281 10.4001 12.0001ZM12.0001 15.4001C10.1223 15.4001 8.6001 13.8778 8.6001 12.0001C8.6001 11.1301 8.92718 10.3369 9.46346 9.73625L7.36989 7.64268C6.85696 7.91617 6.37207 8.22443 5.92647 8.55683C5.08247 9.18643 4.42149 9.87162 3.98547 10.5171C3.53859 11.1787 3.4001 11.6877 3.4001 12.0001C3.4001 12.3124 3.53859 12.8215 3.98547 13.483C4.42149 14.1285 5.08247 14.8137 5.92647 15.4433C7.63091 16.7148 9.86236 17.6001 12.0001 17.6001C13.4393 17.6001 14.9251 17.199 16.2692 16.542L14.264 14.5368C13.6634 15.0729 12.8696 15.4001 12.0001 15.4001Z", fill: "currentColor" })))), vu = V(gu), wu = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", { id: "history_backward_outline_16" }, /* @__PURE__ */ o.createElement("g", { id: "â³ Icon Color" }, /* @__PURE__ */ o.createElement("path", { d: "M9.82812 2.81225C8.76081 2.43628 7.60354 2.39889 6.51421 2.70518C5.77939 2.91179 5.09962 3.268 4.51547 3.74723H5.25001C5.66423 3.74723 6.00001 4.08301 6.00001 4.49723C6.00001 4.91144 5.66423 5.24723 5.25001 5.24723L3.13679 5.24723C3.07942 5.24727 2.9982 5.24733 2.92474 5.24133C2.83667 5.23413 2.69611 5.21471 2.54602 5.13823C2.35786 5.04236 2.20488 4.88938 2.10901 4.70122C2.03253 4.55113 2.01311 4.41057 2.00591 4.3225C1.99991 4.24903 1.99997 4.16782 2.00001 4.11045L2.00001 2C2.00001 1.58579 2.3358 1.25 2.75001 1.25C3.16423 1.25 3.50001 1.58579 3.50001 2V2.64074C4.25771 2.00391 5.14585 1.53176 6.10819 1.26117C7.49481 0.871294 8.96792 0.918891 10.3265 1.39747C11.6851 1.87604 12.8629 2.76227 13.6992 3.93517C14.5356 5.10807 14.9898 6.51052 14.9998 7.95113C15.0099 9.39175 14.5753 10.8004 13.7554 11.9849C12.9355 13.1693 11.7702 14.0719 10.4184 14.5694C9.06667 15.0669 7.59437 15.1351 6.20244 14.7646C5.10673 14.473 4.07704 13.9192 3.24201 13.1503C2.93728 12.8698 2.9177 12.3953 3.19826 12.0906C3.47883 11.7859 3.9533 11.7663 4.25802 12.0468C4.90755 12.6449 5.71874 13.0837 6.58825 13.3151C7.68175 13.6061 8.83839 13.5526 9.90034 13.1617C10.9623 12.7709 11.8779 12.0618 12.5221 11.1311C13.1663 10.2005 13.5078 9.09361 13.4999 7.9616C13.492 6.82959 13.1351 5.72761 12.4779 4.80605C11.8208 3.88448 10.8954 3.18823 9.82812 2.81225Z" }), /* @__PURE__ */ o.createElement("path", { d: "M7.75001 5C8.16423 5 8.50001 5.33579 8.50001 5.75V8.22256L9.81946 9.76191C10.089 10.0764 10.0526 10.5499 9.73811 10.8194C9.42361 11.089 8.95014 11.0526 8.68057 10.7381L7.18057 8.98809C7.06406 8.85216 7.00001 8.67903 7.00001 8.5V5.75C7.00001 5.33579 7.3358 5 7.75001 5Z" })))), yu = V(wu), bu = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.99992 5.91667C10.4141 5.91667 10.7499 6.25245 10.7499 6.66667V9.77267L12.6136 11.6363C12.9065 11.9292 12.9065 12.4041 12.6136 12.697C12.3207 12.9899 11.8458 12.9899 11.5529 12.697L9.46959 10.6137C9.32894 10.473 9.24992 10.2822 9.24992 10.0833V6.66667C9.24992 6.25245 9.58571 5.91667 9.99992 5.91667Z", fill: "inherit" }), /* @__PURE__ */ o.createElement("path", { d: "M15.8336 4.16637C14.3414 2.6742 12.2778 1.75 9.99992 1.75C7.67944 1.75 5.58153 2.70898 4.08325 4.2506V2.5C4.08325 2.08579 3.74747 1.75 3.33325 1.75C2.91904 1.75 2.58325 2.08579 2.58325 2.5V5.83335C2.58325 6.24757 2.91904 6.58335 3.33325 6.58335H6.66659C7.0808 6.58335 7.41659 6.24757 7.41659 5.83335C7.41659 5.41914 7.0808 5.08335 6.66659 5.08335H5.37505C6.5838 3.94581 8.20997 3.25 9.99992 3.25C11.864 3.25 13.5505 4.00467 14.7729 5.22703C15.9952 6.44939 16.7499 8.13587 16.7499 10C16.7499 11.8641 15.9953 13.5506 14.7729 14.773C13.5505 15.9953 11.864 16.75 9.99992 16.75C8.34866 16.75 6.83759 16.158 5.66446 15.1738C5.34713 14.9076 4.87407 14.9491 4.60784 15.2664C4.34162 15.5837 4.38305 16.0568 4.70039 16.323C6.13356 17.5254 7.98312 18.25 9.99992 18.25C12.2778 18.25 14.3414 17.3258 15.8335 15.8336C17.3257 14.3415 18.2499 12.2779 18.2499 10C18.2499 7.72208 17.3257 5.65854 15.8336 4.16637Z", fill: "inherit" })), _u = V(bu), xu = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { id: "â³ Icon Color", fillRule: "evenodd", clipRule: "evenodd", d: "M14.2169 5.65965C14.0763 5.61397 13.9249 5.61397 13.7843 5.65965C13.7688 5.66467 13.7034 5.68766 13.5299 5.83499C13.3469 5.99027 13.1219 6.21411 12.7632 6.57288L6.50321 12.8329C6.06432 13.2717 5.97065 13.375 5.90639 13.4798C5.83603 13.5946 5.78418 13.7198 5.75274 13.8508C5.72403 13.9704 5.71728 14.1096 5.71728 14.7303V20.5338C5.71728 21.0412 5.7181 21.3586 5.73764 21.5977C5.75617 21.8246 5.7862 21.8872 5.79358 21.9016C5.86069 22.0334 5.96778 22.1404 6.09949 22.2076C6.11397 22.2149 6.17651 22.245 6.40339 22.2635C6.64253 22.283 6.95991 22.2838 7.46728 22.2838H10.6173V18.5505C10.6173 16.6819 12.1321 15.1672 14.0006 15.1672C15.8692 15.1672 17.3839 16.6819 17.3839 18.5505V22.2838H20.5339C21.0413 22.2838 21.3587 22.283 21.5978 22.2635C21.8247 22.245 21.8873 22.2149 21.9017 22.2076C22.0335 22.1404 22.1405 22.0334 22.2077 21.9016C22.215 21.8872 22.2451 21.8246 22.2636 21.5977C22.2831 21.3586 22.2839 21.0412 22.2839 20.5338V14.7303C22.2839 14.1096 22.2772 13.9704 22.2485 13.8508C22.2171 13.7198 22.1652 13.5946 22.0948 13.4798C22.0306 13.375 21.9369 13.2717 21.498 12.8329L15.2381 6.57288C14.8793 6.21411 14.6543 5.99027 14.4714 5.83499C14.2978 5.68766 14.2324 5.66467 14.2169 5.65965ZM13.1354 3.66243C13.6977 3.47971 14.3035 3.47971 14.8659 3.66243C15.25 3.78724 15.5576 4.00242 15.8304 4.23407C16.0867 4.45161 16.3725 4.73747 16.6955 5.06047L22.9829 11.3479C23.005 11.37 23.0269 11.3918 23.0485 11.4134C23.388 11.7524 23.6745 12.0384 23.8854 12.3826C24.0709 12.6853 24.2076 13.0153 24.2905 13.3605C24.3847 13.753 24.3844 14.1579 24.384 14.6376C24.384 14.6682 24.3839 14.6991 24.3839 14.7303V20.5727C24.384 21.0295 24.384 21.4337 24.3566 21.7687C24.3275 22.1255 24.2621 22.4952 24.0788 22.855C23.8103 23.3819 23.382 23.8102 22.8551 24.0787C22.4953 24.262 22.1256 24.3274 21.7688 24.3565C21.4338 24.3839 21.0296 24.3839 20.5728 24.3838H16.5541C15.8526 24.3838 15.2839 23.8152 15.2839 23.1137V18.5505C15.2839 17.8417 14.7094 17.2672 14.0006 17.2672C13.2918 17.2672 12.7173 17.8417 12.7173 18.5505V23.1137C12.7173 23.8152 12.1486 24.3838 11.4472 24.3838H7.42839C6.97163 24.3839 6.5674 24.3839 6.23238 24.3565C5.87563 24.3274 5.50597 24.262 5.14611 24.0787C4.61925 23.8102 4.19091 23.3819 3.92246 22.855C3.7391 22.4952 3.67376 22.1255 3.64461 21.7687C3.61724 21.4337 3.61726 21.0295 3.61728 20.5727L3.61728 14.7303C3.61728 14.6991 3.61726 14.6682 3.61723 14.6376C3.61686 14.1579 3.61654 13.753 3.71076 13.3605C3.79364 13.0153 3.93035 12.6853 4.11585 12.3826C4.32674 12.0384 4.61324 11.7524 4.95273 11.4134C4.97437 11.3918 4.99622 11.37 5.01829 11.3479L11.3058 5.06045C11.6287 4.73746 11.9145 4.45161 12.1708 4.23407C12.4437 4.00242 12.7512 3.78724 13.1354 3.66243Z" })), Lu = V(xu), Eu = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { className: "svg-substrate", cx: 12, cy: 12, r: 11, fill: "transparent" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM13.8954 11.1979L15.0983 12.6796C16.0368 13.8317 16.5515 15.2929 16.5515 16.7921C16.5515 18.0113 15.5846 19 14.3988 19H9.60138C8.41269 19 7.44866 18.0083 7.44866 16.7921C7.44866 15.2929 7.96622 13.8317 8.90181 12.6796L10.1047 11.1979L9.79191 10.9558C9.77661 10.9442 9.76176 10.9328 9.74734 10.9219C9.54198 10.7652 9.4231 10.6746 9.31416 10.5738C8.56625 9.89709 8.11125 8.96376 8.03163 7.94292C8.02025 7.78542 8.02025 7.63084 8.02025 7.32167C8.02025 7.04167 8.02025 6.90167 8.03731 6.76459C8.1596 5.86042 8.85916 5.14292 9.73503 5.02042C9.86869 5.00001 10.0052 5.00001 10.2782 5.00001H13.7163C13.9893 5.00001 14.1258 5.00001 14.2594 5.02042C15.1382 5.14292 15.8377 5.86042 15.96 6.76459C15.9799 6.90167 15.9799 7.04167 15.9799 7.32167V7.32175C15.9799 7.63087 15.9799 7.78544 15.9685 7.94292C15.8889 8.96084 15.4339 9.89709 14.686 10.5738C14.5746 10.6741 14.458 10.7638 14.2394 10.9319L14.2083 10.9558L13.8954 11.1979ZM9.89428 16.9583H14.1059C14.359 16.9583 14.5609 16.7483 14.5609 16.4917C14.5609 15.6633 14.2765 14.9867 13.4404 14.4704C12.5077 13.8958 11.4896 13.8958 10.5597 14.4704C9.72366 14.9867 9.43928 15.6663 9.43928 16.4917C9.43928 16.7513 9.64403 16.9583 9.89428 16.9583Z", fill: "inherit" })), Mu = V(Eu), ku = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { cx: 10, cy: 10, r: 10, fill: "white" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.8631 10.628L11.7515 9.25883L12.0406 9.03512C12.2613 8.86532 12.3743 8.77907 12.482 8.68204C13.1732 8.05674 13.5936 7.19155 13.6672 6.2509C13.6777 6.10536 13.6777 5.96251 13.6777 5.67681C13.6777 5.41806 13.6777 5.28869 13.6593 5.16201C13.5463 4.32648 12.8999 3.66344 12.0879 3.55024C11.9644 3.53137 11.8382 3.53137 11.5859 3.53137H8.40881C8.15653 3.53137 8.0304 3.53137 7.90688 3.55024C7.09749 3.66344 6.45103 4.32648 6.33803 5.16201C6.32227 5.28869 6.32227 5.41806 6.32227 5.67681C6.32227 5.96251 6.32227 6.10536 6.33278 6.2509C6.40636 7.19425 6.82682 8.05674 7.51796 8.68204C7.6257 8.78177 7.74396 8.87071 7.95944 9.03512L8.24851 9.25883L7.13691 10.628C6.27234 11.6927 5.79406 13.043 5.79406 14.4284C5.79406 15.5523 6.68492 16.4687 7.78337 16.4687H12.2166C13.3125 16.4687 14.2059 15.555 14.2059 14.4284C14.2059 13.043 13.7303 11.6927 12.8631 10.628ZM11.946 14.582H8.05405C7.82279 14.582 7.63358 14.3906 7.63358 14.1508C7.63358 13.388 7.89637 12.76 8.66897 12.2829C9.52829 11.752 10.4691 11.752 11.331 12.2829C12.1036 12.76 12.3664 13.3853 12.3664 14.1508C12.3664 14.3879 12.1798 14.582 11.946 14.582Z", fill: "inherit" })), Su = V(ku), Au = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.0984 8.67959L9.89551 7.19792L10.2083 6.95584C10.4472 6.77209 10.5695 6.67876 10.6861 6.57376C11.434 5.89709 11.889 4.96084 11.9686 3.94292C11.98 3.78542 11.98 3.63084 11.98 3.32167C11.98 3.04167 11.98 2.90167 11.9601 2.76459C11.8378 1.86042 11.1382 1.14292 10.2595 1.02042C10.1259 1.00001 9.98936 1.00001 9.71636 1.00001H6.27826C6.00526 1.00001 5.86876 1.00001 5.73511 1.02042C4.85923 1.14292 4.15967 1.86042 4.03739 2.76459C4.02032 2.90167 4.02032 3.04167 4.02032 3.32167C4.02032 3.63084 4.02032 3.78542 4.0317 3.94292C4.11132 4.96376 4.56632 5.89709 5.31423 6.57376C5.43082 6.68167 5.55879 6.77792 5.79198 6.95584L6.10479 7.19792L4.90189 8.67959C3.96629 9.83167 3.44873 11.2929 3.44873 12.7921C3.44873 14.0083 4.41276 15 5.60145 15H10.3989C11.5847 15 12.5516 14.0113 12.5516 12.7921C12.5516 11.2929 12.0369 9.83167 11.0984 8.67959ZM10.1059 12.9583H5.89436C5.64411 12.9583 5.43936 12.7513 5.43936 12.4917C5.43936 11.6663 5.72373 10.9867 6.55979 10.4704C7.4897 9.89584 8.50776 9.89584 9.44051 10.4704C10.2766 10.9867 10.5609 11.6633 10.5609 12.4917C10.5609 12.7483 10.359 12.9583 10.1059 12.9583Z", fill: "inherit" })), Tu = V(Au), Iu = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { className: "svg-substrate", cx: 12, cy: 12, r: 11, fill: "transparent" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM18.1467 8.62399C18.3769 8.39379 18.7722 8.50084 18.8506 8.81675C19.2631 10.4754 18.8212 12.3033 17.5243 13.6002C16.1285 14.9961 14.1221 15.3819 12.3687 14.7973L8.82172 18.3443C7.94746 19.2186 6.52989 19.2186 5.65563 18.3443C4.78137 17.47 4.78137 16.0525 5.65563 15.1782L9.20891 11.625C8.63167 9.87223 9.01335 7.86203 10.4001 6.47524C11.6956 5.18012 13.5207 4.73756 15.1783 5.14828C15.4963 5.22735 15.6079 5.62197 15.3763 5.85357L12.7749 8.45501L13.1705 10.8298L15.5453 11.2254L18.1467 8.62399Z", fill: "inherit" })), Ru = V(Iu), Nu = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M14.8507 4.81675C14.7723 4.50084 14.377 4.39379 14.1468 4.62399L11.5453 7.22543L9.17059 6.82976L8.77492 4.45501L11.3764 1.85357C11.608 1.62197 11.4964 1.22735 11.1783 1.14828C9.52079 0.737565 7.69566 1.18012 6.40019 2.47524C5.01341 3.86203 4.63173 5.87223 5.20897 7.62496L1.65569 11.1782C0.781435 12.0525 0.781435 13.47 1.65569 14.3443C2.52995 15.2186 3.94752 15.2186 4.82178 14.3443L8.36875 10.7973C10.1222 11.3819 12.1285 10.9961 13.5244 9.60018C14.8213 8.3033 15.2631 6.47537 14.8507 4.81675Z", fill: "inherit" })), Hu = V(Nu), Ou = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M10 1.5C14.692 1.5 18.5 5.308 18.5 10C18.5 14.692 14.692 18.5 10 18.5C5.308 18.5 1.5 14.692 1.5 10C1.5 5.308 5.308 1.5 10 1.5ZM10 9C9.50294 9 9.1 9.40294 9.1 9.9V13.6C9.1 14.0971 9.50294 14.5 10 14.5C10.4971 14.5 10.9 14.0971 10.9 13.6V9.9C10.9 9.40294 10.4971 9 10 9ZM10 5.5C9.44772 5.5 9 5.94772 9 6.5C9 7.05228 9.44772 7.5 10 7.5C10.5523 7.5 11 7.05228 11 6.5C11 5.94772 10.5523 5.5 10 5.5Z", fill: "inherit" })), ju = V(Ou), Pu = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.32 3.59999H10.68C9.30617 3.59999 8.38406 3.60139 7.67395 3.65941C6.98485 3.71571 6.65537 3.81623 6.43803 3.92697C5.87354 4.21459 5.4146 4.67353 5.12698 5.23802C5.01624 5.45536 4.91572 5.78484 4.85942 6.47393C4.8014 7.18404 4.8 8.10616 4.8 9.47999V14.52C4.8 15.8938 4.8014 16.8159 4.85942 17.526C4.91572 18.2151 5.01624 18.5446 5.12698 18.762C5.4146 19.3264 5.87354 19.7854 6.43803 20.073C6.65537 20.1838 6.98485 20.2843 7.67395 20.3406C8.38406 20.3986 9.30617 20.4 10.68 20.4H13.32C14.6938 20.4 15.6159 20.3986 16.3261 20.3406C17.0152 20.2843 17.3446 20.1838 17.562 20.073C18.1265 19.7854 18.5854 19.3264 18.873 18.762C18.9838 18.5446 19.0843 18.2151 19.1406 17.526C19.1986 16.8159 19.2 15.8938 19.2 14.52V9.47999C19.2 8.10616 19.1986 7.18404 19.1406 6.47393C19.0843 5.78484 18.9838 5.45536 18.873 5.23802C18.5854 4.67353 18.1265 4.21459 17.562 3.92697C17.3446 3.81623 17.0152 3.71571 16.3261 3.65941C15.6159 3.60139 14.6938 3.59999 13.32 3.59999ZM3.52317 4.42083C3 5.44761 3 6.79174 3 9.47999V14.52C3 17.2082 3 18.5524 3.52317 19.5791C3.98336 20.4823 4.71767 21.2166 5.62085 21.6768C6.64762 22.2 7.99175 22.2 10.68 22.2H13.32C16.0083 22.2 17.3524 22.2 18.3792 21.6768C19.2823 21.2166 20.0166 20.4823 20.4768 19.5791C21 18.5524 21 17.2082 21 14.52V9.47999C21 6.79174 21 5.44761 20.4768 4.42083C20.0166 3.51766 19.2823 2.78335 18.3792 2.32316C17.3524 1.79999 16.0083 1.79999 13.32 1.79999H10.68C7.99175 1.79999 6.64762 1.79999 5.62085 2.32316C4.71767 2.78335 3.98336 3.51766 3.52317 4.42083Z", fill: "currentColor" }), /* @__PURE__ */ o.createElement("path", { d: "M14.4 8.39999C14.4 9.72547 13.3255 10.8 12 10.8C10.6745 10.8 9.6 9.72547 9.6 8.39999C9.6 7.0745 10.6745 5.99999 12 5.99999C13.3255 5.99999 14.4 7.0745 14.4 8.39999Z", fill: "currentColor" }), /* @__PURE__ */ o.createElement("path", { d: "M7.2 13.5C7.2 13.0029 7.60294 12.6 8.1 12.6H15.9C16.3971 12.6 16.8 13.0029 16.8 13.5C16.8 13.997 16.3971 14.4 15.9 14.4H8.1C7.60294 14.4 7.2 13.997 7.2 13.5Z", fill: "currentColor" }), /* @__PURE__ */ o.createElement("path", { d: "M7.2 17.1C7.2 16.6029 7.60294 16.2 8.1 16.2H15.9C16.3971 16.2 16.8 16.6029 16.8 17.1C16.8 17.597 16.3971 18 15.9 18H8.1C7.60294 18 7.2 17.597 7.2 17.1Z", fill: "currentColor" })), Du = V(Pu), Vu = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M10 18.1053C14.4764 18.1053 18.1053 14.4764 18.1053 10C18.1053 5.52359 14.4764 1.89474 10 1.89474C5.52359 1.89474 1.89474 5.52359 1.89474 10C1.89474 14.4764 5.52359 18.1053 10 18.1053ZM10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20ZM10 7.62772C9.27331 7.62772 8.68421 7.03863 8.68421 6.31193C8.68421 5.58524 9.27331 4.99615 10 4.99615C10.7267 4.99615 11.3158 5.58524 11.3158 6.31193C11.3158 7.03863 10.7267 7.62772 10 7.62772ZM9.05263 10.4499C9.05263 9.90861 9.47678 9.46983 10 9.46983C10.5232 9.46983 10.9474 9.90861 10.9474 10.4499V14.2793C10.9474 14.8205 10.5232 15.2593 10 15.2593C9.47678 15.2593 9.05263 14.8205 9.05263 14.2793V10.4499Z", fill: "currentColor" })), Bu = V(Vu), Fu = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { className: "svg-substrate", cx: 12, cy: 12, r: 11, fill: "transparent" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM18.6418 7.17407C18.8486 6.93675 18.97 6.62632 18.97 6.28786C18.97 5.53692 18.3592 4.92616 17.6083 4.92616C17.2879 4.92616 16.9875 5.04631 16.7572 5.23655C16.1865 4.93617 15.5357 4.74593 14.8448 4.74593C12.562 4.74593 10.7096 6.59825 10.7096 8.8811C10.7096 9.72215 10.97 10.5031 11.4005 11.164L5.29287 17.2716C4.90238 17.6621 4.90238 18.2929 5.29287 18.6834C5.68336 19.0738 6.31415 19.0738 6.70464 18.6834L7.42554 17.9625L8.56696 19.1039C8.76721 19.3041 9.0776 19.3041 9.27785 19.1039C9.4781 18.9036 9.4781 18.5932 9.27785 18.393L9.00751 18.1227L9.398 17.7322L9.66834 18.0025C9.86859 18.2028 10.179 18.2028 10.3792 18.0025C10.5795 17.8023 10.5795 17.4919 10.3792 17.2916L10.1089 17.0213L10.4994 16.6308L10.7697 16.9011C10.97 17.1014 11.2804 17.1014 11.4806 16.9011C11.6809 16.7009 11.6809 16.3905 11.4806 16.1902L10.3392 15.0488L12.9124 12.4756C13.4931 12.796 14.1539 12.9862 14.8648 12.9862C17.1477 12.9862 19 11.1339 19 8.85107C19 8.25228 18.8707 7.69328 18.6418 7.17407ZM12.7222 8.87109C12.7222 10.0526 13.6834 11.0038 14.8548 11.0038C16.0363 11.0038 16.9875 10.0526 16.9875 8.87109C16.9875 7.68961 16.0363 6.73842 14.8548 6.73842C13.6733 6.73842 12.7222 7.68961 12.7222 8.87109Z", fill: "inherit" })), Zu = V(Fu), Gu = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M14.6195 3.199C14.8398 2.9587 14.97 2.6383 14.97 2.28786C14.97 1.53692 14.3592 0.926159 13.6083 0.926159C13.2879 0.926159 12.9875 1.04631 12.7572 1.23655C12.1865 0.936171 11.5357 0.745934 10.8448 0.745934C8.56195 0.745934 6.70964 2.59825 6.70964 4.8811C6.70964 5.72215 6.96996 6.50313 7.4005 7.16396L1.29287 13.2716C0.902378 13.6621 0.902378 14.2929 1.29287 14.6834C1.68335 15.0738 2.31414 15.0738 2.70463 14.6834L3.42553 13.9625L4.56696 15.1039C4.76721 15.3041 5.0776 15.3041 5.27785 15.1039C5.4781 14.9036 5.4781 14.5932 5.27785 14.393L5.00751 14.1227L5.398 13.7322L5.66834 14.0025C5.86859 14.2028 6.17897 14.2028 6.37922 14.0025C6.57947 13.8023 6.57947 13.4919 6.37922 13.2916L6.10889 13.0213L6.49937 12.6308L6.76971 12.9011C6.96996 13.1014 7.28035 13.1014 7.4806 12.9011C7.68085 12.7009 7.68085 12.3905 7.4806 12.1902L6.33917 11.0488L8.91239 8.4756C9.49312 8.796 10.1539 8.98623 10.8648 8.98623C13.1477 8.98623 15 7.13392 15 4.85106C15 4.25031 14.8698 3.68961 14.6395 3.16896L14.6195 3.199ZM10.8548 7.00376C9.68335 7.00376 8.72215 6.05257 8.72215 4.87109C8.72215 3.68961 9.67334 2.73842 10.8548 2.73842C12.0363 2.73842 12.9875 3.68961 12.9875 4.87109C12.9875 6.05257 12.0363 7.00376 10.8548 7.00376Z", fill: "inherit" })), Wu = V(Gu), Uu = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { className: "svg-substrate", cx: 12, cy: 12, r: 11, fill: "transparent" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM10.2367 7.12934C10.3826 6.28859 10.4556 5.86822 10.6849 5.57819C10.8866 5.32306 11.17 5.13704 11.4946 5.04678C11.8636 4.94417 12.3095 5.02403 13.2013 5.18376L13.2013 5.18376L16.707 5.81166C17.5988 5.97139 18.0447 6.05125 18.3569 6.27588C18.6315 6.47347 18.8352 6.74675 18.9389 7.05656C19.0567 7.40876 18.9837 7.82914 18.8378 8.66988L17.7613 14.8712C17.6154 15.7119 17.5424 16.1323 17.3131 16.4223C17.1114 16.6775 16.8279 16.8635 16.5033 16.9538C16.1343 17.0564 15.6884 16.9765 14.7966 16.8168L11.2909 16.1889C10.3992 16.0291 9.95329 15.9493 9.64108 15.7247C9.43196 15.5742 9.26396 15.3799 9.14995 15.1589C9.11423 15.0897 9.08378 15.0178 9.05906 14.9439C8.94125 14.5917 9.01422 14.1713 9.16016 13.3306L10.1266 7.76333L10.1284 7.75306L10.2367 7.12934ZM8.44959 8.65373C8.51497 8.2771 8.54766 8.08878 8.48985 7.95294C8.43927 7.83408 8.34465 7.7394 8.22582 7.68875C8.09001 7.63087 7.90168 7.66345 7.52501 7.72861L7.10951 7.80049C6.28173 7.94369 5.86784 8.01529 5.58066 8.23089C5.32806 8.42053 5.14265 8.68548 5.05102 8.98776C4.94684 9.33141 5.02134 9.74478 5.17036 10.5715L6.30865 16.8868C6.45767 17.7136 6.53218 18.1269 6.75019 18.4148C6.94196 18.6681 7.20878 18.8548 7.5124 18.9482C7.85756 19.0544 8.27146 18.9828 9.09917 18.8397L9.0992 18.8396L9.09923 18.8396L9.09925 18.8396L11.0738 18.498L11.0739 18.498C11.9016 18.3548 12.3155 18.2832 12.6027 18.0676C12.6534 18.0295 12.6317 17.9528 12.5692 17.9416L10.9879 17.6584L10.9878 17.6583C10.5821 17.5857 10.1983 17.517 9.87957 17.4343C9.53411 17.3446 9.14228 17.2097 8.77092 16.9426C8.24882 16.5669 7.84631 16.0363 7.63833 15.4145C7.48747 14.9635 7.48721 14.5391 7.51755 14.1847C7.54496 13.8645 7.6095 13.493 7.67511 13.1153L8.44959 8.65373Z", fill: "inherit" })), zu = V(Uu), qu = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M6.68483 1.57819C6.45554 1.86822 6.38257 2.2886 6.23662 3.12934L6.12835 3.75307C6.12774 3.75631 6.12717 3.75962 6.12652 3.76333L5.16012 9.33057C5.01418 10.1713 4.94121 10.5917 5.05902 10.9439C5.08374 11.0178 5.11419 11.0897 5.14991 11.1589C5.26392 11.3799 5.43192 11.5742 5.64104 11.7247C5.95325 11.9493 6.39914 12.0291 7.2909 12.1889L10.7966 12.8168C11.6884 12.9765 12.1343 13.0564 12.5033 12.9538C12.8279 12.8635 13.1114 12.6775 13.3131 12.4223C13.5423 12.1323 13.6153 11.7119 13.7613 10.8712L14.8377 4.66988C14.9837 3.82914 15.0566 3.40877 14.9388 3.05656C14.8352 2.74675 14.6315 2.47347 14.3568 2.27588C14.0446 2.05125 13.5987 1.97139 12.707 1.81166L9.20128 1.18376C8.30949 1.02403 7.8636 0.944169 7.49458 1.04678C7.16999 1.13704 6.88653 1.32306 6.68483 1.57819Z", fill: "inherit" }), /* @__PURE__ */ o.createElement("path", { d: "M4.48982 3.95294C4.54762 4.08878 4.51493 4.2771 4.44955 4.65373L3.67507 9.11534C3.60946 9.49297 3.54492 9.86449 3.51751 10.1847C3.48717 10.5391 3.48743 10.9635 3.63829 11.4145C3.84627 12.0363 4.24878 12.5669 4.77088 12.9426C5.14224 13.2097 5.53407 13.3446 5.87954 13.4343C6.19823 13.517 6.58206 13.5857 6.98785 13.6584L8.56914 13.9416C8.63161 13.9528 8.6534 14.0295 8.60264 14.0676C8.31547 14.2832 7.90158 14.3548 7.0738 14.498L5.09921 14.8396C4.27145 14.9828 3.85753 15.0544 3.51236 14.9482C3.20874 14.8548 2.94192 14.6681 2.75015 14.4149C2.53214 14.1269 2.45763 13.7136 2.30861 12.8868L1.17032 6.57154C1.0213 5.74478 0.946796 5.33141 1.05098 4.98776C1.14262 4.68548 1.32802 4.42053 1.58063 4.23089C1.8678 4.0153 2.28169 3.94369 3.10947 3.80049L3.52497 3.72861C3.90164 3.66345 4.08997 3.63087 4.22578 3.68875C4.34461 3.7394 4.43924 3.83408 4.48982 3.95294Z", fill: "inherit" })), $u = V(qu), Yu = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { cx: 10, cy: 10, r: 10, fill: "white" }), /* @__PURE__ */ o.createElement("path", { d: "M15.6832 7.44332L10.409 4.42196C10.1542 4.27601 9.84577 4.27601 9.59099 4.42196L4.31682 7.44332C4.17473 7.52472 4.05785 7.64682 3.97994 7.79526C3.75405 8.22561 3.90488 8.76578 4.31682 9.00177L5.1875 9.49881L9.56449 12.0134C9.83419 12.1684 10.1659 12.1685 10.4357 12.0138L14.083 9.91761L15.1038 9.33322L15.104 11.955C15.104 12.2495 15.3325 12.4882 15.6144 12.4882C15.8963 12.4882 16.1248 12.2495 16.1248 11.955L16.125 8.22235C16.1247 7.90868 15.965 7.60479 15.6832 7.44332Z", fill: "inherit" }), /* @__PURE__ */ o.createElement("path", { d: "M14.0831 11.2118L10.4189 13.2081C10.1578 13.3504 9.84228 13.3503 9.58125 13.2079L5.91672 11.2091L5.91681 12.1328C5.91681 14.1237 7.76586 15.6875 10 15.6875C12.2341 15.6875 14.0832 14.1237 14.0832 12.1328L14.0831 11.2118Z", fill: "inherit" })), Ku = V(Yu), Qu = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M3.25 5.75L15.0833 5.75C15.4975 5.75 15.8333 5.41421 15.8333 5C15.8333 4.58579 15.4975 4.25 15.0833 4.25L3.25 4.25C2.83579 4.25 2.5 4.58579 2.5 5C2.5 5.41422 2.83579 5.75 3.25 5.75Z", fill: "currentColor" }), /* @__PURE__ */ o.createElement("path", { d: "M3.25 8.41667C2.83579 8.41667 2.5 8.75245 2.5 9.16667C2.5 9.58088 2.83579 9.91667 3.25 9.91667L15.0833 9.91667C15.4975 9.91667 15.8333 9.58088 15.8333 9.16667C15.8333 8.75245 15.4975 8.41667 15.0833 8.41667L3.25 8.41667Z", fill: "currentColor" }), /* @__PURE__ */ o.createElement("path", { d: "M2.5 13.3333C2.5 12.9191 2.83579 12.5833 3.25 12.5833H7.58333C7.99755 12.5833 8.33333 12.9191 8.33333 13.3333C8.33333 13.7475 7.99755 14.0833 7.58333 14.0833H3.25C2.83579 14.0833 2.5 13.7475 2.5 13.3333Z", fill: "currentColor" }), /* @__PURE__ */ o.createElement("path", { d: "M18.9361 11.4088C19.2539 11.0758 19.2416 10.5483 18.9087 10.2306C18.5758 9.91278 18.0483 9.92504 17.7305 10.258L13.5606 14.6265L11.4361 12.4008C11.1183 12.0679 10.5909 12.0556 10.2579 12.3734C9.92502 12.6912 9.91276 13.2187 10.2305 13.5516L12.9578 16.4088C13.1151 16.5735 13.3329 16.6667 13.5606 16.6667C13.7883 16.6667 14.0062 16.5735 14.1634 16.4088L18.9361 11.4088Z", fill: "currentColor" })), Xu = V(Qu), Ju = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { className: "svg-substrate", cx: 12, cy: 12, r: 11, fill: "transparent" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM8.72713 6.15312C8.96891 6.48944 8.89228 6.95809 8.55596 7.19987C7.06268 8.27342 6.09266 10.0234 6.09266 12C6.09266 13.9766 7.06268 15.7266 8.55596 16.8001C8.89228 17.0419 8.96891 17.5106 8.72713 17.8469C8.48534 18.1832 8.01669 18.2598 7.68037 18.0181C5.81193 16.6748 4.59266 14.4798 4.59266 12C4.59266 9.52023 5.81193 7.32521 7.68037 5.98195C8.01669 5.74016 8.48534 5.8168 8.72713 6.15312ZM15.2729 6.15312C15.5147 5.8168 15.9833 5.74016 16.3196 5.98195C18.1881 7.32521 19.4073 9.52023 19.4073 12C19.4073 14.4798 18.1881 16.6748 16.3196 18.0181C15.9833 18.2598 15.5147 18.1832 15.2729 17.8469C15.0311 17.5106 15.1077 17.0419 15.444 16.8001C16.9373 15.7266 17.9073 13.9766 17.9073 12C17.9073 10.0234 16.9373 8.27342 15.444 7.19987C15.1077 6.95809 15.0311 6.48944 15.2729 6.15312ZM14.9474 8.07172C14.6163 7.82292 14.1461 7.88968 13.8973 8.22084C13.6485 8.552 13.7153 9.02216 14.0464 9.27097C14.8751 9.89357 15.4109 10.8835 15.4109 12C15.4109 13.1153 14.8764 14.1055 14.0464 14.7291C13.7153 14.9779 13.6485 15.448 13.8973 15.7792C14.1461 16.1104 14.6163 16.1771 14.9474 15.9283C16.1383 15.0336 16.9109 13.6069 16.9109 12C16.9109 10.3943 16.1396 8.96738 14.9474 8.07172ZM9.05262 8.07172C9.38378 7.82292 9.85394 7.88968 10.1027 8.22084C10.3516 8.552 10.2848 9.02216 9.95363 9.27097C9.12495 9.89357 8.58919 10.8835 8.58919 12C8.58919 13.1165 9.12496 14.1065 9.95363 14.7291C10.2848 14.9779 10.3516 15.448 10.1027 15.7792C9.85394 16.1104 9.38378 16.1771 9.05262 15.9283C7.86051 15.0326 7.08919 13.6057 7.08919 12C7.08919 10.3943 7.86051 8.96738 9.05262 8.07172ZM12 13.6643C12.9192 13.6643 13.6643 12.9191 13.6643 11.9999C13.6643 11.0807 12.9192 10.3356 12 10.3356C11.0808 10.3356 10.3356 11.0807 10.3356 11.9999C10.3356 12.9191 11.0808 13.6643 12 13.6643Z", fill: "inherit" })), ed = V(Ju), td = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M6.12515 5.17927C6.50159 4.85467 6.54361 4.28638 6.21902 3.90994C5.89442 3.53351 5.32612 3.49148 4.94969 3.81608L4.88357 3.87356C4.70453 4.03048 4.53073 4.19322 4.36247 4.36148C2.40904 6.31491 1.19922 9.01615 1.19922 11.9982C1.19922 14.9803 2.40904 17.6816 4.36247 19.635C4.55137 19.8239 4.74725 20.0058 4.94969 20.1804C5.32612 20.505 5.89442 20.463 6.21901 20.0865C6.54361 19.7101 6.50159 19.1418 6.12515 18.8172C5.95628 18.6716 5.79286 18.5198 5.63526 18.3622C4.00559 16.7325 2.99922 14.4838 2.99922 11.9982C2.99922 9.51271 4.00559 7.26394 5.63526 5.63427C5.77564 5.49389 5.92064 5.35812 6.06999 5.22722L6.12515 5.17927Z" }), /* @__PURE__ */ o.createElement("path", { d: "M19.0487 3.81608C18.6723 3.49148 18.104 3.53351 17.7794 3.90994C17.4548 4.28638 17.4969 4.85467 17.8733 5.17927C18.0422 5.32488 18.2056 5.47667 18.3632 5.63427C19.9928 7.26394 20.9992 9.51271 20.9992 11.9982C20.9992 14.4838 19.9928 16.7325 18.3632 18.3622C18.2056 18.5198 18.0422 18.6716 17.8733 18.8172C17.4969 19.1418 17.4548 19.7101 17.7794 20.0865C18.104 20.463 18.6723 20.505 19.0487 20.1804C19.2512 20.0058 19.4471 19.8239 19.636 19.635C21.5894 17.6816 22.7992 14.9803 22.7992 11.9982C22.7992 9.01615 21.5894 6.31491 19.636 4.36148C19.4471 4.17258 19.2512 3.99063 19.0487 3.81608Z" }), /* @__PURE__ */ o.createElement("path", { d: "M8.14489 8.2161C8.49305 7.86134 8.48769 7.29152 8.13294 6.94336C7.77818 6.59521 7.20836 6.60056 6.8602 6.95532C5.58633 8.25334 4.79922 10.0347 4.79922 11.9982C4.79922 13.9616 5.58633 15.743 6.8602 17.0411C7.20836 17.3958 7.77818 17.4012 8.13294 17.053C8.48769 16.7049 8.49305 16.135 8.14489 15.7803C7.1879 14.8051 6.59922 13.4713 6.59922 11.9982C6.59922 10.5251 7.1879 9.19123 8.14489 8.2161Z" }), /* @__PURE__ */ o.createElement("path", { d: "M17.1382 6.95532C16.7901 6.60056 16.2203 6.59521 15.8655 6.94336C15.5107 7.29152 15.5054 7.86134 15.8535 8.2161C16.8105 9.19123 17.3992 10.5251 17.3992 11.9982C17.3992 13.4713 16.8105 14.8051 15.8535 15.7803C15.5054 16.135 15.5107 16.7049 15.8655 17.053C16.2203 17.4012 16.7901 17.3958 17.1382 17.0411C18.4121 15.743 19.1992 13.9616 19.1992 11.9982C19.1992 10.0347 18.4121 8.25334 17.1382 6.95532Z" }), /* @__PURE__ */ o.createElement("path", { d: "M14.4069 11.998C14.4069 13.3275 13.3291 14.4053 11.9995 14.4053C10.67 14.4053 9.59219 13.3275 9.59219 11.998C9.59219 10.6684 10.67 9.59063 11.9995 9.59063C13.3291 9.59063 14.4069 10.6684 14.4069 11.998Z" })), nd = V(td), rd = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.273 2.15312C11.5148 1.8168 11.9834 1.74016 12.3197 1.98195C14.1882 3.32521 15.4075 5.52023 15.4075 8.00001C15.4075 10.4798 14.1882 12.6748 12.3197 14.0181C11.9834 14.2598 11.5148 14.1832 11.273 13.8469C11.0312 13.5106 11.1078 13.0419 11.4442 12.8001C12.9374 11.7266 13.9075 9.97659 13.9075 8.00001C13.9075 6.02343 12.9374 4.27343 11.4442 3.19988C11.1078 2.95809 11.0312 2.48944 11.273 2.15312Z", fill: "inherit" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.72724 2.15312C4.96903 2.48944 4.8924 2.95809 4.55608 3.19988C3.0628 4.27343 2.09277 6.02343 2.09277 8.00001C2.09277 9.97659 3.0628 11.7266 4.55608 12.8001C4.8924 13.0419 4.96903 13.5106 4.72724 13.8469C4.48546 14.1832 4.01681 14.2598 3.68049 14.0181C1.81205 12.6748 0.592773 10.4798 0.592773 8.00001C0.592773 5.52023 1.81205 3.32521 3.68049 1.98195C4.01681 1.74016 4.48546 1.8168 4.72724 2.15312Z", fill: "inherit" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.89744 4.22084C10.1462 3.88968 10.6164 3.82292 10.9476 4.07173C12.1397 4.96738 12.911 6.39434 12.911 8.00002C12.911 9.60694 12.1384 11.0336 10.9476 11.9283C10.6164 12.1771 10.1462 12.1104 9.89744 11.7792C9.64863 11.448 9.71539 10.9779 10.0466 10.7291C10.8765 10.1055 11.411 9.11529 11.411 8.00002C11.411 6.88351 10.8752 5.89357 10.0466 5.27097C9.71539 5.02216 9.64863 4.552 9.89744 4.22084Z", fill: "inherit" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.05274 4.07173C5.3839 3.82292 5.85405 3.88968 6.10286 4.22084C6.35167 4.552 6.28491 5.02216 5.95375 5.27097C5.12507 5.89357 4.58931 6.88351 4.58931 8.00002C4.58931 9.11653 5.12507 10.1065 5.95375 10.7291C6.28491 10.9779 6.35167 11.448 6.10286 11.7792C5.85405 12.1104 5.3839 12.1771 5.05274 11.9283C3.86062 11.0327 3.08931 9.60569 3.08931 8.00002C3.08931 6.39434 3.86063 4.96738 5.05274 4.07173Z", fill: "inherit" }), /* @__PURE__ */ o.createElement("path", { d: "M9.66443 7.99992C9.66443 8.91911 8.91928 9.66426 8.0001 9.66426C7.08091 9.66426 6.33576 8.91911 6.33576 7.99992C6.33576 7.08074 7.08091 6.33559 8.0001 6.33559C8.91928 6.33559 9.66443 7.08074 9.66443 7.99992Z", fill: "inherit" })), ad = V(rd), id = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M12 23C11.5858 23 11.25 22.6642 11.25 22.25C11.25 21.8358 11.5858 21.5 12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 13.1042 2.68811 14.1815 3.05169 15.1986C3.19112 15.5886 2.98797 16.0178 2.59793 16.1573C2.20789 16.2967 1.77867 16.0935 1.63923 15.7035C1.21793 14.525 1 13.2769 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23Z" })), od = V(id), sd = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.0001 13.0001C12.5524 13.0001 13.0001 13.4478 13.0001 14.0001V16.0001C13.0001 16.5524 12.5524 17.0001 12.0001 17.0001C11.4478 17.0001 11.0001 16.5524 11.0001 16.0001V14.0001C11.0001 13.4478 11.4478 13.0001 12.0001 13.0001Z" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.7707 8.52517C18.1922 8.23044 17.5404 8.15252 16.9001 8.12224V7.0001C16.9001 4.2939 14.7063 2.1001 12.0001 2.1001C9.2939 2.1001 7.1001 4.2939 7.1001 7.0001V8.12224C6.45982 8.15252 5.80799 8.23044 5.22954 8.52517C4.4957 8.89908 3.89908 9.4957 3.52517 10.2295C3.28626 10.6984 3.18938 11.2005 3.14396 11.7564C3.10008 12.2935 3.10009 12.9543 3.1001 13.7624V16.2378C3.10009 17.0459 3.10008 17.7067 3.14396 18.2438C3.18938 18.7997 3.28626 19.3018 3.52517 19.7707C3.89908 20.5045 4.4957 21.1011 5.22954 21.475C5.69843 21.7139 6.2005 21.8108 6.75642 21.8562C7.29349 21.9001 7.95434 21.9001 8.76239 21.9001H15.2378C16.0459 21.9001 16.7067 21.9001 17.2438 21.8562C17.7997 21.8108 18.3018 21.7139 18.7707 21.475C19.5045 21.1011 20.1011 20.5045 20.475 19.7707C20.7139 19.3018 20.8108 18.7997 20.8562 18.2438C20.9001 17.7067 20.9001 17.0459 20.9001 16.2378V13.7624C20.9001 12.9543 20.9001 12.2935 20.8562 11.7564C20.8108 11.2005 20.7139 10.6984 20.475 10.2295C20.1011 9.4957 19.5045 8.89908 18.7707 8.52517ZM6.90299 9.93798C6.45839 9.97431 6.21957 10.0409 6.04672 10.129C5.65158 10.3303 5.33032 10.6516 5.12898 11.0467C5.04091 11.2196 4.97431 11.4584 4.93798 11.903C4.9008 12.3581 4.9001 12.9452 4.9001 13.8001V16.2001C4.9001 17.055 4.9008 17.6421 4.93798 18.0972C4.97431 18.5418 5.04091 18.7806 5.12898 18.9535C5.33032 19.3486 5.65158 19.6699 6.04672 19.8712C6.21957 19.9593 6.45839 20.0259 6.90299 20.0622C7.3581 20.0994 7.94517 20.1001 8.8001 20.1001H15.2001C16.055 20.1001 16.6421 20.0994 17.0972 20.0622C17.5418 20.0259 17.7806 19.9593 17.9535 19.8712C18.3486 19.6699 18.6699 19.3486 18.8712 18.9535C18.9593 18.7806 19.0259 18.5418 19.0622 18.0972C19.0994 17.6421 19.1001 17.055 19.1001 16.2001V13.8001C19.1001 12.9452 19.0994 12.3581 19.0622 11.903C19.0259 11.4584 18.9593 11.2196 18.8712 11.0467C18.6699 10.6516 18.3486 10.3303 17.9535 10.129C17.7806 10.0409 17.5418 9.97431 17.0972 9.93798C16.6421 9.9008 16.055 9.9001 15.2001 9.9001H8.8001C7.94517 9.9001 7.3581 9.9008 6.90299 9.93798ZM15.1001 7.0001C15.1001 5.28802 13.7122 3.9001 12.0001 3.9001C10.288 3.9001 8.9001 5.28802 8.9001 7.0001V8.1001H15.1001V7.0001Z" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.0001 14.0001C13.0001 13.4478 12.5524 13.0001 12.0001 13.0001C11.4478 13.0001 11.0001 13.4478 11.0001 14.0001V16.0001C11.0001 16.5524 11.4478 17.0001 12.0001 17.0001C12.5524 17.0001 13.0001 16.5524 13.0001 16.0001V14.0001Z" })), ld = V(sd), cd = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.0802 3.83992C4.61039 3.44228 5.36255 3.54973 5.76019 4.07992L8.52796 7.77028C9.61767 7.40053 10.7855 7.2 12.0002 7.2C13.2149 7.2 14.3827 7.40053 15.4724 7.77028L18.2402 4.07992C18.6378 3.54973 19.39 3.44228 19.9202 3.83992C20.4504 4.23757 20.5578 4.98973 20.1602 5.51992L17.6874 8.81698C20.7565 10.7218 22.8002 14.1222 22.8002 18H1.2002C1.2002 14.1222 3.24391 10.7218 6.31299 8.81698L3.8402 5.51992C3.44255 4.98973 3.55 4.23757 4.0802 3.83992ZM15.6825 13.2C16.3453 13.2 16.8825 12.6627 16.8825 12C16.8825 11.3373 16.3453 10.8 15.6825 10.8C15.0198 10.8 14.4825 11.3373 14.4825 12C14.4825 12.6627 15.0198 13.2 15.6825 13.2ZM9.68252 12C9.68252 12.6627 9.14526 13.2 8.48252 13.2C7.81978 13.2 7.28252 12.6627 7.28252 12C7.28252 11.3373 7.81978 10.8 8.48252 10.8C9.14526 10.8 9.68252 11.3373 9.68252 12Z", fill: "currentColor" })), ud = V(cd), dd = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M17.6648 14.031C17.3775 14.66 17.0375 15.2389 16.6435 15.7711C16.1065 16.4967 15.6668 16.999 15.328 17.2779C14.8027 17.7357 14.2399 17.9701 13.6372 17.9835C13.2045 17.9835 12.6828 17.8668 12.0754 17.6301C11.4661 17.3946 10.9061 17.2779 10.3941 17.2779C9.85705 17.2779 9.28111 17.3946 8.66508 17.6301C8.04811 17.8668 7.55108 17.9901 7.17107 18.0024C6.59314 18.0257 6.01709 17.7846 5.4421 17.2779C5.0751 16.9745 4.61607 16.4545 4.06616 15.7178C3.47616 14.9311 2.99109 14.0188 2.61108 12.9788C2.20411 11.8554 2.00009 10.7675 2.00009 9.71438C2.00009 8.50799 2.27516 7.46749 2.82612 6.59556C3.25913 5.89519 3.83518 5.34272 4.55615 4.93714C5.27713 4.53156 6.05614 4.32489 6.89507 4.31166C7.3541 4.31166 7.95606 4.44623 8.70412 4.71068C9.45007 4.97603 9.92904 5.11059 10.139 5.11059C10.296 5.11059 10.8281 4.95325 11.7301 4.63957C12.5831 4.34867 13.303 4.22821 13.8928 4.27566C15.4909 4.39789 16.6916 4.99492 17.4901 6.07053C16.0608 6.89124 15.3537 8.04074 15.3678 9.51537C15.3807 10.664 15.8204 11.6198 16.6845 12.3787C17.0762 12.731 17.5135 13.0032 18.0001 13.1966C17.8946 13.4866 17.7832 13.7644 17.6648 14.031ZM13.9995 0.362573C13.9995 1.26285 13.6524 2.10344 12.9607 2.88148C12.1258 3.80642 11.1161 4.34089 10.0211 4.25655C10.0071 4.14854 9.99904 4.03487 9.99904 3.91542C9.99904 3.05115 10.396 2.12622 11.1011 1.36996C11.4531 0.987049 11.9007 0.668667 12.4436 0.414686C12.9853 0.164496 13.4977 0.0261351 13.9796 0.00244141C13.9936 0.122795 13.9995 0.243167 13.9995 0.362573Z", fill: "inherit" })), fd = V(dd), hd = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { id: "Icon Color", fillRule: "evenodd", clipRule: "evenodd", d: "M9.53781 2.60253C9.76787 2.46803 10.052 2.46571 10.2843 2.59644L16.1176 5.88022C16.3509 6.01156 16.4965 6.25729 16.4996 6.525C16.5028 6.7927 16.363 7.04178 16.1328 7.17855L11.0775 10.1824L16.1328 13.1863C16.3686 13.3264 16.5091 13.5841 16.4992 13.8581C16.4893 14.1322 16.3306 14.3791 16.0853 14.5018L10.252 17.4207C10.0195 17.5371 9.74331 17.5247 9.52214 17.388C9.30097 17.2514 9.16634 17.01 9.16634 16.75V11.3181L4.46613 14.111C4.23433 14.2487 3.94644 14.2514 3.71209 14.1181C3.47774 13.9847 3.33301 13.7358 3.33301 13.4662V6.89865C3.33301 6.62902 3.47774 6.38014 3.71209 6.24679C3.94644 6.11344 4.23433 6.11615 4.46613 6.25389L9.16634 9.04679V3.25C9.16634 2.98351 9.30775 2.73703 9.53781 2.60253ZM8.14113 10.1824L4.83301 8.21672V12.1481L8.14113 10.1824ZM10.6663 11.6829L14.1865 13.7746L10.6663 15.5361V11.6829ZM10.6663 8.68193V4.53287L14.2519 6.55133L10.6663 8.68193Z" })), pd = V(hd), md = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M1.42856 10V3.8243L8.57142 2.85645V10H1.42856V10ZM9.2857 10H18.5714V1.42859L9.2857 2.7193V10ZM8.57142 10.7143H1.42856V16.1757L8.57142 17.1436V10.7143V10.7143ZM9.2857 10.7143V17.2814L18.5714 18.5714V10.7143H9.2857V10.7143Z", fill: "inherit" })), Cd = V(md), gd = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.31739 2L9.25 2C9.66421 2 10 2.33579 10 2.75C10 3.16421 9.66421 3.5 9.25 3.5L8.35 3.5C7.35753 3.5 6.65829 3.50058 6.11228 3.54519C5.57503 3.58909 5.25252 3.67184 5.00152 3.79973C4.48408 4.06338 4.06338 4.48408 3.79973 5.00153C3.67184 5.25252 3.58909 5.57503 3.54519 6.11228C3.50058 6.65829 3.5 7.35753 3.5 8.35V11.65C3.5 12.6425 3.50058 13.3417 3.54519 13.8877C3.58909 14.425 3.67184 14.7475 3.79973 14.9985C4.06338 15.5159 4.48408 15.9366 5.00152 16.2003C5.25252 16.3282 5.57503 16.4109 6.11228 16.4548C6.65829 16.4994 7.35753 16.5 8.35 16.5H9.24536C9.65957 16.5 9.99536 16.8358 9.99536 17.25C9.99536 17.6642 9.65958 18 9.24536 18H8.31737C7.36493 18 6.60439 18 5.99013 17.9498C5.36012 17.8984 4.81824 17.7904 4.32054 17.5368C3.52085 17.1293 2.87068 16.4791 2.46322 15.6795C2.20963 15.1818 2.10165 14.6399 2.05017 14.0099C1.99999 13.3956 1.99999 12.6351 2 11.6826V8.31739C1.99999 7.36494 1.99999 6.6044 2.05017 5.99013C2.10165 5.36012 2.20963 4.81824 2.46322 4.32054C2.87068 3.52085 3.52085 2.87068 4.32054 2.46322C4.81823 2.20963 5.36012 2.10165 5.99013 2.05018C6.60439 1.99999 7.36494 1.99999 8.31739 2ZM14.2197 6.96967C14.5126 6.67678 14.9874 6.67678 15.2803 6.96967L17.7803 9.46965C17.921 9.6103 18 9.80107 18 9.99998C18 10.1989 17.921 10.3897 17.7803 10.5303L15.2803 13.0303C14.9874 13.3232 14.5126 13.3232 14.2197 13.0303C13.9268 12.7374 13.9268 12.2626 14.2197 11.9697L15.4393 10.75L8.75 10.75C8.33579 10.75 8 10.4142 8 10C8 9.58579 8.33578 9.25 8.75 9.25L15.4393 9.24999L14.2197 8.03033C13.9268 7.73744 13.9268 7.26257 14.2197 6.96967Z" })), vd = V(gd), wd = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { id: "â³ Icon Color", fillRule: "evenodd", clipRule: "evenodd", d: "M7.8001 4.1001H7.7624H7.76237C6.95433 4.10009 6.29349 4.10008 5.75642 4.14396C5.2005 4.18938 4.69842 4.28626 4.22954 4.52517C3.4957 4.89908 2.89908 5.4957 2.52517 6.22954C2.28626 6.69842 2.18938 7.2005 2.14396 7.75642C2.10008 8.29349 2.10009 8.95433 2.1001 9.76238V9.7624V9.8001V14.2001V14.2378V14.2378C2.10009 15.0459 2.10008 15.7067 2.14396 16.2438C2.18938 16.7997 2.28626 17.3018 2.52517 17.7707C2.89908 18.5045 3.4957 19.1011 4.22954 19.475C4.69842 19.7139 5.2005 19.8108 5.75642 19.8562C6.29349 19.9001 6.95434 19.9001 7.76239 19.9001H7.8001H16.2001H16.2378C17.0459 19.9001 17.7067 19.9001 18.2438 19.8562C18.7997 19.8108 19.3018 19.7139 19.7707 19.475C20.5045 19.1011 21.1011 18.5045 21.475 17.7707C21.7139 17.3018 21.8108 16.7997 21.8562 16.2438C21.9001 15.7067 21.9001 15.0459 21.9001 14.2378V14.2001V9.8001V9.76239C21.9001 8.95434 21.9001 8.29349 21.8562 7.75642C21.8108 7.2005 21.7139 6.69842 21.475 6.22954C21.1011 5.4957 20.5045 4.89908 19.7707 4.52517C19.3018 4.28626 18.7997 4.18938 18.2438 4.14396C17.7067 4.10008 17.0459 4.10009 16.2378 4.1001H16.2378H16.2001H7.8001ZM5.38073 6.01226C5.5163 5.98091 5.68489 5.9558 5.90299 5.93798C6.3581 5.9008 6.94517 5.9001 7.8001 5.9001H16.2001C17.055 5.9001 17.6421 5.9008 18.0972 5.93798C18.3153 5.9558 18.4839 5.98091 18.6195 6.01226L14.6104 9.52018C14.0326 10.0258 13.637 10.3711 13.3075 10.6175C12.9871 10.8571 12.7833 10.9606 12.607 11.0128C12.2109 11.1299 11.7893 11.1299 11.3932 11.0128C11.2169 10.9606 11.0131 10.8571 10.6926 10.6175C10.3632 10.3711 9.9676 10.0258 9.38979 9.52019L5.38073 6.01226ZM4.0505 7.24009C4.00096 7.39577 3.96255 7.60233 3.93798 7.90299C3.9008 8.3581 3.9001 8.94517 3.9001 9.8001V14.2001C3.9001 15.055 3.9008 15.6421 3.93798 16.0972C3.97431 16.5418 4.04092 16.7806 4.12898 16.9535C4.33032 17.3486 4.65158 17.6699 5.04672 17.8712C5.21956 17.9593 5.45839 18.0259 5.90299 18.0622C6.3581 18.0994 6.94517 18.1001 7.8001 18.1001H16.2001C17.055 18.1001 17.6421 18.0994 18.0972 18.0622C18.5418 18.0259 18.7806 17.9593 18.9535 17.8712C19.3486 17.6699 19.6699 17.3486 19.8712 16.9535C19.9593 16.7806 20.0259 16.5418 20.0622 16.0972C20.0994 15.6421 20.1001 15.055 20.1001 14.2001V9.8001C20.1001 8.94517 20.0994 8.3581 20.0622 7.90299C20.0377 7.60233 19.9992 7.39577 19.9497 7.24009L15.7957 10.8748L15.7695 10.8978C15.2244 11.3748 14.7769 11.7663 14.3855 12.059C13.9789 12.3631 13.5797 12.6022 13.1174 12.7389C12.3882 12.9546 11.612 12.9546 10.8828 12.7389C10.4205 12.6022 10.0213 12.3631 9.61468 12.059C9.22329 11.7663 8.77586 11.3748 8.23074 10.8978L8.20448 10.8748L4.0505 7.24009Z" })), yd = V(wd), bd = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.57744 2.5H13.4226C15.1963 2.5 15.8413 2.68056 16.4902 3.0283C17.1293 3.3708 17.6309 3.8734 17.9728 4.51382C18.3198 5.16404 18.5 5.8103 18.5 7.58756V12.4124C18.5 14.1897 18.3198 14.836 17.9728 15.4862C17.6309 16.1266 17.1293 16.6292 16.4902 16.9717C15.8413 17.3194 15.1963 17.5 13.4226 17.5H6.57744C4.80372 17.5 4.15874 17.3194 3.50981 16.9717C2.87067 16.6292 2.36906 16.1266 2.02725 15.4862C1.6802 14.836 1.5 14.1897 1.5 12.4124V7.58756C1.5 5.8103 1.6802 5.16404 2.02725 4.51382C2.36906 3.8734 2.87067 3.3708 3.50981 3.0283C4.15874 2.68056 4.80372 2.5 6.57744 2.5ZM3 12.4124V7.58756C3 5.98996 3.1558 5.5912 3.3294 5.26007L7.79301 9.72368C8.07257 10.0033 8.31375 10.2445 8.52863 10.4269C8.75542 10.6194 9.00178 10.7901 9.30469 10.8885C9.75658 11.0354 10.2434 11.0354 10.6953 10.8885C10.9982 10.7901 11.2445 10.6194 11.4713 10.4269C11.6862 10.2445 11.9274 10.0033 12.2069 9.72369L16.6706 5.26005C16.8442 5.59119 17 5.98993 17 7.58756V12.4124C17 14.0747 16.8313 14.4391 16.6495 14.7799C16.4471 15.1591 16.1592 15.4473 15.7817 15.6496C15.4429 15.8311 15.0807 16 13.4226 16H6.57744C4.91934 16 4.55712 15.8311 4.21831 15.6496C3.84076 15.4473 3.55295 15.1591 3.35055 14.7799C3.16867 14.4391 3 14.0747 3 12.4124ZM13.4226 4H6.57744C5.25129 4 4.75409 4.10802 4.43482 4.24417L8.83325 8.6426C9.13901 8.94836 9.33685 9.14538 9.49939 9.28336C9.65524 9.41566 9.72863 9.4491 9.76821 9.46196C9.91885 9.5109 10.0811 9.5109 10.2317 9.46196C10.2713 9.4491 10.3447 9.41566 10.5006 9.28336C10.6631 9.14538 10.8609 8.94836 11.1667 8.6426L15.5652 4.24416C15.2459 4.10802 14.7487 4 13.4226 4Z", fill: "inherit" })), _d = V(bd), xd = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M18.1321 6.85721C19.2784 6.85721 19.694 6.97656 20.1131 7.20067C20.5321 7.42478 20.861 7.75365 21.0851 8.1727L21.1642 8.33111C21.3372 8.70707 21.4286 9.15068 21.4286 10.1536V16.2423L21.424 16.7406C21.3908 18.4708 21.1755 19.1698 20.7989 19.8741C20.388 20.6423 19.7851 21.2452 19.0168 21.6561C18.2486 22.067 17.4865 22.2858 15.3851 22.2858H8.61485L8.11662 22.2812C6.38637 22.248 5.68736 22.0327 4.98313 21.6561C4.21488 21.2452 3.61195 20.6423 3.20108 19.8741C2.80733 19.1378 2.58998 18.4073 2.57255 16.4981L2.57141 10.1536C2.57141 9.0074 2.69076 8.59175 2.91487 8.1727C3.13898 7.75365 3.46785 7.42478 3.8869 7.20067L4.04531 7.12157C4.39442 6.96094 4.80185 6.87068 5.6613 6.85861L18.1321 6.85721ZM18.1321 8.5715H5.86783L5.5655 8.57386C5.02661 8.58347 4.86158 8.62345 4.69535 8.71235C4.57505 8.77669 4.49089 8.86085 4.42655 8.98115C4.33024 9.16123 4.29134 9.3399 4.28628 9.99403L4.2857 16.2423C4.2857 17.8995 4.3968 18.4748 4.71276 19.0656C4.96386 19.5351 5.32208 19.8933 5.79159 20.1444C6.38238 20.4604 6.95773 20.5715 8.61485 20.5715H15.3851C17.0422 20.5715 17.6176 20.4604 18.2084 20.1444C18.6779 19.8933 19.0361 19.5351 19.2872 19.0656C19.6032 18.4748 19.7143 17.8995 19.7143 16.2423V10.1536C19.7143 9.36738 19.6771 9.17508 19.5734 8.98115C19.5091 8.86085 19.4249 8.77669 19.3046 8.71235C19.1384 8.62345 18.9734 8.58347 18.4345 8.57386L18.1321 8.5715ZM16.2857 10.2858C16.7591 10.2858 17.1428 10.6695 17.1428 11.1429C17.1428 11.6163 16.7591 12.0001 16.2857 12.0001C15.8123 12.0001 15.4286 11.6163 15.4286 11.1429C15.4286 10.6695 15.8123 10.2858 16.2857 10.2858ZM7.71427 10.2858C8.18766 10.2858 8.57141 10.6695 8.57141 11.1429C8.57141 11.6163 8.18766 12.0001 7.71427 12.0001C7.24088 12.0001 6.85713 11.6163 6.85713 11.1429C6.85713 10.6695 7.24088 10.2858 7.71427 10.2858ZM12 1.71436C14.8403 1.71436 17.1428 4.01689 17.1428 6.85721H15.4286C15.4286 4.96367 13.8935 3.42864 12 3.42864C10.1064 3.42864 8.57141 4.96367 8.57141 6.85721H6.85713C6.85713 4.01689 9.15966 1.71436 12 1.71436Z", fill: "inherit" })), Ld = V(xd), Ed = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M11.9996 1.10156C14.761 1.10156 16.9996 3.34014 16.9996 6.10156H17.0538C18.3911 6.10156 18.876 6.2408 19.3649 6.50226C19.8538 6.76372 20.2374 7.14741 20.4989 7.63629C20.7604 8.12518 20.8996 8.61011 20.8996 9.94739V14.8359C20.8996 16.925 20.6791 17.6975 20.2652 18.4716C19.8512 19.2456 19.2437 19.8531 18.4696 20.2671C17.6955 20.6811 16.923 20.9016 14.834 20.9016H9.16526C7.0762 20.9016 6.30367 20.6811 5.5296 20.2671C4.75553 19.8531 4.14803 19.2456 3.73405 18.4716C3.32007 17.6975 3.09961 16.925 3.09961 14.8359V9.94739C3.09961 8.61011 3.23885 8.12518 3.50031 7.63629C3.76177 7.14741 4.14545 6.76372 4.63434 6.50226C5.12323 6.2408 5.60816 6.10156 6.94544 6.10156H6.99961C6.99961 3.34014 9.23818 1.10156 11.9996 1.10156ZM17.2465 7.90233L6.94544 7.90156C5.99795 7.90156 5.74241 7.95091 5.48322 8.08953C5.30801 8.18323 5.18127 8.30997 5.08757 8.48517C4.94896 8.74436 4.89961 8.9999 4.89961 9.94739V14.8359C4.89961 16.4709 5.01014 17.0408 5.32131 17.6227C5.56753 18.0831 5.91809 18.4336 6.37848 18.6799C6.96033 18.991 7.53024 19.1016 9.16526 19.1016H14.834C16.469 19.1016 17.0389 18.991 17.6207 18.6799C18.0811 18.4336 18.4317 18.0831 18.6779 17.6227C18.9891 17.0408 19.0996 16.4709 19.0996 14.8359V9.94739C19.0996 8.9999 19.0503 8.74436 18.9116 8.48517C18.8179 8.30997 18.6912 8.18323 18.516 8.08953C18.2753 7.96081 18.0378 7.90907 17.2465 7.90233ZM15.9456 9.00156C16.151 9.00156 16.2937 9.03637 16.4159 9.10174C16.5381 9.1671 16.6341 9.26302 16.6994 9.38525C16.7648 9.50747 16.7996 9.65019 16.7996 9.85555V9.94757C16.7996 10.1529 16.7648 10.2957 16.6994 10.4179C16.6341 10.5401 16.5381 10.636 16.4159 10.7014C16.2937 10.7668 16.151 10.8016 15.9456 10.8016H15.8536C15.6482 10.8016 15.5055 10.7668 15.3833 10.7014C15.2611 10.636 15.1651 10.5401 15.0998 10.4179C15.0344 10.2957 14.9996 10.1529 14.9996 9.94757V9.85555C14.9996 9.65019 15.0344 9.50747 15.0998 9.38525C15.1651 9.26302 15.2611 9.1671 15.3833 9.10174C15.5055 9.03637 15.6482 9.00156 15.8536 9.00156H15.9456ZM7.94562 9.00156C8.15098 9.00156 8.2937 9.03637 8.41593 9.10174C8.53815 9.1671 8.63407 9.26302 8.69943 9.38525C8.7648 9.50747 8.79961 9.65019 8.79961 9.85555V9.94757C8.79961 10.1529 8.7648 10.2957 8.69943 10.4179C8.63407 10.5401 8.53815 10.636 8.41593 10.7014C8.2937 10.7668 8.15098 10.8016 7.94562 10.8016H7.8536C7.64824 10.8016 7.50551 10.7668 7.38329 10.7014C7.26107 10.636 7.16515 10.5401 7.09978 10.4179C7.03442 10.2957 6.99961 10.1529 6.99961 9.94757V9.85555C6.99961 9.65019 7.03442 9.50747 7.09978 9.38525C7.16515 9.26302 7.26107 9.1671 7.38329 9.10174C7.50551 9.03637 7.64824 9.00156 7.8536 9.00156H7.94562ZM11.9996 2.90156C10.2323 2.90156 8.79961 4.33425 8.79961 6.10156H15.1996C15.1996 4.33425 13.7669 2.90156 11.9996 2.90156Z" })), Md = V(Ed), kd = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 7.5C8 4.18629 10.6863 1.5 14 1.5C17.3137 1.5 20 4.18629 20 7.5H21.2667C22.5735 7.5 23.2269 7.5 23.726 7.75432C24.165 7.97802 24.522 8.33498 24.7457 8.77402C25 9.27315 25 9.92654 25 11.2333V15.352C25 18.7291 25 20.4177 24.3428 21.7076C23.7647 22.8422 22.8422 23.7647 21.7076 24.3428C20.4177 25 18.7291 25 15.352 25H12.648C9.27088 25 7.58232 25 6.29244 24.3428C5.15782 23.7647 4.23535 22.8422 3.65723 21.7076C3 20.4177 3 18.7291 3 15.352V11.2333C3 9.92654 3 9.27315 3.25432 8.77402C3.47802 8.33498 3.83498 7.97802 4.27402 7.75432C4.77315 7.5 5.42654 7.5 6.73333 7.5H8ZM18 7.5C18 5.29086 16.2091 3.5 14 3.5C11.7909 3.5 10 5.29086 10 7.5H18ZM10.25 11.25C10.25 11.9404 9.69036 12.5 9 12.5C8.30964 12.5 7.75 11.9404 7.75 11.25C7.75 10.5596 8.30964 10 9 10C9.69036 10 10.25 10.5596 10.25 11.25ZM19 12.5C19.6904 12.5 20.25 11.9404 20.25 11.25C20.25 10.5596 19.6904 10 19 10C18.3096 10 17.75 10.5596 17.75 11.25C17.75 11.9404 18.3096 12.5 19 12.5Z" })), Sd = V(kd), Ad = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { className: "svg-substrate", cx: 12, cy: 12, r: 11, fill: "transparent" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM6.01289 7C5.45349 7 5 7.45349 5 8.01289C5 8.57229 5.45349 9.02577 6.01289 9.02577H7.39491V12.8026C7.39491 13.362 7.84839 13.8154 8.40779 13.8154C8.9672 13.8154 9.42068 13.362 9.42068 12.8026V9.02577L10.8025 9.02578C11.3619 9.02578 11.8154 8.57229 11.8154 8.01289C11.8154 7.45349 11.3619 7 10.8025 7L6.01289 7ZM13.7961 10.2232H17.987C18.5464 10.2232 18.9999 9.76972 18.9999 9.21031C18.9999 8.65091 18.5464 8.19743 17.987 8.19743H13.7961C13.2367 8.19743 12.7832 8.65091 12.7832 9.21031C12.7832 9.76972 13.2367 10.2232 13.7961 10.2232ZM11.4013 11.7897C10.8419 11.7897 10.3884 12.2431 10.3884 12.8026C10.3884 13.362 10.8419 13.8154 11.4013 13.8154H17.9871C18.5465 13.8154 19 13.362 19 12.8026C19 12.2432 18.5465 11.7897 17.9871 11.7897H11.4013ZM8.40779 17.4077L17.9871 17.4077C18.5465 17.4077 19 16.9542 19 16.3948C19 15.8354 18.5465 15.3819 17.9871 15.3819L8.40779 15.3819C7.84839 15.3819 7.39491 15.8354 7.39491 16.3948C7.39491 16.9542 7.84839 17.4077 8.40779 17.4077Z", fill: "inherit" })), Td = V(Ad), Id = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 4.01289C1 3.45349 1.45349 3 2.01289 3L6.80255 3C7.36195 3 7.81543 3.45349 7.81543 4.01289C7.81543 4.57229 7.36195 5.02578 6.80255 5.02578L5.42068 5.02578V8.80255C5.42068 9.36195 4.9672 9.81544 4.40779 9.81544C3.84839 9.81544 3.39491 9.36195 3.39491 8.80255V5.02577H2.01289C1.45349 5.02577 1 4.57229 1 4.01289ZM13.987 6.2232L9.79609 6.2232C9.23669 6.2232 8.7832 5.76972 8.7832 5.21031C8.7832 4.65091 9.23669 4.19743 9.79609 4.19743L13.987 4.19743C14.5464 4.19743 14.9999 4.65091 14.9999 5.21031C14.9999 5.76972 14.5464 6.2232 13.987 6.2232ZM6.3884 8.80255C6.3884 8.24315 6.84189 7.78966 7.40129 7.78966L13.9871 7.78967C14.5465 7.78967 15 8.24315 15 8.80255C15 9.36196 14.5465 9.81544 13.9871 9.81544L7.40129 9.81544C6.84189 9.81544 6.3884 9.36195 6.3884 8.80255ZM13.9871 13.4077L4.40779 13.4077C3.84839 13.4077 3.39491 12.9542 3.39491 12.3948C3.39491 11.8354 3.84839 11.3819 4.40779 11.3819L13.9871 11.3819C14.5465 11.3819 15 11.8354 15 12.3948C15 12.9542 14.5465 13.4077 13.9871 13.4077Z", fill: "inherit" })), Rd = V(Id), Nd = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M21 11H3C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H21C21.5523 13 22 12.5523 22 12C22 11.4477 21.5523 11 21 11ZM21 4H3C2.44772 4 2 4.44772 2 5C2 5.55228 2.44772 6 3 6H21C21.5523 6 22 5.55228 22 5C22 4.44772 21.5523 4 21 4ZM3 20H21C21.5523 20 22 19.5523 22 19C22 18.4477 21.5523 18 21 18H3C2.44772 18 2 18.4477 2 19C2 19.5523 2.44772 20 3 20Z", fill: "inherit" })), Hd = V(Nd), Od = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { id: "â³ Icon Color", d: "M24.4987 12.8337H3.4987C2.85437 12.8337 2.33203 13.356 2.33203 14.0003C2.33203 14.6447 2.85437 15.167 3.4987 15.167H24.4987C25.143 15.167 25.6654 14.6447 25.6654 14.0003C25.6654 13.356 25.143 12.8337 24.4987 12.8337ZM24.4987 4.66699H3.4987C2.85437 4.66699 2.33203 5.18933 2.33203 5.83366C2.33203 6.47799 2.85437 7.00033 3.4987 7.00033H24.4987C25.143 7.00033 25.6654 6.47799 25.6654 5.83366C25.6654 5.18933 25.143 4.66699 24.4987 4.66699ZM3.4987 23.3337H24.4987C25.143 23.3337 25.6654 22.8113 25.6654 22.167C25.6654 21.5227 25.143 21.0003 24.4987 21.0003H3.4987C2.85437 21.0003 2.33203 21.5227 2.33203 22.167C2.33203 22.8113 2.85437 23.3337 3.4987 23.3337Z" })), jd = V(Od), Pd = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M6.00262 2.78552C6.76032 2.78552 7.38025 2.16559 7.38025 1.4079C7.38025 0.650204 6.76032 0.0302734 6.00262 0.0302734C5.24493 0.0302734 4.625 0.650204 4.625 1.4079C4.625 2.16559 5.24493 2.78552 6.00262 2.78552ZM6.00262 4.62235C5.24493 4.62235 4.625 5.24229 4.625 5.99998C4.625 6.75767 5.24493 7.3776 6.00262 7.3776C6.76032 7.3776 7.38025 6.75767 7.38025 5.99998C7.38025 5.24229 6.76032 4.62235 6.00262 4.62235ZM6.00262 9.21444C5.24493 9.21444 4.625 9.83437 4.625 10.5921C4.625 11.3498 5.24493 11.9697 6.00262 11.9697C6.76032 11.9697 7.38025 11.3498 7.38025 10.5921C7.38025 9.83437 6.76032 9.21444 6.00262 9.21444Z", fill: "white" })), Dd = V(Pd), Vd = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM6.7 8C6.7 7.28203 7.28203 6.7 8 6.7H16C16.718 6.7 17.3 7.28203 17.3 8V16C17.3 16.718 16.718 17.3 16 17.3H8C7.28203 17.3 6.7 16.718 6.7 16V8ZM5 8C5 6.34315 6.34315 5 8 5H16C17.6569 5 19 6.34315 19 8V16C19 17.6569 17.6569 19 16 19H8C6.34315 19 5 17.6569 5 16V8ZM8 12C8 11.4477 8.44771 11 9 11H15C15.5523 11 16 11.4477 16 12V15C16 15.5523 15.5523 16 15 16H9C8.44771 16 8 15.5523 8 15V12ZM9 8C8.44772 8 8 8.44771 8 9C8 9.55229 8.44772 10 9 10H13C13.5523 10 14 9.55229 14 9C14 8.44771 13.5523 8 13 8H9Z", fill: "inherit" })), Bd = V(Vd), Fd = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M15.0774 2.57129C16.9485 2.57129 17.8483 2.74504 18.7832 3.24502C19.631 3.69842 20.3014 4.36889 20.7548 5.21668C21.2548 6.15155 21.4286 7.05132 21.4286 8.92247V15.0772C21.4286 16.9484 21.2548 17.8482 20.7548 18.783C20.3014 19.6308 19.631 20.3013 18.7832 20.7547C17.8483 21.2547 16.9485 21.4284 15.0774 21.4284H8.92259C7.05145 21.4284 6.15167 21.2547 5.2168 20.7547C4.36901 20.3013 3.69854 19.6308 3.24514 18.783C2.74516 17.8482 2.57141 16.9484 2.57141 15.0772V8.92247C2.57141 7.05132 2.74516 6.15155 3.24514 5.21668C3.69854 4.36889 4.36901 3.69842 5.2168 3.24502C6.15167 2.74504 7.05145 2.57129 8.92259 2.57129H15.0774ZM4.28483 9.42843L4.2857 15.0772C4.2857 16.6896 4.40782 17.322 4.75682 17.9746C5.05045 18.5236 5.47622 18.9494 6.02526 19.243C6.67783 19.592 7.31024 19.7141 8.92259 19.7141H15.0774C16.6897 19.7141 17.3221 19.592 17.9747 19.243C18.5238 18.9494 18.9495 18.5236 19.2431 17.9746C19.5921 17.322 19.7143 16.6896 19.7143 15.0772L19.7134 9.42843H4.28483ZM15.0774 4.28557H8.92259C7.31024 4.28557 6.67783 4.4077 6.02526 4.7567C5.47622 5.05033 5.05045 5.47609 4.75682 6.02513C4.51203 6.48286 4.37885 6.93067 4.32115 7.71368H19.6788C19.6211 6.93067 19.4879 6.48286 19.2431 6.02513C18.9495 5.47609 18.5238 5.05033 17.9747 4.7567C17.3221 4.4077 16.6897 4.28557 15.0774 4.28557Z", fill: "inherit" }), /* @__PURE__ */ o.createElement("path", { d: "M6.85713 12.857C6.85713 12.3836 7.27577 11.9999 7.79219 11.9999H16.2078C16.7242 11.9999 17.1428 12.3836 17.1428 12.857C17.1428 13.3304 16.7242 13.7141 16.2078 13.7141H7.79219C7.27577 13.7141 6.85713 13.3304 6.85713 12.857Z", fill: "inherit" }), /* @__PURE__ */ o.createElement("path", { d: "M6.85713 16.2856C6.85713 15.8122 7.27577 15.4284 7.79219 15.4284H16.2078C16.7242 15.4284 17.1428 15.8122 17.1428 16.2856C17.1428 16.759 16.7242 17.1427 16.2078 17.1427H7.79219C7.27577 17.1427 6.85713 16.759 6.85713 16.2856Z", fill: "inherit" })), Zd = V(Fd), Gd = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M15.0763 2.57031C16.9474 2.57031 17.8472 2.74407 18.7821 3.24404C19.6299 3.69744 20.3003 4.36792 20.7537 5.2157C21.2537 6.15058 21.4275 7.05035 21.4275 8.92149V15.0763C21.4275 16.9474 21.2537 17.8472 20.7537 18.7821C20.3003 19.6299 19.6299 20.3003 18.7821 20.7537C17.8472 21.2537 16.9474 21.4275 15.0763 21.4275H8.92149C7.05035 21.4275 6.15058 21.2537 5.2157 20.7537C4.36792 20.3003 3.69744 19.6299 3.24404 18.7821C2.74407 17.8472 2.57031 16.9474 2.57031 15.0763V8.92149C2.57031 7.05035 2.74407 6.15058 3.24404 5.2157C3.69744 4.36792 4.36792 3.69744 5.2157 3.24404C6.15058 2.74407 7.05035 2.57031 8.92149 2.57031H15.0763ZM4.28373 9.42746L4.2846 15.0763C4.2846 16.6886 4.40672 17.321 4.75572 17.9736C5.04935 18.5227 5.47512 18.9484 6.02416 19.242C6.67673 19.591 7.30914 19.7132 8.92149 19.7132H15.0763C16.6886 19.7132 17.321 19.591 17.9736 19.242C18.5227 18.9484 18.9484 18.5227 19.242 17.9736C19.591 17.321 19.7132 16.6886 19.7132 15.0763L19.7123 9.42746H4.28373ZM15.0763 4.2846H8.92149C7.30914 4.2846 6.67673 4.40672 6.02416 4.75572C5.47512 5.04935 5.04935 5.47512 4.75572 6.02416C4.51093 6.48188 4.37775 6.92969 4.32005 7.7127H19.6777C19.62 6.92969 19.4868 6.48188 19.242 6.02416C18.9484 5.47512 18.5227 5.04935 17.9736 4.75572C17.321 4.40672 16.6886 4.2846 15.0763 4.2846Z" }), /* @__PURE__ */ o.createElement("path", { d: "M6.85603 12.856C6.85603 12.3826 7.27467 11.9989 7.79109 11.9989H16.2067C16.7231 11.9989 17.1417 12.3826 17.1417 12.856C17.1417 13.3294 16.7231 13.7132 16.2067 13.7132H7.79109C7.27467 13.7132 6.85603 13.3294 6.85603 12.856Z" }), /* @__PURE__ */ o.createElement("path", { d: "M6.85603 16.2846C6.85603 15.8112 7.27467 15.4275 7.79109 15.4275H16.2067C16.7231 15.4275 17.1417 15.8112 17.1417 16.2846C17.1417 16.758 16.7231 17.1417 16.2067 17.1417H7.79109C7.27467 17.1417 6.85603 16.758 6.85603 16.2846Z" })), Wd = V(Gd), Ud = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", { id: "notification_outline_24" }, /* @__PURE__ */ o.createElement("path", { id: "â³ Icon Color", d: "M16.0076 2.80176C21.3613 2.80176 25.2021 7.17284 25.2021 12.8439V14.9767C25.2021 15.2817 25.4597 15.6858 26.1628 16.4112C26.2529 16.5042 26.3378 16.5904 26.5233 16.7782C27.9649 18.2404 28.5354 19.0828 28.5354 20.438C28.5354 21.0307 28.4663 21.4927 28.1785 22.0464C27.5702 23.2164 26.2807 23.8684 24.353 23.8684L21.8039 23.8698C20.965 26.9798 18.9633 28.6687 16.0021 28.6687C13.0093 28.6687 10.9966 26.9436 10.1738 23.7699L10.1994 23.8684H7.65121C5.66726 23.8684 4.36388 23.1987 3.78163 21.9876C3.52703 21.458 3.46875 21.0281 3.46875 20.438C3.46875 19.0828 4.03925 18.2404 5.48091 16.7782C5.66634 16.5904 5.75123 16.5042 5.8414 16.4112C6.54442 15.6858 6.80208 15.2817 6.80208 14.9767V12.8439C6.80208 7.17505 10.6524 2.80176 16.0076 2.80176ZM19.29 23.8709H12.7141C13.3221 25.5331 14.3698 26.2687 16.0021 26.2687C17.6344 26.2687 18.6821 25.5331 19.29 23.8709ZM16.0076 5.20176C12.0507 5.20176 9.20208 8.43732 9.20208 12.8439V14.9767C9.20208 16.1135 8.68283 16.9279 7.56476 18.0815C7.46707 18.1823 7.37486 18.276 7.18992 18.4632C6.19408 19.4732 5.86875 19.9536 5.86875 20.438C5.86875 20.6942 5.88681 20.8274 5.94465 20.9477C6.08771 21.2453 6.52196 21.4684 7.65121 21.4684H24.353C25.4464 21.4684 25.8908 21.2437 26.049 20.9394C26.115 20.8125 26.1354 20.6758 26.1354 20.438C26.1354 19.9536 25.8101 19.4732 24.8142 18.4632C24.6293 18.276 24.5371 18.1823 24.4394 18.0815C23.3213 16.9279 22.8021 16.1135 22.8021 14.9767V12.8439C22.8021 8.43423 19.9617 5.20176 16.0076 5.20176Z" }))), zd = V(Ud), qd = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { id: "â³ Icon Color", fillRule: "evenodd", clipRule: "evenodd", d: "M28.3074 18.5495C27.8985 18.0043 27.1352 17.8952 26.59 18.3041C26.0447 18.7131 25.9357 19.4764 26.3446 20.0216C26.6581 20.4442 26.7672 20.7577 26.7672 21.0167C26.7672 21.2484 26.7535 21.4528 26.6309 21.6028C26.5627 21.6982 26.2356 22.0662 24.9406 22.0662H7.87501C6.56646 22.0662 6.25296 21.7118 6.1848 21.6164C6.07576 21.4801 6.0485 21.2893 6.0485 21.003C6.0485 20.7713 6.13028 20.4987 6.37563 20.1579C6.62099 19.7899 6.97538 19.4355 7.41157 18.9857C7.43883 18.9584 7.46609 18.9312 7.49335 18.9039C7.87501 18.5086 8.33845 18.0452 8.69285 17.5545C9.08814 17.0092 9.45617 16.3004 9.45617 15.4281V13.2472C9.45617 9.64865 11.3372 6.81347 14.0906 5.81843C14.7313 5.58671 15.0584 4.89154 14.8267 4.2509C14.5949 3.61026 13.8998 3.28312 13.2591 3.51484C9.36076 4.9188 7.00265 8.81718 7.00265 13.2472V15.4281C7.00265 15.5644 6.94812 15.7825 6.70277 16.1096C6.45742 16.4504 6.11665 16.7911 5.6941 17.2273L5.65321 17.2682C5.23065 17.6908 4.72632 18.2087 4.34466 18.7812C3.93574 19.381 3.59497 20.1307 3.59497 21.0167V21.0439C3.59497 21.3574 3.59497 22.2843 4.22198 23.1158C4.91715 24.029 6.11665 24.5334 7.86138 24.5334H10.4785C10.8738 26.0055 11.5417 27.2459 12.564 28.1183C13.6272 29.0179 14.9357 29.4404 16.4078 29.4404C17.8799 29.4404 19.2021 29.0315 20.2517 28.1183C21.274 27.2459 21.9283 26.0055 22.3372 24.5334H24.9543C26.7126 24.5334 27.9121 24.0018 28.6073 23.0885C29.2343 22.257 29.2343 21.3302 29.2343 21.0439C29.2343 20.008 28.7845 19.1901 28.3211 18.5495H28.3074ZM18.6569 26.2508C18.1253 26.7143 17.4029 26.9733 16.4078 26.9733C15.4128 26.9733 14.6904 26.7007 14.1588 26.2508C13.7226 25.8828 13.3546 25.324 13.0547 24.5197H19.761C19.4611 25.324 19.0794 25.8828 18.6569 26.2508Z" })), $d = V(qd), Yd = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { id: "â³ Icon Color", d: "M3.5 8.16699V19.8337C3.5 21.7667 5.067 23.3337 7 23.3337H9.33333C9.97767 23.3337 10.5 22.8113 10.5 22.167C10.5 21.5227 9.97767 21.0003 9.33333 21.0003H7C6.35567 21.0003 5.83333 20.478 5.83333 19.8337V10.5003C5.83333 9.85599 6.35567 9.33366 7 9.33366H21C21.6443 9.33366 22.1667 9.85599 22.1667 10.5003V19.8337C22.1667 20.478 21.6443 21.0003 21 21.0003H18.6667C18.0223 21.0003 17.5 21.5227 17.5 22.167C17.5 22.8113 18.0223 23.3337 18.6667 23.3337H21C22.933 23.3337 24.5 21.7667 24.5 19.8337V8.16699C24.5 6.234 22.933 4.66699 21 4.66699H7C5.067 4.66699 3.5 6.234 3.5 8.16699ZM13.5875 12.0795L10.3291 15.3378C10.1013 15.5657 10.1013 15.935 10.3291 16.1628C10.4385 16.2722 10.5869 16.3337 10.7416 16.3337H12.8333V22.167C12.8333 22.8113 13.3557 23.3337 14 23.3337C14.6443 23.3337 15.1667 22.8113 15.1667 22.167V16.3337H17.2584C17.5805 16.3337 17.8417 16.0725 17.8417 15.7503C17.8417 15.5956 17.7802 15.4472 17.6709 15.3378L14.4125 12.0795C14.1847 11.8517 13.8153 11.8517 13.5875 12.0795Z" })), Kd = V(Yd), Qd = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M5 12C5 11.7239 5.22386 11.5 5.5 11.5H6.5C6.77614 11.5 7 11.7239 7 12V13C7 13.2761 6.77614 13.5 6.5 13.5H5.5C5.22386 13.5 5 13.2761 5 13V12Z" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.81739 3H12.1826C13.1351 2.99999 13.8956 2.99999 14.5099 3.05018C15.1399 3.10165 15.6818 3.20963 16.1795 3.46322C16.9791 3.87068 17.6293 4.52085 18.0368 5.32054C18.2904 5.81824 18.3983 6.36012 18.4498 6.99013C18.5 7.60439 18.5 8.36493 18.5 9.31737V10.6826C18.5 11.6351 18.5 12.3956 18.4498 13.0099C18.3983 13.6399 18.2904 14.1818 18.0368 14.6795C17.6293 15.4791 16.9791 16.1293 16.1795 16.5368C15.6818 16.7904 15.1399 16.8984 14.5099 16.9498C13.8956 17 13.1351 17 12.1826 17H7.81737C6.86493 17 6.10439 17 5.49013 16.9498C4.86012 16.8984 4.31824 16.7904 3.82054 16.5368C3.02085 16.1293 2.37068 15.4791 1.96322 14.6795C1.70963 14.1818 1.60165 13.6399 1.55018 13.0099C1.49999 12.3956 1.49999 11.6351 1.5 10.6826V9.31739C1.49999 8.36494 1.49999 7.6044 1.55018 6.99013C1.60165 6.36012 1.70963 5.81824 1.96322 5.32054C2.37068 4.52085 3.02085 3.87068 3.82054 3.46322C4.31824 3.20963 4.86012 3.10165 5.49013 3.05018C6.1044 2.99999 6.86494 2.99999 7.81739 3ZM4.50153 4.79973C4.75252 4.67184 5.07503 4.58909 5.61228 4.54519C6.15829 4.50058 6.85753 4.5 7.85 4.5H12.15C13.1425 4.5 13.8417 4.50058 14.3877 4.54519C14.925 4.58909 15.2475 4.67184 15.4985 4.79973C16.0159 5.06338 16.4366 5.48408 16.7003 6.00153C16.8282 6.25252 16.9109 6.57503 16.9548 7.11228L16.9785 7.5H3.02152L3.04519 7.11228C3.08909 6.57503 3.17184 6.25252 3.29973 6.00153C3.56338 5.48408 3.98408 5.06338 4.50153 4.79973ZM3 9.35V10.65C3 11.6425 3.00058 12.3417 3.04519 12.8877C3.08909 13.425 3.17184 13.7475 3.29973 13.9985C3.56338 14.5159 3.98408 14.9366 4.50153 15.2003C4.75252 15.3282 5.07503 15.4109 5.61228 15.4548C6.15829 15.4994 6.85753 15.5 7.85 15.5H12.15C13.1425 15.5 13.8417 15.4994 14.3877 15.4548C14.925 15.4109 15.2475 15.3282 15.4985 15.2003C16.0159 14.9366 16.4366 14.5159 16.7003 13.9985C16.8282 13.7475 16.9109 13.425 16.9548 12.8877C16.9994 12.3417 17 11.6425 17 10.65V9.35L16.9999 9H3.0001L3 9.35ZM5.5 11.5H6.5C6.77614 11.5 7 11.7239 7 12V13C7 13.2761 6.77614 13.5 6.5 13.5H5.5C5.22386 13.5 5 13.2761 5 13V12C5 11.7239 5.22386 11.5 5.5 11.5Z" })), Xd = V(Qd), Jd = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.5358 1.66419C12.0373 1.44527 11.4698 1.44527 10.9713 1.66419C10.7686 1.75324 10.6042 1.87791 10.4581 2.00627C10.3207 2.12698 10.1662 2.28155 9.99267 2.45507L2.60308 9.84464C2.3076 10.1398 2.075 10.3721 1.90431 10.6506C1.75389 10.8961 1.64304 11.1637 1.57583 11.4437C1.49957 11.7613 1.49978 12.5562 1.50003 12.9738C1.5 13.0957 1.49997 13.2278 1.50931 13.3422C1.51989 13.4716 1.54606 13.6427 1.63595 13.8191C1.75551 14.0537 1.94628 14.2445 2.18093 14.364C2.35734 14.4539 2.52836 14.4801 2.65781 14.4907C2.77218 14.5 2.90431 14.5 3.02618 14.5C3.44381 14.5002 4.23866 14.5004 4.55633 14.4242C4.83626 14.3569 5.10387 14.2461 5.34934 14.0957C5.62789 13.925 5.86021 13.6924 6.15534 13.3969L13.5449 6.00734C13.7184 5.83382 13.873 5.67925 13.9937 5.54185C14.1221 5.39577 14.2467 5.23142 14.3358 5.02864C14.5547 4.53014 14.5547 3.96272 14.3358 3.46421C14.2467 3.26144 14.1221 3.09709 13.9937 2.951C13.873 2.81363 13.7184 2.65908 13.5449 2.48559L13.5145 2.45512C13.341 2.28158 13.1864 2.12699 13.049 2.00627C12.9029 1.87791 12.7385 1.75324 12.5358 1.66419ZM11.573 3.03434C11.6881 2.98382 11.819 2.98382 11.9341 3.03434C11.9376 3.03587 11.9697 3.04997 12.0612 3.13043C12.1579 3.21536 12.2781 3.33507 12.4715 3.52846C12.6649 3.72185 12.7846 3.84208 12.8695 3.93874C12.95 4.03031 12.9641 4.06242 12.9656 4.06592C13.0162 4.18096 13.0161 4.31195 12.9656 4.42698C12.9641 4.43048 12.95 4.46255 12.8695 4.55412C12.7846 4.65078 12.6649 4.77101 12.4715 4.9644L11.7483 5.68764L10.3123 4.25171L11.0356 3.52846C11.229 3.33507 11.3492 3.21536 11.4459 3.13043C11.5374 3.04997 11.5695 3.03587 11.573 3.03434ZM9.25167 5.31237L3.71237 10.8517C3.3421 11.222 3.2466 11.3243 3.18024 11.4325C3.11187 11.5441 3.06148 11.6658 3.03093 11.793C3.0199 11.839 3.01279 12.018 3.00803 12.2249C2.9984 12.6435 2.99359 12.8528 3.01561 12.8971C3.0442 12.9546 3.04794 12.9583 3.10536 12.987C3.1496 13.009 3.35813 13.0045 3.77519 12.9954C3.98467 12.9909 4.14811 12.9832 4.20699 12.9691C4.33423 12.9385 4.45587 12.8881 4.56745 12.8197C4.67573 12.7534 4.77803 12.6579 5.1483 12.2876L10.6876 6.7483L9.25167 5.31237Z", fill: "inherit" })), ef = V(Jd), tf = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { className: "svg-substrate", cx: 12, cy: 12, r: 11, fill: "transparent" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM13.1656 5.52811C13.2684 5.01415 13.9025 4.82215 14.2731 5.19277L18.8076 9.72722C19.1782 10.0978 18.9862 10.732 18.4723 10.8348L17.1248 11.1043C17.0745 11.1143 17.0283 11.139 16.992 11.1753L14.8367 13.3307C14.7928 13.3745 14.7661 13.4326 14.7613 13.4945L14.5016 16.8707C14.4443 17.6162 13.5349 17.9707 12.993 17.4288L10.4008 14.8364L6.49351 18.7437C6.1518 19.0854 5.59778 19.0854 5.25607 18.7437C4.91437 18.402 4.91437 17.848 5.25607 17.5063L9.16339 13.599L6.5716 11.0074C6.04594 10.4817 6.35674 9.58008 7.12968 9.49875L10.5059 9.23905C10.5677 9.23429 10.6258 9.20757 10.6697 9.16371L12.825 7.00835C12.8613 6.97208 12.886 6.92588 12.8961 6.87557L13.1656 5.52811Z", fill: "inherit" })), nf = V(tf), rf = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { cx: 7, cy: 7, r: 7, fill: "inherit" }), /* @__PURE__ */ o.createElement("path", { d: "M8.13667 3.59639C7.95136 3.41107 7.6343 3.50707 7.5829 3.76406L7.44816 4.43779C7.44312 4.46294 7.43076 4.48604 7.41262 4.50417L6.33495 5.58185C6.31302 5.60378 6.28396 5.61714 6.25304 5.61952L4.56494 5.74938C4.17847 5.79004 4.02307 6.24087 4.2859 6.5037L5.5818 7.79949L3.62814 9.75314C3.45729 9.924 3.45729 10.201 3.62814 10.3719C3.799 10.5427 4.076 10.5427 4.24686 10.3719L6.20052 8.4182L7.49658 9.71438C7.76757 9.98537 8.22223 9.8081 8.25091 9.43534L8.38076 7.74724C8.38314 7.71632 8.3965 7.68727 8.41843 7.66534L9.49611 6.58766C9.51425 6.56952 9.53735 6.55716 9.5625 6.55213L10.2362 6.41738C10.4932 6.36599 10.5892 6.04892 10.4039 5.86361L8.13667 3.59639Z", fill: "inherit" })), af = V(rf), of = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M10.2731 1.19277C9.90248 0.822147 9.26835 1.01415 9.16556 1.52811L8.89607 2.87557C8.88601 2.92587 8.86128 2.97208 8.82501 3.00835L6.66965 5.1637C6.62579 5.20756 6.56768 5.23429 6.50584 5.23905L3.12964 5.49875C2.3567 5.58008 2.0459 6.48175 2.57156 7.0074L5.16335 9.59897L1.25604 13.5063C0.914329 13.848 0.914329 14.402 1.25604 14.7437C1.59775 15.0854 2.15177 15.0854 2.49347 14.7437L6.40079 10.8364L8.99292 13.4288C9.53489 13.9707 10.4442 13.6162 10.5016 12.8707L10.7613 9.49448C10.766 9.43264 10.7928 9.37453 10.8366 9.33067L12.992 7.17532C13.0283 7.13905 13.0745 7.11432 13.1248 7.10426L14.4722 6.83477C14.9862 6.73197 15.1782 6.09785 14.8076 5.72722L10.2731 1.19277Z", fill: "inherit" })), sf = V(of), lf = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 57, height: 57, viewBox: "0 0 57 57", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M33.632 19.573c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 9c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zM25.172 32.613c-.83 0-1.5.67-1.5 1.5v2.98c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-2.98c0-.83-.67-1.5-1.5-1.5z" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M53.642 32.893c1.49-6.77-2.9-11.28-5.64-12.94l-.03-.7c-.13-1.93-.4-3.56-1.02-5.09-1.53-3.75-4.47-6.73-8.16-8.28-1.5-.63-3.11-.9-5.01-1.04-1.87-.12-4.17-.12-7.07-.12h-2.72c-2.91 0-5.2 0-7.07.13-1.9.13-3.51.41-5.01 1.04-3.7 1.55-6.64 4.53-8.17 8.28-.62 1.52-.89 3.16-1.02 5.09-.13 1.88-.13 4.22-.13 7.17v.69c0 1.27 0 2.54.08 3.81.08 1.2.25 2.3.68 3.35 1.01 2.48 2.95 4.45 5.4 5.48.54.23 1.51.72 1.51 1.42V49.813c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-4.08h10.41v4.08c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-4.08h10.77v4.08c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V41.183c-.01-.71.96-1.2 1.5-1.42a9.945 9.945 0 0 0 4.06-3.16c.9 1.07 1.92 2.01 2.96 2.8 1.06.8 2.13 1.46 3.11 1.95-.12-.71-.19-1.96 0-3.45.19-1.54.64-3.33 1.57-5.01zm-40.57-24.24c1.07-.45 2.31-.69 4.06-.81 1.73-.12 3.91-.12 6.86-.12h2.72c2.95 0 5.12 0 6.86.12 1.74.12 2.99.36 4.06.81 2.92 1.23 5.26 3.58 6.5 6.56l-37.59.06c1.24-3.01 3.59-5.38 6.53-6.62zm-7.41 22.08c-.08-1.15-.08-2.31-.07-3.58v-.72c0-2.99 0-5.2.12-6.97.03-.42.06-.82.11-1.19l15.07-.02-1.46 1.83a6.005 6.005 0 0 0-8.4 5.5c0 1.33.44 2.55 1.17 3.55l-4.82 6.03a7.49 7.49 0 0 1-1.25-2c-.26-.63-.39-1.36-.46-2.41l-.01-.02zm35.12 6.26a7.2 7.2 0 0 0-1.63.92c-.52.4-1.73 1.48-1.73 3.27v1.55h-24.16v-1.54c0-1.8-1.21-2.87-1.73-3.27-.62-.48-1.28-.77-1.63-.92l-.12-.06 4.73-5.91a6.005 6.005 0 0 0 8.51-5.45c0-1.37-.46-2.63-1.24-3.64l2.95-3.69 20.12-.03c.05.39.08.8.11 1.25.07.98.09 2.1.11 3.4-2.66 4.2-2.41 7.96-.88 11.02a7.011 7.011 0 0 1-3.42 3.1h.01zm10.01-5.12c-.68 1.32-1.13 2.67-1.41 3.95-1.11-1.06-2.07-2.29-2.67-3.63-.61-1.36-.84-2.83-.5-4.45.24-1.15.79-2.47 1.86-3.97 1.73 1.67 3.37 4.44 2.72 8.09v.01z" })), cf = V(lf), uf = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 57, height: 57, viewBox: "0 0 57 57", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.85 12.892a.875.875 0 0 0-.876.875v7.126c0 .483.392.875.875.875h1.81l.439.44a5.722 5.722 0 0 1 .806 7.078l-1.035 1.656a25.208 25.208 0 0 0-3.637 10.234l-.123.984a.875.875 0 0 0 .868.984h7.371a.875.875 0 0 0 .67-.311l5.15-18.243a3.875 3.875 0 0 1 3.73-2.822h24.329a.875.875 0 0 0 .875-.875v-7.126a.875.875 0 0 0-.875-.875H8.849zm27.257 11.876h13.12a3.875 3.875 0 0 0 3.875-3.875v-7.126a3.875 3.875 0 0 0-3.875-3.875H8.849a3.875 3.875 0 0 0-3.875 3.875v7.126a3.875 3.875 0 0 0 3.875 3.875h.484c.569.873.597 2.016.027 2.928l-1.035 1.656a28.209 28.209 0 0 0-4.07 11.452l-.123.984a3.875 3.875 0 0 0 3.845 4.356h7.371a3.875 3.875 0 0 0 3.739-2.856l2.29-8.394.368-1.306a.875.875 0 0 1 .794-.507h8.27c1.73 0 3.25-1.147 3.726-2.81l1.572-5.503zm-3.12 0h-8.09a.875.875 0 0 0-.842.637l-1.32 4.676h8.074c.39 0 .734-.26.842-.635l1.336-4.678z" })), df = V(uf), ff = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.9998 13C13.9328 13 15.4998 11.433 15.4998 9.5C15.4998 7.567 13.9328 6 11.9998 6C10.0668 6 8.49982 7.567 8.49982 9.5C8.49982 11.433 10.0668 13 11.9998 13ZM11.9998 11.2C12.9387 11.2 13.6998 10.4389 13.6998 9.49999C13.6998 8.5611 12.9387 7.79999 11.9998 7.79999C11.0609 7.79999 10.2998 8.5611 10.2998 9.49999C10.2998 10.4389 11.0609 11.2 11.9998 11.2Z" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.24268 9.76987C4.24268 5.48026 7.71409 2 11.9998 2C16.2855 2 19.757 5.48026 19.757 9.76987C19.757 12.903 17.7829 16.6225 14.1922 20.8679C14.0891 20.9898 13.976 21.1029 13.8541 21.206C12.6433 22.2301 10.8315 22.0787 9.8074 20.8679L9.24032 20.1974L9.24608 20.1923C6.01154 16.2269 4.24268 12.7357 4.24268 9.76987ZM11.1848 19.7091C11.5675 20.1576 12.2411 20.2128 12.6917 19.8317C12.7372 19.7932 12.7794 19.751 12.8179 19.7055C16.3631 15.5139 17.957 12.2221 17.957 9.76987C17.957 6.47123 15.2883 3.8 11.9998 3.8C8.71135 3.8 6.04268 6.47123 6.04268 9.76987C6.04268 12.2221 7.63655 15.5139 11.1817 19.7055L11.1848 19.7091Z" })), hf = V(ff), pf = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 57, height: 57, viewBox: "0 0 57 57", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m46.053 21.719-.003.002-4.666 4.667 3.182 16.618a5.238 5.238 0 0 1-9.445 3.976L29 38.18c-1.754 1.446-3.444 2.717-5.008 3.764l.58 4.697-2.977.367-.64-5.176c-.063-.507-.094-.761-.046-.985a1.31 1.31 0 0 1 .252-.544c.14-.18.366-.329.818-.625 1.734-1.135 3.681-2.602 5.736-4.334.665-.56.997-.84 1.336-.908.303-.062.602-.023.878.116.31.154.552.502 1.036 1.199l6.62 9.518a2.238 2.238 0 0 0 4.035-1.699l-3.266-17.05c-.079-.413-.118-.62-.098-.818.019-.176.071-.347.155-.503.094-.176.243-.324.54-.622l4.92-4.919.06-.06c4.724-4.724 7.08-10.025 5.263-11.841-1.816-1.817-7.117.54-11.84 5.263l-4.974 4.973c-.298.298-.447.447-.623.541a1.356 1.356 0 0 1-.503.155c-.198.02-.405-.02-.819-.099l-17.053-3.277a2.244 2.244 0 0 0-1.705 4.045l9.525 6.628c.696.484 1.044.726 1.199 1.035.138.276.177.575.116.878-.07.339-.35.67-.91 1.335-1.732 2.057-3.2 4.006-4.336 5.741-.296.452-.444.678-.625.818a1.31 1.31 0 0 1-.544.252c-.224.048-.478.017-.985-.046l-5.17-.639a1.678 1.678 0 0 0-1.106 3.082l4.28 2.72c1.145.727 1.936 1.513 2.672 2.671l2.72 4.281a1.678 1.678 0 0 0 3.082-1.105l2.977-.368a4.678 4.678 0 0 1-8.59 3.082l-2.721-4.28c-.498-.785-.973-1.256-1.748-1.749l-4.281-2.72a4.678 4.678 0 0 1 3.082-8.591l4.691.58c1.048-1.566 2.32-3.258 3.768-5.013l-8.81-6.13a5.244 5.244 0 0 1 3.985-9.453L30.57 15.56l4.662-4.663c2.554-2.553 5.356-4.567 7.913-5.704 1.27-.564 2.628-.979 3.955-1.042 1.328-.063 2.958.226 4.216 1.483 1.257 1.258 1.546 2.888 1.483 4.216-.063 1.327-.478 2.686-1.042 3.954-1.137 2.558-3.15 5.36-5.704 7.914z" })), mf = V(pf), Cf = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 38, height: 43, viewBox: "0 0 38 43", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M36 18.1972C38.6667 19.7368 38.6667 23.5858 36 25.1254L6 42.4459C3.33333 43.9855 -2.11562e-06 42.061 -1.98102e-06 38.9818L-4.66815e-07 4.34075C-3.32219e-07 1.26154 3.33333 -0.662956 6 0.876644L36 18.1972Z", fill: "inherit" })), gf = V(Cf), vf = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 41, height: 47, viewBox: "0 0 41 47", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M39 20.1972C41.6667 21.7368 41.6667 25.5858 39 27.1254L5.99999 46.1779C3.33333 47.7175 -2.27875e-06 45.793 -2.14416e-06 42.7138L-4.78528e-07 4.60869C-3.43932e-07 1.52949 3.33333 -0.395008 6 1.14459L39 20.1972Z", fill: "inherit" })), wf = V(vf), yf = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 54, height: 61, viewBox: "0 0 54 61", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M51 25.4651C55 27.7745 55 33.548 51 35.8574L9 60.1061C5 62.4155 -3.0103e-06 59.5288 -2.8084e-06 54.91L-6.88511e-07 6.41254C-4.86617e-07 1.79374 5 -1.09301 9 1.21639L51 25.4651Z", fill: "inherit" })), bf = V(yf), _f = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 57, height: 64, viewBox: "0 0 57 64", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M54 26.8038C58 29.1132 58 34.8868 54 37.1962L9 63.1769C5 65.4863 -3.17343e-06 62.5996 -2.97153e-06 57.9808L-7.00223e-07 6.01923C-4.98329e-07 1.40043 5 -1.48632 9 0.823084L54 26.8038Z", fill: "inherit" })), xf = V(_f), Lf = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.33594 5.83268C2.33594 5.18835 2.85827 4.66602 3.5026 4.66602H24.5026C25.1469 4.66602 25.6693 5.18835 25.6693 5.83268V16.916C25.6693 17.5603 25.1469 18.0827 24.5026 18.0827H3.5026C2.85827 18.0827 2.33594 17.5603 2.33594 16.916V5.83268ZM21.0026 14.5826V8.16591H23.3359V14.5826H21.0026ZM8.7526 14.5826V8.16594H11.0859V14.5826H8.7526ZM7.0026 8.16602L7.0026 14.5827H4.66927V8.16602H7.0026ZM12.8359 8.16602L12.8359 14.5827H15.1693V8.16602L12.8359 8.16602ZM16.9193 8.16592V14.5826H19.2526V8.16592H16.9193Z" }), /* @__PURE__ */ o.createElement("path", { d: "M5.2526 20.9993C4.60827 20.9993 4.08594 21.5217 4.08594 22.166C4.08594 22.8104 4.60827 23.3327 5.2526 23.3327H22.7526C23.3969 23.3327 23.9193 22.8104 23.9193 22.166C23.9193 21.5217 23.3969 20.9993 22.7526 20.9993H5.2526Z" })), Ef = V(Lf), Mf = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 57, height: 57, viewBox: "0 0 57 57", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M53.818 46.218c-.28-.28-.66-.44-1.06-.44h-9.05c-.17-.75-.32-1.47-.42-2.16a1.5 1.5 0 0 0-.64-1.08l-1.42-.98 1.13-.78c.4-.28.64-.74.65-1.23.04-3.79.94-7.36 2.67-10.61 1.05-1.96 1.85-4.06 2.36-6.25.14-.6-.1-1.23-.61-1.58l-.89-.61 1.46-1.01c.38-.26.62-.68.64-1.14.28-4.53-.64-8.53-1.47-11.08a6.514 6.514 0 0 0-2.37-3.26 6.503 6.503 0 0 0-3.84-1.25H8.728c-1.71.01-3.32.67-4.56 1.88a6.425 6.425 0 0 0-1.91 4.57c0 .83.67 1.5 1.5 1.5h9.04c.62 2.75.85 5.49.62 8.15v.14c0 .49.24.96.65 1.24l.7.48-1.37.94c-.31.22-.53.54-.61.91-1.527 6.036-4.975 10.749-4.96 17.31 0 .49.24.95.65 1.23l.98.67-.73.5c-.46.32-.71.88-.63 1.43.25 1.86.67 3.72 1.25 5.51a6.486 6.486 0 0 0 2.36 3.25c1.12.82 2.45 1.26 3.86 1.26H47.768c1.71 0 3.34-.66 4.61-1.89 1.22-1.23 1.9-2.84 1.9-4.55 0-.4-.16-.78-.44-1.06l-.02-.01zM5.608 7.708c.17-.34.39-.65.66-.93.67-.66 1.56-1.02 2.5-1.02 1.36 0 2.57.76 3.16 1.94h-6.32v.01zm6.58 40.58c-.43-1.33-.77-2.7-1-4.08l1.75-1.21c.41-.28.65-.74.65-1.24s-.24-.96-.65-1.23l-2.11-1.45c.159-5.732 3.245-9.973 4.72-15.27l2.7-1.86c.41-.28.65-.74.65-1.24s-.24-.96-.65-1.24l-1.79-1.23c.17-3.09-.17-6.25-1.02-9.42-.15-.56-.3-1.07-.46-1.54-.18-.54-.44-1.04-.74-1.5h26.72c.75 0 1.47.24 2.08.68.6.44 1.04 1.05 1.28 1.76.7 2.17 1.48 5.48 1.36 9.25l-2.64 1.82a1.487 1.487 0 0 0 0 2.46l1.82 1.25c-.44 1.58-1.06 3.1-1.83 4.54-1.84 3.45-2.85 7.21-3 11.22l-2.29 1.58c-.41.28-.65.74-.65 1.24s.24.96.65 1.24l2.68 1.84c.06.37.14.76.22 1.14h-20.06c-.83 0-1.5.67-1.5 1.5 0 1.89-1.57 3.43-3.5 3.44-.76 0-1.48-.23-2.09-.68-.6-.44-1.04-1.04-1.27-1.75l-.03-.02zm38.07 1.4c-.68.66-1.57 1.02-2.5 1.02h-26.7c.38-.59.66-1.24.83-1.94h29.02c-.16.33-.38.64-.65.91v.01z" }), /* @__PURE__ */ o.createElement("path", { d: "M35.12 16.443a.5.5 0 0 0-.95 0l-.6 1.803a.5.5 0 0 1-.317.317l-1.803.6a.5.5 0 0 0 0 .95l1.803.6a.5.5 0 0 1 .316.317l.602 1.803a.5.5 0 0 0 .948 0l.602-1.803a.5.5 0 0 1 .316-.316l1.803-.602a.5.5 0 0 0 0-.948l-1.803-.601a.5.5 0 0 1-.316-.317l-.602-1.803zM27.582 23.313c-.243-.729-1.275-.729-1.518 0l-1.48 4.44a.8.8 0 0 1-.506.506l-4.439 1.48c-.73.243-.73 1.274 0 1.517l4.44 1.48a.8.8 0 0 1 .505.506l1.48 4.44c.243.729 1.275.729 1.518 0l1.48-4.44a.8.8 0 0 1 .506-.506l4.44-1.48c.729-.243.729-1.274 0-1.518l-4.44-1.48a.8.8 0 0 1-.506-.505l-1.48-4.44z" })), kf = V(Mf), Sf = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 4.5C6.73858 4.5 4.5 6.73858 4.5 9.5C4.5 12.2614 6.73858 14.5 9.5 14.5C12.2614 14.5 14.5 12.2614 14.5 9.5C14.5 6.73858 12.2614 4.5 9.5 4.5ZM3 9.5C3 5.91015 5.91015 3 9.5 3C13.0899 3 16 5.91015 16 9.5C16 11.0247 15.475 12.4268 14.596 13.5353L17.7803 16.7197C18.0732 17.0126 18.0732 17.4874 17.7803 17.7803C17.4874 18.0732 17.0126 18.0732 16.7197 17.7803L13.5353 14.596C12.4268 15.475 11.0247 16 9.5 16C5.91015 16 3 13.0899 3 9.5Z", fill: "inherit" })), Af = V(Sf), Tf = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M6.50006 1C9.53765 1 12.0001 3.46256 12.0001 6.50029C12.0001 7.74868 11.5842 8.89993 10.8835 9.82304L14.7791 13.7233C15.0718 14.0164 15.0715 14.4913 14.7785 14.784C14.4854 15.0767 14.0105 15.0764 13.7178 14.7834L9.82266 10.8839C8.89959 11.5847 7.74839 12.0006 6.50006 12.0006C3.46246 12.0006 1 9.53802 1 6.50029C1 3.46256 3.46246 1 6.50006 1ZM6.50006 2.5C4.2909 2.5 2.5 4.29098 2.5 6.50029C2.5 8.70961 4.2909 10.5006 6.50006 10.5006C8.70921 10.5006 10.5001 8.70961 10.5001 6.50029C10.5001 4.29098 8.70921 2.5 6.50006 2.5Z", fill: "inherit" })), If = V(Tf), Rf = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { id: "â³ Icon Color", d: "M17.312 2.3327C17.8006 2.41088 18.2628 2.59784 18.6778 2.92986C19.3577 3.47376 19.6815 4.15938 19.9317 5.16034C19.9958 5.41658 20.1066 5.7153 20.2452 6.00523C20.563 6.14034 20.8739 6.29051 21.177 6.45516C21.4761 6.38125 21.7634 6.28309 21.9928 6.1763C23.6068 5.42492 24.9608 5.4644 26.0696 6.66034C26.1634 6.7615 26.2194 6.82851 26.3412 6.97896L27.0604 7.86713C27.2539 8.10599 27.3365 8.21483 27.4585 8.4179C28.2492 9.73383 27.9409 10.9594 26.9415 12.2874C26.7756 12.5077 26.6063 12.7962 26.4647 13.0997C26.554 13.4226 26.6285 13.75 26.6876 14.0811C26.9422 14.285 27.2128 14.4637 27.4518 14.5857C28.3708 15.0547 28.966 15.5244 29.343 16.3092C29.5732 16.7883 29.6514 17.2807 29.6176 17.7744C29.5998 18.0353 29.5716 18.1808 29.4964 18.5065L29.2393 19.62C29.1641 19.9457 29.1257 20.0888 29.0274 20.3312C28.8413 20.7897 28.5551 21.198 28.1382 21.5277C27.4553 22.0678 26.7145 22.229 25.6829 22.2477C25.4219 22.2524 25.1101 22.2923 24.7999 22.3606C24.5982 22.6393 24.3834 22.9082 24.1564 23.1665C24.1602 23.4799 24.1914 23.7879 24.2448 24.0397C24.4586 25.0491 24.4682 25.8072 24.0956 26.5941C23.8681 27.0745 23.5346 27.4452 23.1297 27.7296C22.9157 27.88 22.7849 27.9496 22.4845 28.0961L21.4573 28.5971C21.1569 28.7436 21.0215 28.8038 20.7712 28.8799C20.2978 29.0238 19.8004 29.0584 19.2818 28.9419C18.4323 28.7511 17.8408 28.2768 17.1771 27.4869C17.0016 27.2781 16.7619 27.0508 16.5013 26.8461C16.3346 26.8537 16.1675 26.8576 16 26.8576C15.8325 26.8576 15.6653 26.8537 15.4987 26.8461C15.238 27.0508 14.9983 27.2781 14.8229 27.4869C14.1592 28.2768 13.5676 28.7511 12.7181 28.9419C12.1995 29.0584 11.7021 29.0238 11.2287 28.8799C10.9785 28.8038 10.8431 28.7436 10.5427 28.5971L9.51546 28.0961C9.42515 28.0522 9.36913 28.0244 9.30369 27.9903C7.80478 27.2098 7.36536 25.8794 7.75519 24.0397C7.80855 23.7879 7.8397 23.4799 7.84359 23.1665C7.61651 22.9082 7.40173 22.6393 7.20005 22.3606C6.88986 22.2923 6.57803 22.2524 6.31707 22.2477C5.28548 22.229 4.5446 22.0678 3.8617 21.5277C3.44483 21.198 3.15868 20.7897 2.97259 20.3312C2.87423 20.0888 2.83582 19.9457 2.76063 19.62L2.50354 18.5065C2.42393 18.1616 2.39461 18.0079 2.37951 17.7285C2.3512 17.2047 2.45143 16.6843 2.71729 16.1906C3.10466 15.4713 3.67803 15.0298 4.54817 14.5857C4.78717 14.4637 5.05776 14.285 5.31234 14.0811C5.37149 13.75 5.4459 13.4226 5.53525 13.0997C5.39361 12.7962 5.2243 12.5077 5.05848 12.2874C4.05906 10.9594 3.75075 9.73383 4.54144 8.4179C4.66346 8.21483 4.74609 8.10599 4.93952 7.86713L5.65874 6.97896C5.78058 6.82851 5.83657 6.7615 5.93036 6.66034C7.03916 5.4644 8.39315 5.42492 10.0071 6.1763C10.2366 6.28309 10.5238 6.38125 10.823 6.45516C11.1261 6.29051 11.437 6.14034 11.7548 6.00523C11.8933 5.7153 12.0042 5.41658 12.0682 5.16034C12.3185 4.15938 12.6422 3.47376 13.3221 2.92986C13.7371 2.59784 14.1993 2.41088 14.688 2.3327C14.8946 2.29964 15.0307 2.28967 15.248 2.28701L16.5714 2.28613C16.9057 2.28613 17.0537 2.29137 17.312 2.3327ZM16.6693 4.57208L15.4285 4.57185C14.8571 4.57185 14.5714 4.57185 14.2857 5.7147C14.1271 6.34907 13.7924 7.1595 13.3306 7.85281C12.5962 8.09326 11.9055 8.43024 11.2736 8.84874C10.4544 8.76803 9.62774 8.52094 9.04247 8.24847C7.9745 7.75129 7.79469 7.97333 7.43508 8.41741L6.71585 9.30558C6.35624 9.74966 6.17644 9.9717 6.8848 10.913C7.28349 11.4427 7.70895 12.2271 7.95568 13.0342C7.70303 13.7191 7.53536 14.4452 7.46546 15.1996C6.89219 15.8102 6.17294 16.3227 5.58715 16.6216C4.53786 17.1571 4.60213 17.4355 4.73067 17.9923L4.98776 19.1059C5.1163 19.6626 5.18057 19.941 6.35841 19.9623C7.00964 19.9741 7.87037 20.1168 8.64741 20.4085C9.04208 21.0654 9.52228 21.665 10.0726 22.192C10.1804 23.0121 10.1258 23.8787 9.99125 24.5135C9.74705 25.666 10.0039 25.7912 10.5174 26.0417L11.5446 26.5427C12.0582 26.7932 12.315 26.9185 13.0728 26.0165C13.4977 25.5108 14.1629 24.9223 14.8905 24.5007C15.2537 24.5476 15.624 24.5718 16 24.5718C16.3759 24.5718 16.7462 24.5476 17.1094 24.5007C17.8371 24.9223 18.5022 25.5108 18.9271 26.0165C19.6849 26.9185 19.9417 26.7932 20.4553 26.5427L21.4825 26.0417C21.9961 25.7912 22.2529 25.666 22.0087 24.5135C21.8742 23.8787 21.8195 23.0121 21.9273 22.192C22.4777 21.665 22.9579 21.0654 23.3525 20.4085C24.1296 20.1168 24.9903 19.9741 25.6415 19.9623C26.8194 19.941 26.8836 19.6626 27.0122 19.1059L27.2693 17.9923C27.3978 17.4355 27.4621 17.1571 26.4128 16.6216C25.827 16.3227 25.1078 15.8102 24.5345 15.1996C24.4646 14.4452 24.2969 13.7191 24.0443 13.0342C24.291 12.2271 24.7165 11.4427 25.1151 10.913C25.8235 9.9717 25.6437 9.74966 25.2841 9.30558L24.5649 8.41741C24.2053 7.97333 24.0255 7.75129 22.9575 8.24847C22.3722 8.52094 21.5455 8.76803 20.7264 8.84874C20.0944 8.43024 19.4037 8.09326 18.6693 7.85281C18.2075 7.1595 17.8729 6.34907 17.7143 5.7147C17.4454 4.63907 17.1764 4.5758 16.6693 4.57208ZM16 10.8576C18.8403 10.8576 21.1428 13.1601 21.1428 16.0004C21.1428 18.8407 18.8403 21.1433 16 21.1433C13.1597 21.1433 10.8571 18.8407 10.8571 16.0004C10.8571 13.1601 13.1597 10.8576 16 10.8576ZM16 13.1433C14.422 13.1433 13.1428 14.4225 13.1428 16.0004C13.1428 17.5784 14.422 18.8576 16 18.8576C17.5779 18.8576 18.8571 17.5784 18.8571 16.0004C18.8571 14.4225 17.5779 13.1433 16 13.1433Z" })), Nf = V(Rf), Hf = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", { id: "sliders_outline_28" }, /* @__PURE__ */ o.createElement("path", { id: "â³ Icon Color", d: "M18.5 15C20.0856 15 21.4249 16.0543 21.8551 17.5002L24 17.5C24.5523 17.5 25 17.9477 25 18.5C25 19.0523 24.5523 19.5 24 19.5L21.8548 19.5008C21.4243 20.9462 20.0852 22 18.5 22C16.9148 22 15.5757 20.9462 15.1452 19.5008L4 19.5C3.44772 19.5 3 19.0523 3 18.5C3 17.9477 3.44772 17.5 4 17.5L15.1449 17.5002C15.5751 16.0543 16.9144 15 18.5 15ZM18.5 16.75C17.5335 16.75 16.75 17.5335 16.75 18.5C16.75 19.4665 17.5335 20.25 18.5 20.25C19.4665 20.25 20.25 19.4665 20.25 18.5C20.25 17.5335 19.4665 16.75 18.5 16.75ZM10.5 6C12.0856 6 13.4249 7.05433 13.8551 8.50016L24 8.5C24.5523 8.5 25 8.94772 25 9.5C25 10.0523 24.5523 10.5 24 10.5L13.8548 10.5008C13.4243 11.9462 12.0852 13 10.5 13C8.9148 13 7.57573 11.9462 7.14519 10.5008L4 10.5C3.44772 10.5 3 10.0523 3 9.5C3 8.94772 3.44772 8.5 4 8.5L7.14489 8.50016C7.57511 7.05433 8.91443 6 10.5 6ZM10.5 7.75C9.5335 7.75 8.75 8.5335 8.75 9.5C8.75 10.4665 9.5335 11.25 10.5 11.25C11.4665 11.25 12.25 10.4665 12.25 9.5C12.25 8.5335 11.4665 7.75 10.5 7.75Z" }))), Of = V(Hf), jf = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23 12C23 12.11 23 12.22 22.9954 12.33C18.5404 12.385 16.0333 12.6921 14.365 14.365C12.6921 16.0379 12.3896 18.5404 12.33 22.9954C12.22 22.9954 12.11 23 12 23C11.89 23 11.78 23 11.67 22.9954C11.615 18.5404 11.3079 16.0333 9.635 14.365C7.96667 12.6921 5.45958 12.385 1.00458 12.33C1.00458 12.22 1 12.11 1 12C1 11.89 1 11.78 1.00458 11.67C5.45958 11.615 7.96667 11.3079 9.635 9.635C11.3079 7.96667 11.615 5.45958 11.67 1.00458C11.78 1.00458 11.89 1 12 1C12.11 1 12.22 1 12.33 1.00458C12.385 5.45958 12.6921 7.96667 14.365 9.635C16.0379 11.3079 18.5404 11.6104 22.9954 11.67C22.9954 11.78 23 11.89 23 12Z", fill: "currentColor" })), Pf = V(jf), Df = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.0171 10.371C15.0817 11.304 13.7752 11.8964 12.335 11.8964C10.9097 11.8964 9.58832 11.304 8.65296 10.371C7.71759 9.43796 7.12371 8.14952 7.12371 6.69818C7.12371 5.24684 7.71759 3.94359 8.65296 3.0254C9.58832 2.09239 10.8949 1.50001 12.335 1.50001C13.7752 1.50001 15.0817 2.09239 16.0171 3.0254C16.9525 3.9584 17.5464 5.26165 17.5464 6.69818C17.5464 8.13471 16.9525 9.43796 16.0171 10.371ZM12.3499 4.31383C11.6966 4.31383 11.1027 4.58041 10.6722 5.00989C10.2564 5.43936 9.97435 6.03175 9.97435 6.68337C9.97435 7.33499 10.2416 7.92738 10.6722 8.35686C11.1027 8.78634 11.6818 9.05291 12.3499 9.05291C13.0032 9.05291 13.597 8.78634 14.0276 8.35686C14.4582 7.92738 14.7254 7.3498 14.7254 6.68337C14.7254 6.03175 14.4582 5.43936 14.0276 5.00989C13.597 4.58041 13.018 4.31383 12.3499 4.31383Z", fill: "currentColor" }), /* @__PURE__ */ o.createElement("path", { d: "M17.8433 11.9111L19.3726 13.9993C19.4617 14.103 19.4468 14.2362 19.2538 14.3251C17.9621 15.3914 16.4625 16.0726 14.9036 16.4429L18.1403 22.1298C18.2293 22.3075 18.1254 22.5 17.9324 22.5H14.77C14.666 22.5 14.577 22.426 14.5473 22.3371L12.2905 17.3018L10.0338 22.3371C10.0041 22.4408 9.91498 22.5 9.81105 22.5H6.64862C6.47045 22.5 6.35167 22.2927 6.44076 22.1298L9.67742 16.4429C8.11848 16.0726 6.61892 15.3618 5.32723 14.3251C5.23814 14.2362 5.2233 14.103 5.29753 13.9993L6.82678 11.9111C6.91586 11.8075 7.09403 11.7927 7.19796 11.8815C8.65297 13.1107 10.4198 13.9104 12.3351 13.9104C14.2503 13.9104 16.032 13.1107 17.4721 11.8815C17.5761 11.7778 17.7542 11.7927 17.8433 11.9111Z", fill: "currentColor" })), Vf = V(Df), Bf = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M21.75 4.84177L21.7254 4.83841C21.7285 4.80476 21.7328 4.77112 21.7342 4.73748C21.7581 4.07708 21.4136 3.71442 20.7569 3.75277C20.4956 3.77157 20.2386 3.82987 19.9947 3.92569C19.3417 4.17599 18.6992 4.4532 18.053 4.72066C13.1301 6.75602 8.20743 8.79328 3.285 10.8325C3.00051 10.9491 2.73551 11.1085 2.49917 11.3051C2.08068 11.6601 2.20952 12.1869 2.73465 12.3608C3.34555 12.5627 3.95376 12.774 4.5687 12.963C5.25765 13.175 5.93078 13.4522 6.65606 13.5255C7.2895 13.5898 7.87619 13.4952 8.42822 13.1184C10.6996 11.5675 12.9854 10.0375 15.2696 8.50542C15.5757 8.3002 15.8997 8.1192 16.2246 7.94426C16.3682 7.8694 16.5226 7.8172 16.6821 7.78951C16.9176 7.74712 17.0007 7.84771 16.9341 8.07513C16.9087 8.17841 16.8665 8.27683 16.8093 8.36647C16.667 8.56631 16.5287 8.77557 16.3531 8.94445C14.777 10.459 13.1967 11.9692 11.6122 13.4751C11.4017 13.6769 11.178 13.8667 10.9876 14.0857C10.6491 14.4746 10.6649 14.9129 11.0081 15.2968C11.0709 15.3684 11.1406 15.4337 11.216 15.4919C11.6351 15.8108 12.0455 16.1432 12.4798 16.4396C13.7752 17.324 15.0759 18.1999 16.3821 19.0674C16.892 19.4075 17.4347 19.6858 18.0409 19.8166C18.7422 19.968 19.2364 19.7033 19.4914 19.0318C19.5528 18.8693 19.5979 18.7012 19.626 18.5298C19.7605 17.7126 19.887 16.8935 20.0175 16.0739C20.247 14.6313 20.4768 13.1885 20.7072 11.7455C20.905 10.4747 21.1018 9.2035 21.2975 7.93182C21.4536 6.9027 21.5996 5.8719 21.75 4.84177Z", fill: "currentColor" })), Ff = V(Bf), Zf = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", { clipPath: "url(#clip0_6_5)" }, /* @__PURE__ */ o.createElement("path", { d: "M7.66667 16H8.33333C11.96 16 13.7667 16 14.8867 14.88C16 13.76 16 11.9467 16 8.33333V7.65333C16 4.05333 16 2.24 14.8867 1.12C13.7667 0 11.9533 0 8.33333 0H7.66667C4.04 0 2.23333 0 1.11333 1.12C0 2.24 0 4.05333 0 7.66667V8.34667C0 11.9467 0 13.76 1.12 14.88C2.24 16 4.05333 16 7.66667 16Z", fill: "#0077FF" }), /* @__PURE__ */ o.createElement("path", { d: "M8.51353 11.5267C4.86686 11.5267 2.78686 9.0267 2.7002 4.8667H4.52686C4.58686 7.92003 5.93353 9.21337 7.0002 9.48003V4.8667H8.7202V7.50003C9.77353 7.3867 10.8802 6.1867 11.2535 4.8667H12.9735C12.8328 5.55129 12.5524 6.19949 12.1498 6.77075C11.7471 7.34201 11.231 7.82404 10.6335 8.1867C11.3004 8.51807 11.8894 8.9871 12.3617 9.56283C12.8341 10.1386 13.1789 10.8079 13.3735 11.5267H11.4802C11.3055 10.9024 10.9504 10.3435 10.4594 9.92013C9.96844 9.49675 9.36342 9.2277 8.7202 9.1467V11.5267H8.51353Z", fill: "white" })), /* @__PURE__ */ o.createElement("defs", null, /* @__PURE__ */ o.createElement("clipPath", { id: "clip0_6_5" }, /* @__PURE__ */ o.createElement("rect", { width: 16, height: 16, fill: "white" })))), Gf = V(Zf), Wf = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M12.9378 18.3537C5.7629 18.3537 1.67052 13.4349 1.5 5.25001H5.094C5.21206 11.2575 7.86158 13.8022 9.96027 14.3268V5.25001H13.3445V10.4311C15.417 10.2082 17.5941 7.84713 18.3287 5.25001H21.7129C21.1488 8.45051 18.7878 10.8115 17.1089 11.7822C18.7878 12.5692 21.4769 14.6285 22.5 18.3537H18.7747C17.9746 15.8615 15.981 13.9333 13.3445 13.671V18.3537H12.9378Z", fill: "currentColor" })), Uf = V(Wf), zf = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.26667 3.00003C6.27774 3.00003 6.28886 3.00003 6.3 3.00003L7.73333 3.00003C8.12484 3.00001 8.47133 2.99999 8.75849 3.02345C9.06427 3.04844 9.38112 3.10444 9.68958 3.26161C10.1412 3.49171 10.5083 3.85886 10.7384 4.31045C10.8956 4.6189 10.9516 4.93576 10.9766 5.24154C11 5.52869 11 5.87519 11 6.26669V7.73336C11 8.12487 11 8.47136 10.9766 8.75851C10.9516 9.0643 10.8956 9.38115 10.7384 9.6896C10.5083 10.1412 10.1412 10.5083 9.68958 10.7384C9.38112 10.8956 9.06427 10.9516 8.75849 10.9766C8.47133 11.0001 8.12484 11 7.73334 11H6.26667C5.87516 11 5.52867 11.0001 5.24152 10.9766C4.93573 10.9516 4.61888 10.8956 4.31042 10.7384C3.85883 10.5083 3.49168 10.1412 3.26159 9.6896C3.10442 9.38115 3.04841 9.0643 3.02343 8.75851C2.99997 8.47136 2.99998 8.12487 3 7.73336V6.30003C3 6.28888 3 6.27777 3 6.2667C2.99998 5.87519 2.99997 5.5287 3.02343 5.24154C3.04841 4.93576 3.10442 4.6189 3.26159 4.31045C3.49168 3.85886 3.85883 3.49171 4.31042 3.26161C4.61888 3.10444 4.93573 3.04844 5.24152 3.02345C5.52867 2.99999 5.87516 3.00001 6.26667 3.00003ZM5.38809 4.81747C5.19362 4.83336 5.14002 4.8591 5.12761 4.86542C5.01471 4.92295 4.92292 5.01473 4.8654 5.12763C4.85907 5.14004 4.83334 5.19365 4.81745 5.38812C4.8007 5.5931 4.8 5.86514 4.8 6.30003V7.70003C4.8 8.13492 4.8007 8.40696 4.81745 8.61193C4.83334 8.80641 4.85907 8.86001 4.8654 8.87242C4.92292 8.98532 5.01471 9.07711 5.12761 9.13463C5.14002 9.14095 5.19362 9.16669 5.38809 9.18258C5.59307 9.19933 5.86511 9.20003 6.3 9.20003H7.7C8.13489 9.20003 8.40693 9.19933 8.61191 9.18258C8.80638 9.16669 8.85998 9.14095 8.8724 9.13463C8.98529 9.07711 9.07708 8.98532 9.1346 8.87242C9.14093 8.86001 9.16667 8.80641 9.18256 8.61193C9.1993 8.40696 9.2 8.13492 9.2 7.70003V6.30003C9.2 5.86514 9.1993 5.5931 9.18256 5.38812C9.16667 5.19365 9.14093 5.14004 9.1346 5.12763C9.07708 5.01473 8.98529 4.92295 8.8724 4.86542C8.85998 4.8591 8.80638 4.83336 8.61191 4.81747C8.40693 4.80073 8.13489 4.80003 7.7 4.80003H6.3C5.86511 4.80003 5.59307 4.80073 5.38809 4.81747Z", fill: "inherit" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.26672 13C6.27779 13 6.2889 13 6.30005 13L7.73338 13C8.12489 13 8.47138 13 8.75854 13.0234C9.06432 13.0484 9.38117 13.1044 9.68963 13.2616C10.1412 13.4917 10.5084 13.8588 10.7385 14.3104C10.8956 14.6189 10.9516 14.9357 10.9766 15.2415C11.0001 15.5287 11.0001 15.8752 11.0001 16.2667V17.7333C11.0001 18.1248 11.0001 18.4713 10.9766 18.7585C10.9516 19.0643 10.8956 19.3811 10.7385 19.6896C10.5084 20.1412 10.1412 20.5083 9.68963 20.7384C9.38117 20.8956 9.06432 20.9516 8.75854 20.9766C8.47138 21 8.12489 21 7.73339 21H6.26672C5.87521 21 5.52872 21 5.24156 20.9766C4.93578 20.9516 4.61893 20.8956 4.31047 20.7384C3.85888 20.5083 3.49173 20.1412 3.26163 19.6896C3.10447 19.3811 3.04846 19.0643 3.02347 18.7585C3.00001 18.4713 3.00003 18.1248 3.00005 17.7333L3.00005 16.3C3.00005 16.2889 3.00005 16.2777 3.00005 16.2667C3.00003 15.8752 3.00001 15.5287 3.02347 15.2415C3.04846 14.9357 3.10447 14.6189 3.26163 14.3104C3.49173 13.8588 3.85888 13.4917 4.31047 13.2616C4.61893 13.1044 4.93578 13.0484 5.24156 13.0234C5.52872 13 5.87521 13 6.26672 13ZM5.38814 14.8174C5.19367 14.8333 5.14007 14.8591 5.12766 14.8654C5.01476 14.9229 4.92297 15.0147 4.86545 15.1276C4.85912 15.14 4.83339 15.1936 4.8175 15.3881C4.80075 15.5931 4.80005 15.8651 4.80005 16.3V17.7C4.80005 18.1349 4.80075 18.4069 4.8175 18.6119C4.83339 18.8064 4.85912 18.86 4.86545 18.8724C4.92297 18.9853 5.01476 19.0771 5.12766 19.1346C5.14007 19.1409 5.19367 19.1667 5.38814 19.1826C5.59312 19.1993 5.86516 19.2 6.30005 19.2H7.70005C8.13494 19.2 8.40698 19.1993 8.61196 19.1826C8.80643 19.1667 8.86003 19.1409 8.87244 19.1346C8.98534 19.0771 9.07713 18.9853 9.13465 18.8724C9.14098 18.86 9.16671 18.8064 9.1826 18.6119C9.19935 18.4069 9.20005 18.1349 9.20005 17.7V16.3C9.20005 15.8651 9.19935 15.5931 9.1826 15.3881C9.16671 15.1936 9.14098 15.14 9.13465 15.1276C9.07713 15.0147 8.98534 14.9229 8.87244 14.8654C8.86003 14.8591 8.80643 14.8333 8.61196 14.8174C8.40698 14.8007 8.13494 14.8 7.70005 14.8H6.30005C5.86516 14.8 5.59312 14.8007 5.38814 14.8174Z", fill: "inherit" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.2667 3C16.2777 3 16.2889 3 16.3 3L17.7333 3C18.1248 2.99998 18.4713 2.99997 18.7585 3.02343C19.0643 3.04841 19.3811 3.10442 19.6896 3.26159C20.1412 3.49168 20.5083 3.85884 20.7384 4.31042C20.8956 4.61888 20.9516 4.93573 20.9766 5.24152C21 5.52867 21 5.87516 21 6.26667V7.73334C21 8.12484 21 8.47133 20.9766 8.75849C20.9516 9.06427 20.8956 9.38112 20.7384 9.68958C20.5083 10.1412 20.1412 10.5083 19.6896 10.7384C19.3811 10.8956 19.0643 10.9516 18.7585 10.9766C18.4713 11 18.1248 11 17.7333 11H16.2667C15.8752 11 15.5287 11 15.2415 10.9766C14.9357 10.9516 14.6189 10.8956 14.3104 10.7384C13.8588 10.5083 13.4917 10.1412 13.2616 9.68958C13.1044 9.38112 13.0484 9.06427 13.0234 8.75849C13 8.47133 13 8.12484 13 7.73334V6.3C13 6.28886 13 6.27775 13 6.26667C13 5.87516 13 5.52867 13.0234 5.24152C13.0484 4.93573 13.1044 4.61888 13.2616 4.31042C13.4917 3.85884 13.8588 3.49168 14.3104 3.26159C14.6189 3.10442 14.9357 3.04841 15.2415 3.02343C15.5287 2.99997 15.8752 2.99998 16.2667 3ZM15.3881 4.81745C15.1936 4.83334 15.14 4.85907 15.1276 4.8654C15.0147 4.92292 14.9229 5.01471 14.8654 5.12761C14.8591 5.14002 14.8333 5.19362 14.8174 5.38809C14.8007 5.59307 14.8 5.86511 14.8 6.3V7.7C14.8 8.13489 14.8007 8.40693 14.8174 8.61191C14.8333 8.80638 14.8591 8.85998 14.8654 8.8724C14.9229 8.98529 15.0147 9.07708 15.1276 9.13461C15.14 9.14093 15.1936 9.16667 15.3881 9.18255C15.5931 9.1993 15.8651 9.2 16.3 9.2H17.7C18.1349 9.2 18.4069 9.1993 18.6119 9.18255C18.8064 9.16667 18.86 9.14093 18.8724 9.13461C18.9853 9.07708 19.0771 8.98529 19.1346 8.8724C19.1409 8.85998 19.1667 8.80638 19.1826 8.61191C19.1993 8.40693 19.2 8.13489 19.2 7.7V6.3C19.2 5.86511 19.1993 5.59307 19.1826 5.38809C19.1667 5.19362 19.1409 5.14002 19.1346 5.12761C19.0771 5.01471 18.9853 4.92292 18.8724 4.8654C18.86 4.85907 18.8064 4.83334 18.6119 4.81745C18.4069 4.8007 18.1349 4.8 17.7 4.8H16.3C15.8651 4.8 15.5931 4.8007 15.3881 4.81745Z", fill: "inherit" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.2667 13C16.2777 13 16.2889 13 16.3 13L17.7333 13C18.1248 13 18.4713 12.9999 18.7585 13.0234C19.0643 13.0484 19.3811 13.1044 19.6896 13.2616C20.1412 13.4917 20.5083 13.8588 20.7384 14.3104C20.8956 14.6189 20.9516 14.9357 20.9766 15.2415C21 15.5286 21 15.8751 21 16.2666V17.7333C21 18.1248 21 18.4713 20.9766 18.7585C20.9516 19.0642 20.8956 19.3811 20.7384 19.6896C20.5083 20.1411 20.1412 20.5083 19.6896 20.7384C19.3811 20.8956 19.0643 20.9516 18.7585 20.9766C18.4713 21 18.1248 21 17.7333 21H16.2667C15.8752 21 15.5287 21 15.2415 20.9766C14.9357 20.9516 14.6189 20.8956 14.3104 20.7384C13.8588 20.5083 13.4917 20.1411 13.2616 19.6896C13.1044 19.3811 13.0484 19.0642 13.0234 18.7585C13 18.4713 13 18.1248 13 17.7333V16.3C13 16.2888 13 16.2777 13 16.2666C13 15.8751 13 15.5286 13.0234 15.2415C13.0484 14.9357 13.1044 14.6189 13.2616 14.3104C13.4917 13.8588 13.8588 13.4917 14.3104 13.2616C14.6189 13.1044 14.9357 13.0484 15.2415 13.0234C15.5287 12.9999 15.8752 13 16.2667 13ZM15.3881 14.8174C15.1936 14.8333 15.14 14.859 15.1276 14.8654C15.0147 14.9229 14.9229 15.0147 14.8654 15.1276C14.8591 15.14 14.8333 15.1936 14.8174 15.3881C14.8007 15.593 14.8 15.8651 14.8 16.3V17.7C14.8 18.1349 14.8007 18.4069 14.8174 18.6119C14.8333 18.8064 14.8591 18.86 14.8654 18.8724C14.9229 18.9853 15.0147 19.0771 15.1276 19.1346C15.14 19.1409 15.1936 19.1666 15.3881 19.1825C15.5931 19.1993 15.8651 19.2 16.3 19.2H17.7C18.1349 19.2 18.4069 19.1993 18.6119 19.1825C18.8064 19.1666 18.86 19.1409 18.8724 19.1346C18.9853 19.0771 19.0771 18.9853 19.1346 18.8724C19.1409 18.86 19.1667 18.8064 19.1826 18.6119C19.1993 18.4069 19.2 18.1349 19.2 17.7V16.3C19.2 15.8651 19.1993 15.593 19.1826 15.3881C19.1667 15.1936 19.1409 15.14 19.1346 15.1276C19.0771 15.0147 18.9853 14.9229 18.8724 14.8654C18.86 14.859 18.8064 14.8333 18.6119 14.8174C18.4069 14.8007 18.1349 14.8 17.7 14.8H16.3C15.8651 14.8 15.5931 14.8007 15.3881 14.8174Z", fill: "inherit" })), qf = V(zf), $f = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 21, viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M7.28107 5.48586L6.75641 6.69843C6.71981 6.78302 6.70151 6.82531 6.67303 6.85817C6.64782 6.88724 6.61693 6.91083 6.58228 6.92746C6.54312 6.94626 6.4976 6.95271 6.40656 6.96559L5.65687 7.07167C3.50737 7.37583 2.43262 7.5279 1.98094 8.0315C1.58879 8.46873 1.42576 9.06612 1.54125 9.64268C1.67428 10.3068 2.52202 10.9865 4.21751 12.346L4.49107 12.5654C4.56798 12.627 4.60643 12.6579 4.63136 12.6968C4.65342 12.7312 4.66774 12.77 4.67334 12.8106C4.67966 12.8564 4.67048 12.9049 4.65211 13.0019L4.5677 13.4478C4.09397 15.9504 3.8571 17.2018 4.22927 17.8137C4.55153 18.3436 5.11598 18.6775 5.73431 18.7041C6.4484 18.7347 7.42583 17.9214 9.38064 16.295L9.71764 16.0146C9.81986 15.9295 9.87097 15.887 9.92798 15.8708C9.97825 15.8564 10.0315 15.8564 10.0818 15.8708C10.1388 15.887 10.1899 15.9295 10.2921 16.0146L10.6291 16.295C12.5839 17.9214 13.5614 18.7347 14.2755 18.7041C14.8938 18.6775 15.4582 18.3436 15.7805 17.8137C16.1527 17.2018 15.9158 15.9504 15.4421 13.4478L15.3577 13.0019C15.3393 12.9049 15.3301 12.8564 15.3364 12.8106C15.342 12.77 15.3563 12.7312 15.3784 12.6968C15.4033 12.6579 15.4418 12.627 15.5187 12.5654L15.7923 12.346C17.4877 10.9865 18.3355 10.3068 18.4685 9.64268C18.584 9.06612 18.421 8.46873 18.0288 8.0315C17.5771 7.5279 16.5024 7.37583 14.3529 7.07167L13.6032 6.96559C13.5122 6.95271 13.4666 6.94626 13.4275 6.92746C13.3928 6.91083 13.3619 6.88724 13.3367 6.85817C13.3083 6.82531 13.29 6.78302 13.2534 6.69843L12.7287 5.48586C11.8689 3.49862 11.4389 2.50499 10.8363 2.20212C10.313 1.93914 9.69673 1.93914 9.17346 2.20212C8.57083 2.50499 8.14091 3.49862 7.28107 5.48586Z", fill: "#FC8800" })), Yf = V($f), Kf = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.4053 11.7936C15.9506 12.7877 15.3579 13.814 14.5861 14.5856C13.8143 15.3572 12.7877 15.9497 11.7933 16.4044C12.7877 16.859 13.8143 17.4515 14.5861 18.2231C15.3575 18.9943 15.9503 20.019 16.4053 21.0115C16.8603 20.019 17.4531 18.9943 18.2246 18.2231C18.996 17.4519 20.0209 16.8592 21.0137 16.4044C20.0209 15.9495 18.996 15.3568 18.2246 14.5856C17.4528 13.814 16.8601 12.7877 16.4053 11.7936ZM15.3571 8.95917C14.8306 10.5673 14.1037 12.2402 13.1719 13.1718C12.2401 14.1033 10.5667 14.83 8.95812 15.3564C8.79416 15.41 8.63088 15.4616 8.46912 15.5111C8.1078 15.6217 7.7541 15.7219 7.41754 15.8118C7.32065 15.8376 7.22519 15.8627 7.13137 15.8868C6.68453 16.0019 6.68453 16.8068 7.13137 16.9219C7.22519 16.946 7.32065 16.9711 7.41754 16.997C7.7541 17.0868 8.1078 17.187 8.46912 17.2976C8.63088 17.3471 8.79416 17.3987 8.95812 17.4523C10.5667 17.9787 12.2401 18.7054 13.1719 19.6369C14.1035 20.5683 14.8303 22.2365 15.3568 23.8393C15.4102 24.0019 15.4616 24.1639 15.5109 24.3243C15.6217 24.6851 15.7222 25.0383 15.8123 25.3743C15.8384 25.4715 15.8636 25.5672 15.8879 25.6613C16.0034 26.1077 16.8073 26.1077 16.9227 25.6613C16.9471 25.5672 16.9723 25.4715 16.9983 25.3743C17.0885 25.0383 17.1889 24.6851 17.2998 24.3243C17.3491 24.1639 17.4004 24.0019 17.4539 23.8393C17.9804 22.2365 18.7071 20.5683 19.6388 19.6369C20.5704 18.7056 22.239 17.979 23.8422 17.4526C24.0049 17.3992 24.1669 17.3479 24.3274 17.2986C24.6883 17.1877 25.0415 17.0873 25.3776 16.9972C25.4748 16.9712 25.5706 16.946 25.6648 16.9216C26.1112 16.8062 26.1112 16.0025 25.6648 15.8871C25.5706 15.8627 25.4748 15.8375 25.3776 15.8115C25.0415 15.7214 24.6883 15.621 24.3274 15.5101C24.1669 15.4608 24.0049 15.4095 23.8422 15.3561C22.239 14.8297 20.5704 14.1031 19.6388 13.1718C18.707 12.2402 17.9801 10.5673 17.4536 8.95917C17.3999 8.79526 17.3483 8.63203 17.2988 8.47032C17.1882 8.1091 17.088 7.75549 16.9981 7.41903C16.9722 7.32217 16.9472 7.22672 16.923 7.13293C16.8078 6.68621 16.0028 6.68621 15.8877 7.13293C15.8635 7.22672 15.8385 7.32217 15.8126 7.41903C15.7226 7.75549 15.6224 8.1091 15.5118 8.47032C15.4623 8.63203 15.4107 8.79526 15.3571 8.95917Z", fill: "#E4E9EC" }), /* @__PURE__ */ o.createElement("path", { d: "M7.29687 2.36389C7.13336 1.8735 6.43953 1.8735 6.27603 2.36389L5.62479 4.31708C5.4197 4.9322 4.93688 5.41489 4.32159 5.61993L2.36789 6.271C1.87737 6.43446 1.87737 7.1281 2.36789 7.29157L4.31676 7.94102C4.93477 8.14697 5.41896 8.63295 5.62252 9.25161L6.27536 11.2357C6.4376 11.7288 7.1353 11.7288 7.29754 11.2357L7.94878 9.25645C8.15323 8.63508 8.64073 8.14771 9.26227 7.94331L11.2421 7.29223C11.7353 7.13004 11.7353 6.43252 11.2421 6.27033L9.25742 5.61766C8.63861 5.41415 8.15249 4.93009 7.94649 4.31224L7.29687 2.36389Z", fill: "#E4E9EC" })), Qf = V(Kf), Xf = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { className: "svg-substrate", cx: 12, cy: 12, r: 11, fill: "transparent" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM9.41101 6.56401L7.87982 10.1244C7.73887 10.4522 7.66617 10.8052 7.66617 11.162V15.9788C7.66617 17.3712 8.79496 18.5 10.1874 18.5L14.0076 18.5C15.1162 18.5 16.1102 17.8172 16.508 16.7825L18.1436 12.5281C18.7388 10.98 17.596 9.31629 15.9374 9.31629L13.0102 9.31629C12.8862 9.31629 12.7857 9.21578 12.7857 9.0918L12.7857 7.25896C12.7858 6.28752 11.9983 5.5 11.0268 5.5C10.324 5.5 9.68867 5.91837 9.41101 6.56401ZM6.87857 17.9091C6.87857 18.2354 6.61401 18.5 6.28766 18.5C5.96131 18.5 5.69675 18.2354 5.69675 17.9091V11.2121C5.69675 10.8858 5.96131 10.6212 6.28766 10.6212C6.61401 10.6212 6.87857 10.8858 6.87857 11.2121V17.9091Z", fill: "inherit" })), Jf = V(Xf), eh = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.87985 6.12443L5.41104 2.56401C5.6887 1.91837 6.32405 1.5 7.02686 1.5C7.99829 1.5 8.78579 2.28752 8.78577 3.25896L8.78572 5.0918C8.78571 5.21578 8.88622 5.31629 9.0102 5.31629L11.9374 5.31629C13.596 5.31629 14.7388 6.97996 14.1436 8.52809L12.508 12.7825C12.1103 13.8172 11.1162 14.5 10.0077 14.5L6.18741 14.5C4.79499 14.5 3.6662 13.3712 3.6662 11.9788V7.16199C3.6662 6.80521 3.7389 6.45218 3.87985 6.12443ZM2.28769 14.5C2.61404 14.5 2.8786 14.2354 2.8786 13.9091V7.21212C2.8786 6.88577 2.61404 6.62121 2.28769 6.62121C1.96134 6.62121 1.69678 6.88577 1.69678 7.21212V13.9091C1.69678 14.2354 1.96134 14.5 2.28769 14.5Z", fill: "inherit" })), th = V(eh), nh = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.1045 4C19.6098 4 19.2088 4.40103 19.2088 4.89572V15.1043C19.2088 15.599 19.6098 16 20.1045 16C20.5992 16 21.0002 15.599 21.0002 15.1043V4.89572C21.0002 4.40103 20.5992 4 20.1045 4ZM16.6091 15.818L14.6553 19.9069C14.3361 20.5749 13.6617 21.0001 12.9214 21.0001C11.8602 21.0001 10.9998 20.1397 10.9999 19.0784L11 16.2942C11 16.1317 10.8683 16.0001 10.7059 16.0001H6.00193C3.91276 16.0001 2.46328 13.918 3.18847 11.9587L5.40926 5.95871C5.84498 4.78153 6.9675 4.00006 8.22273 4.00006L14 4.00006C15.6568 4.00006 17 5.34321 17 7.00006V14.0934C17 14.6902 16.8664 15.2795 16.6091 15.818Z", fill: "white" })), rh = V(nh), ah = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.8893 19.8741C13.6882 20.299 13.2602 20.5699 12.7901 20.5699C12.1185 20.5699 11.574 20.0254 11.574 19.3538V16.1833C11.574 15.529 11.0435 14.9985 10.3891 14.9985H5.58137C4.06719 14.9985 3.03064 13.4707 3.5902 12.0637L6.14684 5.63515C6.47122 4.81951 7.26023 4.28418 8.13801 4.28418H14.1454C15.3289 4.28418 16.2883 5.24357 16.2883 6.42704V14.0996C16.2883 14.5646 16.1851 15.0239 15.9861 15.4442L13.8893 19.8741ZM12.7901 22.2842C13.9229 22.2842 14.9542 21.6313 15.4388 20.6075L17.5356 16.1776C17.8431 15.528 18.0026 14.8183 18.0026 14.0996V6.42704C18.0026 4.29679 16.2757 2.56989 14.1454 2.56989H8.13801C6.55801 2.56989 5.13779 3.53349 4.55391 5.00164L1.99727 11.4302C0.990057 13.9628 2.85584 16.7127 5.58137 16.7127H9.85972V19.3538C9.85972 20.9722 11.1717 22.2842 12.7901 22.2842ZM20.574 2.56989C20.1006 2.56989 19.7169 2.95365 19.7169 3.42704L19.7169 13.7128C19.7169 14.1861 20.1006 14.5699 20.574 14.5699C21.0474 14.5699 21.4312 14.1861 21.4312 13.7128L21.4312 3.42704C21.4312 2.95365 21.0474 2.56989 20.574 2.56989Z", fill: "#979C9F" })), ih = V(ah), oh = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 23, viewBox: "0 0 24 23", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.32499 7.84316L8.6571 2.42038C9.08 1.43702 10.0477 0.799805 11.1181 0.799805C12.5977 0.799805 13.7971 1.99926 13.7971 3.47883L13.797 6.27039C13.797 6.45923 13.9501 6.61231 14.1389 6.61231L18.5972 6.6123C21.1234 6.61231 22.864 9.1462 21.9575 11.5041L19.4664 17.9839C18.8605 19.5598 17.3465 20.5998 15.6581 20.5998L9.83959 20.5998C7.71881 20.5998 5.99959 18.8806 5.99959 16.7598V9.42345C5.99959 8.88005 6.11031 8.34235 6.32499 7.84316ZM3.9 20.5998C4.39706 20.5998 4.8 20.1969 4.8 19.6998V9.49981C4.8 9.00275 4.39706 8.5998 3.9 8.5998C3.40294 8.5998 3 9.00275 3 9.49981V19.6998C3 20.1969 3.40294 20.5998 3.9 20.5998Z", fill: "white" })), sh = V(oh), lh = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M4.28313 20.573C4.28313 21.0464 3.89938 21.4301 3.42599 21.4301C2.9526 21.4301 2.56885 21.0464 2.56885 20.573V10.2872C2.56885 9.81386 2.9526 9.43011 3.42599 9.43011C3.89938 9.43011 4.28313 9.81386 4.28313 10.2872V20.573Z", fill: "#979C9F" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.2099 3.43011C10.7398 3.43011 10.3118 3.70104 10.1107 4.12593L8.01387 8.5558C7.81491 8.97612 7.71171 9.43537 7.71171 9.9004L7.71171 17.573C7.71171 18.7564 8.6711 19.7158 9.85457 19.7158L15.862 19.7158C16.7398 19.7158 17.5288 19.1805 17.8532 18.3648L20.4098 11.9363C20.9694 10.5293 19.9328 9.00154 18.4186 9.00154H13.6109C12.9565 9.00154 12.426 8.47105 12.426 7.81666V4.64622C12.426 3.97458 11.8815 3.43011 11.2099 3.43011ZM8.56121 3.39251C9.04583 2.36867 10.0771 1.71582 11.2099 1.71582C12.8283 1.71582 14.1403 3.02781 14.1403 4.64622L14.1403 7.28725H18.4186C21.1442 7.28725 23.01 10.0372 22.0027 12.5698L19.4461 18.9984C18.8622 20.4665 17.442 21.4301 15.862 21.4301L9.85457 21.4301C7.72432 21.4301 5.99743 19.7032 5.99743 17.573L5.99743 9.9004C5.99743 9.18171 6.15692 8.47197 6.46439 7.82238L8.56121 3.39251Z", fill: "#979C9F" })), ch = V(lh), uh = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { className: "svg-substrate", cx: 12, cy: 12, r: 11, fill: "transparent" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12.0294 4.72232C12.9697 4.72232 13.7321 5.48464 13.7321 6.42502V12.3413L17.2063 15.8156C17.8713 16.4805 17.8713 17.5586 17.2063 18.2236C16.5413 18.8886 15.4633 18.8886 14.7983 18.2236L10.8254 14.2506C10.506 13.9313 10.3267 13.4982 10.3267 13.0466V6.42502C10.3267 5.48464 11.089 4.72232 12.0294 4.72232Z", fill: "inherit" })), dh = V(uh), fh = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.73205 2.42502C9.73205 1.48464 8.96974 0.722321 8.02936 0.722321C7.08898 0.722321 6.32666 1.48464 6.32666 2.42502V9.04662C6.32666 9.49821 6.50605 9.93128 6.82536 10.2506L10.7983 14.2236C11.4633 14.8886 12.5413 14.8886 13.2063 14.2236C13.8713 13.5586 13.8713 12.4805 13.2063 11.8156L9.73205 8.34134V2.42502Z", fill: "inherit" })), hh = V(fh), ph = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M7.5364 6.2636C7.18492 5.91213 6.61508 5.91213 6.2636 6.2636C5.91213 6.61508 5.91213 7.18492 6.2636 7.5364L10.7272 12L6.2636 16.4636C5.91213 16.8151 5.91213 17.3849 6.2636 17.7364C6.61508 18.0879 7.18492 18.0879 7.5364 17.7364L12 13.2728L16.4636 17.7364C16.8151 18.0879 17.3849 18.0879 17.7364 17.7364C18.0879 17.3849 18.0879 16.8151 17.7364 16.4636L13.2728 12L17.7364 7.5364C18.0879 7.18492 18.0879 6.61508 17.7364 6.2636C17.3849 5.91213 16.8151 5.91213 16.4636 6.2636L12 10.7272L7.5364 6.2636Z", fill: "inherit" })), mh = V(ph), Ch = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("circle", { className: "svg-substrate", cx: 12, cy: 12, r: 11, fill: "transparent" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM6.57632 12.4703L7.13356 13.0275L14.1927 5.96838C14.3649 5.79613 14.5942 5.69267 14.8373 5.67745L16.6276 5.56534C17.2282 5.52772 17.7258 6.02527 17.6881 6.62588L17.576 8.41619C17.5608 8.65932 17.4574 8.88854 17.2851 9.0608L10.226 16.1199L10.7832 16.6772C10.9394 16.8334 10.9394 17.0866 10.7832 17.2428L10.5004 17.5257C10.3442 17.6819 10.0909 17.6819 9.93469 17.5257L9.10423 16.6952L7.65569 18.1438C7.26517 18.5343 6.632 18.5343 6.24148 18.1438L5.10971 17.012C4.71918 16.6215 4.71918 15.9883 5.10971 15.5978L6.55825 14.1492L5.7278 13.3188C5.57159 13.1626 5.57159 12.9093 5.7278 12.7531L6.01064 12.4703C6.16685 12.3141 6.42011 12.3141 6.57632 12.4703ZM6.31186 6.62589C6.27425 6.02528 6.7718 5.52774 7.37241 5.56535L9.16272 5.67746C9.40585 5.69268 9.63507 5.79613 9.80733 5.9684L10.8592 7.02025C11.0154 7.17646 11.0154 7.42972 10.8592 7.58593L8.33245 10.1127C8.17624 10.2689 7.92297 10.2689 7.76676 10.1127L6.71491 9.06081C6.54265 8.88855 6.4392 8.65934 6.42397 8.4162L6.31186 6.62589ZM13.0886 15.4371C12.9336 15.2807 12.9342 15.0285 13.0899 14.8728L15.6166 12.3461C15.7734 12.1893 16.0277 12.1899 16.1836 12.3474L16.8619 13.0321L17.4237 12.4703C17.5799 12.3141 17.8332 12.3141 17.9894 12.4703L18.2722 12.7531C18.4284 12.9093 18.4284 13.1626 18.2722 13.3188L17.4418 14.1493L18.8903 15.5978C19.2808 15.9883 19.2808 16.6215 18.8903 17.012L17.7585 18.1438C17.368 18.5343 16.7348 18.5343 16.3443 18.1438L14.8958 16.6952L14.0653 17.5257C13.9091 17.6819 13.6558 17.6819 13.4996 17.5257L13.2168 17.2429C13.0606 17.0866 13.0606 16.8334 13.2168 16.6772L13.7695 16.1245L13.0886 15.4371Z", fill: "inherit" })), gh = V(Ch), vh = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.44948 12.6154L5.22523 13.3912L15.0525 3.56389C15.2923 3.32408 15.6114 3.18006 15.9499 3.15886L18.4423 3.00279C19.2784 2.95043 19.971 3.64307 19.9187 4.47921L19.7626 6.97157C19.7414 7.31005 19.5974 7.62915 19.3576 7.86896L9.5303 17.6962L10.3061 18.472C10.5235 18.6895 10.5235 19.042 10.3061 19.2595L9.9123 19.6533C9.69484 19.8707 9.34226 19.8707 9.12479 19.6533L7.96868 18.4972L5.95212 20.5137C5.40845 21.0574 4.527 21.0574 3.98333 20.5137L2.40775 18.9381C1.86408 18.3945 1.86408 17.513 2.40775 16.9694L4.42431 14.9528L3.26821 13.7967C3.05075 13.5792 3.05075 13.2266 3.26821 13.0092L3.66197 12.6154C3.87944 12.398 4.23202 12.398 4.44948 12.6154ZM18.2159 4.94182C18.2243 4.80804 18.1134 4.69722 17.9796 4.70559L16.3695 4.80643C16.2341 4.8149 16.1064 4.87251 16.0105 4.96844L6.4065 14.5724L8.34903 16.515L17.953 6.91097C18.049 6.81505 18.1066 6.68741 18.115 6.55201L18.2159 4.94182ZM5.60558 16.1341L3.7859 17.9537L4.96773 19.1356L6.78741 17.3159L5.60558 16.1341Z" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.08132 4.47923C4.02896 3.64309 4.72161 2.95044 5.55774 3.0028L8.0501 3.15888C8.38857 3.18007 8.70767 3.32409 8.94749 3.5639L10.4118 5.02822C10.6293 5.24569 10.6293 5.59827 10.4118 5.81574L10.0181 6.20949C9.80059 6.42696 9.44801 6.42696 9.23054 6.20949L7.9895 4.96845C7.89358 4.87253 7.76594 4.81492 7.63055 4.80644L5.89435 4.69772C5.82746 4.69353 5.77205 4.74894 5.77624 4.81584L5.88496 6.55203C5.89344 6.68742 5.95104 6.81506 6.04697 6.91099L7.28801 8.15202C7.50547 8.36949 7.50548 8.72207 7.28801 8.93954L6.89425 9.33329C6.67679 9.55076 6.32421 9.55076 6.10674 9.3333L4.64242 7.86897C4.40261 7.62917 4.25859 7.31007 4.23739 6.97159L4.08132 4.47923Z" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.6411 12.8362C16.4244 13.053 16.4235 13.4041 16.6393 13.6219L17.5872 14.5788L15.6446 16.5213L14.7004 15.5681C14.4833 15.3489 14.1292 15.3481 13.9111 15.5663L13.5173 15.96C13.3006 16.1768 13.2997 16.5279 13.5155 16.7457L14.4634 17.7026L13.6939 18.472C13.4765 18.6895 13.4765 19.0421 13.6939 19.2595L14.0877 19.6533C14.3052 19.8707 14.6577 19.8707 14.8752 19.6533L16.0313 18.4972L18.0479 20.5137C18.5915 21.0574 19.473 21.0574 20.0167 20.5137L21.5922 18.9381C22.1359 18.3945 22.1359 17.513 21.5922 16.9694L19.5757 14.9528L20.7318 13.7967C20.9493 13.5792 20.9493 13.2267 20.7318 13.0092L20.338 12.6154C20.1206 12.398 19.768 12.398 19.5505 12.6154L18.7684 13.3975L17.8242 12.4443C17.6071 12.2251 17.253 12.2243 17.0349 12.4425L16.6411 12.8362ZM18.3944 16.1341L20.2141 17.9538L19.0323 19.1356L17.2126 17.3159L18.3944 16.1341Z" })), wh = V(vh), yh = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.5764 8.47027L3.13364 9.0275L10.1928 1.96838C10.365 1.79612 10.5942 1.69267 10.8374 1.67744L12.6277 1.56533C13.2283 1.52772 13.7258 2.02526 13.6882 2.62588L13.5761 4.41619C13.5609 4.65932 13.4574 4.88854 13.2852 5.0608L6.22605 12.1199L6.78329 12.6772C6.9395 12.8334 6.9395 13.0866 6.78329 13.2428L6.50045 13.5257C6.34424 13.6819 6.09098 13.6819 5.93477 13.5257L5.10431 12.6952L3.65577 14.1438C3.26525 14.5343 2.63208 14.5343 2.24156 14.1438L1.10979 13.012C0.719264 12.6215 0.719263 11.9883 1.10979 11.5978L2.55833 10.1492L1.72788 9.3188C1.57167 9.16259 1.57167 8.90932 1.72788 8.75311L2.01072 8.47027C2.16693 8.31406 2.4202 8.31406 2.5764 8.47027Z", fill: "inherit" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.31194 2.62589C2.27433 2.02528 2.77188 1.52773 3.37249 1.56535L5.1628 1.67746C5.40593 1.69268 5.63514 1.79613 5.80741 1.96839L6.85926 3.02024C7.01547 3.17645 7.01547 3.42972 6.85926 3.58593C6.01702 4.42817 5.17477 5.27041 4.33253 6.11266C4.17632 6.26887 3.92305 6.26887 3.76684 6.11266L2.71499 5.06081C2.54273 4.88855 2.43928 4.65933 2.42405 4.4162L2.31194 2.62589Z", fill: "inherit" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.09 10.8728C8.9343 11.0285 8.93371 11.2807 9.08867 11.4371L9.76958 12.1245L9.21687 12.6772C9.06066 12.8334 9.06066 13.0866 9.21687 13.2429L9.49972 13.5257C9.65593 13.6819 9.90919 13.6819 10.0654 13.5257L10.8959 12.6952L12.3444 14.1438C12.7349 14.5343 13.3681 14.5343 13.7586 14.1438L14.8904 13.012C15.2809 12.6215 15.2809 11.9883 14.8904 11.5978L13.4418 10.1493L14.2723 9.31881C14.4285 9.1626 14.4285 8.90933 14.2723 8.75312L13.9894 8.47028C13.8332 8.31407 13.58 8.31407 13.4238 8.47028L12.862 9.03205L12.1837 8.34739C12.0277 8.18992 11.7734 8.18932 11.6167 8.34605C10.7745 9.1883 9.93224 10.0305 9.09 10.8728Z", fill: "inherit" })), bh = V(yh), _h = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { id: "â³ Icon Color", d: "M23.3335 9.33366C23.3335 6.75533 21.2452 4.66699 18.6668 4.66699C16.0885 4.66699 14.0002 6.75533 14.0002 9.33366C14.0002 11.912 16.0885 14.0003 18.6668 14.0003C21.2452 14.0003 23.3335 11.912 23.3335 9.33366ZM5.8335 7.58366C5.18916 7.58366 4.66683 8.10599 4.66683 8.75033V11.667H1.75016C1.10583 11.667 0.583496 12.1893 0.583496 12.8337C0.583496 13.478 1.10583 14.0003 1.75016 14.0003H4.66683V16.917C4.66683 17.5613 5.18916 18.0837 5.8335 18.0837C6.47783 18.0837 7.00016 17.5613 7.00016 16.917V14.0003H9.91683C10.5612 14.0003 11.0835 13.478 11.0835 12.8337C11.0835 12.1893 10.5612 11.667 9.91683 11.667H7.00016V8.75033C7.00016 8.10599 6.47783 7.58366 5.8335 7.58366ZM9.3335 21.0003V22.167C9.3335 22.8113 9.85583 23.3337 10.5002 23.3337H26.8335C27.4778 23.3337 28.0002 22.8113 28.0002 22.167V21.0003C28.0002 16.917 21.7818 15.7503 18.6668 15.7503C15.5518 15.7503 9.3335 16.917 9.3335 21.0003Z" })), xh = V(_h), Lh = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M10.75 5.25C10.75 3.73063 9.51937 2.5 8 2.5C6.48063 2.5 5.25 3.73063 5.25 5.25C5.25 6.76937 6.48063 8 8 8C9.51937 8 10.75 6.76937 10.75 5.25ZM2.5 12.1154V12.83C2.5 13.2 2.79997 13.5 3.17 13.5H12.83C13.2 13.5 13.5 13.2 13.5 12.83V12.1154C13.5 9.69231 9.83563 9 8 9C6.16437 9 2.5 9.69231 2.5 12.1154Z", fill: "inherit" })), Eh = V(Lh), Mh = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", { id: "user_outline_20" }, /* @__PURE__ */ o.createElement("path", { id: "â³ Icon Color", d: "M10 4.00005C10 2.89492 9.10513 2.00005 8 2.00005C6.89487 2.00005 6 2.89492 6 4.00005C6 5.10518 6.89487 6.00005 8 6.00005C9.10513 6.00005 10 5.10518 10 4.00005ZM11.2 4.00005C11.2 5.76792 9.76787 7.20005 8 7.20005C6.23213 7.20005 4.8 5.76792 4.8 4.00005C4.8 2.23218 6.23213 0.800049 8 0.800049C9.76787 0.800049 11.2 2.23218 11.2 4.00005ZM3.2 12.4C3.2 12.9722 3.48612 13.2 4 13.2H12C12.5139 13.2 12.8 12.9722 12.8 12.4C12.8 10.5334 10.7467 9.60005 8 9.60005C5.25329 9.60005 3.2 10.5334 3.2 12.4ZM2 12.4C2 9.61219 4.66671 8.40005 8 8.40005C11.3333 8.40005 14 9.61219 14 12.4C14 13.7027 13.1243 14.4 12 14.4H4C2.87574 14.4 2 13.7027 2 12.4Z", fill: "inherit" }))), kh = V(Mh), Sh = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 28 28", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M22.5 10C22.5 8.06625 20.9338 6.5 19 6.5C17.0662 6.5 15.5 8.06625 15.5 10C15.5 11.9338 17.0662 13.5 19 13.5C20.9338 13.5 22.5 11.9338 22.5 10ZM19 15C21.4706 15 26 15.8571 26 19.2857C26 20.7857 25.5882 21 24.7647 21L17.7546 21.0011C17.9174 20.5134 18 19.9402 18 19.2857C18 17.5963 17.3723 16.2767 16.3292 15.2922C17.2862 15.081 18.2404 15 19 15ZM9 15C11.4706 15 16 15.8571 16 19.2857C16 20.7857 15.5882 21 14.7647 21H3.23529C2.41176 21 2 20.7857 2 19.2857C2 15.8571 6.52941 15 9 15ZM9 6.5C10.9338 6.5 12.5 8.06625 12.5 10C12.5 11.9338 10.9338 13.5 9 13.5C7.06625 13.5 5.5 11.9338 5.5 10C5.5 8.06625 7.06625 6.5 9 6.5Z", fill: "inherit" })), Ah = V(Sh), Th = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 28, height: 28, viewBox: "0 0 28 28", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.2863 17.9102C9.38931 18.4613 9 19.1284 9 19.7856C9 20.2675 9.15281 20.5304 9.32532 20.6841C9.51402 20.8523 9.85216 21 10.4 21H17.6C18.1478 21 18.486 20.8523 18.6747 20.6841C18.8472 20.5304 19 20.2675 19 19.7856C19 19.1284 18.6107 18.4613 17.7137 17.9102C16.8152 17.3582 15.5057 17 14 17C12.4943 17 11.1848 17.3582 10.2863 17.9102ZM9.23938 16.2062C10.5161 15.4218 12.2067 15 14 15C15.7933 15 17.4839 15.4218 18.7606 16.2062C20.0388 16.9915 21 18.2172 21 19.7856C21 20.7381 20.6728 21.5824 20.0053 22.1773C19.354 22.7577 18.4922 23 17.6 23H10.4C9.50784 23 8.64598 22.7577 7.99468 22.1773C7.32719 21.5824 7 20.7381 7 19.7856C7 18.2172 7.96116 16.9915 9.23938 16.2062Z" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.8047 17.0821C3.28518 17.4284 3 17.8879 3 18.5C3 19.0228 3.16989 19.3807 3.39461 19.6054C3.61933 19.8301 3.97725 20 4.5 20C5.05228 20 5.5 20.4477 5.5 21C5.5 21.5523 5.05228 22 4.5 22C3.52275 22 2.63067 21.6699 1.98039 21.0196C1.33011 20.3693 1 19.4772 1 18.5C1 17.1121 1.71482 16.0716 2.6953 15.4179C3.64614 14.7841 4.85166 14.5 6 14.5C6.55228 14.5 7 14.9477 7 15.5C7 16.0523 6.55228 16.5 6 16.5C5.14834 16.5 4.35386 16.7159 3.8047 17.0821Z" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24.1953 17.0821C24.7148 17.4284 25 17.8879 25 18.5C25 19.0228 24.8301 19.3807 24.6054 19.6054C24.3807 19.8301 24.0228 20 23.5 20C22.9477 20 22.5 20.4477 22.5 21C22.5 21.5523 22.9477 22 23.5 22C24.4772 22 25.3693 21.6699 26.0196 21.0196C26.6699 20.3693 27 19.4772 27 18.5C27 17.1121 26.2852 16.0716 25.3047 15.4179C24.3539 14.7841 23.1483 14.5 22 14.5C21.4477 14.5 21 14.9477 21 15.5C21 16.0523 21.4477 16.5 22 16.5C22.8517 16.5 23.6461 16.7159 24.1953 17.0821Z" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.5 8.5C11.5 9.88071 12.6193 11 14 11C15.3807 11 16.5 9.88071 16.5 8.5C16.5 7.11929 15.3807 6 14 6C12.6193 6 11.5 7.11929 11.5 8.5ZM14 4C11.5147 4 9.5 6.01472 9.5 8.5C9.5 10.9853 11.5147 13 14 13C16.4853 13 18.5 10.9853 18.5 8.5C18.5 6.01472 16.4853 4 14 4Z" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 6.5C5.89543 6.5 5 7.39543 5 8.5C5 9.60457 5.89543 10.5 7 10.5C7.55228 10.5 8 10.9477 8 11.5C8 12.0523 7.55228 12.5 7 12.5C4.79086 12.5 3 10.7091 3 8.5C3 6.29086 4.79086 4.5 7 4.5C7.55228 4.5 8 4.94772 8 5.5C8 6.05228 7.55228 6.5 7 6.5Z" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 6.5C22.1046 6.5 23 7.39543 23 8.5C23 9.60457 22.1046 10.5 21 10.5C20.4477 10.5 20 10.9477 20 11.5C20 12.0523 20.4477 12.5 21 12.5C23.2091 12.5 25 10.7091 25 8.5C25 6.29086 23.2091 4.5 21 4.5C20.4477 4.5 20 4.94772 20 5.5C20 6.05228 20.4477 6.5 21 6.5Z" })), Ih = V(Th), Rh = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M12 4.6001C17.1997 4.6001 22.4 8.83737 22.4 12.0001C22.4 15.1628 17.1997 19.4001 12 19.4001C6.80026 19.4001 1.59998 15.1628 1.59998 12.0001C1.59998 8.83737 6.80026 4.6001 12 4.6001ZM12 6.4001C7.72242 6.4001 3.39998 9.92209 3.39998 12.0001C3.39998 14.0781 7.72242 17.6001 12 17.6001C16.2775 17.6001 20.6 14.0781 20.6 12.0001C20.6 9.92209 16.2775 6.4001 12 6.4001ZM12 8.6001C13.8777 8.6001 15.4 10.1223 15.4 12.0001C15.4 13.8779 13.8777 15.4001 12 15.4001C10.1222 15.4001 8.59998 13.8779 8.59998 12.0001C8.59998 10.1223 10.1222 8.6001 12 8.6001ZM12 10.4001C11.1163 10.4001 10.4 11.1164 10.4 12.0001C10.4 12.8838 11.1163 13.6001 12 13.6001C12.8836 13.6001 13.6 12.8838 13.6 12.0001C13.6 11.1164 12.8836 10.4001 12 10.4001Z", fill: "#979C9F" })), Nh = V(Rh), Hh = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 7.66667C15 6.73333 12.2 3 8 3C3.8 3 1 6.73333 1 7.66667C1 8.6 3.8 12.3333 8 12.3333C12.2 12.3333 15 8.6 15 7.66667ZM11.5 7.66667C11.5 9.59966 9.933 11.1667 8 11.1667C6.067 11.1667 4.5 9.59966 4.5 7.66667C4.5 5.73367 6.067 4.16667 8 4.16667C9.933 4.16667 11.5 5.73367 11.5 7.66667ZM8 9.41667C8.9665 9.41667 9.75 8.63316 9.75 7.66667C9.75 6.70017 8.9665 5.91667 8 5.91667C7.0335 5.91667 6.25 6.70017 6.25 7.66667C6.25 8.63316 7.0335 9.41667 8 9.41667Z", fill: "inherit" })), Oh = V(Hh), jh = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("g", { id: "wallet_outline_24" }, /* @__PURE__ */ o.createElement("path", { id: "â³ Icon Color", fill: "inherit", fillRule: "evenodd", clipRule: "evenodd", d: "M7.7624 3.1001H7.8001H15.5001C17.3779 3.1001 18.9001 4.62233 18.9001 6.5001V7.23168C19.2047 7.29235 19.4935 7.38395 19.7707 7.52517C20.5045 7.89908 21.1011 8.4957 21.475 9.22954C21.7139 9.69842 21.8108 10.2005 21.8562 10.7564C21.9001 11.2935 21.9001 11.9543 21.9001 12.7624V12.8001V14.2001V14.2378C21.9001 15.0459 21.9001 15.7067 21.8562 16.2438C21.8108 16.7997 21.7139 17.3018 21.475 17.7707C21.1011 18.5045 20.5045 19.1011 19.7707 19.475C19.3018 19.7139 18.7997 19.8108 18.2438 19.8562C17.7067 19.9001 17.0459 19.9001 16.2378 19.9001H16.2001H10.502C10.5013 19.9001 10.5007 19.9001 10.5001 19.9001H7.8001H7.76239C7.76236 19.9001 7.76233 19.9001 7.7623 19.9001C6.95429 19.9001 6.29347 19.9001 5.75642 19.8562C5.72167 19.8534 5.68714 19.8504 5.65281 19.8471C5.13787 19.7982 4.66912 19.699 4.22954 19.475C4.18367 19.4517 4.13834 19.4274 4.09357 19.4023C3.422 19.026 2.87571 18.4586 2.52517 17.7707C2.28626 17.3018 2.18938 16.7997 2.14396 16.2438C2.10008 15.7067 2.10009 15.0459 2.1001 14.2378V14.2378V14.2001V9.0001V8.8001V8.7624V8.76238C2.10009 7.95433 2.10008 7.29349 2.14396 6.75642C2.18938 6.2005 2.28626 5.69842 2.52517 5.22954C2.89908 4.4957 3.4957 3.89908 4.22954 3.52517C4.69842 3.28626 5.2005 3.18938 5.75642 3.14396C6.29349 3.10008 6.95433 3.10009 7.76238 3.1001H7.7624ZM3.9001 9.0001V14.2001C3.9001 15.055 3.9008 15.6421 3.93798 16.0972C3.97431 16.5418 4.04092 16.7806 4.12898 16.9535C4.33032 17.3486 4.65158 17.6699 5.04672 17.8712C5.21956 17.9593 5.45839 18.0259 5.90299 18.0622C6.3581 18.0994 6.94517 18.1001 7.8001 18.1001H10.5001H16.2001C17.055 18.1001 17.6421 18.0994 18.0972 18.0622C18.5418 18.0259 18.7806 17.9593 18.9535 17.8712C19.3486 17.6699 19.6699 17.3486 19.8712 16.9535C19.9593 16.7806 20.0259 16.5418 20.0622 16.0972C20.0994 15.6421 20.1001 15.055 20.1001 14.2001V12.8001C20.1001 11.9452 20.0994 11.3581 20.0622 10.903C20.0259 10.4584 19.9593 10.2196 19.8712 10.0467C19.6699 9.65158 19.3486 9.33032 18.9535 9.12898C18.7806 9.04092 18.5418 8.97431 18.0972 8.93798C17.6421 8.9008 17.055 8.9001 16.2001 8.9001H3.9001V9.0001ZM3.92453 7.1001H16.2001L16.2378 7.1001H16.2378C16.5463 7.10009 16.8332 7.10009 17.1001 7.10253V6.5001C17.1001 5.61644 16.3838 4.9001 15.5001 4.9001H7.8001C6.94517 4.9001 6.3581 4.9008 5.90299 4.93798C5.45839 4.97431 5.21956 5.04092 5.04672 5.12898C4.65158 5.33032 4.33032 5.65158 4.12898 6.04672C4.04092 6.21957 3.97431 6.45839 3.93798 6.90299C3.93283 6.96604 3.92838 7.03162 3.92453 7.1001ZM15.1001 14.0001C15.1001 13.503 15.503 13.1001 16.0001 13.1001H17.2001C17.6972 13.1001 18.1001 13.503 18.1001 14.0001C18.1001 14.4972 17.6972 14.9001 17.2001 14.9001H16.0001C15.503 14.9001 15.1001 14.4972 15.1001 14.0001Z" }))), Ph = V(jh), Dh = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { d: "M8.79985 11.2008C8.79985 11.6426 8.44168 12.0008 7.99985 12.0008C7.55803 12.0008 7.19985 11.6426 7.19985 11.2008C7.19985 10.7589 7.55803 10.4008 7.99985 10.4008C8.44168 10.4008 8.79985 10.7589 8.79985 11.2008Z" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.9004 2.69137C9.77433 2.47463 9.1916 1.60156 7.99924 1.60156C6.80689 1.60156 6.23208 2.46311 6.0993 2.69137L1.21834 11.0824C0.889558 11.6476 0.828239 12.3293 1.05088 12.944C1.36771 13.8188 2.19915 14.4016 3.13038 14.4016H12.8693C13.8006 14.4016 14.632 13.8188 14.9488 12.944C15.1715 12.3293 15.1101 11.6476 14.7814 11.0824L9.9004 2.69137ZM12.8693 13.2028C13.2952 13.2028 13.6755 12.9362 13.8204 12.5361C13.9222 12.255 13.8942 11.9432 13.7438 11.6847L8.86286 3.29368C8.86286 3.29368 8.5998 2.79665 7.99922 2.79665C7.39864 2.79665 7.13684 3.29368 7.13684 3.29368L2.25588 11.6847C2.10551 11.9432 2.07746 12.255 2.17929 12.5361C2.32419 12.9362 2.70447 13.2028 3.13038 13.2028H12.8693Z" }), /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.9998 4.80078C8.33118 4.80078 8.5998 5.06941 8.5998 5.40078V9.00078C8.5998 9.33215 8.33118 9.60078 7.9998 9.60078C7.66843 9.60078 7.3998 9.33215 7.3998 9.00078V5.40078C7.3998 5.06941 7.66843 4.80078 7.9998 4.80078Z" })), Vh = V(Dh), Bh = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.871188 14.3966C0.173389 15.606 1.04199 17.1205 2.43343 17.1205H17.5666C18.9581 17.1205 19.8267 15.6059 19.1287 14.3965L11.5614 1.2836C10.8656 0.0779327 9.1327 0.0780078 8.43702 1.28373L0.871188 14.3966ZM8.92899 14.1642C8.92899 13.5705 9.40808 13.0892 9.99905 13.0892C10.59 13.0892 11.0691 13.5705 11.0691 14.1642C11.0691 14.758 10.59 15.2393 9.99905 15.2393C9.40808 15.2393 8.92899 14.758 8.92899 14.1642ZM9.99909 4.35464C9.41449 4.35464 8.94664 4.84207 8.96789 5.42899L9.1674 10.9397C9.18368 11.3894 9.55124 11.7454 9.99911 11.7454C10.447 11.7454 10.8146 11.3894 10.8308 10.9397L11.0303 5.42898C11.0515 4.84206 10.5837 4.35464 9.99909 4.35464Z", fill: "currentColor" })), Fh = V(Bh), Zh = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ o.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ o.createElement("title", { id: t }, e) : null, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.45553 20.1197C2.049 18.7145 2.049 16.4361 3.45553 15.0309L6.02182 12.4669C6.20799 12.2809 6.27527 12.0087 6.21496 11.7526C6.07438 11.1554 6.00001 10.5327 6.00001 9.89263C6.00001 5.42319 9.6265 1.8 14.1 1.8C15.0936 1.8 16.0455 1.97875 16.9251 2.30581C17.381 2.47536 17.4727 3.05424 17.1295 3.39901L14.0097 6.53304C13.8754 6.66797 13.8 6.85061 13.8 7.04099V9.48C13.8 9.87764 14.1224 10.2 14.52 10.2H16.9546C17.1449 10.2 17.3275 10.1246 17.4625 9.99034L20.6011 6.86678C20.9458 6.52378 21.5244 6.61529 21.694 7.07096C22.0212 7.94953 22.2 8.90022 22.2 9.89263C22.2 14.3621 18.5735 17.9853 14.1 17.9853C13.4686 17.9853 12.854 17.9131 12.2642 17.7765C12.009 17.7175 11.7385 17.7848 11.5532 17.9699L8.97523 20.5455C7.5687 21.9508 5.28827 21.9508 3.88175 20.5455L3.45553 20.1197ZM14.1 16.1853C17.5809 16.1853 20.4 13.3664 20.4 9.89263C20.4 9.79869 20.398 9.70529 20.3939 9.61246L18.7322 11.2662C18.26 11.7362 17.6208 12 16.9546 12H14.52C13.1282 12 12 10.8718 12 9.48V7.04099C12 6.37463 12.2639 5.7354 12.734 5.26314L14.3834 3.60622C14.2895 3.60209 14.1951 3.6 14.1 3.6C10.6191 3.6 7.80001 6.41885 7.80001 9.89263C7.80001 10.3928 7.85808 10.8771 7.96707 11.3401C8.15798 12.1511 7.95818 13.0767 7.29403 13.7403L4.72774 16.3042C4.02493 17.0064 4.02493 18.1442 4.72774 18.8463L5.15396 19.2722C5.85768 19.9753 6.9993 19.9753 7.70302 19.2722L10.281 16.6965C10.9418 16.0363 11.8621 15.8358 12.6701 16.0229C13.1278 16.1289 13.6062 16.1853 14.1 16.1853Z", fill: "inherit" })), Gh = V(Zh), Wh = (e) => typeof e == "object" && e !== null && Object.prototype.hasOwnProperty.call(e, "render"), Uh = /* @__PURE__ */ Object.assign({
  "./svg/add-alt.svg": Zl,
  "./svg/add-square-outline.svg": Wl,
  "./svg/add.svg": zl,
  "./svg/advertising-circle.svg": $l,
  "./svg/advertising.svg": Kl,
  "./svg/arrow-down-outline.svg": Xl,
  "./svg/arrow-left-double.svg": e9,
  "./svg/arrow-left.svg": n9,
  "./svg/arrow-reply-outline.svg": a9,
  "./svg/arrow-right.svg": o9,
  "./svg/block-outline.svg": l9,
  "./svg/bomb.svg": u9,
  "./svg/bookmark-20.svg": f9,
  "./svg/bookmark-check.svg": p9,
  "./svg/bookmark-outline.svg": C9,
  "./svg/bookmark.svg": v9,
  "./svg/bookspread-circle.svg": y9,
  "./svg/brain.svg": _9,
  "./svg/browser-circle.svg": L9,
  "./svg/browser.svg": M9,
  "./svg/burger.svg": S9,
  "./svg/calendar-circle.svg": T9,
  "./svg/calendar.svg": R9,
  "./svg/cancel-outline-28.svg": H9,
  "./svg/cancel.svg": j9,
  "./svg/check-circle-blue.svg": D9,
  "./svg/check-circle-large-16.svg": B9,
  "./svg/check-circle-outline.svg": Z9,
  "./svg/check-circle.svg": W9,
  "./svg/check-long.svg": z9,
  "./svg/check.svg": $9,
  "./svg/checked.svg": K9,
  "./svg/chevron-down-12.svg": X9,
  "./svg/chevron-down-20.svg": e8,
  "./svg/chevron-down-24.svg": n8,
  "./svg/chevron-down-32.svg": a8,
  "./svg/chevron-down-small-24.svg": o8,
  "./svg/chevron-left.svg": l8,
  "./svg/chevron-right-20.svg": u8,
  "./svg/chevron-right-outline-12.svg": f8,
  "./svg/chevron-right-outline-24.svg": p8,
  "./svg/chevron-right-outline-48.svg": C8,
  "./svg/chevron-right-square-16.svg": v8,
  "./svg/chevron-right.svg": y8,
  "./svg/chevron-up-12.svg": _8,
  "./svg/chevron-up-24.svg": L8,
  "./svg/chip.svg": M8,
  "./svg/clock-outline.svg": S8,
  "./svg/close-16.svg": T8,
  "./svg/close.svg": R8,
  "./svg/cloud-circle.svg": H8,
  "./svg/cloud-outline.svg": j8,
  "./svg/cloud-save.svg": D8,
  "./svg/cloud.svg": B8,
  "./svg/coins-circle.svg": Z8,
  "./svg/coins.svg": W8,
  "./svg/comment-circle.svg": z8,
  "./svg/comment.svg": $8,
  "./svg/computer-smartphone-outline.svg": K8,
  "./svg/copy-check-outline.svg": X8,
  "./svg/copy-outline.svg": e7,
  "./svg/country-checked.svg": n7,
  "./svg/country-flag-arab.svg": a7,
  "./svg/country-flag-chinese_simp.svg": o7,
  "./svg/country-flag-english.svg": l7,
  "./svg/country-flag-french.svg": u7,
  "./svg/country-flag-german.svg": f7,
  "./svg/country-flag-italian.svg": p7,
  "./svg/country-flag-japanese.svg": C7,
  "./svg/country-flag-kazakh.svg": v7,
  "./svg/country-flag-korean.svg": y7,
  "./svg/country-flag-portuguese.svg": _7,
  "./svg/country-flag-russian.svg": L7,
  "./svg/country-flag-spanish.svg": M7,
  "./svg/country-flag-turkish.svg": S7,
  "./svg/cup-circle.svg": T7,
  "./svg/cup.svg": R7,
  "./svg/datetime.svg": H7,
  "./svg/delete-outline-20.svg": j7,
  "./svg/delete-outline.svg": D7,
  "./svg/delimiter.svg": B7,
  "./svg/demo-circle.svg": Z7,
  "./svg/demo.svg": W7,
  "./svg/dlc-circle.svg": z7,
  "./svg/done-circle.svg": $7,
  "./svg/done-outline.svg": K7,
  "./svg/dots.svg": X7,
  "./svg/download-circle.svg": ec,
  "./svg/download-outline-sm.svg": nc,
  "./svg/download-outline.svg": ac,
  "./svg/download.svg": oc,
  "./svg/education-circle.svg": lc,
  "./svg/education.svg": uc,
  "./svg/emoji-high.svg": fc,
  "./svg/emoji-low-128.svg": pc,
  "./svg/emoji-low.svg": Cc,
  "./svg/emoji-neutral-big.svg": vc,
  "./svg/emoji-neutral.svg": yc,
  "./svg/error-bold-circle.svg": _c,
  "./svg/error-bold.svg": Lc,
  "./svg/error-circle.svg": Mc,
  "./svg/error.svg": Sc,
  "./svg/external-link-outline.svg": Tc,
  "./svg/fire-circle.svg": Rc,
  "./svg/fire.svg": Hc,
  "./svg/flash-circle.svg": jc,
  "./svg/flash.svg": Dc,
  "./svg/folder-arrow-outline.svg": Bc,
  "./svg/folder-game-outline.svg": Zc,
  "./svg/game-circle.svg": Wc,
  "./svg/game-outline-28.svg": zc,
  "./svg/game-outline.svg": $c,
  "./svg/game.svg": Kc,
  "./svg/gamepad-circle.svg": Xc,
  "./svg/gear-outline.svg": eu,
  "./svg/gift-circle.svg": nu,
  "./svg/gift-outline.svg": au,
  "./svg/gift.svg": ou,
  "./svg/globe-cross.svg": lu,
  "./svg/globe.svg": uu,
  "./svg/graphics-card.svg": fu,
  "./svg/hdd.svg": pu,
  "./svg/help-outline.svg": Cu,
  "./svg/hide-outline.svg": vu,
  "./svg/history-backward-outline-16.svg": yu,
  "./svg/history.svg": _u,
  "./svg/home-outline.svg": Lu,
  "./svg/hourglass-circle.svg": Mu,
  "./svg/hourglass-cirlce.svg": Su,
  "./svg/hourglass.svg": Tu,
  "./svg/in-development-circle.svg": Ru,
  "./svg/in-development.svg": Hu,
  "./svg/info-circle.svg": ju,
  "./svg/info-lines-outline.svg": Du,
  "./svg/info-outline-circle.svg": Bu,
  "./svg/key-circle.svg": Zu,
  "./svg/key.svg": Wu,
  "./svg/kit-circle.svg": zu,
  "./svg/kit.svg": $u,
  "./svg/lab-circle.svg": Ku,
  "./svg/list-check-outline.svg": Xu,
  "./svg/live-circle.svg": ed,
  "./svg/live-outline.svg": nd,
  "./svg/live.svg": ad,
  "./svg/loader.svg": od,
  "./svg/lock-outline.svg": ld,
  "./svg/logo-android.svg": ud,
  "./svg/logo-apple.svg": fd,
  "./svg/logo-sbpbank.svg": pd,
  "./svg/logo-windows.svg": Cd,
  "./svg/logout-outline.svg": vd,
  "./svg/mail-outline.svg": yd,
  "./svg/mail-small-rounding-outline.svg": _d,
  "./svg/market-outline-28.svg": Ld,
  "./svg/market-outline.svg": Md,
  "./svg/market.svg": Sd,
  "./svg/media-circle.svg": Td,
  "./svg/media.svg": Rd,
  "./svg/menu-outline-24.svg": Hd,
  "./svg/menu.svg": jd,
  "./svg/more-vertical.svg": Dd,
  "./svg/newsfeed-alt-circle.svg": Bd,
  "./svg/newsfeed-lines-outline-28.svg": Zd,
  "./svg/newsfeed-lines-outline.svg": Wd,
  "./svg/notification-outline.svg": zd,
  "./svg/notification-subtract-outline.svg": $d,
  "./svg/open-in.svg": Kd,
  "./svg/payment-card-outline.svg": Xd,
  "./svg/pen-outline.svg": ef,
  "./svg/pin-circle.svg": nf,
  "./svg/pin-label-fill.svg": af,
  "./svg/pin.svg": sf,
  "./svg/pirate.svg": cf,
  "./svg/pistol.svg": df,
  "./svg/place-outline.svg": hf,
  "./svg/plane.svg": mf,
  "./svg/play-56.svg": gf,
  "./svg/play-60.svg": wf,
  "./svg/play-80.svg": bf,
  "./svg/play-84.svg": xf,
  "./svg/ram.svg": Ef,
  "./svg/scroll.svg": kf,
  "./svg/search-outline-20.svg": Af,
  "./svg/search.svg": If,
  "./svg/settings-outline.svg": Nf,
  "./svg/sliders-outline.svg": Of,
  "./svg/social-dzen.svg": Pf,
  "./svg/social-ok.svg": Vf,
  "./svg/social-telegram.svg": Ff,
  "./svg/social-vk-filled.svg": Gf,
  "./svg/social-vk.svg": Uf,
  "./svg/square-4-outline-24.svg": qf,
  "./svg/star.svg": Yf,
  "./svg/stars-outline.svg": Qf,
  "./svg/thumb-up-circle.svg": Jf,
  "./svg/thumb-up.svg": th,
  "./svg/thumbs-down-fill.svg": rh,
  "./svg/thumbs-down-outline.svg": ih,
  "./svg/thumbs-up-fill.svg": sh,
  "./svg/thumbs-up-outline.svg": ch,
  "./svg/time-circle.svg": dh,
  "./svg/time.svg": hh,
  "./svg/times.svg": mh,
  "./svg/tournament-circle.svg": gh,
  "./svg/tournament-outline.svg": wh,
  "./svg/tournament.svg": bh,
  "./svg/user-add.svg": xh,
  "./svg/user-fill.svg": Eh,
  "./svg/user-outline.svg": kh,
  "./svg/users-fill.svg": Ah,
  "./svg/users-outline.svg": Ih,
  "./svg/view-outline.svg": Nh,
  "./svg/view.svg": Oh,
  "./svg/wallet-outline.svg": Ph,
  "./svg/warning-triangle-outline.svg": Vh,
  "./svg/warning.svg": Fh,
  "./svg/wrench-outline-20.svg": Gh
}), qo = Object.entries(Uh).reduce((e, [t, n]) => {
  var r;
  const a = /svg\/(.*)\.svg/, i = ((r = t.match(a)) == null ? void 0 : r[1]) || t;
  return Wh(n) && (e[i] = n), e;
}, {}), b1 = ({ name: e, ...t }) => {
  if (!qo[e])
    return null;
  const n = qo[e];
  return /* @__PURE__ */ i1.jsx(
    n,
    {
      ...t
    }
  );
}, zh = "WrapperButton__root--32ebd", qh = {
  root: zh
}, Je = V(({
  children: e,
  onClick: t,
  className: n,
  ...r
}, a) => /* @__PURE__ */ i1.jsx(
  "button",
  {
    ...r,
    onClick: t,
    type: "button",
    className: Q1(qh.root, n),
    ref: a,
    children: e
  }
));
var s4 = { exports: {} };
(function() {
  var e = { 7: function(r) {
    var a, i = typeof Reflect == "object" ? Reflect : null, l = i && typeof i.apply == "function" ? i.apply : function(L, S, E) {
      return Function.prototype.apply.call(L, S, E);
    };
    a = i && typeof i.ownKeys == "function" ? i.ownKeys : Object.getOwnPropertySymbols ? function(L) {
      return Object.getOwnPropertyNames(L).concat(Object.getOwnPropertySymbols(L));
    } : function(L) {
      return Object.getOwnPropertyNames(L);
    };
    var s = Number.isNaN || function(L) {
      return L != L;
    };
    function c() {
      c.init.call(this);
    }
    r.exports = c, r.exports.once = function(L, S) {
      return new Promise(function(E, j) {
        function g(C) {
          L.removeListener(S, w), j(C);
        }
        function w() {
          typeof L.removeListener == "function" && L.removeListener("error", g), E([].slice.call(arguments));
        }
        T(L, S, w, { once: !0 }), S !== "error" && function(C, b, M) {
          typeof C.on == "function" && T(C, "error", b, { once: !0 });
        }(L, g);
      });
    }, c.EventEmitter = c, c.prototype._events = void 0, c.prototype._eventsCount = 0, c.prototype._maxListeners = void 0;
    var p = 10;
    function h(L) {
      if (typeof L != "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof L);
    }
    function u(L) {
      return L._maxListeners === void 0 ? c.defaultMaxListeners : L._maxListeners;
    }
    function m(L, S, E, j) {
      var g, w, C, b;
      if (h(E), (w = L._events) === void 0 ? (w = L._events = /* @__PURE__ */ Object.create(null), L._eventsCount = 0) : (w.newListener !== void 0 && (L.emit("newListener", S, E.listener ? E.listener : E), w = L._events), C = w[S]), C === void 0) C = w[S] = E, ++L._eventsCount;
      else if (typeof C == "function" ? C = w[S] = j ? [E, C] : [C, E] : j ? C.unshift(E) : C.push(E), (g = u(L)) > 0 && C.length > g && !C.warned) {
        C.warned = !0;
        var M = new Error("Possible EventEmitter memory leak detected. " + C.length + " " + String(S) + " listeners added. Use emitter.setMaxListeners() to increase limit");
        M.name = "MaxListenersExceededWarning", M.emitter = L, M.type = S, M.count = C.length, b = M, console && console.warn && console.warn(b);
      }
      return L;
    }
    function d() {
      if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
    }
    function v(L, S, E) {
      var j = { fired: !1, wrapFn: void 0, target: L, type: S, listener: E }, g = d.bind(j);
      return g.listener = E, j.wrapFn = g, g;
    }
    function x(L, S, E) {
      var j = L._events;
      if (j === void 0) return [];
      var g = j[S];
      return g === void 0 ? [] : typeof g == "function" ? E ? [g.listener || g] : [g] : E ? function(w) {
        for (var C = new Array(w.length), b = 0; b < C.length; ++b) C[b] = w[b].listener || w[b];
        return C;
      }(g) : I(g, g.length);
    }
    function k(L) {
      var S = this._events;
      if (S !== void 0) {
        var E = S[L];
        if (typeof E == "function") return 1;
        if (E !== void 0) return E.length;
      }
      return 0;
    }
    function I(L, S) {
      for (var E = new Array(S), j = 0; j < S; ++j) E[j] = L[j];
      return E;
    }
    function T(L, S, E, j) {
      if (typeof L.on == "function") j.once ? L.once(S, E) : L.on(S, E);
      else {
        if (typeof L.addEventListener != "function") throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof L);
        L.addEventListener(S, function g(w) {
          j.once && L.removeEventListener(S, g), E(w);
        });
      }
    }
    Object.defineProperty(c, "defaultMaxListeners", { enumerable: !0, get: function() {
      return p;
    }, set: function(L) {
      if (typeof L != "number" || L < 0 || s(L)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + L + ".");
      p = L;
    } }), c.init = function() {
      this._events !== void 0 && this._events !== Object.getPrototypeOf(this)._events || (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
    }, c.prototype.setMaxListeners = function(L) {
      if (typeof L != "number" || L < 0 || s(L)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + L + ".");
      return this._maxListeners = L, this;
    }, c.prototype.getMaxListeners = function() {
      return u(this);
    }, c.prototype.emit = function(L) {
      for (var S = [], E = 1; E < arguments.length; E++) S.push(arguments[E]);
      var j = L === "error", g = this._events;
      if (g !== void 0) j = j && g.error === void 0;
      else if (!j) return !1;
      if (j) {
        var w;
        if (S.length > 0 && (w = S[0]), w instanceof Error) throw w;
        var C = new Error("Unhandled error." + (w ? " (" + w.message + ")" : ""));
        throw C.context = w, C;
      }
      var b = g[L];
      if (b === void 0) return !1;
      if (typeof b == "function") l(b, this, S);
      else {
        var M = b.length, R = I(b, M);
        for (E = 0; E < M; ++E) l(R[E], this, S);
      }
      return !0;
    }, c.prototype.addListener = function(L, S) {
      return m(this, L, S, !1);
    }, c.prototype.on = c.prototype.addListener, c.prototype.prependListener = function(L, S) {
      return m(this, L, S, !0);
    }, c.prototype.once = function(L, S) {
      return h(S), this.on(L, v(this, L, S)), this;
    }, c.prototype.prependOnceListener = function(L, S) {
      return h(S), this.prependListener(L, v(this, L, S)), this;
    }, c.prototype.removeListener = function(L, S) {
      var E, j, g, w, C;
      if (h(S), (j = this._events) === void 0) return this;
      if ((E = j[L]) === void 0) return this;
      if (E === S || E.listener === S) --this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete j[L], j.removeListener && this.emit("removeListener", L, E.listener || S));
      else if (typeof E != "function") {
        for (g = -1, w = E.length - 1; w >= 0; w--) if (E[w] === S || E[w].listener === S) {
          C = E[w].listener, g = w;
          break;
        }
        if (g < 0) return this;
        g === 0 ? E.shift() : function(b, M) {
          for (; M + 1 < b.length; M++) b[M] = b[M + 1];
          b.pop();
        }(E, g), E.length === 1 && (j[L] = E[0]), j.removeListener !== void 0 && this.emit("removeListener", L, C || S);
      }
      return this;
    }, c.prototype.off = c.prototype.removeListener, c.prototype.removeAllListeners = function(L) {
      var S, E, j;
      if ((E = this._events) === void 0) return this;
      if (E.removeListener === void 0) return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : E[L] !== void 0 && (--this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete E[L]), this;
      if (arguments.length === 0) {
        var g, w = Object.keys(E);
        for (j = 0; j < w.length; ++j) (g = w[j]) !== "removeListener" && this.removeAllListeners(g);
        return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
      }
      if (typeof (S = E[L]) == "function") this.removeListener(L, S);
      else if (S !== void 0) for (j = S.length - 1; j >= 0; j--) this.removeListener(L, S[j]);
      return this;
    }, c.prototype.listeners = function(L) {
      return x(this, L, !0);
    }, c.prototype.rawListeners = function(L) {
      return x(this, L, !1);
    }, c.listenerCount = function(L, S) {
      return typeof L.listenerCount == "function" ? L.listenerCount(S) : k.call(L, S);
    }, c.prototype.listenerCount = k, c.prototype.eventNames = function() {
      return this._eventsCount > 0 ? a(this._events) : [];
    };
  }, 348: function(r, a) {
    var i, l;
    i = function(s, c) {
      var p = 5e3, h = "callback";
      function u(d) {
        try {
          delete window[d];
        } catch {
          window[d] = void 0;
        }
      }
      function m(d) {
        var v = document.getElementById(d);
        v && document.getElementsByTagName("head")[0].removeChild(v);
      }
      c.exports = function(d) {
        var v = arguments.length <= 1 || arguments[1] === void 0 ? {} : arguments[1], x = d, k = v.timeout || p, I = v.jsonpCallback || h, T = void 0;
        return new Promise(function(L, S) {
          var E = v.jsonpCallbackFunction || "jsonp_" + Date.now() + "_" + Math.ceil(1e5 * Math.random()), j = I + "_" + E;
          window[E] = function(w) {
            L({ ok: !0, json: function() {
              return Promise.resolve(w);
            } }), T && clearTimeout(T), m(j), u(E);
          }, x += x.indexOf("?") === -1 ? "?" : "&";
          var g = document.createElement("script");
          g.setAttribute("src", "" + x + I + "=" + E), v.charset && g.setAttribute("charset", v.charset), v.nonce && g.setAttribute("nonce", v.nonce), v.referrerPolicy && g.setAttribute("referrerPolicy", v.referrerPolicy), v.crossorigin && g.setAttribute("crossorigin", "true"), g.id = j, document.getElementsByTagName("head")[0].appendChild(g), T = setTimeout(function() {
            S(new Error("JSONP request to " + d + " timed out")), u(E), m(j), window[E] = function() {
              u(E);
            };
          }, k), g.onerror = function() {
            S(new Error("JSONP request to " + d + " failed")), u(E), m(j), T && clearTimeout(T);
          };
        });
      };
    }, (l = i.apply(a, [a, r])) === void 0 || (r.exports = l);
  }, 156: function(r, a, i) {
    var l = this && this.__createBinding || (Object.create ? function(c, p, h, u) {
      u === void 0 && (u = h);
      var m = Object.getOwnPropertyDescriptor(p, h);
      m && !("get" in m ? !p.__esModule : m.writable || m.configurable) || (m = { enumerable: !0, get: function() {
        return p[h];
      } }), Object.defineProperty(c, u, m);
    } : function(c, p, h, u) {
      u === void 0 && (u = h), c[u] = p[h];
    }), s = this && this.__exportStar || function(c, p) {
      for (var h in c) h === "default" || Object.prototype.hasOwnProperty.call(p, h) || l(p, c, h);
    };
    Object.defineProperty(a, "__esModule", { value: !0 }), s(i(545), a);
  }, 789: function(r, a, i) {
    var l = this && this.__assign || function() {
      return l = Object.assign || function(g) {
        for (var w, C = 1, b = arguments.length; C < b; C++) for (var M in w = arguments[C]) Object.prototype.hasOwnProperty.call(w, M) && (g[M] = w[M]);
        return g;
      }, l.apply(this, arguments);
    }, s = this && this.__importDefault || function(g) {
      return g && g.__esModule ? g : { default: g };
    };
    Object.defineProperty(a, "__esModule", { value: !0 }), a.default = a.get_csrf_jwt_token = a.Backend = void 0;
    var c, p = s(i(348)), h = i(872);
    function u() {
      return window.CSRF_TOKEN ? window.CSRF_TOKEN : (0, h.getCookie)("csrftoken") || "";
    }
    (function(g) {
      g.get = "GET", g.post = "POST", g.put = "PUT", g.delete = "DELETE", g.patch = "PATCH";
    })(c || (c = {}));
    var m = function(g) {
      g === void 0 && (g = {});
      var w = "";
      Object.keys(g).forEach(function(b) {
        var M = g[b];
        Array.isArray(M) && (M.forEach(function(R) {
          w += "&".concat(b, "=").concat(R);
        }), delete g[b]);
      });
      var C = (0, h.qsStringify)(g);
      return C.length === 0 && w.replace("&", ""), C + w;
    }, d = function(g) {
      return Object.keys(g).forEach(function(w) {
        g[w] == null && delete g[w];
      }), g;
    }, v = function(g, w, C, b, M) {
      w === void 0 && (w = c.get), C === void 0 && (C = {});
      var R = w === c.get, O = w === c.delete, N = C.body, H = N == null ? void 0 : N.isJSON, Z = N && N instanceof FormData, z = C.responseType === "blob", K = C.responseType === "arrayBuffer", D = C.headers;
      N != null && N.headers && (D = l(l({}, D), N.headers), delete N.headers);
      var W = l({}, (!R || D) && { headers: l(l({}, !Z && { "Content-Type": H ? "application/json" : "application/x-www-form-urlencoded" }), D) });
      return (C = d(C)).body && (C.body = d(C.body)), H && delete C.body.isJSON, R ? (delete C.headers, Object.keys(C).length > 0 && (g += (g.includes("?") ? "&" : "?") + m(C))) : W.body = Z ? N : H ? JSON.stringify(N) : m(N), fetch(g, l({ method: w, credentials: b ? "omit" : "include" }, W)).then(function(q) {
        if (q.ok) {
          var e1 = q.headers.get("content-type") || "";
          return M ? { response: q, encoding: e1.split("charset=")[1] || "utf-8" } : z ? q.blob() : K ? q.arrayBuffer() : O ? q.text() : q.json();
        }
        return Promise.reject(q);
      }).catch(function(q) {
        return Promise.reject(q);
      });
    }, x = function(g, w, C, b) {
      return v(g, c.get, w, C, b).then(function(M) {
        return M;
      });
    }, k = function(g, w, C) {
      return v(g, c.post, w, C).then(function(b) {
        return b;
      });
    }, I = function(g, w, C) {
      return v(g, c.put, w, C).then(function(b) {
        return b;
      });
    }, T = function(g, w, C) {
      return v(g, c.delete, w, C).then(function(b) {
        return b;
      });
    }, L = !1;
    function S(g, w, C, b) {
      return function(M) {
        M ? M.code === 8018 ? function() {
          if (L) return g(C, b), !1;
          var R = "//".concat((0, h.getAuthHost)("auth-ac"), "/sdc"), O = "callback" + ((/* @__PURE__ */ new Date()).valueOf() + Math.floor(1e3 * Math.random()));
          (0, p.default)("".concat(R, "?from=").concat((0, h.absoluteUrl)(w)), { timeout: 1e4, jsonpCallback: "JSONP_call", jsonpCallbackFunction: O }).then(function() {
            L = !0, g(C, b);
          }).catch(function(N) {
            b(N);
          });
        }() : C(M) : b();
      };
    }
    var E = { api_get: function(g, w) {
      return g = (0, h.build_api_url)(g), new Promise(function C(b, M) {
        x(g, w).then(S(C, g, b, M)).catch(function(R) {
          return M(R);
        });
      });
    }, get: function(g, w) {
      return new Promise(function C(b, M) {
        x(g, w).then(S(C, g, b, M)).catch(function(R) {
          return M(R);
        });
      });
    }, get_without_cred: function(g, w) {
      return new Promise(function C(b, M) {
        x(g, w, !0).then(S(C, g, b, M)).catch(function(R) {
          return M(R);
        });
      });
    }, api_post: function(g, w) {
      return j().then(function(C) {
        return g = (0, h.build_api_url)(g), w = l({ csrfmiddlewaretoken: u(), csrfmiddlewaretoken_jwt: C }, w), new Promise(function b(M, R) {
          k(g, { body: w }).then(S(b, g, M, R)).catch(function(O) {
            return R(O);
          });
        });
      });
    }, api_patch: function(g, w) {
      return j().then(function(C) {
        return g = (0, h.build_api_url)(g), w = l({ csrfmiddlewaretoken: u(), csrfmiddlewaretoken_jwt: C }, w), new Promise(function b(M, R) {
          (function(O, N, H) {
            return v(O, c.patch, N, H).then(function(Z) {
              return Z;
            });
          })(g, { body: w }).then(S(b, g, M, R)).catch(function(O) {
            return R(O);
          });
        });
      });
    }, api_delete: function(g) {
      return j().then(function() {
        return g = (0, h.build_api_url)(g), new Promise(function w(C, b) {
          T(g).then(S(w, g, C, b)).catch(function(M) {
            return b(M);
          });
        });
      });
    }, delete: function(g) {
      return j().then(function(w) {
        return new Promise(function C(b, M) {
          T(g, { headers: { "X-CSRFToken": u(), "X-JWTCSRFToken": w } }).then(S(C, g, b, M)).catch(function(R) {
            return M(R);
          });
        });
      });
    }, api_put: function(g, w) {
      return j().then(function(C) {
        return g = (0, h.build_api_url)(g), w = l({ csrfmiddlewaretoken: u(), csrfmiddlewaretoken_jwt: C }, w), new Promise(function b(M, R) {
          I(g, { body: w }).then(S(b, g, M, R)).catch(function(O) {
            return R(O);
          });
        });
      });
    }, remote_api_post: function(g, w) {
      return new Promise(function(C, b) {
        k(g, { body: w }).then(function(M) {
          M ? C(M) : b();
        }).catch(function(M) {
          return b(M);
        });
      });
    }, doc_get: function(g, w) {
      return new Promise(function(C, b) {
        x(g, w, !0, !0).then(function(M) {
          var R = M.response, O = M.encoding;
          O === "utf-8" ? R.text().then(function(N) {
            N ? C(N) : b();
          }) : R.arrayBuffer().then(function(N) {
            if (N) {
              var H = new TextDecoder(O);
              C(H.decode(N));
            } else b();
          });
        }).catch(function(M) {
          return b(M);
        });
      });
    }, simple_post: function(g, w) {
      return new Promise(function(C, b) {
        k(g, { body: w }, !0).then(function(M) {
          M ? C(M) : b();
        }).catch(function(M) {
          return b(M);
        });
      });
    }, remote_api_get: function(g, w) {
      return new Promise(function(C, b) {
        x(g, w).then(function(M) {
          C(M);
        }).catch(function(M) {
          return b(M);
        });
      });
    }, post: function(g, w) {
      return j().then(function(C) {
        return w = l({ csrfmiddlewaretoken: u(), csrfmiddlewaretoken_jwt: C }, w), new Promise(function b(M, R) {
          k(g, { body: w, responseType: w == null ? void 0 : w.responseType }).then(S(b, g, M, R)).catch(function(O) {
            return R(O);
          });
        });
      });
    }, post_formdata: function(g, w, C) {
      var b = C.file, M = C.fileField, R = M === void 0 ? "filedata" : M;
      return j().then(function(O) {
        var N = new FormData();
        for (var H in w = l({ csrfmiddlewaretoken: u(), csrfmiddlewaretoken_jwt: O }, w)) w[H] && N.append("".concat(H), "".concat(w[H]));
        return N.append("".concat(R), b), new Promise(function Z(z, K) {
          k(g, { body: N }).then(S(Z, g, z, K)).catch(function(D) {
            return K(D);
          });
        });
      });
    }, post_real_formdata: function(g, w) {
      return j().then(function(C) {
        return w.append("csrfmiddlewaretoken", u()), w.append("csrfmiddlewaretoken_jwt", C), new Promise(function b(M, R) {
          k(g, { body: w }).then(S(b, g, M, R)).catch(function(O) {
            return R(O);
          });
        });
      });
    }, put: function(g, w) {
      return new Promise(function C(b, M) {
        I(g, w).then(S(C, g, b, M)).catch(function(R) {
          return M(R);
        });
      });
    }, jsonp: function(g, w) {
      var C = w;
      return C = typeof w != "string" ? w ? "?".concat(new URLSearchParams(w).toString()) : "" : w ? "?".concat(C) : "", new Promise(function(b, M) {
        (0, p.default)("".concat(g).concat(C), { timeout: 1e4 }).then(function(R) {
          return R.json();
        }).then(function(R) {
          b(R);
        }).catch(function(R) {
          M(R);
        });
      });
    } };
    function j() {
      var g = window.__GEMS && window.__GEMS.token || window.CSRF_JWT_TOKEN;
      return new Promise(function(w) {
        g || window.__GEMS && window.__GEMS.no_session ? w(g) : E.api_get("/social/profile/user_token").then(function(C) {
          C.status === "fail" && window.__GEMS && (window.__GEMS.no_session = !0), window.__GEMS && h.isGem && (window.__GEMS.token = C.token), window.CSRF_JWT_TOKEN = C.token, w(C.token);
        }, function() {
          return window.__GEMS && (window.__GEMS.no_session = !0), w("");
        });
      });
    }
    a.Backend = E, a.default = E, a.get_csrf_jwt_token = j;
  }, 318: function(r, a, i) {
    var l = this && this.__importDefault || function(h) {
      return h && h.__esModule ? h : { default: h };
    };
    Object.defineProperty(a, "__esModule", { value: !0 }), a.default = a.Broadcast = void 0;
    var s = l(i(7)), c = function() {
      var h = (/* @__PURE__ */ new Date()).getTime(), u = {};
      try {
        u = window.localStorage;
      } catch (v) {
        console.error("[broadcast]", v);
      }
      var m = new s.default(), d = function(v) {
        var x, k = (v.key || "").match(/^broadcast_(.*)$/);
        if (k) {
          x = k[1];
          var I = JSON.parse(v.newValue);
          I.sender !== h && m.emit(x, I);
        }
      };
      return { selfId: h, post: function(v, x) {
        x.ts = (/* @__PURE__ */ new Date()).getTime(), x.sender = h, u["broadcast_" + v] = JSON.stringify(x);
      }, on: function(v, x) {
        m.on(v, x);
      }, off: function(v, x) {
        x ? m.removeListener(v, x) : m.removeAllListeners(v);
      }, init: function() {
        try {
          u.setItem("test", "1"), u.removeItem("test");
        } catch {
          u = {};
        }
        window.addEventListener("storage", d, !1);
      } };
    }();
    function p() {
      c.init();
    }
    a.Broadcast = c, a.default = c, document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", function h() {
      p(), document.removeEventListener("DOMContentLoaded", h);
    }) : p();
  }, 747: function(r, a) {
    Object.defineProperty(a, "__esModule", { value: !0 }), a.default = a.HashUtils = void 0;
    var i = { LongMath: { add64: function(l, s) {
      var c, p = { h: l.h + s.h, l: l.l + s.l };
      return c = p.l / 4294967296 >>> 0, p.l = (4294967295 & p.l) >>> 0, p.h = (p.h + c & 4294967295) >>> 0, p;
    }, mul64: function(l, s) {
      var c = this.mul32(l.l, s.l), p = this.mul32(l.h, s.l), h = this.mul32(l.l, s.h);
      return { h: (c.h + p.l + h.l & 4294967295) >>> 0, l: c.l };
    }, mul32: function(l, s) {
      var c = l >> 16 & 65535, p = 65535 & l, h = s >> 16 & 65535, u = 65535 & s, m = p * u, d = c * u, v = p * h, x = (m + (d + v << 16) >>> 0 & 4294967295) >>> 0;
      return { h: c * h + ((m + 65536 * (d + v) - x) / 4294967296 >>> 0), l: x };
    } }, SipHash: /* @__PURE__ */ function() {
      function l(d, v) {
        var x = d.l + v.l, k = { h: d.h + v.h + (x / 2 >>> 31) >>> 0, l: x >>> 0 };
        d.h = k.h, d.l = k.l;
      }
      function s(d, v) {
        d.h ^= v.h, d.h >>>= 0, d.l ^= v.l, d.l >>>= 0;
      }
      function c(d, v) {
        var x = { h: d.h << v | d.l >>> 32 - v, l: d.l << v | d.h >>> 32 - v };
        d.h = x.h, d.l = x.l;
      }
      function p(d) {
        var v = d.l;
        d.l = d.h, d.h = v;
      }
      function h(d, v, x, k) {
        l(d, v), l(x, k), c(v, 13), c(k, 16), s(v, d), s(k, x), p(d), l(x, v), l(d, k), c(v, 17), c(k, 21), s(v, x), s(k, d), p(x);
      }
      function u(d, v) {
        return d.charCodeAt(v + 3) << 24 | d.charCodeAt(v + 2) << 16 | d.charCodeAt(v + 1) << 8 | d.charCodeAt(v);
      }
      function m(d, v) {
        var x, k = { h: d[1] >>> 0, l: d[0] >>> 0 }, I = { h: d[3] >>> 0, l: d[2] >>> 0 }, T = { h: k.h, l: k.l }, L = k, S = { h: I.h, l: I.l }, E = I, j = v.length, g = j - 7, w = new Uint8Array(new ArrayBuffer(8)), C = 0;
        for (s(T, { h: 1936682341, l: 1886610805 }), s(S, { h: 1685025377, l: 1852075885 }), s(L, { h: 1819895653, l: 1852142177 }), s(E, { h: 1952801890, l: 2037671283 }); C < g; ) s(E, x = { h: u(v, C + 4), l: u(v, C) }), h(T, S, L, E), h(T, S, L, E), s(T, x), C += 8;
        w[7] = j;
        for (var b = 0; C < j; ) w[b++] = v.charCodeAt(C++);
        for (; b < 7; ) w[b++] = 0;
        s(E, x = { h: w[7] << 24 | w[6] << 16 | w[5] << 8 | w[4], l: w[3] << 24 | w[2] << 16 | w[1] << 8 | w[0] }), h(T, S, L, E), h(T, S, L, E), s(T, x), s(L, { h: 0, l: 255 }), h(T, S, L, E), h(T, S, L, E), h(T, S, L, E), h(T, S, L, E);
        var M = T;
        return s(M, S), s(M, L), s(M, E), M;
      }
      return { string16_to_key: function(d) {
        return [u(d, 0), u(d, 4), u(d, 8), u(d, 12)];
      }, hash: m, hash_hex: function(d, v) {
        var x = m(d, v);
        return ("0000000" + x.h.toString(16)).substr(-8) + ("0000000" + x.l.toString(16)).substr(-8);
      }, hash_uint: function(d, v) {
        var x = m(d, v);
        return 4294967296 * (2097151 & x.h) + x.l;
      } };
    }(), jumphash: function(l, s) {
      for (var c = { h: 666578662, l: 2276503805 }, p = 0, h = -1; p < s; ) h = p, l = i.LongMath.mul64(l, c), l = i.LongMath.add64(l, { h: 0, l: 1 }), p = Math.floor((h + 1) * (2147483648 / (1 + (l.h >>> 1))));
      return h;
    }, getShard: function(l, s) {
      return i.jumphash(i.SipHash.hash(0, l), s);
    } };
    a.HashUtils = i, a.default = i;
  }, 545: function(r, a, i) {
    var l = this && this.__createBinding || (Object.create ? function(c, p, h, u) {
      u === void 0 && (u = h);
      var m = Object.getOwnPropertyDescriptor(p, h);
      m && !("get" in m ? !p.__esModule : m.writable || m.configurable) || (m = { enumerable: !0, get: function() {
        return p[h];
      } }), Object.defineProperty(c, u, m);
    } : function(c, p, h, u) {
      u === void 0 && (u = h), c[u] = p[h];
    }), s = this && this.__exportStar || function(c, p) {
      for (var h in c) h === "default" || Object.prototype.hasOwnProperty.call(p, h) || l(p, c, h);
    };
    Object.defineProperty(a, "__esModule", { value: !0 }), s(i(287), a), s(i(872), a), s(i(789), a), s(i(318), a), s(i(63), a), s(i(638), a);
  }, 63: function(r, a, i) {
    var l = this && this.__importDefault || function(m) {
      return m && m.__esModule ? m : { default: m };
    };
    Object.defineProperty(a, "__esModule", { value: !0 }), a.default = a.MasterSlave = void 0;
    var s, c = l(i(7)), p = i(318), h = i(872);
    function u() {
      s.init();
    }
    a.MasterSlave = s, a.default = s, h.inGamecenter ? a.default = a.MasterSlave = s = { _master: !1, _events: new c.default(), isMaster: function() {
      return this._master;
    }, on: function(m, d) {
      s._events.on(m, d);
    }, off: function(m, d) {
      d ? s._events.removeListener(m, d) : s._events.removeAllListeners(m);
    }, init: function() {
      s._master = window.location.pathname.search("/gamecenter/chat") === 0 || window.location.pathname.search("/app") === 0, s._events.emit("master");
    } } : a.default = a.MasterSlave = s = { _events: new c.default(), broadcastHandle: null, tryMasterHandle: null, masterId: null, authIdentity: null, debugFlag: !1, _debug: function() {
      for (var m = [], d = 0; d < arguments.length; d++) m[d] = arguments[d];
      s.debugFlag && window.console && window.console.debug.apply(window, m);
    }, _becomeMaster: function() {
      s._debug("become master"), s.masterId = p.Broadcast.selfId, s._sendBroadcast(), s._events.emit("master");
    }, _becomeDeadman: function() {
      s._debug("become deadman"), s.isMaster() && (s.masterId = 0, clearTimeout(s.broadcastHandle), p.Broadcast.post("master_resign", {})), p.Broadcast.off("master_broadcast"), p.Broadcast.off("master_resign"), s._events.emit("deadman");
    }, _sendBroadcast: function() {
      s.isMaster() && (s.isAuthChanged() ? s._becomeDeadman() : (s._debug("master broadcast", p.Broadcast.selfId), clearTimeout(s.broadcastHandle), s.broadcastHandle = setTimeout(s._sendBroadcast, 1200), p.Broadcast.post("master_broadcast", {})));
    }, _tryBecomeMaster: function(m) {
      var d = (m || 0) + Math.round(500 * Math.random());
      s._debug("_tryBecomeMaster", m), clearTimeout(s.tryMasterHandle), s.isAuthChanged() ? s._becomeDeadman() : s.tryMasterHandle = setTimeout(s._becomeMaster, d);
    }, _acceptMaster: function(m) {
      (!s.isMaster() || m.sender < p.Broadcast.selfId) && (s._debug("accept master", m.sender), s.isMaster() && s._events.emit("slave"), s.masterId = m.sender, clearTimeout(s.broadcastHandle), clearTimeout(s.tryMasterHandle), s._tryBecomeMaster(5e3));
    }, isMaster: function() {
      return s.masterId === p.Broadcast.selfId;
    }, isAuthChanged: function() {
      return !!s.authIdentityGetter && s.authIdentity !== s.authIdentityGetter();
    }, on: function(m, d) {
      s._events.on(m, d);
    }, off: function(m, d) {
      d ? s._events.removeListener(m, d) : s._events.removeAllListeners(m);
    }, init: function(m) {
      s.authIdentityGetter = m, m && (s.authIdentity = m()), p.Broadcast.on("master_broadcast", s._acceptMaster), p.Broadcast.on("master_resign", s._tryBecomeMaster), window.addEventListener("unload", s._becomeDeadman, !1), s._tryBecomeMaster(2e3);
    } }, document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", function m() {
      u(), document.removeEventListener("DOMContentLoaded", m);
    }) : u();
  }, 638: function(r, a, i) {
    Object.defineProperty(a, "__esModule", { value: !0 }), a.tmrStopTimespent = a.tmrStartTimespent = a.tmrPushTimespent = a.TimespentEventTypes = a.HostsActivityID = void 0;
    var l, s, c = i(872);
    (function(d) {
      d.GamePage = "68", d.Catalog = "69", d.GOF = "70", d.Community = "71", d.Profile = "72", d.Support = "74";
    })(l = a.HostsActivityID || (a.HostsActivityID = {})), function(d) {
      d.Start = "startForegroundTimespent", d.Stop = "stopTimespent";
    }(s = a.TimespentEventTypes || (a.TimespentEventTypes = {}));
    var p = "3252498", h = "showcase_timespent_started", u = function() {
      try {
        return window.localStorage.getItem(h);
      } catch (d) {
        return console.error("Error getting timespent status:", d), null;
      }
    }, m = function(d) {
      try {
        d ? window.localStorage.setItem(h, d) : window.localStorage.removeItem(h);
      } catch (v) {
        console.error("Error setting timespent:", v);
      }
    };
    a.tmrPushTimespent = function(d, v) {
      var x = window.location, k = x.hostname, I = x.pathname, T = k === (0, c.getGemHost)("store"), L = k === (0, c.getGemHost)("gof"), S = k === (0, c.getGemHost)("community"), E = k === (0, c.getGemHost)("profile"), j = k === (0, c.getGemHost)("support"), g = T && (I.includes("/play/game/") || I.includes("/gamecenter/game")), w = T && I.includes("/play/") && !(I.includes("/play/game/") || I.includes("/play/my/") || I.includes("/play/promo/") || I.includes("/play/market/") || I.includes("/play/code/")), C = g ? l.GamePage : w ? l.Catalog : L ? l.GOF : S ? l.Community : E ? l.Profile : j ? l.Support : "", b = v || C;
      v && v === C || (d === s.Start ? m(b) : m(), b !== "" && ((window._tmr || (window._tmr = [])).push({ id: p, type: d, activity: b }), console.log("⏱ tmr event sent:", d, p, "siteId: ".concat(b))));
    }, a.tmrStartTimespent = function(d) {
      var v = d ? u() : null;
      (0, a.tmrPushTimespent)(s.Start, v);
    }, a.tmrStopTimespent = function() {
      var d = u();
      d && (0, a.tmrPushTimespent)(s.Stop, d);
    };
  }, 872: function(r, a) {
    var i = this && this.__assign || function() {
      return i = Object.assign || function(g) {
        for (var w, C = 1, b = arguments.length; C < b; C++) for (var M in w = arguments[C]) Object.prototype.hasOwnProperty.call(w, M) && (g[M] = w[M]);
        return g;
      }, i.apply(this, arguments);
    };
    Object.defineProperty(a, "__esModule", { value: !0 }), a.isCorpUser = a.isMyGamesEmail = a.isMailRuEmail = a.isMobile = a.isProduction = a.isMacGC = a.isMac = a.isWindows = a.inGamecenter = a.getAuthHost = a.getGemHost = a.hostname_rgx = a.domain_rgx = a.API_DOMAIN = a.DOMAIN = a.isVkPlayMedia = a.isGCUserAgent = a.isChatPage = a.isGm3 = a.isGm2 = a.isAtTest = a.isMyCom = a.isMailRu = a.isDevDomain = a.isGMR = a.isGem = a.isAstrum = a.isMyGames = a.isVkPlay = a.isVkPlayLive = a.isVkPlayRu = a.isDevVkPlay = a.isDevMyGames = a.isDevGem = a.isProductionMode = a.isDevMode = a.VKPLAY_DEV_DOMAIN = a.VKPLAY_LIVE_DOMAIN = a.VKPLAY_DOMAIN = a.SUPPORT_DOMAIN = a.MYCOM_DOMAIN = a.MAILRU_DOMAIN = a.GMR_GM_HOST = a.GMR_GM3_DOMAIN = a.GMR_GM2_DOMAIN = a.GMR_DOMAIN = a.ASTRUM_DOMAIN_RU = a.ASTRUM_DOMAIN = a.MYGAMES_DEV_DOMAIN = a.MYGAMES_DOMAIN = void 0, a.getUserCMPConsent = a.getShortLocale = a.isOpenForWorld = a.calculateAge = a.setScriptTag = a.setLinkTag = a.openGameProfileURL = a.createGCGameURL = a.openUserProfileURL = a.openURL = a.getUserProfileURL = a.decodeEntities = a.allowCloud = a.isCis = a.CIS_REGIONS = a.copyTextToClipboard = a.copyTextToClipboardIE11 = a.createCallLastDecorator = a.createDebounceDecorator = a.createThrottlingDecorator = a.getRandomInt = a.formatPrice = a.formatNumber = a.humanFileSize = a.isValidDate = a.resizePic = a.declineNum = a.qsStringify = a.query_string = a.htmlUnescape = a.htmlEscape = a.setCookie = a.getCookie = a.triggerPixel = a.safeRedirectUrl = a.safeUrl = a.absoluteUrl = a.buildGcHttpUrl = a.getGoogleCID = a.rbClick = a.rbShow = a.openGCUrl = a.build_url = a.build_api_url = a.showSignupBlock = a.showAuthBlock = a.isMyGamesApp = a.Domains = a.getShards = a.origin_by_login = void 0;
    var l = /^[^@]+@(mail\.ru|xmail\.ru|list\.ru|inbox\.ru|bk\.ru|internet\.ru|corp\.mail\.ru|mail\.ua|vk\.com|vk\.team|vkteam\.ru|vk\.ru|corp\.vk\.ru|corp\.my\.com)$/, s = /^[^@]+@(corp\.mail.ru|corp\.vk\.com|vk\.team|vkteam\.ru)$/, c = /^[^@]+@(my\.games|guestmg(?:0[1-4])?\.pro)$/;
    a.MYGAMES_DOMAIN = "my.games", a.MYGAMES_DEV_DOMAIN = "dev-my.games", a.ASTRUM_DOMAIN = "astrum.top", a.ASTRUM_DOMAIN_RU = "astrum-entertainment.ru", a.GMR_DOMAIN = "games.mail.ru", a.GMR_GM2_DOMAIN = "games.gm2.corp.mail.ru", a.GMR_GM3_DOMAIN = "games.gm3.corp.mail.ru", a.GMR_GM_HOST = window.location.hostname.match(/gm\d/), a.MAILRU_DOMAIN = "mail.ru", a.MYCOM_DOMAIN = "my.com", a.SUPPORT_DOMAIN = "support.my.games", a.VKPLAY_DOMAIN = "vkplay.ru", a.VKPLAY_LIVE_DOMAIN = "vkplay.live", a.VKPLAY_DEV_DOMAIN = "dev-vkplay.ru", a.isDevMode = function() {
      return !1;
    }, a.isProductionMode = !0, a.isDevGem = window.location.hostname.endsWith(a.MYGAMES_DEV_DOMAIN) || window.location.hostname.endsWith(a.VKPLAY_DEV_DOMAIN), a.isDevMyGames = window.location.hostname.endsWith(a.MYGAMES_DEV_DOMAIN), a.isDevVkPlay = window.location.hostname.endsWith(a.VKPLAY_DEV_DOMAIN), a.isVkPlayRu = window.location.hostname.endsWith(a.VKPLAY_DOMAIN), a.isVkPlayLive = window.location.hostname.endsWith(a.VKPLAY_LIVE_DOMAIN), a.isVkPlay = a.isVkPlayRu || a.isVkPlayLive || window.isVkp, a.isMyGames = window.location.hostname.endsWith(a.MYGAMES_DOMAIN), a.isAstrum = window.location.hostname.endsWith(a.ASTRUM_DOMAIN) || window.location.hostname.endsWith(a.ASTRUM_DOMAIN_RU), a.isGem = a.isMyGames || a.isVkPlay, a.isGMR = window.location.hostname.endsWith(a.GMR_DOMAIN) || window.location.hostname.endsWith(a.GMR_GM2_DOMAIN) || window.location.hostname.endsWith(a.GMR_GM3_DOMAIN), a.isDevDomain = a.isDevGem && a.isGem, a.isMailRu = window.location.hostname.endsWith(a.MAILRU_DOMAIN), a.isMyCom = window.location.hostname.endsWith(a.MYCOM_DOMAIN), a.isAtTest = k("at_test") === "1", a.isGm2 = location.origin.includes("gm2"), a.isGm3 = location.origin.includes("gm3"), a.isChatPage = location.pathname.includes("/chat"), a.isGCUserAgent = navigator.userAgent.match(/\bDownloader\/\d+\b/);
    var p, h, u = location.pathname.includes("/gamecenter/") || location.search.includes("in_gamecenter=1");
    function m(g) {
      var w = a.hostname_rgx.exec(window.location.hostname);
      w || (w = window.location.hostname.endsWith("dev-vkplay.ru") ? a.hostname_rgx.exec("store.dev-vkplay.ru") : a.hostname_rgx.exec(a.isMyGames ? a.MYGAMES_DOMAIN : a.VKPLAY_DOMAIN));
      var C = w[1] || "", b = w[3] || "", M = w[4] || "", R = w[5], O = w[3] !== void 0, N = w[4] !== void 0, H = !O && !N;
      return H && !a.isMyGames && g === "store" ? R : H && !a.isMyGames && g === "chat" ? "chat.".concat(R) : "".concat(C).concat(g, ".").concat(b).concat(M).concat(R);
    }
    function d(g) {
      if (g = g || "/", a.isGem) {
        if (g.indexOf("/profile/") > -1) return "//" + m("profile") + g;
      } else if (window.location.hostname.endsWith("corp.mail.ru")) {
        var w = window.location.hostname.split("."), C = "games.gm2.corp.mail.ru";
        return w[0] === "bonus" || w[0] === "market" ? "//games.mail.ru" + g : "//" + (C = w[0].length === 1 ? w[0] + "." + w[1] + "." + C : w[0] + "." + C) + g;
      }
      return "//games.mail.ru" + g;
    }
    function v(g, w) {
      a.inGamecenter && window.gc_open_url_mainwnd && (w = w || g.target.href) && (g.preventDefault(), w.indexOf("//") === 0 && (w = "https:" + w), window.gc_open_url_mainwnd(w));
    }
    function x(g) {
      return g.startsWith("//") ? g = document.location.protocol + g : /^https?:\/\//i.test(g) || (g = document.location.origin + g), g;
    }
    function k(g) {
      var w = document.cookie.match(new RegExp("(?:^|; )" + g.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
      return w ? decodeURIComponent(w[1]) : void 0;
    }
    function I(g) {
      for (var w = {}, C = (g || window.location.search || "").replace(/^[^?]*\?/, "").split("&"), b = 0; b < C.length; b++) {
        var M = C[b], R = M.indexOf("="), O = decodeURIComponent(M.substr(0, R));
        O && (w[O] = decodeURIComponent(M.substr(R + 1)));
      }
      return w;
    }
    function T(g, w) {
      g === void 0 && (g = {}), w === void 0 && (w = {});
      var C = w.addQueryPrefix, b = C !== void 0 && C;
      return typeof g == "object" ? Object.keys(g).reduce(function(M, R) {
        return g[R] !== void 0 && g[R] !== "" && g[R] !== null && (b && M.length === 0 ? M += "?" : (b && M.length > 0 || M.length > 0) && (M += "&"), M += "".concat(R, "=").concat(encodeURIComponent(g[R]))), M;
      }, "") : "";
    }
    function L(g) {
      return Object.prototype.toString.call(g) === "[object Date]" && !isNaN(g.getTime());
    }
    function S(g, w) {
      var C = w.decimalSignType, b = C === void 0 ? "point" : C, M = w.postfix, R = M === void 0 ? "" : M, O = w.prefix, N = O === void 0 ? "" : O, H = w.separateThousandsWith, Z = g.toString();
      return b === "comma" && (Z = Z.replace(".", ",")), H && (Z = Z.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1".concat(H))), "".concat(N).concat(Z).concat(R);
    }
    a.isVkPlayMedia = window.location.hostname.includes("media."), a.DOMAIN = a.isDevMyGames ? a.MYGAMES_DEV_DOMAIN : a.isDevVkPlay ? a.VKPLAY_DEV_DOMAIN : a.isVkPlay ? a.VKPLAY_DOMAIN : a.isMailRu ? a.MAILRU_DOMAIN : a.isMyGames ? a.MYGAMES_DOMAIN : a.isMyCom ? a.MYCOM_DOMAIN : a.isAstrum ? a.ASTRUM_DOMAIN : a.VKPLAY_DOMAIN, a.API_DOMAIN = "api.".concat(a.DOMAIN), a.domain_rgx = new RegExp("^https?://([^/]+.)?".concat(a.DOMAIN)), a.hostname_rgx = new RegExp("^([^.]+-)?(?:([^.-]+).)?((?:gm[123]|test[12]).)?(dev-)?(my.games|vkplay.ru|astrum.top)$"), a.getGemHost = m, a.getAuthHost = function(g) {
      var w = a.hostname_rgx.exec(window.location.hostname);
      w || (w = window.location.hostname.endsWith("dev-vkplay.ru") ? a.hostname_rgx.exec("store.dev-vkplay.ru") : a.hostname_rgx.exec(a.isMyGames ? a.MYGAMES_DOMAIN : a.VKPLAY_DOMAIN));
      var C = w[4] || "", b = w[5];
      return "".concat(g, ".").concat(C).concat(b);
    }, a.inGamecenter = !(window.location.pathname.indexOf("/gamecenter/download") > -1) && (u || a.isGCUserAgent || window.IN_GAMECENTER), a.isWindows = navigator.platform.toLowerCase().indexOf("win") > -1, a.isMac = /Macintosh/i.test(navigator.userAgent), a.isMacGC = a.inGamecenter && a.isMac, a.isProduction = a.isGem && !a.isGm3 || window.location.hostname.endsWith(a.GMR_DOMAIN) || document.domain === "games.my.com", a.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent), a.isMailRuEmail = function(g) {
      return l.test(g);
    }, a.isMyGamesEmail = function(g) {
      return c.test(g);
    }, a.isCorpUser = function(g) {
      return s.test(g);
    }, a.origin_by_login = function(g) {
      return g ? (0, a.isMailRuEmail)(g) ? "mailru" : g.endsWith("@vk") ? "vk" : g.endsWith("@ok") ? "ok" : isNaN(g) ? g.endsWith("@facebook") ? "fb" : g.endsWith("@twitter") ? "tw" : g.endsWith("@discord") ? "ds" : g.endsWith("@google") ? "g" : g.endsWith("@steam") ? "steam" : g.endsWith("@twitch") ? "twitch" : g.endsWith("@hitbox") ? "hitbox" : g.endsWith("@ps") ? "ps" : g.endsWith("@xbox") ? "xbox" : g.endsWith("@apple") ? "apple" : g.endsWith("@eg") ? "eg" : g.endsWith("@pl") ? "pl" : g.endsWith("@ns") ? "ns" : (0, a.isMyGamesEmail)(g) ? "mygames" : g.indexOf("@") > 0 ? "e" : void console.error("unknown origin for login: '".concat(g, "'")) : "p" : "";
    }, a.getShards = function() {
      return a.isGem ? (w = ["ws0.".concat(a.API_DOMAIN)], C = ["ws0.gm2.".concat(a.DOMAIN), "ws1.gm2.".concat(a.DOMAIN)], b = ["ws0.gm3.".concat(a.DOMAIN)], M = ["wss0.".concat(a.API_DOMAIN), "wss1.".concat(a.API_DOMAIN), "wss2.".concat(a.API_DOMAIN), "wss3.".concat(a.API_DOMAIN), "wss4.".concat(a.API_DOMAIN), "wss5.".concat(a.API_DOMAIN)], R = ["eu-ws0.".concat(a.API_DOMAIN), "eu-ws1.".concat(a.API_DOMAIN), "eu-ws2.".concat(a.API_DOMAIN), "eu-ws3.".concat(a.API_DOMAIN), "eu-ws4.".concat(a.API_DOMAIN), "eu-ws5.".concat(a.API_DOMAIN)], a.isDevGem ? a.isGm3 ? b : w : a.isProduction ? a.isMyGames ? R : M : C) : (g = ["ws0.".concat(a.GMR_DOMAIN), "ws1.".concat(a.GMR_DOMAIN), "ws2.".concat(a.GMR_DOMAIN), "ws3.".concat(a.GMR_DOMAIN), "ws4.".concat(a.GMR_DOMAIN), "ws5.".concat(a.GMR_DOMAIN)], a.isProduction ? g : ["ws0.games.gm2.corp.mail.ru", "ws1.games.gm2.corp.mail.ru"]);
      var g, w, C, b, M, R;
    }, a.Domains = { wsd: (0, a.getShards)() }, a.isMyGamesApp = (p = navigator.userAgent, h = I(), p.indexOf("com.my.mygamesapp") > -1 || h.is_mygames_app === "1"), a.showAuthBlock = function(g) {
      window.__GEMS && g && (window.__GEMS.continue = g), a.isMyGamesApp ? messageHandler.postMessage("LOGIN") : a.inGamecenter ? window.gc_show_auth_window && window.gc_show_auth_window() : a.isMyCom ? window.__GMC && window.__GMC.showLogin() : a.isGem ? window.__GEM && window.__GEM.showLogin(g) : a.isAtTest && window.__GMR_HEADER && window.__GMR_HEADER.showSignIn ? window.__GMR_HEADER.showSignIn(g) : window.__PH && window.__PH.authForm.show({ mobile_redirect: 1, successPage: g });
    }, a.showSignupBlock = function(g) {
      a.isMyCom ? window.__GMC && window.__GMC.showSignup() : a.isGem ? window.__GEM && window.__GEM.showSignup(g) : window.__PH && window.__PH.authForm.show({ mobile_redirect: 1, successPage: g });
    }, a.build_api_url = function(g) {
      g = g || "/";
      var w = window.location.hostname.replace(/^m([-.])/, "");
      if (w != null && w.endsWith("my.com")) return w != null && w.endsWith("dev.my.com") ? "//api-" + w + g : "//api.games.my.com" + g;
      if (w != null && w.endsWith("corp.mail.ru")) {
        var C = window.location.hostname.split(".")[0];
        return "//".concat(C, "-api.games.").concat(a.GMR_GM_HOST, ".corp.mail.ru").concat(g);
      }
      return w != null && w.endsWith("dev-my.games") ? "//api.dev-my.games".concat(g) : a.isGem ? "//" + m("api") + g : "//api.games.mail.ru" + g;
    }, a.build_url = d, a.openGCUrl = v, a.rbShow = function(g) {
      g = String(g || "").replace(/^\s*(cl[nb])?/, "").replace(/\s*$/, ""), new Image().src = "//rs.mail.ru/d" + g + ".gif?rnd=" + Math.random();
    }, a.rbClick = function(g) {
      g = String(g || "").replace(/^\s*(cl[nb])?/, "").replace(/\s*$/, ""), new Image().src = "//rs.mail.ru/sb" + g + ".gif?rnd=" + Math.random();
    }, a.getGoogleCID = function(g) {
      g === void 0 && (g = k("_ga"));
      var w = g.match(/(\d+\.\d+)$/);
      return w ? w[1] : void 0;
    }, a.buildGcHttpUrl = function(g) {
      return g === void 0 && (g = ""), "mailrugames://urlhttps/games.mail.ru" + g;
    }, a.absoluteUrl = x, a.safeUrl = function(g) {
      return g && ((g = x(g)).search(a.domain_rgx) === 0 || g.startsWith(window.location.origin)) ? g : "";
    }, a.safeRedirectUrl = function(g) {
      if (!/^[\w\-]+:\/\/([\w\-]+\.)*[\w\-]+(:\d+)?(\/.*)?$/.test(g)) throw new Error("unsafe redirect url: ".concat(g));
      return g;
    }, a.triggerPixel = function(g) {
      var w, C;
      if (g && g !== "") {
        var b = g.indexOf("?") > -1 ? "&rnd=" : "?rnd=", M = window.gem_cookiebot_loaded;
        (!M || M && !((C = (w = window.Cookiebot) === null || w === void 0 ? void 0 : w.consent) === null || C === void 0) && C.statistics) && (new Image().src = g + b + Math.random());
      }
    }, a.getCookie = k, a.setCookie = function(g, w, C) {
      C === void 0 && (C = {});
      var b = (C = C || {}).expires;
      if (typeof b == "number" && b) {
        var M = /* @__PURE__ */ new Date();
        M.setTime(M.getTime() + 1e3 * b), b = C.expires = M;
      }
      b && b.toUTCString && (C.expires = b.toUTCString());
      var R = g + "=" + (w = encodeURIComponent(w));
      for (var O in C) if (C[O]) {
        var N = C[O];
        R += "; " + O, N !== !0 && (R += "=" + N);
      }
      document.cookie = R;
    }, a.htmlEscape = function(g) {
      return g === void 0 && (g = ""), g ? g.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\//g, "&#x2F;") : "";
    }, a.htmlUnescape = function(g) {
      return g === void 0 && (g = ""), g ? g.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&apos;/g, "'").replace(/&#x27;/g, "'").replace(/&lt;/g, "<").replace(/&#60;/g, "<").replace(/&gt;/g, ">").replace(/&#62;/g, ">").replace(/&#x2F;/g, "/").replace(/&amp;/g, "&") : "";
    }, a.query_string = I, a.qsStringify = T, a.declineNum = function(g, w, C, b) {
      var M;
      return g % 100 == 11 || g % 100 == 12 || g % 100 == 13 || g % 100 == 14 ? M = b : g % 10 == 1 ? M = w : g % 10 >= 2 && g % 10 <= 4 ? M = C : (g % 10 == 0 || g % 10 >= 5 && g % 10 <= 9) && (M = b), M;
    }, a.resizePic = function(g, w) {
      var C;
      w === void 0 && (w = {});
      var b = w.method || "crop", M = w.quality, R = M === void 0 ? 85 : M, O = w.format, N = w.blur, H = w.feather, Z = w.color, z = T(i(i(i(i(i({}, !isNaN(R) && R < 100 && { quality: R }), O && { format: O }), N && { feather_blur: N }), H && { feather: H }), Z && { feather_color: Z }));
      if (C = w && (w.width || w.height) ? w.width + "x" + w.height : "big2", g) return (g += z.length > 0 ? (g.includes("?") ? "&" : "?") + z : "").indexOf("/hotbox/") > -1 ? g = g.replace("/hotbox/", "/pre_".concat(C, "_").concat(b, "/hotbox/")) : g.indexOf("/pic/") > -1 && (g = g.replace("/pic/", "/pre_".concat(C, "_").concat(b, "/pic/"))), g;
    }, a.isValidDate = L, a.humanFileSize = function(g, w, C) {
      w === void 0 && (w = {});
      var b = 0;
      if (w) {
        for (var M = C ? 1e3 : 1024; g > 1e3; ) g /= M, b++;
        return g.toFixed(1) + " " + w[b];
      }
    }, a.formatNumber = S;
    var E, j = { USD: { separateThousandsWith: " ", prefix: "$" }, EUR: { separateThousandsWith: " ", prefix: "€" }, RUB: { separateThousandsWith: " ", decimalSignType: "comma", postfix: " ₽" } };
    a.formatPrice = function(g, w) {
      return j[w] ? S(g, j[w]) : null;
    }, a.getRandomInt = function(g, w) {
      return g = Math.ceil(g), w = Math.floor(w), Math.floor(Math.random() * (w - g + 1)) + g;
    }, a.createThrottlingDecorator = function(g, w) {
      w === void 0 && (w = 1e3);
      var C, b, M = !1;
      return function R() {
        for (var O = [], N = 0; N < arguments.length; N++) O[N] = arguments[N];
        if (M) return C = O, void (b = this);
        g.apply(void 0, O), M = !0, setTimeout(function() {
          M = !1, C && (R.apply(b, C), C = b = null);
        }, w);
      };
    }, a.createDebounceDecorator = function(g, w) {
      w === void 0 && (w = 1e3);
      var C = !1;
      return function() {
        for (var b = [], M = 0; M < arguments.length; M++) b[M] = arguments[M];
        C || (g.apply(void 0, b), C = !0, setTimeout(function() {
          return C = !1;
        }, w));
      };
    }, a.createCallLastDecorator = function(g, w) {
      w === void 0 && (w = 1e3);
      var C = null;
      return function() {
        for (var b = [], M = 0; M < arguments.length; M++) b[M] = arguments[M];
        C && clearTimeout(C), C = setTimeout(function() {
          return g.apply(void 0, b);
        }, w);
      };
    }, a.copyTextToClipboardIE11 = function(g, w) {
      var C = document.createElement("textarea");
      C.value = g, C.style.top = "0", C.style.left = "0", C.style.opacity = "0", C.style.position = "fixed", document.body.appendChild(C), C.select(), C.setSelectionRange(0, 99999), document.execCommand("copy"), w && w(), document.body.removeChild(C);
    }, a.copyTextToClipboard = function(g, w) {
      window.gc_clipboard_copy ? (window.gc_clipboard_copy(g), w && w()) : navigator.clipboard ? navigator.clipboard.writeText(g).then(w).catch(function() {
        return (0, a.copyTextToClipboardIE11)(g, w);
      }) : (0, a.copyTextToClipboardIE11)(g, w);
    }, a.CIS_REGIONS = ["398", "219", "215", "201", "29", "28", "34", "191", "188", "17", "33", "16", "196", "467"], a.isCis = function() {
      var g;
      return a.CIS_REGIONS.includes(((g = window.__GEMS) === null || g === void 0 ? void 0 : g.country_id) || window.country_id);
    }, a.allowCloud = function(g) {
      var w, C;
      g === void 0 && (g = {});
      var b = g.login && (0, a.isCorpUser)(g.login), M = a.isGem ? (w = window.__GEMS) === null || w === void 0 ? void 0 : w.country_id : (C = window.gmrGeo) === null || C === void 0 ? void 0 : C.country_id, R = a.CIS_REGIONS.includes(M);
      return b || R;
    }, a.decodeEntities = (E = document.createElement("div"), function(g) {
      g === void 0 && (g = "");
      var w = g;
      return w = (w = (w = w.replace(/<br\s*[\/]?>/gi, `
`)).replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, "")).replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, ""), E.innerHTML = w, w = E.textContent, E.textContent = "", w;
    }), a.getUserProfileURL = function(g) {
      return d("".concat(a.inGamecenter && !a.isGem ? "/gamecenter" : "", "/profile/").concat(g));
    }, a.openURL = function(g, w) {
      a.inGamecenter ? v(g, w) : window.open(w, "_blank", "noopener,noreferrer");
    }, a.openUserProfileURL = function(g, w) {
      var C = (0, a.getUserProfileURL)(w);
      (0, a.openURL)(g, C);
    }, a.createGCGameURL = function(g) {
      return "mailrugames://show/".concat(g);
    }, a.openGameProfileURL = function(g, w) {
      a.inGamecenter ? v(g, (0, a.createGCGameURL)(w.gc_id)) : (0, a.openURL)(g, w.url);
    }, a.setLinkTag = function(g) {
      return new Promise(function(w, C) {
        var b = document.createElement("link");
        b.type = "text/css", b.rel = "stylesheet", b.href = g, b.onload = function() {
          return w();
        }, b.onerror = function() {
          return C();
        }, document.head.appendChild(b);
      });
    }, a.setScriptTag = function(g) {
      var w = g.src, C = g.inlineScript, b = g.onload, M = g.data, R = g.async, O = g.prepend, N = g.id, H = g.setToHead, Z = document.createElement("script"), z = H ? document.head : document.body;
      if (Z.type = "text/javascript", Z.onload = b, !N || (Z.id = N, !document.getElementById(N))) {
        if (w && (Z.src = w), R && (Z.async = !0), M && Object.keys(M).map(function(D) {
          Z.setAttribute(["data-".concat(D)], M[D]);
        }), C) {
          var K = document.createTextNode(C);
          Z.appendChild(K);
        }
        O ? z.prepend(Z) : z.appendChild(Z);
      }
    }, a.calculateAge = function(g) {
      g === void 0 && (g = "");
      var w = new Date(g);
      if (!L(w)) return console.warn("Age calculation error: invalid date"), null;
      var C = /* @__PURE__ */ new Date(), b = C.getMonth() - w.getMonth(), M = C.getFullYear() - w.getFullYear();
      return (b < 0 || b === 0 && C.getDate() < w.getDate()) && M--, M;
    }, a.isOpenForWorld = function(g) {
      var w = ["188", "201"].includes(g);
      return !(!g || w);
    }, a.getShortLocale = function(g) {
      var w = a.isMyGames ? "en" : "ru", C = g.replace("-", "_"), b = C.split("_")[0];
      return ["zh_CN", "zh_TW", "pt_BR"].includes(C) && (b = C.split("_")[1].toLowerCase()), b != null ? b : w;
    }, a.getUserCMPConsent = function() {
      var g, w, C, b;
      if (!window.__cmp) return !0;
      var M = (g = window.__cmp("consentStatus")) === null || g === void 0 ? void 0 : g.consentExists, R = (w = window.__cmp("consentStatus")) === null || w === void 0 ? void 0 : w.userChoiceExists, O = (b = (C = window.__cmp("getCMPData")) === null || C === void 0 ? void 0 : C.purposeConsents) === null || b === void 0 ? void 0 : b.c52;
      return !!(M && R && O);
    };
  }, 287: function(r, a, i) {
    var l = this && this.__importDefault || function(m) {
      return m && m.__esModule ? m : { default: m };
    };
    Object.defineProperty(a, "__esModule", { value: !0 }), a.default = a.WSD = void 0;
    var s = l(i(7)), c = i(747), p = i(63), h = i(318), u = { id: null, properShardNumber: NaN, CODE_CID_DUP: 4001, CODE_RESHARD: 4002, CODE_NO_AUTH: 4003, socket: null, reconnectHandle: null, errorTimeout: 2e3, minErrorTimeout: 2e3, maxErrorTimeout: 3e5, minPageReloadInterval: 36e5, reopens: 0, opened: !1, events: new s.default(), _log: function() {
      for (var m, d = [], v = 0; v < arguments.length; v++) d[v] = arguments[v];
      window.console && (m = window.console).log.apply(m, d);
    }, _debug: function() {
      for (var m, d = [], v = 0; v < arguments.length; v++) d[v] = arguments[v];
      window.console && (m = window.console).debug.apply(m, d);
    }, _error: function() {
      for (var m, d = [], v = 0; v < arguments.length; v++) d[v] = arguments[v];
      window.console && (m = window.console).error.apply(m, d);
    }, on: function(m, d) {
      u.events.on(m, d);
    }, off: function(m, d) {
      d ? u.events.removeListener(m, d) : u.events.removeAllListeners(m);
    }, getShard: function() {
      var m;
      return m = isNaN(u.properShardNumber) ? c.HashUtils.getShard(String(u.id), u.shards.length) : u.properShardNumber, u.shards[m];
    }, getCid: function() {
      var m = window.localStorage.getItem("ws_cid");
      return m || (m = String(Math.round(4294967295 * Math.random())), window.localStorage.setItem("ws_cid", m)), m;
    }, getUrl: function() {
      var m = u.getShard(), d = u.getCid();
      return ((window.location.protocol || "").match("^https") ? "wss" : "ws") + "://" + m + "?cid=" + encodeURIComponent(d);
    }, onWebsocketOpen: function(m) {
      u._debug("[ws] opened", m), u.emitOpen(), h.Broadcast.post("ws", { type: "open" });
    }, onWebsocketClose: function(m) {
      if (u._debug("[ws] closed", "code:", m.code, "reason:", m.reason, "wasClean:", m.wasClean), u.emitClose(), h.Broadcast.post("ws", { type: "close" }), u.socket = null, m.wasClean) switch (m.code) {
        case u.CODE_CID_DUP:
          window.localStorage.removeItem("ws_cid"), u.reconnect();
          break;
        case u.CODE_RESHARD:
          var d = parseInt(m.reason);
          if (u._debug("[ws] reshard", "new:", d, "prev:", u.properShardNumber), !isNaN(d)) if (isNaN(u.properShardNumber)) u.properShardNumber = d, u.reconnect();
          else {
            var v = parseInt(window.localStorage.getItem("ws_last_reload_ts")), x = (/* @__PURE__ */ new Date()).getTime();
            (!v || x - v > u.minPageReloadInterval) && u.pageReload();
          }
          break;
        case u.CODE_NO_AUTH:
          window.gc_renew_cookie && window.gc_renew_cookie(), document.body.className += " no_auth", u.reconnect(!0);
          break;
        default:
          return void (u.errorTimeout = u.minErrorTimeout);
      }
      else u.reconnect(!0);
    }, onWebsocketMessage: function(m) {
      var d = m.data;
      u.emitMessage(d), h.Broadcast.post("ws", { type: "message", message: d });
    }, onCrossTabMessage: function(m) {
      switch (m.type) {
        case "message":
          u.emitMessage(m.message);
          break;
        case "open":
          u.emitOpen();
          break;
        case "close":
          u.emitClose();
          break;
        default:
          u._error("unknown broadcast message", m);
      }
    }, emitMessage: function(m) {
      m = JSON.parse(m), u._debug("[ws] message", m), u.events.emit("message", m);
    }, emitOpen: function() {
      u.events.emit("open", u.reopens), u.reopens += 1, u.opened = !0;
    }, emitClose: function() {
      u.events.emit("close"), u.opened = !1;
    }, isOpened: function() {
      return u.opened;
    }, pageReload: function() {
      var m = (/* @__PURE__ */ new Date()).getTime();
      window.localStorage.setItem("ws_last_reload_ts", String(m)), window.location.reload();
    }, connect: function() {
      clearTimeout(u.reconnectHandle), u.socket && (u.socket.close(), u.socket = null);
      try {
        u.socket = new WebSocket(u.getUrl()), u.socket.onopen = function(m) {
          u.onWebsocketOpen(m);
        }, u.socket.onclose = function(m) {
          u.onWebsocketClose(m);
        }, u.socket.onerror = function(m) {
          u._error("[ws] error", m);
        }, u.socket.onmessage = function(m) {
          u.onWebsocketMessage(m);
        };
      } catch (m) {
        u._error("[ws] error", m);
      }
    }, reconnect: function(m) {
      if (clearTimeout(u.reconnectHandle), m) {
        u.errorTimeout === u.maxErrorTimeout && u.pageReload(), u.errorTimeout = Math.min(u.maxErrorTimeout, 2 * u.errorTimeout);
        var d = Math.round(u.errorTimeout * (0.75 + Math.random() / 2));
        u.reconnectHandle = setTimeout(u.connect, d);
      } else u.reconnectHandle = setTimeout(u.connect);
    }, disconnect: function() {
      clearTimeout(u.reconnectHandle), u.socket && (u.socket.onopen = null, u.socket.onclose = null, u.socket.onerror = null, u.socket.onmessage = null, u.socket.close(), u.socket = null);
    }, becomeMaster: function() {
      u._debug("[ws] is master"), h.Broadcast.off("ws", u.onCrossTabMessage), u.connect();
    }, becomeSlave: function() {
      u._debug("[ws] is slave"), u.disconnect(), h.Broadcast.on("ws", u.onCrossTabMessage);
    }, becomeDeadman: function() {
      u._debug("[ws] is deadman"), u.disconnect(), h.Broadcast.off("ws", u.onCrossTabMessage);
    }, init: function(m, d) {
      window.WebSocket && m ? (u.id = m, u.shards = d, p.MasterSlave.on("master", u.becomeMaster), p.MasterSlave.on("slave", u.becomeSlave), p.MasterSlave.on("deadman", u.becomeDeadman), p.MasterSlave.isMaster() ? u.becomeMaster() : u.becomeSlave()) : u._error("[ws] is not inited, id=", m);
    } };
    a.WSD = u, a.default = u;
  } }, t = {}, n = function r(a) {
    var i = t[a];
    if (i !== void 0) return i.exports;
    var l = t[a] = { exports: {} };
    return e[a].call(l.exports, l, l.exports, r), l.exports;
  }(156);
  s4.exports = n;
})();
var l4 = s4.exports;
const $o = {
  /**
   * Если ширина меньше 360px, то возвращает TRUE
   */
  mobileSmMax: "360px",
  /**
   * Если ширина меньше 480px, то возвращает TRUE
   */
  mobileMdMax: "480px",
  /**
   * Если ширина меньше 768px, то возвращает TRUE
   */
  tabletSmMax: "768px",
  /**
   * Если ширина меньше 1179px, то возвращает TRUE
   */
  tabletMdMax: "1179px",
  /**
   * Если ширина меньше 1280px, то возвращает TRUE
   */
  tabletXMdMax: "1280px",
  /**
   * Если ширина меньше 1460px, то возвращает TRUE
   */
  tabletLgMax: "1460px",
  /**
   * Если ширина меньше 1600px, то возвращает TRUE
   */
  desktopSmMax: "1600px",
  /**
   * Если ширина меньше 1727px, то возвращает TRUE
   */
  desktopMdMax: "1727px",
  /**
   * Если ширина меньше 1920px, то возвращает TRUE
   */
  desktopLgMax: "1920px"
}, Yo = {
  /**
   * Если ширина больше 361px, то возвращает TRUE
   */
  mobileSmMin: "361px",
  /**
   * Если ширина больше 481px, то возвращает TRUE
   */
  mobileMdMin: "481px",
  /**
   * Если ширина больше 769px, то возвращает TRUE
   */
  tabletSmMin: "769px",
  /**
   * Если ширина больше 1180px, то возвращает TRUE
   */
  tabletMdMin: "1180px",
  /**
   * Если ширина больше 1281px, то возвращает TRUE
   */
  tabletXMdMin: "1281px",
  /**
   * Если ширина больше 1461px, то возвращает TRUE
   */
  tabletLgMin: "1461px",
  /**
   * Если ширина больше 1601px, то возвращает TRUE
   */
  desktopSmMin: "1601px",
  /**
   * Если ширина больше 1728px, то возвращает TRUE
   */
  desktopMdMin: "1728px",
  /**
   * Если ширина больше 1921px, то возвращает TRUE
   */
  desktopLgMin: "1921px"
}, $h = () => {
  const e = {}, t = Object.keys($o), n = Object.keys(Yo);
  return t.forEach((r) => {
    e[r] = window.matchMedia(`(max-width: ${$o[r]})`);
  }), n.forEach((r) => {
    e[r] = window.matchMedia(`(min-width: ${Yo[r]})`);
  }), e;
};
class Yh {
  constructor() {
    t0(this, "breakpoints", {}), t0(this, "matchMedia", $h()), t0(this, "addHandler", (t, n) => {
      this.breakpoints[t] || (this.breakpoints[t] = []), this.breakpoints[t].push(n);
    }), t0(this, "getValueByKey", (t) => this.matchMedia[t].matches), this.setListeners();
  }
  handleChange(t, n) {
    this.breakpoints[n] && this.breakpoints[n].forEach((r) => r(t.matches));
  }
  setListeners() {
    Object.keys(this.matchMedia).forEach((t) => {
      this.matchMedia[t].addEventListener("change", (n) => this.handleChange(n, t));
    });
  }
}
const Ko = new Yh();
function Ue(e = []) {
  e.length === 0 && !l4.isProduction && console.log("%c Добавь ключи breakpoint в useBreakpoints", "background: #222; color: red");
  const [t, n] = r1(() => Array.from(new Set(e.flat())).reduce(
    (r, a) => Object.assign(
      r,
      { [a]: Ko.getValueByKey(a) }
    ),
    {}
  ));
  return u1(() => {
    e.forEach((r) => Ko.addHandler(r, (a) => n((i) => ({
      ...i,
      [r]: a
    }))));
  }, []), t;
}
const Kh = "Button__root--e2ace", Qh = "Button__disabled--e91a8", Xh = "Button__stretched--cbd28", Jh = "Button__label--59f80", ep = "Button__counter--cfc43", tp = "Button__xs--b28da", np = "Button__divider--bdd5b", rp = "Button__sm--e323b", ap = "Button__md--45f10", ip = "Button__lg--15d54", op = "Button__xl--c40ce", Nt = {
  root: Kh,
  disabled: Qh,
  stretched: Xh,
  label: Jh,
  counter: ep,
  xs: tp,
  "icon-button": "Button__icon-button--376c0",
  divider: np,
  sm: rp,
  md: ap,
  lg: ip,
  xl: op,
  "radius-none": "Button__radius-none--e491b",
  "radius-round": "Button__radius-round--5e252",
  "radius-round-left": "Button__radius-round-left--042b5",
  "radius-round-right": "Button__radius-round-right--5fa95",
  "appearance-accent": "Button__appearance-accent--4b639",
  "mode-primary": "Button__mode-primary--ade16",
  "mode-outline": "Button__mode-outline--506a0",
  "mode-link": "Button__mode-link--662c7",
  "appearance-neutral": "Button__appearance-neutral--0e549",
  "appearance-overlay": "Button__appearance-overlay--32571",
  "appearance-dark": "Button__appearance-dark--6d15d",
  "appearance-alpha": "Button__appearance-alpha--acb5b"
}, sp = "ButtonGroup__xs--7ff9e", lp = "ButtonGroup__sm--3c6b8", cp = "ButtonGroup__md--115ec", up = "ButtonGroup__lg--fbe11", dp = "ButtonGroup__xl--22ab0", ma = {
  "button-group": "ButtonGroup__button-group--c7645",
  "type-separated": "ButtonGroup__type-separated--60818",
  xs: sp,
  sm: lp,
  md: cp,
  lg: up,
  xl: dp,
  "type-segmented": "ButtonGroup__type-segmented--2e229"
}, fp = ({
  children: e,
  className: t,
  type: n = "separated",
  size: r = "md",
  ...a
}) => {
  const i = No.count(e);
  function l(s) {
    return n !== "segmented" ? "round" : s === 0 ? "round-left" : s === i - 1 ? "round-right" : "none";
  }
  return /* @__PURE__ */ i1.jsx(
    "div",
    {
      className: Q1(
        ma["button-group"],
        ma[`type-${n}`],
        ma[r]
      ),
      children: No.map(e, (s, c) => W6(s, {
        size: r,
        radius: l(c),
        ...a
      }))
    }
  );
}, hp = ({ className: e }) => /* @__PURE__ */ i1.jsx(
  "span",
  {
    className: Q1(Nt.divider, e)
  }
), q1 = ({
  className: e,
  labelClassName: t,
  children: n,
  component: r = "button",
  size: a = "md",
  appearance: i = "accent",
  mode: l = "primary",
  radius: s = "default",
  isDisabled: c = !1,
  isStretched: p = !1,
  leftIcon: h,
  rightIcon: u,
  counter: m,
  ...d
}) => /* @__PURE__ */ i1.jsxs(
  r,
  {
    ...d,
    className: Q1(
      e,
      Nt.root,
      Nt[a],
      Nt[`appearance-${i}`],
      Nt[`mode-${l}`],
      Nt[`radius-${s}`],
      {
        [Nt.disabled]: c,
        [Nt.stretched]: p,
        [Nt["icon-button"]]: !n
      }
    ),
    children: [
      h,
      n != null && /* @__PURE__ */ i1.jsx("span", { className: Q1(Nt.label, t), children: n }),
      m != null && /* @__PURE__ */ i1.jsx("span", { className: Nt.counter, children: m }),
      u
    ]
  }
);
q1.Divider = hp;
q1.Group = fp;
const pp = "Counter__root--c94ac", mp = "Counter__size_large--21e39", Cp = "Counter__size_medium--573e1", gp = "Counter__size_small--e630e", vp = "Counter__mode_accent--8539c", wp = "Counter__mode_contrast--357f2", yp = "Counter__mode_secondary--61493", bp = "Counter__mode_negative--b7185", _p = "Counter__mode_accentInverse--5251c", xp = "Counter__mode_contrastInverse--2b76a", Lp = "Counter__mode_num--4bf82", Ca = {
  root: pp,
  size_large: mp,
  size_medium: Cp,
  size_small: gp,
  mode_accent: vp,
  mode_contrast: wp,
  mode_secondary: yp,
  mode_negative: bp,
  mode_accentInverse: _p,
  mode_contrastInverse: xp,
  mode_num: Lp
}, Ep = (e) => {
  const t = typeof e == "string" ? parseInt(e, 10) : e;
  return Number.isNaN(t) ? `${e}` : t > 99 ? "99+" : t < 0 ? "0" : `${t}`;
}, q0 = ({
  className: e,
  children: t,
  mode: n = "accent",
  size: r = "md"
}) => /* @__PURE__ */ i1.jsx(
  "div",
  {
    className: Q1(Ca.root, {
      [Ca[`mode_${n}`]]: n,
      [Ca[`size_${r}`]]: r
    }, e),
    children: Ep(t)
  }
), Mp = "Dialog__wrapper--f852a", kp = "Dialog__root--fa513", Sp = "Dialog__lg--3e835", Ap = "Dialog__md--5cfe1", Tp = "Dialog__sm--3e548", Ip = "Dialog__dialogType--38abe", Rp = "Dialog__close--efd11", Np = "Dialog__header--587d3", Hp = "Dialog__title--7a02a", Op = "Dialog__left--81ced", jp = "Dialog__center--692c8", Pp = "Dialog__description--ddb2a", Dp = "Dialog__bottom--25f1c", Vp = "Dialog__btn--17202", Bp = "Dialog__content--cc86f", at = {
  wrapper: Mp,
  "backdrop-fade-in": "Dialog__backdrop-fade-in--d935b",
  root: kp,
  "fade-in": "Dialog__fade-in--8b2e1",
  lg: Sp,
  md: Ap,
  sm: Tp,
  dialogType: Ip,
  "slide-up": "Dialog__slide-up--131c1",
  close: Rp,
  header: Np,
  title: Hp,
  left: Op,
  center: jp,
  description: Pp,
  bottom: Dp,
  btn: Vp,
  content: Bp
}, Fr = ({
  open: e,
  className: t = "",
  children: n,
  size: r = "md",
  type: a = "popup",
  title: i,
  titlePos: l = "left",
  onClose: s,
  domNode: c,
  modalOptions: p = {},
  zIndex: h = 9999,
  notCloseOnBackdropClick: u = !1,
  hideCloseIcon: m = !1
}) => {
  const {
    successText: d,
    noSuccessText: v,
    description: x,
    onSuccess: k,
    isSuccessAccent: I
  } = p || {}, T = typeof c == "string" ? document.querySelector(c) : c, L = a === "dialog", S = V1(null), [E, j] = r1(!1), g = (R) => {
    R.target.classList.contains(at.wrapper) || j(!0);
  }, w = () => {
    setTimeout(() => j(!1), 0);
  }, C = W1((R) => {
    if (u)
      return !1;
    if (R.target.classList.contains(at.wrapper) && !E)
      return s && s();
  }, [E]), b = () => {
    k && k();
  };
  if (u1(() => {
    const R = (O) => {
      O.key === "Escape" && !u && s();
    };
    return e && (T && (T.style.overflow = "hidden"), document.body.style.overflow = "hidden", document.addEventListener("keydown", R)), () => {
      e && (T && (T.style.overflow = "initial"), document.body.style.overflow = "initial", document.addEventListener("keydown", R));
    };
  }, [e]), !e)
    return null;
  const M = () => L ? /* @__PURE__ */ i1.jsxs(i1.Fragment, { children: [
    /* @__PURE__ */ i1.jsx("p", { className: at.description, children: x }),
    /* @__PURE__ */ i1.jsxs("div", { className: at.bottom, children: [
      /* @__PURE__ */ i1.jsx(
        q1,
        {
          onClick: I ? s : b,
          mode: "link",
          className: at.btn,
          children: I ? v : d
        }
      ),
      /* @__PURE__ */ i1.jsx(
        q1,
        {
          onClick: I ? b : s,
          className: at.btn,
          children: I ? d : v
        }
      )
    ] })
  ] }) : n;
  return t4.createPortal(
    // eslint-disable-next-line
    /* @__PURE__ */ i1.jsx(
      "div",
      {
        className: at.wrapper,
        style: { zIndex: h },
        onClick: C,
        onMouseDown: g,
        onMouseUp: w,
        children: /* @__PURE__ */ i1.jsxs(
          "div",
          {
            className: Q1(at.root, t, {
              [at[r]]: r,
              [at[`${a}Type`]]: a
            }),
            ref: S,
            children: [
              !m && /* @__PURE__ */ i1.jsx(
                "button",
                {
                  className: at.close,
                  onClick: s,
                  tabIndex: -1,
                  children: /* @__PURE__ */ i1.jsx(b1, { name: "close" })
                }
              ),
              !!i && /* @__PURE__ */ i1.jsx("div", { className: at.header, children: /* @__PURE__ */ i1.jsx(
                "h3",
                {
                  className: Q1(at.title, {
                    [at[l]]: l
                  }),
                  children: i
                }
              ) }),
              /* @__PURE__ */ i1.jsx("div", { className: at.content, children: M() })
            ]
          }
        )
      }
    ),
    T || document.body
  );
}, Fp = "Dotdotdoter__clamp--66277", Zp = "Dotdotdoter__clamp1--28524", Gp = "Dotdotdoter__clamp2--08823", Wp = "Dotdotdoter__clamp3--b67b6", Up = "Dotdotdoter__clamp4--107d8", zp = "Dotdotdoter__clamp5--fb150", qp = "Dotdotdoter__clamp6--c6d63", $p = "Dotdotdoter__clamp7--95993", Yp = "Dotdotdoter__clamp8--8ea41", Kp = "Dotdotdoter__clamp9--456e4", Qp = "Dotdotdoter__clamp10--0fe40", Qo = {
  clamp: Fp,
  clamp1: Zp,
  clamp2: Gp,
  clamp3: Wp,
  clamp4: Up,
  clamp5: zp,
  clamp6: qp,
  clamp7: $p,
  clamp8: Yp,
  clamp9: Kp,
  clamp10: Qp
};
function pn({
  clamp: e = 1,
  className: t = void 0,
  children: n,
  tagName: r = "span",
  dotdotdoterRef: a,
  ...i
}) {
  const l = r;
  return /* @__PURE__ */ i1.jsx(
    l,
    {
      className: Q1(
        t,
        Qo.clamp,
        Qo[`clamp${e}`]
      ),
      ...a && { ref: a },
      ...i,
      children: n
    }
  );
}
const $0 = (e) => {
  const { id: t, caption: n, captionId: r } = e, a = r || `caption-${t}`, i = {
    id: t,
    ...n && {
      "aria-describedby": a
    }
  };
  return {
    captionLabelId: a,
    fieldProps: i
  };
}, Xp = "Input__inputWrapper--a4018", Jp = "Input__selectWrapper--99050", em = "Input__autoWidth--65cde", tm = "Input__input--07830", nm = "Input__textarea--a70ab", rm = "Input__hasBeforeIcon--adedf", am = "Input__errorWrapper--ff3e8", im = "Input__validWrapper--841f6", om = "Input__disabled--42c80", sm = "Input__auxContainer--7a215", lm = "Input__suffix--7876c", cm = "Input__value--f1deb", um = "Input__iconBefore--0bc09", dm = "Input__accent--198de", fm = "Input__rightBlock--4eed7", hm = "Input__afterText--f6f95", pm = "Input__iconAfter--ce7e5", mm = "Input__loader--f5814", Cm = "Input__spin--b8f24", gm = "Input__iconClear--820bd", vm = "Input__hasAfterIcon--a1aab", wm = "Input__hasAfterText--29d70", ym = "Input__formField--bb5c2", bm = "Input__formFieldInput--d9d70", _m = "Input__label--f0162", xm = "Input__labelRequired--ae90f", Lm = "Input__subhead--1f959", Em = "Input__caption--c3ccc", Mm = "Input__error--c2b2d", km = "Input__valid--c58b9", Sm = "Input__selectOpened--9e6ff", Am = "Input__removeBtn--1121c", Tm = "Input__selectInput--188b6", Im = "Input__selectDropdown--ad29f", Rm = "Input__left--805a4", Nm = "Input__right--965dd", Hm = "Input__fullWidth--5a033", Om = "Input__selectOptions--eb05f", jm = "Input__selectOption--8b711", Pm = "Input__selected--dc609", Dm = "Input__focused--d91ee", Vm = "Input__optionIcon--ea3bd", Bm = "Input__optionText--f4139", Fm = "Input__selectedIcon--295df", Zm = "Input__autoWidthTemplate--eb49f", Gm = "Input__disabledInfo--91008", F1 = {
  inputWrapper: Xp,
  selectWrapper: Jp,
  autoWidth: em,
  input: tm,
  textarea: nm,
  hasBeforeIcon: rm,
  errorWrapper: am,
  validWrapper: im,
  disabled: om,
  auxContainer: sm,
  suffix: lm,
  value: cm,
  iconBefore: um,
  accent: dm,
  rightBlock: fm,
  afterText: hm,
  iconAfter: pm,
  loader: mm,
  spin: Cm,
  iconClear: gm,
  hasAfterIcon: vm,
  hasAfterText: wm,
  formField: ym,
  formFieldInput: bm,
  label: _m,
  labelRequired: xm,
  subhead: Lm,
  caption: Em,
  error: Mm,
  valid: km,
  selectOpened: Sm,
  removeBtn: Am,
  selectInput: Tm,
  selectDropdown: Im,
  left: Rm,
  right: Nm,
  fullWidth: Hm,
  selectOptions: Om,
  selectOption: jm,
  selected: Pm,
  focused: Dm,
  optionIcon: Vm,
  optionText: Bm,
  selectedIcon: Fm,
  autoWidthTemplate: Zm,
  disabledInfo: Gm
}, Jn = Math.min, fn = Math.max, A0 = Math.round, r0 = Math.floor, V2 = (e) => ({
  x: e,
  y: e
}), Wm = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Um = {
  start: "end",
  end: "start"
};
function ai(e, t, n) {
  return fn(e, Jn(t, n));
}
function Zr(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function mn(e) {
  return e.split("-")[0];
}
function Gr(e) {
  return e.split("-")[1];
}
function c4(e) {
  return e === "x" ? "y" : "x";
}
function Xi(e) {
  return e === "y" ? "height" : "width";
}
function er(e) {
  return ["top", "bottom"].includes(mn(e)) ? "y" : "x";
}
function Ji(e) {
  return c4(er(e));
}
function zm(e, t, n) {
  n === void 0 && (n = !1);
  const r = Gr(e), a = Ji(e), i = Xi(a);
  let l = a === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (l = T0(l)), [l, T0(l)];
}
function qm(e) {
  const t = T0(e);
  return [ii(e), t, ii(t)];
}
function ii(e) {
  return e.replace(/start|end/g, (t) => Um[t]);
}
function $m(e, t, n) {
  const r = ["left", "right"], a = ["right", "left"], i = ["top", "bottom"], l = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? a : r : t ? r : a;
    case "left":
    case "right":
      return t ? i : l;
    default:
      return [];
  }
}
function Ym(e, t, n, r) {
  const a = Gr(e);
  let i = $m(mn(e), n === "start", r);
  return a && (i = i.map((l) => l + "-" + a), t && (i = i.concat(i.map(ii)))), i;
}
function T0(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Wm[t]);
}
function Km(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function u4(e) {
  return typeof e != "number" ? Km(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function I0(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: a
  } = e;
  return {
    width: r,
    height: a,
    top: n,
    left: t,
    right: t + r,
    bottom: n + a,
    x: t,
    y: n
  };
}
function Xo(e, t, n) {
  let {
    reference: r,
    floating: a
  } = e;
  const i = er(t), l = Ji(t), s = Xi(l), c = mn(t), p = i === "y", h = r.x + r.width / 2 - a.width / 2, u = r.y + r.height / 2 - a.height / 2, m = r[s] / 2 - a[s] / 2;
  let d;
  switch (c) {
    case "top":
      d = {
        x: h,
        y: r.y - a.height
      };
      break;
    case "bottom":
      d = {
        x: h,
        y: r.y + r.height
      };
      break;
    case "right":
      d = {
        x: r.x + r.width,
        y: u
      };
      break;
    case "left":
      d = {
        x: r.x - a.width,
        y: u
      };
      break;
    default:
      d = {
        x: r.x,
        y: r.y
      };
  }
  switch (Gr(t)) {
    case "start":
      d[l] -= m * (n && p ? -1 : 1);
      break;
    case "end":
      d[l] += m * (n && p ? -1 : 1);
      break;
  }
  return d;
}
const Qm = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: a = "absolute",
    middleware: i = [],
    platform: l
  } = n, s = i.filter(Boolean), c = await (l.isRTL == null ? void 0 : l.isRTL(t));
  let p = await l.getElementRects({
    reference: e,
    floating: t,
    strategy: a
  }), {
    x: h,
    y: u
  } = Xo(p, r, c), m = r, d = {}, v = 0;
  for (let x = 0; x < s.length; x++) {
    const {
      name: k,
      fn: I
    } = s[x], {
      x: T,
      y: L,
      data: S,
      reset: E
    } = await I({
      x: h,
      y: u,
      initialPlacement: r,
      placement: m,
      strategy: a,
      middlewareData: d,
      rects: p,
      platform: l,
      elements: {
        reference: e,
        floating: t
      }
    });
    h = T != null ? T : h, u = L != null ? L : u, d = {
      ...d,
      [k]: {
        ...d[k],
        ...S
      }
    }, E && v <= 50 && (v++, typeof E == "object" && (E.placement && (m = E.placement), E.rects && (p = E.rects === !0 ? await l.getElementRects({
      reference: e,
      floating: t,
      strategy: a
    }) : E.rects), {
      x: h,
      y: u
    } = Xo(p, m, c)), x = -1);
  }
  return {
    x: h,
    y: u,
    placement: m,
    strategy: a,
    middlewareData: d
  };
};
async function d4(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: a,
    platform: i,
    rects: l,
    elements: s,
    strategy: c
  } = e, {
    boundary: p = "clippingAncestors",
    rootBoundary: h = "viewport",
    elementContext: u = "floating",
    altBoundary: m = !1,
    padding: d = 0
  } = Zr(t, e), v = u4(d), x = s[m ? u === "floating" ? "reference" : "floating" : u], k = I0(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(x))) == null || n ? x : x.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: p,
    rootBoundary: h,
    strategy: c
  })), I = u === "floating" ? {
    x: r,
    y: a,
    width: l.floating.width,
    height: l.floating.height
  } : l.reference, T = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), L = await (i.isElement == null ? void 0 : i.isElement(T)) ? await (i.getScale == null ? void 0 : i.getScale(T)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = I0(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: I,
    offsetParent: T,
    strategy: c
  }) : I);
  return {
    top: (k.top - S.top + v.top) / L.y,
    bottom: (S.bottom - k.bottom + v.bottom) / L.y,
    left: (k.left - S.left + v.left) / L.x,
    right: (S.right - k.right + v.right) / L.x
  };
}
const Xm = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: a,
      rects: i,
      platform: l,
      elements: s,
      middlewareData: c
    } = t, {
      element: p,
      padding: h = 0
    } = Zr(e, t) || {};
    if (p == null)
      return {};
    const u = u4(h), m = {
      x: n,
      y: r
    }, d = Ji(a), v = Xi(d), x = await l.getDimensions(p), k = d === "y", I = k ? "top" : "left", T = k ? "bottom" : "right", L = k ? "clientHeight" : "clientWidth", S = i.reference[v] + i.reference[d] - m[d] - i.floating[v], E = m[d] - i.reference[d], j = await (l.getOffsetParent == null ? void 0 : l.getOffsetParent(p));
    let g = j ? j[L] : 0;
    (!g || !await (l.isElement == null ? void 0 : l.isElement(j))) && (g = s.floating[L] || i.floating[v]);
    const w = S / 2 - E / 2, C = g / 2 - x[v] / 2 - 1, b = Jn(u[I], C), M = Jn(u[T], C), R = b, O = g - x[v] - M, N = g / 2 - x[v] / 2 + w, H = ai(R, N, O), Z = !c.arrow && Gr(a) != null && N !== H && i.reference[v] / 2 - (N < R ? b : M) - x[v] / 2 < 0, z = Z ? N < R ? N - R : N - O : 0;
    return {
      [d]: m[d] + z,
      data: {
        [d]: H,
        centerOffset: N - H - z,
        ...Z && {
          alignmentOffset: z
        }
      },
      reset: Z
    };
  }
}), Jm = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: a,
        middlewareData: i,
        rects: l,
        initialPlacement: s,
        platform: c,
        elements: p
      } = t, {
        mainAxis: h = !0,
        crossAxis: u = !0,
        fallbackPlacements: m,
        fallbackStrategy: d = "bestFit",
        fallbackAxisSideDirection: v = "none",
        flipAlignment: x = !0,
        ...k
      } = Zr(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const I = mn(a), T = er(s), L = mn(s) === s, S = await (c.isRTL == null ? void 0 : c.isRTL(p.floating)), E = m || (L || !x ? [T0(s)] : qm(s)), j = v !== "none";
      !m && j && E.push(...Ym(s, x, v, S));
      const g = [s, ...E], w = await d4(t, k), C = [];
      let b = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (h && C.push(w[I]), u) {
        const N = zm(a, l, S);
        C.push(w[N[0]], w[N[1]]);
      }
      if (b = [...b, {
        placement: a,
        overflows: C
      }], !C.every((N) => N <= 0)) {
        var M, R;
        const N = (((M = i.flip) == null ? void 0 : M.index) || 0) + 1, H = g[N];
        if (H)
          return {
            data: {
              index: N,
              overflows: b
            },
            reset: {
              placement: H
            }
          };
        let Z = (R = b.filter((z) => z.overflows[0] <= 0).sort((z, K) => z.overflows[1] - K.overflows[1])[0]) == null ? void 0 : R.placement;
        if (!Z)
          switch (d) {
            case "bestFit": {
              var O;
              const z = (O = b.filter((K) => {
                if (j) {
                  const D = er(K.placement);
                  return D === T || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  D === "y";
                }
                return !0;
              }).map((K) => [K.placement, K.overflows.filter((D) => D > 0).reduce((D, W) => D + W, 0)]).sort((K, D) => K[1] - D[1])[0]) == null ? void 0 : O[0];
              z && (Z = z);
              break;
            }
            case "initialPlacement":
              Z = s;
              break;
          }
        if (a !== Z)
          return {
            reset: {
              placement: Z
            }
          };
      }
      return {};
    }
  };
};
async function eC(e, t) {
  const {
    placement: n,
    platform: r,
    elements: a
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(a.floating)), l = mn(n), s = Gr(n), c = er(n) === "y", p = ["left", "top"].includes(l) ? -1 : 1, h = i && c ? -1 : 1, u = Zr(t, e);
  let {
    mainAxis: m,
    crossAxis: d,
    alignmentAxis: v
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: u.mainAxis || 0,
    crossAxis: u.crossAxis || 0,
    alignmentAxis: u.alignmentAxis
  };
  return s && typeof v == "number" && (d = s === "end" ? v * -1 : v), c ? {
    x: d * h,
    y: m * p
  } : {
    x: m * p,
    y: d * h
  };
}
const tC = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: a,
        y: i,
        placement: l,
        middlewareData: s
      } = t, c = await eC(t, e);
      return l === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: a + c.x,
        y: i + c.y,
        data: {
          ...c,
          placement: l
        }
      };
    }
  };
}, nC = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: a
      } = t, {
        mainAxis: i = !0,
        crossAxis: l = !1,
        limiter: s = {
          fn: (k) => {
            let {
              x: I,
              y: T
            } = k;
            return {
              x: I,
              y: T
            };
          }
        },
        ...c
      } = Zr(e, t), p = {
        x: n,
        y: r
      }, h = await d4(t, c), u = er(mn(a)), m = c4(u);
      let d = p[m], v = p[u];
      if (i) {
        const k = m === "y" ? "top" : "left", I = m === "y" ? "bottom" : "right", T = d + h[k], L = d - h[I];
        d = ai(T, d, L);
      }
      if (l) {
        const k = u === "y" ? "top" : "left", I = u === "y" ? "bottom" : "right", T = v + h[k], L = v - h[I];
        v = ai(T, v, L);
      }
      const x = s.fn({
        ...t,
        [m]: d,
        [u]: v
      });
      return {
        ...x,
        data: {
          x: x.x - n,
          y: x.y - r,
          enabled: {
            [m]: i,
            [u]: l
          }
        }
      };
    }
  };
};
function Y0() {
  return typeof window < "u";
}
function cr(e) {
  return f4(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function wt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function s2(e) {
  var t;
  return (t = (f4(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function f4(e) {
  return Y0() ? e instanceof Node || e instanceof wt(e).Node : !1;
}
function Bt(e) {
  return Y0() ? e instanceof Element || e instanceof wt(e).Element : !1;
}
function r2(e) {
  return Y0() ? e instanceof HTMLElement || e instanceof wt(e).HTMLElement : !1;
}
function Jo(e) {
  return !Y0() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof wt(e).ShadowRoot;
}
function Wr(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: a
  } = Ft(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(a);
}
function rC(e) {
  return ["table", "td", "th"].includes(cr(e));
}
function K0(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function eo(e) {
  const t = to(), n = Bt(e) ? Ft(e) : e;
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function aC(e) {
  let t = B2(e);
  for (; r2(t) && !tr(t); ) {
    if (eo(t))
      return t;
    if (K0(t))
      return null;
    t = B2(t);
  }
  return null;
}
function to() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function tr(e) {
  return ["html", "body", "#document"].includes(cr(e));
}
function Ft(e) {
  return wt(e).getComputedStyle(e);
}
function Q0(e) {
  return Bt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function B2(e) {
  if (cr(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Jo(e) && e.host || // Fallback.
    s2(e)
  );
  return Jo(t) ? t.host : t;
}
function h4(e) {
  const t = B2(e);
  return tr(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : r2(t) && Wr(t) ? t : h4(t);
}
function Nr(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const a = h4(e), i = a === ((r = e.ownerDocument) == null ? void 0 : r.body), l = wt(a);
  if (i) {
    const s = oi(l);
    return t.concat(l, l.visualViewport || [], Wr(a) ? a : [], s && n ? Nr(s) : []);
  }
  return t.concat(a, Nr(a, [], n));
}
function oi(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function p4(e) {
  const t = Ft(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const a = r2(e), i = a ? e.offsetWidth : n, l = a ? e.offsetHeight : r, s = A0(n) !== i || A0(r) !== l;
  return s && (n = i, r = l), {
    width: n,
    height: r,
    $: s
  };
}
function no(e) {
  return Bt(e) ? e : e.contextElement;
}
function Nn(e) {
  const t = no(e);
  if (!r2(t))
    return V2(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: a,
    $: i
  } = p4(t);
  let l = (i ? A0(n.width) : n.width) / r, s = (i ? A0(n.height) : n.height) / a;
  return (!l || !Number.isFinite(l)) && (l = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: l,
    y: s
  };
}
const iC = /* @__PURE__ */ V2(0);
function m4(e) {
  const t = wt(e);
  return !to() || !t.visualViewport ? iC : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function oC(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== wt(e) ? !1 : t;
}
function Cn(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const a = e.getBoundingClientRect(), i = no(e);
  let l = V2(1);
  t && (r ? Bt(r) && (l = Nn(r)) : l = Nn(e));
  const s = oC(i, n, r) ? m4(i) : V2(0);
  let c = (a.left + s.x) / l.x, p = (a.top + s.y) / l.y, h = a.width / l.x, u = a.height / l.y;
  if (i) {
    const m = wt(i), d = r && Bt(r) ? wt(r) : r;
    let v = m, x = oi(v);
    for (; x && r && d !== v; ) {
      const k = Nn(x), I = x.getBoundingClientRect(), T = Ft(x), L = I.left + (x.clientLeft + parseFloat(T.paddingLeft)) * k.x, S = I.top + (x.clientTop + parseFloat(T.paddingTop)) * k.y;
      c *= k.x, p *= k.y, h *= k.x, u *= k.y, c += L, p += S, v = wt(x), x = oi(v);
    }
  }
  return I0({
    width: h,
    height: u,
    x: c,
    y: p
  });
}
function sC(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: a
  } = e;
  const i = a === "fixed", l = s2(r), s = t ? K0(t.floating) : !1;
  if (r === l || s && i)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, p = V2(1);
  const h = V2(0), u = r2(r);
  if ((u || !u && !i) && ((cr(r) !== "body" || Wr(l)) && (c = Q0(r)), r2(r))) {
    const m = Cn(r);
    p = Nn(r), h.x = m.x + r.clientLeft, h.y = m.y + r.clientTop;
  }
  return {
    width: n.width * p.x,
    height: n.height * p.y,
    x: n.x * p.x - c.scrollLeft * p.x + h.x,
    y: n.y * p.y - c.scrollTop * p.y + h.y
  };
}
function lC(e) {
  return Array.from(e.getClientRects());
}
function si(e, t) {
  const n = Q0(e).scrollLeft;
  return t ? t.left + n : Cn(s2(e)).left + n;
}
function cC(e) {
  const t = s2(e), n = Q0(e), r = e.ownerDocument.body, a = fn(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = fn(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let l = -n.scrollLeft + si(e);
  const s = -n.scrollTop;
  return Ft(r).direction === "rtl" && (l += fn(t.clientWidth, r.clientWidth) - a), {
    width: a,
    height: i,
    x: l,
    y: s
  };
}
function uC(e, t) {
  const n = wt(e), r = s2(e), a = n.visualViewport;
  let i = r.clientWidth, l = r.clientHeight, s = 0, c = 0;
  if (a) {
    i = a.width, l = a.height;
    const p = to();
    (!p || p && t === "fixed") && (s = a.offsetLeft, c = a.offsetTop);
  }
  return {
    width: i,
    height: l,
    x: s,
    y: c
  };
}
function dC(e, t) {
  const n = Cn(e, !0, t === "fixed"), r = n.top + e.clientTop, a = n.left + e.clientLeft, i = r2(e) ? Nn(e) : V2(1), l = e.clientWidth * i.x, s = e.clientHeight * i.y, c = a * i.x, p = r * i.y;
  return {
    width: l,
    height: s,
    x: c,
    y: p
  };
}
function e3(e, t, n) {
  let r;
  if (t === "viewport")
    r = uC(e, n);
  else if (t === "document")
    r = cC(s2(e));
  else if (Bt(t))
    r = dC(t, n);
  else {
    const a = m4(e);
    r = {
      ...t,
      x: t.x - a.x,
      y: t.y - a.y
    };
  }
  return I0(r);
}
function C4(e, t) {
  const n = B2(e);
  return n === t || !Bt(n) || tr(n) ? !1 : Ft(n).position === "fixed" || C4(n, t);
}
function fC(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Nr(e, [], !1).filter((s) => Bt(s) && cr(s) !== "body"), a = null;
  const i = Ft(e).position === "fixed";
  let l = i ? B2(e) : e;
  for (; Bt(l) && !tr(l); ) {
    const s = Ft(l), c = eo(l);
    !c && s.position === "fixed" && (a = null), (i ? !c && !a : !c && s.position === "static" && a && ["absolute", "fixed"].includes(a.position) || Wr(l) && !c && C4(e, l)) ? r = r.filter((p) => p !== l) : a = s, l = B2(l);
  }
  return t.set(e, r), r;
}
function hC(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: a
  } = e;
  const i = [...n === "clippingAncestors" ? K0(t) ? [] : fC(t, this._c) : [].concat(n), r], l = i[0], s = i.reduce((c, p) => {
    const h = e3(t, p, a);
    return c.top = fn(h.top, c.top), c.right = Jn(h.right, c.right), c.bottom = Jn(h.bottom, c.bottom), c.left = fn(h.left, c.left), c;
  }, e3(t, l, a));
  return {
    width: s.right - s.left,
    height: s.bottom - s.top,
    x: s.left,
    y: s.top
  };
}
function pC(e) {
  const {
    width: t,
    height: n
  } = p4(e);
  return {
    width: t,
    height: n
  };
}
function mC(e, t, n) {
  const r = r2(t), a = s2(t), i = n === "fixed", l = Cn(e, !0, i, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = V2(0);
  if (r || !r && !i)
    if ((cr(t) !== "body" || Wr(a)) && (s = Q0(t)), r) {
      const d = Cn(t, !0, i, t);
      c.x = d.x + t.clientLeft, c.y = d.y + t.clientTop;
    } else a && (c.x = si(a));
  let p = 0, h = 0;
  if (a && !r && !i) {
    const d = a.getBoundingClientRect();
    h = d.top + s.scrollTop, p = d.left + s.scrollLeft - // RTL <body> scrollbar.
    si(a, d);
  }
  const u = l.left + s.scrollLeft - c.x - p, m = l.top + s.scrollTop - c.y - h;
  return {
    x: u,
    y: m,
    width: l.width,
    height: l.height
  };
}
function ga(e) {
  return Ft(e).position === "static";
}
function t3(e, t) {
  if (!r2(e) || Ft(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return s2(e) === n && (n = n.ownerDocument.body), n;
}
function g4(e, t) {
  const n = wt(e);
  if (K0(e))
    return n;
  if (!r2(e)) {
    let a = B2(e);
    for (; a && !tr(a); ) {
      if (Bt(a) && !ga(a))
        return a;
      a = B2(a);
    }
    return n;
  }
  let r = t3(e, t);
  for (; r && rC(r) && ga(r); )
    r = t3(r, t);
  return r && tr(r) && ga(r) && !eo(r) ? n : r || aC(e) || n;
}
const CC = async function(e) {
  const t = this.getOffsetParent || g4, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: mC(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function gC(e) {
  return Ft(e).direction === "rtl";
}
const vC = {
  convertOffsetParentRelativeRectToViewportRelativeRect: sC,
  getDocumentElement: s2,
  getClippingRect: hC,
  getOffsetParent: g4,
  getElementRects: CC,
  getClientRects: lC,
  getDimensions: pC,
  getScale: Nn,
  isElement: Bt,
  isRTL: gC
};
function wC(e, t) {
  let n = null, r;
  const a = s2(e);
  function i() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function l(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), i();
    const {
      left: p,
      top: h,
      width: u,
      height: m
    } = e.getBoundingClientRect();
    if (s || t(), !u || !m)
      return;
    const d = r0(h), v = r0(a.clientWidth - (p + u)), x = r0(a.clientHeight - (h + m)), k = r0(p), I = {
      rootMargin: -d + "px " + -v + "px " + -x + "px " + -k + "px",
      threshold: fn(0, Jn(1, c)) || 1
    };
    let T = !0;
    function L(S) {
      const E = S[0].intersectionRatio;
      if (E !== c) {
        if (!T)
          return l();
        E ? l(!1, E) : r = setTimeout(() => {
          l(!1, 1e-7);
        }, 1e3);
      }
      T = !1;
    }
    try {
      n = new IntersectionObserver(L, {
        ...I,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(L, I);
    }
    n.observe(e);
  }
  return l(!0), i;
}
function yC(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: i = !0,
    elementResize: l = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, p = no(e), h = a || i ? [...p ? Nr(p) : [], ...Nr(t)] : [];
  h.forEach((I) => {
    a && I.addEventListener("scroll", n, {
      passive: !0
    }), i && I.addEventListener("resize", n);
  });
  const u = p && s ? wC(p, n) : null;
  let m = -1, d = null;
  l && (d = new ResizeObserver((I) => {
    let [T] = I;
    T && T.target === p && d && (d.unobserve(t), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var L;
      (L = d) == null || L.observe(t);
    })), n();
  }), p && !c && d.observe(p), d.observe(t));
  let v, x = c ? Cn(e) : null;
  c && k();
  function k() {
    const I = Cn(e);
    x && (I.x !== x.x || I.y !== x.y || I.width !== x.width || I.height !== x.height) && n(), x = I, v = requestAnimationFrame(k);
  }
  return n(), () => {
    var I;
    h.forEach((T) => {
      a && T.removeEventListener("scroll", n), i && T.removeEventListener("resize", n);
    }), u == null || u(), (I = d) == null || I.disconnect(), d = null, c && cancelAnimationFrame(v);
  };
}
const bC = tC, _C = nC, xC = Jm, LC = Xm, n3 = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), a = {
    platform: vC,
    ...n
  }, i = {
    ...a.platform,
    _c: r
  };
  return Qm(e, t, {
    ...a,
    platform: i
  });
};
/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/
const EC = "react-tooltip-core-styles", MC = "react-tooltip-base-styles", r3 = { core: !1, base: !1 };
function a3({ css: e, id: t = MC, type: n = "base", ref: r }) {
  var a, i;
  if (!e || typeof document > "u" || r3[n] || n === "core" && typeof process < "u" && !((a = process == null ? void 0 : process.env) === null || a === void 0) && a.REACT_TOOLTIP_DISABLE_CORE_STYLES || n !== "base" && typeof process < "u" && !((i = process == null ? void 0 : process.env) === null || i === void 0) && i.REACT_TOOLTIP_DISABLE_BASE_STYLES) return;
  n === "core" && (t = EC), r || (r = {});
  const { insertAt: l } = r;
  if (document.getElementById(t)) return;
  const s = document.head || document.getElementsByTagName("head")[0], c = document.createElement("style");
  c.id = t, c.type = "text/css", l === "top" && s.firstChild ? s.insertBefore(c, s.firstChild) : s.appendChild(c), c.styleSheet ? c.styleSheet.cssText = e : c.appendChild(document.createTextNode(e)), r3[n] = !0;
}
const i3 = async ({ elementReference: e = null, tooltipReference: t = null, tooltipArrowReference: n = null, place: r = "top", offset: a = 10, strategy: i = "absolute", middlewares: l = [bC(Number(a)), xC({ fallbackAxisSideDirection: "start" }), _C({ padding: 5 })], border: s }) => {
  if (!e) return { tooltipStyles: {}, tooltipArrowStyles: {}, place: r };
  if (t === null) return { tooltipStyles: {}, tooltipArrowStyles: {}, place: r };
  const c = l;
  return n ? (c.push(LC({ element: n, padding: 5 })), n3(e, t, { placement: r, strategy: i, middleware: c }).then(({ x: p, y: h, placement: u, middlewareData: m }) => {
    var d, v;
    const x = { left: `${p}px`, top: `${h}px`, border: s }, { x: k, y: I } = (d = m.arrow) !== null && d !== void 0 ? d : { x: 0, y: 0 }, T = (v = { top: "bottom", right: "left", bottom: "top", left: "right" }[u.split("-")[0]]) !== null && v !== void 0 ? v : "bottom", L = s && { borderBottom: s, borderRight: s };
    let S = 0;
    if (s) {
      const E = `${s}`.match(/(\d+)px/);
      S = E != null && E[1] ? Number(E[1]) : 1;
    }
    return { tooltipStyles: x, tooltipArrowStyles: { left: k != null ? `${k}px` : "", top: I != null ? `${I}px` : "", right: "", bottom: "", ...L, [T]: `-${4 + S}px` }, place: u };
  })) : n3(e, t, { placement: "bottom", strategy: i, middleware: c }).then(({ x: p, y: h, placement: u }) => ({ tooltipStyles: { left: `${p}px`, top: `${h}px` }, tooltipArrowStyles: {}, place: u }));
}, o3 = (e, t) => !("CSS" in window && "supports" in window.CSS) || window.CSS.supports(e, t), s3 = (e, t, n) => {
  let r = null;
  const a = function(...i) {
    const l = () => {
      r = null;
    };
    !r && (e.apply(this, i), r = setTimeout(l, t));
  };
  return a.cancel = () => {
    r && (clearTimeout(r), r = null);
  }, a;
}, l3 = (e) => e !== null && !Array.isArray(e) && typeof e == "object", li = (e, t) => {
  if (e === t) return !0;
  if (Array.isArray(e) && Array.isArray(t)) return e.length === t.length && e.every((a, i) => li(a, t[i]));
  if (Array.isArray(e) !== Array.isArray(t)) return !1;
  if (!l3(e) || !l3(t)) return e === t;
  const n = Object.keys(e), r = Object.keys(t);
  return n.length === r.length && n.every((a) => li(e[a], t[a]));
}, kC = (e) => {
  if (!(e instanceof HTMLElement || e instanceof SVGElement)) return !1;
  const t = getComputedStyle(e);
  return ["overflow", "overflow-x", "overflow-y"].some((n) => {
    const r = t.getPropertyValue(n);
    return r === "auto" || r === "scroll";
  });
}, c3 = (e) => {
  if (!e) return null;
  let t = e.parentElement;
  for (; t; ) {
    if (kC(t)) return t;
    t = t.parentElement;
  }
  return document.scrollingElement || document.documentElement;
}, SC = typeof window < "u" ? _n : u1, xt = (e) => {
  e.current && (clearTimeout(e.current), e.current = null);
}, AC = "DEFAULT_TOOLTIP_ID", TC = { anchorRefs: /* @__PURE__ */ new Set(), activeAnchor: { current: null }, attach: () => {
}, detach: () => {
}, setActiveAnchor: () => {
} }, IC = o2({ getTooltipData: () => TC });
function v4(e = AC) {
  return D1(IC).getTooltipData(e);
}
var Sn = { tooltip: "core-styles-module_tooltip__3vRRp", fixed: "core-styles-module_fixed__pcSol", arrow: "core-styles-module_arrow__cvMwQ", noArrow: "core-styles-module_noArrow__xock6", clickable: "core-styles-module_clickable__ZuTTB", show: "core-styles-module_show__Nt9eE", closing: "core-styles-module_closing__sGnxF" }, va = { tooltip: "styles-module_tooltip__mnnfp", arrow: "styles-module_arrow__K0L3T", dark: "styles-module_dark__xNqje", light: "styles-module_light__Z6W-X", success: "styles-module_success__A2AKt", warning: "styles-module_warning__SCK0X", error: "styles-module_error__JvumD", info: "styles-module_info__BWdHW" };
const RC = ({ forwardRef: e, id: t, className: n, classNameArrow: r, variant: a = "dark", anchorId: i, anchorSelect: l, place: s = "top", offset: c = 10, events: p = ["hover"], openOnClick: h = !1, positionStrategy: u = "absolute", middlewares: m, wrapper: d, delayShow: v = 0, delayHide: x = 0, float: k = !1, hidden: I = !1, noArrow: T = !1, clickable: L = !1, closeOnEsc: S = !1, closeOnScroll: E = !1, closeOnResize: j = !1, openEvents: g, closeEvents: w, globalCloseEvents: C, imperativeModeOnly: b, style: M, position: R, afterShow: O, afterHide: N, disableTooltip: H, content: Z, contentWrapperRef: z, isOpen: K, defaultIsOpen: D = !1, setIsOpen: W, activeAnchor: q, setActiveAnchor: e1, border: o1, opacity: c1, arrowColor: v1, role: m1 = "tooltip" }) => {
  var $;
  const n1 = V1(null), d1 = V1(null), f1 = V1(null), M1 = V1(null), Y = V1(null), [P1, J1] = r1({ tooltipStyles: {}, tooltipArrowStyles: {}, place: s }), [I1, ce] = r1(!1), [ve, oe] = r1(!1), [x1, ae] = r1(null), ke = V1(!1), Ie = V1(null), { anchorRefs: ye, setActiveAnchor: Ye } = v4(t), Ne = V1(!1), [K1, be] = r1([]), He = V1(!1), Oe = h || p.includes("click"), Pe = Oe || (g == null ? void 0 : g.click) || (g == null ? void 0 : g.dblclick) || (g == null ? void 0 : g.mousedown), Ze = g ? { ...g } : { mouseover: !0, focus: !0, mouseenter: !1, click: !1, dblclick: !1, mousedown: !1 };
  !g && Oe && Object.assign(Ze, { mouseenter: !1, focus: !1, mouseover: !1, click: !0 });
  const Re = w ? { ...w } : { mouseout: !0, blur: !0, mouseleave: !1, click: !1, dblclick: !1, mouseup: !1 };
  !w && Oe && Object.assign(Re, { mouseleave: !1, blur: !1, mouseout: !1 });
  const ne = C ? { ...C } : { escape: S || !1, scroll: E || !1, resize: j || !1, clickOutsideAnchor: Pe || !1 };
  b && (Object.assign(Ze, { mouseenter: !1, focus: !1, click: !1, dblclick: !1, mousedown: !1 }), Object.assign(Re, { mouseleave: !1, blur: !1, click: !1, dblclick: !1, mouseup: !1 }), Object.assign(ne, { escape: !1, scroll: !1, resize: !1, clickOutsideAnchor: !1 })), SC(() => (He.current = !0, () => {
    He.current = !1;
  }), []);
  const A1 = (A) => {
    He.current && (A && oe(!0), setTimeout(() => {
      He.current && (W == null || W(A), K === void 0 && ce(A));
    }, 10));
  };
  u1(() => {
    if (K === void 0) return () => null;
    K && oe(!0);
    const A = setTimeout(() => {
      ce(K);
    }, 10);
    return () => {
      clearTimeout(A);
    };
  }, [K]), u1(() => {
    if (I1 !== ke.current) if (xt(Y), ke.current = I1, I1) O == null || O();
    else {
      const A = ((G) => {
        const U = G.match(/^([\d.]+)(ms|s)$/);
        if (!U) return 0;
        const [, s1, E1] = U;
        return Number(s1) * (E1 === "ms" ? 1 : 1e3);
      })(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));
      Y.current = setTimeout(() => {
        oe(!1), ae(null), N == null || N();
      }, A + 25);
    }
  }, [I1]);
  const ze = (A) => {
    J1((G) => li(G, A) ? G : A);
  }, _e = (A = v) => {
    xt(f1), ve ? A1(!0) : f1.current = setTimeout(() => {
      A1(!0);
    }, A);
  }, De = (A = x) => {
    xt(M1), M1.current = setTimeout(() => {
      Ne.current || A1(!1);
    }, A);
  }, je = (A) => {
    var G;
    if (!A) return;
    const U = (G = A.currentTarget) !== null && G !== void 0 ? G : A.target;
    if (!(U != null && U.isConnected)) return e1(null), void Ye({ current: null });
    v ? _e() : A1(!0), e1(U), Ye({ current: U }), xt(M1);
  }, Se = () => {
    L ? De(x || 100) : x ? De() : A1(!1), xt(f1);
  }, se = ({ x: A, y: G }) => {
    var U;
    const s1 = { getBoundingClientRect: () => ({ x: A, y: G, width: 0, height: 0, top: G, left: A, right: A, bottom: G }) };
    i3({ place: (U = x1 == null ? void 0 : x1.place) !== null && U !== void 0 ? U : s, offset: c, elementReference: s1, tooltipReference: n1.current, tooltipArrowReference: d1.current, strategy: u, middlewares: m, border: o1 }).then((E1) => {
      ze(E1);
    });
  }, xe = (A) => {
    if (!A) return;
    const G = A, U = { x: G.clientX, y: G.clientY };
    se(U), Ie.current = U;
  }, Le = (A) => {
    var G;
    if (!I1) return;
    const U = A.target;
    U.isConnected && (!((G = n1.current) === null || G === void 0) && G.contains(U) || [document.querySelector(`[id='${i}']`), ...K1].some((s1) => s1 == null ? void 0 : s1.contains(U)) || (A1(!1), xt(f1)));
  }, Ee = s3(je, 50), Z1 = s3(Se, 50), C1 = (A) => {
    Z1.cancel(), Ee(A);
  }, Q = () => {
    Ee.cancel(), Z1();
  }, a1 = W1(() => {
    var A, G;
    const U = (A = x1 == null ? void 0 : x1.position) !== null && A !== void 0 ? A : R;
    U ? se(U) : k ? Ie.current && se(Ie.current) : q != null && q.isConnected && i3({ place: (G = x1 == null ? void 0 : x1.place) !== null && G !== void 0 ? G : s, offset: c, elementReference: q, tooltipReference: n1.current, tooltipArrowReference: d1.current, strategy: u, middlewares: m, border: o1 }).then((s1) => {
      He.current && ze(s1);
    });
  }, [I1, q, Z, M, s, x1 == null ? void 0 : x1.place, c, u, R, x1 == null ? void 0 : x1.position, k]);
  u1(() => {
    var A, G;
    const U = new Set(ye);
    K1.forEach((y1) => {
      H != null && H(y1) || U.add({ current: y1 });
    });
    const s1 = document.querySelector(`[id='${i}']`);
    s1 && !(H != null && H(s1)) && U.add({ current: s1 });
    const E1 = () => {
      A1(!1);
    }, O1 = c3(q), R1 = c3(n1.current);
    ne.scroll && (window.addEventListener("scroll", E1), O1 == null || O1.addEventListener("scroll", E1), R1 == null || R1.addEventListener("scroll", E1));
    let y = null;
    ne.resize ? window.addEventListener("resize", E1) : q && n1.current && (y = yC(q, n1.current, a1, { ancestorResize: !0, elementResize: !0, layoutShift: !0 }));
    const P = (y1) => {
      y1.key === "Escape" && A1(!1);
    };
    ne.escape && window.addEventListener("keydown", P), ne.clickOutsideAnchor && window.addEventListener("click", Le);
    const F = [], t1 = (y1) => {
      I1 && (y1 == null ? void 0 : y1.target) === q || je(y1);
    }, w1 = (y1) => {
      I1 && (y1 == null ? void 0 : y1.target) === q && Se();
    }, L1 = ["mouseover", "mouseout", "mouseenter", "mouseleave", "focus", "blur"], g1 = ["click", "dblclick", "mousedown", "mouseup"];
    Object.entries(Ze).forEach(([y1, H1]) => {
      H1 && (L1.includes(y1) ? F.push({ event: y1, listener: C1 }) : g1.includes(y1) && F.push({ event: y1, listener: t1 }));
    }), Object.entries(Re).forEach(([y1, H1]) => {
      H1 && (L1.includes(y1) ? F.push({ event: y1, listener: Q }) : g1.includes(y1) && F.push({ event: y1, listener: w1 }));
    }), k && F.push({ event: "pointermove", listener: xe });
    const p1 = () => {
      Ne.current = !0;
    }, X1 = () => {
      Ne.current = !1, Se();
    };
    return L && !Pe && ((A = n1.current) === null || A === void 0 || A.addEventListener("mouseenter", p1), (G = n1.current) === null || G === void 0 || G.addEventListener("mouseleave", X1)), F.forEach(({ event: y1, listener: H1 }) => {
      U.forEach((T1) => {
        var Ce;
        (Ce = T1.current) === null || Ce === void 0 || Ce.addEventListener(y1, H1);
      });
    }), () => {
      var y1, H1;
      ne.scroll && (window.removeEventListener("scroll", E1), O1 == null || O1.removeEventListener("scroll", E1), R1 == null || R1.removeEventListener("scroll", E1)), ne.resize ? window.removeEventListener("resize", E1) : y == null || y(), ne.clickOutsideAnchor && window.removeEventListener("click", Le), ne.escape && window.removeEventListener("keydown", P), L && !Pe && ((y1 = n1.current) === null || y1 === void 0 || y1.removeEventListener("mouseenter", p1), (H1 = n1.current) === null || H1 === void 0 || H1.removeEventListener("mouseleave", X1)), F.forEach(({ event: T1, listener: Ce }) => {
        U.forEach((Ge) => {
          var Y1;
          (Y1 = Ge.current) === null || Y1 === void 0 || Y1.removeEventListener(T1, Ce);
        });
      });
    };
  }, [q, a1, ve, ye, K1, g, w, C, Oe, v, x]), u1(() => {
    var A, G;
    let U = (G = (A = x1 == null ? void 0 : x1.anchorSelect) !== null && A !== void 0 ? A : l) !== null && G !== void 0 ? G : "";
    !U && t && (U = `[data-tooltip-id='${t.replace(/'/g, "\\'")}']`);
    const s1 = new MutationObserver((E1) => {
      const O1 = [], R1 = [];
      E1.forEach((y) => {
        if (y.type === "attributes" && y.attributeName === "data-tooltip-id" && (y.target.getAttribute("data-tooltip-id") === t ? O1.push(y.target) : y.oldValue === t && R1.push(y.target)), y.type === "childList") {
          if (q) {
            const P = [...y.removedNodes].filter((F) => F.nodeType === 1);
            if (U) try {
              R1.push(...P.filter((F) => F.matches(U))), R1.push(...P.flatMap((F) => [...F.querySelectorAll(U)]));
            } catch {
            }
            P.some((F) => {
              var t1;
              return !!(!((t1 = F == null ? void 0 : F.contains) === null || t1 === void 0) && t1.call(F, q)) && (oe(!1), A1(!1), e1(null), xt(f1), xt(M1), !0);
            });
          }
          if (U) try {
            const P = [...y.addedNodes].filter((F) => F.nodeType === 1);
            O1.push(...P.filter((F) => F.matches(U))), O1.push(...P.flatMap((F) => [...F.querySelectorAll(U)]));
          } catch {
          }
        }
      }), (O1.length || R1.length) && be((y) => [...y.filter((P) => !R1.includes(P)), ...O1]);
    });
    return s1.observe(document.body, { childList: !0, subtree: !0, attributes: !0, attributeFilter: ["data-tooltip-id"], attributeOldValue: !0 }), () => {
      s1.disconnect();
    };
  }, [t, l, x1 == null ? void 0 : x1.anchorSelect, q]), u1(() => {
    a1();
  }, [a1]), u1(() => {
    if (!(z != null && z.current)) return () => null;
    const A = new ResizeObserver(() => {
      setTimeout(() => a1());
    });
    return A.observe(z.current), () => {
      A.disconnect();
    };
  }, [Z, z == null ? void 0 : z.current]), u1(() => {
    var A;
    const G = document.querySelector(`[id='${i}']`), U = [...K1, G];
    q && U.includes(q) || e1((A = K1[0]) !== null && A !== void 0 ? A : G);
  }, [i, K1, q]), u1(() => (D && A1(!0), () => {
    xt(f1), xt(M1);
  }), []), u1(() => {
    var A;
    let G = (A = x1 == null ? void 0 : x1.anchorSelect) !== null && A !== void 0 ? A : l;
    if (!G && t && (G = `[data-tooltip-id='${t.replace(/'/g, "\\'")}']`), G) try {
      const U = Array.from(document.querySelectorAll(G));
      be(U);
    } catch {
      be([]);
    }
  }, [t, l, x1 == null ? void 0 : x1.anchorSelect]), u1(() => {
    f1.current && (xt(f1), _e(v));
  }, [v]);
  const B1 = ($ = x1 == null ? void 0 : x1.content) !== null && $ !== void 0 ? $ : Z, ie = I1 && Object.keys(P1.tooltipStyles).length > 0;
  return J5(e, () => ({ open: (A) => {
    if (A != null && A.anchorSelect) try {
      document.querySelector(A.anchorSelect);
    } catch {
      return void console.warn(`[react-tooltip] "${A.anchorSelect}" is not a valid CSS selector`);
    }
    ae(A != null ? A : null), A != null && A.delay ? _e(A.delay) : A1(!0);
  }, close: (A) => {
    A != null && A.delay ? De(A.delay) : A1(!1);
  }, activeAnchor: q, place: P1.place, isOpen: !!(ve && !I && B1 && ie) })), ve && !I && B1 ? l1.createElement(d, { id: t, role: m1, className: Q1("react-tooltip", Sn.tooltip, va.tooltip, va[a], n, `react-tooltip__place-${P1.place}`, Sn[ie ? "show" : "closing"], ie ? "react-tooltip__show" : "react-tooltip__closing", u === "fixed" && Sn.fixed, L && Sn.clickable), onTransitionEnd: (A) => {
    xt(Y), I1 || A.propertyName !== "opacity" || (oe(!1), ae(null), N == null || N());
  }, style: { ...M, ...P1.tooltipStyles, opacity: c1 !== void 0 && ie ? c1 : void 0 }, ref: n1 }, B1, l1.createElement(d, { className: Q1("react-tooltip-arrow", Sn.arrow, va.arrow, r, T && Sn.noArrow), style: { ...P1.tooltipArrowStyles, background: v1 ? `linear-gradient(to right bottom, transparent 50%, ${v1} 50%)` : void 0 }, ref: d1 })) : null;
}, NC = ({ content: e }) => l1.createElement("span", { dangerouslySetInnerHTML: { __html: e } }), w4 = l1.forwardRef(({ id: e, anchorId: t, anchorSelect: n, content: r, html: a, render: i, className: l, classNameArrow: s, variant: c = "dark", place: p = "top", offset: h = 10, wrapper: u = "div", children: m = null, events: d = ["hover"], openOnClick: v = !1, positionStrategy: x = "absolute", middlewares: k, delayShow: I = 0, delayHide: T = 0, float: L = !1, hidden: S = !1, noArrow: E = !1, clickable: j = !1, closeOnEsc: g = !1, closeOnScroll: w = !1, closeOnResize: C = !1, openEvents: b, closeEvents: M, globalCloseEvents: R, imperativeModeOnly: O = !1, style: N, position: H, isOpen: Z, defaultIsOpen: z = !1, disableStyleInjection: K = !1, border: D, opacity: W, arrowColor: q, setIsOpen: e1, afterShow: o1, afterHide: c1, disableTooltip: v1, role: m1 = "tooltip" }, $) => {
  const [n1, d1] = r1(r), [f1, M1] = r1(a), [Y, P1] = r1(p), [J1, I1] = r1(c), [ce, ve] = r1(h), [oe, x1] = r1(I), [ae, ke] = r1(T), [Ie, ye] = r1(L), [Ye, Ne] = r1(S), [K1, be] = r1(u), [He, Oe] = r1(d), [Pe, Ze] = r1(x), [Re, ne] = r1(null), [A1, ze] = r1(null), _e = V1(K), { anchorRefs: De, activeAnchor: je } = v4(e), Se = (Z1) => Z1 == null ? void 0 : Z1.getAttributeNames().reduce((C1, Q) => {
    var a1;
    return Q.startsWith("data-tooltip-") && (C1[Q.replace(/^data-tooltip-/, "")] = (a1 = Z1 == null ? void 0 : Z1.getAttribute(Q)) !== null && a1 !== void 0 ? a1 : null), C1;
  }, {}), se = (Z1) => {
    const C1 = { place: (Q) => {
      var a1;
      P1((a1 = Q) !== null && a1 !== void 0 ? a1 : p);
    }, content: (Q) => {
      d1(Q != null ? Q : r);
    }, html: (Q) => {
      M1(Q != null ? Q : a);
    }, variant: (Q) => {
      var a1;
      I1((a1 = Q) !== null && a1 !== void 0 ? a1 : c);
    }, offset: (Q) => {
      ve(Q === null ? h : Number(Q));
    }, wrapper: (Q) => {
      var a1;
      be((a1 = Q) !== null && a1 !== void 0 ? a1 : u);
    }, events: (Q) => {
      const a1 = Q == null ? void 0 : Q.split(" ");
      Oe(a1 != null ? a1 : d);
    }, "position-strategy": (Q) => {
      var a1;
      Ze((a1 = Q) !== null && a1 !== void 0 ? a1 : x);
    }, "delay-show": (Q) => {
      x1(Q === null ? I : Number(Q));
    }, "delay-hide": (Q) => {
      ke(Q === null ? T : Number(Q));
    }, float: (Q) => {
      ye(Q === null ? L : Q === "true");
    }, hidden: (Q) => {
      Ne(Q === null ? S : Q === "true");
    }, "class-name": (Q) => {
      ne(Q);
    } };
    Object.values(C1).forEach((Q) => Q(null)), Object.entries(Z1).forEach(([Q, a1]) => {
      var B1;
      (B1 = C1[Q]) === null || B1 === void 0 || B1.call(C1, a1);
    });
  };
  u1(() => {
    d1(r);
  }, [r]), u1(() => {
    M1(a);
  }, [a]), u1(() => {
    P1(p);
  }, [p]), u1(() => {
    I1(c);
  }, [c]), u1(() => {
    ve(h);
  }, [h]), u1(() => {
    x1(I);
  }, [I]), u1(() => {
    ke(T);
  }, [T]), u1(() => {
    ye(L);
  }, [L]), u1(() => {
    Ne(S);
  }, [S]), u1(() => {
    Ze(x);
  }, [x]), u1(() => {
    _e.current !== K && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
  }, [K]), u1(() => {
    typeof window < "u" && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", { detail: { disableCore: K === "core", disableBase: K } }));
  }, []), u1(() => {
    var Z1;
    const C1 = new Set(De);
    let Q = n;
    if (!Q && e && (Q = `[data-tooltip-id='${e.replace(/'/g, "\\'")}']`), Q) try {
      document.querySelectorAll(Q).forEach((G) => {
        C1.add({ current: G });
      });
    } catch {
      console.warn(`[react-tooltip] "${Q}" is not a valid CSS selector`);
    }
    const a1 = document.querySelector(`[id='${t}']`);
    if (a1 && C1.add({ current: a1 }), !C1.size) return () => null;
    const B1 = (Z1 = A1 != null ? A1 : a1) !== null && Z1 !== void 0 ? Z1 : je.current, ie = new MutationObserver((G) => {
      G.forEach((U) => {
        var s1;
        if (!B1 || U.type !== "attributes" || !(!((s1 = U.attributeName) === null || s1 === void 0) && s1.startsWith("data-tooltip-"))) return;
        const E1 = Se(B1);
        se(E1);
      });
    }), A = { attributes: !0, childList: !1, subtree: !1 };
    if (B1) {
      const G = Se(B1);
      se(G), ie.observe(B1, A);
    }
    return () => {
      ie.disconnect();
    };
  }, [De, je, A1, t, n]), u1(() => {
    N != null && N.border && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), D && !o3("border", `${D}`) && console.warn(`[react-tooltip] "${D}" is not a valid \`border\`.`), N != null && N.opacity && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), W && !o3("opacity", `${W}`) && console.warn(`[react-tooltip] "${W}" is not a valid \`opacity\`.`);
  }, []);
  let xe = m;
  const Le = V1(null);
  if (i) {
    const Z1 = i({ content: (A1 == null ? void 0 : A1.getAttribute("data-tooltip-content")) || n1 || null, activeAnchor: A1 });
    xe = Z1 ? l1.createElement("div", { ref: Le, className: "react-tooltip-content-wrapper" }, Z1) : null;
  } else n1 && (xe = n1);
  f1 && (xe = l1.createElement(NC, { content: f1 }));
  const Ee = { forwardRef: $, id: e, anchorId: t, anchorSelect: n, className: Q1(l, Re), classNameArrow: s, content: xe, contentWrapperRef: Le, place: Y, variant: J1, offset: ce, wrapper: K1, events: He, openOnClick: v, positionStrategy: Pe, middlewares: k, delayShow: oe, delayHide: ae, float: Ie, hidden: Ye, noArrow: E, clickable: j, closeOnEsc: g, closeOnScroll: w, closeOnResize: C, openEvents: b, closeEvents: M, globalCloseEvents: R, imperativeModeOnly: O, style: N, position: H, isOpen: Z, defaultIsOpen: z, border: D, opacity: W, arrowColor: q, setIsOpen: e1, afterShow: o1, afterHide: c1, disableTooltip: v1, activeAnchor: A1, setActiveAnchor: (Z1) => ze(Z1), role: m1 };
  return l1.createElement(RC, { ...Ee });
});
typeof window < "u" && window.addEventListener("react-tooltip-inject-styles", (e) => {
  e.detail.disableCore || a3({ css: ":root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}", type: "core" }), e.detail.disableBase || a3({ css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:8px;height:8px}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`, type: "base" });
});
const HC = "Tooltip__tooltip--57322", OC = "Tooltip__title--9fe21", jC = "Tooltip__description--a879e", PC = "Tooltip__button--f9394", Ir = {
  tooltip: HC,
  title: OC,
  description: jC,
  button: PC,
  "appearance-neutral": "Tooltip__appearance-neutral--0ee46",
  "appearance-white": "Tooltip__appearance-white--bff71",
  "appearance-accent": "Tooltip__appearance-accent--a94c5"
}, kt = V((e, t) => {
  const {
    appearance: n,
    className: r
  } = e;
  return /* @__PURE__ */ i1.jsx(
    w4,
    {
      noArrow: !0,
      ...e,
      ref: t,
      className: Q1(Ir.tooltip, Ir[`appearance-${n}`], r),
      opacity: "1"
    }
  );
}), DC = V((e, t) => {
  const {
    id: n,
    children: r,
    content: a,
    appearance: i = "neutral",
    className: l,
    ...s
  } = e;
  return /* @__PURE__ */ i1.jsxs("div", { "data-tooltip-id": n, className: Q1(Ir.wrapper, l), children: [
    r,
    !!a && /* @__PURE__ */ i1.jsx(
      w4,
      {
        noArrow: !0,
        ...s,
        className: Q1(Ir.tooltip, Ir[`appearance-${i}`]),
        opacity: "1",
        id: n,
        ref: t,
        children: a
      }
    )
  ] });
}), wa = ({
  name: e,
  type: t = "before",
  text: n,
  accent: r,
  className: a,
  onClick: i
}) => {
  const l = !e && n, s = e === "loader", c = e ? `${e}-${Math.random().toString(36).substr(2, 9)}` : "", p = (u) => {
    i && i(u);
  };
  if (l)
    return /* @__PURE__ */ i1.jsx("span", { className: F1.afterText, children: n });
  if (!e)
    return null;
  const h = /* @__PURE__ */ i1.jsx(
    q1,
    {
      type: "button",
      appearance: "neutral",
      mode: "link",
      onClick: p,
      className: Q1(F1.iconAfter, a, {
        [F1.loader]: s
      }),
      leftIcon: /* @__PURE__ */ i1.jsx(b1, { name: e }),
      isDisabled: s || !i
    }
  );
  return t === "after" ? n && !s ? /* @__PURE__ */ i1.jsx(
    DC,
    {
      id: c,
      content: n,
      children: h
    }
  ) : h : t === "clear" ? /* @__PURE__ */ i1.jsx(
    q1,
    {
      type: "button",
      appearance: "alpha",
      mode: "primary",
      size: "xs",
      onClick: p,
      radius: "round",
      className: Q1(F1.iconClear, a),
      leftIcon: /* @__PURE__ */ i1.jsx(b1, { name: e })
    }
  ) : /* @__PURE__ */ i1.jsx(
    "div",
    {
      className: Q1(F1.iconBefore, a, {
        [F1.accent]: r
      }),
      children: /* @__PURE__ */ i1.jsx(b1, { name: e })
    }
  );
}, y4 = V(({
  component: e = "input",
  status: t,
  beforeIcon: n,
  isIconAccent: r,
  afterIcon: a,
  onAfterIconClick: i,
  afterText: l,
  isLoading: s,
  isDisabled: c,
  onClear: p,
  wrapperClassName: h,
  inputClassName: u,
  suffix: m,
  style: d = {},
  ...v
}, x) => {
  const [k, I] = r1(0), T = V1(null), L = e === "textarea", S = !L, E = n && S, j = (a || s) && S, g = l && S, w = p && !c && S;
  return _n(() => {
    var C;
    T.current && I(((C = T.current) == null ? void 0 : C.offsetWidth) || 0);
  }), /* @__PURE__ */ i1.jsxs(
    "div",
    {
      className: Q1(F1.inputWrapper, h, {
        [F1.errorWrapper]: t === "error",
        [F1.validWrapper]: t === "valid",
        [F1.disabled]: c
      }),
      children: [
        /* @__PURE__ */ i1.jsx(
          e,
          {
            ...v,
            className: Q1(F1.input, u, {
              [F1.hasBeforeIcon]: E,
              [F1.hasAfterIcon]: j,
              [F1.hasAfterText]: g && !g,
              [F1.textarea]: L
            }),
            disabled: c,
            style: {
              ...d,
              paddingRight: `${k}px`
            },
            ref: x
          }
        ),
        m && v.value ? /* @__PURE__ */ i1.jsxs(
          "span",
          {
            className: Q1(F1.suffix, F1.input, {
              [F1.hasBeforeIcon]: E
            }),
            children: [
              /* @__PURE__ */ i1.jsx("span", { className: Q1(F1.value), children: v.value }),
              m
            ]
          }
        ) : null,
        E && /* @__PURE__ */ i1.jsx(
          wa,
          {
            name: n,
            type: "before",
            accent: r
          }
        ),
        (j || g || w) && /* @__PURE__ */ i1.jsxs("div", { className: F1.rightBlock, ref: T, children: [
          w && /* @__PURE__ */ i1.jsx(
            wa,
            {
              name: "cancel",
              type: "clear",
              onClick: p
            }
          ),
          (j || g) && /* @__PURE__ */ i1.jsx(
            wa,
            {
              name: s ? "loader" : a,
              type: "after",
              text: l,
              onClick: i
            }
          )
        ] })
      ]
    }
  );
}), b4 = V(({
  type: e,
  disabled: t,
  propRef: n,
  ...r
}, a) => {
  const [i, l] = r1(e || "text"), s = i === "password", c = n || a, p = W1(() => {
    l(s ? "text" : "password");
  }, [i]);
  return /* @__PURE__ */ i1.jsx(
    y4,
    {
      ...e === "password" && {
        afterIcon: s ? "view-outline" : "hide-outline",
        onAfterIconClick: p
      },
      isDisabled: t,
      ...r,
      type: i,
      component: "input",
      ...c && { ref: c }
    }
  );
}), VC = ["ArrowUp", "ArrowDown", "Escape", "Enter"], u3 = (e = [], t = -1) => t >= e.length - 1 ? -1 : e.findIndex((n, r) => r > t && !n.disabled), d3 = (e = [], t = e.length) => {
  let n = -1;
  if (t <= 0)
    return n;
  for (let r = t - 1; r >= 0; r--)
    if (!e[r].disabled) {
      n = r;
      break;
    }
  return n;
}, BC = ({
  value: e,
  className: t,
  options: n = [],
  fullWidth: r,
  autoWidth: a,
  align: i = "left",
  style: l,
  onSelectOption: s,
  onToggle: c,
  ...p
}) => {
  const h = Xe(
    () => n.find(($) => $.selected || $.value === e),
    [n, e]
  ), u = V1(null), m = V1(null), d = V1(null), v = V1(null), x = V1(), k = V1({ x: 0, y: 0 }), [I, T] = r1((h == null ? void 0 : h.value) || ""), [L, S] = r1(-1), [E, j] = r1(!1), [g, w] = r1(l), C = Xe(() => {
    var $;
    return ($ = n.find((n1) => n1.value === I)) == null ? void 0 : $.text;
  }, [n, I]), b = () => m.current !== null, M = W1(() => {
    j(!0), S(n.findIndex(($) => $.value === I)), c && c("open");
  }, [I]), R = () => {
    j(!1), c && c("close");
  }, O = W1(() => {
    E ? R() : M();
  }, [M, E]), N = () => {
    R();
  }, H = W1(($, n1) => {
    var d1, f1;
    const M1 = ((d1 = n[$]) == null ? void 0 : d1.value) || "";
    R(), T(M1), (f1 = u.current) == null || f1.blur(), s && s(M1, n1);
  }, [n]), Z = ($) => {
    $.preventDefault();
  }, z = W1(() => {
    clearTimeout(x.current), x.current = setTimeout(() => {
      var $;
      ($ = u.current) == null || $.focus();
    }, 0);
  }, [u]), K = W1(($) => {
    !u.current || !document || $.target !== u.current && (u.current.click(), document.activeElement !== u.current && z());
  }, [u, z]), D = W1(($, n1 = !1) => {
    const d1 = m.current, f1 = d.current, M1 = d1 && f1 ? f1.children[$] : null;
    if (!M1 || !d1)
      return;
    const Y = d1.offsetHeight, { scrollTop: P1 } = d1, J1 = M1.offsetTop, I1 = M1.offsetHeight;
    n1 ? d1.scrollTop = J1 - Y / 2 + I1 / 2 : J1 + I1 > Y + P1 ? d1.scrollTop = J1 - Y + I1 : J1 < P1 && (d1.scrollTop = J1);
  }, []), W = W1(($, n1 = !0) => {
    const d1 = n[$];
    d1 != null && d1.disabled || (n1 && D($), S((f1) => f1 !== $ ? $ : f1));
  }, [n, D]), q = () => {
    S(-1);
  }, e1 = W1(($) => {
    const n1 = n.length;
    return $ >= 0 && $ < (n1 != null ? n1 : 0);
  }, [n]), o1 = ($) => {
    L === void 0 || !e1(L) || H(L, $);
  }, c1 = W1(($) => {
    let n1 = L;
    if ($ === "next") {
      const d1 = u3(n, n1);
      n1 = d1 === -1 ? u3(n) : d1;
    } else if ($ === "prev") {
      const d1 = d3(n, n1);
      n1 = d1 === -1 ? d3(n) : d1;
    }
    W(n1);
  }, [W, L, n]), v1 = W1(($, n1) => {
    (Math.abs(k.current.x - $.clientX) >= 1 || Math.abs(k.current.y - $.clientY) >= 1) && W(n1, !1), k.current = { x: $.clientX, y: $.clientY };
  }, [W]), m1 = W1(($) => {
    switch (VC.includes($.key) && b() && $.preventDefault(), $.key) {
      case "ArrowUp":
        E ? b() && c1("prev") : M();
        break;
      case "ArrowDown":
        E ? b() && c1("next") : M();
        break;
      case "Escape":
        R();
        break;
      case "Backspace":
      case "Delete": {
        E || (j(!0), c && c("open")), q();
        break;
      }
      case "Enter":
      case "Spacebar":
      case " ":
        E ? b() && o1($) : M();
        break;
    }
  }, [E, M, c1]);
  return _n(() => {
    var $;
    if (!a)
      return;
    const n1 = `${((($ = v.current) == null ? void 0 : $.clientWidth) || 0) + 35}px`;
    w({
      ...l || {},
      width: n1
    });
  }, [C]), // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
  /* @__PURE__ */ i1.jsxs(
    "div",
    {
      className: Q1(F1.selectWrapper, {
        [F1.autoWidth]: a
      }),
      onClick: K,
      children: [
        /* @__PURE__ */ i1.jsx(
          b4,
          {
            afterIcon: E ? "chevron-up-24" : "chevron-down-24",
            ...p,
            inputClassName: Q1(F1.selectInput, t),
            propRef: u,
            type: "text",
            onAfterIconClick: z,
            onBlur: N,
            onClick: O,
            onKeyDown: m1,
            value: C,
            style: g,
            readOnly: !0
          }
        ),
        E && /* @__PURE__ */ i1.jsx(
          "div",
          {
            className: Q1(F1.selectDropdown, F1[i], {
              [F1.fullWidth]: r
            }),
            ref: m,
            children: /* @__PURE__ */ i1.jsx("div", { className: F1.selectOptions, ref: d, children: n.map(($, n1) => {
              const d1 = I === $.value && !$.disabled, f1 = $.disabled && ($.disabledHint || $.disabledIcon);
              return /* @__PURE__ */ i1.jsxs(
                Je,
                {
                  "data-value": $.value,
                  className: Q1(F1.selectOption, {
                    [F1.focused]: L === n1,
                    [F1.selected]: d1,
                    [F1.disabled]: $.disabled
                  }),
                  disabled: $.disabled,
                  onClick: (M1) => H(n1, M1),
                  onMouseDown: Z,
                  onMouseMove: (M1) => v1(M1, n1),
                  children: [
                    $.icon && /* @__PURE__ */ i1.jsx("span", { className: F1.optionIcon, children: $.icon }),
                    /* @__PURE__ */ i1.jsx("span", { className: F1.optionText, children: $.text }),
                    d1 && /* @__PURE__ */ i1.jsx(b1, { name: "check-circle-large-16", className: F1.selectedIcon }),
                    f1 && /* @__PURE__ */ i1.jsxs("span", { className: F1.disabledInfo, children: [
                      $.disabledIcon && /* @__PURE__ */ i1.jsx(b1, { name: $.disabledIcon }),
                      $.disabledHint && $.disabledHint
                    ] })
                  ]
                },
                $.value
              );
            }) })
          }
        ),
        a && /* @__PURE__ */ i1.jsx(
          "span",
          {
            ref: v,
            className: Q1(F1.input, F1.autoWidthTemplate),
            children: C
          }
        )
      ]
    }
  );
}, FC = V(({
  disabled: e,
  ...t
}, n) => /* @__PURE__ */ i1.jsx(
  y4,
  {
    isDisabled: e,
    ...t,
    component: "textarea",
    ...n && { ref: n }
  }
)), xn = ({
  children: e,
  label: t,
  subhead: n,
  caption: r,
  captionId: a,
  required: i,
  fieldClassName: l,
  onRemove: s,
  id: c,
  status: p
}) => {
  const { captionLabelId: h } = $0({
    id: c,
    caption: r,
    captionId: a
  });
  return /* @__PURE__ */ i1.jsxs(
    "div",
    {
      className: Q1(F1.formField, l, {
        [F1.valid]: p === "valid",
        [F1.error]: p === "error"
      }),
      children: [
        t && /* @__PURE__ */ i1.jsxs("label", { htmlFor: c, className: F1.label, children: [
          t,
          i && /* @__PURE__ */ i1.jsx("span", { className: F1.labelRequired, children: "*" }),
          n && /* @__PURE__ */ i1.jsx("span", { className: F1.subhead, children: n })
        ] }),
        /* @__PURE__ */ i1.jsxs("div", { className: F1.formFieldInput, children: [
          e,
          s && /* @__PURE__ */ i1.jsx(
            q1,
            {
              type: "button",
              className: F1.removeBtn,
              appearance: "neutral",
              mode: "link",
              onClick: s,
              leftIcon: /* @__PURE__ */ i1.jsx(b1, { name: "cancel" })
            }
          )
        ] }),
        r && /* @__PURE__ */ i1.jsx(
          "span",
          {
            id: h,
            className: F1.caption,
            children: r
          }
        )
      ]
    }
  );
}, ZC = V(({
  id: e,
  caption: t,
  captionId: n,
  label: r,
  subhead: a,
  onRemove: i,
  fieldClassName: l,
  ...s
}, c) => {
  const { captionLabelId: p, fieldProps: h } = $0({
    id: e,
    caption: t,
    captionId: n
  }), u = {
    ...s,
    id: e,
    caption: t,
    captionId: p,
    label: r,
    subhead: a,
    onRemove: i,
    fieldClassName: l
  };
  return /* @__PURE__ */ i1.jsx(xn, { ...u, children: /* @__PURE__ */ i1.jsx(
    b4,
    {
      ...s,
      ...h,
      ...c && { ref: c }
    }
  ) });
}), GC = V(({
  id: e,
  caption: t,
  captionId: n,
  label: r,
  subhead: a,
  onRemove: i,
  fieldClassName: l,
  ...s
}, c) => {
  const { captionLabelId: p, fieldProps: h } = $0({
    id: e,
    caption: t,
    captionId: n
  }), u = {
    ...s,
    id: e,
    caption: t,
    captionId: p,
    label: r,
    subhead: a,
    onRemove: i,
    fieldClassName: l
  };
  return /* @__PURE__ */ i1.jsx(
    xn,
    {
      ...u,
      children: /* @__PURE__ */ i1.jsx(
        FC,
        {
          ...s,
          ...h,
          ...c && { ref: c }
        }
      )
    }
  );
}), WC = ({
  id: e,
  caption: t,
  captionId: n,
  label: r,
  subhead: a,
  onRemove: i,
  fieldClassName: l,
  onToggle: s,
  ...c
}) => {
  const [p, h] = r1(!1), { captionLabelId: u, fieldProps: m } = $0({
    id: e,
    caption: t,
    captionId: n
  }), d = {
    ...c,
    id: e,
    caption: t,
    captionId: u,
    label: r,
    subhead: a,
    onRemove: i,
    fieldClassName: Q1(l, {
      [F1.selectOpened]: p
    })
  }, v = (x) => {
    h(x === "open"), s && s(x);
  };
  return /* @__PURE__ */ i1.jsx(
    xn,
    {
      ...d,
      children: /* @__PURE__ */ i1.jsx(
        BC,
        {
          ...c,
          ...m,
          onToggle: v
        }
      )
    }
  );
};
xn.Input = ZC;
xn.Textarea = GC;
xn.Select = WC;
const UC = "Label__root--d1371", zC = "Label__size_xs--ae319", qC = "Label__icon--58691", $C = "Label__size_sm--6026d", YC = "Label__size_2xs--1dfda", KC = "Label__label--79e2b", QC = "Label__size_md--3fa63", XC = "Label__noText--d757c", JC = "Label__size_lg--4c692", eg = "Label__size_xl--1b861", tg = "Label__variant_blue--81a04", ng = "Label__variant_blackInvariable--73d52", rg = "Label__variant_whiteAlpha--763dc", ag = "Label__variant_blackAlpha--c0e21", ig = "Label__variant_dlc--a4b4f", og = "Label__variant_demo--5d332", sg = "Label__variant_laboratory--3baea", lg = "Label__variant_earlyAccess--c2493", cg = "Label__variant_gray--c33a8", ug = "Label__variant_bundle--21288", dg = "Label__variant_lime--3fb2f", fg = "Label__variant_whiteInvariable--853ee", hg = "Label__disabled--89c15", q2 = {
  root: UC,
  size_xs: zC,
  icon: qC,
  size_sm: $C,
  size_2xs: YC,
  label: KC,
  size_md: QC,
  noText: XC,
  size_lg: JC,
  size_xl: eg,
  variant_blue: tg,
  variant_blackInvariable: ng,
  variant_whiteAlpha: rg,
  variant_blackAlpha: ag,
  variant_dlc: ig,
  variant_demo: og,
  variant_laboratory: sg,
  variant_earlyAccess: lg,
  variant_gray: cg,
  variant_bundle: ug,
  variant_lime: dg,
  variant_whiteInvariable: fg,
  disabled: hg
}, ro = ({
  id: e,
  label: t,
  iconName: n,
  size: r = "md",
  variant: a = "blue",
  isDisabled: i,
  className: l
}) => {
  const s = t ? `${n}-circle` : n;
  return /* @__PURE__ */ i1.jsxs(
    "div",
    {
      "data-id": e ? `label_${e}` : void 0,
      className: Q1(
        q2.root,
        {
          [q2[`variant_${a}`]]: a,
          [q2[`size_${r}`]]: r,
          [q2.noText]: !t,
          [q2.disabled]: i
        },
        l
      ),
      children: [
        s && /* @__PURE__ */ i1.jsx("div", { className: Q1(q2.icon), children: /* @__PURE__ */ i1.jsx(b1, { name: s }) }),
        t && /* @__PURE__ */ i1.jsx("span", { className: q2.label, children: t })
      ]
    }
  );
}, _4 = ({
  discount: e,
  variant: t = "lime",
  className: n,
  isDisabled: r,
  size: a = "xs"
}) => {
  const i = `−${e}%`;
  return /* @__PURE__ */ i1.jsx(
    ro,
    {
      id: "discount",
      className: n,
      variant: t,
      label: i,
      size: a,
      isDisabled: r
    }
  );
}, f3 = {
  vkp: {
    variant: "blackAlpha",
    iconName: "check"
  },
  download: {
    variant: "whiteAlpha",
    iconName: "download"
  },
  cloud: {
    variant: "whiteAlpha",
    iconName: "cloud"
  },
  dev: {
    variant: "blackAlpha",
    iconName: "in-development"
  },
  key: {
    variant: "whiteInvariable",
    iconName: "key"
  },
  bundle: {
    variant: "bundle",
    iconName: "kit"
  },
  earlyAccess: {
    variant: "earlyAccess",
    iconName: "hourglass"
  },
  dlc: {
    variant: "dlc",
    iconName: "game"
  },
  demo: {
    variant: "demo",
    iconName: "demo"
  },
  laboratory: {
    variant: "laboratory",
    iconName: "education"
  },
  browser: {
    variant: "whiteAlpha",
    iconName: "browser"
  },
  steamGift: {
    variant: "whiteInvariable",
    iconName: "gift"
  },
  unpublished: {
    variant: "whiteInvariable",
    iconName: "error-bold"
  }
}, J2 = ({
  type: e,
  label: t,
  size: n,
  className: r
}) => {
  if (!f3[e])
    return null;
  const { variant: a, iconName: i } = f3[e];
  return /* @__PURE__ */ i1.jsx(
    ro,
    {
      id: e,
      className: r,
      variant: a,
      iconName: i,
      label: t,
      size: n
    }
  );
}, pg = "Loader__wrapper--604d1", mg = "Loader__spinner--317a2", Cg = "Loader__spin--f29bc", ya = {
  wrapper: pg,
  spinner: mg,
  spin: Cg,
  "size-56": "Loader__size-56--5bafd",
  "size-48": "Loader__size-48--59896",
  "size-32": "Loader__size-32--65d1d",
  "size-28": "Loader__size-28--5c6b7",
  "size-24": "Loader__size-24--aaa08",
  "size-20": "Loader__size-20--d1285",
  "size-16": "Loader__size-16--82ad7"
}, nr = ({ size: e = "32", className: t, spinnerClassName: n }) => /* @__PURE__ */ i1.jsx("div", { className: Q1(ya.wrapper, t), children: /* @__PURE__ */ i1.jsx(
  "div",
  {
    className: Q1(ya.spinner, n, {
      [ya[`size-${e}`]]: e
    }),
    children: /* @__PURE__ */ i1.jsx(b1, { name: "loader" })
  }
) }), gg = "Price__root--85025", vg = "Price__sub--615ac", wg = "Price__strike--6c25e", yg = "Price__variant_lime--54196", bg = "Price__variant_gray--eaff8", _g = "Price__variant_whiteInvariable--916b7", xg = "Price__variant_blackInvariable--422ea", Lg = "Price__size_lg--84998", Eg = "Price__size_md--2dfe3", Mg = "Price__size_sm--d029a", kg = "Price__size_xs--e8e83", Sg = "Price__priceLabel--70868", Ag = "Price__icon--9108a", Tg = "Price__label--2fc37", t2 = {
  root: gg,
  sub: vg,
  strike: wg,
  variant_lime: yg,
  variant_gray: bg,
  variant_whiteInvariable: _g,
  variant_blackInvariable: xg,
  size_lg: Lg,
  size_md: Eg,
  size_sm: Mg,
  size_xs: kg,
  priceLabel: Sg,
  icon: Ag,
  label: Tg
}, h3 = ({
  className: e,
  children: t,
  currency: n = "RUB",
  size: r = "md",
  variant: a = "lime",
  isSub: i,
  isStrike: l,
  beforeLabel: s
}) => /* @__PURE__ */ i1.jsxs(
  "span",
  {
    "data-id": i ? "subprice" : "price",
    className: Q1(t2.root, {
      [t2[`size_${r}`]]: r,
      [t2[`variant_${a}`]]: a,
      [t2.sub]: i,
      [t2.strike]: l
    }, e),
    children: [
      s && /* @__PURE__ */ i1.jsxs(i1.Fragment, { children: [
        s,
        " "
      ] }),
      l4.formatPrice(t, n)
    ]
  }
), a0 = ({
  id: e,
  className: t,
  icon: n,
  label: r,
  size: a,
  variant: i
}) => /* @__PURE__ */ i1.jsxs(
  "div",
  {
    "data-id": e ? `price-label_${e}` : void 0,
    className: Q1(t2.priceLabel, {
      [t2[`size_${a}`]]: a,
      [t2[`variant_${i}`]]: i
    }, t),
    children: [
      n && /* @__PURE__ */ i1.jsx("div", { className: t2.icon, children: n }),
      /* @__PURE__ */ i1.jsx("span", { className: t2.label, children: r })
    ]
  }
), Ig = "SkeletonBlock__root--ef884", Rg = "SkeletonBlock__primary--22641", Ng = "SkeletonBlock__withAnimation--10f2c", Hg = "SkeletonBlock__secondary--ce222", ba = {
  root: Ig,
  primary: Rg,
  withAnimation: Ng,
  "vkp-skeleton-animation": "SkeletonBlock__vkp-skeleton-animation--3b029",
  secondary: Hg
};
function ot({
  appearance: e = "primary",
  className: t,
  withAnimation: n = !0,
  height: r,
  width: a,
  marginBottom: i,
  children: l
}) {
  return /* @__PURE__ */ i1.jsx(
    "div",
    {
      className: Q1(ba.root, ba[e], t, {
        [ba.withAnimation]: n
      }),
      style: {
        height: r,
        width: a,
        marginBottom: i
      },
      children: l
    }
  );
}
const Og = "/hotbox", jg = ["webp"], Pg = "Picture__root--e4695", Dg = "Picture__image--b0181", Vg = "Picture__skeleton--c16a6", _a = {
  root: Pg,
  image: Dg,
  skeleton: Vg
}, Bg = {
  mobileSmMax: "360px",
  mobileMdMax: "480px",
  tabletSmMax: "768px",
  tabletMdMax: "1179px",
  tabletXMdMax: "1280px",
  tabletLgMax: "1460px",
  desktopSmMax: "1600px",
  desktopMdMax: "1727px",
  desktopLgMax: "1920px"
}, Fg = {
  mobileSmMin: "361px",
  mobileMdMin: "481px",
  tabletSmMin: "769px",
  tabletMdMin: "1180px",
  tabletXMdMin: "1281px",
  tabletLgMin: "1461px",
  desktopSmMin: "1601px",
  desktopMdMin: "1728px",
  desktopLgMin: "1921px"
}, Zg = {
  anyDeviceMin: "0px",
  ...Bg,
  ...Fg
}, p3 = ({
  source: e,
  width: t = 0,
  height: n = 0,
  format: r,
  factor: a,
  quality: i
}) => {
  const l = new URL(e, document.baseURI), s = Math.round(t * a), c = Math.round(n * a), p = `pre_${s}x${c}_resize`;
  return l.searchParams.append("quality", String(i)), l.searchParams.append("format", String(r)), l.pathname = `${p}${l.pathname}`, String(l);
}, Gg = ({
  src: e,
  width: t,
  height: n,
  type: r,
  quality: a
}) => {
  const i = p3({
    source: e,
    width: t,
    height: n,
    format: r,
    factor: 1,
    quality: a
  }), l = p3({
    source: e,
    width: t,
    height: n,
    format: r,
    factor: 2,
    quality: a
  });
  return `${i} 1x, ${l} 2x`;
}, Wg = ({
  src: e,
  type: t,
  size: n,
  height: r,
  width: a,
  mediaQuery: i,
  quality: l
}) => {
  const s = Gg({
    src: e,
    type: t,
    width: a,
    height: r,
    quality: l
  });
  return /* @__PURE__ */ i1.jsx(
    "source",
    {
      type: `image/${t}`,
      media: i ? `(${i}: ${n})` : void 0,
      srcSet: s,
      width: a,
      height: r
    }
  );
}, Ug = ({
  src: e,
  types: t,
  width: n,
  height: r,
  quality: a,
  breakpoints: i = {
    anyDeviceMin: {}
  }
}) => Object.entries(i).map(([l, s]) => {
  const c = s.src || e, p = s.width || n, h = s.height || r;
  return c != null && c.includes(Og) ? t.map((u) => /* @__PURE__ */ i1.jsx(
    Wg,
    {
      src: c,
      type: u,
      width: p,
      height: h,
      quality: a,
      mediaQuery: `${l.slice(-3).toLowerCase()}-width`,
      size: Zg[l]
    },
    u
  )) : null;
}), ur = ({
  className: e,
  src: t,
  width: n,
  height: r,
  quality: a = 85,
  // TODO: выставить 100, когда добавим avif
  alt: i,
  loading: l,
  breakpoints: s,
  hideSkeleton: c,
  fallbackSrc: p,
  ...h
}) => {
  const [u, m] = r1(!1), [d, v] = r1(t);
  function x() {
    v(p);
  }
  function k() {
    m(!0);
  }
  return /* @__PURE__ */ i1.jsxs(
    "picture",
    {
      className: Q1(
        e,
        _a.root
      ),
      onError: x,
      ...h,
      children: [
        !c && !u && /* @__PURE__ */ i1.jsx(ot, { className: _a.skeleton, width: "100%", height: "100%" }),
        /* @__PURE__ */ i1.jsx(
          Ug,
          {
            src: d,
            width: n,
            height: r,
            types: jg,
            quality: a,
            breakpoints: s
          }
        ),
        /* @__PURE__ */ i1.jsx(
          "img",
          {
            className: _a.image,
            src: d,
            width: n,
            height: r,
            alt: i,
            loading: l,
            onLoad: k,
            onError: k
          }
        )
      ]
    }
  );
}, zg = "PriceManager__root--1d5db", qg = "PriceManager__size_lg--ea1ec", $g = "PriceManager__size_md--d67e2", Yg = "PriceManager__size_sm--0e5b8", Kg = "PriceManager__size_xs--cc3ad", Qg = "PriceManager__originalPrice--237db", xa = {
  root: zg,
  size_lg: qg,
  size_md: $g,
  size_sm: Yg,
  size_xs: Kg,
  originalPrice: Qg
}, X0 = ({
  size: e = "md",
  variant: t = "lime",
  currency: n,
  actualValue: r,
  originalValue: a = 0,
  hideOriginalValue: i,
  discountValue: l = 0,
  isCloudOnly: s,
  cloudOnlyLabel: c,
  isBought: p,
  boughtLabel: h,
  isReleaseSoon: u,
  releaseSoonLabel: m,
  beforeLabel: d,
  freeLabel: v,
  preorder: x,
  showDiscountLabel: k = !0
}) => {
  if (s && c)
    return /* @__PURE__ */ i1.jsx(
      a0,
      {
        id: "cloud",
        variant: "gray",
        label: c,
        icon: /* @__PURE__ */ i1.jsx(b1, { name: "cloud" }),
        size: e
      }
    );
  if (p && h)
    return /* @__PURE__ */ i1.jsx(
      a0,
      {
        id: "bought",
        variant: "gray",
        label: h,
        icon: /* @__PURE__ */ i1.jsx(b1, { name: "check-circle" }),
        size: e
      }
    );
  if ((u && !x || !r && x) && m)
    return /* @__PURE__ */ i1.jsx(
      a0,
      {
        id: "release-soon",
        variant: "gray",
        label: m,
        icon: /* @__PURE__ */ i1.jsx(b1, { name: "time-circle" }),
        size: e
      }
    );
  if (!r && v)
    return /* @__PURE__ */ i1.jsx(
      a0,
      {
        id: "free",
        variant: "lime",
        label: v,
        size: e
      }
    );
  if (!r)
    return null;
  const I = !!(a && l), T = !i, L = I ? t : "whiteInvariable";
  return /* @__PURE__ */ i1.jsxs(
    "div",
    {
      className: Q1(xa.root, {
        [xa[`size_${e}`]]: e
      }),
      children: [
        /* @__PURE__ */ i1.jsx(
          h3,
          {
            variant: L,
            size: e,
            currency: n,
            beforeLabel: d,
            children: r
          }
        ),
        I && /* @__PURE__ */ i1.jsxs(i1.Fragment, { children: [
          T && /* @__PURE__ */ i1.jsx(
            h3,
            {
              className: xa.originalPrice,
              variant: "gray",
              currency: n,
              size: e,
              isSub: !0,
              isStrike: !0,
              children: a
            }
          ),
          k && /* @__PURE__ */ i1.jsx(_4, { variant: L, size: e, discount: l })
        ] })
      ]
    }
  );
};
new Date((/* @__PURE__ */ new Date()).setMonth((/* @__PURE__ */ new Date()).getMonth() + 9));
var x4 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var i = "", l = 0; l < arguments.length; l++) {
        var s = arguments[l];
        s && (i = a(i, r(s)));
      }
      return i;
    }
    function r(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return n.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var l = "";
      for (var s in i)
        t.call(i, s) && i[s] && (l = a(l, s));
      return l;
    }
    function a(i, l) {
      return l ? i ? i + " " + l : i + l : i;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(x4);
var Xg = x4.exports;
const h1 = /* @__PURE__ */ $6(Xg);
var L4 = { exports: {} };
(function() {
  var e = { 7: function(r) {
    var a, i = typeof Reflect == "object" ? Reflect : null, l = i && typeof i.apply == "function" ? i.apply : function(L, S, E) {
      return Function.prototype.apply.call(L, S, E);
    };
    a = i && typeof i.ownKeys == "function" ? i.ownKeys : Object.getOwnPropertySymbols ? function(L) {
      return Object.getOwnPropertyNames(L).concat(Object.getOwnPropertySymbols(L));
    } : function(L) {
      return Object.getOwnPropertyNames(L);
    };
    var s = Number.isNaN || function(L) {
      return L != L;
    };
    function c() {
      c.init.call(this);
    }
    r.exports = c, r.exports.once = function(L, S) {
      return new Promise(function(E, j) {
        function g(C) {
          L.removeListener(S, w), j(C);
        }
        function w() {
          typeof L.removeListener == "function" && L.removeListener("error", g), E([].slice.call(arguments));
        }
        T(L, S, w, { once: !0 }), S !== "error" && function(C, b, M) {
          typeof C.on == "function" && T(C, "error", b, { once: !0 });
        }(L, g);
      });
    }, c.EventEmitter = c, c.prototype._events = void 0, c.prototype._eventsCount = 0, c.prototype._maxListeners = void 0;
    var p = 10;
    function h(L) {
      if (typeof L != "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof L);
    }
    function u(L) {
      return L._maxListeners === void 0 ? c.defaultMaxListeners : L._maxListeners;
    }
    function m(L, S, E, j) {
      var g, w, C, b;
      if (h(E), (w = L._events) === void 0 ? (w = L._events = /* @__PURE__ */ Object.create(null), L._eventsCount = 0) : (w.newListener !== void 0 && (L.emit("newListener", S, E.listener ? E.listener : E), w = L._events), C = w[S]), C === void 0) C = w[S] = E, ++L._eventsCount;
      else if (typeof C == "function" ? C = w[S] = j ? [E, C] : [C, E] : j ? C.unshift(E) : C.push(E), (g = u(L)) > 0 && C.length > g && !C.warned) {
        C.warned = !0;
        var M = new Error("Possible EventEmitter memory leak detected. " + C.length + " " + String(S) + " listeners added. Use emitter.setMaxListeners() to increase limit");
        M.name = "MaxListenersExceededWarning", M.emitter = L, M.type = S, M.count = C.length, b = M, console && console.warn && console.warn(b);
      }
      return L;
    }
    function d() {
      if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
    }
    function v(L, S, E) {
      var j = { fired: !1, wrapFn: void 0, target: L, type: S, listener: E }, g = d.bind(j);
      return g.listener = E, j.wrapFn = g, g;
    }
    function x(L, S, E) {
      var j = L._events;
      if (j === void 0) return [];
      var g = j[S];
      return g === void 0 ? [] : typeof g == "function" ? E ? [g.listener || g] : [g] : E ? function(w) {
        for (var C = new Array(w.length), b = 0; b < C.length; ++b) C[b] = w[b].listener || w[b];
        return C;
      }(g) : I(g, g.length);
    }
    function k(L) {
      var S = this._events;
      if (S !== void 0) {
        var E = S[L];
        if (typeof E == "function") return 1;
        if (E !== void 0) return E.length;
      }
      return 0;
    }
    function I(L, S) {
      for (var E = new Array(S), j = 0; j < S; ++j) E[j] = L[j];
      return E;
    }
    function T(L, S, E, j) {
      if (typeof L.on == "function") j.once ? L.once(S, E) : L.on(S, E);
      else {
        if (typeof L.addEventListener != "function") throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof L);
        L.addEventListener(S, function g(w) {
          j.once && L.removeEventListener(S, g), E(w);
        });
      }
    }
    Object.defineProperty(c, "defaultMaxListeners", { enumerable: !0, get: function() {
      return p;
    }, set: function(L) {
      if (typeof L != "number" || L < 0 || s(L)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + L + ".");
      p = L;
    } }), c.init = function() {
      this._events !== void 0 && this._events !== Object.getPrototypeOf(this)._events || (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
    }, c.prototype.setMaxListeners = function(L) {
      if (typeof L != "number" || L < 0 || s(L)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + L + ".");
      return this._maxListeners = L, this;
    }, c.prototype.getMaxListeners = function() {
      return u(this);
    }, c.prototype.emit = function(L) {
      for (var S = [], E = 1; E < arguments.length; E++) S.push(arguments[E]);
      var j = L === "error", g = this._events;
      if (g !== void 0) j = j && g.error === void 0;
      else if (!j) return !1;
      if (j) {
        var w;
        if (S.length > 0 && (w = S[0]), w instanceof Error) throw w;
        var C = new Error("Unhandled error." + (w ? " (" + w.message + ")" : ""));
        throw C.context = w, C;
      }
      var b = g[L];
      if (b === void 0) return !1;
      if (typeof b == "function") l(b, this, S);
      else {
        var M = b.length, R = I(b, M);
        for (E = 0; E < M; ++E) l(R[E], this, S);
      }
      return !0;
    }, c.prototype.addListener = function(L, S) {
      return m(this, L, S, !1);
    }, c.prototype.on = c.prototype.addListener, c.prototype.prependListener = function(L, S) {
      return m(this, L, S, !0);
    }, c.prototype.once = function(L, S) {
      return h(S), this.on(L, v(this, L, S)), this;
    }, c.prototype.prependOnceListener = function(L, S) {
      return h(S), this.prependListener(L, v(this, L, S)), this;
    }, c.prototype.removeListener = function(L, S) {
      var E, j, g, w, C;
      if (h(S), (j = this._events) === void 0) return this;
      if ((E = j[L]) === void 0) return this;
      if (E === S || E.listener === S) --this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete j[L], j.removeListener && this.emit("removeListener", L, E.listener || S));
      else if (typeof E != "function") {
        for (g = -1, w = E.length - 1; w >= 0; w--) if (E[w] === S || E[w].listener === S) {
          C = E[w].listener, g = w;
          break;
        }
        if (g < 0) return this;
        g === 0 ? E.shift() : function(b, M) {
          for (; M + 1 < b.length; M++) b[M] = b[M + 1];
          b.pop();
        }(E, g), E.length === 1 && (j[L] = E[0]), j.removeListener !== void 0 && this.emit("removeListener", L, C || S);
      }
      return this;
    }, c.prototype.off = c.prototype.removeListener, c.prototype.removeAllListeners = function(L) {
      var S, E, j;
      if ((E = this._events) === void 0) return this;
      if (E.removeListener === void 0) return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : E[L] !== void 0 && (--this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete E[L]), this;
      if (arguments.length === 0) {
        var g, w = Object.keys(E);
        for (j = 0; j < w.length; ++j) (g = w[j]) !== "removeListener" && this.removeAllListeners(g);
        return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
      }
      if (typeof (S = E[L]) == "function") this.removeListener(L, S);
      else if (S !== void 0) for (j = S.length - 1; j >= 0; j--) this.removeListener(L, S[j]);
      return this;
    }, c.prototype.listeners = function(L) {
      return x(this, L, !0);
    }, c.prototype.rawListeners = function(L) {
      return x(this, L, !1);
    }, c.listenerCount = function(L, S) {
      return typeof L.listenerCount == "function" ? L.listenerCount(S) : k.call(L, S);
    }, c.prototype.listenerCount = k, c.prototype.eventNames = function() {
      return this._eventsCount > 0 ? a(this._events) : [];
    };
  }, 348: function(r, a) {
    var i, l;
    i = function(s, c) {
      var p = 5e3, h = "callback";
      function u(d) {
        try {
          delete window[d];
        } catch {
          window[d] = void 0;
        }
      }
      function m(d) {
        var v = document.getElementById(d);
        v && document.getElementsByTagName("head")[0].removeChild(v);
      }
      c.exports = function(d) {
        var v = arguments.length <= 1 || arguments[1] === void 0 ? {} : arguments[1], x = d, k = v.timeout || p, I = v.jsonpCallback || h, T = void 0;
        return new Promise(function(L, S) {
          var E = v.jsonpCallbackFunction || "jsonp_" + Date.now() + "_" + Math.ceil(1e5 * Math.random()), j = I + "_" + E;
          window[E] = function(w) {
            L({ ok: !0, json: function() {
              return Promise.resolve(w);
            } }), T && clearTimeout(T), m(j), u(E);
          }, x += x.indexOf("?") === -1 ? "?" : "&";
          var g = document.createElement("script");
          g.setAttribute("src", "" + x + I + "=" + E), v.charset && g.setAttribute("charset", v.charset), v.nonce && g.setAttribute("nonce", v.nonce), v.referrerPolicy && g.setAttribute("referrerPolicy", v.referrerPolicy), v.crossorigin && g.setAttribute("crossorigin", "true"), g.id = j, document.getElementsByTagName("head")[0].appendChild(g), T = setTimeout(function() {
            S(new Error("JSONP request to " + d + " timed out")), u(E), m(j), window[E] = function() {
              u(E);
            };
          }, k), g.onerror = function() {
            S(new Error("JSONP request to " + d + " failed")), u(E), m(j), T && clearTimeout(T);
          };
        });
      };
    }, (l = i.apply(a, [a, r])) === void 0 || (r.exports = l);
  }, 156: function(r, a, i) {
    var l = this && this.__createBinding || (Object.create ? function(c, p, h, u) {
      u === void 0 && (u = h);
      var m = Object.getOwnPropertyDescriptor(p, h);
      m && !("get" in m ? !p.__esModule : m.writable || m.configurable) || (m = { enumerable: !0, get: function() {
        return p[h];
      } }), Object.defineProperty(c, u, m);
    } : function(c, p, h, u) {
      u === void 0 && (u = h), c[u] = p[h];
    }), s = this && this.__exportStar || function(c, p) {
      for (var h in c) h === "default" || Object.prototype.hasOwnProperty.call(p, h) || l(p, c, h);
    };
    Object.defineProperty(a, "__esModule", { value: !0 }), s(i(545), a);
  }, 789: function(r, a, i) {
    var l = this && this.__assign || function() {
      return l = Object.assign || function(g) {
        for (var w, C = 1, b = arguments.length; C < b; C++) for (var M in w = arguments[C]) Object.prototype.hasOwnProperty.call(w, M) && (g[M] = w[M]);
        return g;
      }, l.apply(this, arguments);
    }, s = this && this.__importDefault || function(g) {
      return g && g.__esModule ? g : { default: g };
    };
    Object.defineProperty(a, "__esModule", { value: !0 }), a.default = a.get_csrf_jwt_token = a.Backend = void 0;
    var c, p = s(i(348)), h = i(872);
    function u() {
      return window.CSRF_TOKEN ? window.CSRF_TOKEN : (0, h.getCookie)("csrftoken") || "";
    }
    (function(g) {
      g.get = "GET", g.post = "POST", g.put = "PUT", g.delete = "DELETE", g.patch = "PATCH";
    })(c || (c = {}));
    var m = function(g) {
      g === void 0 && (g = {});
      var w = "";
      Object.keys(g).forEach(function(b) {
        var M = g[b];
        Array.isArray(M) && (M.forEach(function(R) {
          w += "&".concat(b, "=").concat(R);
        }), delete g[b]);
      });
      var C = (0, h.qsStringify)(g);
      return C.length === 0 && w.replace("&", ""), C + w;
    }, d = function(g) {
      return Object.keys(g).forEach(function(w) {
        g[w] == null && delete g[w];
      }), g;
    }, v = function(g, w, C, b, M) {
      w === void 0 && (w = c.get), C === void 0 && (C = {});
      var R = w === c.get, O = w === c.delete, N = C.body, H = C == null ? void 0 : C.signal, Z = N == null ? void 0 : N.isJSON, z = N && N instanceof FormData, K = C.responseType === "blob", D = C.responseType === "arrayBuffer";
      H && delete C.signal;
      var W = C.headers;
      N != null && N.headers && (W = l(l({}, W), N.headers), delete N.headers);
      var q = l({}, (!R || W) && { headers: l(l({}, !z && { "Content-Type": Z ? "application/json" : "application/x-www-form-urlencoded" }), W) });
      return (C = d(C)).body && (C.body = d(C.body)), Z && delete C.body.isJSON, R ? (delete C.headers, Object.keys(C).length > 0 && (g += (g.includes("?") ? "&" : "?") + m(C))) : q.body = z ? N : Z ? JSON.stringify(N) : m(N), fetch(g, l(l({ method: w, credentials: b ? "omit" : "include" }, !!H && { signal: H }), q)).then(function(e1) {
        if (e1.ok) {
          var o1 = e1.headers.get("content-type") || "";
          return M ? { response: e1, encoding: o1.split("charset=")[1] || "utf-8" } : K ? e1.blob() : D ? e1.arrayBuffer() : O ? e1.text() : e1.json();
        }
        return Promise.reject(e1);
      }).catch(function(e1) {
        if (!(H != null && H.aborted)) return Promise.reject(e1);
      });
    }, x = function(g, w, C, b) {
      return v(g, c.get, w, C, b).then(function(M) {
        return M;
      });
    }, k = function(g, w, C) {
      return v(g, c.post, w, C).then(function(b) {
        return b;
      });
    }, I = function(g, w, C) {
      return v(g, c.put, w, C).then(function(b) {
        return b;
      });
    }, T = function(g, w, C) {
      return v(g, c.delete, w, C).then(function(b) {
        return b;
      });
    }, L = !1;
    function S(g, w, C, b) {
      return function(M) {
        M ? M.code === 8018 ? function() {
          if (L) return g(C, b), !1;
          var R = "https://".concat((0, h.getAuthHost)("auth-ac"), "/sdc"), O = "callback" + ((/* @__PURE__ */ new Date()).valueOf() + Math.floor(1e3 * Math.random()));
          (0, p.default)("".concat(R, "?from=").concat((0, h.absoluteUrl)(w)), { timeout: 1e4, jsonpCallback: "JSONP_call", jsonpCallbackFunction: O }).then(function() {
            L = !0, g(C, b);
          }).catch(function(N) {
            b(N), window.location.href = "".concat(R, "?sdc_domain=api.vkplay.ru&continue=").concat(encodeURIComponent(window.location.href));
          });
        }() : C(M) : b();
      };
    }
    var E = { localhost_origin: "https://common-api.gm3.dev-vkplay.ru", set_localhost_origin: function(g) {
      this.localhost_origin = g;
    }, api_get: function(g, w) {
      return g = (0, h.build_api_url)(g, this.localhost_origin), new Promise(function C(b, M) {
        x(g, w).then(S(C, g, b, M)).catch(function(R) {
          return M(R);
        });
      });
    }, get: function(g, w) {
      return new Promise(function C(b, M) {
        x(g, w).then(S(C, g, b, M)).catch(function(R) {
          return M(R);
        });
      });
    }, get_without_cred: function(g, w) {
      return new Promise(function C(b, M) {
        x(g, w, !0).then(S(C, g, b, M)).catch(function(R) {
          return M(R);
        });
      });
    }, api_post: function(g, w) {
      var C = this;
      return j().then(function(b) {
        return g = (0, h.build_api_url)(g, C.localhost_origin), w = l({ csrfmiddlewaretoken: u(), csrfmiddlewaretoken_jwt: b }, w), new Promise(function M(R, O) {
          k(g, { body: w }).then(S(M, g, R, O)).catch(function(N) {
            return O(N);
          });
        });
      });
    }, api_patch: function(g, w) {
      var C = this;
      return j().then(function(b) {
        return g = (0, h.build_api_url)(g, C.localhost_origin), w = l({ csrfmiddlewaretoken: u(), csrfmiddlewaretoken_jwt: b }, w), new Promise(function M(R, O) {
          (function(N, H, Z) {
            return v(N, c.patch, H, Z).then(function(z) {
              return z;
            });
          })(g, { body: w }).then(S(M, g, R, O)).catch(function(N) {
            return O(N);
          });
        });
      });
    }, api_delete: function(g) {
      var w = this;
      return j().then(function() {
        return g = (0, h.build_api_url)(g, w.localhost_origin), new Promise(function C(b, M) {
          T(g).then(S(C, g, b, M)).catch(function(R) {
            return M(R);
          });
        });
      });
    }, delete: function(g) {
      return j().then(function(w) {
        return new Promise(function C(b, M) {
          T(g, { headers: { "X-CSRFToken": u(), "X-JWTCSRFToken": w } }).then(S(C, g, b, M)).catch(function(R) {
            return M(R);
          });
        });
      });
    }, api_put: function(g, w) {
      var C = this;
      return j().then(function(b) {
        return g = (0, h.build_api_url)(g, C.localhost_origin), w = l({ csrfmiddlewaretoken: u(), csrfmiddlewaretoken_jwt: b }, w), new Promise(function M(R, O) {
          I(g, { body: w }).then(S(M, g, R, O)).catch(function(N) {
            return O(N);
          });
        });
      });
    }, remote_api_post: function(g, w) {
      return new Promise(function(C, b) {
        k(g, { body: w }).then(function(M) {
          M ? C(M) : b();
        }).catch(function(M) {
          return b(M);
        });
      });
    }, doc_get: function(g, w) {
      return new Promise(function(C, b) {
        x(g, w, !0, !0).then(function(M) {
          var R = M.response, O = M.encoding;
          O === "utf-8" ? R.text().then(function(N) {
            N ? C(N) : b();
          }) : R.arrayBuffer().then(function(N) {
            if (N) {
              var H = new TextDecoder(O);
              C(H.decode(N));
            } else b();
          });
        }).catch(function(M) {
          return b(M);
        });
      });
    }, simple_post: function(g, w) {
      return new Promise(function(C, b) {
        k(g, { body: w }, !0).then(function(M) {
          M ? C(M) : b();
        }).catch(function(M) {
          return b(M);
        });
      });
    }, remote_api_get: function(g, w) {
      return new Promise(function(C, b) {
        x(g, w).then(function(M) {
          C(M);
        }).catch(function(M) {
          return b(M);
        });
      });
    }, post: function(g, w) {
      return j().then(function(C) {
        return w = l({ csrfmiddlewaretoken: u(), csrfmiddlewaretoken_jwt: C }, w), new Promise(function b(M, R) {
          k(g, { body: w, responseType: w == null ? void 0 : w.responseType }).then(S(b, g, M, R)).catch(function(O) {
            return R(O);
          });
        });
      });
    }, post_formdata: function(g, w, C) {
      var b = C.file, M = C.fileField, R = M === void 0 ? "filedata" : M;
      return j().then(function(O) {
        var N = new FormData();
        for (var H in w = l({ csrfmiddlewaretoken: u(), csrfmiddlewaretoken_jwt: O }, w)) w[H] && N.append("".concat(H), "".concat(w[H]));
        return N.append("".concat(R), b), new Promise(function Z(z, K) {
          k(g, { body: N }).then(S(Z, g, z, K)).catch(function(D) {
            return K(D);
          });
        });
      });
    }, post_real_formdata: function(g, w) {
      return j().then(function(C) {
        return w.append("csrfmiddlewaretoken", u()), w.append("csrfmiddlewaretoken_jwt", C), new Promise(function b(M, R) {
          k(g, { body: w }).then(S(b, g, M, R)).catch(function(O) {
            return R(O);
          });
        });
      });
    }, put: function(g, w) {
      return new Promise(function C(b, M) {
        I(g, w).then(S(C, g, b, M)).catch(function(R) {
          return M(R);
        });
      });
    }, jsonp: function(g, w) {
      var C = w;
      return C = typeof w != "string" ? w ? "?".concat(new URLSearchParams(w).toString()) : "" : w ? "?".concat(C) : "", new Promise(function(b, M) {
        (0, p.default)("".concat(g).concat(C), { timeout: 1e4 }).then(function(R) {
          return R.json();
        }).then(function(R) {
          b(R);
        }).catch(function(R) {
          M(R);
        });
      });
    } };
    function j() {
      var g = window.CSRF_JWT_TOKEN;
      return new Promise(function(w) {
        g ? w(g) : E.api_get("/social/profile/user_token").then(function(C) {
          window.CSRF_JWT_TOKEN = C.token, w(C.token);
        }, function() {
          return w("");
        });
      });
    }
    a.Backend = E, a.default = E, a.get_csrf_jwt_token = j;
  }, 318: function(r, a, i) {
    var l = this && this.__importDefault || function(h) {
      return h && h.__esModule ? h : { default: h };
    };
    Object.defineProperty(a, "__esModule", { value: !0 }), a.default = a.Broadcast = void 0;
    var s = l(i(7)), c = function() {
      var h = (/* @__PURE__ */ new Date()).getTime(), u = {};
      try {
        u = window.localStorage;
      } catch (v) {
        console.error("[broadcast]", v);
      }
      var m = new s.default(), d = function(v) {
        var x, k = (v.key || "").match(/^broadcast_(.*)$/);
        if (k) {
          x = k[1];
          var I = JSON.parse(v.newValue);
          I.sender !== h && m.emit(x, I);
        }
      };
      return { selfId: h, post: function(v, x) {
        x.ts = (/* @__PURE__ */ new Date()).getTime(), x.sender = h, u["broadcast_" + v] = JSON.stringify(x);
      }, on: function(v, x) {
        m.on(v, x);
      }, off: function(v, x) {
        x ? m.removeListener(v, x) : m.removeAllListeners(v);
      }, init: function() {
        try {
          u.setItem("test", "1"), u.removeItem("test");
        } catch {
          u = {};
        }
        window.addEventListener("storage", d, !1);
      } };
    }();
    function p() {
      c.init();
    }
    a.Broadcast = c, a.default = c, document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", function h() {
      p(), document.removeEventListener("DOMContentLoaded", h);
    }) : p();
  }, 747: function(r, a) {
    Object.defineProperty(a, "__esModule", { value: !0 }), a.default = a.HashUtils = void 0;
    var i = { LongMath: { add64: function(l, s) {
      var c, p = { h: l.h + s.h, l: l.l + s.l };
      return c = p.l / 4294967296 >>> 0, p.l = (4294967295 & p.l) >>> 0, p.h = (p.h + c & 4294967295) >>> 0, p;
    }, mul64: function(l, s) {
      var c = this.mul32(l.l, s.l), p = this.mul32(l.h, s.l), h = this.mul32(l.l, s.h);
      return { h: (c.h + p.l + h.l & 4294967295) >>> 0, l: c.l };
    }, mul32: function(l, s) {
      var c = l >> 16 & 65535, p = 65535 & l, h = s >> 16 & 65535, u = 65535 & s, m = p * u, d = c * u, v = p * h, x = (m + (d + v << 16) >>> 0 & 4294967295) >>> 0;
      return { h: c * h + ((m + 65536 * (d + v) - x) / 4294967296 >>> 0), l: x };
    } }, SipHash: /* @__PURE__ */ function() {
      function l(d, v) {
        var x = d.l + v.l, k = { h: d.h + v.h + (x / 2 >>> 31) >>> 0, l: x >>> 0 };
        d.h = k.h, d.l = k.l;
      }
      function s(d, v) {
        d.h ^= v.h, d.h >>>= 0, d.l ^= v.l, d.l >>>= 0;
      }
      function c(d, v) {
        var x = { h: d.h << v | d.l >>> 32 - v, l: d.l << v | d.h >>> 32 - v };
        d.h = x.h, d.l = x.l;
      }
      function p(d) {
        var v = d.l;
        d.l = d.h, d.h = v;
      }
      function h(d, v, x, k) {
        l(d, v), l(x, k), c(v, 13), c(k, 16), s(v, d), s(k, x), p(d), l(x, v), l(d, k), c(v, 17), c(k, 21), s(v, x), s(k, d), p(x);
      }
      function u(d, v) {
        return d.charCodeAt(v + 3) << 24 | d.charCodeAt(v + 2) << 16 | d.charCodeAt(v + 1) << 8 | d.charCodeAt(v);
      }
      function m(d, v) {
        var x, k = { h: d[1] >>> 0, l: d[0] >>> 0 }, I = { h: d[3] >>> 0, l: d[2] >>> 0 }, T = { h: k.h, l: k.l }, L = k, S = { h: I.h, l: I.l }, E = I, j = v.length, g = j - 7, w = new Uint8Array(new ArrayBuffer(8)), C = 0;
        for (s(T, { h: 1936682341, l: 1886610805 }), s(S, { h: 1685025377, l: 1852075885 }), s(L, { h: 1819895653, l: 1852142177 }), s(E, { h: 1952801890, l: 2037671283 }); C < g; ) s(E, x = { h: u(v, C + 4), l: u(v, C) }), h(T, S, L, E), h(T, S, L, E), s(T, x), C += 8;
        w[7] = j;
        for (var b = 0; C < j; ) w[b++] = v.charCodeAt(C++);
        for (; b < 7; ) w[b++] = 0;
        s(E, x = { h: w[7] << 24 | w[6] << 16 | w[5] << 8 | w[4], l: w[3] << 24 | w[2] << 16 | w[1] << 8 | w[0] }), h(T, S, L, E), h(T, S, L, E), s(T, x), s(L, { h: 0, l: 255 }), h(T, S, L, E), h(T, S, L, E), h(T, S, L, E), h(T, S, L, E);
        var M = T;
        return s(M, S), s(M, L), s(M, E), M;
      }
      return { string16_to_key: function(d) {
        return [u(d, 0), u(d, 4), u(d, 8), u(d, 12)];
      }, hash: m, hash_hex: function(d, v) {
        var x = m(d, v);
        return ("0000000" + x.h.toString(16)).substr(-8) + ("0000000" + x.l.toString(16)).substr(-8);
      }, hash_uint: function(d, v) {
        var x = m(d, v);
        return 4294967296 * (2097151 & x.h) + x.l;
      } };
    }(), jumphash: function(l, s) {
      for (var c = { h: 666578662, l: 2276503805 }, p = 0, h = -1; p < s; ) h = p, l = i.LongMath.mul64(l, c), l = i.LongMath.add64(l, { h: 0, l: 1 }), p = Math.floor((h + 1) * (2147483648 / (1 + (l.h >>> 1))));
      return h;
    }, getShard: function(l, s) {
      return i.jumphash(i.SipHash.hash(0, l), s);
    } };
    a.HashUtils = i, a.default = i;
  }, 545: function(r, a, i) {
    var l = this && this.__createBinding || (Object.create ? function(c, p, h, u) {
      u === void 0 && (u = h);
      var m = Object.getOwnPropertyDescriptor(p, h);
      m && !("get" in m ? !p.__esModule : m.writable || m.configurable) || (m = { enumerable: !0, get: function() {
        return p[h];
      } }), Object.defineProperty(c, u, m);
    } : function(c, p, h, u) {
      u === void 0 && (u = h), c[u] = p[h];
    }), s = this && this.__exportStar || function(c, p) {
      for (var h in c) h === "default" || Object.prototype.hasOwnProperty.call(p, h) || l(p, c, h);
    };
    Object.defineProperty(a, "__esModule", { value: !0 }), s(i(287), a), s(i(872), a), s(i(789), a), s(i(318), a), s(i(63), a), s(i(638), a);
  }, 63: function(r, a, i) {
    var l = this && this.__importDefault || function(m) {
      return m && m.__esModule ? m : { default: m };
    };
    Object.defineProperty(a, "__esModule", { value: !0 }), a.default = a.MasterSlave = void 0;
    var s, c = l(i(7)), p = i(318), h = i(872);
    function u() {
      s.init();
    }
    a.MasterSlave = s, a.default = s, h.inGamecenter ? a.default = a.MasterSlave = s = { _master: !1, _events: new c.default(), isMaster: function() {
      return this._master;
    }, on: function(m, d) {
      s._events.on(m, d);
    }, off: function(m, d) {
      d ? s._events.removeListener(m, d) : s._events.removeAllListeners(m);
    }, init: function() {
      s._master = window.location.pathname.search("/gamecenter/chat") === 0 || window.location.pathname.search("/app") === 0, s._events.emit("master");
    } } : a.default = a.MasterSlave = s = { _events: new c.default(), broadcastHandle: null, tryMasterHandle: null, masterId: null, authIdentity: null, debugFlag: !1, _debug: function() {
      for (var m = [], d = 0; d < arguments.length; d++) m[d] = arguments[d];
      s.debugFlag && window.console && window.console.debug.apply(window, m);
    }, _becomeMaster: function() {
      s._debug("become master"), s.masterId = p.Broadcast.selfId, s._sendBroadcast(), s._events.emit("master");
    }, _becomeDeadman: function() {
      s._debug("become deadman"), s.isMaster() && (s.masterId = 0, clearTimeout(s.broadcastHandle), p.Broadcast.post("master_resign", {})), p.Broadcast.off("master_broadcast"), p.Broadcast.off("master_resign"), s._events.emit("deadman");
    }, _sendBroadcast: function() {
      s.isMaster() && (s.isAuthChanged() ? s._becomeDeadman() : (s._debug("master broadcast", p.Broadcast.selfId), clearTimeout(s.broadcastHandle), s.broadcastHandle = setTimeout(s._sendBroadcast, 1200), p.Broadcast.post("master_broadcast", {})));
    }, _tryBecomeMaster: function(m) {
      var d = (m || 0) + Math.round(500 * Math.random());
      s._debug("_tryBecomeMaster", m), clearTimeout(s.tryMasterHandle), s.isAuthChanged() ? s._becomeDeadman() : s.tryMasterHandle = setTimeout(s._becomeMaster, d);
    }, _acceptMaster: function(m) {
      (!s.isMaster() || m.sender < p.Broadcast.selfId) && (s._debug("accept master", m.sender), s.isMaster() && s._events.emit("slave"), s.masterId = m.sender, clearTimeout(s.broadcastHandle), clearTimeout(s.tryMasterHandle), s._tryBecomeMaster(5e3));
    }, isMaster: function() {
      return s.masterId === p.Broadcast.selfId;
    }, isAuthChanged: function() {
      return !!s.authIdentityGetter && s.authIdentity !== s.authIdentityGetter();
    }, on: function(m, d) {
      s._events.on(m, d);
    }, off: function(m, d) {
      d ? s._events.removeListener(m, d) : s._events.removeAllListeners(m);
    }, init: function(m) {
      s.authIdentityGetter = m, m && (s.authIdentity = m()), p.Broadcast.on("master_broadcast", s._acceptMaster), p.Broadcast.on("master_resign", s._tryBecomeMaster), window.addEventListener("unload", s._becomeDeadman, !1), s._tryBecomeMaster(2e3);
    } }, document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", function m() {
      u(), document.removeEventListener("DOMContentLoaded", m);
    }) : u();
  }, 638: function(r, a, i) {
    Object.defineProperty(a, "__esModule", { value: !0 }), a.tmrStopTimespent = a.tmrStartTimespent = a.tmrPushTimespent = a.TimespentEventTypes = a.HostsActivityID = void 0;
    var l, s, c = i(872);
    (function(d) {
      d.GamePage = "68", d.Catalog = "69", d.GOF = "70", d.Community = "71", d.Profile = "72", d.Support = "74";
    })(l = a.HostsActivityID || (a.HostsActivityID = {})), function(d) {
      d.Start = "startForegroundTimespent", d.Stop = "stopTimespent";
    }(s = a.TimespentEventTypes || (a.TimespentEventTypes = {}));
    var p = "3252498", h = "showcase_timespent_started", u = function() {
      try {
        return window.localStorage.getItem(h);
      } catch (d) {
        return console.error("Error getting timespent status:", d), null;
      }
    }, m = function(d) {
      try {
        d ? window.localStorage.setItem(h, d) : window.localStorage.removeItem(h);
      } catch (v) {
        console.error("Error setting timespent:", v);
      }
    };
    a.tmrPushTimespent = function(d, v) {
      var x = window.location, k = x.hostname, I = x.pathname, T = k === (0, c.getGemHost)("store"), L = k === (0, c.getGemHost)("gof"), S = k === (0, c.getGemHost)("community"), E = k === (0, c.getGemHost)("profile"), j = k === (0, c.getGemHost)("support"), g = T && (I.includes("/play/game/") || I.includes("/gamecenter/game")), w = T && I.includes("/play/") && !(I.includes("/play/game/") || I.includes("/play/my/") || I.includes("/play/promo/") || I.includes("/play/market/") || I.includes("/play/code/")), C = g ? l.GamePage : w ? l.Catalog : L ? l.GOF : S ? l.Community : E ? l.Profile : j ? l.Support : "", b = v || C;
      v && v === C || (d === s.Start ? m(b) : m(), b !== "" && ((window._tmr || (window._tmr = [])).push({ id: p, type: d, activity: b }), console.log("⏱ tmr event sent:", d, p, "siteId: ".concat(b))));
    }, a.tmrStartTimespent = function(d) {
      var v = d ? u() : null;
      (0, a.tmrPushTimespent)(s.Start, v);
    }, a.tmrStopTimespent = function() {
      var d = u();
      d && (0, a.tmrPushTimespent)(s.Stop, d);
    };
  }, 872: function(r, a) {
    var i = this && this.__assign || function() {
      return i = Object.assign || function(C) {
        for (var b, M = 1, R = arguments.length; M < R; M++) for (var O in b = arguments[M]) Object.prototype.hasOwnProperty.call(b, O) && (C[O] = b[O]);
        return C;
      }, i.apply(this, arguments);
    };
    Object.defineProperty(a, "__esModule", { value: !0 }), a.isMyGamesEmail = a.isMailRuEmail = a.isMobile = a.isProduction = a.isMacGC = a.isMac = a.isWindows = a.inGamecenter = a.getAuthHost = a.getGemHost = a.hostname_rgx = a.domain_rgx = a.API_DOMAIN = a.DOMAIN = a.isVkPlayMedia = a.isGCUserAgent = a.isChatPage = a.isGm3 = a.isGm2 = a.isAtTest = a.isMyCom = a.isMailRu = a.isDevDomain = a.isGMR = a.isGem = a.isAstrum = a.isMyGames = a.isVkPlay = a.isVkPlayLive = a.isVkPlayRu = a.isDevVkPlay = a.isDevMyGames = a.isDevGem = a.isProductionMode = a.isDevMode = a.STATIC_CDN_DOMAIN = a.VKPLAY_DEV_DOMAIN = a.VKPLAY_LIVE_DOMAIN = a.VKPLAY_DOMAIN = a.SUPPORT_DOMAIN = a.MYCOM_DOMAIN = a.MAILRU_DOMAIN = a.GMR_GM_HOST = a.GMR_GM3_DOMAIN = a.GMR_GM2_DOMAIN = a.GMR_DOMAIN = a.ASTRUM_DOMAIN_RU = a.ASTRUM_DOMAIN = a.MYGAMES_DEV_DOMAIN = a.MYGAMES_DOMAIN = void 0, a.getShortLocale = a.isOpenForWorld = a.calculateAge = a.setScriptTag = a.setLinkTag = a.openGameProfileURL = a.createGCGameURL = a.openUserProfileURL = a.openURL = a.getUserProfileURL = a.decodeEntities = a.allowCloud = a.isCis = a.CIS_REGIONS = a.copyTextToClipboard = a.copyTextToClipboardIE11 = a.createCallLastDecorator = a.createDebounceDecorator = a.createThrottlingDecorator = a.getRandomInt = a.formatPrice = a.formatNumber = a.humanFileSize = a.isValidDate = a.resizePic = a.declineNum = a.qsStringify = a.query_string = a.htmlUnescape = a.htmlEscape = a.setCookie = a.getCookie = a.triggerPixel = a.safeRedirectUrl = a.safeUrl = a.absoluteUrl = a.buildGcHttpUrl = a.getGoogleCID = a.rbClick = a.rbShow = a.openGCUrl = a.build_url = a.build_api_url = a.showSignupBlock = a.showAuthBlock = a.isMyGamesApp = a.Domains = a.getShards = a.origin_by_login = a.isCorpUser = void 0, a.getUserCMPConsent = void 0;
    var l = /^[^@]+@(mail\.ru|xmail\.ru|list\.ru|inbox\.ru|bk\.ru|internet\.ru|corp\.mail\.ru|mail\.ua|vk\.com|vk\.team|vkteam\.ru|vk\.ru|corp\.vk\.ru|corp\.my\.com)$/, s = /^[^@]+@(corp\.mail.ru|corp\.vk\.com|vk\.team|vkteam\.ru)$/, c = /^[^@]+@(my\.games|guestmg(?:0[1-4])?\.pro)$/;
    a.MYGAMES_DOMAIN = "my.games", a.MYGAMES_DEV_DOMAIN = "dev-my.games", a.ASTRUM_DOMAIN = "astrum.top", a.ASTRUM_DOMAIN_RU = "astrum-entertainment.ru", a.GMR_DOMAIN = "games.mail.ru", a.GMR_GM2_DOMAIN = "games.gm2.corp.mail.ru", a.GMR_GM3_DOMAIN = "games.gm3.corp.mail.ru", a.GMR_GM_HOST = window.location.hostname.match(/gm\d/), a.MAILRU_DOMAIN = "mail.ru", a.MYCOM_DOMAIN = "my.com", a.SUPPORT_DOMAIN = "support.my.games", a.VKPLAY_DOMAIN = "vkplay.ru", a.VKPLAY_LIVE_DOMAIN = "vkplay.live", a.VKPLAY_DEV_DOMAIN = "dev-vkplay.ru", a.STATIC_CDN_DOMAIN = "store.mrgcdn.ru", a.isDevMode = function() {
      return !1;
    };
    var p = window.location.hostname === "localhost";
    a.isProductionMode = !0, a.isDevGem = window.location.hostname.endsWith(a.MYGAMES_DEV_DOMAIN) || window.location.hostname.endsWith(a.VKPLAY_DEV_DOMAIN) || p, a.isDevMyGames = window.location.hostname.endsWith(a.MYGAMES_DEV_DOMAIN) || p, a.isDevVkPlay = window.location.hostname.endsWith(a.VKPLAY_DEV_DOMAIN) || p, a.isVkPlayRu = window.location.hostname.endsWith(a.VKPLAY_DOMAIN), a.isVkPlayLive = window.location.hostname.endsWith(a.VKPLAY_LIVE_DOMAIN), a.isVkPlay = a.isVkPlayRu || a.isVkPlayLive || window.isVkp, a.isMyGames = window.location.hostname.endsWith(a.MYGAMES_DOMAIN), a.isAstrum = window.location.hostname.endsWith(a.ASTRUM_DOMAIN) || window.location.hostname.endsWith(a.ASTRUM_DOMAIN_RU), a.isGem = a.isMyGames || a.isVkPlay, a.isGMR = window.location.hostname.endsWith(a.GMR_DOMAIN) || window.location.hostname.endsWith(a.GMR_GM2_DOMAIN) || window.location.hostname.endsWith(a.GMR_GM3_DOMAIN), a.isDevDomain = a.isDevGem && a.isGem, a.isMailRu = window.location.hostname.endsWith(a.MAILRU_DOMAIN), a.isMyCom = window.location.hostname.endsWith(a.MYCOM_DOMAIN), a.isAtTest = T("at_test") === "1", a.isGm2 = location.origin.includes("gm2"), a.isGm3 = location.origin.includes("gm3"), a.isChatPage = location.pathname.includes("/chat"), a.isGCUserAgent = navigator.userAgent.match(/\bDownloader\/\d+\b/);
    var h, u, m = location.pathname.includes("/gamecenter/") || location.search.includes("in_gamecenter=1");
    function d(C) {
      if (window.location.hostname === "localhost") return C === "api" ? "api.dev-vkplay.ru" : window.location.host;
      var b = a.hostname_rgx.exec(window.location.hostname);
      b || (b = window.location.hostname.endsWith("dev-vkplay.ru") ? a.hostname_rgx.exec("store.dev-vkplay.ru") : a.hostname_rgx.exec(a.isMyGames ? a.MYGAMES_DOMAIN : a.VKPLAY_DOMAIN));
      var M = b[1] || "", R = b[3] || "", O = b[4] || "", N = b[5], H = b[3] !== void 0, Z = b[4] !== void 0, z = window.location.hostname.startsWith("catalog"), K = !H && !Z;
      return C === "store" && z && (C = "catalog"), C === "media" && (C = "store"), K && !a.isMyGames && C === "store" ? N : K && !a.isMyGames && C === "chat" ? "chat.".concat(N) : "".concat(M).concat(C, ".").concat(R).concat(O).concat(N);
    }
    function v(C) {
      var b = typeof C == "string" ? C : C == null ? void 0 : C.continueUrl, M = C && typeof C != "string" && C.fromUrl, R = b ? "&continue=".concat(encodeURIComponent(b)) : "";
      a.isMyGamesApp ? messageHandler.postMessage("LOGIN") : a.inGamecenter ? window.gc_show_auth_window && window.gc_show_auth_window() : window.location.href = "https://account.vkplay.ru/login?from=".concat(encodeURIComponent(M || window.location.href)).concat(R);
    }
    function x(C) {
      if (C = C || "/", a.isGem) {
        if (C.indexOf("/profile/") > -1) return "//" + d("profile") + C;
      } else if (window.location.hostname.endsWith("corp.mail.ru")) {
        var b = window.location.hostname.split("."), M = "games.gm2.corp.mail.ru";
        return b[0] === "bonus" || b[0] === "market" ? "//games.mail.ru" + C : "//" + (M = b[0].length === 1 ? b[0] + "." + b[1] + "." + M : b[0] + "." + M) + C;
      }
      return "//games.mail.ru" + C;
    }
    function k(C, b) {
      a.inGamecenter && window.gc_open_url_mainwnd && (b = b || C.target.href) && (C.preventDefault(), b.indexOf("//") === 0 && (b = "https:" + b), window.gc_open_url_mainwnd(b));
    }
    function I(C) {
      return C.startsWith("//") ? C = document.location.protocol + C : /^https?:\/\//i.test(C) || (C = document.location.origin + C), C;
    }
    function T(C) {
      var b = document.cookie.match(new RegExp("(?:^|; )" + C.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
      return b ? decodeURIComponent(b[1]) : void 0;
    }
    function L(C) {
      for (var b = {}, M = (C || window.location.search || "").replace(/^[^?]*\?/, "").split("&"), R = 0; R < M.length; R++) {
        var O = M[R], N = O.indexOf("="), H = decodeURIComponent(O.substr(0, N));
        H && (b[H] = decodeURIComponent(O.substr(N + 1)));
      }
      return b;
    }
    function S(C, b) {
      C === void 0 && (C = {}), b === void 0 && (b = {});
      var M = b.addQueryPrefix, R = M !== void 0 && M;
      return typeof C == "object" ? Object.keys(C).reduce(function(O, N) {
        return C[N] !== void 0 && C[N] !== "" && C[N] !== null && (R && O.length === 0 ? O += "?" : (R && O.length > 0 || O.length > 0) && (O += "&"), O += "".concat(N, "=").concat(encodeURIComponent(C[N]))), O;
      }, "") : "";
    }
    function E(C) {
      return Object.prototype.toString.call(C) === "[object Date]" && !isNaN(C.getTime());
    }
    function j(C, b) {
      var M = b.decimalSignType, R = M === void 0 ? "point" : M, O = b.postfix, N = O === void 0 ? "" : O, H = b.prefix, Z = H === void 0 ? "" : H, z = b.separateThousandsWith, K = C.toString();
      return R === "comma" && (K = K.replace(".", ",")), z && (K = K.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1".concat(z))), "".concat(Z).concat(K).concat(N);
    }
    a.isVkPlayMedia = window.location.hostname.includes("media."), a.DOMAIN = a.isDevMyGames ? a.MYGAMES_DEV_DOMAIN : a.isDevVkPlay ? a.VKPLAY_DEV_DOMAIN : a.isVkPlay ? a.VKPLAY_DOMAIN : a.isMailRu ? a.MAILRU_DOMAIN : a.isMyGames ? a.MYGAMES_DOMAIN : a.isMyCom ? a.MYCOM_DOMAIN : a.isAstrum ? a.ASTRUM_DOMAIN : a.VKPLAY_DOMAIN, a.API_DOMAIN = "api.".concat(a.DOMAIN), a.domain_rgx = new RegExp("^https?://([^/]+.)?".concat(a.DOMAIN)), a.hostname_rgx = new RegExp("^([^.]+-)?(?:([^.-]+).)?((?:gm[123]|test[12]).)?(dev-)?(my.games|vkplay.ru|astrum.top)$"), a.getGemHost = d, a.getAuthHost = function(C) {
      var b = a.hostname_rgx.exec(window.location.hostname);
      b || (b = window.location.hostname.endsWith("dev-vkplay.ru") ? a.hostname_rgx.exec("store.dev-vkplay.ru") : a.hostname_rgx.exec(a.isMyGames ? a.MYGAMES_DOMAIN : a.VKPLAY_DOMAIN));
      var M = b[4] || "", R = b[5];
      return "".concat(C, ".").concat(M).concat(R);
    }, a.inGamecenter = !(window.location.pathname.indexOf("/gamecenter/download") > -1) && (m || a.isGCUserAgent || window.IN_GAMECENTER), a.isWindows = navigator.platform.toLowerCase().indexOf("win") > -1, a.isMac = /Macintosh/i.test(navigator.userAgent), a.isMacGC = a.inGamecenter && a.isMac, a.isProduction = a.isGem && !a.isGm3 && !a.isDevVkPlay || window.location.hostname.endsWith(a.GMR_DOMAIN) || document.domain === "games.my.com", a.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent), a.isMailRuEmail = function(C) {
      return l.test(C);
    }, a.isMyGamesEmail = function(C) {
      return c.test(C);
    }, a.isCorpUser = function(C) {
      return s.test(C);
    }, a.origin_by_login = function(C) {
      return C ? (0, a.isMailRuEmail)(C) ? "mailru" : C.endsWith("@vk") ? "vk" : C.endsWith("@ok") ? "ok" : isNaN(C) ? C.endsWith("@facebook") ? "fb" : C.endsWith("@twitter") ? "tw" : C.endsWith("@discord") ? "ds" : C.endsWith("@google") ? "g" : C.endsWith("@steam") ? "steam" : C.endsWith("@twitch") ? "twitch" : C.endsWith("@hitbox") ? "hitbox" : C.endsWith("@ps") ? "ps" : C.endsWith("@xbox") ? "xbox" : C.endsWith("@apple") ? "apple" : C.endsWith("@eg") ? "eg" : C.endsWith("@pl") ? "pl" : C.endsWith("@ns") ? "ns" : C.endsWith("@astrum") ? "astrum" : C.endsWith("@vkplay") ? "vkplay" : (0, a.isMyGamesEmail)(C) ? "mygames" : C.indexOf("@") > 0 ? "e" : void console.error("unknown origin for login: '".concat(C, "'")) : "p" : "";
    }, a.getShards = function() {
      return a.isGem ? (b = ["ws0.".concat(a.API_DOMAIN)], M = ["ws0.gm2.".concat(a.DOMAIN), "ws1.gm2.".concat(a.DOMAIN)], R = ["ws0.gm3.".concat(a.DOMAIN)], O = ["wss0.".concat(a.API_DOMAIN), "wss1.".concat(a.API_DOMAIN), "wss2.".concat(a.API_DOMAIN), "wss3.".concat(a.API_DOMAIN), "wss4.".concat(a.API_DOMAIN), "wss5.".concat(a.API_DOMAIN)], N = ["eu-ws0.".concat(a.API_DOMAIN), "eu-ws1.".concat(a.API_DOMAIN), "eu-ws2.".concat(a.API_DOMAIN), "eu-ws3.".concat(a.API_DOMAIN), "eu-ws4.".concat(a.API_DOMAIN), "eu-ws5.".concat(a.API_DOMAIN)], a.isDevGem ? a.isGm3 ? R : b : a.isProduction ? a.isMyGames ? N : O : M) : (C = ["ws0.".concat(a.GMR_DOMAIN), "ws1.".concat(a.GMR_DOMAIN), "ws2.".concat(a.GMR_DOMAIN), "ws3.".concat(a.GMR_DOMAIN), "ws4.".concat(a.GMR_DOMAIN), "ws5.".concat(a.GMR_DOMAIN)], a.isProduction ? C : ["ws0.games.gm2.corp.mail.ru", "ws1.games.gm2.corp.mail.ru"]);
      var C, b, M, R, O, N;
    }, a.Domains = { wsd: (0, a.getShards)() }, a.isMyGamesApp = (h = navigator.userAgent, u = L(), h.indexOf("com.my.mygamesapp") > -1 || u.is_mygames_app === "1"), a.showAuthBlock = v, a.showSignupBlock = function(C) {
      v(C);
    }, a.build_api_url = function(C, b) {
      C = C || "/";
      var M = window.location.hostname.replace(/^m([-.])/, "");
      if (M != null && M.endsWith("my.com")) return M != null && M.endsWith("dev.my.com") ? "//api-" + M + C : "//api.games.my.com" + C;
      if (M != null && M.endsWith("corp.mail.ru")) {
        var R = window.location.hostname.split(".")[0];
        return "//".concat(R, "-api.games.").concat(a.GMR_GM_HOST, ".corp.mail.ru").concat(C);
      }
      return M != null && M.endsWith("dev-my.games") ? "//api.dev-my.games".concat(C) : a.isGem ? "//" + d("api") + C : window.location.hostname === "localhost" ? "".concat(b).concat(C) : "//api.games.mail.ru" + C;
    }, a.build_url = x, a.openGCUrl = k, a.rbShow = function(C) {
      C = String(C || "").replace(/^\s*(cl[nb])?/, "").replace(/\s*$/, ""), new Image().src = "//rs.mail.ru/d" + C + ".gif?rnd=" + Math.random();
    }, a.rbClick = function(C) {
      C = String(C || "").replace(/^\s*(cl[nb])?/, "").replace(/\s*$/, ""), new Image().src = "//rs.mail.ru/sb" + C + ".gif?rnd=" + Math.random();
    }, a.getGoogleCID = function(C) {
      C === void 0 && (C = T("_ga"));
      var b = C.match(/(\d+\.\d+)$/);
      return b ? b[1] : void 0;
    }, a.buildGcHttpUrl = function(C) {
      return C === void 0 && (C = ""), "mailrugames://urlhttps/games.mail.ru" + C;
    }, a.absoluteUrl = I, a.safeUrl = function(C) {
      return C && ((C = I(C)).search(a.domain_rgx) === 0 || C.startsWith(window.location.origin)) ? C : "";
    }, a.safeRedirectUrl = function(C) {
      if (!/^[\w\-]+:\/\/([\w\-]+\.)*[\w\-]+(:\d+)?(\/.*)?$/.test(C)) throw new Error("unsafe redirect url: ".concat(C));
      return C;
    }, a.triggerPixel = function(C) {
      var b, M;
      if (C && C !== "") {
        var R = C.indexOf("?") > -1 ? "&rnd=" : "?rnd=", O = window.gem_cookiebot_loaded;
        (!O || O && (!((M = (b = window.Cookiebot) === null || b === void 0 ? void 0 : b.consent) === null || M === void 0) && M.statistics)) && (new Image().src = C + R + Math.random());
      }
    }, a.getCookie = T, a.setCookie = function(C, b, M) {
      M === void 0 && (M = {});
      var R = (M = M || {}).expires;
      if (typeof R == "number" && R) {
        var O = /* @__PURE__ */ new Date();
        O.setTime(O.getTime() + 1e3 * R), R = M.expires = O;
      }
      R && R.toUTCString && (M.expires = R.toUTCString());
      var N = C + "=" + (b = encodeURIComponent(b));
      for (var H in M) if (M[H]) {
        var Z = M[H];
        N += "; " + H, Z !== !0 && (N += "=" + Z);
      }
      document.cookie = N;
    }, a.htmlEscape = function(C) {
      return C === void 0 && (C = ""), C ? C.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\//g, "&#x2F;") : "";
    }, a.htmlUnescape = function(C) {
      return C === void 0 && (C = ""), C ? C.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&apos;/g, "'").replace(/&#x27;/g, "'").replace(/&lt;/g, "<").replace(/&#60;/g, "<").replace(/&gt;/g, ">").replace(/&#62;/g, ">").replace(/&#x2F;/g, "/").replace(/&amp;/g, "&") : "";
    }, a.query_string = L, a.qsStringify = S, a.declineNum = function(C, b, M, R) {
      var O;
      return C % 100 == 11 || C % 100 == 12 || C % 100 == 13 || C % 100 == 14 ? O = R : C % 10 == 1 ? O = b : C % 10 >= 2 && C % 10 <= 4 ? O = M : (C % 10 == 0 || C % 10 >= 5 && C % 10 <= 9) && (O = R), O;
    }, a.resizePic = function(C, b) {
      var M;
      b === void 0 && (b = {});
      var R = b.method || "crop", O = b.quality, N = O === void 0 ? 85 : O, H = b.format, Z = b.blur, z = b.feather, K = b.color, D = S(i(i(i(i(i({}, !isNaN(N) && N < 100 && { quality: N }), H && { format: H }), Z && { feather_blur: Z }), z && { feather: z }), K && { feather_color: K }));
      if (M = b && (b.width || b.height) ? b.width + "x" + b.height : "big2", C) return ((C += D.length > 0 ? (C.includes("?") ? "&" : "?") + D : "").includes("/hotbox/") || C.includes("/pic/")) && (C = C.replace("https://".concat(a.VKPLAY_DOMAIN, "/"), "https://".concat(a.STATIC_CDN_DOMAIN, "/"))), C.includes("/hotbox/") ? C = C.replace("/hotbox/", "/pre_".concat(M, "_").concat(R, "/hotbox/")) : C.includes("/pic/") && (C = C.replace("/pic/", "/pre_".concat(M, "_").concat(R, "/pic/"))), C;
    }, a.isValidDate = E, a.humanFileSize = function(C, b, M) {
      b === void 0 && (b = {});
      var R = 0;
      if (b) {
        for (var O = M ? 1e3 : 1024; C > 1e3; ) C /= O, R++;
        return C.toFixed(1) + " " + b[R];
      }
    }, a.formatNumber = j;
    var g, w = { USD: { separateThousandsWith: " ", prefix: "$" }, EUR: { separateThousandsWith: " ", prefix: "€" }, RUB: { separateThousandsWith: " ", decimalSignType: "comma", postfix: " ₽" } };
    a.formatPrice = function(C, b) {
      return w[b] ? j(C, w[b]) : null;
    }, a.getRandomInt = function(C, b) {
      return C = Math.ceil(C), b = Math.floor(b), Math.floor(Math.random() * (b - C + 1)) + C;
    }, a.createThrottlingDecorator = function(C, b) {
      b === void 0 && (b = 1e3);
      var M, R, O = !1;
      return function N() {
        for (var H = [], Z = 0; Z < arguments.length; Z++) H[Z] = arguments[Z];
        if (O) return M = H, void (R = this);
        C.apply(void 0, H), O = !0, setTimeout(function() {
          O = !1, M && (N.apply(R, M), M = R = null);
        }, b);
      };
    }, a.createDebounceDecorator = function(C, b) {
      b === void 0 && (b = 1e3);
      var M = !1;
      return function() {
        for (var R = [], O = 0; O < arguments.length; O++) R[O] = arguments[O];
        M || (C.apply(void 0, R), M = !0, setTimeout(function() {
          return M = !1;
        }, b));
      };
    }, a.createCallLastDecorator = function(C, b) {
      b === void 0 && (b = 1e3);
      var M = null;
      return function() {
        for (var R = [], O = 0; O < arguments.length; O++) R[O] = arguments[O];
        M && clearTimeout(M), M = setTimeout(function() {
          return C.apply(void 0, R);
        }, b);
      };
    }, a.copyTextToClipboardIE11 = function(C, b) {
      var M = document.createElement("textarea");
      M.value = C, M.style.top = "0", M.style.left = "0", M.style.opacity = "0", M.style.position = "fixed", document.body.appendChild(M), M.select(), M.setSelectionRange(0, 99999), document.execCommand("copy"), b && b(), document.body.removeChild(M);
    }, a.copyTextToClipboard = function(C, b) {
      window.gc_clipboard_copy ? (window.gc_clipboard_copy(C), b && b()) : navigator.clipboard ? navigator.clipboard.writeText(C).then(b).catch(function() {
        return (0, a.copyTextToClipboardIE11)(C, b);
      }) : (0, a.copyTextToClipboardIE11)(C, b);
    }, a.CIS_REGIONS = ["398", "219", "215", "201", "29", "28", "34", "191", "188", "17", "33", "16", "196", "467"], a.isCis = function() {
      return a.CIS_REGIONS.includes(window.country_id);
    }, a.allowCloud = function(C) {
      C === void 0 && (C = {});
      var b = C.login && (0, a.isCorpUser)(C.login), M = a.CIS_REGIONS.includes(window.country_id);
      return b || M;
    }, a.decodeEntities = (g = document.createElement("div"), function(C) {
      C === void 0 && (C = "");
      var b = C;
      return b = (b = (b = b.replace(/<br\s*[\/]?>/gi, `
`)).replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, "")).replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, ""), g.innerHTML = b, b = g.textContent, g.textContent = "", b;
    }), a.getUserProfileURL = function(C) {
      return x("".concat(a.inGamecenter && !a.isGem ? "/gamecenter" : "", "/profile/").concat(C));
    }, a.openURL = function(C, b) {
      a.inGamecenter ? k(C, b) : window.open(b, "_blank", "noopener,noreferrer");
    }, a.openUserProfileURL = function(C, b) {
      var M = (0, a.getUserProfileURL)(b);
      (0, a.openURL)(C, M);
    }, a.createGCGameURL = function(C) {
      return "mailrugames://show/".concat(C);
    }, a.openGameProfileURL = function(C, b) {
      a.inGamecenter ? k(C, (0, a.createGCGameURL)(b.gc_id)) : (0, a.openURL)(C, b.url);
    }, a.setLinkTag = function(C) {
      return new Promise(function(b, M) {
        var R = document.createElement("link");
        R.type = "text/css", R.rel = "stylesheet", R.href = C, R.onload = function() {
          return b();
        }, R.onerror = function() {
          return M();
        }, document.head.appendChild(R);
      });
    }, a.setScriptTag = function(C) {
      var b = C.src, M = C.inlineScript, R = C.onload, O = C.data, N = C.async, H = C.prepend, Z = C.id, z = C.setToHead, K = document.createElement("script"), D = z ? document.head : document.body;
      if (K.type = "text/javascript", K.onload = R, !Z || (K.id = Z, !document.getElementById(Z))) {
        if (b && (K.src = b), N && (K.async = !0), O && Object.keys(O).map(function(q) {
          K.setAttribute(["data-".concat(q)], O[q]);
        }), M) {
          var W = document.createTextNode(M);
          K.appendChild(W);
        }
        H ? D.prepend(K) : D.appendChild(K);
      }
    }, a.calculateAge = function(C) {
      C === void 0 && (C = "");
      var b = new Date(C);
      if (!E(b)) return console.warn("Age calculation error: invalid date"), null;
      var M = /* @__PURE__ */ new Date(), R = M.getMonth() - b.getMonth(), O = M.getFullYear() - b.getFullYear();
      return (R < 0 || R === 0 && M.getDate() < b.getDate()) && O--, O;
    }, a.isOpenForWorld = function(C) {
      var b = ["188", "201"].includes(C);
      return !(!C || b);
    }, a.getShortLocale = function(C) {
      C === void 0 && (C = "ru_RU");
      var b = a.isMyGames ? "en" : "ru", M = C.replace("-", "_"), R = M.split("_")[0];
      return ["zh_CN", "zh_TW", "pt_BR"].includes(M) && (R = M.split("_")[1].toLowerCase()), R != null ? R : b;
    }, a.getUserCMPConsent = function() {
      var C, b, M, R;
      if (!window.__cmp) return !0;
      var O = (C = window.__cmp("consentStatus")) === null || C === void 0 ? void 0 : C.consentExists, N = (b = window.__cmp("consentStatus")) === null || b === void 0 ? void 0 : b.userChoiceExists, H = (R = (M = window.__cmp("getCMPData")) === null || M === void 0 ? void 0 : M.purposeConsents) === null || R === void 0 ? void 0 : R.c52;
      return !!(O && N && H);
    };
  }, 287: function(r, a, i) {
    var l = this && this.__importDefault || function(m) {
      return m && m.__esModule ? m : { default: m };
    };
    Object.defineProperty(a, "__esModule", { value: !0 }), a.default = a.WSD = void 0;
    var s = l(i(7)), c = i(747), p = i(63), h = i(318), u = { id: null, properShardNumber: NaN, CODE_CID_DUP: 4001, CODE_RESHARD: 4002, CODE_NO_AUTH: 4003, socket: null, reconnectHandle: null, errorTimeout: 2e3, minErrorTimeout: 2e3, maxErrorTimeout: 3e5, minPageReloadInterval: 36e5, reopens: 0, opened: !1, events: new s.default(), _log: function() {
      for (var m, d = [], v = 0; v < arguments.length; v++) d[v] = arguments[v];
      window.console && (m = window.console).log.apply(m, d);
    }, _debug: function() {
      for (var m, d = [], v = 0; v < arguments.length; v++) d[v] = arguments[v];
      window.console && (m = window.console).debug.apply(m, d);
    }, _error: function() {
      for (var m, d = [], v = 0; v < arguments.length; v++) d[v] = arguments[v];
      window.console && (m = window.console).error.apply(m, d);
    }, on: function(m, d) {
      u.events.on(m, d);
    }, off: function(m, d) {
      d ? u.events.removeListener(m, d) : u.events.removeAllListeners(m);
    }, getShard: function() {
      var m;
      return m = isNaN(u.properShardNumber) ? c.HashUtils.getShard(String(u.id), u.shards.length) : u.properShardNumber, u.shards[m];
    }, getCid: function() {
      var m = window.localStorage.getItem("ws_cid");
      return m || (m = String(Math.round(4294967295 * Math.random())), window.localStorage.setItem("ws_cid", m)), m;
    }, getUrl: function() {
      var m = u.getShard(), d = u.getCid();
      return ((window.location.protocol || "").match("^https") ? "wss" : "ws") + "://" + m + "?cid=" + encodeURIComponent(d);
    }, onWebsocketOpen: function(m) {
      u._debug("[ws] opened", m), u.emitOpen(), h.Broadcast.post("ws", { type: "open" });
    }, onWebsocketClose: function(m) {
      if (u._debug("[ws] closed", "code:", m.code, "reason:", m.reason, "wasClean:", m.wasClean), u.emitClose(), h.Broadcast.post("ws", { type: "close" }), u.socket = null, m.wasClean) switch (m.code) {
        case u.CODE_CID_DUP:
          window.localStorage.removeItem("ws_cid"), u.reconnect();
          break;
        case u.CODE_RESHARD:
          var d = parseInt(m.reason);
          if (u._debug("[ws] reshard", "new:", d, "prev:", u.properShardNumber), !isNaN(d)) if (isNaN(u.properShardNumber)) u.properShardNumber = d, u.reconnect();
          else {
            var v = parseInt(window.localStorage.getItem("ws_last_reload_ts")), x = (/* @__PURE__ */ new Date()).getTime();
            (!v || x - v > u.minPageReloadInterval) && u.pageReload();
          }
          break;
        case u.CODE_NO_AUTH:
          window.gc_renew_cookie && window.gc_renew_cookie(), document.body.className += " no_auth", u.reconnect(!0);
          break;
        default:
          return void (u.errorTimeout = u.minErrorTimeout);
      }
      else u.reconnect(!0);
    }, onWebsocketMessage: function(m) {
      var d = m.data;
      u.emitMessage(d), h.Broadcast.post("ws", { type: "message", message: d });
    }, onCrossTabMessage: function(m) {
      switch (m.type) {
        case "message":
          u.emitMessage(m.message);
          break;
        case "open":
          u.emitOpen();
          break;
        case "close":
          u.emitClose();
          break;
        default:
          u._error("unknown broadcast message", m);
      }
    }, emitMessage: function(m) {
      m = JSON.parse(m), u._debug("[ws] message", m), u.events.emit("message", m);
    }, emitOpen: function() {
      u.events.emit("open", u.reopens), u.reopens += 1, u.opened = !0;
    }, emitClose: function() {
      u.events.emit("close"), u.opened = !1;
    }, isOpened: function() {
      return u.opened;
    }, pageReload: function() {
      var m = (/* @__PURE__ */ new Date()).getTime();
      window.localStorage.setItem("ws_last_reload_ts", String(m)), window.location.reload();
    }, connect: function() {
      clearTimeout(u.reconnectHandle), u.socket && (u.socket.close(), u.socket = null);
      try {
        u.socket = new WebSocket(u.getUrl()), u.socket.onopen = function(m) {
          u.onWebsocketOpen(m);
        }, u.socket.onclose = function(m) {
          u.onWebsocketClose(m);
        }, u.socket.onerror = function(m) {
          u._error("[ws] error", m);
        }, u.socket.onmessage = function(m) {
          u.onWebsocketMessage(m);
        };
      } catch (m) {
        u._error("[ws] error", m);
      }
    }, reconnect: function(m) {
      if (clearTimeout(u.reconnectHandle), m) {
        u.errorTimeout === u.maxErrorTimeout && u.pageReload(), u.errorTimeout = Math.min(u.maxErrorTimeout, 2 * u.errorTimeout);
        var d = Math.round(u.errorTimeout * (0.75 + Math.random() / 2));
        u.reconnectHandle = setTimeout(u.connect, d);
      } else u.reconnectHandle = setTimeout(u.connect);
    }, disconnect: function() {
      clearTimeout(u.reconnectHandle), u.socket && (u.socket.onopen = null, u.socket.onclose = null, u.socket.onerror = null, u.socket.onmessage = null, u.socket.close(), u.socket = null);
    }, becomeMaster: function() {
      u._debug("[ws] is master"), h.Broadcast.off("ws", u.onCrossTabMessage), u.connect();
    }, becomeSlave: function() {
      u._debug("[ws] is slave"), u.disconnect(), h.Broadcast.on("ws", u.onCrossTabMessage);
    }, becomeDeadman: function() {
      u._debug("[ws] is deadman"), u.disconnect(), h.Broadcast.off("ws", u.onCrossTabMessage);
    }, init: function(m, d) {
      window.WebSocket && m ? (u.id = m, u.shards = d, p.MasterSlave.on("master", u.becomeMaster), p.MasterSlave.on("slave", u.becomeSlave), p.MasterSlave.on("deadman", u.becomeDeadman), p.MasterSlave.isMaster() ? u.becomeMaster() : u.becomeSlave()) : u._error("[ws] is not inited, id=", m);
    } };
    a.WSD = u, a.default = u;
  } }, t = {}, n = function r(a) {
    var i = t[a];
    if (i !== void 0) return i.exports;
    var l = t[a] = { exports: {} };
    return e[a].call(l.exports, l, l.exports, r), l.exports;
  }(156);
  L4.exports = n;
})();
var J = L4.exports, ci = function(e, t) {
  return ci = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (n[a] = r[a]);
  }, ci(e, t);
};
function St(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  ci(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var S1 = function() {
  return S1 = Object.assign || function(t) {
    for (var n, r = 1, a = arguments.length; r < a; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, S1.apply(this, arguments);
};
function rr(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
}
function ft(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, a = t.length, i; r < a; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function ut(e, t) {
  var n = t && t.cache ? t.cache : av, r = t && t.serializer ? t.serializer : rv, a = t && t.strategy ? t.strategy : tv;
  return a(e, {
    cache: n,
    serializer: r
  });
}
function Jg(e) {
  return e == null || typeof e == "number" || typeof e == "boolean";
}
function ev(e, t, n, r) {
  var a = Jg(r) ? r : n(r), i = t.get(a);
  return typeof i == "undefined" && (i = e.call(this, r), t.set(a, i)), i;
}
function E4(e, t, n) {
  var r = Array.prototype.slice.call(arguments, 3), a = n(r), i = t.get(a);
  return typeof i == "undefined" && (i = e.apply(this, r), t.set(a, i)), i;
}
function M4(e, t, n, r, a) {
  return n.bind(t, e, r, a);
}
function tv(e, t) {
  var n = e.length === 1 ? ev : E4;
  return M4(e, this, n, t.cache.create(), t.serializer);
}
function nv(e, t) {
  return M4(e, this, E4, t.cache.create(), t.serializer);
}
var rv = function() {
  return JSON.stringify(arguments);
};
function ao() {
  this.cache = /* @__PURE__ */ Object.create(null);
}
ao.prototype.get = function(e) {
  return this.cache[e];
};
ao.prototype.set = function(e, t) {
  this.cache[e] = t;
};
var av = {
  create: function() {
    return new ao();
  }
}, dt = {
  variadic: nv
};
function k4(e, t, n) {
  if (n === void 0 && (n = Error), !e)
    throw new n(t);
}
ut(function() {
  for (var e, t = [], n = 0; n < arguments.length; n++)
    t[n] = arguments[n];
  return new ((e = Intl.NumberFormat).bind.apply(e, ft([void 0], t, !1)))();
}, {
  strategy: dt.variadic
});
ut(function() {
  for (var e, t = [], n = 0; n < arguments.length; n++)
    t[n] = arguments[n];
  return new ((e = Intl.DateTimeFormat).bind.apply(e, ft([void 0], t, !1)))();
}, {
  strategy: dt.variadic
});
ut(function() {
  for (var e, t = [], n = 0; n < arguments.length; n++)
    t[n] = arguments[n];
  return new ((e = Intl.PluralRules).bind.apply(e, ft([void 0], t, !1)))();
}, {
  strategy: dt.variadic
});
ut(function() {
  for (var e, t = [], n = 0; n < arguments.length; n++)
    t[n] = arguments[n];
  return new ((e = Intl.Locale).bind.apply(e, ft([void 0], t, !1)))();
}, {
  strategy: dt.variadic
});
ut(function() {
  for (var e, t = [], n = 0; n < arguments.length; n++)
    t[n] = arguments[n];
  return new ((e = Intl.ListFormat).bind.apply(e, ft([void 0], t, !1)))();
}, {
  strategy: dt.variadic
});
var ee;
(function(e) {
  e[e.EXPECT_ARGUMENT_CLOSING_BRACE = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE", e[e.EMPTY_ARGUMENT = 2] = "EMPTY_ARGUMENT", e[e.MALFORMED_ARGUMENT = 3] = "MALFORMED_ARGUMENT", e[e.EXPECT_ARGUMENT_TYPE = 4] = "EXPECT_ARGUMENT_TYPE", e[e.INVALID_ARGUMENT_TYPE = 5] = "INVALID_ARGUMENT_TYPE", e[e.EXPECT_ARGUMENT_STYLE = 6] = "EXPECT_ARGUMENT_STYLE", e[e.INVALID_NUMBER_SKELETON = 7] = "INVALID_NUMBER_SKELETON", e[e.INVALID_DATE_TIME_SKELETON = 8] = "INVALID_DATE_TIME_SKELETON", e[e.EXPECT_NUMBER_SKELETON = 9] = "EXPECT_NUMBER_SKELETON", e[e.EXPECT_DATE_TIME_SKELETON = 10] = "EXPECT_DATE_TIME_SKELETON", e[e.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE", e[e.EXPECT_SELECT_ARGUMENT_OPTIONS = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS", e[e.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT", e[e.INVALID_PLURAL_ARGUMENT_SELECTOR = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_PLURAL_ARGUMENT_SELECTOR = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_SELECT_ARGUMENT_SELECTOR = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR", e[e.MISSING_OTHER_CLAUSE = 22] = "MISSING_OTHER_CLAUSE", e[e.INVALID_TAG = 23] = "INVALID_TAG", e[e.INVALID_TAG_NAME = 25] = "INVALID_TAG_NAME", e[e.UNMATCHED_CLOSING_TAG = 26] = "UNMATCHED_CLOSING_TAG", e[e.UNCLOSED_TAG = 27] = "UNCLOSED_TAG";
})(ee || (ee = {}));
var Te;
(function(e) {
  e[e.literal = 0] = "literal", e[e.argument = 1] = "argument", e[e.number = 2] = "number", e[e.date = 3] = "date", e[e.time = 4] = "time", e[e.select = 5] = "select", e[e.plural = 6] = "plural", e[e.pound = 7] = "pound", e[e.tag = 8] = "tag";
})(Te || (Te = {}));
var ar;
(function(e) {
  e[e.number = 0] = "number", e[e.dateTime = 1] = "dateTime";
})(ar || (ar = {}));
function m3(e) {
  return e.type === Te.literal;
}
function iv(e) {
  return e.type === Te.argument;
}
function S4(e) {
  return e.type === Te.number;
}
function A4(e) {
  return e.type === Te.date;
}
function T4(e) {
  return e.type === Te.time;
}
function I4(e) {
  return e.type === Te.select;
}
function R4(e) {
  return e.type === Te.plural;
}
function ov(e) {
  return e.type === Te.pound;
}
function N4(e) {
  return e.type === Te.tag;
}
function H4(e) {
  return !!(e && typeof e == "object" && e.type === ar.number);
}
function ui(e) {
  return !!(e && typeof e == "object" && e.type === ar.dateTime);
}
var O4 = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/, sv = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function lv(e) {
  var t = {};
  return e.replace(sv, function(n) {
    var r = n.length;
    switch (n[0]) {
      case "G":
        t.era = r === 4 ? "long" : r === 5 ? "narrow" : "short";
        break;
      case "y":
        t.year = r === 2 ? "2-digit" : "numeric";
        break;
      case "Y":
      case "u":
      case "U":
      case "r":
        throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
      case "q":
      case "Q":
        throw new RangeError("`q/Q` (quarter) patterns are not supported");
      case "M":
      case "L":
        t.month = ["numeric", "2-digit", "short", "long", "narrow"][r - 1];
        break;
      case "w":
      case "W":
        throw new RangeError("`w/W` (week) patterns are not supported");
      case "d":
        t.day = ["numeric", "2-digit"][r - 1];
        break;
      case "D":
      case "F":
      case "g":
        throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
      case "E":
        t.weekday = r === 4 ? "long" : r === 5 ? "narrow" : "short";
        break;
      case "e":
        if (r < 4)
          throw new RangeError("`e..eee` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][r - 4];
        break;
      case "c":
        if (r < 4)
          throw new RangeError("`c..ccc` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][r - 4];
        break;
      case "a":
        t.hour12 = !0;
        break;
      case "b":
      case "B":
        throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
      case "h":
        t.hourCycle = "h12", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "H":
        t.hourCycle = "h23", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "K":
        t.hourCycle = "h11", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "k":
        t.hourCycle = "h24", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "j":
      case "J":
      case "C":
        throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
      case "m":
        t.minute = ["numeric", "2-digit"][r - 1];
        break;
      case "s":
        t.second = ["numeric", "2-digit"][r - 1];
        break;
      case "S":
      case "A":
        throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
      case "z":
        t.timeZoneName = r < 4 ? "short" : "long";
        break;
      case "Z":
      case "O":
      case "v":
      case "V":
      case "X":
      case "x":
        throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
    }
    return "";
  }), t;
}
var cv = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
function uv(e) {
  if (e.length === 0)
    throw new Error("Number skeleton cannot be empty");
  for (var t = e.split(cv).filter(function(m) {
    return m.length > 0;
  }), n = [], r = 0, a = t; r < a.length; r++) {
    var i = a[r], l = i.split("/");
    if (l.length === 0)
      throw new Error("Invalid number skeleton");
    for (var s = l[0], c = l.slice(1), p = 0, h = c; p < h.length; p++) {
      var u = h[p];
      if (u.length === 0)
        throw new Error("Invalid number skeleton");
    }
    n.push({ stem: s, options: c });
  }
  return n;
}
function dv(e) {
  return e.replace(/^(.*?)-/, "");
}
var C3 = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g, j4 = /^(@+)?(\+|#+)?[rs]?$/g, fv = /(\*)(0+)|(#+)(0+)|(0+)/g, P4 = /^(0+)$/;
function g3(e) {
  var t = {};
  return e[e.length - 1] === "r" ? t.roundingPriority = "morePrecision" : e[e.length - 1] === "s" && (t.roundingPriority = "lessPrecision"), e.replace(j4, function(n, r, a) {
    return typeof a != "string" ? (t.minimumSignificantDigits = r.length, t.maximumSignificantDigits = r.length) : a === "+" ? t.minimumSignificantDigits = r.length : r[0] === "#" ? t.maximumSignificantDigits = r.length : (t.minimumSignificantDigits = r.length, t.maximumSignificantDigits = r.length + (typeof a == "string" ? a.length : 0)), "";
  }), t;
}
function D4(e) {
  switch (e) {
    case "sign-auto":
      return {
        signDisplay: "auto"
      };
    case "sign-accounting":
    case "()":
      return {
        currencySign: "accounting"
      };
    case "sign-always":
    case "+!":
      return {
        signDisplay: "always"
      };
    case "sign-accounting-always":
    case "()!":
      return {
        signDisplay: "always",
        currencySign: "accounting"
      };
    case "sign-except-zero":
    case "+?":
      return {
        signDisplay: "exceptZero"
      };
    case "sign-accounting-except-zero":
    case "()?":
      return {
        signDisplay: "exceptZero",
        currencySign: "accounting"
      };
    case "sign-never":
    case "+_":
      return {
        signDisplay: "never"
      };
  }
}
function hv(e) {
  var t;
  if (e[0] === "E" && e[1] === "E" ? (t = {
    notation: "engineering"
  }, e = e.slice(2)) : e[0] === "E" && (t = {
    notation: "scientific"
  }, e = e.slice(1)), t) {
    var n = e.slice(0, 2);
    if (n === "+!" ? (t.signDisplay = "always", e = e.slice(2)) : n === "+?" && (t.signDisplay = "exceptZero", e = e.slice(2)), !P4.test(e))
      throw new Error("Malformed concise eng/scientific notation");
    t.minimumIntegerDigits = e.length;
  }
  return t;
}
function v3(e) {
  var t = {}, n = D4(e);
  return n || t;
}
function pv(e) {
  for (var t = {}, n = 0, r = e; n < r.length; n++) {
    var a = r[n];
    switch (a.stem) {
      case "percent":
      case "%":
        t.style = "percent";
        continue;
      case "%x100":
        t.style = "percent", t.scale = 100;
        continue;
      case "currency":
        t.style = "currency", t.currency = a.options[0];
        continue;
      case "group-off":
      case ",_":
        t.useGrouping = !1;
        continue;
      case "precision-integer":
      case ".":
        t.maximumFractionDigits = 0;
        continue;
      case "measure-unit":
      case "unit":
        t.style = "unit", t.unit = dv(a.options[0]);
        continue;
      case "compact-short":
      case "K":
        t.notation = "compact", t.compactDisplay = "short";
        continue;
      case "compact-long":
      case "KK":
        t.notation = "compact", t.compactDisplay = "long";
        continue;
      case "scientific":
        t = S1(S1(S1({}, t), { notation: "scientific" }), a.options.reduce(function(c, p) {
          return S1(S1({}, c), v3(p));
        }, {}));
        continue;
      case "engineering":
        t = S1(S1(S1({}, t), { notation: "engineering" }), a.options.reduce(function(c, p) {
          return S1(S1({}, c), v3(p));
        }, {}));
        continue;
      case "notation-simple":
        t.notation = "standard";
        continue;
      case "unit-width-narrow":
        t.currencyDisplay = "narrowSymbol", t.unitDisplay = "narrow";
        continue;
      case "unit-width-short":
        t.currencyDisplay = "code", t.unitDisplay = "short";
        continue;
      case "unit-width-full-name":
        t.currencyDisplay = "name", t.unitDisplay = "long";
        continue;
      case "unit-width-iso-code":
        t.currencyDisplay = "symbol";
        continue;
      case "scale":
        t.scale = parseFloat(a.options[0]);
        continue;
      case "rounding-mode-floor":
        t.roundingMode = "floor";
        continue;
      case "rounding-mode-ceiling":
        t.roundingMode = "ceil";
        continue;
      case "rounding-mode-down":
        t.roundingMode = "trunc";
        continue;
      case "rounding-mode-up":
        t.roundingMode = "expand";
        continue;
      case "rounding-mode-half-even":
        t.roundingMode = "halfEven";
        continue;
      case "rounding-mode-half-down":
        t.roundingMode = "halfTrunc";
        continue;
      case "rounding-mode-half-up":
        t.roundingMode = "halfExpand";
        continue;
      case "integer-width":
        if (a.options.length > 1)
          throw new RangeError("integer-width stems only accept a single optional option");
        a.options[0].replace(fv, function(c, p, h, u, m, d) {
          if (p)
            t.minimumIntegerDigits = h.length;
          else {
            if (u && m)
              throw new Error("We currently do not support maximum integer digits");
            if (d)
              throw new Error("We currently do not support exact integer digits");
          }
          return "";
        });
        continue;
    }
    if (P4.test(a.stem)) {
      t.minimumIntegerDigits = a.stem.length;
      continue;
    }
    if (C3.test(a.stem)) {
      if (a.options.length > 1)
        throw new RangeError("Fraction-precision stems only accept a single optional option");
      a.stem.replace(C3, function(c, p, h, u, m, d) {
        return h === "*" ? t.minimumFractionDigits = p.length : u && u[0] === "#" ? t.maximumFractionDigits = u.length : m && d ? (t.minimumFractionDigits = m.length, t.maximumFractionDigits = m.length + d.length) : (t.minimumFractionDigits = p.length, t.maximumFractionDigits = p.length), "";
      });
      var i = a.options[0];
      i === "w" ? t = S1(S1({}, t), { trailingZeroDisplay: "stripIfInteger" }) : i && (t = S1(S1({}, t), g3(i)));
      continue;
    }
    if (j4.test(a.stem)) {
      t = S1(S1({}, t), g3(a.stem));
      continue;
    }
    var l = D4(a.stem);
    l && (t = S1(S1({}, t), l));
    var s = hv(a.stem);
    s && (t = S1(S1({}, t), s));
  }
  return t;
}
var i0 = {
  "001": [
    "H",
    "h"
  ],
  AC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AD: [
    "H",
    "hB"
  ],
  AE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  AF: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  AG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AL: [
    "h",
    "H",
    "hB"
  ],
  AM: [
    "H",
    "hB"
  ],
  AO: [
    "H",
    "hB"
  ],
  AR: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  AS: [
    "h",
    "H"
  ],
  AT: [
    "H",
    "hB"
  ],
  AU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AW: [
    "H",
    "hB"
  ],
  AX: [
    "H"
  ],
  AZ: [
    "H",
    "hB",
    "h"
  ],
  BA: [
    "H",
    "hB",
    "h"
  ],
  BB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BD: [
    "h",
    "hB",
    "H"
  ],
  BE: [
    "H",
    "hB"
  ],
  BF: [
    "H",
    "hB"
  ],
  BG: [
    "H",
    "hB",
    "h"
  ],
  BH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  BI: [
    "H",
    "h"
  ],
  BJ: [
    "H",
    "hB"
  ],
  BL: [
    "H",
    "hB"
  ],
  BM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BN: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  BO: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  BQ: [
    "H"
  ],
  BR: [
    "H",
    "hB"
  ],
  BS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BT: [
    "h",
    "H"
  ],
  BW: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  BY: [
    "H",
    "h"
  ],
  BZ: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CA: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  CC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CD: [
    "hB",
    "H"
  ],
  CF: [
    "H",
    "h",
    "hB"
  ],
  CG: [
    "H",
    "hB"
  ],
  CH: [
    "H",
    "hB",
    "h"
  ],
  CI: [
    "H",
    "hB"
  ],
  CK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CL: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CM: [
    "H",
    "h",
    "hB"
  ],
  CN: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  CO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  CP: [
    "H"
  ],
  CR: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CU: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CV: [
    "H",
    "hB"
  ],
  CW: [
    "H",
    "hB"
  ],
  CX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CY: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  CZ: [
    "H"
  ],
  DE: [
    "H",
    "hB"
  ],
  DG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  DJ: [
    "h",
    "H"
  ],
  DK: [
    "H"
  ],
  DM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  DO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  DZ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  EC: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  EE: [
    "H",
    "hB"
  ],
  EG: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  ER: [
    "h",
    "H"
  ],
  ES: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  ET: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  FI: [
    "H"
  ],
  FJ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  FM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FO: [
    "H",
    "h"
  ],
  FR: [
    "H",
    "hB"
  ],
  GA: [
    "H",
    "hB"
  ],
  GB: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GD: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GE: [
    "H",
    "hB",
    "h"
  ],
  GF: [
    "H",
    "hB"
  ],
  GG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GH: [
    "h",
    "H"
  ],
  GI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GL: [
    "H",
    "h"
  ],
  GM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GN: [
    "H",
    "hB"
  ],
  GP: [
    "H",
    "hB"
  ],
  GQ: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  GR: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  GT: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  GU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GW: [
    "H",
    "hB"
  ],
  GY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  HK: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  HN: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  HR: [
    "H",
    "hB"
  ],
  HU: [
    "H",
    "h"
  ],
  IC: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  ID: [
    "H"
  ],
  IE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IL: [
    "H",
    "hB"
  ],
  IM: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IN: [
    "h",
    "H"
  ],
  IO: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IQ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  IR: [
    "hB",
    "H"
  ],
  IS: [
    "H"
  ],
  IT: [
    "H",
    "hB"
  ],
  JE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  JM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  JO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  JP: [
    "H",
    "K",
    "h"
  ],
  KE: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  KG: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KH: [
    "hB",
    "h",
    "H",
    "hb"
  ],
  KI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KM: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KN: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KP: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KW: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  KY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KZ: [
    "H",
    "hB"
  ],
  LA: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  LB: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  LC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LI: [
    "H",
    "hB",
    "h"
  ],
  LK: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  LR: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LS: [
    "h",
    "H"
  ],
  LT: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  LU: [
    "H",
    "h",
    "hB"
  ],
  LV: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  LY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  MC: [
    "H",
    "hB"
  ],
  MD: [
    "H",
    "hB"
  ],
  ME: [
    "H",
    "hB",
    "h"
  ],
  MF: [
    "H",
    "hB"
  ],
  MG: [
    "H",
    "h"
  ],
  MH: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ML: [
    "H"
  ],
  MM: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  MN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MP: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MQ: [
    "H",
    "hB"
  ],
  MR: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MS: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MT: [
    "H",
    "h"
  ],
  MU: [
    "H",
    "h"
  ],
  MV: [
    "H",
    "h"
  ],
  MW: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MX: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  MY: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  MZ: [
    "H",
    "hB"
  ],
  NA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  NC: [
    "H",
    "hB"
  ],
  NE: [
    "H"
  ],
  NF: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NI: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  NL: [
    "H",
    "hB"
  ],
  NO: [
    "H",
    "h"
  ],
  NP: [
    "H",
    "h",
    "hB"
  ],
  NR: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NU: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  OM: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PE: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  PF: [
    "H",
    "h",
    "hB"
  ],
  PG: [
    "h",
    "H"
  ],
  PH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PK: [
    "h",
    "hB",
    "H"
  ],
  PL: [
    "H",
    "h"
  ],
  PM: [
    "H",
    "hB"
  ],
  PN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  PR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PS: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PT: [
    "H",
    "hB"
  ],
  PW: [
    "h",
    "H"
  ],
  PY: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  QA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  RE: [
    "H",
    "hB"
  ],
  RO: [
    "H",
    "hB"
  ],
  RS: [
    "H",
    "hB",
    "h"
  ],
  RU: [
    "H"
  ],
  RW: [
    "H",
    "h"
  ],
  SA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SC: [
    "H",
    "h",
    "hB"
  ],
  SD: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SE: [
    "H"
  ],
  SG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SH: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SI: [
    "H",
    "hB"
  ],
  SJ: [
    "H"
  ],
  SK: [
    "H"
  ],
  SL: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SM: [
    "H",
    "h",
    "hB"
  ],
  SN: [
    "H",
    "h",
    "hB"
  ],
  SO: [
    "h",
    "H"
  ],
  SR: [
    "H",
    "hB"
  ],
  SS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ST: [
    "H",
    "hB"
  ],
  SV: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  SX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  TC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TD: [
    "h",
    "H",
    "hB"
  ],
  TF: [
    "H",
    "h",
    "hB"
  ],
  TG: [
    "H",
    "hB"
  ],
  TH: [
    "H",
    "h"
  ],
  TJ: [
    "H",
    "h"
  ],
  TL: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  TM: [
    "H",
    "h"
  ],
  TN: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  TO: [
    "h",
    "H"
  ],
  TR: [
    "H",
    "hB"
  ],
  TT: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TW: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  TZ: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UA: [
    "H",
    "hB",
    "h"
  ],
  UG: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  US: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  UY: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  UZ: [
    "H",
    "hB",
    "h"
  ],
  VA: [
    "H",
    "h",
    "hB"
  ],
  VC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VE: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  VG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VN: [
    "H",
    "h"
  ],
  VU: [
    "h",
    "H"
  ],
  WF: [
    "H",
    "hB"
  ],
  WS: [
    "h",
    "H"
  ],
  XK: [
    "H",
    "hB",
    "h"
  ],
  YE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  YT: [
    "H",
    "hB"
  ],
  ZA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ZM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ZW: [
    "H",
    "h"
  ],
  "af-ZA": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "ar-001": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "ca-ES": [
    "H",
    "h",
    "hB"
  ],
  "en-001": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "es-BO": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-BR": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-EC": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-ES": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-GQ": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-PE": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "fr-CA": [
    "H",
    "h",
    "hB"
  ],
  "gl-ES": [
    "H",
    "h",
    "hB"
  ],
  "gu-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "hi-IN": [
    "hB",
    "h",
    "H"
  ],
  "it-CH": [
    "H",
    "h",
    "hB"
  ],
  "it-IT": [
    "H",
    "h",
    "hB"
  ],
  "kn-IN": [
    "hB",
    "h",
    "H"
  ],
  "ml-IN": [
    "hB",
    "h",
    "H"
  ],
  "mr-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "pa-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "ta-IN": [
    "hB",
    "h",
    "hb",
    "H"
  ],
  "te-IN": [
    "hB",
    "h",
    "H"
  ],
  "zu-ZA": [
    "H",
    "hB",
    "hb",
    "h"
  ]
};
function mv(e, t) {
  for (var n = "", r = 0; r < e.length; r++) {
    var a = e.charAt(r);
    if (a === "j") {
      for (var i = 0; r + 1 < e.length && e.charAt(r + 1) === a; )
        i++, r++;
      var l = 1 + (i & 1), s = i < 2 ? 1 : 3 + (i >> 1), c = "a", p = Cv(t);
      for ((p == "H" || p == "k") && (s = 0); s-- > 0; )
        n += c;
      for (; l-- > 0; )
        n = p + n;
    } else a === "J" ? n += "H" : n += a;
  }
  return n;
}
function Cv(e) {
  var t = e.hourCycle;
  if (t === void 0 && // @ts-ignore hourCycle(s) is not identified yet
  e.hourCycles && // @ts-ignore
  e.hourCycles.length && (t = e.hourCycles[0]), t)
    switch (t) {
      case "h24":
        return "k";
      case "h23":
        return "H";
      case "h12":
        return "h";
      case "h11":
        return "K";
      default:
        throw new Error("Invalid hourCycle");
    }
  var n = e.language, r;
  n !== "root" && (r = e.maximize().region);
  var a = i0[r || ""] || i0[n || ""] || i0["".concat(n, "-001")] || i0["001"];
  return a[0];
}
var La, gv = new RegExp("^".concat(O4.source, "*")), vv = new RegExp("".concat(O4.source, "*$"));
function re(e, t) {
  return { start: e, end: t };
}
var wv = !!String.prototype.startsWith && "_a".startsWith("a", 1), yv = !!String.fromCodePoint, bv = !!Object.fromEntries, _v = !!String.prototype.codePointAt, xv = !!String.prototype.trimStart, Lv = !!String.prototype.trimEnd, Ev = !!Number.isSafeInteger, Mv = Ev ? Number.isSafeInteger : function(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e && Math.abs(e) <= 9007199254740991;
}, di = !0;
try {
  var kv = B4("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  di = ((La = kv.exec("a")) === null || La === void 0 ? void 0 : La[0]) === "a";
} catch {
  di = !1;
}
var w3 = wv ? (
  // Native
  function(t, n, r) {
    return t.startsWith(n, r);
  }
) : (
  // For IE11
  function(t, n, r) {
    return t.slice(r, r + n.length) === n;
  }
), fi = yv ? String.fromCodePoint : (
  // IE11
  function() {
    for (var t = [], n = 0; n < arguments.length; n++)
      t[n] = arguments[n];
    for (var r = "", a = t.length, i = 0, l; a > i; ) {
      if (l = t[i++], l > 1114111)
        throw RangeError(l + " is not a valid code point");
      r += l < 65536 ? String.fromCharCode(l) : String.fromCharCode(((l -= 65536) >> 10) + 55296, l % 1024 + 56320);
    }
    return r;
  }
), y3 = (
  // native
  bv ? Object.fromEntries : (
    // Ponyfill
    function(t) {
      for (var n = {}, r = 0, a = t; r < a.length; r++) {
        var i = a[r], l = i[0], s = i[1];
        n[l] = s;
      }
      return n;
    }
  )
), V4 = _v ? (
  // Native
  function(t, n) {
    return t.codePointAt(n);
  }
) : (
  // IE 11
  function(t, n) {
    var r = t.length;
    if (!(n < 0 || n >= r)) {
      var a = t.charCodeAt(n), i;
      return a < 55296 || a > 56319 || n + 1 === r || (i = t.charCodeAt(n + 1)) < 56320 || i > 57343 ? a : (a - 55296 << 10) + (i - 56320) + 65536;
    }
  }
), Sv = xv ? (
  // Native
  function(t) {
    return t.trimStart();
  }
) : (
  // Ponyfill
  function(t) {
    return t.replace(gv, "");
  }
), Av = Lv ? (
  // Native
  function(t) {
    return t.trimEnd();
  }
) : (
  // Ponyfill
  function(t) {
    return t.replace(vv, "");
  }
);
function B4(e, t) {
  return new RegExp(e, t);
}
var hi;
if (di) {
  var b3 = B4("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  hi = function(t, n) {
    var r;
    b3.lastIndex = n;
    var a = b3.exec(t);
    return (r = a[1]) !== null && r !== void 0 ? r : "";
  };
} else
  hi = function(t, n) {
    for (var r = []; ; ) {
      var a = V4(t, n);
      if (a === void 0 || F4(a) || Nv(a))
        break;
      r.push(a), n += a >= 65536 ? 2 : 1;
    }
    return fi.apply(void 0, r);
  };
var Tv = (
  /** @class */
  function() {
    function e(t, n) {
      n === void 0 && (n = {}), this.message = t, this.position = { offset: 0, line: 1, column: 1 }, this.ignoreTag = !!n.ignoreTag, this.locale = n.locale, this.requiresOtherClause = !!n.requiresOtherClause, this.shouldParseSkeletons = !!n.shouldParseSkeletons;
    }
    return e.prototype.parse = function() {
      if (this.offset() !== 0)
        throw Error("parser can only be used once");
      return this.parseMessage(0, "", !1);
    }, e.prototype.parseMessage = function(t, n, r) {
      for (var a = []; !this.isEOF(); ) {
        var i = this.char();
        if (i === 123) {
          var l = this.parseArgument(t, r);
          if (l.err)
            return l;
          a.push(l.val);
        } else {
          if (i === 125 && t > 0)
            break;
          if (i === 35 && (n === "plural" || n === "selectordinal")) {
            var s = this.clonePosition();
            this.bump(), a.push({
              type: Te.pound,
              location: re(s, this.clonePosition())
            });
          } else if (i === 60 && !this.ignoreTag && this.peek() === 47) {
            if (r)
              break;
            return this.error(ee.UNMATCHED_CLOSING_TAG, re(this.clonePosition(), this.clonePosition()));
          } else if (i === 60 && !this.ignoreTag && pi(this.peek() || 0)) {
            var l = this.parseTag(t, n);
            if (l.err)
              return l;
            a.push(l.val);
          } else {
            var l = this.parseLiteral(t, n);
            if (l.err)
              return l;
            a.push(l.val);
          }
        }
      }
      return { val: a, err: null };
    }, e.prototype.parseTag = function(t, n) {
      var r = this.clonePosition();
      this.bump();
      var a = this.parseTagName();
      if (this.bumpSpace(), this.bumpIf("/>"))
        return {
          val: {
            type: Te.literal,
            value: "<".concat(a, "/>"),
            location: re(r, this.clonePosition())
          },
          err: null
        };
      if (this.bumpIf(">")) {
        var i = this.parseMessage(t + 1, n, !0);
        if (i.err)
          return i;
        var l = i.val, s = this.clonePosition();
        if (this.bumpIf("</")) {
          if (this.isEOF() || !pi(this.char()))
            return this.error(ee.INVALID_TAG, re(s, this.clonePosition()));
          var c = this.clonePosition(), p = this.parseTagName();
          return a !== p ? this.error(ee.UNMATCHED_CLOSING_TAG, re(c, this.clonePosition())) : (this.bumpSpace(), this.bumpIf(">") ? {
            val: {
              type: Te.tag,
              value: a,
              children: l,
              location: re(r, this.clonePosition())
            },
            err: null
          } : this.error(ee.INVALID_TAG, re(s, this.clonePosition())));
        } else
          return this.error(ee.UNCLOSED_TAG, re(r, this.clonePosition()));
      } else
        return this.error(ee.INVALID_TAG, re(r, this.clonePosition()));
    }, e.prototype.parseTagName = function() {
      var t = this.offset();
      for (this.bump(); !this.isEOF() && Rv(this.char()); )
        this.bump();
      return this.message.slice(t, this.offset());
    }, e.prototype.parseLiteral = function(t, n) {
      for (var r = this.clonePosition(), a = ""; ; ) {
        var i = this.tryParseQuote(n);
        if (i) {
          a += i;
          continue;
        }
        var l = this.tryParseUnquoted(t, n);
        if (l) {
          a += l;
          continue;
        }
        var s = this.tryParseLeftAngleBracket();
        if (s) {
          a += s;
          continue;
        }
        break;
      }
      var c = re(r, this.clonePosition());
      return {
        val: { type: Te.literal, value: a, location: c },
        err: null
      };
    }, e.prototype.tryParseLeftAngleBracket = function() {
      return !this.isEOF() && this.char() === 60 && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
      !Iv(this.peek() || 0)) ? (this.bump(), "<") : null;
    }, e.prototype.tryParseQuote = function(t) {
      if (this.isEOF() || this.char() !== 39)
        return null;
      switch (this.peek()) {
        case 39:
          return this.bump(), this.bump(), "'";
        case 123:
        case 60:
        case 62:
        case 125:
          break;
        case 35:
          if (t === "plural" || t === "selectordinal")
            break;
          return null;
        default:
          return null;
      }
      this.bump();
      var n = [this.char()];
      for (this.bump(); !this.isEOF(); ) {
        var r = this.char();
        if (r === 39)
          if (this.peek() === 39)
            n.push(39), this.bump();
          else {
            this.bump();
            break;
          }
        else
          n.push(r);
        this.bump();
      }
      return fi.apply(void 0, n);
    }, e.prototype.tryParseUnquoted = function(t, n) {
      if (this.isEOF())
        return null;
      var r = this.char();
      return r === 60 || r === 123 || r === 35 && (n === "plural" || n === "selectordinal") || r === 125 && t > 0 ? null : (this.bump(), fi(r));
    }, e.prototype.parseArgument = function(t, n) {
      var r = this.clonePosition();
      if (this.bump(), this.bumpSpace(), this.isEOF())
        return this.error(ee.EXPECT_ARGUMENT_CLOSING_BRACE, re(r, this.clonePosition()));
      if (this.char() === 125)
        return this.bump(), this.error(ee.EMPTY_ARGUMENT, re(r, this.clonePosition()));
      var a = this.parseIdentifierIfPossible().value;
      if (!a)
        return this.error(ee.MALFORMED_ARGUMENT, re(r, this.clonePosition()));
      if (this.bumpSpace(), this.isEOF())
        return this.error(ee.EXPECT_ARGUMENT_CLOSING_BRACE, re(r, this.clonePosition()));
      switch (this.char()) {
        case 125:
          return this.bump(), {
            val: {
              type: Te.argument,
              // value does not include the opening and closing braces.
              value: a,
              location: re(r, this.clonePosition())
            },
            err: null
          };
        case 44:
          return this.bump(), this.bumpSpace(), this.isEOF() ? this.error(ee.EXPECT_ARGUMENT_CLOSING_BRACE, re(r, this.clonePosition())) : this.parseArgumentOptions(t, n, a, r);
        default:
          return this.error(ee.MALFORMED_ARGUMENT, re(r, this.clonePosition()));
      }
    }, e.prototype.parseIdentifierIfPossible = function() {
      var t = this.clonePosition(), n = this.offset(), r = hi(this.message, n), a = n + r.length;
      this.bumpTo(a);
      var i = this.clonePosition(), l = re(t, i);
      return { value: r, location: l };
    }, e.prototype.parseArgumentOptions = function(t, n, r, a) {
      var i, l = this.clonePosition(), s = this.parseIdentifierIfPossible().value, c = this.clonePosition();
      switch (s) {
        case "":
          return this.error(ee.EXPECT_ARGUMENT_TYPE, re(l, c));
        case "number":
        case "date":
        case "time": {
          this.bumpSpace();
          var p = null;
          if (this.bumpIf(",")) {
            this.bumpSpace();
            var h = this.clonePosition(), u = this.parseSimpleArgStyleIfPossible();
            if (u.err)
              return u;
            var m = Av(u.val);
            if (m.length === 0)
              return this.error(ee.EXPECT_ARGUMENT_STYLE, re(this.clonePosition(), this.clonePosition()));
            var d = re(h, this.clonePosition());
            p = { style: m, styleLocation: d };
          }
          var v = this.tryParseArgumentClose(a);
          if (v.err)
            return v;
          var x = re(a, this.clonePosition());
          if (p && w3(p == null ? void 0 : p.style, "::", 0)) {
            var k = Sv(p.style.slice(2));
            if (s === "number") {
              var u = this.parseNumberSkeletonFromString(k, p.styleLocation);
              return u.err ? u : {
                val: { type: Te.number, value: r, location: x, style: u.val },
                err: null
              };
            } else {
              if (k.length === 0)
                return this.error(ee.EXPECT_DATE_TIME_SKELETON, x);
              var I = k;
              this.locale && (I = mv(k, this.locale));
              var m = {
                type: ar.dateTime,
                pattern: I,
                location: p.styleLocation,
                parsedOptions: this.shouldParseSkeletons ? lv(I) : {}
              }, T = s === "date" ? Te.date : Te.time;
              return {
                val: { type: T, value: r, location: x, style: m },
                err: null
              };
            }
          }
          return {
            val: {
              type: s === "number" ? Te.number : s === "date" ? Te.date : Te.time,
              value: r,
              location: x,
              style: (i = p == null ? void 0 : p.style) !== null && i !== void 0 ? i : null
            },
            err: null
          };
        }
        case "plural":
        case "selectordinal":
        case "select": {
          var L = this.clonePosition();
          if (this.bumpSpace(), !this.bumpIf(","))
            return this.error(ee.EXPECT_SELECT_ARGUMENT_OPTIONS, re(L, S1({}, L)));
          this.bumpSpace();
          var S = this.parseIdentifierIfPossible(), E = 0;
          if (s !== "select" && S.value === "offset") {
            if (!this.bumpIf(":"))
              return this.error(ee.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, re(this.clonePosition(), this.clonePosition()));
            this.bumpSpace();
            var u = this.tryParseDecimalInteger(ee.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, ee.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
            if (u.err)
              return u;
            this.bumpSpace(), S = this.parseIdentifierIfPossible(), E = u.val;
          }
          var j = this.tryParsePluralOrSelectOptions(t, s, n, S);
          if (j.err)
            return j;
          var v = this.tryParseArgumentClose(a);
          if (v.err)
            return v;
          var g = re(a, this.clonePosition());
          return s === "select" ? {
            val: {
              type: Te.select,
              value: r,
              options: y3(j.val),
              location: g
            },
            err: null
          } : {
            val: {
              type: Te.plural,
              value: r,
              options: y3(j.val),
              offset: E,
              pluralType: s === "plural" ? "cardinal" : "ordinal",
              location: g
            },
            err: null
          };
        }
        default:
          return this.error(ee.INVALID_ARGUMENT_TYPE, re(l, c));
      }
    }, e.prototype.tryParseArgumentClose = function(t) {
      return this.isEOF() || this.char() !== 125 ? this.error(ee.EXPECT_ARGUMENT_CLOSING_BRACE, re(t, this.clonePosition())) : (this.bump(), { val: !0, err: null });
    }, e.prototype.parseSimpleArgStyleIfPossible = function() {
      for (var t = 0, n = this.clonePosition(); !this.isEOF(); ) {
        var r = this.char();
        switch (r) {
          case 39: {
            this.bump();
            var a = this.clonePosition();
            if (!this.bumpUntil("'"))
              return this.error(ee.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, re(a, this.clonePosition()));
            this.bump();
            break;
          }
          case 123: {
            t += 1, this.bump();
            break;
          }
          case 125: {
            if (t > 0)
              t -= 1;
            else
              return {
                val: this.message.slice(n.offset, this.offset()),
                err: null
              };
            break;
          }
          default:
            this.bump();
            break;
        }
      }
      return {
        val: this.message.slice(n.offset, this.offset()),
        err: null
      };
    }, e.prototype.parseNumberSkeletonFromString = function(t, n) {
      var r = [];
      try {
        r = uv(t);
      } catch {
        return this.error(ee.INVALID_NUMBER_SKELETON, n);
      }
      return {
        val: {
          type: ar.number,
          tokens: r,
          location: n,
          parsedOptions: this.shouldParseSkeletons ? pv(r) : {}
        },
        err: null
      };
    }, e.prototype.tryParsePluralOrSelectOptions = function(t, n, r, a) {
      for (var i, l = !1, s = [], c = /* @__PURE__ */ new Set(), p = a.value, h = a.location; ; ) {
        if (p.length === 0) {
          var u = this.clonePosition();
          if (n !== "select" && this.bumpIf("=")) {
            var m = this.tryParseDecimalInteger(ee.EXPECT_PLURAL_ARGUMENT_SELECTOR, ee.INVALID_PLURAL_ARGUMENT_SELECTOR);
            if (m.err)
              return m;
            h = re(u, this.clonePosition()), p = this.message.slice(u.offset, this.offset());
          } else
            break;
        }
        if (c.has(p))
          return this.error(n === "select" ? ee.DUPLICATE_SELECT_ARGUMENT_SELECTOR : ee.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, h);
        p === "other" && (l = !0), this.bumpSpace();
        var d = this.clonePosition();
        if (!this.bumpIf("{"))
          return this.error(n === "select" ? ee.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : ee.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, re(this.clonePosition(), this.clonePosition()));
        var v = this.parseMessage(t + 1, n, r);
        if (v.err)
          return v;
        var x = this.tryParseArgumentClose(d);
        if (x.err)
          return x;
        s.push([
          p,
          {
            value: v.val,
            location: re(d, this.clonePosition())
          }
        ]), c.add(p), this.bumpSpace(), i = this.parseIdentifierIfPossible(), p = i.value, h = i.location;
      }
      return s.length === 0 ? this.error(n === "select" ? ee.EXPECT_SELECT_ARGUMENT_SELECTOR : ee.EXPECT_PLURAL_ARGUMENT_SELECTOR, re(this.clonePosition(), this.clonePosition())) : this.requiresOtherClause && !l ? this.error(ee.MISSING_OTHER_CLAUSE, re(this.clonePosition(), this.clonePosition())) : { val: s, err: null };
    }, e.prototype.tryParseDecimalInteger = function(t, n) {
      var r = 1, a = this.clonePosition();
      this.bumpIf("+") || this.bumpIf("-") && (r = -1);
      for (var i = !1, l = 0; !this.isEOF(); ) {
        var s = this.char();
        if (s >= 48 && s <= 57)
          i = !0, l = l * 10 + (s - 48), this.bump();
        else
          break;
      }
      var c = re(a, this.clonePosition());
      return i ? (l *= r, Mv(l) ? { val: l, err: null } : this.error(n, c)) : this.error(t, c);
    }, e.prototype.offset = function() {
      return this.position.offset;
    }, e.prototype.isEOF = function() {
      return this.offset() === this.message.length;
    }, e.prototype.clonePosition = function() {
      return {
        offset: this.position.offset,
        line: this.position.line,
        column: this.position.column
      };
    }, e.prototype.char = function() {
      var t = this.position.offset;
      if (t >= this.message.length)
        throw Error("out of bound");
      var n = V4(this.message, t);
      if (n === void 0)
        throw Error("Offset ".concat(t, " is at invalid UTF-16 code unit boundary"));
      return n;
    }, e.prototype.error = function(t, n) {
      return {
        val: null,
        err: {
          kind: t,
          message: this.message,
          location: n
        }
      };
    }, e.prototype.bump = function() {
      if (!this.isEOF()) {
        var t = this.char();
        t === 10 ? (this.position.line += 1, this.position.column = 1, this.position.offset += 1) : (this.position.column += 1, this.position.offset += t < 65536 ? 1 : 2);
      }
    }, e.prototype.bumpIf = function(t) {
      if (w3(this.message, t, this.offset())) {
        for (var n = 0; n < t.length; n++)
          this.bump();
        return !0;
      }
      return !1;
    }, e.prototype.bumpUntil = function(t) {
      var n = this.offset(), r = this.message.indexOf(t, n);
      return r >= 0 ? (this.bumpTo(r), !0) : (this.bumpTo(this.message.length), !1);
    }, e.prototype.bumpTo = function(t) {
      if (this.offset() > t)
        throw Error("targetOffset ".concat(t, " must be greater than or equal to the current offset ").concat(this.offset()));
      for (t = Math.min(t, this.message.length); ; ) {
        var n = this.offset();
        if (n === t)
          break;
        if (n > t)
          throw Error("targetOffset ".concat(t, " is at invalid UTF-16 code unit boundary"));
        if (this.bump(), this.isEOF())
          break;
      }
    }, e.prototype.bumpSpace = function() {
      for (; !this.isEOF() && F4(this.char()); )
        this.bump();
    }, e.prototype.peek = function() {
      if (this.isEOF())
        return null;
      var t = this.char(), n = this.offset(), r = this.message.charCodeAt(n + (t >= 65536 ? 2 : 1));
      return r != null ? r : null;
    }, e;
  }()
);
function pi(e) {
  return e >= 97 && e <= 122 || e >= 65 && e <= 90;
}
function Iv(e) {
  return pi(e) || e === 47;
}
function Rv(e) {
  return e === 45 || e === 46 || e >= 48 && e <= 57 || e === 95 || e >= 97 && e <= 122 || e >= 65 && e <= 90 || e == 183 || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 893 || e >= 895 && e <= 8191 || e >= 8204 && e <= 8205 || e >= 8255 && e <= 8256 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
}
function F4(e) {
  return e >= 9 && e <= 13 || e === 32 || e === 133 || e >= 8206 && e <= 8207 || e === 8232 || e === 8233;
}
function Nv(e) {
  return e >= 33 && e <= 35 || e === 36 || e >= 37 && e <= 39 || e === 40 || e === 41 || e === 42 || e === 43 || e === 44 || e === 45 || e >= 46 && e <= 47 || e >= 58 && e <= 59 || e >= 60 && e <= 62 || e >= 63 && e <= 64 || e === 91 || e === 92 || e === 93 || e === 94 || e === 96 || e === 123 || e === 124 || e === 125 || e === 126 || e === 161 || e >= 162 && e <= 165 || e === 166 || e === 167 || e === 169 || e === 171 || e === 172 || e === 174 || e === 176 || e === 177 || e === 182 || e === 187 || e === 191 || e === 215 || e === 247 || e >= 8208 && e <= 8213 || e >= 8214 && e <= 8215 || e === 8216 || e === 8217 || e === 8218 || e >= 8219 && e <= 8220 || e === 8221 || e === 8222 || e === 8223 || e >= 8224 && e <= 8231 || e >= 8240 && e <= 8248 || e === 8249 || e === 8250 || e >= 8251 && e <= 8254 || e >= 8257 && e <= 8259 || e === 8260 || e === 8261 || e === 8262 || e >= 8263 && e <= 8273 || e === 8274 || e === 8275 || e >= 8277 && e <= 8286 || e >= 8592 && e <= 8596 || e >= 8597 && e <= 8601 || e >= 8602 && e <= 8603 || e >= 8604 && e <= 8607 || e === 8608 || e >= 8609 && e <= 8610 || e === 8611 || e >= 8612 && e <= 8613 || e === 8614 || e >= 8615 && e <= 8621 || e === 8622 || e >= 8623 && e <= 8653 || e >= 8654 && e <= 8655 || e >= 8656 && e <= 8657 || e === 8658 || e === 8659 || e === 8660 || e >= 8661 && e <= 8691 || e >= 8692 && e <= 8959 || e >= 8960 && e <= 8967 || e === 8968 || e === 8969 || e === 8970 || e === 8971 || e >= 8972 && e <= 8991 || e >= 8992 && e <= 8993 || e >= 8994 && e <= 9e3 || e === 9001 || e === 9002 || e >= 9003 && e <= 9083 || e === 9084 || e >= 9085 && e <= 9114 || e >= 9115 && e <= 9139 || e >= 9140 && e <= 9179 || e >= 9180 && e <= 9185 || e >= 9186 && e <= 9254 || e >= 9255 && e <= 9279 || e >= 9280 && e <= 9290 || e >= 9291 && e <= 9311 || e >= 9472 && e <= 9654 || e === 9655 || e >= 9656 && e <= 9664 || e === 9665 || e >= 9666 && e <= 9719 || e >= 9720 && e <= 9727 || e >= 9728 && e <= 9838 || e === 9839 || e >= 9840 && e <= 10087 || e === 10088 || e === 10089 || e === 10090 || e === 10091 || e === 10092 || e === 10093 || e === 10094 || e === 10095 || e === 10096 || e === 10097 || e === 10098 || e === 10099 || e === 10100 || e === 10101 || e >= 10132 && e <= 10175 || e >= 10176 && e <= 10180 || e === 10181 || e === 10182 || e >= 10183 && e <= 10213 || e === 10214 || e === 10215 || e === 10216 || e === 10217 || e === 10218 || e === 10219 || e === 10220 || e === 10221 || e === 10222 || e === 10223 || e >= 10224 && e <= 10239 || e >= 10240 && e <= 10495 || e >= 10496 && e <= 10626 || e === 10627 || e === 10628 || e === 10629 || e === 10630 || e === 10631 || e === 10632 || e === 10633 || e === 10634 || e === 10635 || e === 10636 || e === 10637 || e === 10638 || e === 10639 || e === 10640 || e === 10641 || e === 10642 || e === 10643 || e === 10644 || e === 10645 || e === 10646 || e === 10647 || e === 10648 || e >= 10649 && e <= 10711 || e === 10712 || e === 10713 || e === 10714 || e === 10715 || e >= 10716 && e <= 10747 || e === 10748 || e === 10749 || e >= 10750 && e <= 11007 || e >= 11008 && e <= 11055 || e >= 11056 && e <= 11076 || e >= 11077 && e <= 11078 || e >= 11079 && e <= 11084 || e >= 11085 && e <= 11123 || e >= 11124 && e <= 11125 || e >= 11126 && e <= 11157 || e === 11158 || e >= 11159 && e <= 11263 || e >= 11776 && e <= 11777 || e === 11778 || e === 11779 || e === 11780 || e === 11781 || e >= 11782 && e <= 11784 || e === 11785 || e === 11786 || e === 11787 || e === 11788 || e === 11789 || e >= 11790 && e <= 11798 || e === 11799 || e >= 11800 && e <= 11801 || e === 11802 || e === 11803 || e === 11804 || e === 11805 || e >= 11806 && e <= 11807 || e === 11808 || e === 11809 || e === 11810 || e === 11811 || e === 11812 || e === 11813 || e === 11814 || e === 11815 || e === 11816 || e === 11817 || e >= 11818 && e <= 11822 || e === 11823 || e >= 11824 && e <= 11833 || e >= 11834 && e <= 11835 || e >= 11836 && e <= 11839 || e === 11840 || e === 11841 || e === 11842 || e >= 11843 && e <= 11855 || e >= 11856 && e <= 11857 || e === 11858 || e >= 11859 && e <= 11903 || e >= 12289 && e <= 12291 || e === 12296 || e === 12297 || e === 12298 || e === 12299 || e === 12300 || e === 12301 || e === 12302 || e === 12303 || e === 12304 || e === 12305 || e >= 12306 && e <= 12307 || e === 12308 || e === 12309 || e === 12310 || e === 12311 || e === 12312 || e === 12313 || e === 12314 || e === 12315 || e === 12316 || e === 12317 || e >= 12318 && e <= 12319 || e === 12320 || e === 12336 || e === 64830 || e === 64831 || e >= 65093 && e <= 65094;
}
function mi(e) {
  e.forEach(function(t) {
    if (delete t.location, I4(t) || R4(t))
      for (var n in t.options)
        delete t.options[n].location, mi(t.options[n].value);
    else S4(t) && H4(t.style) || (A4(t) || T4(t)) && ui(t.style) ? delete t.style.location : N4(t) && mi(t.children);
  });
}
function Hv(e, t) {
  t === void 0 && (t = {}), t = S1({ shouldParseSkeletons: !0, requiresOtherClause: !0 }, t);
  var n = new Tv(e, t).parse();
  if (n.err) {
    var r = SyntaxError(ee[n.err.kind]);
    throw r.location = n.err.location, r.originalMessage = n.err.message, r;
  }
  return t != null && t.captureLocation || mi(n.val), n.val;
}
var a2;
(function(e) {
  e.MISSING_VALUE = "MISSING_VALUE", e.INVALID_VALUE = "INVALID_VALUE", e.MISSING_INTL_API = "MISSING_INTL_API";
})(a2 || (a2 = {}));
var W2 = (
  /** @class */
  function(e) {
    St(t, e);
    function t(n, r, a) {
      var i = e.call(this, n) || this;
      return i.code = r, i.originalMessage = a, i;
    }
    return t.prototype.toString = function() {
      return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    }, t;
  }(Error)
), _3 = (
  /** @class */
  function(e) {
    St(t, e);
    function t(n, r, a, i) {
      return e.call(this, 'Invalid values for "'.concat(n, '": "').concat(r, '". Options are "').concat(Object.keys(a).join('", "'), '"'), a2.INVALID_VALUE, i) || this;
    }
    return t;
  }(W2)
), Ov = (
  /** @class */
  function(e) {
    St(t, e);
    function t(n, r, a) {
      return e.call(this, 'Value for "'.concat(n, '" must be of type ').concat(r), a2.INVALID_VALUE, a) || this;
    }
    return t;
  }(W2)
), jv = (
  /** @class */
  function(e) {
    St(t, e);
    function t(n, r) {
      return e.call(this, 'The intl string context variable "'.concat(n, '" was not provided to the string "').concat(r, '"'), a2.MISSING_VALUE, r) || this;
    }
    return t;
  }(W2)
), ct;
(function(e) {
  e[e.literal = 0] = "literal", e[e.object = 1] = "object";
})(ct || (ct = {}));
function Pv(e) {
  return e.length < 2 ? e : e.reduce(function(t, n) {
    var r = t[t.length - 1];
    return !r || r.type !== ct.literal || n.type !== ct.literal ? t.push(n) : r.value += n.value, t;
  }, []);
}
function Z4(e) {
  return typeof e == "function";
}
function E0(e, t, n, r, a, i, l) {
  if (e.length === 1 && m3(e[0]))
    return [
      {
        type: ct.literal,
        value: e[0].value
      }
    ];
  for (var s = [], c = 0, p = e; c < p.length; c++) {
    var h = p[c];
    if (m3(h)) {
      s.push({
        type: ct.literal,
        value: h.value
      });
      continue;
    }
    if (ov(h)) {
      typeof i == "number" && s.push({
        type: ct.literal,
        value: n.getNumberFormat(t).format(i)
      });
      continue;
    }
    var u = h.value;
    if (!(a && u in a))
      throw new jv(u, l);
    var m = a[u];
    if (iv(h)) {
      (!m || typeof m == "string" || typeof m == "number") && (m = typeof m == "string" || typeof m == "number" ? String(m) : ""), s.push({
        type: typeof m == "string" ? ct.literal : ct.object,
        value: m
      });
      continue;
    }
    if (A4(h)) {
      var d = typeof h.style == "string" ? r.date[h.style] : ui(h.style) ? h.style.parsedOptions : void 0;
      s.push({
        type: ct.literal,
        value: n.getDateTimeFormat(t, d).format(m)
      });
      continue;
    }
    if (T4(h)) {
      var d = typeof h.style == "string" ? r.time[h.style] : ui(h.style) ? h.style.parsedOptions : r.time.medium;
      s.push({
        type: ct.literal,
        value: n.getDateTimeFormat(t, d).format(m)
      });
      continue;
    }
    if (S4(h)) {
      var d = typeof h.style == "string" ? r.number[h.style] : H4(h.style) ? h.style.parsedOptions : void 0;
      d && d.scale && (m = m * (d.scale || 1)), s.push({
        type: ct.literal,
        value: n.getNumberFormat(t, d).format(m)
      });
      continue;
    }
    if (N4(h)) {
      var v = h.children, x = h.value, k = a[x];
      if (!Z4(k))
        throw new Ov(x, "function", l);
      var I = E0(v, t, n, r, a, i), T = k(I.map(function(E) {
        return E.value;
      }));
      Array.isArray(T) || (T = [T]), s.push.apply(s, T.map(function(E) {
        return {
          type: typeof E == "string" ? ct.literal : ct.object,
          value: E
        };
      }));
    }
    if (I4(h)) {
      var L = h.options[m] || h.options.other;
      if (!L)
        throw new _3(h.value, m, Object.keys(h.options), l);
      s.push.apply(s, E0(L.value, t, n, r, a));
      continue;
    }
    if (R4(h)) {
      var L = h.options["=".concat(m)];
      if (!L) {
        if (!Intl.PluralRules)
          throw new W2(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, a2.MISSING_INTL_API, l);
        var S = n.getPluralRules(t, { type: h.pluralType }).select(m - (h.offset || 0));
        L = h.options[S] || h.options.other;
      }
      if (!L)
        throw new _3(h.value, m, Object.keys(h.options), l);
      s.push.apply(s, E0(L.value, t, n, r, a, m - (h.offset || 0)));
      continue;
    }
  }
  return Pv(s);
}
function Dv(e, t) {
  return t ? S1(S1(S1({}, e || {}), t || {}), Object.keys(e).reduce(function(n, r) {
    return n[r] = S1(S1({}, e[r]), t[r] || {}), n;
  }, {})) : e;
}
function Vv(e, t) {
  return t ? Object.keys(e).reduce(function(n, r) {
    return n[r] = Dv(e[r], t[r]), n;
  }, S1({}, e)) : e;
}
function Ea(e) {
  return {
    create: function() {
      return {
        get: function(t) {
          return e[t];
        },
        set: function(t, n) {
          e[t] = n;
        }
      };
    }
  };
}
function Bv(e) {
  return e === void 0 && (e = {
    number: {},
    dateTime: {},
    pluralRules: {}
  }), {
    getNumberFormat: ut(function() {
      for (var t, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return new ((t = Intl.NumberFormat).bind.apply(t, ft([void 0], n, !1)))();
    }, {
      cache: Ea(e.number),
      strategy: dt.variadic
    }),
    getDateTimeFormat: ut(function() {
      for (var t, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return new ((t = Intl.DateTimeFormat).bind.apply(t, ft([void 0], n, !1)))();
    }, {
      cache: Ea(e.dateTime),
      strategy: dt.variadic
    }),
    getPluralRules: ut(function() {
      for (var t, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return new ((t = Intl.PluralRules).bind.apply(t, ft([void 0], n, !1)))();
    }, {
      cache: Ea(e.pluralRules),
      strategy: dt.variadic
    })
  };
}
var G4 = (
  /** @class */
  function() {
    function e(t, n, r, a) {
      n === void 0 && (n = e.defaultLocale);
      var i = this;
      if (this.formatterCache = {
        number: {},
        dateTime: {},
        pluralRules: {}
      }, this.format = function(c) {
        var p = i.formatToParts(c);
        if (p.length === 1)
          return p[0].value;
        var h = p.reduce(function(u, m) {
          return !u.length || m.type !== ct.literal || typeof u[u.length - 1] != "string" ? u.push(m.value) : u[u.length - 1] += m.value, u;
        }, []);
        return h.length <= 1 ? h[0] || "" : h;
      }, this.formatToParts = function(c) {
        return E0(i.ast, i.locales, i.formatters, i.formats, c, void 0, i.message);
      }, this.resolvedOptions = function() {
        var c;
        return {
          locale: ((c = i.resolvedLocale) === null || c === void 0 ? void 0 : c.toString()) || Intl.NumberFormat.supportedLocalesOf(i.locales)[0]
        };
      }, this.getAst = function() {
        return i.ast;
      }, this.locales = n, this.resolvedLocale = e.resolveLocale(n), typeof t == "string") {
        if (this.message = t, !e.__parse)
          throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
        var l = a || {};
        l.formatters;
        var s = rr(l, ["formatters"]);
        this.ast = e.__parse(t, S1(S1({}, s), { locale: this.resolvedLocale }));
      } else
        this.ast = t;
      if (!Array.isArray(this.ast))
        throw new TypeError("A message must be provided as a String or AST.");
      this.formats = Vv(e.formats, r), this.formatters = a && a.formatters || Bv(this.formatterCache);
    }
    return Object.defineProperty(e, "defaultLocale", {
      get: function() {
        return e.memoizedDefaultLocale || (e.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale), e.memoizedDefaultLocale;
      },
      enumerable: !1,
      configurable: !0
    }), e.memoizedDefaultLocale = null, e.resolveLocale = function(t) {
      if (typeof Intl.Locale != "undefined") {
        var n = Intl.NumberFormat.supportedLocalesOf(t);
        return n.length > 0 ? new Intl.Locale(n[0]) : new Intl.Locale(typeof t == "string" ? t : t[0]);
      }
    }, e.__parse = Hv, e.formats = {
      number: {
        integer: {
          maximumFractionDigits: 0
        },
        currency: {
          style: "currency"
        },
        percent: {
          style: "percent"
        }
      },
      date: {
        short: {
          month: "numeric",
          day: "numeric",
          year: "2-digit"
        },
        medium: {
          month: "short",
          day: "numeric",
          year: "numeric"
        },
        long: {
          month: "long",
          day: "numeric",
          year: "numeric"
        },
        full: {
          weekday: "long",
          month: "long",
          day: "numeric",
          year: "numeric"
        }
      },
      time: {
        short: {
          hour: "numeric",
          minute: "numeric"
        },
        medium: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric"
        },
        long: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        },
        full: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        }
      }
    }, e;
  }()
), gn;
(function(e) {
  e.FORMAT_ERROR = "FORMAT_ERROR", e.UNSUPPORTED_FORMATTER = "UNSUPPORTED_FORMATTER", e.INVALID_CONFIG = "INVALID_CONFIG", e.MISSING_DATA = "MISSING_DATA", e.MISSING_TRANSLATION = "MISSING_TRANSLATION";
})(gn || (gn = {}));
var Ur = (
  /** @class */
  function(e) {
    St(t, e);
    function t(n, r, a) {
      var i = this, l = a ? a instanceof Error ? a : new Error(String(a)) : void 0;
      return i = e.call(this, "[@formatjs/intl Error ".concat(n, "] ").concat(r, `
`).concat(l ? `
`.concat(l.message, `
`).concat(l.stack) : "")) || this, i.code = n, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(i, t), i;
    }
    return t;
  }(Error)
), Fv = (
  /** @class */
  function(e) {
    St(t, e);
    function t(n, r) {
      return e.call(this, gn.UNSUPPORTED_FORMATTER, n, r) || this;
    }
    return t;
  }(Ur)
), Zv = (
  /** @class */
  function(e) {
    St(t, e);
    function t(n, r) {
      return e.call(this, gn.INVALID_CONFIG, n, r) || this;
    }
    return t;
  }(Ur)
), x3 = (
  /** @class */
  function(e) {
    St(t, e);
    function t(n, r) {
      return e.call(this, gn.MISSING_DATA, n, r) || this;
    }
    return t;
  }(Ur)
), At = (
  /** @class */
  function(e) {
    St(t, e);
    function t(n, r, a) {
      var i = e.call(this, gn.FORMAT_ERROR, "".concat(n, `
Locale: `).concat(r, `
`), a) || this;
      return i.locale = r, i;
    }
    return t;
  }(Ur)
), Ma = (
  /** @class */
  function(e) {
    St(t, e);
    function t(n, r, a, i) {
      var l = e.call(this, "".concat(n, `
MessageID: `).concat(a == null ? void 0 : a.id, `
Default Message: `).concat(a == null ? void 0 : a.defaultMessage, `
Description: `).concat(a == null ? void 0 : a.description, `
`), r, i) || this;
      return l.descriptor = a, l.locale = r, l;
    }
    return t;
  }(At)
), Gv = (
  /** @class */
  function(e) {
    St(t, e);
    function t(n, r) {
      var a = e.call(this, gn.MISSING_TRANSLATION, 'Missing message: "'.concat(n.id, '" for locale "').concat(r, '", using ').concat(n.defaultMessage ? "default message (".concat(typeof n.defaultMessage == "string" ? n.defaultMessage : n.defaultMessage.map(function(i) {
        var l;
        return (l = i.value) !== null && l !== void 0 ? l : JSON.stringify(i);
      }).join(), ")") : "id", " as fallback.")) || this;
      return a.descriptor = n, a;
    }
    return t;
  }(Ur)
);
function Ln(e, t, n) {
  return n === void 0 && (n = {}), t.reduce(function(r, a) {
    return a in e ? r[a] = e[a] : a in n && (r[a] = n[a]), r;
  }, {});
}
var Wv = function(e) {
  process.env.NODE_ENV !== "production" && console.error(e);
}, Uv = function(e) {
  process.env.NODE_ENV !== "production" && console.warn(e);
}, W4 = {
  formats: {},
  messages: {},
  timeZone: void 0,
  defaultLocale: "en",
  defaultFormats: {},
  fallbackOnEmptyString: !0,
  onError: Wv,
  onWarn: Uv
};
function U4() {
  return {
    dateTime: {},
    number: {},
    message: {},
    relativeTime: {},
    pluralRules: {},
    list: {},
    displayNames: {}
  };
}
function $2(e) {
  return {
    create: function() {
      return {
        get: function(t) {
          return e[t];
        },
        set: function(t, n) {
          e[t] = n;
        }
      };
    }
  };
}
function zv(e) {
  e === void 0 && (e = U4());
  var t = Intl.RelativeTimeFormat, n = Intl.ListFormat, r = Intl.DisplayNames, a = ut(function() {
    for (var s, c = [], p = 0; p < arguments.length; p++)
      c[p] = arguments[p];
    return new ((s = Intl.DateTimeFormat).bind.apply(s, ft([void 0], c, !1)))();
  }, {
    cache: $2(e.dateTime),
    strategy: dt.variadic
  }), i = ut(function() {
    for (var s, c = [], p = 0; p < arguments.length; p++)
      c[p] = arguments[p];
    return new ((s = Intl.NumberFormat).bind.apply(s, ft([void 0], c, !1)))();
  }, {
    cache: $2(e.number),
    strategy: dt.variadic
  }), l = ut(function() {
    for (var s, c = [], p = 0; p < arguments.length; p++)
      c[p] = arguments[p];
    return new ((s = Intl.PluralRules).bind.apply(s, ft([void 0], c, !1)))();
  }, {
    cache: $2(e.pluralRules),
    strategy: dt.variadic
  });
  return {
    getDateTimeFormat: a,
    getNumberFormat: i,
    getMessageFormat: ut(function(s, c, p, h) {
      return new G4(s, c, p, S1({ formatters: {
        getNumberFormat: i,
        getDateTimeFormat: a,
        getPluralRules: l
      } }, h || {}));
    }, {
      cache: $2(e.message),
      strategy: dt.variadic
    }),
    getRelativeTimeFormat: ut(function() {
      for (var s = [], c = 0; c < arguments.length; c++)
        s[c] = arguments[c];
      return new (t.bind.apply(t, ft([void 0], s, !1)))();
    }, {
      cache: $2(e.relativeTime),
      strategy: dt.variadic
    }),
    getPluralRules: l,
    getListFormat: ut(function() {
      for (var s = [], c = 0; c < arguments.length; c++)
        s[c] = arguments[c];
      return new (n.bind.apply(n, ft([void 0], s, !1)))();
    }, {
      cache: $2(e.list),
      strategy: dt.variadic
    }),
    getDisplayNames: ut(function() {
      for (var s = [], c = 0; c < arguments.length; c++)
        s[c] = arguments[c];
      return new (r.bind.apply(r, ft([void 0], s, !1)))();
    }, {
      cache: $2(e.displayNames),
      strategy: dt.variadic
    })
  };
}
function io(e, t, n, r) {
  var a = e && e[t], i;
  if (a && (i = a[n]), i)
    return i;
  r(new Fv("No ".concat(t, " format named: ").concat(n)));
}
function o0(e, t) {
  return Object.keys(e).reduce(function(n, r) {
    return n[r] = S1({ timeZone: t }, e[r]), n;
  }, {});
}
function L3(e, t) {
  var n = Object.keys(S1(S1({}, e), t));
  return n.reduce(function(r, a) {
    return r[a] = S1(S1({}, e[a] || {}), t[a] || {}), r;
  }, {});
}
function E3(e, t) {
  if (!t)
    return e;
  var n = G4.formats;
  return S1(S1(S1({}, n), e), { date: L3(o0(n.date, t), o0(e.date || {}, t)), time: L3(o0(n.time, t), o0(e.time || {}, t)) });
}
var Ci = function(e, t, n, r, a) {
  var i = e.locale, l = e.formats, s = e.messages, c = e.defaultLocale, p = e.defaultFormats, h = e.fallbackOnEmptyString, u = e.onError, m = e.timeZone, d = e.defaultRichTextElements;
  n === void 0 && (n = { id: "" });
  var v = n.id, x = n.defaultMessage;
  k4(!!v, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
  var k = String(v), I = (
    // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    s && Object.prototype.hasOwnProperty.call(s, k) && s[k]
  );
  if (Array.isArray(I) && I.length === 1 && I[0].type === Te.literal)
    return I[0].value;
  if (!r && I && typeof I == "string" && !d)
    return I.replace(/'\{(.*?)\}'/gi, "{$1}");
  if (r = S1(S1({}, d), r || {}), l = E3(l, m), p = E3(p, m), !I) {
    if (h === !1 && I === "")
      return I;
    if ((!x || i && i.toLowerCase() !== c.toLowerCase()) && u(new Gv(n, i)), x)
      try {
        var T = t.getMessageFormat(x, c, p, a);
        return T.format(r);
      } catch (L) {
        return u(new Ma('Error formatting default message for: "'.concat(k, '", rendering default message verbatim'), i, n, L)), typeof x == "string" ? x : k;
      }
    return k;
  }
  try {
    var T = t.getMessageFormat(I, i, l, S1({ formatters: t }, a || {}));
    return T.format(r);
  } catch (L) {
    u(new Ma('Error formatting message: "'.concat(k, '", using ').concat(x ? "default message" : "id", " as fallback."), i, n, L));
  }
  if (x)
    try {
      var T = t.getMessageFormat(x, c, p, a);
      return T.format(r);
    } catch (L) {
      u(new Ma('Error formatting the default message for: "'.concat(k, '", rendering message verbatim'), i, n, L));
    }
  return typeof I == "string" ? I : typeof x == "string" ? x : k;
}, z4 = [
  "formatMatcher",
  "timeZone",
  "hour12",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "hourCycle",
  "dateStyle",
  "timeStyle",
  "calendar",
  // 'dayPeriod',
  "numberingSystem",
  "fractionalSecondDigits"
];
function J0(e, t, n, r) {
  var a = e.locale, i = e.formats, l = e.onError, s = e.timeZone;
  r === void 0 && (r = {});
  var c = r.format, p = S1(S1({}, s && { timeZone: s }), c && io(i, t, c, l)), h = Ln(r, z4, p);
  return t === "time" && !h.hour && !h.minute && !h.second && !h.timeStyle && !h.dateStyle && (h = S1(S1({}, h), { hour: "numeric", minute: "numeric" })), n(a, h);
}
function qv(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  var a = n[0], i = n[1], l = i === void 0 ? {} : i, s = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return J0(e, "date", t, l).format(s);
  } catch (c) {
    e.onError(new At("Error formatting date.", e.locale, c));
  }
  return String(s);
}
function $v(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  var a = n[0], i = n[1], l = i === void 0 ? {} : i, s = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return J0(e, "time", t, l).format(s);
  } catch (c) {
    e.onError(new At("Error formatting time.", e.locale, c));
  }
  return String(s);
}
function Yv(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  var a = n[0], i = n[1], l = n[2], s = l === void 0 ? {} : l, c = e.timeZone, p = e.locale, h = e.onError, u = Ln(s, z4, c ? { timeZone: c } : {});
  try {
    return t(p, u).formatRange(a, i);
  } catch (m) {
    h(new At("Error formatting date time range.", e.locale, m));
  }
  return String(a);
}
function Kv(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  var a = n[0], i = n[1], l = i === void 0 ? {} : i, s = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return J0(e, "date", t, l).formatToParts(s);
  } catch (c) {
    e.onError(new At("Error formatting date.", e.locale, c));
  }
  return [];
}
function Qv(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  var a = n[0], i = n[1], l = i === void 0 ? {} : i, s = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return J0(e, "time", t, l).formatToParts(s);
  } catch (c) {
    e.onError(new At("Error formatting time.", e.locale, c));
  }
  return [];
}
var Xv = [
  "style",
  "type",
  "fallback",
  "languageDisplay"
];
function Jv(e, t, n, r) {
  var a = e.locale, i = e.onError, l = Intl.DisplayNames;
  l || i(new W2(`Intl.DisplayNames is not available in this environment.
Try polyfilling it using "@formatjs/intl-displaynames"
`, a2.MISSING_INTL_API));
  var s = Ln(r, Xv);
  try {
    return t(a, s).of(n);
  } catch (c) {
    i(new At("Error formatting display name.", a, c));
  }
}
var ew = [
  "type",
  "style"
], M3 = Date.now();
function tw(e) {
  return "".concat(M3, "_").concat(e, "_").concat(M3);
}
function nw(e, t, n, r) {
  r === void 0 && (r = {});
  var a = q4(e, t, n, r).reduce(function(i, l) {
    var s = l.value;
    return typeof s != "string" ? i.push(s) : typeof i[i.length - 1] == "string" ? i[i.length - 1] += s : i.push(s), i;
  }, []);
  return a.length === 1 ? a[0] : a.length === 0 ? "" : a;
}
function q4(e, t, n, r) {
  var a = e.locale, i = e.onError;
  r === void 0 && (r = {});
  var l = Intl.ListFormat;
  l || i(new W2(`Intl.ListFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-listformat"
`, a2.MISSING_INTL_API));
  var s = Ln(r, ew);
  try {
    var c = {}, p = n.map(function(h, u) {
      if (typeof h == "object") {
        var m = tw(u);
        return c[m] = h, m;
      }
      return String(h);
    });
    return t(a, s).formatToParts(p).map(function(h) {
      return h.type === "literal" ? h : S1(S1({}, h), { value: c[h.value] || h.value });
    });
  } catch (h) {
    i(new At("Error formatting list.", a, h));
  }
  return n;
}
var rw = ["type"];
function aw(e, t, n, r) {
  var a = e.locale, i = e.onError;
  r === void 0 && (r = {}), Intl.PluralRules || i(new W2(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, a2.MISSING_INTL_API));
  var l = Ln(r, rw);
  try {
    return t(a, l).select(n);
  } catch (s) {
    i(new At("Error formatting plural.", a, s));
  }
  return "other";
}
var iw = ["numeric", "style"];
function ow(e, t, n) {
  var r = e.locale, a = e.formats, i = e.onError;
  n === void 0 && (n = {});
  var l = n.format, s = !!l && io(a, "relative", l, i) || {}, c = Ln(n, iw, s);
  return t(r, c);
}
function sw(e, t, n, r, a) {
  a === void 0 && (a = {}), r || (r = "second");
  var i = Intl.RelativeTimeFormat;
  i || e.onError(new W2(`Intl.RelativeTimeFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-relativetimeformat"
`, a2.MISSING_INTL_API));
  try {
    return ow(e, t, a).format(n, r);
  } catch (l) {
    e.onError(new At("Error formatting relative time.", e.locale, l));
  }
  return String(n);
}
var lw = [
  "style",
  "currency",
  "unit",
  "unitDisplay",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  // ES2020 NumberFormat
  "compactDisplay",
  "currencyDisplay",
  "currencySign",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "numberingSystem",
  // ES2023 NumberFormat
  "trailingZeroDisplay",
  "roundingPriority",
  "roundingIncrement",
  "roundingMode"
];
function $4(e, t, n) {
  var r = e.locale, a = e.formats, i = e.onError;
  n === void 0 && (n = {});
  var l = n.format, s = l && io(a, "number", l, i) || {}, c = Ln(n, lw, s);
  return t(r, c);
}
function cw(e, t, n, r) {
  r === void 0 && (r = {});
  try {
    return $4(e, t, r).format(n);
  } catch (a) {
    e.onError(new At("Error formatting number.", e.locale, a));
  }
  return String(n);
}
function uw(e, t, n, r) {
  r === void 0 && (r = {});
  try {
    return $4(e, t, r).formatToParts(n);
  } catch (a) {
    e.onError(new At("Error formatting number.", e.locale, a));
  }
  return [];
}
function dw(e) {
  var t = e ? e[Object.keys(e)[0]] : void 0;
  return typeof t == "string";
}
function fw(e) {
  e.onWarn && e.defaultRichTextElements && dw(e.messages || {}) && e.onWarn(`[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. 
Please consider using "@formatjs/cli" to pre-compile your messages for performance.
For more details see https://formatjs.io/docs/getting-started/message-distribution`);
}
function hw(e, t) {
  var n = zv(t), r = S1(S1({}, W4), e), a = r.locale, i = r.defaultLocale, l = r.onError;
  return a ? !Intl.NumberFormat.supportedLocalesOf(a).length && l ? l(new x3('Missing locale data for locale: "'.concat(a, '" in Intl.NumberFormat. Using default locale: "').concat(i, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details'))) : !Intl.DateTimeFormat.supportedLocalesOf(a).length && l && l(new x3('Missing locale data for locale: "'.concat(a, '" in Intl.DateTimeFormat. Using default locale: "').concat(i, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details'))) : (l && l(new Zv('"locale" was not configured, using "'.concat(i, '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details'))), r.locale = r.defaultLocale || "en"), fw(r), S1(S1({}, r), {
    formatters: n,
    formatNumber: cw.bind(null, r, n.getNumberFormat),
    formatNumberToParts: uw.bind(null, r, n.getNumberFormat),
    formatRelativeTime: sw.bind(null, r, n.getRelativeTimeFormat),
    formatDate: qv.bind(null, r, n.getDateTimeFormat),
    formatDateToParts: Kv.bind(null, r, n.getDateTimeFormat),
    formatTime: $v.bind(null, r, n.getDateTimeFormat),
    formatDateTimeRange: Yv.bind(null, r, n.getDateTimeFormat),
    formatTimeToParts: Qv.bind(null, r, n.getDateTimeFormat),
    formatPlural: aw.bind(null, r, n.getPluralRules),
    // @ts-expect-error TODO: will get to this later
    formatMessage: Ci.bind(null, r, n),
    // @ts-expect-error TODO: will get to this later
    $t: Ci.bind(null, r, n),
    formatList: nw.bind(null, r, n.getListFormat),
    formatListToParts: q4.bind(null, r, n.getListFormat),
    formatDisplayName: Jv.bind(null, r, n.getDisplayNames)
  });
}
function Y4(e) {
  k4(e, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var K4 = S1(S1({}, W4), { textComponent: o.Fragment });
function pw(e) {
  return function(t) {
    return e(o.Children.toArray(t));
  };
}
function gi(e, t) {
  if (e === t)
    return !0;
  if (!e || !t)
    return !1;
  var n = Object.keys(e), r = Object.keys(t), a = n.length;
  if (r.length !== a)
    return !1;
  for (var i = 0; i < a; i++) {
    var l = n[i];
    if (e[l] !== t[l] || !Object.prototype.hasOwnProperty.call(t, l))
      return !1;
  }
  return !0;
}
var vi = { exports: {} }, ue = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var k3;
function mw() {
  if (k3) return ue;
  k3 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, h = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, d = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, x = e ? Symbol.for("react.block") : 60121, k = e ? Symbol.for("react.fundamental") : 60117, I = e ? Symbol.for("react.responder") : 60118, T = e ? Symbol.for("react.scope") : 60119;
  function L(E) {
    if (typeof E == "object" && E !== null) {
      var j = E.$$typeof;
      switch (j) {
        case t:
          switch (E = E.type, E) {
            case c:
            case p:
            case r:
            case i:
            case a:
            case u:
              return E;
            default:
              switch (E = E && E.$$typeof, E) {
                case s:
                case h:
                case v:
                case d:
                case l:
                  return E;
                default:
                  return j;
              }
          }
        case n:
          return j;
      }
    }
  }
  function S(E) {
    return L(E) === p;
  }
  return ue.AsyncMode = c, ue.ConcurrentMode = p, ue.ContextConsumer = s, ue.ContextProvider = l, ue.Element = t, ue.ForwardRef = h, ue.Fragment = r, ue.Lazy = v, ue.Memo = d, ue.Portal = n, ue.Profiler = i, ue.StrictMode = a, ue.Suspense = u, ue.isAsyncMode = function(E) {
    return S(E) || L(E) === c;
  }, ue.isConcurrentMode = S, ue.isContextConsumer = function(E) {
    return L(E) === s;
  }, ue.isContextProvider = function(E) {
    return L(E) === l;
  }, ue.isElement = function(E) {
    return typeof E == "object" && E !== null && E.$$typeof === t;
  }, ue.isForwardRef = function(E) {
    return L(E) === h;
  }, ue.isFragment = function(E) {
    return L(E) === r;
  }, ue.isLazy = function(E) {
    return L(E) === v;
  }, ue.isMemo = function(E) {
    return L(E) === d;
  }, ue.isPortal = function(E) {
    return L(E) === n;
  }, ue.isProfiler = function(E) {
    return L(E) === i;
  }, ue.isStrictMode = function(E) {
    return L(E) === a;
  }, ue.isSuspense = function(E) {
    return L(E) === u;
  }, ue.isValidElementType = function(E) {
    return typeof E == "string" || typeof E == "function" || E === r || E === p || E === i || E === a || E === u || E === m || typeof E == "object" && E !== null && (E.$$typeof === v || E.$$typeof === d || E.$$typeof === l || E.$$typeof === s || E.$$typeof === h || E.$$typeof === k || E.$$typeof === I || E.$$typeof === T || E.$$typeof === x);
  }, ue.typeOf = L, ue;
}
var de = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var S3;
function Cw() {
  return S3 || (S3 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, h = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, d = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, x = e ? Symbol.for("react.block") : 60121, k = e ? Symbol.for("react.fundamental") : 60117, I = e ? Symbol.for("react.responder") : 60118, T = e ? Symbol.for("react.scope") : 60119;
    function L(Y) {
      return typeof Y == "string" || typeof Y == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Y === r || Y === p || Y === i || Y === a || Y === u || Y === m || typeof Y == "object" && Y !== null && (Y.$$typeof === v || Y.$$typeof === d || Y.$$typeof === l || Y.$$typeof === s || Y.$$typeof === h || Y.$$typeof === k || Y.$$typeof === I || Y.$$typeof === T || Y.$$typeof === x);
    }
    function S(Y) {
      if (typeof Y == "object" && Y !== null) {
        var P1 = Y.$$typeof;
        switch (P1) {
          case t:
            var J1 = Y.type;
            switch (J1) {
              case c:
              case p:
              case r:
              case i:
              case a:
              case u:
                return J1;
              default:
                var I1 = J1 && J1.$$typeof;
                switch (I1) {
                  case s:
                  case h:
                  case v:
                  case d:
                  case l:
                    return I1;
                  default:
                    return P1;
                }
            }
          case n:
            return P1;
        }
      }
    }
    var E = c, j = p, g = s, w = l, C = t, b = h, M = r, R = v, O = d, N = n, H = i, Z = a, z = u, K = !1;
    function D(Y) {
      return K || (K = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), W(Y) || S(Y) === c;
    }
    function W(Y) {
      return S(Y) === p;
    }
    function q(Y) {
      return S(Y) === s;
    }
    function e1(Y) {
      return S(Y) === l;
    }
    function o1(Y) {
      return typeof Y == "object" && Y !== null && Y.$$typeof === t;
    }
    function c1(Y) {
      return S(Y) === h;
    }
    function v1(Y) {
      return S(Y) === r;
    }
    function m1(Y) {
      return S(Y) === v;
    }
    function $(Y) {
      return S(Y) === d;
    }
    function n1(Y) {
      return S(Y) === n;
    }
    function d1(Y) {
      return S(Y) === i;
    }
    function f1(Y) {
      return S(Y) === a;
    }
    function M1(Y) {
      return S(Y) === u;
    }
    de.AsyncMode = E, de.ConcurrentMode = j, de.ContextConsumer = g, de.ContextProvider = w, de.Element = C, de.ForwardRef = b, de.Fragment = M, de.Lazy = R, de.Memo = O, de.Portal = N, de.Profiler = H, de.StrictMode = Z, de.Suspense = z, de.isAsyncMode = D, de.isConcurrentMode = W, de.isContextConsumer = q, de.isContextProvider = e1, de.isElement = o1, de.isForwardRef = c1, de.isFragment = v1, de.isLazy = m1, de.isMemo = $, de.isPortal = n1, de.isProfiler = d1, de.isStrictMode = f1, de.isSuspense = M1, de.isValidElementType = L, de.typeOf = S;
  }()), de;
}
process.env.NODE_ENV === "production" ? vi.exports = mw() : vi.exports = Cw();
var gw = vi.exports, Q4 = gw, vw = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, ww = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, X4 = {};
X4[Q4.ForwardRef] = vw;
X4[Q4.Memo] = ww;
var oo = typeof window != "undefined" && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = o.createContext(null)) : o.createContext(null);
oo.Consumer;
var yw = oo.Provider, bw = yw, _w = oo;
function N1() {
  var e = o.useContext(_w);
  return Y4(e), e;
}
var wi;
(function(e) {
  e.formatDate = "FormattedDate", e.formatTime = "FormattedTime", e.formatNumber = "FormattedNumber", e.formatList = "FormattedList", e.formatDisplayName = "FormattedDisplayName";
})(wi || (wi = {}));
var yi;
(function(e) {
  e.formatDate = "FormattedDateParts", e.formatTime = "FormattedTimeParts", e.formatNumber = "FormattedNumberParts", e.formatList = "FormattedListParts";
})(yi || (yi = {}));
function J4(e) {
  var t = function(n) {
    var r = N1(), a = n.value, i = n.children, l = rr(n, ["value", "children"]), s = typeof a == "string" ? new Date(a || 0) : a, c = e === "formatDate" ? r.formatDateToParts(s, l) : r.formatTimeToParts(s, l);
    return i(c);
  };
  return t.displayName = yi[e], t;
}
function zr(e) {
  var t = function(n) {
    var r = N1(), a = n.value, i = n.children, l = rr(
      n,
      ["value", "children"]
    ), s = r[e](a, l);
    if (typeof i == "function")
      return i(s);
    var c = r.textComponent || o.Fragment;
    return o.createElement(c, null, s);
  };
  return t.displayName = wi[e], t;
}
function es(e) {
  return e && Object.keys(e).reduce(function(t, n) {
    var r = e[n];
    return t[n] = Z4(r) ? pw(r) : r, t;
  }, {});
}
var A3 = function(e, t, n, r) {
  for (var a = [], i = 4; i < arguments.length; i++)
    a[i - 4] = arguments[i];
  var l = es(r), s = Ci.apply(void 0, ft([
    e,
    t,
    n,
    l
  ], a, !1));
  return Array.isArray(s) ? o.Children.toArray(s) : s;
}, T3 = function(e, t) {
  var n = e.defaultRichTextElements, r = rr(e, ["defaultRichTextElements"]), a = es(n), i = hw(S1(S1(S1({}, K4), r), { defaultRichTextElements: a }), t), l = {
    locale: i.locale,
    timeZone: i.timeZone,
    fallbackOnEmptyString: i.fallbackOnEmptyString,
    formats: i.formats,
    defaultLocale: i.defaultLocale,
    defaultFormats: i.defaultFormats,
    messages: i.messages,
    onError: i.onError,
    defaultRichTextElements: a
  };
  return S1(S1({}, i), {
    formatMessage: A3.bind(
      null,
      l,
      // @ts-expect-error fix this
      i.formatters
    ),
    // @ts-expect-error fix this
    $t: A3.bind(null, l, i.formatters)
  });
};
function ka(e) {
  return {
    locale: e.locale,
    timeZone: e.timeZone,
    fallbackOnEmptyString: e.fallbackOnEmptyString,
    formats: e.formats,
    textComponent: e.textComponent,
    messages: e.messages,
    defaultLocale: e.defaultLocale,
    defaultFormats: e.defaultFormats,
    onError: e.onError,
    onWarn: e.onWarn,
    wrapRichTextChunksInFragment: e.wrapRichTextChunksInFragment,
    defaultRichTextElements: e.defaultRichTextElements
  };
}
var xw = (
  /** @class */
  function(e) {
    St(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.cache = U4(), n.state = {
        cache: n.cache,
        intl: T3(ka(n.props), n.cache),
        prevConfig: ka(n.props)
      }, n;
    }
    return t.getDerivedStateFromProps = function(n, r) {
      var a = r.prevConfig, i = r.cache, l = ka(n);
      return gi(a, l) ? null : {
        intl: T3(l, i),
        prevConfig: l
      };
    }, t.prototype.render = function() {
      return Y4(this.state.intl), o.createElement(bw, { value: this.state.intl }, this.props.children);
    }, t.displayName = "IntlProvider", t.defaultProps = K4, t;
  }(o.PureComponent)
);
function Lw(e, t) {
  var n = e.values, r = rr(e, ["values"]), a = t.values, i = rr(t, ["values"]);
  return gi(a, n) && gi(r, i);
}
function ts(e) {
  var t = N1(), n = t.formatMessage, r = t.textComponent, a = r === void 0 ? o.Fragment : r, i = e.id, l = e.description, s = e.defaultMessage, c = e.values, p = e.children, h = e.tagName, u = h === void 0 ? a : h, m = e.ignoreTag, d = { id: i, description: l, defaultMessage: s }, v = n(d, c, {
    ignoreTag: m
  });
  return typeof p == "function" ? p(Array.isArray(v) ? v : [v]) : u ? o.createElement(u, null, o.Children.toArray(v)) : o.createElement(o.Fragment, null, v);
}
ts.displayName = "FormattedMessage";
var ns = o.memo(ts, Lw);
ns.displayName = "MemoizedFormattedMessage";
zr("formatDate");
zr("formatTime");
zr("formatNumber");
zr("formatList");
zr("formatDisplayName");
J4("formatDate");
J4("formatTime");
const Kt = J.getGemHost(
  "api"
  /* API */
), bi = J.getAuthHost(
  "auth-ac"
  /* AUTH */
), Hn = J.getGemHost(
  "account"
  /* ACCOUNT */
), Ke = J.getGemHost(
  "store"
  /* GAMES */
), qr = J.getGemHost(
  "profile"
  /* PROFILE */
), ea = J.getGemHost(
  "support"
  /* SUPPORT */
), M2 = `${J.getGemHost(
  "store"
  /* GAMES */
)}/media`, On = J.getGemHost(
  "pvp"
  /* PVP */
);
J.getGemHost(
  "live"
  /* LIVE */
);
const jn = J.getGemHost(
  "market"
  /* MARKET */
), en = J.getGemHost(
  "cloud"
  /* CLOUD */
), tn = J.getGemHost(
  "documentation"
  /* DEVDOCS */
), Ew = J.getGemHost(
  "developers"
  /* DEVELOPERS */
), Mw = J.getGemHost(
  "mini"
  /* MINI */
), kw = J.getGemHost(
  "community"
  /* COMMUNITY */
), Sw = window.location.hostname === Hn, so = window.location.href.includes(M2), $r = window.location.hostname === Ke && !so, Aw = window.location.hostname === On, Tw = $r && window.location.pathname.match(/^\/\b(live)\b\/?/), rs = $r && window.location.pathname.match(/^\/\b(app)\b\/?/), as = window.location.hostname === jn, Iw = window.location.hostname === Mw, Rw = window.location.hostname === kw, Nw = window.location.hostname === ea, Y2 = Kt, me = {
  login: `https://${Hn}/login/`,
  logout: `https://${bi}/logout`,
  get_user: `https://${Kt}/social/profile/v2/session`,
  get_terms: `https://${Kt}/account/terms/versions/`,
  get_gc_auth: `https://${Kt}/account/get_gc_auth/`,
  terms_accept: `https://${Kt}/account/terms/accept/`,
  profile: `https://${qr}/profile/`,
  accountSettings: `https://${Hn}/profile/userinfo/`,
  support: `https://${ea}`,
  devdocs: `https://${tn}`,
  change_language: `https://${Kt}/account/change_language/`,
  main: `https://${Ke}/`,
  payment_steam: `https://${Ke}/services/payment_steam/`,
  gamecenter: `https://${Ke}/about/?from=gamecenter`,
  ckassa: `https://${Kt}/play/market/steam/ckassa/`,
  wishlist: `https://${Kt}/play/games/wishlist/`,
  social_back: `https://${Hn}/social_back/`,
  /* NOTIFICATIONS */
  count: `https://${Y2}/social/notifications/count`,
  notifications: `https://${Y2}/social/notifications/list`,
  notificationDelete: `https://${Y2}/social/notifications/remove`,
  friendRequest: `https://${Y2}/profile/p/friend_request/`,
  readOne: `https://${Y2}/social/notifications/read`,
  readAll: `https://${Y2}/social/notifications/read_all`,
  nextNotification: `https://${Y2}/social/notifications/next`,
  gameSetting: "/play/set_game_setting/",
  userWishlist: "/games/wishlist"
}, lo = () => {
  const e = Sw && !window.location.pathname.includes("oauth") ? `https://${Hn}/login/` : window.location.href;
  return `${me.logout}?continue=${e}`;
}, Hw = () => rs ? "" : Tw ? "live" : $r ? "store" : as ? "market" : Aw ? "pvp" : Rw ? "community" : so ? "media" : Nw ? "support" : "", Ow = "_gcBtn_1dtvd_1", jw = "_button_1dtvd_60", Pw = "_rightIcon_1dtvd_98", Dw = "_leftIcon_1dtvd_108", Vw = "_buttonText_1dtvd_155", Bw = "_tooltip_1dtvd_188", Fw = "_icon_1dtvd_201", Zw = "_label_1dtvd_230", d2 = {
  gcBtn: Ow,
  button: jw,
  rightIcon: Pw,
  leftIcon: Dw,
  buttonText: Vw,
  tooltip: Bw,
  icon: Fw,
  label: Zw
}, Sa = {
  btnName: {
    id: "gamecenter.download",
    defaultMessage: "Лаунчер для"
  },
  downloadTooltip: {
    id: "gamecenter.download.tooltip",
    defaultMessage: "Скачать Игровой Центр"
  },
  download: {
    id: "menu.cloud.download",
    defaultMessage: "Скачать"
  }
}, Gw = () => {
  const {
    pushReachGoal: e
  } = le(), {
    formatMessage: t
  } = N1(), n = () => {
    e({
      params: {
        category: "header",
        action: "click",
        label: "ph-menu-gc"
      }
    });
  };
  return /* @__PURE__ */ f.jsxs("div", { className: d2.gcBtn, children: [
    /* @__PURE__ */ f.jsx("span", { className: d2.icon }),
    /* @__PURE__ */ f.jsxs("p", { className: d2.label, children: [
      t(Sa.btnName),
      " ",
      /* @__PURE__ */ f.jsx("span", { children: J.isMac ? "MacOS" : "Windows" })
    ] }),
    /* @__PURE__ */ f.jsxs("a", { href: me.gamecenter, target: "_blank", rel: "noreferrer", className: d2.button, "data-tooltip-id": "gc-btn", "data-tooltip-position-strategy": "fixed", onClick: n, children: [
      J.isMac ? /* @__PURE__ */ f.jsx(b1, { name: "logo-apple", className: d2.leftIcon }) : /* @__PURE__ */ f.jsx(b1, { name: "logo-windows", className: d2.leftIcon }),
      /* @__PURE__ */ f.jsx("span", { className: d2.buttonText, children: t(Sa.download) }),
      /* @__PURE__ */ f.jsx(b1, { name: "download-outline-sm", className: d2.rightIcon })
    ] }),
    /* @__PURE__ */ f.jsx(kt, { id: "gc-btn", content: t(Sa.downloadTooltip), className: d2.tooltip, place: "right-end", delayShow: 500 })
  ] });
}, Ww = J.query_string(), is = () => {
  const t = /^((store|market|profile|account|documentation|developers|community|media)\.vkplay\.ru|vkplay\.ru)$/.test(window.location.hostname), {
    no_cookiebot: n,
    force_show_cookiebot: r
  } = Ww;
  if (r)
    return !0;
  let a = !1;
  return window.self !== window.top && (document.referrer.includes("metrika.yandex.ru") || document.referrer.includes("webvisor.com")) && (a = !0), !J.inGamecenter && t && !window.location.pathname.includes("/oauth2/") && !window.location.pathname.includes("/signup_terms_accept/") && !window.location.pathname.includes("/social_back/") && !window.location.pathname.includes("/secstep/") && !window.location.pathname.startsWith("/special") && !window.location.pathname.includes("/app/") && !n && !a;
}, Uw = function(e) {
  window.gdprAppliesGlobally = !0, (!("cmp_id" in window) || window.cmp_id < 1) && (window.cmp_id = 0), "cmp_cdid" in window || (window.cmp_cdid = "5475788091d81"), "cmp_params" in window || (window.cmp_params = ""), "cmp_host" in window || (window.cmp_host = "d.delivery.consentmanager.net"), "cmp_cdn" in window || (window.cmp_cdn = "cdn.consentmanager.net"), "cmp_proto" in window || (window.cmp_proto = "https:"), "cmp_codesrc" in window || (window.cmp_codesrc = "1"), window.cmp_getsupportedLangs = function() {
    var t = ["DE", "EN", "FR", "IT", "NO", "DA", "FI", "ES", "PT", "RO", "BG", "ET", "EL", "GA", "HR", "LV", "LT", "MT", "NL", "PL", "SV", "SK", "SL", "CS", "HU", "RU", "SR", "ZH", "TR", "UK", "AR", "BS"];
    if ("cmp_customlanguages" in window)
      for (var n = 0; n < window.cmp_customlanguages.length; n++)
        t.push(window.cmp_customlanguages[n].l.toUpperCase());
    return t;
  }, window.cmp_getRTLLangs = function() {
    var t = ["AR"];
    if ("cmp_customlanguages" in window)
      for (var n = 0; n < window.cmp_customlanguages.length; n++)
        "r" in window.cmp_customlanguages[n] && window.cmp_customlanguages[n].r && t.push(window.cmp_customlanguages[n].l);
    return t;
  }, window.cmp_getlang = function(t) {
    if (typeof t != "boolean" && (t = !0), t && typeof cmp_getlang.usedlang == "string" && cmp_getlang.usedlang !== "")
      return cmp_getlang.usedlang;
    var n = window.cmp_getsupportedLangs(), r = [], a = location.hash, i = location.search, l = "languages" in navigator ? navigator.languages : [];
    if (a.indexOf("cmplang=") != -1)
      r.push(a.substr(a.indexOf("cmplang=") + 8, 2).toUpperCase());
    else if (i.indexOf("cmplang=") != -1)
      r.push(i.substr(i.indexOf("cmplang=") + 8, 2).toUpperCase());
    else if ("cmp_setlang" in window && window.cmp_setlang != "")
      r.push(window.cmp_setlang.toUpperCase());
    else if (l.length > 0)
      for (var s = 0; s < l.length; s++)
        r.push(l[s]);
    "language" in navigator && r.push(navigator.language), "userLanguage" in navigator && r.push(navigator.userLanguage);
    for (var c = "", s = 0; s < r.length; s++) {
      var p = r[s].toUpperCase();
      if (n.indexOf(p) != -1) {
        c = p;
        break;
      }
      if (p.indexOf("-") != -1 && (p = p.substr(0, 2)), n.indexOf(p) != -1) {
        c = p;
        break;
      }
    }
    return c == "" && typeof cmp_getlang.defaultlang == "string" && cmp_getlang.defaultlang !== "" ? cmp_getlang.defaultlang : (c == "" && (c = "EN"), c = c.toUpperCase(), c);
  }, function() {
    var t = document, n = t.getElementsByTagName, r = window, a = "", i = "_en";
    if ("cmp_getlang" in r) {
      if (a = r.cmp_getlang().toLowerCase(), "cmp_customlanguages" in r) {
        for (var l = 0; l < r.cmp_customlanguages.length; l++)
          if (r.cmp_customlanguages[l].l.toUpperCase() == a.toUpperCase()) {
            a = "en";
            break;
          }
      }
      i = "_" + a;
    }
    function s(L, S) {
      var E = "";
      L += "=";
      var j = L.length, g = location;
      if (g.hash.indexOf(L) != -1)
        E = g.hash.substr(g.hash.indexOf(L) + j, 9999);
      else if (g.search.indexOf(L) != -1)
        E = g.search.substr(g.search.indexOf(L) + j, 9999);
      else
        return S;
      return E.indexOf("&") != -1 && (E = E.substr(0, E.indexOf("&"))), E;
    }
    var c = "cmp_proto" in r ? r.cmp_proto : "https:";
    c != "http:" && c != "https:" && (c = "https:");
    var p = "cmp_ref" in r ? r.cmp_ref : location.href, T = t.createElement("script");
    T.setAttribute("data-cmp-ab", "1");
    var h = s("cmpdesign", "cmp_design" in r ? r.cmp_design : ""), u = s("cmpregulationkey", "cmp_regulationkey" in r ? r.cmp_regulationkey : ""), m = s("cmpgppkey", "cmp_gppkey" in r ? r.cmp_gppkey : ""), d = s("cmpatt", "cmp_att" in r ? r.cmp_att : "");
    if (T.src = c + "//" + r.cmp_host + "/delivery/cmp.php?" + ("cmp_id" in r && r.cmp_id > 0 ? "id=" + r.cmp_id : "") + ("cmp_cdid" in r ? "&cdid=" + r.cmp_cdid : "") + "&h=" + encodeURIComponent(p) + (h != "" ? "&cmpdesign=" + encodeURIComponent(h) : "") + (u != "" ? "&cmpregulationkey=" + encodeURIComponent(u) : "") + (m != "" ? "&cmpgppkey=" + encodeURIComponent(m) : "") + (d != "" ? "&cmpatt=" + encodeURIComponent(d) : "") + ("cmp_params" in r ? "&" + r.cmp_params : "") + (t.cookie.length > 0 ? "&__cmpfcc=1" : "") + "&l=" + a.toLowerCase() + "&o=" + (/* @__PURE__ */ new Date()).getTime(), T.type = "text/javascript", T.async = !0, t.currentScript && t.currentScript.parentElement)
      t.currentScript.parentElement.appendChild(T);
    else if (t.body)
      t.body.appendChild(T);
    else {
      var v = n("body");
      v.length == 0 && (v = n("div")), v.length == 0 && (v = n("span")), v.length == 0 && (v = n("ins")), v.length == 0 && (v = n("script")), v.length == 0 && (v = n("head")), v.length > 0 && v[0].appendChild(T);
    }
    var x = "js", k = s("cmpdebugunminimized", "cmpdebugunminimized" in r ? r.cmpdebugunminimized : 0) > 0 ? "" : ".min", I = s("cmpdebugcoverage", "cmp_debugcoverage" in r ? r.cmp_debugcoverage : "");
    I == "1" && (x = "instrumented", k = "");
    var T = t.createElement("script");
    if (T.src = c + "//" + r.cmp_cdn + "/delivery/" + x + "/cmp" + i + k + ".js", T.type = "text/javascript", T.setAttribute("data-cmp-ab", "1"), T.onload = e, T.async = !0, t.currentScript && t.currentScript.parentElement)
      t.currentScript.parentElement.appendChild(T);
    else if (t.body)
      t.body.appendChild(T);
    else {
      var v = n("body");
      v.length == 0 && (v = n("div")), v.length == 0 && (v = n("span")), v.length == 0 && (v = n("ins")), v.length == 0 && (v = n("script")), v.length == 0 && (v = n("head")), v.length > 0 && v[0].appendChild(T);
    }
  }(), window.cmp_addFrame = function(t) {
    if (!window.frames[t])
      if (document.body) {
        var n = document.createElement("iframe");
        n.style.cssText = "display:none", "cmp_cdn" in window && "cmp_ultrablocking" in window && window.cmp_ultrablocking > 0 && (n.src = "//" + window.cmp_cdn + "/delivery/empty.html"), n.name = t, document.body.appendChild(n);
      } else
        window.setTimeout(window.cmp_addFrame, 10, t);
  }, window.cmp_rc = function(t) {
    for (var n = document.cookie, r = "", a = 0; n != "" && a < 100; ) {
      for (a++; n.substr(0, 1) == " "; )
        n = n.substr(1, n.length);
      var i = n.substring(0, n.indexOf("="));
      if (n.indexOf(";") != -1)
        var l = n.substring(n.indexOf("=") + 1, n.indexOf(";"));
      else
        var l = n.substr(n.indexOf("=") + 1, n.length);
      t == i && (r = l);
      var s = n.indexOf(";") + 1;
      s == 0 && (s = n.length), n = n.substring(s, n.length);
    }
    return r;
  }, window.cmp_stub = function() {
    var t = arguments;
    if (__cmp.a = __cmp.a || [], t.length)
      t[0] === "ping" ? t[1] === 2 ? t[2]({
        gdprApplies: gdprAppliesGlobally,
        cmpLoaded: !1,
        cmpStatus: "stub",
        displayStatus: "hidden",
        apiVersion: "2.0",
        cmpId: 31
      }, !0) : t[2](!1, !0) : t[0] === "getUSPData" ? t[2]({
        version: 1,
        uspString: window.cmp_rc("")
      }, !0) : t[0] === "getTCData" ? __cmp.a.push([].slice.apply(t)) : t[0] === "addEventListener" || t[0] === "removeEventListener" ? __cmp.a.push([].slice.apply(t)) : t.length == 4 && t[3] === !1 ? t[2]({}, !1) : __cmp.a.push([].slice.apply(t));
    else
      return __cmp.a;
  }, window.cmp_gpp_ping = function() {
    return {
      gppVersion: "1.0",
      cmpStatus: "stub",
      cmpDisplayStatus: "hidden",
      supportedAPIs: ["tcfca", "usnat", "usca", "usva", "usco", "usut", "usct"],
      cmpId: 31
    };
  }, window.cmp_gppstub = function() {
    var t = arguments;
    if (__gpp.q = __gpp.q || [], !t.length)
      return __gpp.q;
    var n = t[0], r = t.length > 1 ? t[1] : null, a = t.length > 2 ? t[2] : null;
    if (n === "ping")
      return window.cmp_gpp_ping();
    if (n === "addEventListener") {
      __gpp.e = __gpp.e || [], "lastId" in __gpp || (__gpp.lastId = 0), __gpp.lastId++;
      var i = __gpp.lastId;
      return __gpp.e.push({
        id: i,
        callback: r
      }), {
        eventName: "listenerRegistered",
        listenerId: i,
        data: !0,
        pingData: window.cmp_gpp_ping()
      };
    } else if (n === "removeEventListener") {
      var l = !1;
      __gpp.e = __gpp.e || [];
      for (var s = 0; s < __gpp.e.length; s++)
        if (__gpp.e[s].id == a) {
          __gpp.e[s].splice(s, 1), l = !0;
          break;
        }
      return {
        eventName: "listenerRemoved",
        listenerId: a,
        data: l,
        pingData: window.cmp_gpp_ping()
      };
    } else {
      if (n === "getGPPData")
        return {
          sectionId: 3,
          gppVersion: 1,
          sectionList: [],
          applicableSections: [0],
          gppString: "",
          pingData: window.cmp_gpp_ping()
        };
      if (n === "hasSection" || n === "getSection" || n === "getField")
        return null;
      __gpp.q.push([].slice.apply(t));
    }
  }, window.cmp_msghandler = function(t) {
    var n = typeof t.data == "string";
    try {
      var r = n ? JSON.parse(t.data) : t.data;
    } catch {
      var r = null;
    }
    if (typeof r == "object" && r !== null && "__cmpCall" in r) {
      var a = r.__cmpCall;
      window.__cmp(a.command, a.parameter, function(i, l) {
        var s = {
          __cmpReturn: {
            returnValue: i,
            success: l,
            callId: a.callId
          }
        };
        t.source.postMessage(n ? JSON.stringify(s) : s, "*");
      });
    }
    if (typeof r == "object" && r !== null && "__uspapiCall" in r) {
      var a = r.__uspapiCall;
      window.__uspapi(a.command, a.version, function(l, s) {
        var c = {
          __uspapiReturn: {
            returnValue: l,
            success: s,
            callId: a.callId
          }
        };
        t.source.postMessage(n ? JSON.stringify(c) : c, "*");
      });
    }
    if (typeof r == "object" && r !== null && "__tcfapiCall" in r) {
      var a = r.__tcfapiCall;
      window.__tcfapi(a.command, a.version, function(l, s) {
        var c = {
          __tcfapiReturn: {
            returnValue: l,
            success: s,
            callId: a.callId
          }
        };
        t.source.postMessage(n ? JSON.stringify(c) : c, "*");
      }, a.parameter);
    }
    if (typeof r == "object" && r !== null && "__gppCall" in r) {
      var a = r.__gppCall;
      window.__gpp(a.command, function(l, s) {
        var c = {
          __gppReturn: {
            returnValue: l,
            success: s,
            callId: a.callId
          }
        };
        t.source.postMessage(n ? JSON.stringify(c) : c, "*");
      }, "parameter" in a ? a.parameter : null, "version" in a ? a.version : 1);
    }
  }, window.cmp_setStub = function(t) {
    (!(t in window) || typeof window[t] != "function" && typeof window[t] != "object" && (typeof window[t] == "undefined" || window[t] !== null)) && (window[t] = window.cmp_stub, window[t].msgHandler = window.cmp_msghandler, window.addEventListener("message", window.cmp_msghandler, !1));
  }, window.cmp_setGppStub = function(t) {
    (!(t in window) || typeof window[t] != "function" && typeof window[t] != "object" && (typeof window[t] == "undefined" || window[t] !== null)) && (window[t] = window.cmp_gppstub, window[t].msgHandler = window.cmp_msghandler, window.addEventListener("message", window.cmp_msghandler, !1));
  }, window.cmp_addFrame("__cmpLocator"), (!("cmp_disableusp" in window) || !window.cmp_disableusp) && window.cmp_addFrame("__uspapiLocator"), (!("cmp_disabletcf" in window) || !window.cmp_disabletcf) && window.cmp_addFrame("__tcfapiLocator"), (!("cmp_disablegpp" in window) || !window.cmp_disablegpp) && window.cmp_addFrame("__gppLocator"), window.cmp_setStub("__cmp"), (!("cmp_disabletcf" in window) || !window.cmp_disabletcf) && window.cmp_setStub("__tcfapi"), (!("cmp_disableusp" in window) || !window.cmp_disableusp) && window.cmp_setStub("__uspapi"), (!("cmp_disablegpp" in window) || !window.cmp_disablegpp) && window.cmp_setGppStub("__gpp");
};
function zw(e) {
  return new Image().src = `https://delivery.consentmanager.net/delivery/addurl.php?id=${e}&h=${encodeURIComponent(window.location.href)}`;
}
const qw = ({
  isCis: e,
  userLoaded: t,
  isDisabled: n,
  locale: r
}) => {
  const [a, i] = r1(!1), l = is() && !n, {
    setIsAnalyticsAllowed: s
  } = Qi(), c = t && !e, p = J.getShortLocale(r), h = W1(() => {
    J.getUserCMPConsent() && s(!0);
  }, [t]), u = () => {
    i(!1), window.__cmp && window.__cmp("addEventListener", ["consent", h, !1], null);
  };
  return u1(() => {
    t && (l && zw(60055), c && l && !a && (window.cmp_setlang = p, Uw(u)));
  }, [c, a, t]), u1(() => () => {
    window.__cmp && window.__cmp("removeEventListener", ["consent", h, !1], null);
  }, []), null;
}, $w = ({
  isReady: e,
  userId: t
}) => {
  const [n, r] = r1(!1), {
    pushPageView: a,
    pushSetUser: i
  } = le(), {
    isAnalyticsAllowed: l
  } = Qi();
  return u1(() => {
    e && l && !n && (a({
      url: window.location.href
    }), r(!0)), t && i(t);
  }, [e, l, t, n]), null;
}, Yw = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_1328_7117)'%3e%3cpath%20d='M12%2024C18.6274%2024%2024%2018.6274%2024%2012C24%205.37258%2018.6274%200%2012%200C5.37258%200%200%205.37258%200%2012C0%2018.6274%205.37258%2024%2012%2024Z'%20fill='%23F0F0F0'/%3e%3cpath%20d='M2.48032%204.69434C1.53771%205.92073%200.826945%207.33424%200.413086%208.86982H6.6558L2.48032%204.69434Z'%20fill='%230052B4'/%3e%3cpath%20d='M23.5864%208.86977C23.1725%207.33424%2022.4617%205.92073%2021.5191%204.69434L17.3438%208.86977H23.5864Z'%20fill='%230052B4'/%3e%3cpath%20d='M0.413086%2015.1299C0.826992%2016.6654%201.53776%2018.0789%202.48032%2019.3053L6.65566%2015.1299H0.413086Z'%20fill='%230052B4'/%3e%3cpath%20d='M19.3053%202.48037C18.0789%201.53776%2016.6655%200.826992%2015.1299%200.413086V6.65576L19.3053%202.48037Z'%20fill='%230052B4'/%3e%3cpath%20d='M4.69434%2021.5191C5.92073%2022.4617%207.33424%2023.1725%208.86977%2023.5864V17.3438L4.69434%2021.5191Z'%20fill='%230052B4'/%3e%3cpath%20d='M8.86973%200.413086C7.33419%200.826992%205.92068%201.53776%204.69434%202.48032L8.86973%206.65571V0.413086Z'%20fill='%230052B4'/%3e%3cpath%20d='M15.1299%2023.5864C16.6654%2023.1725%2018.0789%2022.4617%2019.3053%2021.5191L15.1299%2017.3438V23.5864Z'%20fill='%230052B4'/%3e%3cpath%20d='M17.3438%2015.1299L21.5191%2019.3053C22.4617%2018.079%2023.1725%2016.6654%2023.5864%2015.1299H17.3438Z'%20fill='%230052B4'/%3e%3cpath%20d='M23.8984%2010.4348H13.5653H13.5653V0.101578C13.0529%200.034875%2012.5305%200%2012%200C11.4694%200%2010.9471%200.034875%2010.4348%200.101578V10.4347V10.4347H0.101578C0.034875%2010.9471%200%2011.4695%200%2012C0%2012.5306%200.034875%2013.0529%200.101578%2013.5652H10.4347H10.4347V23.8984C10.9471%2023.9651%2011.4694%2024%2012%2024C12.5305%2024%2013.0529%2023.9652%2013.5652%2023.8984V13.5653V13.5653H23.8984C23.9651%2013.0529%2024%2012.5306%2024%2012C24%2011.4695%2023.9651%2010.9471%2023.8984%2010.4348Z'%20fill='%23D80027'/%3e%3cpath%20d='M15.1309%2015.1309L20.4857%2020.4857C20.732%2020.2395%2020.9669%2019.9821%2021.191%2019.7153L16.6066%2015.1309H15.1309V15.1309Z'%20fill='%23D80027'/%3e%3cpath%20d='M8.86951%2015.1309H8.86941L3.51465%2020.4856C3.76084%2020.7319%204.01823%2020.9668%204.28504%2021.191L8.86951%2016.6064V15.1309Z'%20fill='%23D80027'/%3e%3cpath%20d='M8.86976%208.8696V8.86951L3.51495%203.51465C3.26866%203.76084%203.03373%204.01823%202.80957%204.28504L7.39409%208.86955H8.86976V8.8696Z'%20fill='%23D80027'/%3e%3cpath%20d='M15.1309%208.8698L20.4857%203.5149C20.2395%203.26862%2019.9821%203.03368%2019.7153%202.80957L15.1309%207.39409V8.8698Z'%20fill='%23D80027'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_1328_7117'%3e%3crect%20width='24'%20height='24'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Kw = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_880_7486)'%3e%3cpath%20d='M12%2024C18.6274%2024%2024%2018.6274%2024%2012C24%205.37258%2018.6274%200%2012%200C5.37258%200%200%205.37258%200%2012C0%2018.6274%205.37258%2024%2012%2024Z'%20fill='%23F0F0F0'/%3e%3cpath%20d='M23.2536%2016.174C23.736%2014.874%2024%2013.4679%2024%2012.0001C24%2010.5322%2023.736%209.12616%2023.2536%207.82617H0.746391C0.264047%209.12616%200%2010.5322%200%2012.0001C0%2013.4679%200.264047%2014.874%200.746391%2016.174L12%2017.2174L23.2536%2016.174Z'%20fill='%230052B4'/%3e%3cpath%20d='M11.9997%2023.9999C17.1593%2023.9999%2021.5578%2020.7434%2023.2533%2016.1738H0.746094C2.44161%2020.7434%206.84012%2023.9999%2011.9997%2023.9999Z'%20fill='%23D80027'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_880_7486'%3e%3crect%20width='24'%20height='24'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Qw = J.query_string(), _i = ["ru_RU", "en_US"], Xw = Qw.lang, xi = {
  ru_RU: {
    label: "Русский язык",
    name: "Русский",
    flag: Kw,
    analyticsLabel: "ru"
  },
  en_US: {
    label: "English",
    name: "English",
    flag: Yw,
    analyticsLabel: "en"
  }
}, Jw = (e) => Object.keys(xi).reduce((t, n) => (e.includes(n) && (t[n] = xi[n]), t), {}), R0 = J.getCookie("amc_lang") || "ru_RU", os = {
  locale: R0,
  profile: void 0,
  session: void 0
}, bt = o2({
  session: os,
  noSession: !1,
  loaded: !1
});
function ey({
  user: e,
  onGetUser: t,
  children: n,
  config: r
}) {
  var T, L;
  const [a, i] = r1(!!e), [l, s] = r1(e && !e.profile || !1), [c, p] = r1(e || os), [h, u] = r1(!1), m = a && J.CIS_REGIONS.includes(c.country_id || ""), d = a && !m, v = is() && d && !r.noCookieBot, x = Hw(), k = () => {
    u(!0);
  }, I = Xe(() => ({
    session: c,
    noSession: l,
    loaded: a
  }), [c, l, a]);
  return u1(() => {
    if (e)
      return;
    (async () => {
      try {
        const E = await J.Backend.get(me.get_user);
        p(E), E.profile || s(!0);
      } catch (E) {
        console.error(E);
      } finally {
        i(!0);
      }
    })();
  }, [e]), u1(() => {
    t && a && t(c), a && (window.country_id = c.country_id);
  }, [a, c]), u1(() => {
    var S, E;
    !((S = c.profile) != null && S.user_id) || r.simplified && !r.enableWSD || (J.WSD.init((E = c.profile) == null ? void 0 : E.user_id, J.Domains.wsd), r.onInitWSD && r.onInitWSD(J.WSD));
  }, [(T = c.profile) == null ? void 0 : T.user_id]), /* @__PURE__ */ f.jsx(bt.Provider, { value: I, children: /* @__PURE__ */ f.jsxs(_l, { project: rs ? "partner" : "eva", onLoad: k, isAnalyticsAllowed: !v, ...x && {
    extraProject: x
  }, children: [
    /* @__PURE__ */ f.jsx(qw, { isCis: m, userLoaded: a, isDisabled: !!r.noCookieBot, locale: c.locale }),
    /* @__PURE__ */ f.jsx($w, { isReady: h, userId: (L = c.session) == null ? void 0 : L.user_id }),
    n
  ] }) });
}
const rt = o2({}), ta = ({
  config: e,
  children: t
}) => {
  const {
    user: n,
    onGetUser: r
  } = e;
  return /* @__PURE__ */ f.jsx(rt.Provider, { value: e, children: /* @__PURE__ */ f.jsx(ey, { ...n && {
    user: n
  }, ...r && {
    onGetUser: r
  }, config: e, children: t }) });
}, ty = /* @__PURE__ */ Object.assign({
  "../i18n/en_US.json": () => import("./en_US-CiY2Z-7L.js").then((e) => e.default),
  "../i18n/ru_RU.json": () => import("./ru_RU-B8AhoUvl.js").then((e) => e.default)
}), U2 = o2({
  lang: R0.split("_")[0],
  locale: R0,
  langsAvailable: _i,
  langsList: xi
}), Ht = ({
  children: e
}) => {
  const {
    session: {
      locale: t
    }
  } = D1(bt), {
    lang: n = Xw,
    langsAvailable: r = _i
  } = D1(rt), a = r.filter((p) => _i.includes(p)), i = (p) => p && a.includes(p) ? p : "", [l, s] = r1(), c = Xe(() => {
    const p = i(n) || i(t) || i(a[0]) || i(R0) || "ru_RU", h = p.split("_"), u = h.join("-");
    return {
      lang: h[0],
      locale: p,
      intlLocale: u,
      langsAvailable: a,
      langsList: Jw(r)
    };
  }, [n, r, t]);
  return u1(() => {
    ty[`../i18n/${c.locale}.json`]().then((p) => {
      s(p);
    }).catch(() => {
      s(void 0);
    });
  }, [c]), l ? /* @__PURE__ */ f.jsx(U2.Provider, { value: c, children: /* @__PURE__ */ f.jsx(xw, { locale: c.intlLocale, messages: l, children: e }) }) : null;
};
async function Li({
  lang: e,
  withSession: t,
  onChangeLang: n
}) {
  const r = () => {
    J.setCookie("amc_lang", e, {
      expires: 31536e3,
      domain: `.${J.DOMAIN}`,
      path: "/"
    }), n ? n(e) : window.location.reload();
  };
  {
    try {
      await J.Backend.post(me.change_language, {
        lang: e
      });
    } catch (a) {
      console.error(a);
    }
    r();
  }
}
const ny = "_lang_duabi_1", ry = "_langList_duabi_7", ay = "_langItem_duabi_18", iy = "_selected_duabi_33", oy = "_selectedIcon_duabi_38", sy = "_mobileLang_duabi_42", ly = "_content_duabi_54", cy = "_closeDialog_duabi_67", uy = "_dropdownButton_duabi_89", dy = "_transparent_duabi_115", fy = "_open_duabi_139", Ct = {
  lang: ny,
  langList: ry,
  langItem: ay,
  selected: iy,
  selectedIcon: oy,
  mobileLang: sy,
  content: ly,
  closeDialog: cy,
  dropdownButton: uy,
  transparent: dy,
  open: fy
}, co = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEwSURBVHgBnVOLUcMwDH1SOkBHCBOQOxigTNCO0BHIBG0n4LMAxwZ0AjoA3HkDMkIHqCMkJ6GOySWFd5c729F7epJlQoLiQRazDMtasCIgb48dCM577FxJVRxPEXHOGTYkuMcIiPB4aoSOPwJGnjHeRZe4DM7XuDMRtp1l/gM55NQyN8GBZs8zxhf+AVIXnLVKk6jxagRdHc9HWDHkAutK/ixpfbLbiASIsbQeFImtHZrAHrlrNM5Xa8g5yVV9lLT1jVWXkocazXpYxYo3z/Ji12MiU2RLwppl3zsSrDuRyfkQOLrV0ZWmth504g4aMB+bD3V5xVrzQV08/RIXLEaHSzn2LkITPbBF3PlpuJaDINA1bcjJUObuHdiW0v9htE2dcK1f0ZZT6Svda/BbKDnCN/j9kDD99zgqAAAAAElFTkSuQmCC", hy = "_dialog_4powu_1", py = "_base_4powu_12", my = "_header_4powu_19", Cy = "_content_4powu_27", gy = "_actions_4powu_34", vy = "_closeIcon_4powu_41", K2 = {
  dialog: hy,
  base: py,
  header: my,
  content: Cy,
  actions: gy,
  closeIcon: vy
};
function wy(e) {
  const {
    open: t,
    onClose: n,
    className: r
  } = e, a = V1(null);
  u1(() => {
    var l, s;
    t ? (l = a.current) == null || l.showModal() : (s = a.current) != null && s.close && a.current.close();
  }, [t]);
  function i() {
    var l;
    (l = a.current) != null && l.close && a.current.close(), n();
  }
  return e.type === "base" ? /* @__PURE__ */ f.jsx("dialog", { ref: a, onCancel: i, className: h1(K2.dialog, r), children: /* @__PURE__ */ f.jsxs("div", { className: K2.base, children: [
    /* @__PURE__ */ f.jsx("h4", { className: K2.header, children: e.header }),
    /* @__PURE__ */ f.jsx("p", { className: K2.content, children: e.content }),
    /* @__PURE__ */ f.jsxs("div", { className: K2.actions, children: [
      /* @__PURE__ */ f.jsx(q1, { onClick: n, mode: "link", children: e.closeBtn }),
      /* @__PURE__ */ f.jsx(q1, { onClick: e.onSuccess, children: e.successBtn })
    ] }),
    /* @__PURE__ */ f.jsx(b1, { name: "close", className: K2.closeIcon, onClick: n })
  ] }) }) : /* @__PURE__ */ f.jsx("dialog", { ref: a, onCancel: i, className: h1(K2.dialog, r), children: e.children });
}
const I3 = {
  language: {
    id: "app.language",
    defaultMessage: "Язык"
  },
  apply: {
    id: "app.apply",
    defaultMessage: "Применить"
  }
};
function yy({
  isOpen: e,
  onClose: t,
  onSelectLang: n,
  onSetLang: r,
  selectedLang: a
}) {
  const {
    langsList: i
  } = D1(U2), {
    formatMessage: l
  } = N1();
  return /* @__PURE__ */ f.jsxs(wy, { open: e, onClose: t, className: Ct.mobileLang, children: [
    /* @__PURE__ */ f.jsx(Je, { className: Ct.closeDialog, onClick: t, children: /* @__PURE__ */ f.jsx(b1, { name: "close" }) }),
    /* @__PURE__ */ f.jsxs("div", { className: Ct.content, children: [
      /* @__PURE__ */ f.jsx("h4", { children: l(I3.language) }),
      /* @__PURE__ */ f.jsx("div", { children: Object.entries(i).map(([s, c]) => (
        // eslint-disable-next-line max-len
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions
        /* @__PURE__ */ f.jsxs("p", { className: h1(Ct.langItem, {
          [Ct.selected]: a === s
        }), onClick: () => n(s), children: [
          /* @__PURE__ */ f.jsx("img", { src: c.flag, alt: c.label }),
          /* @__PURE__ */ f.jsx("span", { children: c.name }),
          a === s && /* @__PURE__ */ f.jsx("img", { src: co, alt: s, className: Ct.selectedIcon })
        ] }, s)
      )) }),
      /* @__PURE__ */ f.jsx(q1, { size: "md", appearance: "accent", mode: "primary", onClick: r, children: l(I3.apply) })
    ] })
  ] });
}
const ir = Math.min, hn = Math.max, N0 = Math.round, s0 = Math.floor, n2 = (e) => ({
  x: e,
  y: e
}), by = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, _y = {
  start: "end",
  end: "start"
};
function Ei(e, t, n) {
  return hn(e, ir(t, n));
}
function Yr(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function vn(e) {
  return e.split("-")[0];
}
function Kr(e) {
  return e.split("-")[1];
}
function ss(e) {
  return e === "x" ? "y" : "x";
}
function uo(e) {
  return e === "y" ? "height" : "width";
}
function or(e) {
  return ["top", "bottom"].includes(vn(e)) ? "y" : "x";
}
function fo(e) {
  return ss(or(e));
}
function xy(e, t, n) {
  n === void 0 && (n = !1);
  const r = Kr(e), a = fo(e), i = uo(a);
  let l = a === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (l = H0(l)), [l, H0(l)];
}
function Ly(e) {
  const t = H0(e);
  return [Mi(e), t, Mi(t)];
}
function Mi(e) {
  return e.replace(/start|end/g, (t) => _y[t]);
}
function Ey(e, t, n) {
  const r = ["left", "right"], a = ["right", "left"], i = ["top", "bottom"], l = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? a : r : t ? r : a;
    case "left":
    case "right":
      return t ? i : l;
    default:
      return [];
  }
}
function My(e, t, n, r) {
  const a = Kr(e);
  let i = Ey(vn(e), n === "start", r);
  return a && (i = i.map((l) => l + "-" + a), t && (i = i.concat(i.map(Mi)))), i;
}
function H0(e) {
  return e.replace(/left|right|bottom|top/g, (t) => by[t]);
}
function ky(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function ls(e) {
  return typeof e != "number" ? ky(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function O0(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: a
  } = e;
  return {
    width: r,
    height: a,
    top: n,
    left: t,
    right: t + r,
    bottom: n + a,
    x: t,
    y: n
  };
}
function R3(e, t, n) {
  let {
    reference: r,
    floating: a
  } = e;
  const i = or(t), l = fo(t), s = uo(l), c = vn(t), p = i === "y", h = r.x + r.width / 2 - a.width / 2, u = r.y + r.height / 2 - a.height / 2, m = r[s] / 2 - a[s] / 2;
  let d;
  switch (c) {
    case "top":
      d = {
        x: h,
        y: r.y - a.height
      };
      break;
    case "bottom":
      d = {
        x: h,
        y: r.y + r.height
      };
      break;
    case "right":
      d = {
        x: r.x + r.width,
        y: u
      };
      break;
    case "left":
      d = {
        x: r.x - a.width,
        y: u
      };
      break;
    default:
      d = {
        x: r.x,
        y: r.y
      };
  }
  switch (Kr(t)) {
    case "start":
      d[l] -= m * (n && p ? -1 : 1);
      break;
    case "end":
      d[l] += m * (n && p ? -1 : 1);
      break;
  }
  return d;
}
const Sy = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: a = "absolute",
    middleware: i = [],
    platform: l
  } = n, s = i.filter(Boolean), c = await (l.isRTL == null ? void 0 : l.isRTL(t));
  let p = await l.getElementRects({
    reference: e,
    floating: t,
    strategy: a
  }), {
    x: h,
    y: u
  } = R3(p, r, c), m = r, d = {}, v = 0;
  for (let x = 0; x < s.length; x++) {
    const {
      name: k,
      fn: I
    } = s[x], {
      x: T,
      y: L,
      data: S,
      reset: E
    } = await I({
      x: h,
      y: u,
      initialPlacement: r,
      placement: m,
      strategy: a,
      middlewareData: d,
      rects: p,
      platform: l,
      elements: {
        reference: e,
        floating: t
      }
    });
    h = T != null ? T : h, u = L != null ? L : u, d = {
      ...d,
      [k]: {
        ...d[k],
        ...S
      }
    }, E && v <= 50 && (v++, typeof E == "object" && (E.placement && (m = E.placement), E.rects && (p = E.rects === !0 ? await l.getElementRects({
      reference: e,
      floating: t,
      strategy: a
    }) : E.rects), {
      x: h,
      y: u
    } = R3(p, m, c)), x = -1);
  }
  return {
    x: h,
    y: u,
    placement: m,
    strategy: a,
    middlewareData: d
  };
};
async function cs(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: a,
    platform: i,
    rects: l,
    elements: s,
    strategy: c
  } = e, {
    boundary: p = "clippingAncestors",
    rootBoundary: h = "viewport",
    elementContext: u = "floating",
    altBoundary: m = !1,
    padding: d = 0
  } = Yr(t, e), v = ls(d), k = s[m ? u === "floating" ? "reference" : "floating" : u], I = O0(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(k))) == null || n ? k : k.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: p,
    rootBoundary: h,
    strategy: c
  })), T = u === "floating" ? {
    x: r,
    y: a,
    width: l.floating.width,
    height: l.floating.height
  } : l.reference, L = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), S = await (i.isElement == null ? void 0 : i.isElement(L)) ? await (i.getScale == null ? void 0 : i.getScale(L)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, E = O0(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: T,
    offsetParent: L,
    strategy: c
  }) : T);
  return {
    top: (I.top - E.top + v.top) / S.y,
    bottom: (E.bottom - I.bottom + v.bottom) / S.y,
    left: (I.left - E.left + v.left) / S.x,
    right: (E.right - I.right + v.right) / S.x
  };
}
const Ay = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: a,
      rects: i,
      platform: l,
      elements: s,
      middlewareData: c
    } = t, {
      element: p,
      padding: h = 0
    } = Yr(e, t) || {};
    if (p == null)
      return {};
    const u = ls(h), m = {
      x: n,
      y: r
    }, d = fo(a), v = uo(d), x = await l.getDimensions(p), k = d === "y", I = k ? "top" : "left", T = k ? "bottom" : "right", L = k ? "clientHeight" : "clientWidth", S = i.reference[v] + i.reference[d] - m[d] - i.floating[v], E = m[d] - i.reference[d], j = await (l.getOffsetParent == null ? void 0 : l.getOffsetParent(p));
    let g = j ? j[L] : 0;
    (!g || !await (l.isElement == null ? void 0 : l.isElement(j))) && (g = s.floating[L] || i.floating[v]);
    const w = S / 2 - E / 2, C = g / 2 - x[v] / 2 - 1, b = ir(u[I], C), M = ir(u[T], C), R = b, O = g - x[v] - M, N = g / 2 - x[v] / 2 + w, H = Ei(R, N, O), Z = !c.arrow && Kr(a) != null && N !== H && i.reference[v] / 2 - (N < R ? b : M) - x[v] / 2 < 0, z = Z ? N < R ? N - R : N - O : 0;
    return {
      [d]: m[d] + z,
      data: {
        [d]: H,
        centerOffset: N - H - z,
        ...Z && {
          alignmentOffset: z
        }
      },
      reset: Z
    };
  }
}), Ty = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: a,
        middlewareData: i,
        rects: l,
        initialPlacement: s,
        platform: c,
        elements: p
      } = t, {
        mainAxis: h = !0,
        crossAxis: u = !0,
        fallbackPlacements: m,
        fallbackStrategy: d = "bestFit",
        fallbackAxisSideDirection: v = "none",
        flipAlignment: x = !0,
        ...k
      } = Yr(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const I = vn(a), T = or(s), L = vn(s) === s, S = await (c.isRTL == null ? void 0 : c.isRTL(p.floating)), E = m || (L || !x ? [H0(s)] : Ly(s)), j = v !== "none";
      !m && j && E.push(...My(s, x, v, S));
      const g = [s, ...E], w = await cs(t, k), C = [];
      let b = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (h && C.push(w[I]), u) {
        const N = xy(a, l, S);
        C.push(w[N[0]], w[N[1]]);
      }
      if (b = [...b, {
        placement: a,
        overflows: C
      }], !C.every((N) => N <= 0)) {
        var M, R;
        const N = (((M = i.flip) == null ? void 0 : M.index) || 0) + 1, H = g[N];
        if (H)
          return {
            data: {
              index: N,
              overflows: b
            },
            reset: {
              placement: H
            }
          };
        let Z = (R = b.filter((z) => z.overflows[0] <= 0).sort((z, K) => z.overflows[1] - K.overflows[1])[0]) == null ? void 0 : R.placement;
        if (!Z)
          switch (d) {
            case "bestFit": {
              var O;
              const z = (O = b.filter((K) => {
                if (j) {
                  const D = or(K.placement);
                  return D === T || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  D === "y";
                }
                return !0;
              }).map((K) => [K.placement, K.overflows.filter((D) => D > 0).reduce((D, W) => D + W, 0)]).sort((K, D) => K[1] - D[1])[0]) == null ? void 0 : O[0];
              z && (Z = z);
              break;
            }
            case "initialPlacement":
              Z = s;
              break;
          }
        if (a !== Z)
          return {
            reset: {
              placement: Z
            }
          };
      }
      return {};
    }
  };
};
async function Iy(e, t) {
  const {
    placement: n,
    platform: r,
    elements: a
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(a.floating)), l = vn(n), s = Kr(n), c = or(n) === "y", p = ["left", "top"].includes(l) ? -1 : 1, h = i && c ? -1 : 1, u = Yr(t, e);
  let {
    mainAxis: m,
    crossAxis: d,
    alignmentAxis: v
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: u.mainAxis || 0,
    crossAxis: u.crossAxis || 0,
    alignmentAxis: u.alignmentAxis
  };
  return s && typeof v == "number" && (d = s === "end" ? v * -1 : v), c ? {
    x: d * h,
    y: m * p
  } : {
    x: m * p,
    y: d * h
  };
}
const Ry = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: a,
        y: i,
        placement: l,
        middlewareData: s
      } = t, c = await Iy(t, e);
      return l === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: a + c.x,
        y: i + c.y,
        data: {
          ...c,
          placement: l
        }
      };
    }
  };
}, Ny = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: a
      } = t, {
        mainAxis: i = !0,
        crossAxis: l = !1,
        limiter: s = {
          fn: (k) => {
            let {
              x: I,
              y: T
            } = k;
            return {
              x: I,
              y: T
            };
          }
        },
        ...c
      } = Yr(e, t), p = {
        x: n,
        y: r
      }, h = await cs(t, c), u = or(vn(a)), m = ss(u);
      let d = p[m], v = p[u];
      if (i) {
        const k = m === "y" ? "top" : "left", I = m === "y" ? "bottom" : "right", T = d + h[k], L = d - h[I];
        d = Ei(T, d, L);
      }
      if (l) {
        const k = u === "y" ? "top" : "left", I = u === "y" ? "bottom" : "right", T = v + h[k], L = v - h[I];
        v = Ei(T, v, L);
      }
      const x = s.fn({
        ...t,
        [m]: d,
        [u]: v
      });
      return {
        ...x,
        data: {
          x: x.x - n,
          y: x.y - r,
          enabled: {
            [m]: i,
            [u]: l
          }
        }
      };
    }
  };
};
function na() {
  return typeof window != "undefined";
}
function dr(e) {
  return us(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function yt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function l2(e) {
  var t;
  return (t = (us(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function us(e) {
  return na() ? e instanceof Node || e instanceof yt(e).Node : !1;
}
function Zt(e) {
  return na() ? e instanceof Element || e instanceof yt(e).Element : !1;
}
function i2(e) {
  return na() ? e instanceof HTMLElement || e instanceof yt(e).HTMLElement : !1;
}
function N3(e) {
  return !na() || typeof ShadowRoot == "undefined" ? !1 : e instanceof ShadowRoot || e instanceof yt(e).ShadowRoot;
}
function Qr(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: a
  } = Gt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(a);
}
function Hy(e) {
  return ["table", "td", "th"].includes(dr(e));
}
function ra(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function ho(e) {
  const t = po(), n = Zt(e) ? Gt(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function Oy(e) {
  let t = F2(e);
  for (; i2(t) && !sr(t); ) {
    if (ho(t))
      return t;
    if (ra(t))
      return null;
    t = F2(t);
  }
  return null;
}
function po() {
  return typeof CSS == "undefined" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function sr(e) {
  return ["html", "body", "#document"].includes(dr(e));
}
function Gt(e) {
  return yt(e).getComputedStyle(e);
}
function aa(e) {
  return Zt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function F2(e) {
  if (dr(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    N3(e) && e.host || // Fallback.
    l2(e)
  );
  return N3(t) ? t.host : t;
}
function ds(e) {
  const t = F2(e);
  return sr(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : i2(t) && Qr(t) ? t : ds(t);
}
function Hr(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const a = ds(e), i = a === ((r = e.ownerDocument) == null ? void 0 : r.body), l = yt(a);
  if (i) {
    const s = ki(l);
    return t.concat(l, l.visualViewport || [], Qr(a) ? a : [], s && n ? Hr(s) : []);
  }
  return t.concat(a, Hr(a, [], n));
}
function ki(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function fs(e) {
  const t = Gt(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const a = i2(e), i = a ? e.offsetWidth : n, l = a ? e.offsetHeight : r, s = N0(n) !== i || N0(r) !== l;
  return s && (n = i, r = l), {
    width: n,
    height: r,
    $: s
  };
}
function mo(e) {
  return Zt(e) ? e : e.contextElement;
}
function Pn(e) {
  const t = mo(e);
  if (!i2(t))
    return n2(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: a,
    $: i
  } = fs(t);
  let l = (i ? N0(n.width) : n.width) / r, s = (i ? N0(n.height) : n.height) / a;
  return (!l || !Number.isFinite(l)) && (l = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: l,
    y: s
  };
}
const jy = /* @__PURE__ */ n2(0);
function hs(e) {
  const t = yt(e);
  return !po() || !t.visualViewport ? jy : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Py(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== yt(e) ? !1 : t;
}
function wn(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const a = e.getBoundingClientRect(), i = mo(e);
  let l = n2(1);
  t && (r ? Zt(r) && (l = Pn(r)) : l = Pn(e));
  const s = Py(i, n, r) ? hs(i) : n2(0);
  let c = (a.left + s.x) / l.x, p = (a.top + s.y) / l.y, h = a.width / l.x, u = a.height / l.y;
  if (i) {
    const m = yt(i), d = r && Zt(r) ? yt(r) : r;
    let v = m, x = ki(v);
    for (; x && r && d !== v; ) {
      const k = Pn(x), I = x.getBoundingClientRect(), T = Gt(x), L = I.left + (x.clientLeft + parseFloat(T.paddingLeft)) * k.x, S = I.top + (x.clientTop + parseFloat(T.paddingTop)) * k.y;
      c *= k.x, p *= k.y, h *= k.x, u *= k.y, c += L, p += S, v = yt(x), x = ki(v);
    }
  }
  return O0({
    width: h,
    height: u,
    x: c,
    y: p
  });
}
function Co(e, t) {
  const n = aa(e).scrollLeft;
  return t ? t.left + n : wn(l2(e)).left + n;
}
function ps(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), a = r.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    Co(e, r)
  )), i = r.top + t.scrollTop;
  return {
    x: a,
    y: i
  };
}
function Dy(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: a
  } = e;
  const i = a === "fixed", l = l2(r), s = t ? ra(t.floating) : !1;
  if (r === l || s && i)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, p = n2(1);
  const h = n2(0), u = i2(r);
  if ((u || !u && !i) && ((dr(r) !== "body" || Qr(l)) && (c = aa(r)), i2(r))) {
    const d = wn(r);
    p = Pn(r), h.x = d.x + r.clientLeft, h.y = d.y + r.clientTop;
  }
  const m = l && !u && !i ? ps(l, c, !0) : n2(0);
  return {
    width: n.width * p.x,
    height: n.height * p.y,
    x: n.x * p.x - c.scrollLeft * p.x + h.x + m.x,
    y: n.y * p.y - c.scrollTop * p.y + h.y + m.y
  };
}
function Vy(e) {
  return Array.from(e.getClientRects());
}
function By(e) {
  const t = l2(e), n = aa(e), r = e.ownerDocument.body, a = hn(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = hn(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let l = -n.scrollLeft + Co(e);
  const s = -n.scrollTop;
  return Gt(r).direction === "rtl" && (l += hn(t.clientWidth, r.clientWidth) - a), {
    width: a,
    height: i,
    x: l,
    y: s
  };
}
function Fy(e, t) {
  const n = yt(e), r = l2(e), a = n.visualViewport;
  let i = r.clientWidth, l = r.clientHeight, s = 0, c = 0;
  if (a) {
    i = a.width, l = a.height;
    const p = po();
    (!p || p && t === "fixed") && (s = a.offsetLeft, c = a.offsetTop);
  }
  return {
    width: i,
    height: l,
    x: s,
    y: c
  };
}
function Zy(e, t) {
  const n = wn(e, !0, t === "fixed"), r = n.top + e.clientTop, a = n.left + e.clientLeft, i = i2(e) ? Pn(e) : n2(1), l = e.clientWidth * i.x, s = e.clientHeight * i.y, c = a * i.x, p = r * i.y;
  return {
    width: l,
    height: s,
    x: c,
    y: p
  };
}
function H3(e, t, n) {
  let r;
  if (t === "viewport")
    r = Fy(e, n);
  else if (t === "document")
    r = By(l2(e));
  else if (Zt(t))
    r = Zy(t, n);
  else {
    const a = hs(e);
    r = {
      x: t.x - a.x,
      y: t.y - a.y,
      width: t.width,
      height: t.height
    };
  }
  return O0(r);
}
function ms(e, t) {
  const n = F2(e);
  return n === t || !Zt(n) || sr(n) ? !1 : Gt(n).position === "fixed" || ms(n, t);
}
function Gy(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Hr(e, [], !1).filter((s) => Zt(s) && dr(s) !== "body"), a = null;
  const i = Gt(e).position === "fixed";
  let l = i ? F2(e) : e;
  for (; Zt(l) && !sr(l); ) {
    const s = Gt(l), c = ho(l);
    !c && s.position === "fixed" && (a = null), (i ? !c && !a : !c && s.position === "static" && !!a && ["absolute", "fixed"].includes(a.position) || Qr(l) && !c && ms(e, l)) ? r = r.filter((h) => h !== l) : a = s, l = F2(l);
  }
  return t.set(e, r), r;
}
function Wy(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: a
  } = e;
  const l = [...n === "clippingAncestors" ? ra(t) ? [] : Gy(t, this._c) : [].concat(n), r], s = l[0], c = l.reduce((p, h) => {
    const u = H3(t, h, a);
    return p.top = hn(u.top, p.top), p.right = ir(u.right, p.right), p.bottom = ir(u.bottom, p.bottom), p.left = hn(u.left, p.left), p;
  }, H3(t, s, a));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function Uy(e) {
  const {
    width: t,
    height: n
  } = fs(e);
  return {
    width: t,
    height: n
  };
}
function zy(e, t, n) {
  const r = i2(t), a = l2(t), i = n === "fixed", l = wn(e, !0, i, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = n2(0);
  if (r || !r && !i)
    if ((dr(t) !== "body" || Qr(a)) && (s = aa(t)), r) {
      const m = wn(t, !0, i, t);
      c.x = m.x + t.clientLeft, c.y = m.y + t.clientTop;
    } else a && (c.x = Co(a));
  const p = a && !r && !i ? ps(a, s) : n2(0), h = l.left + s.scrollLeft - c.x - p.x, u = l.top + s.scrollTop - c.y - p.y;
  return {
    x: h,
    y: u,
    width: l.width,
    height: l.height
  };
}
function Aa(e) {
  return Gt(e).position === "static";
}
function O3(e, t) {
  if (!i2(e) || Gt(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return l2(e) === n && (n = n.ownerDocument.body), n;
}
function Cs(e, t) {
  const n = yt(e);
  if (ra(e))
    return n;
  if (!i2(e)) {
    let a = F2(e);
    for (; a && !sr(a); ) {
      if (Zt(a) && !Aa(a))
        return a;
      a = F2(a);
    }
    return n;
  }
  let r = O3(e, t);
  for (; r && Hy(r) && Aa(r); )
    r = O3(r, t);
  return r && sr(r) && Aa(r) && !ho(r) ? n : r || Oy(e) || n;
}
const qy = async function(e) {
  const t = this.getOffsetParent || Cs, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: zy(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function $y(e) {
  return Gt(e).direction === "rtl";
}
const Yy = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Dy,
  getDocumentElement: l2,
  getClippingRect: Wy,
  getOffsetParent: Cs,
  getElementRects: qy,
  getClientRects: Vy,
  getDimensions: Uy,
  getScale: Pn,
  isElement: Zt,
  isRTL: $y
};
function gs(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Ky(e, t) {
  let n = null, r;
  const a = l2(e);
  function i() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function l(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), i();
    const p = e.getBoundingClientRect(), {
      left: h,
      top: u,
      width: m,
      height: d
    } = p;
    if (s || t(), !m || !d)
      return;
    const v = s0(u), x = s0(a.clientWidth - (h + m)), k = s0(a.clientHeight - (u + d)), I = s0(h), L = {
      rootMargin: -v + "px " + -x + "px " + -k + "px " + -I + "px",
      threshold: hn(0, ir(1, c)) || 1
    };
    let S = !0;
    function E(j) {
      const g = j[0].intersectionRatio;
      if (g !== c) {
        if (!S)
          return l();
        g ? l(!1, g) : r = setTimeout(() => {
          l(!1, 1e-7);
        }, 1e3);
      }
      g === 1 && !gs(p, e.getBoundingClientRect()) && l(), S = !1;
    }
    try {
      n = new IntersectionObserver(E, {
        ...L,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(E, L);
    }
    n.observe(e);
  }
  return l(!0), i;
}
function Qy(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: i = !0,
    elementResize: l = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, p = mo(e), h = a || i ? [...p ? Hr(p) : [], ...Hr(t)] : [];
  h.forEach((I) => {
    a && I.addEventListener("scroll", n, {
      passive: !0
    }), i && I.addEventListener("resize", n);
  });
  const u = p && s ? Ky(p, n) : null;
  let m = -1, d = null;
  l && (d = new ResizeObserver((I) => {
    let [T] = I;
    T && T.target === p && d && (d.unobserve(t), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var L;
      (L = d) == null || L.observe(t);
    })), n();
  }), p && !c && d.observe(p), d.observe(t));
  let v, x = c ? wn(e) : null;
  c && k();
  function k() {
    const I = wn(e);
    x && !gs(x, I) && n(), x = I, v = requestAnimationFrame(k);
  }
  return n(), () => {
    var I;
    h.forEach((T) => {
      a && T.removeEventListener("scroll", n), i && T.removeEventListener("resize", n);
    }), u == null || u(), (I = d) == null || I.disconnect(), d = null, c && cancelAnimationFrame(v);
  };
}
const vs = Ry, Xy = Ny, Jy = Ty, eb = Ay, j3 = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), a = {
    platform: Yy,
    ...n
  }, i = {
    ...a.platform,
    _c: r
  };
  return Sy(e, t, {
    ...a,
    platform: i
  });
};
/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/
const tb = "react-tooltip-core-styles", nb = "react-tooltip-base-styles", P3 = { core: !1, base: !1 };
function D3({ css: e, id: t = nb, type: n = "base", ref: r }) {
  var a, i;
  if (!e || typeof document == "undefined" || P3[n] || n === "core" && typeof process != "undefined" && (!((a = process == null ? void 0 : process.env) === null || a === void 0) && a.REACT_TOOLTIP_DISABLE_CORE_STYLES) || n !== "base" && typeof process != "undefined" && (!((i = process == null ? void 0 : process.env) === null || i === void 0) && i.REACT_TOOLTIP_DISABLE_BASE_STYLES)) return;
  n === "core" && (t = tb), r || (r = {});
  const { insertAt: l } = r;
  if (document.getElementById(t)) return;
  const s = document.head || document.getElementsByTagName("head")[0], c = document.createElement("style");
  c.id = t, c.type = "text/css", l === "top" && s.firstChild ? s.insertBefore(c, s.firstChild) : s.appendChild(c), c.styleSheet ? c.styleSheet.cssText = e : c.appendChild(document.createTextNode(e)), P3[n] = !0;
}
const V3 = async ({ elementReference: e = null, tooltipReference: t = null, tooltipArrowReference: n = null, place: r = "top", offset: a = 10, strategy: i = "absolute", middlewares: l = [vs(Number(a)), Jy({ fallbackAxisSideDirection: "start" }), Xy({ padding: 5 })], border: s }) => {
  if (!e) return { tooltipStyles: {}, tooltipArrowStyles: {}, place: r };
  if (t === null) return { tooltipStyles: {}, tooltipArrowStyles: {}, place: r };
  const c = l;
  return n ? (c.push(eb({ element: n, padding: 5 })), j3(e, t, { placement: r, strategy: i, middleware: c }).then(({ x: p, y: h, placement: u, middlewareData: m }) => {
    var d, v;
    const x = { left: `${p}px`, top: `${h}px`, border: s }, { x: k, y: I } = (d = m.arrow) !== null && d !== void 0 ? d : { x: 0, y: 0 }, T = (v = { top: "bottom", right: "left", bottom: "top", left: "right" }[u.split("-")[0]]) !== null && v !== void 0 ? v : "bottom", L = s && { borderBottom: s, borderRight: s };
    let S = 0;
    if (s) {
      const E = `${s}`.match(/(\d+)px/);
      S = E != null && E[1] ? Number(E[1]) : 1;
    }
    return { tooltipStyles: x, tooltipArrowStyles: { left: k != null ? `${k}px` : "", top: I != null ? `${I}px` : "", right: "", bottom: "", ...L, [T]: `-${4 + S}px` }, place: u };
  })) : j3(e, t, { placement: "bottom", strategy: i, middleware: c }).then(({ x: p, y: h, placement: u }) => ({ tooltipStyles: { left: `${p}px`, top: `${h}px` }, tooltipArrowStyles: {}, place: u }));
}, B3 = (e, t) => !("CSS" in window && "supports" in window.CSS) || window.CSS.supports(e, t), F3 = (e, t, n) => {
  let r = null;
  const a = function(...i) {
    const l = () => {
      r = null;
    };
    !r && (e.apply(this, i), r = setTimeout(l, t));
  };
  return a.cancel = () => {
    r && (clearTimeout(r), r = null);
  }, a;
}, Z3 = (e) => e !== null && !Array.isArray(e) && typeof e == "object", Si = (e, t) => {
  if (e === t) return !0;
  if (Array.isArray(e) && Array.isArray(t)) return e.length === t.length && e.every((a, i) => Si(a, t[i]));
  if (Array.isArray(e) !== Array.isArray(t)) return !1;
  if (!Z3(e) || !Z3(t)) return e === t;
  const n = Object.keys(e), r = Object.keys(t);
  return n.length === r.length && n.every((a) => Si(e[a], t[a]));
}, rb = (e) => {
  if (!(e instanceof HTMLElement || e instanceof SVGElement)) return !1;
  const t = getComputedStyle(e);
  return ["overflow", "overflow-x", "overflow-y"].some((n) => {
    const r = t.getPropertyValue(n);
    return r === "auto" || r === "scroll";
  });
}, G3 = (e) => {
  if (!e) return null;
  let t = e.parentElement;
  for (; t; ) {
    if (rb(t)) return t;
    t = t.parentElement;
  }
  return document.scrollingElement || document.documentElement;
}, ab = typeof window != "undefined" ? _n : u1, Lt = (e) => {
  e.current && (clearTimeout(e.current), e.current = null);
}, ib = "DEFAULT_TOOLTIP_ID", ob = { anchorRefs: /* @__PURE__ */ new Set(), activeAnchor: { current: null }, attach: () => {
}, detach: () => {
}, setActiveAnchor: () => {
} }, sb = o2({ getTooltipData: () => ob });
function ws(e = ib) {
  return D1(sb).getTooltipData(e);
}
var An = { tooltip: "core-styles-module_tooltip__3vRRp", fixed: "core-styles-module_fixed__pcSol", arrow: "core-styles-module_arrow__cvMwQ", noArrow: "core-styles-module_noArrow__xock6", clickable: "core-styles-module_clickable__ZuTTB", show: "core-styles-module_show__Nt9eE", closing: "core-styles-module_closing__sGnxF" }, Ta = { tooltip: "styles-module_tooltip__mnnfp", arrow: "styles-module_arrow__K0L3T", dark: "styles-module_dark__xNqje", light: "styles-module_light__Z6W-X", success: "styles-module_success__A2AKt", warning: "styles-module_warning__SCK0X", error: "styles-module_error__JvumD", info: "styles-module_info__BWdHW" };
const lb = ({ forwardRef: e, id: t, className: n, classNameArrow: r, variant: a = "dark", anchorId: i, anchorSelect: l, place: s = "top", offset: c = 10, events: p = ["hover"], openOnClick: h = !1, positionStrategy: u = "absolute", middlewares: m, wrapper: d, delayShow: v = 0, delayHide: x = 0, float: k = !1, hidden: I = !1, noArrow: T = !1, clickable: L = !1, closeOnEsc: S = !1, closeOnScroll: E = !1, closeOnResize: j = !1, openEvents: g, closeEvents: w, globalCloseEvents: C, imperativeModeOnly: b, style: M, position: R, afterShow: O, afterHide: N, disableTooltip: H, content: Z, contentWrapperRef: z, isOpen: K, defaultIsOpen: D = !1, setIsOpen: W, activeAnchor: q, setActiveAnchor: e1, border: o1, opacity: c1, arrowColor: v1, role: m1 = "tooltip" }) => {
  var $;
  const n1 = V1(null), d1 = V1(null), f1 = V1(null), M1 = V1(null), Y = V1(null), [P1, J1] = r1({ tooltipStyles: {}, tooltipArrowStyles: {}, place: s }), [I1, ce] = r1(!1), [ve, oe] = r1(!1), [x1, ae] = r1(null), ke = V1(!1), Ie = V1(null), { anchorRefs: ye, setActiveAnchor: Ye } = ws(t), Ne = V1(!1), [K1, be] = r1([]), He = V1(!1), Oe = h || p.includes("click"), Pe = Oe || (g == null ? void 0 : g.click) || (g == null ? void 0 : g.dblclick) || (g == null ? void 0 : g.mousedown), Ze = g ? { ...g } : { mouseover: !0, focus: !0, mouseenter: !1, click: !1, dblclick: !1, mousedown: !1 };
  !g && Oe && Object.assign(Ze, { mouseenter: !1, focus: !1, mouseover: !1, click: !0 });
  const Re = w ? { ...w } : { mouseout: !0, blur: !0, mouseleave: !1, click: !1, dblclick: !1, mouseup: !1 };
  !w && Oe && Object.assign(Re, { mouseleave: !1, blur: !1, mouseout: !1 });
  const ne = C ? { ...C } : { escape: S || !1, scroll: E || !1, resize: j || !1, clickOutsideAnchor: Pe || !1 };
  b && (Object.assign(Ze, { mouseover: !1, focus: !1, mouseenter: !1, click: !1, dblclick: !1, mousedown: !1 }), Object.assign(Re, { mouseout: !1, blur: !1, mouseleave: !1, click: !1, dblclick: !1, mouseup: !1 }), Object.assign(ne, { escape: !1, scroll: !1, resize: !1, clickOutsideAnchor: !1 })), ab(() => (He.current = !0, () => {
    He.current = !1;
  }), []);
  const A1 = (A) => {
    He.current && (A && oe(!0), setTimeout(() => {
      He.current && (W == null || W(A), K === void 0 && ce(A));
    }, 10));
  };
  u1(() => {
    if (K === void 0) return () => null;
    K && oe(!0);
    const A = setTimeout(() => {
      ce(K);
    }, 10);
    return () => {
      clearTimeout(A);
    };
  }, [K]), u1(() => {
    if (I1 !== ke.current) if (Lt(Y), ke.current = I1, I1) O == null || O();
    else {
      const A = ((G) => {
        const U = G.match(/^([\d.]+)(ms|s)$/);
        if (!U) return 0;
        const [, s1, E1] = U;
        return Number(s1) * (E1 === "ms" ? 1 : 1e3);
      })(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));
      Y.current = setTimeout(() => {
        oe(!1), ae(null), N == null || N();
      }, A + 25);
    }
  }, [I1]);
  const ze = (A) => {
    J1((G) => Si(G, A) ? G : A);
  }, _e = (A = v) => {
    Lt(f1), ve ? A1(!0) : f1.current = setTimeout(() => {
      A1(!0);
    }, A);
  }, De = (A = x) => {
    Lt(M1), M1.current = setTimeout(() => {
      Ne.current || A1(!1);
    }, A);
  }, je = (A) => {
    var G;
    if (!A) return;
    const U = (G = A.currentTarget) !== null && G !== void 0 ? G : A.target;
    if (!(U != null && U.isConnected)) return e1(null), void Ye({ current: null });
    v ? _e() : A1(!0), e1(U), Ye({ current: U }), Lt(M1);
  }, Se = () => {
    L ? De(x || 100) : x ? De() : A1(!1), Lt(f1);
  }, se = ({ x: A, y: G }) => {
    var U;
    const s1 = { getBoundingClientRect: () => ({ x: A, y: G, width: 0, height: 0, top: G, left: A, right: A, bottom: G }) };
    V3({ place: (U = x1 == null ? void 0 : x1.place) !== null && U !== void 0 ? U : s, offset: c, elementReference: s1, tooltipReference: n1.current, tooltipArrowReference: d1.current, strategy: u, middlewares: m, border: o1 }).then((E1) => {
      ze(E1);
    });
  }, xe = (A) => {
    if (!A) return;
    const G = A, U = { x: G.clientX, y: G.clientY };
    se(U), Ie.current = U;
  }, Le = (A) => {
    var G;
    if (!I1) return;
    const U = A.target;
    U.isConnected && (!((G = n1.current) === null || G === void 0) && G.contains(U) || [document.querySelector(`[id='${i}']`), ...K1].some((s1) => s1 == null ? void 0 : s1.contains(U)) || (A1(!1), Lt(f1)));
  }, Ee = F3(je, 50), Z1 = F3(Se, 50), C1 = (A) => {
    Z1.cancel(), Ee(A);
  }, Q = () => {
    Ee.cancel(), Z1();
  }, a1 = W1(() => {
    var A, G;
    const U = (A = x1 == null ? void 0 : x1.position) !== null && A !== void 0 ? A : R;
    U ? se(U) : k ? Ie.current && se(Ie.current) : q != null && q.isConnected && V3({ place: (G = x1 == null ? void 0 : x1.place) !== null && G !== void 0 ? G : s, offset: c, elementReference: q, tooltipReference: n1.current, tooltipArrowReference: d1.current, strategy: u, middlewares: m, border: o1 }).then((s1) => {
      He.current && ze(s1);
    });
  }, [I1, q, Z, M, s, x1 == null ? void 0 : x1.place, c, u, R, x1 == null ? void 0 : x1.position, k]);
  u1(() => {
    var A, G;
    const U = new Set(ye);
    K1.forEach((T1) => {
      H != null && H(T1) || U.add({ current: T1 });
    });
    const s1 = document.querySelector(`[id='${i}']`);
    s1 && !(H != null && H(s1)) && U.add({ current: s1 });
    const E1 = () => {
      A1(!1);
    }, O1 = G3(q), R1 = G3(n1.current);
    ne.scroll && (window.addEventListener("scroll", E1), O1 == null || O1.addEventListener("scroll", E1), R1 == null || R1.addEventListener("scroll", E1));
    let y = null;
    ne.resize ? window.addEventListener("resize", E1) : q && n1.current && (y = Qy(q, n1.current, a1, { ancestorResize: !0, elementResize: !0, layoutShift: !0 }));
    const P = (T1) => {
      T1.key === "Escape" && A1(!1);
    };
    ne.escape && window.addEventListener("keydown", P), ne.clickOutsideAnchor && window.addEventListener("click", Le);
    const F = [], t1 = (T1) => !!(T1 != null && T1.target && (q != null && q.contains(T1.target))), w1 = (T1) => {
      I1 && t1(T1) || je(T1);
    }, L1 = (T1) => {
      I1 && t1(T1) && Se();
    }, g1 = ["mouseover", "mouseout", "mouseenter", "mouseleave", "focus", "blur"], p1 = ["click", "dblclick", "mousedown", "mouseup"];
    Object.entries(Ze).forEach(([T1, Ce]) => {
      Ce && (g1.includes(T1) ? F.push({ event: T1, listener: C1 }) : p1.includes(T1) && F.push({ event: T1, listener: w1 }));
    }), Object.entries(Re).forEach(([T1, Ce]) => {
      Ce && (g1.includes(T1) ? F.push({ event: T1, listener: Q }) : p1.includes(T1) && F.push({ event: T1, listener: L1 }));
    }), k && F.push({ event: "pointermove", listener: xe });
    const X1 = () => {
      Ne.current = !0;
    }, y1 = () => {
      Ne.current = !1, Se();
    }, H1 = L && (Re.mouseout || Re.mouseleave);
    return H1 && ((A = n1.current) === null || A === void 0 || A.addEventListener("mouseover", X1), (G = n1.current) === null || G === void 0 || G.addEventListener("mouseout", y1)), F.forEach(({ event: T1, listener: Ce }) => {
      U.forEach((Ge) => {
        var Y1;
        (Y1 = Ge.current) === null || Y1 === void 0 || Y1.addEventListener(T1, Ce);
      });
    }), () => {
      var T1, Ce;
      ne.scroll && (window.removeEventListener("scroll", E1), O1 == null || O1.removeEventListener("scroll", E1), R1 == null || R1.removeEventListener("scroll", E1)), ne.resize ? window.removeEventListener("resize", E1) : y == null || y(), ne.clickOutsideAnchor && window.removeEventListener("click", Le), ne.escape && window.removeEventListener("keydown", P), H1 && ((T1 = n1.current) === null || T1 === void 0 || T1.removeEventListener("mouseover", X1), (Ce = n1.current) === null || Ce === void 0 || Ce.removeEventListener("mouseout", y1)), F.forEach(({ event: Ge, listener: Y1 }) => {
        U.forEach((u2) => {
          var z2;
          (z2 = u2.current) === null || z2 === void 0 || z2.removeEventListener(Ge, Y1);
        });
      });
    };
  }, [q, a1, ve, ye, K1, g, w, C, Oe, v, x]), u1(() => {
    var A, G;
    let U = (G = (A = x1 == null ? void 0 : x1.anchorSelect) !== null && A !== void 0 ? A : l) !== null && G !== void 0 ? G : "";
    !U && t && (U = `[data-tooltip-id='${t.replace(/'/g, "\\'")}']`);
    const s1 = new MutationObserver((E1) => {
      const O1 = [], R1 = [];
      E1.forEach((y) => {
        if (y.type === "attributes" && y.attributeName === "data-tooltip-id" && (y.target.getAttribute("data-tooltip-id") === t ? O1.push(y.target) : y.oldValue === t && R1.push(y.target)), y.type === "childList") {
          if (q) {
            const P = [...y.removedNodes].filter((F) => F.nodeType === 1);
            if (U) try {
              R1.push(...P.filter((F) => F.matches(U))), R1.push(...P.flatMap((F) => [...F.querySelectorAll(U)]));
            } catch {
            }
            P.some((F) => {
              var t1;
              return !!(!((t1 = F == null ? void 0 : F.contains) === null || t1 === void 0) && t1.call(F, q)) && (oe(!1), A1(!1), e1(null), Lt(f1), Lt(M1), !0);
            });
          }
          if (U) try {
            const P = [...y.addedNodes].filter((F) => F.nodeType === 1);
            O1.push(...P.filter((F) => F.matches(U))), O1.push(...P.flatMap((F) => [...F.querySelectorAll(U)]));
          } catch {
          }
        }
      }), (O1.length || R1.length) && be((y) => [...y.filter((P) => !R1.includes(P)), ...O1]);
    });
    return s1.observe(document.body, { childList: !0, subtree: !0, attributes: !0, attributeFilter: ["data-tooltip-id"], attributeOldValue: !0 }), () => {
      s1.disconnect();
    };
  }, [t, l, x1 == null ? void 0 : x1.anchorSelect, q]), u1(() => {
    a1();
  }, [a1]), u1(() => {
    if (!(z != null && z.current)) return () => null;
    const A = new ResizeObserver(() => {
      setTimeout(() => a1());
    });
    return A.observe(z.current), () => {
      A.disconnect();
    };
  }, [Z, z == null ? void 0 : z.current]), u1(() => {
    var A;
    const G = document.querySelector(`[id='${i}']`), U = [...K1, G];
    q && U.includes(q) || e1((A = K1[0]) !== null && A !== void 0 ? A : G);
  }, [i, K1, q]), u1(() => (D && A1(!0), () => {
    Lt(f1), Lt(M1);
  }), []), u1(() => {
    var A;
    let G = (A = x1 == null ? void 0 : x1.anchorSelect) !== null && A !== void 0 ? A : l;
    if (!G && t && (G = `[data-tooltip-id='${t.replace(/'/g, "\\'")}']`), G) try {
      const U = Array.from(document.querySelectorAll(G));
      be(U);
    } catch {
      be([]);
    }
  }, [t, l, x1 == null ? void 0 : x1.anchorSelect]), u1(() => {
    f1.current && (Lt(f1), _e(v));
  }, [v]);
  const B1 = ($ = x1 == null ? void 0 : x1.content) !== null && $ !== void 0 ? $ : Z, ie = I1 && Object.keys(P1.tooltipStyles).length > 0;
  return J5(e, () => ({ open: (A) => {
    if (A != null && A.anchorSelect) try {
      document.querySelector(A.anchorSelect);
    } catch {
      return void console.warn(`[react-tooltip] "${A.anchorSelect}" is not a valid CSS selector`);
    }
    ae(A != null ? A : null), A != null && A.delay ? _e(A.delay) : A1(!0);
  }, close: (A) => {
    A != null && A.delay ? De(A.delay) : A1(!1);
  }, activeAnchor: q, place: P1.place, isOpen: !!(ve && !I && B1 && ie) })), ve && !I && B1 ? l1.createElement(d, { id: t, role: m1, className: h1("react-tooltip", An.tooltip, Ta.tooltip, Ta[a], n, `react-tooltip__place-${P1.place}`, An[ie ? "show" : "closing"], ie ? "react-tooltip__show" : "react-tooltip__closing", u === "fixed" && An.fixed, L && An.clickable), onTransitionEnd: (A) => {
    Lt(Y), I1 || A.propertyName !== "opacity" || (oe(!1), ae(null), N == null || N());
  }, style: { ...M, ...P1.tooltipStyles, opacity: c1 !== void 0 && ie ? c1 : void 0 }, ref: n1 }, B1, l1.createElement(d, { className: h1("react-tooltip-arrow", An.arrow, Ta.arrow, r, T && An.noArrow), style: { ...P1.tooltipArrowStyles, background: v1 ? `linear-gradient(to right bottom, transparent 50%, ${v1} 50%)` : void 0 }, ref: d1 })) : null;
}, cb = ({ content: e }) => l1.createElement("span", { dangerouslySetInnerHTML: { __html: e } }), go = l1.forwardRef(({ id: e, anchorId: t, anchorSelect: n, content: r, html: a, render: i, className: l, classNameArrow: s, variant: c = "dark", place: p = "top", offset: h = 10, wrapper: u = "div", children: m = null, events: d = ["hover"], openOnClick: v = !1, positionStrategy: x = "absolute", middlewares: k, delayShow: I = 0, delayHide: T = 0, float: L = !1, hidden: S = !1, noArrow: E = !1, clickable: j = !1, closeOnEsc: g = !1, closeOnScroll: w = !1, closeOnResize: C = !1, openEvents: b, closeEvents: M, globalCloseEvents: R, imperativeModeOnly: O = !1, style: N, position: H, isOpen: Z, defaultIsOpen: z = !1, disableStyleInjection: K = !1, border: D, opacity: W, arrowColor: q, setIsOpen: e1, afterShow: o1, afterHide: c1, disableTooltip: v1, role: m1 = "tooltip" }, $) => {
  const [n1, d1] = r1(r), [f1, M1] = r1(a), [Y, P1] = r1(p), [J1, I1] = r1(c), [ce, ve] = r1(h), [oe, x1] = r1(I), [ae, ke] = r1(T), [Ie, ye] = r1(L), [Ye, Ne] = r1(S), [K1, be] = r1(u), [He, Oe] = r1(d), [Pe, Ze] = r1(x), [Re, ne] = r1(null), [A1, ze] = r1(null), _e = V1(K), { anchorRefs: De, activeAnchor: je } = ws(e), Se = (Z1) => Z1 == null ? void 0 : Z1.getAttributeNames().reduce((C1, Q) => {
    var a1;
    return Q.startsWith("data-tooltip-") && (C1[Q.replace(/^data-tooltip-/, "")] = (a1 = Z1 == null ? void 0 : Z1.getAttribute(Q)) !== null && a1 !== void 0 ? a1 : null), C1;
  }, {}), se = (Z1) => {
    const C1 = { place: (Q) => {
      var a1;
      P1((a1 = Q) !== null && a1 !== void 0 ? a1 : p);
    }, content: (Q) => {
      d1(Q != null ? Q : r);
    }, html: (Q) => {
      M1(Q != null ? Q : a);
    }, variant: (Q) => {
      var a1;
      I1((a1 = Q) !== null && a1 !== void 0 ? a1 : c);
    }, offset: (Q) => {
      ve(Q === null ? h : Number(Q));
    }, wrapper: (Q) => {
      var a1;
      be((a1 = Q) !== null && a1 !== void 0 ? a1 : u);
    }, events: (Q) => {
      const a1 = Q == null ? void 0 : Q.split(" ");
      Oe(a1 != null ? a1 : d);
    }, "position-strategy": (Q) => {
      var a1;
      Ze((a1 = Q) !== null && a1 !== void 0 ? a1 : x);
    }, "delay-show": (Q) => {
      x1(Q === null ? I : Number(Q));
    }, "delay-hide": (Q) => {
      ke(Q === null ? T : Number(Q));
    }, float: (Q) => {
      ye(Q === null ? L : Q === "true");
    }, hidden: (Q) => {
      Ne(Q === null ? S : Q === "true");
    }, "class-name": (Q) => {
      ne(Q);
    } };
    Object.values(C1).forEach((Q) => Q(null)), Object.entries(Z1).forEach(([Q, a1]) => {
      var B1;
      (B1 = C1[Q]) === null || B1 === void 0 || B1.call(C1, a1);
    });
  };
  u1(() => {
    d1(r);
  }, [r]), u1(() => {
    M1(a);
  }, [a]), u1(() => {
    P1(p);
  }, [p]), u1(() => {
    I1(c);
  }, [c]), u1(() => {
    ve(h);
  }, [h]), u1(() => {
    x1(I);
  }, [I]), u1(() => {
    ke(T);
  }, [T]), u1(() => {
    ye(L);
  }, [L]), u1(() => {
    Ne(S);
  }, [S]), u1(() => {
    Ze(x);
  }, [x]), u1(() => {
    _e.current !== K && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
  }, [K]), u1(() => {
    typeof window != "undefined" && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", { detail: { disableCore: K === "core", disableBase: K } }));
  }, []), u1(() => {
    var Z1;
    const C1 = new Set(De);
    let Q = n;
    if (!Q && e && (Q = `[data-tooltip-id='${e.replace(/'/g, "\\'")}']`), Q) try {
      document.querySelectorAll(Q).forEach((G) => {
        C1.add({ current: G });
      });
    } catch {
      console.warn(`[react-tooltip] "${Q}" is not a valid CSS selector`);
    }
    const a1 = document.querySelector(`[id='${t}']`);
    if (a1 && C1.add({ current: a1 }), !C1.size) return () => null;
    const B1 = (Z1 = A1 != null ? A1 : a1) !== null && Z1 !== void 0 ? Z1 : je.current, ie = new MutationObserver((G) => {
      G.forEach((U) => {
        var s1;
        if (!B1 || U.type !== "attributes" || !(!((s1 = U.attributeName) === null || s1 === void 0) && s1.startsWith("data-tooltip-"))) return;
        const E1 = Se(B1);
        se(E1);
      });
    }), A = { attributes: !0, childList: !1, subtree: !1 };
    if (B1) {
      const G = Se(B1);
      se(G), ie.observe(B1, A);
    }
    return () => {
      ie.disconnect();
    };
  }, [De, je, A1, t, n]), u1(() => {
    N != null && N.border && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), D && !B3("border", `${D}`) && console.warn(`[react-tooltip] "${D}" is not a valid \`border\`.`), N != null && N.opacity && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), W && !B3("opacity", `${W}`) && console.warn(`[react-tooltip] "${W}" is not a valid \`opacity\`.`);
  }, []);
  let xe = m;
  const Le = V1(null);
  if (i) {
    const Z1 = i({ content: (A1 == null ? void 0 : A1.getAttribute("data-tooltip-content")) || n1 || null, activeAnchor: A1 });
    xe = Z1 ? l1.createElement("div", { ref: Le, className: "react-tooltip-content-wrapper" }, Z1) : null;
  } else n1 && (xe = n1);
  f1 && (xe = l1.createElement(cb, { content: f1 }));
  const Ee = { forwardRef: $, id: e, anchorId: t, anchorSelect: n, className: h1(l, Re), classNameArrow: s, content: xe, contentWrapperRef: Le, place: Y, variant: J1, offset: ce, wrapper: K1, events: He, openOnClick: v, positionStrategy: Pe, middlewares: k, delayShow: oe, delayHide: ae, float: Ie, hidden: Ye, noArrow: E, clickable: j, closeOnEsc: g, closeOnScroll: w, closeOnResize: C, openEvents: b, closeEvents: M, globalCloseEvents: R, imperativeModeOnly: O, style: N, position: H, isOpen: Z, defaultIsOpen: z, border: D, opacity: W, arrowColor: q, setIsOpen: e1, afterShow: o1, afterHide: c1, disableTooltip: v1, activeAnchor: A1, setActiveAnchor: (Z1) => ze(Z1), role: m1 };
  return l1.createElement(lb, { ...Ee });
});
typeof window != "undefined" && window.addEventListener("react-tooltip-inject-styles", (e) => {
  e.detail.disableCore || D3({ css: ":root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}", type: "core" }), e.detail.disableBase || D3({ css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:8px;height:8px}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`, type: "base" });
});
var ys = /* @__PURE__ */ ((e) => (e.Click = "click", e))(ys || {});
function ub({
  locale: e,
  onEvent: t,
  className: n,
  ...r
}) {
  const {
    langsList: a
  } = D1(U2);
  return /* @__PURE__ */ f.jsx(go, { opacity: 1, noArrow: !0, clickable: !0, ...r, className: h1(Ct.langList, n), closeEvents: {
    blur: !0
  }, children: Object.entries(a).map(([i, l]) => (
    // eslint-disable-next-line max-len
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions
    /* @__PURE__ */ f.jsxs("p", { className: h1(Ct.langItem, {
      [Ct.selected]: e === i
    }), onClick: () => t(ys.Click, i), children: [
      /* @__PURE__ */ f.jsx("img", { src: l.flag, alt: l.label }),
      /* @__PURE__ */ f.jsx("span", { children: l.name }),
      e === i && /* @__PURE__ */ f.jsx("img", { src: co, alt: i, className: Ct.selectedIcon })
    ] }, i)
  )) });
}
function bs({
  tooltipId: e = "",
  isMobile: t,
  transparent: n,
  title: r
}) {
  const {
    locale: a,
    langsList: i
  } = D1(U2), [l, s] = r1(!1), [c, p] = r1(a), h = i[a] || i.ru_RU, u = V1(null), m = () => {
    var I;
    (I = u.current) == null || I.classList.toggle(Ct.open);
  }, d = () => {
    s((I) => !I);
  }, v = (I) => {
    p(I);
  }, x = () => {
    c !== a && Li({
      lang: c,
      withSession: !0
    }), d();
  }, k = (I, T) => {
    T !== a && Li({
      lang: T,
      withSession: !0
    });
  };
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsxs("div", { "data-id": "lang-dropdown", className: h1(Ct.lang, {
      [Ct.transparent]: n
    }), children: [
      r && r,
      /* @__PURE__ */ f.jsxs(
        "button",
        {
          "data-tooltip-id": e,
          className: Ct.dropdownButton,
          onClick: d,
          ref: u,
          children: [
            /* @__PURE__ */ f.jsxs("span", { children: [
              /* @__PURE__ */ f.jsx("img", { src: h.flag, alt: "Country flag" }),
              h.name
            ] }),
            /* @__PURE__ */ f.jsx(b1, { name: "chevron-right" })
          ]
        }
      )
    ] }),
    t ? /* @__PURE__ */ f.jsx(yy, { isOpen: l, onClose: d, onSelectLang: v, onSetLang: x, selectedLang: c }) : /* @__PURE__ */ f.jsx(ub, { locale: a, id: e, place: "bottom-start", openOnClick: !0, afterHide: m, afterShow: m, onEvent: k })
  ] });
}
function _s(e) {
  const [t, n] = r1(0), r = () => {
    let a;
    if (typeof e == "string" ? a = document.querySelector(e) : a = e.current, a) {
      const i = a.getBoundingClientRect();
      n(i.left);
    }
  };
  return _n(() => (r(), window.addEventListener("resize", r), () => {
    window.removeEventListener("resize", r);
  }), []), {
    offsetLeft: t,
    updateOffset: r
  };
}
function xs(e, t, n = "touchstart") {
  u1(() => {
    const r = (a) => {
      !e.current || e.current.contains(a.target) || t(a);
    };
    return document.addEventListener("mouseup", r), document.addEventListener(n, r), () => {
      document.removeEventListener("mouseup", r), document.removeEventListener(n, r);
    };
  }, [e, t]);
}
const x2 = (e = "") => {
  const {
    formatMessage: t
  } = N1();
  return (typeof e != "string" && e.id ? t(e) : e).toString();
}, db = "_mobOverlay_15wvi_1", fb = "_title_15wvi_10", hb = "_menuList_15wvi_19", pb = "_menuItem_15wvi_31", mb = "_btnIcon_15wvi_55", Cb = "_transparent_15wvi_88", gb = "_counter_15wvi_96", vb = "_btnText_15wvi_103", wb = "_noAuthBlock_15wvi_116", yb = "_noAuthContent_15wvi_148", bb = "_noAuthTitle_15wvi_170", _b = "_authBlock_15wvi_177", xb = "_authHeader_15wvi_183", Lb = "_avatar_15wvi_193", Eb = "_nick_15wvi_201", Mb = "_copy_15wvi_212", kb = "_profileActions_15wvi_234", Sb = "_langSelector_15wvi_245", Me = {
  mobOverlay: db,
  title: fb,
  menuList: hb,
  menuItem: pb,
  btnIcon: mb,
  transparent: Cb,
  counter: gb,
  btnText: vb,
  noAuthBlock: wb,
  noAuthContent: yb,
  noAuthTitle: bb,
  authBlock: _b,
  authHeader: xb,
  avatar: Lb,
  nick: Eb,
  copy: Mb,
  profileActions: kb,
  langSelector: Sb
}, Ls = ({
  item: e,
  transparent: t
}) => {
  const n = x2(e.label), {
    pushReachGoal: r
  } = le(), a = () => {
    e.analyticsLabel && r({
      params: {
        category: "header",
        action: "click",
        label: e.analyticsLabel
      }
    });
  }, i = (l) => {
    a(), e.onClick && e.onClick(l, e.id);
  };
  return (
    // eslint-disable-next-line
    /* @__PURE__ */ f.jsxs("a", { className: h1(Me.menuItem, {
      [Me.transparent]: t
    }), ...e.href && {
      href: e.href
    }, onClick: i, children: [
      /* @__PURE__ */ f.jsx("div", { className: Me.btnIcon, children: e.icon && /* @__PURE__ */ f.jsx(b1, { name: e.icon }) }),
      /* @__PURE__ */ f.jsx("div", { className: Me.btnText, children: n })
    ] })
  );
}, Ab = "_root_1qtmn_1", Tb = {
  root: Ab
}, ia = ({
  className: e,
  children: t
}) => /* @__PURE__ */ f.jsx("div", { className: h1(Tb.root, e), children: t }), Es = "show_steam_refill", oa = "mt_link_id", Ib = "mt_track", Ms = "drm100", ks = "o8zls6", Rb = "douxz8", vo = J.query_string(), Nb = window.location.search.includes(Ib) || vo[oa] === ks, Ss = vo[Es] === "1" && Nb, As = `${me.payment_steam}?${oa}=${Ms}`, Hb = `${me.payment_steam}?${oa}=${Rb}`, Ob = `${me.payment_steam}?${oa}=${ks}`, jb = (e) => {
  if (Ss || e) {
    const t = {
      ...vo
    };
    delete t[Es];
    const n = J.qsStringify(t), r = n.length > 0 ? "?" : "", a = `${window.location.origin}${window.location.pathname}${r}${n}`;
    window.history.replaceState({
      page: a
    }, "", a);
  }
}, U1 = {
  main: {
    id: "menu.main",
    defaultMessage: "Главная"
  },
  cloud: {
    id: "menu.cloud",
    defaultMessage: "Облачный гейминг"
  },
  cloudPlans: {
    id: "menu.cloud.plans",
    defaultMessage: "Тарифы"
  },
  download: {
    id: "menu.cloud.download",
    defaultMessage: "Скачать"
  },
  faq: {
    id: "menu.cloud.faq",
    defaultMessage: "FAQ"
  },
  live: {
    id: "menu.live",
    defaultMessage: "Стримы"
  },
  market: {
    id: "menu.market",
    defaultMessage: "Маркет"
  },
  goods: {
    id: "menu.market.goods",
    defaultMessage: "Игровые товары"
  },
  keys: {
    id: "menu.market.keys",
    defaultMessage: "Магазин ключей"
  },
  refill: {
    id: "menu.market.refill",
    defaultMessage: "Пополнить баланс"
  },
  media: {
    id: "menu.media",
    defaultMessage: "Медиа"
  },
  news: {
    id: "menu.media.news",
    defaultMessage: "Новости"
  },
  articles: {
    id: "menu.media.articles",
    defaultMessage: "Статьи"
  },
  guides: {
    id: "menu.media.guides",
    defaultMessage: "Руководства"
  },
  store: {
    id: "menu.store",
    defaultMessage: "Каталог игр"
  },
  play: {
    id: "menu.store.play",
    defaultMessage: "Доступно на VK Play"
  },
  free: {
    id: "menu.store.free",
    defaultMessage: "Бесплатно"
  },
  sale: {
    id: "menu.store.sale",
    defaultMessage: "Скидки"
  },
  my: {
    id: "menu.store.my",
    defaultMessage: "Мои игры"
  },
  search: {
    id: "menu.search",
    defaultMessage: "Поиск"
  },
  more: {
    id: "menu.more",
    defaultMessage: "Еще"
  },
  pvp: {
    id: "menu.pvp",
    defaultMessage: "Турниры"
  },
  overview: {
    id: "menu.pvp.overview",
    defaultMessage: "Обзор"
  },
  tournaments: {
    id: "menu.pvp.tournaments",
    defaultMessage: "Все турниры"
  },
  player: {
    id: "menu.pvp.my",
    defaultMessage: "Мои турниры"
  },
  profile: {
    id: "profile.main",
    defaultMessage: "Профиль"
  },
  favorites: {
    id: "profile.favorites",
    defaultMessage: "Избранное"
  },
  notifications: {
    id: "profile.notifications",
    defaultMessage: "Уведомления"
  },
  support: {
    id: "profile.support",
    defaultMessage: "Служба поддержки"
  },
  settings: {
    id: "profile.settings",
    defaultMessage: "Настройки"
  },
  often: {
    id: "menu.live.often",
    defaultMessage: "Часто стримят"
  },
  online: {
    id: "menu.live.online",
    defaultMessage: "Сейчас в эфире"
  },
  steamRefill: {
    id: "steam.refill",
    defaultMessage: "Пополнить Steam"
  }
}, Pb = ({
  onSteamRefillClick: e
}) => [{
  id: "live",
  label: U1.live,
  href: `https://${Ke}/live/`,
  icon: "live-outline",
  analyticsLabel: "ph-menu-streams"
}, {
  id: "market",
  label: U1.market,
  href: `https://${jn}`,
  icon: "market-outline",
  analyticsLabel: "ph-menu-market"
}, {
  id: "cloud",
  label: U1.cloud,
  href: `https://${en}`,
  icon: "cloud-outline",
  analyticsLabel: "ph-menu-cloud"
}, {
  id: "pvp",
  label: U1.pvp,
  href: `https://${On}`,
  icon: "tournament-outline",
  analyticsLabel: "ph-menu-pvp"
}, {
  id: "steam_refill",
  label: U1.steamRefill,
  href: As,
  icon: "wallet-outline",
  analyticsLabel: "ph-menu-wallet",
  onClick: e
}], M0 = {
  title: {
    id: "header.more",
    defaultMessage: "Ещё"
  },
  noAuth: {
    id: "profile.no_auth_title",
    defaultMessage: "Авторизуйтесь, чтобы получить доступ ко всем функциям сервиса"
  },
  loginToAccount: {
    id: "profile.login_to_account",
    defaultMessage: "Войти в аккаунт"
  },
  copied: {
    id: "profile.id.copied",
    defaultMessage: "ID успешно скопирован"
  }
}, W3 = async () => {
  let e = 0;
  try {
    const {
      counters: t
    } = await J.Backend.get(me.count);
    if (!t)
      return 0;
    Object.keys(t).forEach((n) => {
      e += t[n].unread;
    });
  } catch (t) {
    console.error(t);
  }
  return e;
}, Db = async (e = 1) => {
  try {
    return await J.Backend.get(me.notifications, {
      group: "*",
      limit: 10,
      page: e
    });
  } catch (t) {
    return console.error(t), {};
  }
}, Ts = async (e) => {
  try {
    await J.Backend.post(`${me.notificationDelete}?notification_id=${e}`);
  } catch (t) {
    console.error(t);
  }
}, U3 = async (e, t, n) => {
  try {
    const {
      status: r,
      code: a
    } = await J.Backend.post(me.friendRequest, {
      target: e,
      type: t
    });
    r === "error" && a === 8005 && await Ts(n);
  } catch (r) {
    console.error(r);
  }
}, Vb = async (e, t) => {
  try {
    const n = t ? e.replace("unsubscribe", "subscribe") : e;
    await J.Backend.get(n);
  } catch (n) {
    console.error(n);
  }
}, Bb = async (e) => {
  try {
    await J.Backend.post(`${me.readOne}?notification_id=${e}`);
  } catch (t) {
    console.error(t);
  }
}, Fb = async () => {
  try {
    await J.Backend.post(me.readAll);
  } catch (e) {
    console.error(e);
  }
}, Zb = async (e, t) => {
  try {
    await J.Backend.post(me.nextNotification, {
      notification_id: e,
      control_id: t
    });
  } catch (n) {
    console.error(n);
  }
}, Gb = async (e, t, n) => {
  const r = e === "P" ? "post" : "get";
  try {
    await J.Backend[r](t, {
      ...n && {
        headers: {
          Authorization: n
        }
      }
    });
  } catch (a) {
    console.error(a);
  }
};
function z3(e) {
  switch (e) {
    case 15:
    case 12:
      return !0;
    case 8:
      return J.inGamecenter;
    case 4:
      return !J.inGamecenter;
    default:
      return !1;
  }
}
var w2 = /* @__PURE__ */ ((e) => (e.Gift = "442", e.FriendRequest = "443", e.RequestAccepted = "444", e.RequestDeclined = "445", e.GameInvite = "115", e))(w2 || {});
const c2 = o2({
  list: [],
  unread: 0,
  loading: !0,
  nextPage: null,
  needUpdate: !1,
  onReadNotification: () => {
  },
  onCheckAll: () => {
  },
  onDeleteNotification: () => {
  },
  onOpenNotification: () => {
  }
}), Is = ({
  children: e
}) => {
  const {
    pushReachGoal: t
  } = le(), [n, r] = r1([]), [a, i] = r1(0), [l, s] = r1(!0), [c, p] = r1(null), [h, u] = r1(!1);
  u1(() => {
    J.inGamecenter && (window.gc_window_state = (T) => {
      T === 3 && h && d();
    });
  }, [h]), u1(() => {
    J.inGamecenter && window.gc_set_notifications_unread_count && window.gc_set_notifications_unread_count(a);
  }, [a]);
  const m = async () => {
    const T = await W3();
    i(T);
  };
  async function d() {
    const T = await W3(), {
      notifications: L,
      pager: S
    } = await Db(1);
    if (Array.isArray(L) && r(L), s(!1), S) {
      const {
        next_page: E,
        page: j
      } = S;
      p(E !== j ? E : null);
    }
    i(T), u(!1);
  }
  u1(() => {
    J.WSD.on("message", (T) => {
      T.type === "notification_mygames" && z3(T.visibility) && (r((L) => [T, ...L]), u(!0), m()), T.type === "notification_update" && z3(T.visibility) && ([w2.RequestAccepted, w2.RequestDeclined].includes(T.template_id) || r((L) => L.map((S) => S.id === T.id ? T : S)), u(!0)), T.type === "notification_update" && [w2.RequestAccepted, w2.RequestDeclined].includes(T.template_id) && (r((L) => L.map((S) => S.id === T.id ? {
        ...S,
        removeBubble: !0
      } : S)), u(!0));
    }), d();
  }, []);
  const v = () => {
    h && d();
  }, x = async () => {
    a !== 0 && (await Fb(), r((T) => T.map((L) => (L.is_read = !0, L))), i(0), t({
      params: {
        category: "notifications",
        action: "click",
        label: "read_all"
      }
    }));
  }, k = async (T) => {
    await Bb(T), r((L) => L.map((S) => (S.id === T && (S.is_read = !0), S))), i((L) => Math.max(L - 1, 0));
  }, I = () => {
    u(!0);
  };
  return /* @__PURE__ */ f.jsx(c2.Provider, { value: {
    list: n,
    unread: a,
    loading: l,
    nextPage: c,
    needUpdate: h,
    onReadNotification: k,
    onDeleteNotification: I,
    onOpenNotification: v,
    onCheckAll: x
  }, children: e });
}, En = ({
  children: e,
  className: t,
  id: n,
  theme: r = "dark"
}) => /* @__PURE__ */ f.jsx("div", { className: h1("vkp-app-shell", t), "data-theme": r, "data-id": n, children: e }), Z2 = ({
  into: e = "body",
  id: t,
  children: n,
  shouldDisableBodyScroll: r
}) => {
  var l;
  const a = (l = document.querySelector(e)) != null ? l : document.body, i = /* @__PURE__ */ f.jsx(En, { id: t, children: n });
  return u1(() => {
    if (r)
      return document.body.style.overflow = "hidden", () => {
        document.body.style.overflow = "initial";
      };
  }, []), q6(i, a);
}, Wb = "_container_1v69s_1", Ub = "_list_1v69s_6", zb = "_header_1v69s_14", qb = "_headerButton_1v69s_20", $b = "_read_1v69s_28", Yb = "_hidden_1v69s_32", Kb = "_title_1v69s_38", Qb = "_notify_1v69s_45", Xb = "_sub_1v69s_56", Jb = "_mobileLoader_1v69s_70", Qe = {
  container: Wb,
  list: Ub,
  header: zb,
  headerButton: qb,
  read: $b,
  hidden: Yb,
  title: Kb,
  notify: Qb,
  sub: Xb,
  mobileLoader: Jb
}, We = {
  title: {
    id: "notifications.title",
    defaultMessage: "Уведомления"
  },
  checkAll: {
    id: "notifications.checkAll",
    defaultMessage: "Отметить все прочитанным"
  },
  noNewNotifications: {
    id: "notifications.noNewNotifications",
    defaultMessage: "Новых уведомлений нет"
  },
  futureNotifications: {
    id: "notifications.futureNotifications",
    defaultMessage: "Позже здесь будут новости и напоминания о важных событиях"
  },
  noNotificationsYet: {
    id: "notifications.noNotificationsYet",
    defaultMessage: "Уведомлений пока нет"
  },
  deleted: {
    id: "notifications.deleted",
    defaultMessage: "Уведомление удалено"
  },
  friendRequest: {
    id: "notifications.friendRequest",
    defaultMessage: "хочет добавить вас в друзья"
  },
  friendRequestAccepted: {
    id: "notifications.friendRequestAccepted",
    defaultMessage: "Вы приняли заявку на дружбу"
  },
  friendRequestDeclined: {
    id: "notifications.friendRequestDeclined",
    defaultMessage: "Вы отклонили заявку на дружбу"
  },
  deleteNotification: {
    id: "notifications.deleteNotification",
    defaultMessage: "Удалить уведомление"
  },
  hideProject: {
    id: "notifications.hideProject",
    defaultMessage: "Не показывать уведомления проекта"
  },
  accept: {
    id: "button.accept",
    defaultMessage: "Принять"
  },
  decline: {
    id: "button.decline",
    defaultMessage: "Отклонить"
  },
  copyPromo: {
    id: "notifications.copyPromo",
    defaultMessage: "Скопировать промокод"
  },
  copyPromoSuccess: {
    id: "notifications.copyPromoSuccess",
    defaultMessage: "Промокод успешно скопирован"
  },
  cancel: {
    id: "app.cancel",
    defaultMessage: "Отменить"
  },
  unsubscribed: {
    id: "notifications.unsubscribed",
    defaultMessage: "Вы больше не будете получать уведомления от проекта {project_name}"
  },
  controlCancel: {
    id: "search.control.cancel",
    defaultMessage: "Отмена"
  }
};
function e_({
  onClose: e
}) {
  const {
    unread: t,
    onCheckAll: n
  } = D1(c2), {
    formatMessage: r
  } = N1();
  return /* @__PURE__ */ f.jsxs("div", { className: Qe.header, children: [
    /* @__PURE__ */ f.jsx(q1, { onClick: e, leftIcon: /* @__PURE__ */ f.jsx(b1, { name: "chevron-left" }), appearance: "overlay", mode: "link", className: Qe.headerButton, size: "sm" }),
    /* @__PURE__ */ f.jsx("span", { className: Qe.title, children: /* @__PURE__ */ f.jsxs("span", { className: Qe.notify, children: [
      r(We.title),
      t > 0 && /* @__PURE__ */ f.jsx(q0, { size: "large", mode: "negative", children: t })
    ] }) }),
    /* @__PURE__ */ f.jsx(q1, { onClick: n, className: h1(Qe.headerButton, {
      [Qe.read]: t === 0
    }), leftIcon: /* @__PURE__ */ f.jsx(b1, { name: "list-check-outline" }), appearance: "overlay", mode: "link", size: "sm" })
  ] });
}
const t_ = "_loader_5qxe3_15", n_ = "_gc_5qxe3_22", r_ = "_emptyList_5qxe3_28", a_ = "_button_5qxe3_61", i_ = "_buttonInner_5qxe3_77", o_ = "_counter_5qxe3_89", s_ = "_header_5qxe3_95", l_ = "_title_5qxe3_102", c_ = "_checkAll_5qxe3_109", u_ = "_hasNew_5qxe3_121", d_ = "_list_5qxe3_136", nt = {
  loader: t_,
  gc: n_,
  emptyList: r_,
  button: a_,
  buttonInner: i_,
  counter: o_,
  header: s_,
  title: l_,
  checkAll: c_,
  hasNew: u_,
  list: d_
};
function Rs() {
  const {
    formatMessage: e
  } = N1();
  return /* @__PURE__ */ f.jsxs("div", { className: h1(nt.emptyList, {
    [nt.gc]: J.inGamecenter
  }), children: [
    /* @__PURE__ */ f.jsx("span", { children: e(We.noNotificationsYet) }),
    /* @__PURE__ */ f.jsx("span", { children: e(We.futureNotifications) })
  ] });
}
var f_ = Object.defineProperty, h_ = (e, t, n) => t in e ? f_(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, l0 = (e, t, n) => h_(e, typeof t != "symbol" ? t + "" : t, n), Ai = /* @__PURE__ */ new Map(), c0 = /* @__PURE__ */ new WeakMap(), q3 = 0, p_ = void 0;
function m_(e) {
  return e ? (c0.has(e) || (q3 += 1, c0.set(e, q3.toString())), c0.get(e)) : "0";
}
function C_(e) {
  return Object.keys(e).sort().filter(
    (t) => e[t] !== void 0
  ).map((t) => `${t}_${t === "root" ? m_(e.root) : e[t]}`).toString();
}
function g_(e) {
  const t = C_(e);
  let n = Ai.get(t);
  if (!n) {
    const r = /* @__PURE__ */ new Map();
    let a;
    const i = new IntersectionObserver((l) => {
      l.forEach((s) => {
        var c;
        const p = s.isIntersecting && a.some((h) => s.intersectionRatio >= h);
        e.trackVisibility && typeof s.isVisible == "undefined" && (s.isVisible = p), (c = r.get(s.target)) == null || c.forEach((h) => {
          h(p, s);
        });
      });
    }, e);
    a = i.thresholds || (Array.isArray(e.threshold) ? e.threshold : [e.threshold || 0]), n = {
      id: t,
      observer: i,
      elements: r
    }, Ai.set(t, n);
  }
  return n;
}
function v_(e, t, n = {}, r = p_) {
  if (typeof window.IntersectionObserver == "undefined" && r !== void 0) {
    const c = e.getBoundingClientRect();
    return t(r, {
      isIntersecting: r,
      target: e,
      intersectionRatio: typeof n.threshold == "number" ? n.threshold : 0,
      time: 0,
      boundingClientRect: c,
      intersectionRect: c,
      rootBounds: c
    }), () => {
    };
  }
  const { id: a, observer: i, elements: l } = g_(n), s = l.get(e) || [];
  return l.has(e) || l.set(e, s), s.push(t), i.observe(e), function() {
    s.splice(s.indexOf(t), 1), s.length === 0 && (l.delete(e), i.unobserve(e)), l.size === 0 && (i.disconnect(), Ai.delete(a));
  };
}
function w_(e) {
  return typeof e.children != "function";
}
var wo = class extends o.Component {
  constructor(e) {
    super(e), l0(this, "node", null), l0(this, "_unobserveCb", null), l0(this, "handleNode", (t) => {
      this.node && (this.unobserve(), !t && !this.props.triggerOnce && !this.props.skip && this.setState({ inView: !!this.props.initialInView, entry: void 0 })), this.node = t || null, this.observeNode();
    }), l0(this, "handleChange", (t, n) => {
      t && this.props.triggerOnce && this.unobserve(), w_(this.props) || this.setState({ inView: t, entry: n }), this.props.onChange && this.props.onChange(t, n);
    }), this.state = {
      inView: !!e.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve(), this.observeNode();
  }
  componentDidUpdate(e) {
    (e.rootMargin !== this.props.rootMargin || e.root !== this.props.root || e.threshold !== this.props.threshold || e.skip !== this.props.skip || e.trackVisibility !== this.props.trackVisibility || e.delay !== this.props.delay) && (this.unobserve(), this.observeNode());
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold: e,
      root: t,
      rootMargin: n,
      trackVisibility: r,
      delay: a,
      fallbackInView: i
    } = this.props;
    this._unobserveCb = v_(
      this.node,
      this.handleChange,
      {
        threshold: e,
        root: t,
        rootMargin: n,
        // @ts-ignore
        trackVisibility: r,
        // @ts-ignore
        delay: a
      },
      i
    );
  }
  unobserve() {
    this._unobserveCb && (this._unobserveCb(), this._unobserveCb = null);
  }
  render() {
    const { children: e } = this.props;
    if (typeof e == "function") {
      const { inView: d, entry: v } = this.state;
      return e({ inView: d, entry: v, ref: this.handleNode });
    }
    const {
      as: t,
      triggerOnce: n,
      threshold: r,
      root: a,
      rootMargin: i,
      onChange: l,
      skip: s,
      trackVisibility: c,
      delay: p,
      initialInView: h,
      fallbackInView: u,
      ...m
    } = this.props;
    return o.createElement(
      t || "div",
      { ref: this.handleNode, ...m },
      e
    );
  }
};
const y_ = "_wrapper_ntlaq_1", b_ = "_link_ntlaq_19", __ = "_updated_ntlaq_23", x_ = "_contextMenuIcon_ntlaq_30", L_ = "_newLabel_ntlaq_36", E_ = "_contextMenu_ntlaq_30", M_ = "_inBubble_ntlaq_85", k_ = "_contextMenuItem_ntlaq_91", S_ = "_gc_ntlaq_110", A_ = "_cancelContextMenuButton_ntlaq_133", T_ = "_content_ntlaq_138", I_ = "_pictureWrapper_ntlaq_142", R_ = "_picture_ntlaq_142", N_ = "_data_ntlaq_164", H_ = "_title_ntlaq_175", O_ = "_text_ntlaq_191", j_ = "_highlighted_ntlaq_204", P_ = "_date_ntlaq_214", D_ = "_actions_ntlaq_221", V_ = "_copyTooltip_ntlaq_229", B_ = "_actionsTooltip_ntlaq_236", F_ = "_actionButton_ntlaq_249", Z_ = "_lastLink_ntlaq_266", G_ = "_notificationLabel_ntlaq_271", W_ = "_bottom_ntlaq_282", U_ = "_top_ntlaq_286", z_ = "_deleted_ntlaq_291", q_ = "_dialogMobile_ntlaq_302", k1 = {
  wrapper: y_,
  new: "_new_ntlaq_8",
  link: b_,
  updated: __,
  contextMenuIcon: x_,
  newLabel: L_,
  contextMenu: E_,
  inBubble: M_,
  contextMenuItem: k_,
  gc: S_,
  cancelContextMenuButton: A_,
  content: T_,
  pictureWrapper: I_,
  picture: R_,
  data: N_,
  title: H_,
  text: O_,
  highlighted: j_,
  date: P_,
  actions: D_,
  copyTooltip: V_,
  actionsTooltip: B_,
  actionButton: F_,
  lastLink: Z_,
  notificationLabel: G_,
  bottom: W_,
  top: U_,
  deleted: z_,
  dialogMobile: q_
};
function $_({
  id: e,
  onDelete: t,
  onHide: n,
  href: r
}) {
  const {
    formatMessage: a
  } = N1(), {
    tabletMdMax: i
  } = Ue(["tabletMdMax"]), {
    pushReachGoal: l
  } = le(), [s, c] = l1.useState(!1), p = `context-menu-${e}`, h = () => {
    c((x) => (x && l({
      params: {
        category: "notifications",
        action: "menu_click",
        label: "inside kolokolchik",
        entity_id: r
      }
    }), !x));
  }, u = (x) => {
    x.stopPropagation(), i && !J.inGamecenter && h();
  }, m = (x) => {
    t(x), s && h();
  }, d = (x) => {
    n && (n(x), s && h());
  }, v = Xe(() => /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsxs(Je, { onClick: m, className: h1(k1.contextMenuItem, {
      [k1.gc]: J.inGamecenter
    }), children: [
      /* @__PURE__ */ f.jsx(b1, { name: "delete-outline" }),
      /* @__PURE__ */ f.jsx("span", { children: a(We.deleteNotification) })
    ] }),
    n && /* @__PURE__ */ f.jsxs(Je, { onClick: d, className: h1(k1.contextMenuItem, {
      [k1.gc]: J.inGamecenter
    }), children: [
      /* @__PURE__ */ f.jsx(b1, { name: "hide-outline" }),
      /* @__PURE__ */ f.jsx("span", { children: a(We.hideProject) })
    ] })
  ] }), [n, s]);
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(q1, { className: k1.contextMenuIcon, onClick: u, leftIcon: /* @__PURE__ */ f.jsx(b1, { name: "burger" }), size: "lg", appearance: "overlay", mode: "link", "data-tooltip-id": p }),
    i && !J.inGamecenter ? /* @__PURE__ */ f.jsx(Fr, { open: s, onClose: h, className: k1.dialogMobile, hideCloseIcon: !0, children: /* @__PURE__ */ f.jsxs("div", { className: "vkp-app-shell", "data-theme": "dark", children: [
      v,
      /* @__PURE__ */ f.jsx(q1, { size: "lg", appearance: "neutral", onClick: h, className: k1.cancelContextMenuButton, children: a(We.controlCancel) })
    ] }) }) : /* @__PURE__ */ f.jsx(kt, { id: p, place: "bottom-start", clickable: !0, openOnClick: !0, opacity: 1, positionStrategy: "fixed", className: h1({
      [k1.gc]: J.inGamecenter
    }), closeEvents: {
      click: !0
    }, children: v })
  ] });
}
function Ns({
  label: e,
  position: t = "bottom"
}) {
  return e ? /* @__PURE__ */ f.jsx("div", { className: h1(k1.notificationLabel, k1[t]), children: e }) : null;
}
function Hs({
  notification: {
    is_read: e,
    data: {
      project_name: t,
      image_url: n
    }
  }
}) {
  const {
    tabletMdMax: r
  } = Ue(["tabletMdMax"]);
  return /* @__PURE__ */ f.jsxs("div", { className: k1.pictureWrapper, children: [
    /* @__PURE__ */ f.jsx("img", { alt: t, src: n, className: k1.picture }),
    !e && r && /* @__PURE__ */ f.jsx("div", { className: k1.newLabel })
  ] });
}
const Os = "#mob-nav-container", Y_ = {
  day: "numeric",
  month: "short",
  hour: "numeric",
  minute: "numeric"
}, js = (e, t) => new Date(e * 1e3).toLocaleDateString(t, Y_).split(".").join(""), K_ = /((?:[[<]{2}|\[url=[^\]\s]*\])[\s\S]*?(?:[\]>]{2}|\[\/url\]))/g, Q_ = /\[\[([\s\S]+)\]\]/g, X_ = /<<([\s\S]+)>>/, J_ = /\[url=[^\]\s]*\]([\s\S]+)\[\/url\]/g, ex = /«([\s\S]+)»/;
function tx(e) {
  const {
    notification: {
      id: t,
      data: {
        link_url: n,
        project_name: r
      },
      created: a,
      is_read: i,
      raw_data: {
        user_slug: l
      }
    },
    onRead: s,
    onClose: c,
    onView: p
  } = e, {
    tabletMdMax: h
  } = Ue(["tabletMdMax"]), {
    formatMessage: u,
    locale: m
  } = N1(), [d, v] = r1(""), x = async () => {
    await U3(l, "accept", t), v(u(We.friendRequestAccepted));
  }, k = async () => {
    await U3(l, "decline", t), v(u(We.friendRequestDeclined));
  }, I = (T) => {
    J.inGamecenter && window.gc_open_url_mainwnd && (T.stopPropagation(), T.preventDefault(), window.gc_open_url_mainwnd(n), window.gc_close_window && window.gc_close_window());
  };
  return /* @__PURE__ */ f.jsxs(wo, { className: h1(k1.wrapper, {
    [k1.updated]: !!d,
    [k1.new]: !i && !c,
    [k1.inBubble]: !!c
  }), onMouseEnter: s, onChange: p, triggerOnce: !0, threshold: 1, rootMargin: "0px 0px 60px 0px", skip: i || !h || J.inGamecenter, children: [
    /* @__PURE__ */ f.jsxs("div", { className: k1.content, children: [
      /* @__PURE__ */ f.jsx(Hs, { ...e }),
      /* @__PURE__ */ f.jsxs("div", { className: k1.data, children: [
        /* @__PURE__ */ f.jsxs("span", { className: k1.title, children: [
          /* @__PURE__ */ f.jsx("a", { href: n, onClick: I, children: r }),
          /* @__PURE__ */ f.jsx("span", { children: ` ${u(We.friendRequest)}` })
        ] }),
        /* @__PURE__ */ f.jsx("span", { className: k1.date, children: js(a, m) }),
        !d && /* @__PURE__ */ f.jsxs("div", { className: k1.actions, children: [
          /* @__PURE__ */ f.jsx(q1, { size: "sm", appearance: "overlay", onClick: x, children: u(We.accept) }),
          /* @__PURE__ */ f.jsx(q1, { size: "sm", appearance: "neutral", onClick: k, children: u(We.decline) })
        ] })
      ] }),
      c && /* @__PURE__ */ f.jsx(Je, { onClick: () => c(t), className: k1.contextMenuItem, children: /* @__PURE__ */ f.jsx(b1, { name: "close" }) })
    ] }),
    /* @__PURE__ */ f.jsx(Ns, { label: d }),
    !i && !h && !c && /* @__PURE__ */ f.jsx("div", { className: k1.newLabel })
  ] });
}
const Ia = {
  P: {
    appearance: "overlay"
  },
  S: {
    appearance: "neutral"
  },
  A: {
    appearance: "overlay",
    mode: "link"
  }
};
function nx({
  notification: {
    id: e,
    controls: t,
    data: {
      pixel_click_url: n
    }
  },
  inBubble: r = !1,
  onClose: a
}) {
  const [i, l] = r1(!1), {
    tabletMdMax: s
  } = Ue(["tabletMdMax"]), {
    formatMessage: c
  } = N1(), p = async (v, x) => {
    var k;
    if (v.stopPropagation(), n && J.triggerPixel(n), r && a && a(e), x.method === "N") {
      const I = J.inGamecenter ? x.gc_link_url : x.link_url;
      (k = window.open(I, "_blank")) == null || k.focus();
    }
    ["P", "G"].includes(x.method) && await Gb(x.method, x.link_url, x.authorization), x.has_next_template && await Zb(e, x.id);
  }, h = t.slice(0, 2), u = t.slice(2), m = () => {
    l((v) => !v);
  }, d = () => {
    if (u.length === 0) return null;
    const v = {
      size: "sm",
      leftIcon: /* @__PURE__ */ f.jsx(b1, { name: "burger" }),
      appearance: "neutral",
      onClick: () => {
      }
    };
    if (s && !J.inGamecenter)
      return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        /* @__PURE__ */ f.jsx(q1, { ...v, onClick: () => l(!0) }),
        /* @__PURE__ */ f.jsx(Fr, { open: i, onClose: m, className: k1.dialogMobile, hideCloseIcon: !0, children: /* @__PURE__ */ f.jsxs("div", { className: "vkp-app-shell", "data-theme": "dark", children: [
          u.map((k) => /* @__PURE__ */ f.jsx(Je, { onClick: (I) => {
            p(I, k), m();
          }, className: k1.contextMenuItem, children: /* @__PURE__ */ f.jsx("span", { children: k.name }) }, k.id)),
          /* @__PURE__ */ f.jsx(q1, { size: "lg", appearance: "neutral", onClick: m, className: k1.cancelContextMenuButton, children: c(We.controlCancel) })
        ] }) })
      ] });
    const x = `more-buttons-tooltip-${e}${r ? "-inBubble" : ""}`;
    return u.length > 1 ? /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      /* @__PURE__ */ f.jsx(q1, { ...v, "data-tooltip-id": x }),
      /* @__PURE__ */ f.jsx(kt, { id: x, opacity: 1, clickable: !0, place: r ? "right-end" : "right-start", positionStrategy: "fixed", className: h1(k1.actionsTooltip, {
        [k1.gc]: J.inGamecenter
      }), children: u.map((k) => /* @__PURE__ */ f.jsx(q1, { size: "sm", ...Ia[k.type], onClick: (I) => p(I, k), className: k1.actionButton, children: k.name }, k.id)) })
    ] }) : u.map((k) => /* @__PURE__ */ f.jsx(q1, { size: "sm", ...Ia[k.type], onClick: (I) => p(I, k), className: h1({
      [k1.lastLink]: k.type === "A"
    }), children: k.name }, k.id));
  };
  return /* @__PURE__ */ f.jsxs("div", { className: k1.actions, children: [
    h.map((v) => /* @__PURE__ */ f.jsx(q1, { size: "sm", ...Ia[v.type], onClick: (x) => p(x, v), children: v.name }, v.id)),
    d()
  ] });
}
var rx = (e) => {
  switch (e) {
    case "success":
      return ox;
    case "info":
      return lx;
    case "warning":
      return sx;
    case "error":
      return cx;
    default:
      return null;
  }
}, ax = Array(12).fill(0), ix = ({ visible: e, className: t }) => l1.createElement("div", { className: ["sonner-loading-wrapper", t].filter(Boolean).join(" "), "data-visible": e }, l1.createElement("div", { className: "sonner-spinner" }, ax.map((n, r) => l1.createElement("div", { className: "sonner-loading-bar", key: `spinner-bar-${r}` })))), ox = l1.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", height: "20", width: "20" }, l1.createElement("path", { fillRule: "evenodd", d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z", clipRule: "evenodd" })), sx = l1.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", height: "20", width: "20" }, l1.createElement("path", { fillRule: "evenodd", d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z", clipRule: "evenodd" })), lx = l1.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", height: "20", width: "20" }, l1.createElement("path", { fillRule: "evenodd", d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z", clipRule: "evenodd" })), cx = l1.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", height: "20", width: "20" }, l1.createElement("path", { fillRule: "evenodd", d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z", clipRule: "evenodd" })), ux = l1.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }, l1.createElement("line", { x1: "18", y1: "6", x2: "6", y2: "18" }), l1.createElement("line", { x1: "6", y1: "6", x2: "18", y2: "18" })), dx = () => {
  let [e, t] = l1.useState(document.hidden);
  return l1.useEffect(() => {
    let n = () => {
      t(document.hidden);
    };
    return document.addEventListener("visibilitychange", n), () => window.removeEventListener("visibilitychange", n);
  }, []), e;
}, Ti = 1, fx = class {
  constructor() {
    this.subscribe = (e) => (this.subscribers.push(e), () => {
      let t = this.subscribers.indexOf(e);
      this.subscribers.splice(t, 1);
    }), this.publish = (e) => {
      this.subscribers.forEach((t) => t(e));
    }, this.addToast = (e) => {
      this.publish(e), this.toasts = [...this.toasts, e];
    }, this.create = (e) => {
      var t;
      let { message: n, ...r } = e, a = typeof (e == null ? void 0 : e.id) == "number" || ((t = e.id) == null ? void 0 : t.length) > 0 ? e.id : Ti++, i = this.toasts.find((s) => s.id === a), l = e.dismissible === void 0 ? !0 : e.dismissible;
      return this.dismissedToasts.has(a) && this.dismissedToasts.delete(a), i ? this.toasts = this.toasts.map((s) => s.id === a ? (this.publish({ ...s, ...e, id: a, title: n }), { ...s, ...e, id: a, dismissible: l, title: n }) : s) : this.addToast({ title: n, ...r, dismissible: l, id: a }), a;
    }, this.dismiss = (e) => (this.dismissedToasts.add(e), e || this.toasts.forEach((t) => {
      this.subscribers.forEach((n) => n({ id: t.id, dismiss: !0 }));
    }), this.subscribers.forEach((t) => t({ id: e, dismiss: !0 })), e), this.message = (e, t) => this.create({ ...t, message: e }), this.error = (e, t) => this.create({ ...t, message: e, type: "error" }), this.success = (e, t) => this.create({ ...t, type: "success", message: e }), this.info = (e, t) => this.create({ ...t, type: "info", message: e }), this.warning = (e, t) => this.create({ ...t, type: "warning", message: e }), this.loading = (e, t) => this.create({ ...t, type: "loading", message: e }), this.promise = (e, t) => {
      if (!t) return;
      let n;
      t.loading !== void 0 && (n = this.create({ ...t, promise: e, type: "loading", message: t.loading, description: typeof t.description != "function" ? t.description : void 0 }));
      let r = e instanceof Promise ? e : e(), a = n !== void 0, i, l = r.then(async (c) => {
        if (i = ["resolve", c], l1.isValidElement(c)) a = !1, this.create({ id: n, type: "default", message: c });
        else if (px(c) && !c.ok) {
          a = !1;
          let p = typeof t.error == "function" ? await t.error(`HTTP error! status: ${c.status}`) : t.error, h = typeof t.description == "function" ? await t.description(`HTTP error! status: ${c.status}`) : t.description;
          this.create({ id: n, type: "error", message: p, description: h });
        } else if (t.success !== void 0) {
          a = !1;
          let p = typeof t.success == "function" ? await t.success(c) : t.success, h = typeof t.description == "function" ? await t.description(c) : t.description;
          this.create({ id: n, type: "success", message: p, description: h });
        }
      }).catch(async (c) => {
        if (i = ["reject", c], t.error !== void 0) {
          a = !1;
          let p = typeof t.error == "function" ? await t.error(c) : t.error, h = typeof t.description == "function" ? await t.description(c) : t.description;
          this.create({ id: n, type: "error", message: p, description: h });
        }
      }).finally(() => {
        var c;
        a && (this.dismiss(n), n = void 0), (c = t.finally) == null || c.call(t);
      }), s = () => new Promise((c, p) => l.then(() => i[0] === "reject" ? p(i[1]) : c(i[1])).catch(p));
      return typeof n != "string" && typeof n != "number" ? { unwrap: s } : Object.assign(n, { unwrap: s });
    }, this.custom = (e, t) => {
      let n = (t == null ? void 0 : t.id) || Ti++;
      return this.create({ jsx: e(n), id: n, ...t }), n;
    }, this.getActiveToasts = () => this.toasts.filter((e) => !this.dismissedToasts.has(e.id)), this.subscribers = [], this.toasts = [], this.dismissedToasts = /* @__PURE__ */ new Set();
  }
}, mt = new fx(), hx = (e, t) => {
  let n = (t == null ? void 0 : t.id) || Ti++;
  return mt.addToast({ title: e, ...t, id: n }), n;
}, px = (e) => e && typeof e == "object" && "ok" in e && typeof e.ok == "boolean" && "status" in e && typeof e.status == "number", mx = hx, Cx = () => mt.toasts, gx = () => mt.getActiveToasts(), $3 = Object.assign(mx, { success: mt.success, info: mt.info, warning: mt.warning, error: mt.error, custom: mt.custom, message: mt.message, promise: mt.promise, dismiss: mt.dismiss, loading: mt.loading }, { getHistory: Cx, getToasts: gx });
function vx(e, { insertAt: t } = {}) {
  if (typeof document == "undefined") return;
  let n = document.head || document.getElementsByTagName("head")[0], r = document.createElement("style");
  r.type = "text/css", t === "top" && n.firstChild ? n.insertBefore(r, n.firstChild) : n.appendChild(r), r.styleSheet ? r.styleSheet.cssText = e : r.appendChild(document.createTextNode(e));
}
vx(`:where(html[dir="ltr"]),:where([data-sonner-toaster][dir="ltr"]){--toast-icon-margin-start: -3px;--toast-icon-margin-end: 4px;--toast-svg-margin-start: -1px;--toast-svg-margin-end: 0px;--toast-button-margin-start: auto;--toast-button-margin-end: 0;--toast-close-button-start: 0;--toast-close-button-end: unset;--toast-close-button-transform: translate(-35%, -35%)}:where(html[dir="rtl"]),:where([data-sonner-toaster][dir="rtl"]){--toast-icon-margin-start: 4px;--toast-icon-margin-end: -3px;--toast-svg-margin-start: 0px;--toast-svg-margin-end: -1px;--toast-button-margin-start: 0;--toast-button-margin-end: auto;--toast-close-button-start: unset;--toast-close-button-end: 0;--toast-close-button-transform: translate(35%, -35%)}:where([data-sonner-toaster]){position:fixed;width:var(--width);font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;--gray1: hsl(0, 0%, 99%);--gray2: hsl(0, 0%, 97.3%);--gray3: hsl(0, 0%, 95.1%);--gray4: hsl(0, 0%, 93%);--gray5: hsl(0, 0%, 90.9%);--gray6: hsl(0, 0%, 88.7%);--gray7: hsl(0, 0%, 85.8%);--gray8: hsl(0, 0%, 78%);--gray9: hsl(0, 0%, 56.1%);--gray10: hsl(0, 0%, 52.3%);--gray11: hsl(0, 0%, 43.5%);--gray12: hsl(0, 0%, 9%);--border-radius: 8px;box-sizing:border-box;padding:0;margin:0;list-style:none;outline:none;z-index:999999999;transition:transform .4s ease}:where([data-sonner-toaster][data-lifted="true"]){transform:translateY(-10px)}@media (hover: none) and (pointer: coarse){:where([data-sonner-toaster][data-lifted="true"]){transform:none}}:where([data-sonner-toaster][data-x-position="right"]){right:var(--offset-right)}:where([data-sonner-toaster][data-x-position="left"]){left:var(--offset-left)}:where([data-sonner-toaster][data-x-position="center"]){left:50%;transform:translate(-50%)}:where([data-sonner-toaster][data-y-position="top"]){top:var(--offset-top)}:where([data-sonner-toaster][data-y-position="bottom"]){bottom:var(--offset-bottom)}:where([data-sonner-toast]){--y: translateY(100%);--lift-amount: calc(var(--lift) * var(--gap));z-index:var(--z-index);position:absolute;opacity:0;transform:var(--y);filter:blur(0);touch-action:none;transition:transform .4s,opacity .4s,height .4s,box-shadow .2s;box-sizing:border-box;outline:none;overflow-wrap:anywhere}:where([data-sonner-toast][data-styled="true"]){padding:16px;background:var(--normal-bg);border:1px solid var(--normal-border);color:var(--normal-text);border-radius:var(--border-radius);box-shadow:0 4px 12px #0000001a;width:var(--width);font-size:13px;display:flex;align-items:center;gap:6px}:where([data-sonner-toast]:focus-visible){box-shadow:0 4px 12px #0000001a,0 0 0 2px #0003}:where([data-sonner-toast][data-y-position="top"]){top:0;--y: translateY(-100%);--lift: 1;--lift-amount: calc(1 * var(--gap))}:where([data-sonner-toast][data-y-position="bottom"]){bottom:0;--y: translateY(100%);--lift: -1;--lift-amount: calc(var(--lift) * var(--gap))}:where([data-sonner-toast]) :where([data-description]){font-weight:400;line-height:1.4;color:inherit}:where([data-sonner-toast]) :where([data-title]){font-weight:500;line-height:1.5;color:inherit}:where([data-sonner-toast]) :where([data-icon]){display:flex;height:16px;width:16px;position:relative;justify-content:flex-start;align-items:center;flex-shrink:0;margin-left:var(--toast-icon-margin-start);margin-right:var(--toast-icon-margin-end)}:where([data-sonner-toast][data-promise="true"]) :where([data-icon])>svg{opacity:0;transform:scale(.8);transform-origin:center;animation:sonner-fade-in .3s ease forwards}:where([data-sonner-toast]) :where([data-icon])>*{flex-shrink:0}:where([data-sonner-toast]) :where([data-icon]) svg{margin-left:var(--toast-svg-margin-start);margin-right:var(--toast-svg-margin-end)}:where([data-sonner-toast]) :where([data-content]){display:flex;flex-direction:column;gap:2px}[data-sonner-toast][data-styled=true] [data-button]{border-radius:4px;padding-left:8px;padding-right:8px;height:24px;font-size:12px;color:var(--normal-bg);background:var(--normal-text);margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end);border:none;cursor:pointer;outline:none;display:flex;align-items:center;flex-shrink:0;transition:opacity .4s,box-shadow .2s}:where([data-sonner-toast]) :where([data-button]):focus-visible{box-shadow:0 0 0 2px #0006}:where([data-sonner-toast]) :where([data-button]):first-of-type{margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}:where([data-sonner-toast]) :where([data-cancel]){color:var(--normal-text);background:rgba(0,0,0,.08)}:where([data-sonner-toast][data-theme="dark"]) :where([data-cancel]){background:rgba(255,255,255,.3)}:where([data-sonner-toast]) :where([data-close-button]){position:absolute;left:var(--toast-close-button-start);right:var(--toast-close-button-end);top:0;height:20px;width:20px;display:flex;justify-content:center;align-items:center;padding:0;color:var(--gray12);border:1px solid var(--gray4);transform:var(--toast-close-button-transform);border-radius:50%;cursor:pointer;z-index:1;transition:opacity .1s,background .2s,border-color .2s}[data-sonner-toast] [data-close-button]{background:var(--gray1)}:where([data-sonner-toast]) :where([data-close-button]):focus-visible{box-shadow:0 4px 12px #0000001a,0 0 0 2px #0003}:where([data-sonner-toast]) :where([data-disabled="true"]){cursor:not-allowed}:where([data-sonner-toast]):hover :where([data-close-button]):hover{background:var(--gray2);border-color:var(--gray5)}:where([data-sonner-toast][data-swiping="true"]):before{content:"";position:absolute;left:-50%;right:-50%;height:100%;z-index:-1}:where([data-sonner-toast][data-y-position="top"][data-swiping="true"]):before{bottom:50%;transform:scaleY(3) translateY(50%)}:where([data-sonner-toast][data-y-position="bottom"][data-swiping="true"]):before{top:50%;transform:scaleY(3) translateY(-50%)}:where([data-sonner-toast][data-swiping="false"][data-removed="true"]):before{content:"";position:absolute;inset:0;transform:scaleY(2)}:where([data-sonner-toast]):after{content:"";position:absolute;left:0;height:calc(var(--gap) + 1px);bottom:100%;width:100%}:where([data-sonner-toast][data-mounted="true"]){--y: translateY(0);opacity:1}:where([data-sonner-toast][data-expanded="false"][data-front="false"]){--scale: var(--toasts-before) * .05 + 1;--y: translateY(calc(var(--lift-amount) * var(--toasts-before))) scale(calc(-1 * var(--scale)));height:var(--front-toast-height)}:where([data-sonner-toast])>*{transition:opacity .4s}:where([data-sonner-toast][data-expanded="false"][data-front="false"][data-styled="true"])>*{opacity:0}:where([data-sonner-toast][data-visible="false"]){opacity:0;pointer-events:none}:where([data-sonner-toast][data-mounted="true"][data-expanded="true"]){--y: translateY(calc(var(--lift) * var(--offset)));height:var(--initial-height)}:where([data-sonner-toast][data-removed="true"][data-front="true"][data-swipe-out="false"]){--y: translateY(calc(var(--lift) * -100%));opacity:0}:where([data-sonner-toast][data-removed="true"][data-front="false"][data-swipe-out="false"][data-expanded="true"]){--y: translateY(calc(var(--lift) * var(--offset) + var(--lift) * -100%));opacity:0}:where([data-sonner-toast][data-removed="true"][data-front="false"][data-swipe-out="false"][data-expanded="false"]){--y: translateY(40%);opacity:0;transition:transform .5s,opacity .2s}:where([data-sonner-toast][data-removed="true"][data-front="false"]):before{height:calc(var(--initial-height) + 20%)}[data-sonner-toast][data-swiping=true]{transform:var(--y) translateY(var(--swipe-amount-y, 0px)) translate(var(--swipe-amount-x, 0px));transition:none}[data-sonner-toast][data-swiped=true]{user-select:none}[data-sonner-toast][data-swipe-out=true][data-y-position=bottom],[data-sonner-toast][data-swipe-out=true][data-y-position=top]{animation-duration:.2s;animation-timing-function:ease-out;animation-fill-mode:forwards}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=left]{animation-name:swipe-out-left}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=right]{animation-name:swipe-out-right}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=up]{animation-name:swipe-out-up}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=down]{animation-name:swipe-out-down}@keyframes swipe-out-left{0%{transform:var(--y) translate(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translate(calc(var(--swipe-amount-x) - 100%));opacity:0}}@keyframes swipe-out-right{0%{transform:var(--y) translate(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translate(calc(var(--swipe-amount-x) + 100%));opacity:0}}@keyframes swipe-out-up{0%{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) - 100%));opacity:0}}@keyframes swipe-out-down{0%{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) + 100%));opacity:0}}@media (max-width: 600px){[data-sonner-toaster]{position:fixed;right:var(--mobile-offset-right);left:var(--mobile-offset-left);width:100%}[data-sonner-toaster][dir=rtl]{left:calc(var(--mobile-offset-left) * -1)}[data-sonner-toaster] [data-sonner-toast]{left:0;right:0;width:calc(100% - var(--mobile-offset-left) * 2)}[data-sonner-toaster][data-x-position=left]{left:var(--mobile-offset-left)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--mobile-offset-bottom)}[data-sonner-toaster][data-y-position=top]{top:var(--mobile-offset-top)}[data-sonner-toaster][data-x-position=center]{left:var(--mobile-offset-left);right:var(--mobile-offset-right);transform:none}}[data-sonner-toaster][data-theme=light]{--normal-bg: #fff;--normal-border: var(--gray4);--normal-text: var(--gray12);--success-bg: hsl(143, 85%, 96%);--success-border: hsl(145, 92%, 91%);--success-text: hsl(140, 100%, 27%);--info-bg: hsl(208, 100%, 97%);--info-border: hsl(221, 91%, 91%);--info-text: hsl(210, 92%, 45%);--warning-bg: hsl(49, 100%, 97%);--warning-border: hsl(49, 91%, 91%);--warning-text: hsl(31, 92%, 45%);--error-bg: hsl(359, 100%, 97%);--error-border: hsl(359, 100%, 94%);--error-text: hsl(360, 100%, 45%)}[data-sonner-toaster][data-theme=light] [data-sonner-toast][data-invert=true]{--normal-bg: #000;--normal-border: hsl(0, 0%, 20%);--normal-text: var(--gray1)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast][data-invert=true]{--normal-bg: #fff;--normal-border: var(--gray3);--normal-text: var(--gray12)}[data-sonner-toaster][data-theme=dark]{--normal-bg: #000;--normal-bg-hover: hsl(0, 0%, 12%);--normal-border: hsl(0, 0%, 20%);--normal-border-hover: hsl(0, 0%, 25%);--normal-text: var(--gray1);--success-bg: hsl(150, 100%, 6%);--success-border: hsl(147, 100%, 12%);--success-text: hsl(150, 86%, 65%);--info-bg: hsl(215, 100%, 6%);--info-border: hsl(223, 100%, 12%);--info-text: hsl(216, 87%, 65%);--warning-bg: hsl(64, 100%, 6%);--warning-border: hsl(60, 100%, 12%);--warning-text: hsl(46, 87%, 65%);--error-bg: hsl(358, 76%, 10%);--error-border: hsl(357, 89%, 16%);--error-text: hsl(358, 100%, 81%)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast] [data-close-button]{background:var(--normal-bg);border-color:var(--normal-border);color:var(--normal-text)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast] [data-close-button]:hover{background:var(--normal-bg-hover);border-color:var(--normal-border-hover)}[data-rich-colors=true][data-sonner-toast][data-type=success],[data-rich-colors=true][data-sonner-toast][data-type=success] [data-close-button]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=info],[data-rich-colors=true][data-sonner-toast][data-type=info] [data-close-button]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning],[data-rich-colors=true][data-sonner-toast][data-type=warning] [data-close-button]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=error],[data-rich-colors=true][data-sonner-toast][data-type=error] [data-close-button]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}.sonner-loading-wrapper{--size: 16px;height:var(--size);width:var(--size);position:absolute;inset:0;z-index:10}.sonner-loading-wrapper[data-visible=false]{transform-origin:center;animation:sonner-fade-out .2s ease forwards}.sonner-spinner{position:relative;top:50%;left:50%;height:var(--size);width:var(--size)}.sonner-loading-bar{animation:sonner-spin 1.2s linear infinite;background:var(--gray11);border-radius:6px;height:8%;left:-10%;position:absolute;top:-3.9%;width:24%}.sonner-loading-bar:nth-child(1){animation-delay:-1.2s;transform:rotate(.0001deg) translate(146%)}.sonner-loading-bar:nth-child(2){animation-delay:-1.1s;transform:rotate(30deg) translate(146%)}.sonner-loading-bar:nth-child(3){animation-delay:-1s;transform:rotate(60deg) translate(146%)}.sonner-loading-bar:nth-child(4){animation-delay:-.9s;transform:rotate(90deg) translate(146%)}.sonner-loading-bar:nth-child(5){animation-delay:-.8s;transform:rotate(120deg) translate(146%)}.sonner-loading-bar:nth-child(6){animation-delay:-.7s;transform:rotate(150deg) translate(146%)}.sonner-loading-bar:nth-child(7){animation-delay:-.6s;transform:rotate(180deg) translate(146%)}.sonner-loading-bar:nth-child(8){animation-delay:-.5s;transform:rotate(210deg) translate(146%)}.sonner-loading-bar:nth-child(9){animation-delay:-.4s;transform:rotate(240deg) translate(146%)}.sonner-loading-bar:nth-child(10){animation-delay:-.3s;transform:rotate(270deg) translate(146%)}.sonner-loading-bar:nth-child(11){animation-delay:-.2s;transform:rotate(300deg) translate(146%)}.sonner-loading-bar:nth-child(12){animation-delay:-.1s;transform:rotate(330deg) translate(146%)}@keyframes sonner-fade-in{0%{opacity:0;transform:scale(.8)}to{opacity:1;transform:scale(1)}}@keyframes sonner-fade-out{0%{opacity:1;transform:scale(1)}to{opacity:0;transform:scale(.8)}}@keyframes sonner-spin{0%{opacity:1}to{opacity:.15}}@media (prefers-reduced-motion){[data-sonner-toast],[data-sonner-toast]>*,.sonner-loading-bar{transition:none!important;animation:none!important}}.sonner-loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transform-origin:center;transition:opacity .2s,transform .2s}.sonner-loader[data-visible=false]{opacity:0;transform:scale(.8) translate(-50%,-50%)}
`);
function u0(e) {
  return e.label !== void 0;
}
var wx = 3, yx = "32px", bx = "16px", Y3 = 4e3, _x = 356, xx = 14, Lx = 20, Ex = 200;
function Tt(...e) {
  return e.filter(Boolean).join(" ");
}
function Mx(e) {
  let [t, n] = e.split("-"), r = [];
  return t && r.push(t), n && r.push(n), r;
}
var kx = (e) => {
  var t, n, r, a, i, l, s, c, p, h, u;
  let { invert: m, toast: d, unstyled: v, interacting: x, setHeights: k, visibleToasts: I, heights: T, index: L, toasts: S, expanded: E, removeToast: j, defaultRichColors: g, closeButton: w, style: C, cancelButtonStyle: b, actionButtonStyle: M, className: R = "", descriptionClassName: O = "", duration: N, position: H, gap: Z, loadingIcon: z, expandByDefault: K, classNames: D, icons: W, closeButtonAriaLabel: q = "Close toast", pauseWhenPageIsHidden: e1 } = e, [o1, c1] = l1.useState(null), [v1, m1] = l1.useState(null), [$, n1] = l1.useState(!1), [d1, f1] = l1.useState(!1), [M1, Y] = l1.useState(!1), [P1, J1] = l1.useState(!1), [I1, ce] = l1.useState(!1), [ve, oe] = l1.useState(0), [x1, ae] = l1.useState(0), ke = l1.useRef(d.duration || N || Y3), Ie = l1.useRef(null), ye = l1.useRef(null), Ye = L === 0, Ne = L + 1 <= I, K1 = d.type, be = d.dismissible !== !1, He = d.className || "", Oe = d.descriptionClassName || "", Pe = l1.useMemo(() => T.findIndex((C1) => C1.toastId === d.id) || 0, [T, d.id]), Ze = l1.useMemo(() => {
    var C1;
    return (C1 = d.closeButton) != null ? C1 : w;
  }, [d.closeButton, w]), Re = l1.useMemo(() => d.duration || N || Y3, [d.duration, N]), ne = l1.useRef(0), A1 = l1.useRef(0), ze = l1.useRef(0), _e = l1.useRef(null), [De, je] = H.split("-"), Se = l1.useMemo(() => T.reduce((C1, Q, a1) => a1 >= Pe ? C1 : C1 + Q.height, 0), [T, Pe]), se = dx(), xe = d.invert || m, Le = K1 === "loading";
  A1.current = l1.useMemo(() => Pe * Z + Se, [Pe, Se]), l1.useEffect(() => {
    ke.current = Re;
  }, [Re]), l1.useEffect(() => {
    n1(!0);
  }, []), l1.useEffect(() => {
    let C1 = ye.current;
    if (C1) {
      let Q = C1.getBoundingClientRect().height;
      return ae(Q), k((a1) => [{ toastId: d.id, height: Q, position: d.position }, ...a1]), () => k((a1) => a1.filter((B1) => B1.toastId !== d.id));
    }
  }, [k, d.id]), l1.useLayoutEffect(() => {
    if (!$) return;
    let C1 = ye.current, Q = C1.style.height;
    C1.style.height = "auto";
    let a1 = C1.getBoundingClientRect().height;
    C1.style.height = Q, ae(a1), k((B1) => B1.find((ie) => ie.toastId === d.id) ? B1.map((ie) => ie.toastId === d.id ? { ...ie, height: a1 } : ie) : [{ toastId: d.id, height: a1, position: d.position }, ...B1]);
  }, [$, d.title, d.description, k, d.id]);
  let Ee = l1.useCallback(() => {
    f1(!0), oe(A1.current), k((C1) => C1.filter((Q) => Q.toastId !== d.id)), setTimeout(() => {
      j(d);
    }, Ex);
  }, [d, j, k, A1]);
  l1.useEffect(() => {
    if (d.promise && K1 === "loading" || d.duration === 1 / 0 || d.type === "loading") return;
    let C1;
    return E || x || e1 && se ? (() => {
      if (ze.current < ne.current) {
        let Q = (/* @__PURE__ */ new Date()).getTime() - ne.current;
        ke.current = ke.current - Q;
      }
      ze.current = (/* @__PURE__ */ new Date()).getTime();
    })() : ke.current !== 1 / 0 && (ne.current = (/* @__PURE__ */ new Date()).getTime(), C1 = setTimeout(() => {
      var Q;
      (Q = d.onAutoClose) == null || Q.call(d, d), Ee();
    }, ke.current)), () => clearTimeout(C1);
  }, [E, x, d, K1, e1, se, Ee]), l1.useEffect(() => {
    d.delete && Ee();
  }, [Ee, d.delete]);
  function Z1() {
    var C1, Q, a1;
    return W != null && W.loading ? l1.createElement("div", { className: Tt(D == null ? void 0 : D.loader, (C1 = d == null ? void 0 : d.classNames) == null ? void 0 : C1.loader, "sonner-loader"), "data-visible": K1 === "loading" }, W.loading) : z ? l1.createElement("div", { className: Tt(D == null ? void 0 : D.loader, (Q = d == null ? void 0 : d.classNames) == null ? void 0 : Q.loader, "sonner-loader"), "data-visible": K1 === "loading" }, z) : l1.createElement(ix, { className: Tt(D == null ? void 0 : D.loader, (a1 = d == null ? void 0 : d.classNames) == null ? void 0 : a1.loader), visible: K1 === "loading" });
  }
  return l1.createElement("li", { tabIndex: 0, ref: ye, className: Tt(R, He, D == null ? void 0 : D.toast, (t = d == null ? void 0 : d.classNames) == null ? void 0 : t.toast, D == null ? void 0 : D.default, D == null ? void 0 : D[K1], (n = d == null ? void 0 : d.classNames) == null ? void 0 : n[K1]), "data-sonner-toast": "", "data-rich-colors": (r = d.richColors) != null ? r : g, "data-styled": !(d.jsx || d.unstyled || v), "data-mounted": $, "data-promise": !!d.promise, "data-swiped": I1, "data-removed": d1, "data-visible": Ne, "data-y-position": De, "data-x-position": je, "data-index": L, "data-front": Ye, "data-swiping": M1, "data-dismissible": be, "data-type": K1, "data-invert": xe, "data-swipe-out": P1, "data-swipe-direction": v1, "data-expanded": !!(E || K && $), style: { "--index": L, "--toasts-before": L, "--z-index": S.length - L, "--offset": `${d1 ? ve : A1.current}px`, "--initial-height": K ? "auto" : `${x1}px`, ...C, ...d.style }, onDragEnd: () => {
    Y(!1), c1(null), _e.current = null;
  }, onPointerDown: (C1) => {
    Le || !be || (Ie.current = /* @__PURE__ */ new Date(), oe(A1.current), C1.target.setPointerCapture(C1.pointerId), C1.target.tagName !== "BUTTON" && (Y(!0), _e.current = { x: C1.clientX, y: C1.clientY }));
  }, onPointerUp: () => {
    var C1, Q, a1, B1;
    if (P1 || !be) return;
    _e.current = null;
    let ie = Number(((C1 = ye.current) == null ? void 0 : C1.style.getPropertyValue("--swipe-amount-x").replace("px", "")) || 0), A = Number(((Q = ye.current) == null ? void 0 : Q.style.getPropertyValue("--swipe-amount-y").replace("px", "")) || 0), G = (/* @__PURE__ */ new Date()).getTime() - ((a1 = Ie.current) == null ? void 0 : a1.getTime()), U = o1 === "x" ? ie : A, s1 = Math.abs(U) / G;
    if (Math.abs(U) >= Lx || s1 > 0.11) {
      oe(A1.current), (B1 = d.onDismiss) == null || B1.call(d, d), m1(o1 === "x" ? ie > 0 ? "right" : "left" : A > 0 ? "down" : "up"), Ee(), J1(!0), ce(!1);
      return;
    }
    Y(!1), c1(null);
  }, onPointerMove: (C1) => {
    var Q, a1, B1, ie;
    if (!_e.current || !be || ((Q = window.getSelection()) == null ? void 0 : Q.toString().length) > 0) return;
    let A = C1.clientY - _e.current.y, G = C1.clientX - _e.current.x, U = (a1 = e.swipeDirections) != null ? a1 : Mx(H);
    !o1 && (Math.abs(G) > 1 || Math.abs(A) > 1) && c1(Math.abs(G) > Math.abs(A) ? "x" : "y");
    let s1 = { x: 0, y: 0 };
    o1 === "y" ? (U.includes("top") || U.includes("bottom")) && (U.includes("top") && A < 0 || U.includes("bottom") && A > 0) && (s1.y = A) : o1 === "x" && (U.includes("left") || U.includes("right")) && (U.includes("left") && G < 0 || U.includes("right") && G > 0) && (s1.x = G), (Math.abs(s1.x) > 0 || Math.abs(s1.y) > 0) && ce(!0), (B1 = ye.current) == null || B1.style.setProperty("--swipe-amount-x", `${s1.x}px`), (ie = ye.current) == null || ie.style.setProperty("--swipe-amount-y", `${s1.y}px`);
  } }, Ze && !d.jsx ? l1.createElement("button", { "aria-label": q, "data-disabled": Le, "data-close-button": !0, onClick: Le || !be ? () => {
  } : () => {
    var C1;
    Ee(), (C1 = d.onDismiss) == null || C1.call(d, d);
  }, className: Tt(D == null ? void 0 : D.closeButton, (a = d == null ? void 0 : d.classNames) == null ? void 0 : a.closeButton) }, (i = W == null ? void 0 : W.close) != null ? i : ux) : null, d.jsx || fa(d.title) ? d.jsx ? d.jsx : typeof d.title == "function" ? d.title() : d.title : l1.createElement(l1.Fragment, null, K1 || d.icon || d.promise ? l1.createElement("div", { "data-icon": "", className: Tt(D == null ? void 0 : D.icon, (l = d == null ? void 0 : d.classNames) == null ? void 0 : l.icon) }, d.promise || d.type === "loading" && !d.icon ? d.icon || Z1() : null, d.type !== "loading" ? d.icon || (W == null ? void 0 : W[K1]) || rx(K1) : null) : null, l1.createElement("div", { "data-content": "", className: Tt(D == null ? void 0 : D.content, (s = d == null ? void 0 : d.classNames) == null ? void 0 : s.content) }, l1.createElement("div", { "data-title": "", className: Tt(D == null ? void 0 : D.title, (c = d == null ? void 0 : d.classNames) == null ? void 0 : c.title) }, typeof d.title == "function" ? d.title() : d.title), d.description ? l1.createElement("div", { "data-description": "", className: Tt(O, Oe, D == null ? void 0 : D.description, (p = d == null ? void 0 : d.classNames) == null ? void 0 : p.description) }, typeof d.description == "function" ? d.description() : d.description) : null), fa(d.cancel) ? d.cancel : d.cancel && u0(d.cancel) ? l1.createElement("button", { "data-button": !0, "data-cancel": !0, style: d.cancelButtonStyle || b, onClick: (C1) => {
    var Q, a1;
    u0(d.cancel) && be && ((a1 = (Q = d.cancel).onClick) == null || a1.call(Q, C1), Ee());
  }, className: Tt(D == null ? void 0 : D.cancelButton, (h = d == null ? void 0 : d.classNames) == null ? void 0 : h.cancelButton) }, d.cancel.label) : null, fa(d.action) ? d.action : d.action && u0(d.action) ? l1.createElement("button", { "data-button": !0, "data-action": !0, style: d.actionButtonStyle || M, onClick: (C1) => {
    var Q, a1;
    u0(d.action) && ((a1 = (Q = d.action).onClick) == null || a1.call(Q, C1), !C1.defaultPrevented && Ee());
  }, className: Tt(D == null ? void 0 : D.actionButton, (u = d == null ? void 0 : d.classNames) == null ? void 0 : u.actionButton) }, d.action.label) : null));
};
function K3() {
  if (typeof window == "undefined" || typeof document == "undefined") return "ltr";
  let e = document.documentElement.getAttribute("dir");
  return e === "auto" || !e ? window.getComputedStyle(document.documentElement).direction : e;
}
function Sx(e, t) {
  let n = {};
  return [e, t].forEach((r, a) => {
    let i = a === 1, l = i ? "--mobile-offset" : "--offset", s = i ? bx : yx;
    function c(p) {
      ["top", "right", "bottom", "left"].forEach((h) => {
        n[`${l}-${h}`] = typeof p == "number" ? `${p}px` : p;
      });
    }
    typeof r == "number" || typeof r == "string" ? c(r) : typeof r == "object" ? ["top", "right", "bottom", "left"].forEach((p) => {
      r[p] === void 0 ? n[`${l}-${p}`] = s : n[`${l}-${p}`] = typeof r[p] == "number" ? `${r[p]}px` : r[p];
    }) : c(s);
  }), n;
}
var Ax = V(function(e, t) {
  let { invert: n, position: r = "bottom-right", hotkey: a = ["altKey", "KeyT"], expand: i, closeButton: l, className: s, offset: c, mobileOffset: p, theme: h = "light", richColors: u, duration: m, style: d, visibleToasts: v = wx, toastOptions: x, dir: k = K3(), gap: I = xx, loadingIcon: T, icons: L, containerAriaLabel: S = "Notifications", pauseWhenPageIsHidden: E } = e, [j, g] = l1.useState([]), w = l1.useMemo(() => Array.from(new Set([r].concat(j.filter((e1) => e1.position).map((e1) => e1.position)))), [j, r]), [C, b] = l1.useState([]), [M, R] = l1.useState(!1), [O, N] = l1.useState(!1), [H, Z] = l1.useState(h !== "system" ? h : typeof window != "undefined" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"), z = l1.useRef(null), K = a.join("+").replace(/Key/g, "").replace(/Digit/g, ""), D = l1.useRef(null), W = l1.useRef(!1), q = l1.useCallback((e1) => {
    g((o1) => {
      var c1;
      return (c1 = o1.find((v1) => v1.id === e1.id)) != null && c1.delete || mt.dismiss(e1.id), o1.filter(({ id: v1 }) => v1 !== e1.id);
    });
  }, []);
  return l1.useEffect(() => mt.subscribe((e1) => {
    if (e1.dismiss) {
      g((o1) => o1.map((c1) => c1.id === e1.id ? { ...c1, delete: !0 } : c1));
      return;
    }
    setTimeout(() => {
      t4.flushSync(() => {
        g((o1) => {
          let c1 = o1.findIndex((v1) => v1.id === e1.id);
          return c1 !== -1 ? [...o1.slice(0, c1), { ...o1[c1], ...e1 }, ...o1.slice(c1 + 1)] : [e1, ...o1];
        });
      });
    });
  }), []), l1.useEffect(() => {
    if (h !== "system") {
      Z(h);
      return;
    }
    if (h === "system" && (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? Z("dark") : Z("light")), typeof window == "undefined") return;
    let e1 = window.matchMedia("(prefers-color-scheme: dark)");
    try {
      e1.addEventListener("change", ({ matches: o1 }) => {
        Z(o1 ? "dark" : "light");
      });
    } catch {
      e1.addListener(({ matches: c1 }) => {
        try {
          Z(c1 ? "dark" : "light");
        } catch (v1) {
          console.error(v1);
        }
      });
    }
  }, [h]), l1.useEffect(() => {
    j.length <= 1 && R(!1);
  }, [j]), l1.useEffect(() => {
    let e1 = (o1) => {
      var c1, v1;
      a.every((m1) => o1[m1] || o1.code === m1) && (R(!0), (c1 = z.current) == null || c1.focus()), o1.code === "Escape" && (document.activeElement === z.current || (v1 = z.current) != null && v1.contains(document.activeElement)) && R(!1);
    };
    return document.addEventListener("keydown", e1), () => document.removeEventListener("keydown", e1);
  }, [a]), l1.useEffect(() => {
    if (z.current) return () => {
      D.current && (D.current.focus({ preventScroll: !0 }), D.current = null, W.current = !1);
    };
  }, [z.current]), l1.createElement("section", { ref: t, "aria-label": `${S} ${K}`, tabIndex: -1, "aria-live": "polite", "aria-relevant": "additions text", "aria-atomic": "false", suppressHydrationWarning: !0 }, w.map((e1, o1) => {
    var c1;
    let [v1, m1] = e1.split("-");
    return j.length ? l1.createElement("ol", { key: e1, dir: k === "auto" ? K3() : k, tabIndex: -1, ref: z, className: s, "data-sonner-toaster": !0, "data-theme": H, "data-y-position": v1, "data-lifted": M && j.length > 1 && !i, "data-x-position": m1, style: { "--front-toast-height": `${((c1 = C[0]) == null ? void 0 : c1.height) || 0}px`, "--width": `${_x}px`, "--gap": `${I}px`, ...d, ...Sx(c, p) }, onBlur: ($) => {
      W.current && !$.currentTarget.contains($.relatedTarget) && (W.current = !1, D.current && (D.current.focus({ preventScroll: !0 }), D.current = null));
    }, onFocus: ($) => {
      $.target instanceof HTMLElement && $.target.dataset.dismissible === "false" || W.current || (W.current = !0, D.current = $.relatedTarget);
    }, onMouseEnter: () => R(!0), onMouseMove: () => R(!0), onMouseLeave: () => {
      O || R(!1);
    }, onDragEnd: () => R(!1), onPointerDown: ($) => {
      $.target instanceof HTMLElement && $.target.dataset.dismissible === "false" || N(!0);
    }, onPointerUp: () => N(!1) }, j.filter(($) => !$.position && o1 === 0 || $.position === e1).map(($, n1) => {
      var d1, f1;
      return l1.createElement(kx, { key: $.id, icons: L, index: n1, toast: $, defaultRichColors: u, duration: (d1 = x == null ? void 0 : x.duration) != null ? d1 : m, className: x == null ? void 0 : x.className, descriptionClassName: x == null ? void 0 : x.descriptionClassName, invert: n, visibleToasts: v, closeButton: (f1 = x == null ? void 0 : x.closeButton) != null ? f1 : l, interacting: O, position: e1, style: x == null ? void 0 : x.style, unstyled: x == null ? void 0 : x.unstyled, classNames: x == null ? void 0 : x.classNames, cancelButtonStyle: x == null ? void 0 : x.cancelButtonStyle, actionButtonStyle: x == null ? void 0 : x.actionButtonStyle, removeToast: q, toasts: j.filter((M1) => M1.position == $.position), heights: C.filter((M1) => M1.position == $.position), setHeights: b, expandByDefault: i, gap: I, loadingIcon: T, expanded: M, pauseWhenPageIsHidden: E, swipeDirections: e.swipeDirections });
    })) : null;
  }));
});
const Tx = "_snackbar_1oerq_1", Ix = "_close_1oerq_42", Rx = "_content_1oerq_54", Nx = "_info_1oerq_61", Hx = "_icon_1oerq_65", Ox = "_success_1oerq_94", jx = "_error_1oerq_101", Px = "_warning_1oerq_108", Dx = "_title_1oerq_117", Vx = "_text_1oerq_126", Bx = "_description_1oerq_134", f2 = {
  snackbar: Tx,
  close: Ix,
  content: Rx,
  info: Nx,
  icon: Hx,
  success: Ox,
  error: jx,
  warning: Px,
  title: Dx,
  text: Vx,
  description: Bx
}, Fx = {
  success: /* @__PURE__ */ f.jsx(b1, { name: "check-long" }),
  error: /* @__PURE__ */ f.jsx(b1, { name: "error" }),
  warning: /* @__PURE__ */ f.jsx(b1, { name: "warning" }),
  info: /* @__PURE__ */ f.jsx(b1, { name: "info-circle" }),
  default: ""
}, Zx = ({
  message: e,
  status: t = "default",
  className: n = "snackbar-toast",
  title: r,
  options: a,
  content: i
}) => {
  const l = {
    duration: 5e3,
    unstyled: !0,
    className: n,
    ...a
  }, s = () => i || /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx("div", { className: f2.icon, children: Fx[t] }),
    /* @__PURE__ */ f.jsx("div", { className: f2.info, children: r ? /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      /* @__PURE__ */ f.jsx("h3", { className: f2.title, children: r }),
      /* @__PURE__ */ f.jsx("p", { className: f2.description, children: e })
    ] }) : /* @__PURE__ */ f.jsx("p", { className: f2.text, children: e }) })
  ] });
  $3.custom((c) => /* @__PURE__ */ f.jsxs("div", { className: h1(f2.snackbar, {
    [f2[t]]: t
  }), children: [
    /* @__PURE__ */ f.jsx("button", { className: f2.close, onClick: () => $3.dismiss(c), children: /* @__PURE__ */ f.jsx(b1, { name: "close" }) }),
    /* @__PURE__ */ f.jsx("div", { className: f2.content, children: s() })
  ] }), l);
}, P2 = {
  sendMessage: Zx
};
function Gx({
  text: e,
  id: t
}) {
  const {
    formatMessage: n
  } = N1(), r = Xe(() => J.htmlUnescape(e).split(K_), [e]), a = (l, s) => {
    l.stopPropagation(), J.copyTextToClipboard(s, () => {
      P2.sendMessage({
        status: "success",
        message: n(We.copyPromoSuccess)
      });
    });
  }, i = Xe(() => {
    let l = [];
    return l = r.map((s, c) => {
      if (X_.test(s)) {
        const p = `promo-tooltip-${t}`, h = s.replace(/<|>/g, "");
        return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          /* @__PURE__ */ f.jsx(Je, { onClick: (u) => a(u, h), className: k1.highlighted, "data-tooltip-id": p, children: h }, `promo-${h}`),
          /* @__PURE__ */ f.jsx(kt, { id: p, opacity: 1, className: k1.copyTooltip, place: "bottom", children: /* @__PURE__ */ f.jsx("span", { children: n(We.copyPromo) }) }, `promo-tooltip-${h}`)
        ] });
      }
      if (Q_.test(s)) {
        const p = s.replace(/\[|\]/g, "");
        return /* @__PURE__ */ f.jsx("span", { className: k1.highlighted, children: p }, `highlight-${c + p}`);
      }
      if (J_.test(s)) {
        const p = s.split("]")[0].replace("[url=", ""), h = s.replace(/\[url=[^\]\s]*\]/g, "").replace(/\[\/url\]/g, "");
        return /* @__PURE__ */ f.jsx("a", { href: p, target: "_blank", rel: "noopener noreferrer", className: k1.highlighted, onClick: (u) => u.stopPropagation(), children: h }, `highlight-${c + p}`);
      }
      return s;
    }), l;
  }, [r]);
  return /* @__PURE__ */ f.jsx("span", { className: k1.text, children: i });
}
function Wx({
  notification: {
    data: {
      project_name: e,
      image_url: t
    }
  },
  revert: n
}) {
  const {
    formatMessage: r
  } = N1();
  return /* @__PURE__ */ f.jsx("div", { className: h1(k1.wrapper, k1.updated), children: /* @__PURE__ */ f.jsxs("div", { className: k1.content, children: [
    /* @__PURE__ */ f.jsx("img", { alt: e, src: t, className: k1.picture }),
    /* @__PURE__ */ f.jsxs("div", { className: k1.data, children: [
      /* @__PURE__ */ f.jsx("span", { className: k1.title, children: r(We.unsubscribed, {
        project_name: e
      }) }),
      /* @__PURE__ */ f.jsx("div", { className: k1.actions, children: /* @__PURE__ */ f.jsx(q1, { onClick: n, size: "sm", appearance: "alpha", children: r(We.cancel) }) })
    ] })
  ] }) });
}
function yo(e) {
  const {
    tabletMdMax: t
  } = Ue(["tabletMdMax"]), {
    onReadNotification: n,
    onDeleteNotification: r
  } = D1(c2), {
    locale: a
  } = N1(), {
    pushReachGoal: i
  } = le(), {
    notification: {
      id: l,
      created: s,
      controls: c,
      data: {
        title: p,
        text: h,
        project_name: u,
        unsubscribe_url: m,
        gc_link_url: d,
        link_url: v,
        pixel_click_url: x,
        pixel_url: k,
        image_url: I
      },
      is_read: T,
      template_id: L,
      raw_data: S
    },
    onClose: E
  } = e, j = J.htmlUnescape(p), [g, w] = r1(!1), [C, b] = r1(!1), {
    formatMessage: M
  } = N1(), R = !!E, O = J.inGamecenter ? d : v;
  u1(() => {
    R && (k && J.triggerPixel(k), i({
      params: {
        category: "notifications",
        action: "show"
      }
    }));
  }, []);
  const N = (q) => {
    var o1;
    const e1 = q.target;
    [k1.highlighted, k1.wrapper, k1.content, k1.title, k1.text, k1.date].includes(e1.className) && (J.inGamecenter && (J.triggerPixel(x), window.gc_game_invite && L === w2.GameInvite && window.gc_game_invite({
      raw_data: S,
      data: {
        title: p,
        text: h,
        image_url: I
      }
    })), O && ((o1 = window.open(O, "_blank")) == null || o1.focus()), i({
      params: {
        category: "notifications",
        action: "click",
        label: O,
        entity_id: R ? "popup" : "inside kolokolchik"
      }
    }), R && E(l));
  }, H = async (q) => {
    q.stopPropagation(), await Ts(l), b(!0), r(), i({
      params: {
        category: "notifications",
        action: "menu_delete_click",
        label: "inside kolokolchik",
        entity_id: O
      }
    });
  }, Z = async (q) => {
    q.stopPropagation(), await Vb(m, g), w((e1) => !e1), i({
      params: {
        category: "notifications",
        action: "menu_hide_click",
        label: "inside kolokolchik",
        entity_id: O
      }
    });
  }, z = async () => {
    T || R || n(l);
  }, K = (q) => {
    q && (k && !R && J.triggerPixel(k), !(T || !t || J.inGamecenter) && setTimeout(() => {
      z();
    }, 1500));
  }, D = Xe(() => S != null && S.user_name ? j.split(ex).map((e1) => e1 === (S == null ? void 0 : S.user_name) ? /* @__PURE__ */ f.jsx("a", { href: v, onClick: R ? () => E(l) : void 0, children: S == null ? void 0 : S.user_name }) : e1) : "", []);
  if (C && (!t || J.inGamecenter))
    return /* @__PURE__ */ f.jsx("div", { className: k1.deleted, children: M(We.deleted) });
  if (L === w2.FriendRequest)
    return /* @__PURE__ */ f.jsx(tx, { ...e, onDelete: H, onRead: z, onClose: E, onView: K });
  if (g)
    return /* @__PURE__ */ f.jsx(Wx, { ...e, revert: Z });
  const W = !!u && !!m;
  return /* @__PURE__ */ f.jsxs(wo, { className: h1(k1.wrapper, "vkp-notification-wrapper", {
    [k1.new]: (!T || t && C && !J.inGamecenter) && !R,
    [k1.inBubble]: R,
    [k1.link]: !!O
  }), onMouseEnter: z, onClick: N, triggerOnce: !0, onChange: K, threshold: 1, rootMargin: "0px 0px 60px 0px", children: [
    C && t && /* @__PURE__ */ f.jsx(Ns, { label: M(We.deleted), position: "top" }),
    /* @__PURE__ */ f.jsxs("div", { className: h1(k1.content, {
      [k1.inBubble]: R
    }), children: [
      /* @__PURE__ */ f.jsx(Hs, { ...e }),
      /* @__PURE__ */ f.jsxs("div", { className: k1.data, children: [
        /* @__PURE__ */ f.jsx("span", { className: k1.title, children: [w2.RequestAccepted, w2.RequestDeclined].includes(L) ? D : j }),
        h && /* @__PURE__ */ f.jsx(Gx, { text: h, id: l }),
        !R && /* @__PURE__ */ f.jsx("span", { className: k1.date, children: js(s, a) }),
        c.length > 0 && /* @__PURE__ */ f.jsx(nx, { ...e, inBubble: R, onClose: E })
      ] }),
      R ? /* @__PURE__ */ f.jsx(Je, { onClick: () => E(l), className: k1.contextMenuItem, children: /* @__PURE__ */ f.jsx(b1, { name: "close" }) }) : /* @__PURE__ */ f.jsx($_, { id: l, onDelete: H, onHide: W ? Z : void 0, href: O })
    ] }),
    !T && !t && !R && /* @__PURE__ */ f.jsx("div", { className: k1.newLabel })
  ] });
}
function Ux() {
  const {
    list: e,
    loading: t
  } = D1(c2);
  return t ? /* @__PURE__ */ f.jsx(nr, { className: Qe.mobileLoader, size: "48" }) : !t && e.length === 0 ? /* @__PURE__ */ f.jsx(Rs, {}) : /* @__PURE__ */ f.jsx("div", { className: Qe.list, children: e.map((n) => /* @__PURE__ */ f.jsx(yo, { notification: n }, `${n.id}_${n.template_id}`)) });
}
function Ps({
  onClose: e,
  open: t
}) {
  return t ? /* @__PURE__ */ f.jsx(Z2, { shouldDisableBodyScroll: !0, into: Os, children: /* @__PURE__ */ f.jsxs(ia, { className: Qe.container, children: [
    /* @__PURE__ */ f.jsx(e_, { onClose: e }),
    /* @__PURE__ */ f.jsx(Ux, {})
  ] }) }) : null;
}
function zx() {
  const {
    pushReachGoal: e
  } = le(), {
    unread: t
  } = D1(c2), {
    formatMessage: n
  } = N1(), [r, a] = r1(!1), i = W1(() => {
    a(!1);
  }, []), l = W1(() => {
    a(!0), e({
      params: {
        category: "header",
        action: "click",
        label: "ph-menu-notifications"
      }
    });
  }, []);
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsxs(Je, { className: h1(Me.menuItem, Me.transparent), onClick: l, children: [
      /* @__PURE__ */ f.jsxs("div", { className: Me.btnIcon, children: [
        /* @__PURE__ */ f.jsx(b1, { name: t > 0 ? "notification-subtract-outline" : "notification-outline" }),
        t > 0 && /* @__PURE__ */ f.jsx(q0, { size: "small", className: Me.counter, mode: "negative", children: t })
      ] }),
      /* @__PURE__ */ f.jsx("div", { className: Me.btnText, children: n(U1.notifications) })
    ] }),
    /* @__PURE__ */ f.jsx(Ps, { onClose: i, open: r })
  ] });
}
function qx({
  onClose: e,
  count: t
}) {
  const {
    formatMessage: n
  } = N1();
  return /* @__PURE__ */ f.jsxs("div", { className: Qe.header, children: [
    /* @__PURE__ */ f.jsx(q1, { onClick: e, leftIcon: /* @__PURE__ */ f.jsx(b1, { name: "chevron-left" }), appearance: "overlay", mode: "link", className: Qe.headerButton, size: "sm" }),
    /* @__PURE__ */ f.jsx("span", { className: Qe.title, children: /* @__PURE__ */ f.jsxs("span", { className: Qe.notify, children: [
      n(U1.favorites),
      t > 0 && /* @__PURE__ */ f.jsx("span", { className: Qe.sub, children: t })
    ] }) }),
    /* @__PURE__ */ f.jsx(q1, { onClick: () => {
    }, className: h1(Qe.headerButton, Qe.hidden), leftIcon: /* @__PURE__ */ f.jsx(b1, { name: "list-check-outline" }), appearance: "overlay", mode: "link", size: "sm" })
  ] });
}
const bo = o2({
  data: [],
  loading: !0,
  count: 0
}), Q3 = "needWishlistUpdate", _o = ({
  children: e,
  open: t
}) => {
  const [n, r] = r1([]), [a, i] = r1(!0), [l, s] = r1(0), c = V1(!0), p = async () => {
    i(!0);
    try {
      c.current = !1;
      const {
        results: h,
        count: u
      } = await J.Backend.get(me.wishlist, {
        limit: 24
      });
      Array.isArray(h) && (r(h), s(u), localStorage.setItem("needWishlistUpdate", "0"));
    } catch (h) {
      console.error(h), localStorage.setItem("needWishlistUpdate", "1");
    }
    i(!1);
  };
  return u1(() => {
    J.inGamecenter && (c.current && p(), window.gc_window_state = (h) => {
      h === 3 && !c.current && localStorage.getItem(Q3) === "1" && p();
    });
  }, []), u1(() => {
    J.inGamecenter || t && (c.current || localStorage.getItem(Q3) === "1") && p();
  }, [t]), /* @__PURE__ */ f.jsx(bo.Provider, { value: {
    data: n,
    loading: a,
    count: l
  }, children: e });
}, z1 = {
  controlCancel: {
    id: "search.control.cancel",
    defaultMessage: "Отмена"
  },
  controlShowMore: {
    id: "search.control.show_more",
    defaultMessage: "Показать все"
  },
  games: {
    id: "search.group.label.games",
    defaultMessage: "Игры"
  },
  dev: {
    id: "search.group.label.dev",
    defaultMessage: "DEV"
  },
  services: {
    id: "search.group.label.services",
    defaultMessage: "Сервисы"
  },
  media: {
    id: "search.group.label.media",
    defaultMessage: "Медиа"
  },
  market: {
    id: "search.group.label.market",
    defaultMessage: "Маркет"
  },
  placeholderInput: {
    id: "search.placeholder.input",
    defaultMessage: "Нажмите для поиска"
  },
  placeholderNotFoundTitle: {
    id: "search.placeholder.not_found.title",
    defaultMessage: "Ничего не найдено"
  },
  placeholderNotFoundDescription: {
    id: "search.placeholder.not_found.description",
    defaultMessage: "Измените поисковый запрос или воспользуйтесь фильтрами в каталоге"
  },
  dlc: {
    id: "search.label.dlc",
    defaultMessage: "Дополнение"
  },
  bundle: {
    id: "search.label.bundle",
    defaultMessage: "Набор"
  },
  demo: {
    id: "search.label.demo",
    defaultMessage: "Есть демо"
  },
  bought: {
    id: "search.price.bought",
    defaultMessage: "Приобретено"
  },
  releaseSoon: {
    id: "search.price.release_soon",
    defaultMessage: "Скоро релиз"
  },
  free: {
    id: "search.price.free",
    defaultMessage: "Бесплатно"
  },
  cloudOnly: {
    id: "search.price.cloudOnly",
    defaultMessage: "Доступно в облаке"
  },
  priceFrom: {
    id: "search.price.from",
    defaultMessage: "от"
  },
  emptyTitle: {
    id: "search.empty.title",
    defaultMessage: "Игры ближе, чем кажутся"
  },
  emptyDescr: {
    id: "search.empty.descr",
    defaultMessage: "Введите что-нибудь, чтобы начать поиск"
  },
  support: {
    id: "search.support",
    defaultMessage: "Служба поддержки"
  },
  categoryNotFoundTitle: {
    id: "search.category.not_found.title",
    defaultMessage: "В выбранной категории ничего не найдено"
  },
  categoryNotFoundDescription: {
    id: "search.category.not_found.description",
    defaultMessage: "Загляните в другие разделы"
  },
  key: {
    id: "search.label.key",
    defaultMessage: "Ключ"
  },
  steamGift: {
    id: "search.label.steam_gift",
    defaultMessage: "Гифт в Steam"
  },
  cybersport: {
    id: "search.media.cybersport",
    defaultMessage: "Киберспорт"
  },
  gof: {
    id: "search.media.gof",
    defaultMessage: "Игры Будущего"
  },
  static: {
    id: "search.media.static",
    defaultMessage: "Статичные Страницы"
  },
  news: {
    id: "search.media.news",
    defaultMessage: "Новости"
  },
  review: {
    id: "search.media.review",
    defaultMessage: "Рецензии"
  },
  preview: {
    id: "search.media.preview",
    defaultMessage: "Превью"
  },
  feat: {
    id: "search.media.feat",
    defaultMessage: "Фичер"
  },
  secret: {
    id: "search.media.secret",
    defaultMessage: "Секреты"
  },
  hard: {
    id: "search.media.hard",
    defaultMessage: "Железо"
  },
  faq: {
    id: "search.media.faq",
    defaultMessage: "Карточки"
  },
  video: {
    id: "search.media.video",
    defaultMessage: "Видео"
  },
  file: {
    id: "search.media.file",
    defaultMessage: "Файлы"
  },
  article: {
    id: "search.media.article",
    defaultMessage: "Статья"
  },
  compilation: {
    id: "search.media.compilation",
    defaultMessage: "Подборка"
  },
  commercial: {
    id: "search.media.commercial",
    defaultMessage: "Коммерческий материал"
  },
  recommendedTitle: {
    id: "search.recommended.title",
    defaultMessage: "Вам может подойти"
  },
  historyTitle: {
    id: "search.history.title",
    defaultMessage: "Вы искали"
  },
  historyClear: {
    id: "search.history.clear",
    defaultMessage: "Очистить историю"
  },
  historyClearShort: {
    id: "search.history.clear_short",
    defaultMessage: "Очистить"
  },
  steam: {
    id: "steam.refill",
    defaultMessage: "Пополнить Steam"
  },
  tabAll: {
    id: "tabs.all",
    defaultMessage: "Везде"
  },
  tabGames: {
    id: "search.group.label.games",
    defaultMessage: "Игры"
  },
  tabServices: {
    id: "search.group.label.services",
    defaultMessage: "Сервисы"
  },
  tabMedia: {
    id: "search.group.label.media",
    defaultMessage: "Медиа"
  },
  groupLabelGames: {
    id: "search.group.label.games",
    defaultMessage: "Игры"
  },
  groupLabelServices: {
    id: "search.group.label.services",
    defaultMessage: "Сервисы"
  },
  groupLabelMedia: {
    id: "search.group.label.media",
    defaultMessage: "Медиа"
  }
}, $x = ["typedownload", "code", "paid_content", "partner_download"], Yx = ({
  costInfo: e,
  isReleaseSoon: t,
  isCloud: n,
  noDistribution: r,
  gameType: a,
  preorder: i
}) => {
  const {
    formatMessage: l
  } = N1(), {
    currency: s,
    original_cost: c,
    actual_cost: p,
    discount: h,
    bought: u
  } = e, m = $x.includes(a || ""), d = n && (m || r) ? "" : l(z1.free);
  return /* @__PURE__ */ f.jsx(X0, { size: "sm", variant: "lime", currency: s, actualValue: p, originalValue: c, discountValue: h, isBought: u, isReleaseSoon: t, boughtLabel: l(z1.bought), releaseSoonLabel: l(z1.releaseSoon), freeLabel: d, preorder: i });
}, Kx = "_root_15d08_1", Qx = "_fullscreen_15d08_22", Xx = "_wishlist_15d08_26", Jx = "_imageWrapper_15d08_31", eL = "_poster_15d08_71", tL = "_image_15d08_31", nL = "_content_15d08_104", rL = "_title_15d08_112", aL = "_description_15d08_122", iL = "_labelMobile_15d08_167", Wt = {
  root: Kx,
  fullscreen: Qx,
  wishlist: Xx,
  imageWrapper: Jx,
  poster: eL,
  image: tL,
  content: nL,
  title: rL,
  description: aL,
  labelMobile: iL
}, v2 = {
  empty: {
    id: "wishlist.empty",
    defaultMessage: "В избранном пока ничего нет"
  },
  emptySub: {
    id: "wishlist.emptySub",
    defaultMessage: "Для быстрого доступа добавляйте сюда игры, которые вам понравились"
  },
  toCatalog: {
    id: "wishlist.toCatalog",
    defaultMessage: "Перейти в каталог"
  },
  deleted: {
    id: "wishlist.deleted",
    defaultMessage: "Игра успешно удалена из вашей коллекции"
  },
  delete: {
    id: "wishlist.delete",
    defaultMessage: "Удалить из избранного"
  },
  added: {
    id: "wishlist.added",
    defaultMessage: "Игра успешно добавлена в вашу коллекцию"
  },
  add: {
    id: "wishlist.add",
    defaultMessage: "Добавить в избранное"
  },
  seeAll: {
    id: "wishlist.seeAll",
    defaultMessage: "Смотреть все"
  },
  error: {
    id: "wishlist.error",
    defaultMessage: "Что-то не так. Повторите попытку позже"
  }
}, oL = "_wishlist_9m3l2_1", sL = "_app_9m3l2_4", lL = "_redirectButton_9m3l2_14", cL = "_customList_9m3l2_41", uL = "_wishlistGameButton_9m3l2_77", dL = "_wishlistGame_9m3l2_77", fL = "_empty_9m3l2_112", hL = "_emptyGC_9m3l2_121", pL = "_header_9m3l2_125", mL = "_sub_9m3l2_132", CL = "_mobileContainer_9m3l2_141", gL = "_loading_9m3l2_148", vt = {
  wishlist: oL,
  app: sL,
  redirectButton: lL,
  customList: cL,
  wishlistGameButton: uL,
  wishlistGame: dL,
  empty: fL,
  emptyGC: hL,
  header: pL,
  sub: mL,
  mobileContainer: CL,
  loading: gL
};
function vL({
  game: e
}) {
  const {
    formatMessage: t
  } = N1(), {
    pushReachGoal: n
  } = le(), [r, a] = r1(!0), i = async (s) => {
    s.stopPropagation(), s.preventDefault();
    const p = e.is_in_wishlist ? 0 : 1;
    try {
      await J.Backend.api_post(me.gameSetting, {
        game_id: e.id,
        val: p,
        [p ? "keys_on" : "keys_off"]: "show_in_wishlist"
      }), a((h) => (J.inGamecenter || (h ? (n({
        params: {
          category: "library",
          action: "delete_click",
          label: J.inGamecenter ? "Gamecenter" : window.location.host,
          entity_id: e.id
        }
      }), P2.sendMessage({
        status: "success",
        message: t(v2.deleted)
      })) : P2.sendMessage({
        status: "success",
        message: t(v2.added)
      })), !h));
    } catch (h) {
      console.error(h), J.inGamecenter || P2.sendMessage({
        status: "error",
        message: t(v2.error)
      });
    }
    localStorage.setItem("needWishlistUpdate", "1");
  }, l = `wishlist-tooltip-${e.id}`;
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(Je, { className: vt.wishlistGameButton, onClick: i, "data-tooltip-id": l, children: /* @__PURE__ */ f.jsx(b1, { name: r ? "bookmark-20" : "bookmark-outline" }) }),
    /* @__PURE__ */ f.jsx(kt, { id: l, place: "bottom-end", appearance: "neutral", children: t(r ? v2.delete : v2.add) })
  ] });
}
function Ds({
  game: e,
  isFullscreen: t = !1
}) {
  var I;
  const {
    url: n,
    picture: r,
    name: a,
    cost_info: i,
    release_soon: l,
    is_cloud: s,
    has_distribution: c,
    type: p,
    id: h,
    labels: u
  } = e, {
    formatMessage: m
  } = N1(), d = (I = u.find((T) => ["demo", "dlc"].includes(T.type))) == null ? void 0 : I.type, {
    pushReachGoal: v
  } = le(), x = () => {
    v({
      params: {
        category: "library",
        action: "click",
        label: J.inGamecenter ? "Gamecenter" : window.location.host,
        entity_id: h
      }
    }), J.inGamecenter && window.gc_open_url_mainwnd && (window.gc_open_url_mainwnd(e.url), window.gc_close_window && window.gc_close_window());
  }, k = J.inGamecenter ? "div" : "a";
  return /* @__PURE__ */ f.jsxs(k, { className: h1(Wt.root, Wt.wishlist, vt.wishlistGame, {
    [Wt.fullscreen]: t
  }), href: n, onClick: x, children: [
    /* @__PURE__ */ f.jsx("div", { className: h1(Wt.imageWrapper, Wt.poster), children: r && /* @__PURE__ */ f.jsx(ur, { className: Wt.image, src: r.replace(`https://${J.VKPLAY_DOMAIN}/`, `https://${J.STATIC_CDN_DOMAIN}/`), alt: a, breakpoints: {
      tabletMdMax: {
        width: 90,
        height: 48
      },
      tabletMdMin: {
        width: 120,
        height: 64
      }
    } }) }),
    /* @__PURE__ */ f.jsxs("div", { className: Wt.content, children: [
      d && z1[d] && t && /* @__PURE__ */ f.jsx(J2, { type: d, size: "xs", label: m(z1[d]), className: Wt.labelMobile }),
      /* @__PURE__ */ f.jsx("div", { className: Wt.title, children: a }),
      i && /* @__PURE__ */ f.jsxs("div", { className: Wt.description, children: [
        /* @__PURE__ */ f.jsx("div", { children: /* @__PURE__ */ f.jsx(Yx, { costInfo: i, isReleaseSoon: l, isCloud: s, noDistribution: !c, gameType: p }) }),
        d && z1[d] && !t && /* @__PURE__ */ f.jsx(J2, { type: d, size: "lg", label: m(z1[d]) })
      ] }),
      !t && /* @__PURE__ */ f.jsx(vL, { game: e })
    ] })
  ] });
}
function Vs() {
  const {
    pushReachGoal: e
  } = le(), {
    formatMessage: t
  } = N1(), n = () => {
    e({
      params: {
        category: "library",
        action: "goto_catalog_click"
      }
    }), J.inGamecenter && window.gc_open_url_mainwnd ? (window.gc_open_url_mainwnd(`https://${Ke}/play/`), window.gc_close_window && window.gc_close_window()) : window.open(`https://${Ke}/play/`, "_self");
  };
  return /* @__PURE__ */ f.jsxs("div", { className: h1(vt.empty, {
    [vt.emptyGC]: J.inGamecenter
  }), children: [
    /* @__PURE__ */ f.jsx("span", { className: vt.header, children: t(v2.empty) }),
    /* @__PURE__ */ f.jsx("span", { className: vt.sub, children: t(v2.emptySub) }),
    /* @__PURE__ */ f.jsx(q1, { size: "lg", appearance: "neutral", onClick: n, rightIcon: /* @__PURE__ */ f.jsx(b1, { name: "chevron-right-outline-24" }), children: t(v2.toCatalog) })
  ] });
}
function wL({
  onClose: e
}) {
  const {
    loading: t,
    data: n,
    count: r
  } = D1(bo);
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(qx, { onClose: e, count: r }),
    /* @__PURE__ */ f.jsxs("div", { className: h1(vt.mobileContainer, {
      [vt.loading]: t || n.length === 0
    }), children: [
      !t && n.length === 0 && /* @__PURE__ */ f.jsx(Vs, {}),
      t && /* @__PURE__ */ f.jsx(nr, { size: "48" }),
      n.length > 0 && !t && n.map((a) => /* @__PURE__ */ f.jsx(Ds, { game: a, isFullscreen: !0 }, a.id))
    ] })
  ] });
}
function yL(e) {
  return e.open ? /* @__PURE__ */ f.jsx(Z2, { shouldDisableBodyScroll: !0, into: Os, children: /* @__PURE__ */ f.jsx(ia, { className: Qe.container, children: /* @__PURE__ */ f.jsx(wL, { ...e }) }) }) : null;
}
function bL() {
  const {
    pushReachGoal: e
  } = le(), {
    formatMessage: t
  } = N1(), [n, r] = r1(!1), a = W1(() => {
    r(!1);
  }, []), i = W1(() => {
    r(!0), e({
      params: {
        category: "header",
        action: "click",
        label: "ph-menu-library"
      }
    });
  }, []);
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsxs(Je, { className: h1(Me.menuItem, Me.transparent), onClick: i, children: [
      /* @__PURE__ */ f.jsx("div", { className: Me.btnIcon, children: /* @__PURE__ */ f.jsx(b1, { name: "bookmark-outline" }) }),
      /* @__PURE__ */ f.jsx("div", { className: Me.btnText, children: t(U1.favorites) })
    ] }),
    /* @__PURE__ */ f.jsx(_o, { open: n, children: /* @__PURE__ */ f.jsx(yL, { onClose: a, open: n }) })
  ] });
}
const _L = ({
  onNotificationsClick: e
}) => [{
  id: "profile",
  label: U1.profile,
  href: `https://${qr}`,
  icon: "user-outline"
}, {
  id: "favorites",
  label: U1.favorites,
  icon: "bookmark-outline"
}, {
  id: "notifications",
  label: U1.notifications,
  icon: "notification-outline",
  onClick: e
}, {
  id: "support",
  label: U1.support,
  href: `https://${ea}`,
  icon: "help-outline"
}, {
  id: "settings",
  label: U1.settings,
  href: `https://${Hn}/profile/userinfo`,
  icon: "settings-outline"
}], xo = (e) => {
  const {
    continueUrl: t,
    fromUrl: n
  } = e || {}, r = t ? `&continue=${encodeURIComponent(t)}` : "";
  return `${me.login}?from=${encodeURIComponent(n || window.location.href)}${r}`;
}, Bs = (e) => {
  var t, n;
  J.isMyGamesApp ? (t = window.messageHandler) == null || t.postMessage("LOGIN") : J.inGamecenter ? (n = window.gc_show_auth_window) == null || n.call(window) : window.location.href = xo(e);
}, xL = () => {
  const {
    session: {
      session: e,
      profile: t
    }
  } = D1(bt), {
    formatMessage: n
  } = N1(), r = xo(), a = _L({
    onNotificationsClick: () => console.warn("notif click")
  }), i = W1(() => {
    e != null && e.user_id && J.copyTextToClipboard(e.user_id.toString(), () => {
      P2.sendMessage({
        status: "success",
        message: n(M0.copied)
      });
    });
  }, [e]), l = (s) => s.id === "notifications" ? /* @__PURE__ */ f.jsx(zx, {}) : s.id === "favorites" ? /* @__PURE__ */ f.jsx(bL, {}) : /* @__PURE__ */ f.jsx(Ls, { item: s, transparent: !0 }, s.id);
  return t ? /* @__PURE__ */ f.jsxs("div", { className: Me.authBlock, children: [
    /* @__PURE__ */ f.jsxs("div", { className: Me.authHeader, children: [
      /* @__PURE__ */ f.jsx("div", { className: Me.avatar, children: /* @__PURE__ */ f.jsx("img", { src: t.avatar, alt: J.htmlUnescape(t.nick) }) }),
      /* @__PURE__ */ f.jsx("div", { className: Me.nick, children: J.htmlUnescape(t.nick) }),
      /* @__PURE__ */ f.jsxs("button", { type: "button", className: Me.copy, onClick: i, children: [
        "ID:",
        " ",
        e == null ? void 0 : e.user_id,
        " ",
        /* @__PURE__ */ f.jsx(b1, { name: "copy-outline" })
      ] })
    ] }),
    /* @__PURE__ */ f.jsx("div", { className: Me.profileActions, children: a.map(l) })
  ] }) : /* @__PURE__ */ f.jsx("div", { className: Me.noAuthBlock, children: /* @__PURE__ */ f.jsxs("div", { className: Me.noAuthContent, children: [
    /* @__PURE__ */ f.jsx("div", { className: Me.noAuthTitle, children: n(M0.noAuth) }),
    /* @__PURE__ */ f.jsx(q1, { component: "a", href: r, mode: "primary", size: "md", appearance: "overlay", children: n(M0.loginToAccount) })
  ] }) });
}, LL = ({
  onClose: e
}) => {
  const t = V1(null), {
    formatMessage: n
  } = N1(), {
    onSidenavClick: r
  } = D1(rt), a = Xe(() => Pb({
    onSteamRefillClick: (i) => {
      i && r && (r(i, "payment_steam"), e());
    }
  }), [r]);
  return xs(t, e), /* @__PURE__ */ f.jsxs(ia, { className: Me.mobOverlay, children: [
    /* @__PURE__ */ f.jsx("div", { className: Me.title, children: n(M0.title) }),
    /* @__PURE__ */ f.jsx("div", { className: Me.menuList, children: a.map((i) => /* @__PURE__ */ f.jsx(Ls, { item: i }, i.id)) }),
    /* @__PURE__ */ f.jsx(xL, {}),
    /* @__PURE__ */ f.jsx("div", { className: Me.langSelector, children: /* @__PURE__ */ f.jsx(bs, { isMobile: !0, transparent: !0 }) })
  ] });
}, EL = "_root_1vn5q_1", ML = "_top_1vn5q_9", kL = "_title_1vn5q_20", SL = "_clear_1vn5q_34", AL = "_content_1vn5q_38", TL = "_button_1vn5q_44", IL = "_buttonText_1vn5q_72", RL = "_buttonIcon_1vn5q_78", NL = "_tooltip_1vn5q_91", h2 = {
  root: EL,
  top: ML,
  title: kL,
  clear: SL,
  content: AL,
  button: TL,
  buttonText: IL,
  buttonIcon: RL,
  tooltip: NL
};
var fr = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    return this.listeners.add(e), this.onSubscribe(), () => {
      this.listeners.delete(e), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, yn = typeof window == "undefined" || "Deno" in globalThis;
function Mt() {
}
function HL(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ii(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function Fs(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function Dn(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Pt(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function X3(e, t) {
  const {
    type: n = "all",
    exact: r,
    fetchStatus: a,
    predicate: i,
    queryKey: l,
    stale: s
  } = e;
  if (l) {
    if (r) {
      if (t.queryHash !== Lo(l, t.options))
        return !1;
    } else if (!Or(t.queryKey, l))
      return !1;
  }
  if (n !== "all") {
    const c = t.isActive();
    if (n === "active" && !c || n === "inactive" && c)
      return !1;
  }
  return !(typeof s == "boolean" && t.isStale() !== s || a && a !== t.state.fetchStatus || i && !i(t));
}
function J3(e, t) {
  const { exact: n, status: r, predicate: a, mutationKey: i } = e;
  if (i) {
    if (!t.options.mutationKey)
      return !1;
    if (n) {
      if (bn(t.options.mutationKey) !== bn(i))
        return !1;
    } else if (!Or(t.options.mutationKey, i))
      return !1;
  }
  return !(r && t.state.status !== r || a && !a(t));
}
function Lo(e, t) {
  return ((t == null ? void 0 : t.queryKeyHashFn) || bn)(e);
}
function bn(e) {
  return JSON.stringify(
    e,
    (t, n) => Ni(n) ? Object.keys(n).sort().reduce((r, a) => (r[a] = n[a], r), {}) : n
  );
}
function Or(e, t) {
  return e === t ? !0 : typeof e != typeof t ? !1 : e && t && typeof e == "object" && typeof t == "object" ? Object.keys(t).every((n) => Or(e[n], t[n])) : !1;
}
function Ri(e, t) {
  if (e === t)
    return e;
  const n = e5(e) && e5(t);
  if (n || Ni(e) && Ni(t)) {
    const r = n ? e : Object.keys(e), a = r.length, i = n ? t : Object.keys(t), l = i.length, s = n ? [] : {};
    let c = 0;
    for (let p = 0; p < l; p++) {
      const h = n ? p : i[p];
      (!n && r.includes(h) || n) && e[h] === void 0 && t[h] === void 0 ? (s[h] = void 0, c++) : (s[h] = Ri(e[h], t[h]), s[h] === e[h] && e[h] !== void 0 && c++);
    }
    return a === l && c === a ? e : s;
  }
  return t;
}
function j0(e, t) {
  if (!t || Object.keys(e).length !== Object.keys(t).length)
    return !1;
  for (const n in e)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function e5(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function Ni(e) {
  if (!t5(e))
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const n = t.prototype;
  return !(!t5(n) || !n.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(e) !== Object.prototype);
}
function t5(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function OL(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
function Hi(e, t, n) {
  if (typeof n.structuralSharing == "function")
    return n.structuralSharing(e, t);
  if (n.structuralSharing !== !1) {
    if (process.env.NODE_ENV !== "production")
      try {
        return Ri(e, t);
      } catch (r) {
        throw console.error(
          `Structural sharing requires data to be JSON serializable. To fix this, turn off structuralSharing or return JSON-serializable data from your queryFn. [${n.queryHash}]: ${r}`
        ), r;
      }
    return Ri(e, t);
  }
  return t;
}
function jL(e, t, n = 0) {
  const r = [...e, t];
  return n && r.length > n ? r.slice(1) : r;
}
function PL(e, t, n = 0) {
  const r = [t, ...e];
  return n && r.length > n ? r.slice(0, -1) : r;
}
var P0 = Symbol();
function Zs(e, t) {
  return process.env.NODE_ENV !== "production" && e.queryFn === P0 && console.error(
    `Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${e.queryHash}'`
  ), !e.queryFn && (t != null && t.initialPromise) ? () => t.initialPromise : !e.queryFn || e.queryFn === P0 ? () => Promise.reject(new Error(`Missing queryFn: '${e.queryHash}'`)) : e.queryFn;
}
var rn, k2, Bn, G5, DL = (G5 = class extends fr {
  constructor() {
    super();
    j1(this, rn);
    j1(this, k2);
    j1(this, Bn);
    _1(this, Bn, (t) => {
      if (!yn && window.addEventListener) {
        const n = () => t();
        return window.addEventListener("visibilitychange", n, !1), () => {
          window.removeEventListener("visibilitychange", n);
        };
      }
    });
  }
  onSubscribe() {
    B(this, k2) || this.setEventListener(B(this, Bn));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = B(this, k2)) == null || t.call(this), _1(this, k2, void 0));
  }
  setEventListener(t) {
    var n;
    _1(this, Bn, t), (n = B(this, k2)) == null || n.call(this), _1(this, k2, t((r) => {
      typeof r == "boolean" ? this.setFocused(r) : this.onFocus();
    }));
  }
  setFocused(t) {
    B(this, rn) !== t && (_1(this, rn, t), this.onFocus());
  }
  onFocus() {
    const t = this.isFocused();
    this.listeners.forEach((n) => {
      n(t);
    });
  }
  isFocused() {
    var t;
    return typeof B(this, rn) == "boolean" ? B(this, rn) : ((t = globalThis.document) == null ? void 0 : t.visibilityState) !== "hidden";
  }
}, rn = new WeakMap(), k2 = new WeakMap(), Bn = new WeakMap(), G5), Eo = new DL(), Fn, S2, Zn, W5, VL = (W5 = class extends fr {
  constructor() {
    super();
    j1(this, Fn, !0);
    j1(this, S2);
    j1(this, Zn);
    _1(this, Zn, (t) => {
      if (!yn && window.addEventListener) {
        const n = () => t(!0), r = () => t(!1);
        return window.addEventListener("online", n, !1), window.addEventListener("offline", r, !1), () => {
          window.removeEventListener("online", n), window.removeEventListener("offline", r);
        };
      }
    });
  }
  onSubscribe() {
    B(this, S2) || this.setEventListener(B(this, Zn));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = B(this, S2)) == null || t.call(this), _1(this, S2, void 0));
  }
  setEventListener(t) {
    var n;
    _1(this, Zn, t), (n = B(this, S2)) == null || n.call(this), _1(this, S2, t(this.setOnline.bind(this)));
  }
  setOnline(t) {
    B(this, Fn) !== t && (_1(this, Fn, t), this.listeners.forEach((r) => {
      r(t);
    }));
  }
  isOnline() {
    return B(this, Fn);
  }
}, Fn = new WeakMap(), S2 = new WeakMap(), Zn = new WeakMap(), W5), D0 = new VL();
function Oi() {
  let e, t;
  const n = new Promise((a, i) => {
    e = a, t = i;
  });
  n.status = "pending", n.catch(() => {
  });
  function r(a) {
    Object.assign(n, a), delete n.resolve, delete n.reject;
  }
  return n.resolve = (a) => {
    r({
      status: "fulfilled",
      value: a
    }), e(a);
  }, n.reject = (a) => {
    r({
      status: "rejected",
      reason: a
    }), t(a);
  }, n;
}
function BL(e) {
  return Math.min(1e3 * 2 ** e, 3e4);
}
function Gs(e) {
  return (e != null ? e : "online") === "online" ? D0.isOnline() : !0;
}
var Ws = class extends Error {
  constructor(e) {
    super("CancelledError"), this.revert = e == null ? void 0 : e.revert, this.silent = e == null ? void 0 : e.silent;
  }
};
function Ra(e) {
  return e instanceof Ws;
}
function Us(e) {
  let t = !1, n = 0, r = !1, a;
  const i = Oi(), l = (x) => {
    var k;
    r || (m(new Ws(x)), (k = e.abort) == null || k.call(e));
  }, s = () => {
    t = !0;
  }, c = () => {
    t = !1;
  }, p = () => Eo.isFocused() && (e.networkMode === "always" || D0.isOnline()) && e.canRun(), h = () => Gs(e.networkMode) && e.canRun(), u = (x) => {
    var k;
    r || (r = !0, (k = e.onSuccess) == null || k.call(e, x), a == null || a(), i.resolve(x));
  }, m = (x) => {
    var k;
    r || (r = !0, (k = e.onError) == null || k.call(e, x), a == null || a(), i.reject(x));
  }, d = () => new Promise((x) => {
    var k;
    a = (I) => {
      (r || p()) && x(I);
    }, (k = e.onPause) == null || k.call(e);
  }).then(() => {
    var x;
    a = void 0, r || (x = e.onContinue) == null || x.call(e);
  }), v = () => {
    if (r)
      return;
    let x;
    const k = n === 0 ? e.initialPromise : void 0;
    try {
      x = k != null ? k : e.fn();
    } catch (I) {
      x = Promise.reject(I);
    }
    Promise.resolve(x).then(u).catch((I) => {
      var j, g, w;
      if (r)
        return;
      const T = (j = e.retry) != null ? j : yn ? 0 : 3, L = (g = e.retryDelay) != null ? g : BL, S = typeof L == "function" ? L(n, I) : L, E = T === !0 || typeof T == "number" && n < T || typeof T == "function" && T(n, I);
      if (t || !E) {
        m(I);
        return;
      }
      n++, (w = e.onFail) == null || w.call(e, n, I), OL(S).then(() => p() ? void 0 : d()).then(() => {
        t ? m(I) : v();
      });
    });
  };
  return {
    promise: i,
    cancel: l,
    continue: () => (a == null || a(), i),
    cancelRetry: s,
    continueRetry: c,
    canStart: h,
    start: () => (h() ? v() : d().then(v), i)
  };
}
var FL = (e) => setTimeout(e, 0);
function ZL() {
  let e = [], t = 0, n = (s) => {
    s();
  }, r = (s) => {
    s();
  }, a = FL;
  const i = (s) => {
    t ? e.push(s) : a(() => {
      n(s);
    });
  }, l = () => {
    const s = e;
    e = [], s.length && a(() => {
      r(() => {
        s.forEach((c) => {
          n(c);
        });
      });
    });
  };
  return {
    batch: (s) => {
      let c;
      t++;
      try {
        c = s();
      } finally {
        t--, t || l();
      }
      return c;
    },
    /**
     * All calls to the wrapped function will be batched.
     */
    batchCalls: (s) => (...c) => {
      i(() => {
        s(...c);
      });
    },
    schedule: i,
    /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */
    setNotifyFunction: (s) => {
      n = s;
    },
    /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */
    setBatchNotifyFunction: (s) => {
      r = s;
    },
    setScheduler: (s) => {
      a = s;
    }
  };
}
var $e = ZL(), an, U5, zs = (U5 = class {
  constructor() {
    j1(this, an);
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), Ii(this.gcTime) && _1(this, an, setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(e) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      e != null ? e : yn ? 1 / 0 : 5 * 60 * 1e3
    );
  }
  clearGcTimeout() {
    B(this, an) && (clearTimeout(B(this, an)), _1(this, an, void 0));
  }
}, an = new WeakMap(), U5), Gn, Wn, Et, on, et, Pr, sn, Ot, m2, z5, GL = (z5 = class extends zs {
  constructor(t) {
    var n;
    super();
    j1(this, Ot);
    j1(this, Gn);
    j1(this, Wn);
    j1(this, Et);
    j1(this, on);
    j1(this, et);
    j1(this, Pr);
    j1(this, sn);
    _1(this, sn, !1), _1(this, Pr, t.defaultOptions), this.setOptions(t.options), this.observers = [], _1(this, on, t.client), _1(this, Et, B(this, on).getQueryCache()), this.queryKey = t.queryKey, this.queryHash = t.queryHash, _1(this, Gn, WL(this.options)), this.state = (n = t.state) != null ? n : B(this, Gn), this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get promise() {
    var t;
    return (t = B(this, et)) == null ? void 0 : t.promise;
  }
  setOptions(t) {
    this.options = { ...B(this, Pr), ...t }, this.updateGcTime(this.options.gcTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && B(this, Et).remove(this);
  }
  setData(t, n) {
    const r = Hi(this.state.data, t, this.options);
    return $1(this, Ot, m2).call(this, {
      data: r,
      type: "success",
      dataUpdatedAt: n == null ? void 0 : n.updatedAt,
      manual: n == null ? void 0 : n.manual
    }), r;
  }
  setState(t, n) {
    $1(this, Ot, m2).call(this, { type: "setState", state: t, setStateOptions: n });
  }
  cancel(t) {
    var r, a;
    const n = (r = B(this, et)) == null ? void 0 : r.promise;
    return (a = B(this, et)) == null || a.cancel(t), n ? n.then(Mt).catch(Mt) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(B(this, Gn));
  }
  isActive() {
    return this.observers.some(
      (t) => Pt(t.options.enabled, this) !== !1
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 ? !this.isActive() : this.options.queryFn === P0 || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
  }
  isStale() {
    return this.state.isInvalidated ? !0 : this.getObserversCount() > 0 ? this.observers.some(
      (t) => t.getCurrentResult().isStale
    ) : this.state.data === void 0;
  }
  isStaleByTime(t = 0) {
    return this.state.isInvalidated || this.state.data === void 0 || !Fs(this.state.dataUpdatedAt, t);
  }
  onFocus() {
    var n;
    const t = this.observers.find((r) => r.shouldFetchOnWindowFocus());
    t == null || t.refetch({ cancelRefetch: !1 }), (n = B(this, et)) == null || n.continue();
  }
  onOnline() {
    var n;
    const t = this.observers.find((r) => r.shouldFetchOnReconnect());
    t == null || t.refetch({ cancelRefetch: !1 }), (n = B(this, et)) == null || n.continue();
  }
  addObserver(t) {
    this.observers.includes(t) || (this.observers.push(t), this.clearGcTimeout(), B(this, Et).notify({ type: "observerAdded", query: this, observer: t }));
  }
  removeObserver(t) {
    this.observers.includes(t) && (this.observers = this.observers.filter((n) => n !== t), this.observers.length || (B(this, et) && (B(this, sn) ? B(this, et).cancel({ revert: !0 }) : B(this, et).cancelRetry()), this.scheduleGc()), B(this, Et).notify({ type: "observerRemoved", query: this, observer: t }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || $1(this, Ot, m2).call(this, { type: "invalidate" });
  }
  fetch(t, n) {
    var c, p, h;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.data !== void 0 && (n != null && n.cancelRefetch))
        this.cancel({ silent: !0 });
      else if (B(this, et))
        return B(this, et).continueRetry(), B(this, et).promise;
    }
    if (t && this.setOptions(t), !this.options.queryFn) {
      const u = this.observers.find((m) => m.options.queryFn);
      u && this.setOptions(u.options);
    }
    process.env.NODE_ENV !== "production" && (Array.isArray(this.options.queryKey) || console.error(
      "As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"
    ));
    const r = new AbortController(), a = (u) => {
      Object.defineProperty(u, "signal", {
        enumerable: !0,
        get: () => (_1(this, sn, !0), r.signal)
      });
    }, i = () => {
      const u = Zs(this.options, n), m = {
        client: B(this, on),
        queryKey: this.queryKey,
        meta: this.meta
      };
      return a(m), _1(this, sn, !1), this.options.persister ? this.options.persister(
        u,
        m,
        this
      ) : u(m);
    }, l = {
      fetchOptions: n,
      options: this.options,
      queryKey: this.queryKey,
      client: B(this, on),
      state: this.state,
      fetchFn: i
    };
    a(l), (c = this.options.behavior) == null || c.onFetch(
      l,
      this
    ), _1(this, Wn, this.state), (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((p = l.fetchOptions) == null ? void 0 : p.meta)) && $1(this, Ot, m2).call(this, { type: "fetch", meta: (h = l.fetchOptions) == null ? void 0 : h.meta });
    const s = (u) => {
      var m, d, v, x;
      Ra(u) && u.silent || $1(this, Ot, m2).call(this, {
        type: "error",
        error: u
      }), Ra(u) || ((d = (m = B(this, Et).config).onError) == null || d.call(
        m,
        u,
        this
      ), (x = (v = B(this, Et).config).onSettled) == null || x.call(
        v,
        this.state.data,
        u,
        this
      )), this.scheduleGc();
    };
    return _1(this, et, Us({
      initialPromise: n == null ? void 0 : n.initialPromise,
      fn: l.fetchFn,
      abort: r.abort.bind(r),
      onSuccess: (u) => {
        var m, d, v, x;
        if (u === void 0) {
          process.env.NODE_ENV !== "production" && console.error(
            `Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`
          ), s(new Error(`${this.queryHash} data is undefined`));
          return;
        }
        try {
          this.setData(u);
        } catch (k) {
          s(k);
          return;
        }
        (d = (m = B(this, Et).config).onSuccess) == null || d.call(m, u, this), (x = (v = B(this, Et).config).onSettled) == null || x.call(
          v,
          u,
          this.state.error,
          this
        ), this.scheduleGc();
      },
      onError: s,
      onFail: (u, m) => {
        $1(this, Ot, m2).call(this, { type: "failed", failureCount: u, error: m });
      },
      onPause: () => {
        $1(this, Ot, m2).call(this, { type: "pause" });
      },
      onContinue: () => {
        $1(this, Ot, m2).call(this, { type: "continue" });
      },
      retry: l.options.retry,
      retryDelay: l.options.retryDelay,
      networkMode: l.options.networkMode,
      canRun: () => !0
    })), B(this, et).start();
  }
}, Gn = new WeakMap(), Wn = new WeakMap(), Et = new WeakMap(), on = new WeakMap(), et = new WeakMap(), Pr = new WeakMap(), sn = new WeakMap(), Ot = new WeakSet(), m2 = function(t) {
  const n = (r) => {
    var a, i;
    switch (t.type) {
      case "failed":
        return {
          ...r,
          fetchFailureCount: t.failureCount,
          fetchFailureReason: t.error
        };
      case "pause":
        return {
          ...r,
          fetchStatus: "paused"
        };
      case "continue":
        return {
          ...r,
          fetchStatus: "fetching"
        };
      case "fetch":
        return {
          ...r,
          ...qs(r.data, this.options),
          fetchMeta: (a = t.meta) != null ? a : null
        };
      case "success":
        return {
          ...r,
          data: t.data,
          dataUpdateCount: r.dataUpdateCount + 1,
          dataUpdatedAt: (i = t.dataUpdatedAt) != null ? i : Date.now(),
          error: null,
          isInvalidated: !1,
          status: "success",
          ...!t.manual && {
            fetchStatus: "idle",
            fetchFailureCount: 0,
            fetchFailureReason: null
          }
        };
      case "error":
        const l = t.error;
        return Ra(l) && l.revert && B(this, Wn) ? { ...B(this, Wn), fetchStatus: "idle" } : {
          ...r,
          error: l,
          errorUpdateCount: r.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: r.fetchFailureCount + 1,
          fetchFailureReason: l,
          fetchStatus: "idle",
          status: "error"
        };
      case "invalidate":
        return {
          ...r,
          isInvalidated: !0
        };
      case "setState":
        return {
          ...r,
          ...t.state
        };
    }
  };
  this.state = n(this.state), $e.batch(() => {
    this.observers.forEach((r) => {
      r.onQueryUpdate();
    }), B(this, Et).notify({ query: this, type: "updated", action: t });
  });
}, z5);
function qs(e, t) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: Gs(t.networkMode) ? "fetching" : "paused",
    ...e === void 0 && {
      error: null,
      status: "pending"
    }
  };
}
function WL(e) {
  const t = typeof e.initialData == "function" ? e.initialData() : e.initialData, n = t !== void 0, r = n ? typeof e.initialDataUpdatedAt == "function" ? e.initialDataUpdatedAt() : e.initialDataUpdatedAt : 0;
  return {
    data: t,
    dataUpdateCount: 0,
    dataUpdatedAt: n ? r != null ? r : Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: n ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var Qt, q5, UL = (q5 = class extends fr {
  constructor(t = {}) {
    super();
    j1(this, Qt);
    this.config = t, _1(this, Qt, /* @__PURE__ */ new Map());
  }
  build(t, n, r) {
    var s;
    const a = n.queryKey, i = (s = n.queryHash) != null ? s : Lo(a, n);
    let l = this.get(i);
    return l || (l = new GL({
      client: t,
      queryKey: a,
      queryHash: i,
      options: t.defaultQueryOptions(n),
      state: r,
      defaultOptions: t.getQueryDefaults(a)
    }), this.add(l)), l;
  }
  add(t) {
    B(this, Qt).has(t.queryHash) || (B(this, Qt).set(t.queryHash, t), this.notify({
      type: "added",
      query: t
    }));
  }
  remove(t) {
    const n = B(this, Qt).get(t.queryHash);
    n && (t.destroy(), n === t && B(this, Qt).delete(t.queryHash), this.notify({ type: "removed", query: t }));
  }
  clear() {
    $e.batch(() => {
      this.getAll().forEach((t) => {
        this.remove(t);
      });
    });
  }
  get(t) {
    return B(this, Qt).get(t);
  }
  getAll() {
    return [...B(this, Qt).values()];
  }
  find(t) {
    const n = { exact: !0, ...t };
    return this.getAll().find(
      (r) => X3(n, r)
    );
  }
  findAll(t = {}) {
    const n = this.getAll();
    return Object.keys(t).length > 0 ? n.filter((r) => X3(t, r)) : n;
  }
  notify(t) {
    $e.batch(() => {
      this.listeners.forEach((n) => {
        n(t);
      });
    });
  }
  onFocus() {
    $e.batch(() => {
      this.getAll().forEach((t) => {
        t.onFocus();
      });
    });
  }
  onOnline() {
    $e.batch(() => {
      this.getAll().forEach((t) => {
        t.onOnline();
      });
    });
  }
}, Qt = new WeakMap(), q5), Xt, st, ln, Jt, E2, $5, zL = ($5 = class extends zs {
  constructor(t) {
    super();
    j1(this, Jt);
    j1(this, Xt);
    j1(this, st);
    j1(this, ln);
    this.mutationId = t.mutationId, _1(this, st, t.mutationCache), _1(this, Xt, []), this.state = t.state || $s(), this.setOptions(t.options), this.scheduleGc();
  }
  setOptions(t) {
    this.options = t, this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(t) {
    B(this, Xt).includes(t) || (B(this, Xt).push(t), this.clearGcTimeout(), B(this, st).notify({
      type: "observerAdded",
      mutation: this,
      observer: t
    }));
  }
  removeObserver(t) {
    _1(this, Xt, B(this, Xt).filter((n) => n !== t)), this.scheduleGc(), B(this, st).notify({
      type: "observerRemoved",
      mutation: this,
      observer: t
    });
  }
  optionalRemove() {
    B(this, Xt).length || (this.state.status === "pending" ? this.scheduleGc() : B(this, st).remove(this));
  }
  continue() {
    var t, n;
    return (n = (t = B(this, ln)) == null ? void 0 : t.continue()) != null ? n : (
      // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
      this.execute(this.state.variables)
    );
  }
  async execute(t) {
    var i, l, s, c, p, h, u, m, d, v, x, k, I, T, L, S, E, j, g, w, C;
    const n = () => {
      $1(this, Jt, E2).call(this, { type: "continue" });
    };
    _1(this, ln, Us({
      fn: () => this.options.mutationFn ? this.options.mutationFn(t) : Promise.reject(new Error("No mutationFn found")),
      onFail: (b, M) => {
        $1(this, Jt, E2).call(this, { type: "failed", failureCount: b, error: M });
      },
      onPause: () => {
        $1(this, Jt, E2).call(this, { type: "pause" });
      },
      onContinue: n,
      retry: (i = this.options.retry) != null ? i : 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode,
      canRun: () => B(this, st).canRun(this)
    }));
    const r = this.state.status === "pending", a = !B(this, ln).canStart();
    try {
      if (r)
        n();
      else {
        $1(this, Jt, E2).call(this, { type: "pending", variables: t, isPaused: a }), await ((s = (l = B(this, st).config).onMutate) == null ? void 0 : s.call(
          l,
          t,
          this
        ));
        const M = await ((p = (c = this.options).onMutate) == null ? void 0 : p.call(c, t));
        M !== this.state.context && $1(this, Jt, E2).call(this, {
          type: "pending",
          context: M,
          variables: t,
          isPaused: a
        });
      }
      const b = await B(this, ln).start();
      return await ((u = (h = B(this, st).config).onSuccess) == null ? void 0 : u.call(
        h,
        b,
        t,
        this.state.context,
        this
      )), await ((d = (m = this.options).onSuccess) == null ? void 0 : d.call(m, b, t, this.state.context)), await ((x = (v = B(this, st).config).onSettled) == null ? void 0 : x.call(
        v,
        b,
        null,
        this.state.variables,
        this.state.context,
        this
      )), await ((I = (k = this.options).onSettled) == null ? void 0 : I.call(k, b, null, t, this.state.context)), $1(this, Jt, E2).call(this, { type: "success", data: b }), b;
    } catch (b) {
      try {
        throw await ((L = (T = B(this, st).config).onError) == null ? void 0 : L.call(
          T,
          b,
          t,
          this.state.context,
          this
        )), await ((E = (S = this.options).onError) == null ? void 0 : E.call(
          S,
          b,
          t,
          this.state.context
        )), await ((g = (j = B(this, st).config).onSettled) == null ? void 0 : g.call(
          j,
          void 0,
          b,
          this.state.variables,
          this.state.context,
          this
        )), await ((C = (w = this.options).onSettled) == null ? void 0 : C.call(
          w,
          void 0,
          b,
          t,
          this.state.context
        )), b;
      } finally {
        $1(this, Jt, E2).call(this, { type: "error", error: b });
      }
    } finally {
      B(this, st).runNext(this);
    }
  }
}, Xt = new WeakMap(), st = new WeakMap(), ln = new WeakMap(), Jt = new WeakSet(), E2 = function(t) {
  const n = (r) => {
    switch (t.type) {
      case "failed":
        return {
          ...r,
          failureCount: t.failureCount,
          failureReason: t.error
        };
      case "pause":
        return {
          ...r,
          isPaused: !0
        };
      case "continue":
        return {
          ...r,
          isPaused: !1
        };
      case "pending":
        return {
          ...r,
          context: t.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: t.isPaused,
          status: "pending",
          variables: t.variables,
          submittedAt: Date.now()
        };
      case "success":
        return {
          ...r,
          data: t.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: !1
        };
      case "error":
        return {
          ...r,
          data: void 0,
          error: t.error,
          failureCount: r.failureCount + 1,
          failureReason: t.error,
          isPaused: !1,
          status: "error"
        };
    }
  };
  this.state = n(this.state), $e.batch(() => {
    B(this, Xt).forEach((r) => {
      r.onMutationUpdate(t);
    }), B(this, st).notify({
      mutation: this,
      type: "updated",
      action: t
    });
  });
}, $5);
function $s() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var C2, jt, Dr, Y5, qL = (Y5 = class extends fr {
  constructor(t = {}) {
    super();
    j1(this, C2);
    j1(this, jt);
    j1(this, Dr);
    this.config = t, _1(this, C2, /* @__PURE__ */ new Set()), _1(this, jt, /* @__PURE__ */ new Map()), _1(this, Dr, 0);
  }
  build(t, n, r) {
    const a = new zL({
      mutationCache: this,
      mutationId: ++Jr(this, Dr)._,
      options: t.defaultMutationOptions(n),
      state: r
    });
    return this.add(a), a;
  }
  add(t) {
    B(this, C2).add(t);
    const n = d0(t);
    if (typeof n == "string") {
      const r = B(this, jt).get(n);
      r ? r.push(t) : B(this, jt).set(n, [t]);
    }
    this.notify({ type: "added", mutation: t });
  }
  remove(t) {
    if (B(this, C2).delete(t)) {
      const n = d0(t);
      if (typeof n == "string") {
        const r = B(this, jt).get(n);
        if (r)
          if (r.length > 1) {
            const a = r.indexOf(t);
            a !== -1 && r.splice(a, 1);
          } else r[0] === t && B(this, jt).delete(n);
      }
    }
    this.notify({ type: "removed", mutation: t });
  }
  canRun(t) {
    const n = d0(t);
    if (typeof n == "string") {
      const r = B(this, jt).get(n), a = r == null ? void 0 : r.find(
        (i) => i.state.status === "pending"
      );
      return !a || a === t;
    } else
      return !0;
  }
  runNext(t) {
    var r, a;
    const n = d0(t);
    if (typeof n == "string") {
      const i = (r = B(this, jt).get(n)) == null ? void 0 : r.find((l) => l !== t && l.state.isPaused);
      return (a = i == null ? void 0 : i.continue()) != null ? a : Promise.resolve();
    } else
      return Promise.resolve();
  }
  clear() {
    $e.batch(() => {
      B(this, C2).forEach((t) => {
        this.notify({ type: "removed", mutation: t });
      }), B(this, C2).clear(), B(this, jt).clear();
    });
  }
  getAll() {
    return Array.from(B(this, C2));
  }
  find(t) {
    const n = { exact: !0, ...t };
    return this.getAll().find(
      (r) => J3(n, r)
    );
  }
  findAll(t = {}) {
    return this.getAll().filter((n) => J3(t, n));
  }
  notify(t) {
    $e.batch(() => {
      this.listeners.forEach((n) => {
        n(t);
      });
    });
  }
  resumePausedMutations() {
    const t = this.getAll().filter((n) => n.state.isPaused);
    return $e.batch(
      () => Promise.all(
        t.map((n) => n.continue().catch(Mt))
      )
    );
  }
}, C2 = new WeakMap(), jt = new WeakMap(), Dr = new WeakMap(), Y5);
function d0(e) {
  var t;
  return (t = e.options.scope) == null ? void 0 : t.id;
}
function V0(e) {
  return {
    onFetch: (t, n) => {
      var h, u, m, d, v;
      const r = t.options, a = (m = (u = (h = t.fetchOptions) == null ? void 0 : h.meta) == null ? void 0 : u.fetchMore) == null ? void 0 : m.direction, i = ((d = t.state.data) == null ? void 0 : d.pages) || [], l = ((v = t.state.data) == null ? void 0 : v.pageParams) || [];
      let s = { pages: [], pageParams: [] }, c = 0;
      const p = async () => {
        var L;
        let x = !1;
        const k = (S) => {
          Object.defineProperty(S, "signal", {
            enumerable: !0,
            get: () => (t.signal.aborted ? x = !0 : t.signal.addEventListener("abort", () => {
              x = !0;
            }), t.signal)
          });
        }, I = Zs(t.options, t.fetchOptions), T = async (S, E, j) => {
          if (x)
            return Promise.reject();
          if (E == null && S.pages.length)
            return Promise.resolve(S);
          const g = {
            client: t.client,
            queryKey: t.queryKey,
            pageParam: E,
            direction: j ? "backward" : "forward",
            meta: t.options.meta
          };
          k(g);
          const w = await I(
            g
          ), { maxPages: C } = t.options, b = j ? PL : jL;
          return {
            pages: b(S.pages, w, C),
            pageParams: b(S.pageParams, E, C)
          };
        };
        if (a && i.length) {
          const S = a === "backward", E = S ? Ys : ji, j = {
            pages: i,
            pageParams: l
          }, g = E(r, j);
          s = await T(j, g, S);
        } else {
          const S = e != null ? e : i.length;
          do {
            const E = c === 0 ? (L = l[0]) != null ? L : r.initialPageParam : ji(r, s);
            if (c > 0 && E == null)
              break;
            s = await T(s, E), c++;
          } while (c < S);
        }
        return s;
      };
      t.options.persister ? t.fetchFn = () => {
        var x, k;
        return (k = (x = t.options).persister) == null ? void 0 : k.call(
          x,
          p,
          {
            client: t.client,
            queryKey: t.queryKey,
            meta: t.options.meta,
            signal: t.signal
          },
          n
        );
      } : t.fetchFn = p;
    }
  };
}
function ji(e, { pages: t, pageParams: n }) {
  const r = t.length - 1;
  return t.length > 0 ? e.getNextPageParam(
    t[r],
    t,
    n[r],
    n
  ) : void 0;
}
function Ys(e, { pages: t, pageParams: n }) {
  var r;
  return t.length > 0 ? (r = e.getPreviousPageParam) == null ? void 0 : r.call(e, t[0], t, n[0], n) : void 0;
}
function $L(e, t) {
  return t ? ji(e, t) != null : !1;
}
function YL(e, t) {
  return !t || !e.getPreviousPageParam ? !1 : Ys(e, t) != null;
}
var Ve, A2, T2, Un, zn, I2, qn, $n, K5, KL = (K5 = class {
  constructor(e = {}) {
    j1(this, Ve);
    j1(this, A2);
    j1(this, T2);
    j1(this, Un);
    j1(this, zn);
    j1(this, I2);
    j1(this, qn);
    j1(this, $n);
    _1(this, Ve, e.queryCache || new UL()), _1(this, A2, e.mutationCache || new qL()), _1(this, T2, e.defaultOptions || {}), _1(this, Un, /* @__PURE__ */ new Map()), _1(this, zn, /* @__PURE__ */ new Map()), _1(this, I2, 0);
  }
  mount() {
    Jr(this, I2)._++, B(this, I2) === 1 && (_1(this, qn, Eo.subscribe(async (e) => {
      e && (await this.resumePausedMutations(), B(this, Ve).onFocus());
    })), _1(this, $n, D0.subscribe(async (e) => {
      e && (await this.resumePausedMutations(), B(this, Ve).onOnline());
    })));
  }
  unmount() {
    var e, t;
    Jr(this, I2)._--, B(this, I2) === 0 && ((e = B(this, qn)) == null || e.call(this), _1(this, qn, void 0), (t = B(this, $n)) == null || t.call(this), _1(this, $n, void 0));
  }
  isFetching(e) {
    return B(this, Ve).findAll({ ...e, fetchStatus: "fetching" }).length;
  }
  isMutating(e) {
    return B(this, A2).findAll({ ...e, status: "pending" }).length;
  }
  /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */
  getQueryData(e) {
    var n;
    const t = this.defaultQueryOptions({ queryKey: e });
    return (n = B(this, Ve).get(t.queryHash)) == null ? void 0 : n.state.data;
  }
  ensureQueryData(e) {
    const t = this.defaultQueryOptions(e), n = B(this, Ve).build(this, t), r = n.state.data;
    return r === void 0 ? this.fetchQuery(e) : (e.revalidateIfStale && n.isStaleByTime(Dn(t.staleTime, n)) && this.prefetchQuery(t), Promise.resolve(r));
  }
  getQueriesData(e) {
    return B(this, Ve).findAll(e).map(({ queryKey: t, state: n }) => {
      const r = n.data;
      return [t, r];
    });
  }
  setQueryData(e, t, n) {
    const r = this.defaultQueryOptions({ queryKey: e }), a = B(this, Ve).get(
      r.queryHash
    ), i = a == null ? void 0 : a.state.data, l = HL(t, i);
    if (l !== void 0)
      return B(this, Ve).build(this, r).setData(l, { ...n, manual: !0 });
  }
  setQueriesData(e, t, n) {
    return $e.batch(
      () => B(this, Ve).findAll(e).map(({ queryKey: r }) => [
        r,
        this.setQueryData(r, t, n)
      ])
    );
  }
  getQueryState(e) {
    var n;
    const t = this.defaultQueryOptions({ queryKey: e });
    return (n = B(this, Ve).get(
      t.queryHash
    )) == null ? void 0 : n.state;
  }
  removeQueries(e) {
    const t = B(this, Ve);
    $e.batch(() => {
      t.findAll(e).forEach((n) => {
        t.remove(n);
      });
    });
  }
  resetQueries(e, t) {
    const n = B(this, Ve);
    return $e.batch(() => (n.findAll(e).forEach((r) => {
      r.reset();
    }), this.refetchQueries(
      {
        type: "active",
        ...e
      },
      t
    )));
  }
  cancelQueries(e, t = {}) {
    const n = { revert: !0, ...t }, r = $e.batch(
      () => B(this, Ve).findAll(e).map((a) => a.cancel(n))
    );
    return Promise.all(r).then(Mt).catch(Mt);
  }
  invalidateQueries(e, t = {}) {
    return $e.batch(() => {
      var n, r;
      return B(this, Ve).findAll(e).forEach((a) => {
        a.invalidate();
      }), (e == null ? void 0 : e.refetchType) === "none" ? Promise.resolve() : this.refetchQueries(
        {
          ...e,
          type: (r = (n = e == null ? void 0 : e.refetchType) != null ? n : e == null ? void 0 : e.type) != null ? r : "active"
        },
        t
      );
    });
  }
  refetchQueries(e, t = {}) {
    var a;
    const n = {
      ...t,
      cancelRefetch: (a = t.cancelRefetch) != null ? a : !0
    }, r = $e.batch(
      () => B(this, Ve).findAll(e).filter((i) => !i.isDisabled()).map((i) => {
        let l = i.fetch(void 0, n);
        return n.throwOnError || (l = l.catch(Mt)), i.state.fetchStatus === "paused" ? Promise.resolve() : l;
      })
    );
    return Promise.all(r).then(Mt);
  }
  fetchQuery(e) {
    const t = this.defaultQueryOptions(e);
    t.retry === void 0 && (t.retry = !1);
    const n = B(this, Ve).build(this, t);
    return n.isStaleByTime(
      Dn(t.staleTime, n)
    ) ? n.fetch(t) : Promise.resolve(n.state.data);
  }
  prefetchQuery(e) {
    return this.fetchQuery(e).then(Mt).catch(Mt);
  }
  fetchInfiniteQuery(e) {
    return e.behavior = V0(e.pages), this.fetchQuery(e);
  }
  prefetchInfiniteQuery(e) {
    return this.fetchInfiniteQuery(e).then(Mt).catch(Mt);
  }
  ensureInfiniteQueryData(e) {
    return e.behavior = V0(e.pages), this.ensureQueryData(e);
  }
  resumePausedMutations() {
    return D0.isOnline() ? B(this, A2).resumePausedMutations() : Promise.resolve();
  }
  getQueryCache() {
    return B(this, Ve);
  }
  getMutationCache() {
    return B(this, A2);
  }
  getDefaultOptions() {
    return B(this, T2);
  }
  setDefaultOptions(e) {
    _1(this, T2, e);
  }
  setQueryDefaults(e, t) {
    B(this, Un).set(bn(e), {
      queryKey: e,
      defaultOptions: t
    });
  }
  getQueryDefaults(e) {
    const t = [...B(this, Un).values()], n = {};
    return t.forEach((r) => {
      Or(e, r.queryKey) && Object.assign(n, r.defaultOptions);
    }), n;
  }
  setMutationDefaults(e, t) {
    B(this, zn).set(bn(e), {
      mutationKey: e,
      defaultOptions: t
    });
  }
  getMutationDefaults(e) {
    const t = [...B(this, zn).values()], n = {};
    return t.forEach((r) => {
      Or(e, r.mutationKey) && Object.assign(n, r.defaultOptions);
    }), n;
  }
  defaultQueryOptions(e) {
    if (e._defaulted)
      return e;
    const t = {
      ...B(this, T2).queries,
      ...this.getQueryDefaults(e.queryKey),
      ...e,
      _defaulted: !0
    };
    return t.queryHash || (t.queryHash = Lo(
      t.queryKey,
      t
    )), t.refetchOnReconnect === void 0 && (t.refetchOnReconnect = t.networkMode !== "always"), t.throwOnError === void 0 && (t.throwOnError = !!t.suspense), !t.networkMode && t.persister && (t.networkMode = "offlineFirst"), t.queryFn === P0 && (t.enabled = !1), t;
  }
  defaultMutationOptions(e) {
    return e != null && e._defaulted ? e : {
      ...B(this, T2).mutations,
      ...(e == null ? void 0 : e.mutationKey) && this.getMutationDefaults(e.mutationKey),
      ...e,
      _defaulted: !0
    };
  }
  clear() {
    B(this, Ve).clear(), B(this, A2).clear();
  }
}, Ve = new WeakMap(), A2 = new WeakMap(), T2 = new WeakMap(), Un = new WeakMap(), zn = new WeakMap(), I2 = new WeakMap(), qn = new WeakMap(), $n = new WeakMap(), K5), ht, te, Vr, lt, cn, Yn, R2, N2, Br, Kn, Qn, un, dn, H2, Xn, pe, Sr, Pi, Di, Vi, Bi, Fi, Zi, Gi, Qs, Q5, Ks = (Q5 = class extends fr {
  constructor(t, n) {
    super();
    j1(this, pe);
    j1(this, ht);
    j1(this, te);
    j1(this, Vr);
    j1(this, lt);
    j1(this, cn);
    j1(this, Yn);
    j1(this, R2);
    j1(this, N2);
    j1(this, Br);
    j1(this, Kn);
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    j1(this, Qn);
    j1(this, un);
    j1(this, dn);
    j1(this, H2);
    j1(this, Xn, /* @__PURE__ */ new Set());
    this.options = n, _1(this, ht, t), _1(this, N2, null), _1(this, R2, Oi()), this.options.experimental_prefetchInRender || B(this, R2).reject(
      new Error("experimental_prefetchInRender feature flag is not enabled")
    ), this.bindMethods(), this.setOptions(n);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (B(this, te).addObserver(this), n5(B(this, te), this.options) ? $1(this, pe, Sr).call(this) : this.updateResult(), $1(this, pe, Bi).call(this));
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return Wi(
      B(this, te),
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return Wi(
      B(this, te),
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), $1(this, pe, Fi).call(this), $1(this, pe, Zi).call(this), B(this, te).removeObserver(this);
  }
  setOptions(t) {
    const n = this.options, r = B(this, te);
    if (this.options = B(this, ht).defaultQueryOptions(t), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean" && typeof this.options.enabled != "function" && typeof Pt(this.options.enabled, B(this, te)) != "boolean")
      throw new Error(
        "Expected enabled to be a boolean or a callback that returns a boolean"
      );
    $1(this, pe, Gi).call(this), B(this, te).setOptions(this.options), n._defaulted && !j0(this.options, n) && B(this, ht).getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: B(this, te),
      observer: this
    });
    const a = this.hasListeners();
    a && r5(
      B(this, te),
      r,
      this.options,
      n
    ) && $1(this, pe, Sr).call(this), this.updateResult(), a && (B(this, te) !== r || Pt(this.options.enabled, B(this, te)) !== Pt(n.enabled, B(this, te)) || Dn(this.options.staleTime, B(this, te)) !== Dn(n.staleTime, B(this, te))) && $1(this, pe, Pi).call(this);
    const i = $1(this, pe, Di).call(this);
    a && (B(this, te) !== r || Pt(this.options.enabled, B(this, te)) !== Pt(n.enabled, B(this, te)) || i !== B(this, H2)) && $1(this, pe, Vi).call(this, i);
  }
  getOptimisticResult(t) {
    const n = B(this, ht).getQueryCache().build(B(this, ht), t), r = this.createResult(n, t);
    return XL(this, r) && (_1(this, lt, r), _1(this, Yn, this.options), _1(this, cn, B(this, te).state)), r;
  }
  getCurrentResult() {
    return B(this, lt);
  }
  trackResult(t, n) {
    const r = {};
    return Object.keys(t).forEach((a) => {
      Object.defineProperty(r, a, {
        configurable: !1,
        enumerable: !0,
        get: () => (this.trackProp(a), n == null || n(a), t[a])
      });
    }), r;
  }
  trackProp(t) {
    B(this, Xn).add(t);
  }
  getCurrentQuery() {
    return B(this, te);
  }
  refetch({ ...t } = {}) {
    return this.fetch({
      ...t
    });
  }
  fetchOptimistic(t) {
    const n = B(this, ht).defaultQueryOptions(t), r = B(this, ht).getQueryCache().build(B(this, ht), n);
    return r.fetch().then(() => this.createResult(r, n));
  }
  fetch(t) {
    var n;
    return $1(this, pe, Sr).call(this, {
      ...t,
      cancelRefetch: (n = t.cancelRefetch) != null ? n : !0
    }).then(() => (this.updateResult(), B(this, lt)));
  }
  createResult(t, n) {
    var C;
    const r = B(this, te), a = this.options, i = B(this, lt), l = B(this, cn), s = B(this, Yn), p = t !== r ? t.state : B(this, Vr), { state: h } = t;
    let u = { ...h }, m = !1, d;
    if (n._optimisticResults) {
      const b = this.hasListeners(), M = !b && n5(t, n), R = b && r5(t, r, n, a);
      (M || R) && (u = {
        ...u,
        ...qs(h.data, t.options)
      }), n._optimisticResults === "isRestoring" && (u.fetchStatus = "idle");
    }
    let { error: v, errorUpdatedAt: x, status: k } = u;
    d = u.data;
    let I = !1;
    if (n.placeholderData !== void 0 && d === void 0 && k === "pending") {
      let b;
      i != null && i.isPlaceholderData && n.placeholderData === (s == null ? void 0 : s.placeholderData) ? (b = i.data, I = !0) : b = typeof n.placeholderData == "function" ? n.placeholderData(
        (C = B(this, Qn)) == null ? void 0 : C.state.data,
        B(this, Qn)
      ) : n.placeholderData, b !== void 0 && (k = "success", d = Hi(
        i == null ? void 0 : i.data,
        b,
        n
      ), m = !0);
    }
    if (n.select && d !== void 0 && !I)
      if (i && d === (l == null ? void 0 : l.data) && n.select === B(this, Br))
        d = B(this, Kn);
      else
        try {
          _1(this, Br, n.select), d = n.select(d), d = Hi(i == null ? void 0 : i.data, d, n), _1(this, Kn, d), _1(this, N2, null);
        } catch (b) {
          _1(this, N2, b);
        }
    B(this, N2) && (v = B(this, N2), d = B(this, Kn), x = Date.now(), k = "error");
    const T = u.fetchStatus === "fetching", L = k === "pending", S = k === "error", E = L && T, j = d !== void 0, w = {
      status: k,
      fetchStatus: u.fetchStatus,
      isPending: L,
      isSuccess: k === "success",
      isError: S,
      isInitialLoading: E,
      isLoading: E,
      data: d,
      dataUpdatedAt: u.dataUpdatedAt,
      error: v,
      errorUpdatedAt: x,
      failureCount: u.fetchFailureCount,
      failureReason: u.fetchFailureReason,
      errorUpdateCount: u.errorUpdateCount,
      isFetched: u.dataUpdateCount > 0 || u.errorUpdateCount > 0,
      isFetchedAfterMount: u.dataUpdateCount > p.dataUpdateCount || u.errorUpdateCount > p.errorUpdateCount,
      isFetching: T,
      isRefetching: T && !L,
      isLoadingError: S && !j,
      isPaused: u.fetchStatus === "paused",
      isPlaceholderData: m,
      isRefetchError: S && j,
      isStale: Mo(t, n),
      refetch: this.refetch,
      promise: B(this, R2)
    };
    if (this.options.experimental_prefetchInRender) {
      const b = (O) => {
        w.status === "error" ? O.reject(w.error) : w.data !== void 0 && O.resolve(w.data);
      }, M = () => {
        const O = _1(this, R2, w.promise = Oi());
        b(O);
      }, R = B(this, R2);
      switch (R.status) {
        case "pending":
          t.queryHash === r.queryHash && b(R);
          break;
        case "fulfilled":
          (w.status === "error" || w.data !== R.value) && M();
          break;
        case "rejected":
          (w.status !== "error" || w.error !== R.reason) && M();
          break;
      }
    }
    return w;
  }
  updateResult() {
    const t = B(this, lt), n = this.createResult(B(this, te), this.options);
    if (_1(this, cn, B(this, te).state), _1(this, Yn, this.options), B(this, cn).data !== void 0 && _1(this, Qn, B(this, te)), j0(n, t))
      return;
    _1(this, lt, n);
    const r = () => {
      if (!t)
        return !0;
      const { notifyOnChangeProps: a } = this.options, i = typeof a == "function" ? a() : a;
      if (i === "all" || !i && !B(this, Xn).size)
        return !0;
      const l = new Set(
        i != null ? i : B(this, Xn)
      );
      return this.options.throwOnError && l.add("error"), Object.keys(B(this, lt)).some((s) => {
        const c = s;
        return B(this, lt)[c] !== t[c] && l.has(c);
      });
    };
    $1(this, pe, Qs).call(this, { listeners: r() });
  }
  onQueryUpdate() {
    this.updateResult(), this.hasListeners() && $1(this, pe, Bi).call(this);
  }
}, ht = new WeakMap(), te = new WeakMap(), Vr = new WeakMap(), lt = new WeakMap(), cn = new WeakMap(), Yn = new WeakMap(), R2 = new WeakMap(), N2 = new WeakMap(), Br = new WeakMap(), Kn = new WeakMap(), Qn = new WeakMap(), un = new WeakMap(), dn = new WeakMap(), H2 = new WeakMap(), Xn = new WeakMap(), pe = new WeakSet(), Sr = function(t) {
  $1(this, pe, Gi).call(this);
  let n = B(this, te).fetch(
    this.options,
    t
  );
  return t != null && t.throwOnError || (n = n.catch(Mt)), n;
}, Pi = function() {
  $1(this, pe, Fi).call(this);
  const t = Dn(
    this.options.staleTime,
    B(this, te)
  );
  if (yn || B(this, lt).isStale || !Ii(t))
    return;
  const r = Fs(B(this, lt).dataUpdatedAt, t) + 1;
  _1(this, un, setTimeout(() => {
    B(this, lt).isStale || this.updateResult();
  }, r));
}, Di = function() {
  var t;
  return (t = typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(B(this, te)) : this.options.refetchInterval) != null ? t : !1;
}, Vi = function(t) {
  $1(this, pe, Zi).call(this), _1(this, H2, t), !(yn || Pt(this.options.enabled, B(this, te)) === !1 || !Ii(B(this, H2)) || B(this, H2) === 0) && _1(this, dn, setInterval(() => {
    (this.options.refetchIntervalInBackground || Eo.isFocused()) && $1(this, pe, Sr).call(this);
  }, B(this, H2)));
}, Bi = function() {
  $1(this, pe, Pi).call(this), $1(this, pe, Vi).call(this, $1(this, pe, Di).call(this));
}, Fi = function() {
  B(this, un) && (clearTimeout(B(this, un)), _1(this, un, void 0));
}, Zi = function() {
  B(this, dn) && (clearInterval(B(this, dn)), _1(this, dn, void 0));
}, Gi = function() {
  const t = B(this, ht).getQueryCache().build(B(this, ht), this.options);
  if (t === B(this, te))
    return;
  const n = B(this, te);
  _1(this, te, t), _1(this, Vr, t.state), this.hasListeners() && (n == null || n.removeObserver(this), t.addObserver(this));
}, Qs = function(t) {
  $e.batch(() => {
    t.listeners && this.listeners.forEach((n) => {
      n(B(this, lt));
    }), B(this, ht).getQueryCache().notify({
      query: B(this, te),
      type: "observerResultsUpdated"
    });
  });
}, Q5);
function QL(e, t) {
  return Pt(t.enabled, e) !== !1 && e.state.data === void 0 && !(e.state.status === "error" && t.retryOnMount === !1);
}
function n5(e, t) {
  return QL(e, t) || e.state.data !== void 0 && Wi(e, t, t.refetchOnMount);
}
function Wi(e, t, n) {
  if (Pt(t.enabled, e) !== !1) {
    const r = typeof n == "function" ? n(e) : n;
    return r === "always" || r !== !1 && Mo(e, t);
  }
  return !1;
}
function r5(e, t, n, r) {
  return (e !== t || Pt(r.enabled, e) === !1) && (!n.suspense || e.state.status !== "error") && Mo(e, n);
}
function Mo(e, t) {
  return Pt(t.enabled, e) !== !1 && e.isStaleByTime(Dn(t.staleTime, e));
}
function XL(e, t) {
  return !j0(e.getCurrentResult(), t);
}
var JL = class extends Ks {
  constructor(e, t) {
    super(e, t);
  }
  bindMethods() {
    super.bindMethods(), this.fetchNextPage = this.fetchNextPage.bind(this), this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  }
  setOptions(e) {
    super.setOptions({
      ...e,
      behavior: V0()
    });
  }
  getOptimisticResult(e) {
    return e.behavior = V0(), super.getOptimisticResult(e);
  }
  fetchNextPage(e) {
    return this.fetch({
      ...e,
      meta: {
        fetchMore: { direction: "forward" }
      }
    });
  }
  fetchPreviousPage(e) {
    return this.fetch({
      ...e,
      meta: {
        fetchMore: { direction: "backward" }
      }
    });
  }
  createResult(e, t) {
    var v, x;
    const { state: n } = e, r = super.createResult(e, t), { isFetching: a, isRefetching: i, isError: l, isRefetchError: s } = r, c = (x = (v = n.fetchMeta) == null ? void 0 : v.fetchMore) == null ? void 0 : x.direction, p = l && c === "forward", h = a && c === "forward", u = l && c === "backward", m = a && c === "backward";
    return {
      ...r,
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: $L(t, n.data),
      hasPreviousPage: YL(t, n.data),
      isFetchNextPageError: p,
      isFetchingNextPage: h,
      isFetchPreviousPageError: u,
      isFetchingPreviousPage: m,
      isRefetchError: s && !p && !u,
      isRefetching: i && !h && !m
    };
  }
}, O2, j2, pt, g2, b2, k0, Ui, X5, eE = (X5 = class extends fr {
  constructor(n, r) {
    super();
    j1(this, b2);
    j1(this, O2);
    j1(this, j2);
    j1(this, pt);
    j1(this, g2);
    _1(this, O2, n), this.setOptions(r), this.bindMethods(), $1(this, b2, k0).call(this);
  }
  bindMethods() {
    this.mutate = this.mutate.bind(this), this.reset = this.reset.bind(this);
  }
  setOptions(n) {
    var a;
    const r = this.options;
    this.options = B(this, O2).defaultMutationOptions(n), j0(this.options, r) || B(this, O2).getMutationCache().notify({
      type: "observerOptionsUpdated",
      mutation: B(this, pt),
      observer: this
    }), r != null && r.mutationKey && this.options.mutationKey && bn(r.mutationKey) !== bn(this.options.mutationKey) ? this.reset() : ((a = B(this, pt)) == null ? void 0 : a.state.status) === "pending" && B(this, pt).setOptions(this.options);
  }
  onUnsubscribe() {
    var n;
    this.hasListeners() || (n = B(this, pt)) == null || n.removeObserver(this);
  }
  onMutationUpdate(n) {
    $1(this, b2, k0).call(this), $1(this, b2, Ui).call(this, n);
  }
  getCurrentResult() {
    return B(this, j2);
  }
  reset() {
    var n;
    (n = B(this, pt)) == null || n.removeObserver(this), _1(this, pt, void 0), $1(this, b2, k0).call(this), $1(this, b2, Ui).call(this);
  }
  mutate(n, r) {
    var a;
    return _1(this, g2, r), (a = B(this, pt)) == null || a.removeObserver(this), _1(this, pt, B(this, O2).getMutationCache().build(B(this, O2), this.options)), B(this, pt).addObserver(this), B(this, pt).execute(n);
  }
}, O2 = new WeakMap(), j2 = new WeakMap(), pt = new WeakMap(), g2 = new WeakMap(), b2 = new WeakSet(), k0 = function() {
  var r, a;
  const n = (a = (r = B(this, pt)) == null ? void 0 : r.state) != null ? a : $s();
  _1(this, j2, {
    ...n,
    isPending: n.status === "pending",
    isSuccess: n.status === "success",
    isError: n.status === "error",
    isIdle: n.status === "idle",
    mutate: this.mutate,
    reset: this.reset
  });
}, Ui = function(n) {
  $e.batch(() => {
    var r, a, i, l, s, c, p, h;
    if (B(this, g2) && this.hasListeners()) {
      const u = B(this, j2).variables, m = B(this, j2).context;
      (n == null ? void 0 : n.type) === "success" ? ((a = (r = B(this, g2)).onSuccess) == null || a.call(r, n.data, u, m), (l = (i = B(this, g2)).onSettled) == null || l.call(i, n.data, null, u, m)) : (n == null ? void 0 : n.type) === "error" && ((c = (s = B(this, g2)).onError) == null || c.call(s, n.error, u, m), (h = (p = B(this, g2)).onSettled) == null || h.call(
        p,
        void 0,
        n.error,
        u,
        m
      ));
    }
    this.listeners.forEach((u) => {
      u(B(this, j2));
    });
  });
}, X5), Xs = o.createContext(
  void 0
), ko = (e) => {
  const t = o.useContext(Xs);
  if (!t)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return t;
}, Na = ({
  client: e,
  children: t
}) => (o.useEffect(() => (e.mount(), () => {
  e.unmount();
}), [e]), /* @__PURE__ */ f.jsx(Xs.Provider, { value: e, children: t })), Js = o.createContext(!1), tE = () => o.useContext(Js);
Js.Provider;
function nE() {
  let e = !1;
  return {
    clearReset: () => {
      e = !1;
    },
    reset: () => {
      e = !0;
    },
    isReset: () => e
  };
}
var rE = o.createContext(nE()), aE = () => o.useContext(rE);
function e6(e, t) {
  return typeof e == "function" ? e(...t) : !!e;
}
function zi() {
}
var iE = (e, t) => {
  (e.suspense || e.throwOnError || e.experimental_prefetchInRender) && (t.isReset() || (e.retryOnMount = !1));
}, oE = (e) => {
  o.useEffect(() => {
    e.clearReset();
  }, [e]);
}, sE = ({
  result: e,
  errorResetBoundary: t,
  throwOnError: n,
  query: r,
  suspense: a
}) => e.isError && !t.isReset() && !e.isFetching && r && (a && e.data === void 0 || e6(n, [e.error, r])), lE = (e) => {
  const t = e.staleTime;
  e.suspense && (e.staleTime = typeof t == "function" ? (...n) => Math.max(t(...n), 1e3) : Math.max(t != null ? t : 1e3, 1e3), typeof e.gcTime == "number" && (e.gcTime = Math.max(e.gcTime, 1e3)));
}, cE = (e, t) => e.isLoading && e.isFetching && !t, uE = (e, t) => (e == null ? void 0 : e.suspense) && t.isPending, a5 = (e, t, n) => t.fetchOptimistic(e).catch(() => {
  n.clearReset();
});
function t6(e, t, n) {
  var u, m, d, v, x;
  if (process.env.NODE_ENV !== "production" && (typeof e != "object" || Array.isArray(e)))
    throw new Error(
      'Bad argument type. Starting with v5, only the "Object" form is allowed when calling query related functions. Please use the error stack to find the culprit call. More info here: https://tanstack.com/query/latest/docs/react/guides/migrating-to-v5#supports-a-single-signature-one-object'
    );
  const r = ko(), a = tE(), i = aE(), l = r.defaultQueryOptions(e);
  (m = (u = r.getDefaultOptions().queries) == null ? void 0 : u._experimental_beforeQuery) == null || m.call(
    u,
    l
  ), process.env.NODE_ENV !== "production" && (l.queryFn || console.error(
    `[${l.queryHash}]: No queryFn was passed as an option, and no default queryFn was found. The queryFn parameter is only optional when using a default queryFn. More info here: https://tanstack.com/query/latest/docs/framework/react/guides/default-query-function`
  )), l._optimisticResults = a ? "isRestoring" : "optimistic", lE(l), iE(l, i), oE(i);
  const s = !r.getQueryCache().get(l.queryHash), [c] = o.useState(
    () => new t(
      r,
      l
    )
  ), p = c.getOptimisticResult(l), h = !a && e.subscribed !== !1;
  if (o.useSyncExternalStore(
    o.useCallback(
      (k) => {
        const I = h ? c.subscribe($e.batchCalls(k)) : zi;
        return c.updateResult(), I;
      },
      [c, h]
    ),
    () => c.getCurrentResult(),
    () => c.getCurrentResult()
  ), o.useEffect(() => {
    c.setOptions(l);
  }, [l, c]), uE(l, p))
    throw a5(l, c, i);
  if (sE({
    result: p,
    errorResetBoundary: i,
    throwOnError: l.throwOnError,
    query: r.getQueryCache().get(l.queryHash),
    suspense: l.suspense
  }))
    throw p.error;
  if ((v = (d = r.getDefaultOptions().queries) == null ? void 0 : d._experimental_afterQuery) == null || v.call(
    d,
    l,
    p
  ), l.experimental_prefetchInRender && !yn && cE(p, a)) {
    const k = s ? (
      // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
      a5(l, c, i)
    ) : (
      // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
      (x = r.getQueryCache().get(l.queryHash)) == null ? void 0 : x.promise
    );
    k == null || k.catch(zi).finally(() => {
      c.updateResult();
    });
  }
  return l.notifyOnChangeProps ? p : c.trackResult(p);
}
function n6(e, t) {
  return t6(e, Ks);
}
function dE(e, t) {
  const n = ko(), [r] = o.useState(
    () => new eE(
      n,
      e
    )
  );
  o.useEffect(() => {
    r.setOptions(e);
  }, [r, e]);
  const a = o.useSyncExternalStore(
    o.useCallback(
      (l) => r.subscribe($e.batchCalls(l)),
      [r]
    ),
    () => r.getCurrentResult(),
    () => r.getCurrentResult()
  ), i = o.useCallback(
    (l, s) => {
      r.mutate(l, s).catch(zi);
    },
    [r]
  );
  if (a.error && e6(r.options.throwOnError, [a.error]))
    throw a.error;
  return { ...a, mutate: i, mutateAsync: a.mutate };
}
function fE(e, t) {
  return t6(
    e,
    JL
  );
}
const r6 = 1, hE = 4, Ha = `https://kv-api.${J.DOMAIN}/api/v1/kv/get?type=${r6}`, pE = `https://kv-api.${J.DOMAIN}/api/v1/kv/set`;
function a6() {
  const e = ko(), {
    data: t
  } = n6({
    queryKey: [Ha],
    queryFn: () => J.Backend.get(Ha),
    staleTime: 1 / 0,
    retry: 0,
    refetchOnWindowFocus: !1
  }), n = dE({
    mutationFn: (s) => fetch(pE, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(s),
      keepalive: !0
    }),
    onMutate(s) {
      e.setQueryData([Ha], () => s);
    }
  }), r = W1((s) => {
    n.mutate({
      type: r6,
      value: s
    });
  }, []), a = Xe(() => !t || "code" in t ? [] : t.value, [t]);
  function i(s) {
    const c = /* @__PURE__ */ new Set([s, ...a]);
    r([...c].slice(0, hE));
  }
  function l() {
    r([]), P2.sendMessage({
      status: "success",
      message: "История успешно очищена"
    });
  }
  return {
    history: a,
    setHistory: i,
    clearHistory: l
  };
}
const i6 = ({
  onHistoryApply: e
}) => {
  const {
    formatMessage: t
  } = N1(), {
    history: n,
    clearHistory: r
  } = a6(), {
    mobileMdMax: a
  } = Ue(["mobileMdMax"]);
  return n.length ? /* @__PURE__ */ f.jsxs("div", { className: h2.root, children: [
    /* @__PURE__ */ f.jsxs("div", { className: h2.top, children: [
      /* @__PURE__ */ f.jsx("h2", { className: h2.title, "data-id": "search-history__title", children: t(z1.historyTitle) }),
      /* @__PURE__ */ f.jsx(q1, { onClick: r, className: h2.clear, appearance: "neutral", mode: "link", size: a ? "sm" : "md", leftIcon: /* @__PURE__ */ f.jsx(b1, { name: "delete-outline-20" }), "data-id": "search-history__clear", children: t(a ? z1.historyClearShort : z1.historyClear) })
    ] }),
    /* @__PURE__ */ f.jsx("div", { className: h2.content, children: n.map((i, l) => /* @__PURE__ */ f.jsxs(Je, { className: h2.button, onClick: () => e(i, l), "data-tooltip-id": i, children: [
      /* @__PURE__ */ f.jsx(b1, { className: h2.buttonIcon, name: a ? "history-backward-outline-16" : "history" }),
      /* @__PURE__ */ f.jsx("span", { className: h2.buttonText, children: i }),
      i.length > 90 && /* @__PURE__ */ f.jsx(kt, { id: i, content: i, className: h2.tooltip, place: "bottom" })
    ] }, i)) })
  ] }) : null;
}, B0 = "data:image/png;base64,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", mE = "_wrapper_hfgqz_1", CE = "_marketWrapper_hfgqz_15", gE = "_picture_hfgqz_21", vE = "_labels_hfgqz_42", wE = "_marketPicture_hfgqz_51", yE = "_content_hfgqz_64", bE = "_label_hfgqz_42", _E = "_title_hfgqz_69", xE = "_subtitle_hfgqz_76", LE = "_priceWrapper_hfgqz_84", qe = {
  wrapper: mE,
  marketWrapper: CE,
  picture: gE,
  labels: vE,
  marketPicture: wE,
  content: yE,
  label: bE,
  title: _E,
  subtitle: xE,
  priceWrapper: LE
};
function o6({
  labels: e,
  size: t = "md"
}) {
  const {
    formatMessage: n
  } = N1(), r = (i) => {
    if (!i)
      return n(z1.key);
    const l = i.length <= 20;
    return `${n(z1.key)}  ${l ? i : ""}`;
  }, a = () => {
    const i = [];
    return e.forEach((l) => {
      const {
        type: s
      } = l;
      s === "demo" && i.push(/* @__PURE__ */ f.jsx(J2, { size: t, type: s, label: n(z1.demo) }, s)), s === "dlc" && i.push(/* @__PURE__ */ f.jsx(J2, { size: t, type: s, label: n(z1.dlc) }, s)), s === "bundle" && i.push(/* @__PURE__ */ f.jsx(J2, { size: t, type: s, label: n(z1.bundle) }, s)), s === "key" && i.push(/* @__PURE__ */ f.jsx(J2, { size: t, type: s, label: r(l.name) }, s)), s === "steamGift" && i.push(/* @__PURE__ */ f.jsx(J2, { size: t, type: s, label: n(z1.steamGift) }, s));
    }), i;
  };
  return /* @__PURE__ */ f.jsx("div", { className: qe.labels, children: a() });
}
function EE({
  data: {
    name: e,
    price: t,
    picture: n,
    isReleaseSoon: r,
    isBought: a,
    onlyInCloudAvailable: i,
    labels: l,
    url: s,
    noPrice: c,
    isSteamGift: p
  },
  onClick: h
}) {
  const {
    formatMessage: u
  } = N1();
  function m(d) {
    d.button === 1 && h();
  }
  return /* @__PURE__ */ f.jsxs("a", { href: s, className: qe.wrapper, onClick: h, onAuxClick: m, "data-id": "search-card_game", children: [
    /* @__PURE__ */ f.jsxs("div", { className: qe.picture, children: [
      /* @__PURE__ */ f.jsx(ur, { width: 231, height: 130, src: n || B0, fallbackSrc: B0, alt: e }),
      l && /* @__PURE__ */ f.jsx(o6, { labels: l })
    ] }),
    /* @__PURE__ */ f.jsxs("div", { className: qe.content, children: [
      /* @__PURE__ */ f.jsx(pn, { className: qe.title, children: e }),
      !c && /* @__PURE__ */ f.jsx("div", { className: qe.priceWrapper, children: /* @__PURE__ */ f.jsx(X0, { actualValue: t == null ? void 0 : t.actualCost, originalValue: t == null ? void 0 : t.originalCost, currency: t == null ? void 0 : t.currency, isBought: a, isReleaseSoon: r, isCloudOnly: i, discountValue: t == null ? void 0 : t.discount, size: "sm", freeLabel: u(z1.free), boughtLabel: u(z1.bought), releaseSoonLabel: u(z1.releaseSoon), cloudOnlyLabel: u(z1.cloudOnly), ...p && {
        beforeLabel: u(z1.priceFrom)
      } }) })
    ] })
  ] });
}
const s6 = e4(EE), ME = "_wrapper_k6750_1", kE = "_picture_k6750_8", SE = "_discount_k6750_14", AE = "_content_k6750_27", TE = "_name_k6750_39", IE = "_price_k6750_51", Tn = {
  wrapper: ME,
  picture: kE,
  discount: SE,
  content: AE,
  name: TE,
  price: IE
};
function l6({
  data: {
    url: e,
    picture: t,
    price: n,
    isBought: r,
    isReleaseSoon: a,
    onlyInCloudAvailable: i,
    name: l,
    labels: s,
    noPrice: c
  },
  onClick: p
}) {
  const {
    formatMessage: h
  } = N1(), {
    mobileMdMax: u
  } = Ue(["mobileMdMax"]);
  return /* @__PURE__ */ f.jsxs("a", { href: e, className: Tn.wrapper, onClick: p, "data-id": "search-card_game", children: [
    /* @__PURE__ */ f.jsxs("div", { className: Tn.picture, children: [
      /* @__PURE__ */ f.jsx(ur, { alt: "Обложка", height: 92.8, src: t || B0, fallbackSrc: B0 }),
      (n == null ? void 0 : n.discount) && /* @__PURE__ */ f.jsx(_4, { discount: n == null ? void 0 : n.discount, className: Tn.discount, size: u ? "xs" : "sm" })
    ] }),
    /* @__PURE__ */ f.jsxs("div", { className: Tn.content, children: [
      /* @__PURE__ */ f.jsx(pn, { className: Tn.name, children: l }),
      s && /* @__PURE__ */ f.jsx(o6, { labels: s, size: "xs" }),
      !c && /* @__PURE__ */ f.jsx("div", { className: Tn.price, children: /* @__PURE__ */ f.jsx(X0, { actualValue: n == null ? void 0 : n.actualCost, originalValue: n == null ? void 0 : n.originalCost, currency: n == null ? void 0 : n.currency, isBought: r, isReleaseSoon: a, isCloudOnly: i, discountValue: n == null ? void 0 : n.discount, size: "xs", freeLabel: h(z1.free), boughtLabel: h(z1.bought), releaseSoonLabel: h(z1.releaseSoon), cloudOnlyLabel: h(z1.cloudOnly), showDiscountLabel: !1 }) })
    ] })
  ] });
}
function RE(e) {
  switch (e) {
    case "market":
      return 4;
    case "media":
      return 3;
    case "games":
      return 6;
    case "services":
      return 2;
    default:
      return 3;
  }
}
function NE(e) {
  switch (e) {
    case "media":
    case "games":
    case "services":
      return 3;
    case "market":
      return 4;
    default:
      return 3;
  }
}
function HE(e) {
  switch (e) {
    case "services":
    case "media":
    case "market":
      return !1;
    default:
      return !0;
  }
}
const OE = "_skeletonBlock_1udbg_1", jE = "_skeleton_1udbg_1", PE = "_skHeader_1udbg_7", DE = "_skGrid_1udbg_14", VE = "_skeletonGame_1udbg_20", BE = "_skeletonMedia_1udbg_20", FE = "_skeletonMarket_1udbg_20", ZE = "_picture_1udbg_25", GE = "_content_1udbg_32", Ae = {
  skeletonBlock: OE,
  skeleton: jE,
  skHeader: PE,
  skGrid: DE,
  skeletonGame: VE,
  skeletonMedia: BE,
  skeletonMarket: FE,
  picture: ZE,
  content: GE
};
function c6({
  variant: e = "games",
  count: t = RE(e),
  columns: n = NE(e),
  withMoreButton: r = HE(e)
}) {
  const a = (i) => {
    switch (e) {
      case "games":
        return /* @__PURE__ */ f.jsxs("div", { className: Ae.skeletonGame, children: [
          /* @__PURE__ */ f.jsx(ot, { className: h1(Ae.picture, Ae.skeletonBlock) }),
          /* @__PURE__ */ f.jsx(ot, { className: Ae.skeletonBlock, width: "100%", height: 20 }),
          /* @__PURE__ */ f.jsx(ot, { className: Ae.skeletonBlock, width: "60%", height: 14 })
        ] }, `skeleton-${i}`);
      case "media":
        return /* @__PURE__ */ f.jsxs("div", { className: Ae.skeletonMedia, children: [
          /* @__PURE__ */ f.jsx(ot, { className: h1(Ae.picture, Ae.skeletonBlock) }),
          /* @__PURE__ */ f.jsxs("div", { className: Ae.content, children: [
            /* @__PURE__ */ f.jsx(ot, { className: Ae.skeletonBlock, width: "50%", height: 18 }),
            /* @__PURE__ */ f.jsx(ot, { className: Ae.skeletonBlock, width: "100%", height: 19 }),
            /* @__PURE__ */ f.jsx(ot, { className: Ae.skeletonBlock, width: "100%", height: 19 })
          ] })
        ] }, `skeleton-${i}`);
      case "market":
        return /* @__PURE__ */ f.jsxs("div", { className: Ae.skeletonMarket, children: [
          /* @__PURE__ */ f.jsx(ot, { className: h1(Ae.picture, Ae.skeletonBlock) }),
          /* @__PURE__ */ f.jsxs("div", { className: Ae.content, children: [
            /* @__PURE__ */ f.jsx(ot, { className: Ae.skeletonBlock, width: "50%", height: 18 }),
            /* @__PURE__ */ f.jsx(ot, { className: Ae.skeletonBlock, width: "100%", height: 19 }),
            /* @__PURE__ */ f.jsx(ot, { className: Ae.skeletonBlock, width: "100%", height: 19 })
          ] })
        ] }, `skeleton-${i}`);
      case "services":
        return /* @__PURE__ */ f.jsx(ot, { className: Ae.skeletonBlock, width: "100%", height: 44 }, `skeleton-${i}`);
      default:
        return null;
    }
  };
  return /* @__PURE__ */ f.jsxs("div", { className: Ae.skeleton, children: [
    /* @__PURE__ */ f.jsxs("div", { className: Ae.skHeader, children: [
      /* @__PURE__ */ f.jsx(ot, { width: 155, height: 32, className: Ae.skeletonBlock }),
      r && /* @__PURE__ */ f.jsx(ot, { width: 128, height: 40, className: Ae.skeletonBlock })
    ] }),
    /* @__PURE__ */ f.jsx("div", { className: Ae.skGrid, style: {
      gridTemplateColumns: `repeat(${n}, minmax(0, 1fr))`
    }, children: Array.from({
      length: t
    }, (i, l) => a(l)) })
  ] });
}
const i5 = "/catalog/v1/suggest", WE = () => n6({
  queryKey: [i5],
  queryFn: () => J.Backend.api_get(i5, {
    limit: 3
  }),
  staleTime: 1 / 0,
  retry: 0
}), UE = "_top_wb2bb_1", zE = "_title_wb2bb_11", qE = "_content_wb2bb_24", f0 = {
  top: UE,
  title: zE,
  content: qE
};
function u6({
  isFullscreen: e,
  onRecommendedClick: t
}) {
  const {
    formatMessage: n
  } = N1(), r = e ? l6 : s6, {
    data: a,
    isError: i,
    isFetching: l
  } = WE();
  return l ? /* @__PURE__ */ f.jsx(c6, { withMoreButton: !1, count: 3 }) : !(a != null && a.length) || i ? null : /* @__PURE__ */ f.jsxs("div", { className: f0.root, children: [
    /* @__PURE__ */ f.jsx("div", { className: f0.top, children: /* @__PURE__ */ f.jsx("h2", { className: f0.title, "data-id": "search-recommended__title", children: n(z1.recommendedTitle) }) }),
    /* @__PURE__ */ f.jsx("div", { className: f0.content, children: a.map((s, c) => /* @__PURE__ */ f.jsx(r, { data: s, onClick: () => t && t(s.url, c) }, s.name)) })
  ] });
}
const $E = (e) => /* @__PURE__ */ o.createElement("svg", { width: 70, height: 21, viewBox: "0 0 70 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ o.createElement("path", { d: "M1 14.039C12.9576 11.307 42.8879 6.66251 66.948 9.94094M57.1645 1L68.6813 9.01005C69.0824 9.28895 69.1097 9.88594 68.736 10.2024L57.1645 20", stroke: "#A7DD00", strokeWidth: 2, strokeLinecap: "round" })), YE = (e) => /* @__PURE__ */ o.createElement("svg", { width: 113, height: 23, viewBox: "0 0 113 23", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ o.createElement("path", { d: "M2 17.5C34 10.0101 84.8879 7.66251 108.948 10.9409M99.1645 2L110.681 10.0101C111.082 10.289 111.11 10.8859 110.736 11.2024L99.1645 21", stroke: "#A7DD00", strokeWidth: 3, strokeLinecap: "round" })), KE = "data:image/png;base64,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", QE = "_wrapper_1nzlo_1", XE = "_picture_1nzlo_6", JE = "_arrow_1nzlo_14", h0 = {
  wrapper: QE,
  picture: XE,
  arrow: JE
}, eM = {
  survival: {
    id: "search.genre.survival",
    defaultMessage: "Выживание"
  },
  rpg: {
    id: "search.genre.rpg",
    defaultMessage: "Ролевые"
  },
  metroidvania: {
    id: "search.genre.metroidvania",
    defaultMessage: "Метроидвания"
  },
  roguelike: {
    id: "search.genre.roguelike",
    defaultMessage: "Рогалик"
  },
  quest: {
    id: "search.genre.quest",
    defaultMessage: "Квесты"
  },
  shooter: {
    id: "search.genre.shooter",
    defaultMessage: "Шутеры"
  },
  mmo: {
    id: "search.genre.mmo",
    defaultMessage: "MMORPG"
  },
  strategy: {
    id: "search.genre.strategy",
    defaultMessage: "Стратегии"
  },
  action: {
    id: "search.genre.action",
    defaultMessage: "Экшены"
  },
  simulator: {
    id: "search.genre.simulator",
    defaultMessage: "Симуляторы"
  },
  racing: {
    id: "search.genre.racing",
    defaultMessage: "Гонки"
  },
  tower_defense: {
    id: "search.genre.tower_defense",
    defaultMessage: "Защита Башни"
  },
  card: {
    id: "search.genre.card",
    defaultMessage: "Карточные"
  },
  russian: {
    id: "search.genre.russian",
    defaultMessage: "Российские"
  },
  adventure: {
    id: "search.genre.adventure",
    defaultMessage: "Приключения"
  },
  arcade: {
    id: "search.genre.arcade",
    defaultMessage: "Аркады"
  },
  anime: {
    id: "search.genre.anime",
    defaultMessage: "Аниме"
  },
  logic: {
    id: "search.genre.logic",
    defaultMessage: "Логические"
  },
  military: {
    id: "search.genre.military",
    defaultMessage: "Военные"
  },
  visual_novel: {
    id: "search.genre.visual_novel",
    defaultMessage: "Визуальная новелла"
  },
  three: {
    id: "search.genre.three",
    defaultMessage: "Три в ряд"
  },
  other: {
    id: "search.genre.other",
    defaultMessage: "Другие"
  },
  sport: {
    id: "search.genre.sport",
    defaultMessage: "Спортивные"
  },
  table: {
    id: "search.genre.table",
    defaultMessage: "Настольные"
  },
  farms: {
    id: "search.genre.farms",
    defaultMessage: "Фермы"
  },
  fantasy: {
    id: "search.genre.fantasy",
    defaultMessage: "Фэнтези"
  },
  fight: {
    id: "search.genre.fight",
    defaultMessage: "Драки"
  },
  casino: {
    id: "search.genre.casino",
    defaultMessage: "Казино"
  },
  moba: {
    id: "search.genre.moba",
    defaultMessage: "MOBA"
  },
  indie: {
    id: "search.genre.indie",
    defaultMessage: "Инди"
  },
  kids: {
    id: "search.genre.kids",
    defaultMessage: "Детские"
  },
  flash: {
    id: "search.genre.flash",
    defaultMessage: "Флеш"
  },
  horror: {
    id: "search.genre.horror",
    defaultMessage: "Хоррор"
  },
  chess: {
    id: "search.genre.chess",
    defaultMessage: "Шахматы"
  },
  puzzle: {
    id: "search.genre.puzzle",
    defaultMessage: "Пазлы"
  },
  quizzes: {
    id: "search.genre.quizzes",
    defaultMessage: "Викторина"
  },
  mahjong: {
    id: "search.genre.mahjong",
    defaultMessage: "Маджонг"
  },
  bubble: {
    id: "search.genre.bubble",
    defaultMessage: "Шарики"
  },
  dotio: {
    id: "search.genre.dotio",
    defaultMessage: ".IO"
  },
  recommended: {
    id: "search.genre.recommended",
    defaultMessage: "Рекомендуемое"
  },
  social: {
    id: "search.genre.social",
    defaultMessage: "Социальные"
  }
};
function tM({
  data: {
    url: e,
    // picture,
    name: t
  },
  onClick: n
}) {
  const {
    formatMessage: r
  } = N1(), a = eM[t], {
    tabletSmMax: i
  } = Ue(["tabletSmMax"]);
  return /* @__PURE__ */ f.jsxs("a", { href: e, onClick: n, className: h0.wrapper, "data-id": "search-card_genre", children: [
    /* @__PURE__ */ f.jsx("div", { className: h0.picture, children: /* @__PURE__ */ f.jsx(ur, { alt: " ", src: KE }) }),
    /* @__PURE__ */ f.jsx(pn, { children: r(a) }),
    i ? /* @__PURE__ */ f.jsx($E, { className: h0.arrow }) : /* @__PURE__ */ f.jsx(YE, { className: h0.arrow })
  ] });
}
function nM({
  data: e,
  onClick: t
}) {
  var r;
  const {
    tabletMdMax: n
  } = Ue(["tabletMdMax"]);
  return (r = e == null ? void 0 : e.labels) != null && r.find((a) => a.type === "genre") ? /* @__PURE__ */ f.jsx(tM, { data: e, onClick: t }) : n ? /* @__PURE__ */ f.jsx(l6, { data: e, onClick: t }) : /* @__PURE__ */ f.jsx(s6, { data: e, onClick: t });
}
function rM({
  onClick: e,
  data: {
    picture: t,
    name: n,
    labels: r,
    price: a,
    url: i
  }
}) {
  function l(s) {
    s.button === 1 && e();
  }
  return /* @__PURE__ */ f.jsxs("a", { href: i, onClick: e, onAuxClick: l, className: h1(qe.wrapper, qe.marketWrapper), children: [
    /* @__PURE__ */ f.jsx("div", { className: qe.marketPicture, children: /* @__PURE__ */ f.jsx(ur, { alt: " ", src: t, height: 131, width: 131 }) }),
    /* @__PURE__ */ f.jsxs("div", { className: qe.content, children: [
      (r == null ? void 0 : r[0]) && /* @__PURE__ */ f.jsx(ro, { variant: "whiteAlpha", label: r[0].label, className: qe.label }),
      /* @__PURE__ */ f.jsx(pn, { className: qe.title, children: n }),
      /* @__PURE__ */ f.jsx("div", { className: qe.priceWrapper, children: /* @__PURE__ */ f.jsx(X0, { actualValue: a == null ? void 0 : a.actualCost, originalValue: a == null ? void 0 : a.originalCost, currency: a == null ? void 0 : a.currency, discountValue: a == null ? void 0 : a.discount, size: "xs" }) })
    ] })
  ] });
}
const o5 = "https://vkplay.ru/hotbox/showcase/game/search/media_search_pic.png";
function aM({
  data: {
    url: e,
    picture: t,
    name: n,
    alias: r
  },
  onClick: a
}) {
  const {
    formatMessage: i
  } = N1();
  function l(s) {
    s.button === 1 && a();
  }
  return /* @__PURE__ */ f.jsxs("a", { href: e, className: qe.wrapper, onClick: a, onAuxClick: l, "data-id": "search-card_media", children: [
    /* @__PURE__ */ f.jsx("div", { className: qe.picture, children: /* @__PURE__ */ f.jsx(ur, { width: 231, height: 130, src: t || o5, fallbackSrc: o5, alt: n }) }),
    /* @__PURE__ */ f.jsxs("div", { className: qe.content, children: [
      /* @__PURE__ */ f.jsx(pn, { className: qe.subtitle, children: z1[r] ? i(z1[r]) : r }),
      /* @__PURE__ */ f.jsx(pn, { className: h1(qe.title, qe.media), clamp: 3, children: n })
    ] })
  ] });
}
const iM = "_service_l7gun_1", oM = {
  service: iM
};
function sM({
  data: e,
  onClick: t
}) {
  const {
    formatMessage: n
  } = N1();
  function r(a) {
    a.button === 1 && t();
  }
  return /* @__PURE__ */ f.jsxs("a", { className: oM.service, href: e.url, onClick: t, onAuxClick: r, "data-id": "search-card_service", children: [
    /* @__PURE__ */ f.jsx(b1, { name: e.picture }),
    /* @__PURE__ */ f.jsx(pn, { children: n(z1[e.name]) })
  ] });
}
const lM = ({
  sectionId: e,
  data: t,
  onClick: n
}) => {
  if (e === "games") {
    const r = t;
    return /* @__PURE__ */ f.jsx(nM, { data: r, onClick: n });
  }
  if (e === "media") {
    const r = t;
    return /* @__PURE__ */ f.jsx(aM, { data: r, onClick: n });
  }
  if (e === "services") {
    const r = t;
    return /* @__PURE__ */ f.jsx(sM, { data: r, onClick: n });
  }
  if (e === "market") {
    const r = t;
    return /* @__PURE__ */ f.jsx(rM, { data: r, onClick: n });
  }
  return null;
}, F0 = [{
  id: "games",
  label: "tabGames",
  icon: "game-outline-28"
}, {
  id: "media",
  label: "tabMedia",
  icon: "newsfeed-lines-outline-28"
}, {
  id: "market",
  label: "market",
  icon: "market-outline-28"
}, {
  id: "services",
  label: "tabServices",
  icon: "square-4-outline-24"
}], d6 = [{
  id: "all",
  label: "tabAll",
  icon: "menu-outline-24"
}], f6 = [...d6, ...F0], cM = "_root_u4jse_1", uM = "_top_u4jse_10", dM = "_icon_u4jse_17", fM = "_title_u4jse_24", hM = "_moreButton_u4jse_36", pM = "_fullscreen_u4jse_44", mM = "_emptyCategory_u4jse_53", CM = "_content_u4jse_57", gM = "_col4_u4jse_76", vM = "_row_u4jse_91", Ut = {
  root: cM,
  top: uM,
  icon: dM,
  title: fM,
  moreButton: hM,
  fullscreen: pM,
  emptyCategory: mM,
  content: CM,
  col4: gM,
  row: vM
}, h6 = o2({
  size: "default"
}), wM = ({
  size: e = "default",
  children: t
}) => {
  const n = Xe(() => ({
    size: e
  }), [e]);
  return /* @__PURE__ */ f.jsx(h6.Provider, { value: n, children: t });
}, p6 = () => {
  const e = D1(h6);
  if (e === void 0)
    throw new Error("useSearch must be used within a SearchProvider");
  return e;
}, s5 = ({
  id: e,
  children: t,
  title: n,
  icon: r,
  isActiveSection: a,
  isFetching: i,
  hasNextPage: l,
  setCurrentSection: s,
  onLoadMore: c,
  onClickMore: p,
  dataLength: h
}) => {
  const {
    formatMessage: u
  } = N1(), {
    size: m
  } = p6(), d = m === "fullscreen";
  function v() {
    p && p(e), s(e);
  }
  const x = (k) => {
    k && (c == null || c(e));
  };
  return /* @__PURE__ */ f.jsxs("div", { className: h1(Ut.root, {
    [Ut.fullscreen]: d
  }), "data-id": `search-dropdown__group_${e}`, children: [
    /* @__PURE__ */ f.jsxs("div", { className: Ut.top, children: [
      /* @__PURE__ */ f.jsx(b1, { className: Ut.icon, name: r }),
      /* @__PURE__ */ f.jsx("h2", { className: Ut.title, "data-id": "search-dropdown__group-title", children: n }),
      !a && l && /* @__PURE__ */ f.jsx(q1, { className: Ut.moreButton, onClick: v, mode: "link", rightIcon: /* @__PURE__ */ f.jsx(b1, { name: "chevron-right-20" }), children: u(z1.controlShowMore) })
    ] }),
    h === 0 ? /* @__PURE__ */ f.jsx("div", { className: Ut.emptyCategory, children: t }) : /* @__PURE__ */ f.jsx("div", { className: h1(Ut.content, {
      [Ut.row]: !a && d,
      [Ut.col4]: e === "market"
    }), children: t }),
    a && l && /* @__PURE__ */ f.jsx(wo, { triggerOnce: i, onChange: x, children: /* @__PURE__ */ f.jsx(nr, { size: "48" }) }, `id-${h}`)
  ] });
}, yM = (e) => /* @__PURE__ */ o.createElement("svg", { width: 129, height: 128, viewBox: "0 0 129 128", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ o.createElement("path", { d: "M20.4352 29.4375C12.9588 38.9562 8.5 50.9574 8.5 64C8.5 94.9279 33.5721 120 64.5 120C95.4279 120 120.5 94.9279 120.5 64C120.5 33.0721 95.4279 8 64.5 8C51.8539 8 40.1868 12.1918 30.8125 19.2618", stroke: "#A7DD00", strokeWidth: 7, strokeLinecap: "round" }), /* @__PURE__ */ o.createElement("path", { d: "M39.5 63.625H43.875", stroke: "#A7DD00", strokeWidth: 7, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { d: "M86.375 63.625H90.75", stroke: "#A7DD00", strokeWidth: 7, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { d: "M78.239 44.7675C78.239 44.7675 82.6074 48.6599 87.7304 48.997C92.8534 49.334 96.0033 48.516 96.0033 48.516", stroke: "#A7DD00", strokeWidth: 7, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { d: "M28.4171 52.0707C34.1947 52.4956 42.4423 51.7957 47.171 47.8363", stroke: "#A7DD00", strokeWidth: 7, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ o.createElement("path", { d: "M50.8965 89.7012C55.6225 89.7001 69.1995 89.7012 78.2751 89.7012", stroke: "#A7DD00", strokeWidth: 7, strokeLinecap: "round", strokeLinejoin: "round" })), bM = "_wrapper_oe3j6_1", _M = {
  wrapper: bM
};
function l5({
  isCategory: e
}) {
  const {
    formatMessage: t
  } = N1(), n = e ? z1.categoryNotFoundTitle : z1.placeholderNotFoundTitle, r = e ? z1.categoryNotFoundDescription : z1.placeholderNotFoundDescription;
  return /* @__PURE__ */ f.jsxs("div", { className: _M.wrapper, children: [
    /* @__PURE__ */ f.jsx(yM, {}),
    /* @__PURE__ */ f.jsx("h2", { children: t(n) }),
    /* @__PURE__ */ f.jsx("p", { children: t(r) })
  ] });
}
const So = (e) => {
  let t = 0;
  const n = [];
  return {
    itemsAmount: Object.entries(e).reduce((a, [i, l]) => {
      var c, p;
      const s = i.split("Search")[0];
      return a[s] = ((p = (c = l == null ? void 0 : l.searchData) == null ? void 0 : c.items) == null ? void 0 : p.length) || 0, t += a[s], a[s] || n.push(s), a;
    }, {}),
    itemsTotal: t,
    itemsEmpty: n
  };
}, m6 = ({
  currentSection: e,
  setCurrentSection: t,
  data: n,
  onLoadMore: r,
  onClickMore: a,
  onItemClick: i,
  isFetching: l,
  isFetched: s
}) => {
  const {
    formatMessage: c
  } = N1(), {
    itemsTotal: p,
    itemsAmount: h
  } = So(n), u = Xe(() => e === "all" ? F0 : [F0.find((d) => d.id === e)], [e]);
  if (s && !l && (!p || e !== "all" && !h[e])) {
    const d = u.find((v) => (v == null ? void 0 : v.id) === e);
    return !d || !d.id ? /* @__PURE__ */ f.jsx(l5, { isCategory: e !== "all" }) : /* @__PURE__ */ f.jsx(s5, { id: d.id, title: c(z1[d.label]), icon: d.icon, hasNextPage: !1, setCurrentSection: t, isActiveSection: !0, dataLength: 0, children: /* @__PURE__ */ f.jsx(l5, { isCategory: e !== "all" }) }, d.id);
  }
  const m = (d) => {
    switch (d) {
      case "market":
        return 8;
      case "services":
        return 2;
      default:
        return 6;
    }
  };
  return u.map((d) => {
    var I, T, L;
    if (!d) return null;
    const v = n[d.id], x = (I = v.searchData) == null ? void 0 : I.items, k = (T = x == null ? void 0 : x.length) != null ? T : 0;
    return k === 0 && (l || !s) ? /* @__PURE__ */ f.jsx(c6, { variant: d.id }, d.id) : k === 0 && e !== d.id ? null : /* @__PURE__ */ f.jsx(s5, { id: d.id, title: c(z1[d.label]), icon: d.icon, hasNextPage: v.hasNextPage, setCurrentSection: t, isActiveSection: d.id === e, onLoadMore: r, onClickMore: a, dataLength: k, children: ((L = d.id === e ? x : x == null ? void 0 : x.slice(0, m(d.id))) != null ? L : []).map((S, E) => /* @__PURE__ */ f.jsx(lM, { sectionId: d.id, data: S, onClick: () => i(S.url, E, d.id) }, S.url)) }, d.id);
  });
}, xM = "_wrapper_xy9x3_1", c5 = {
  wrapper: xM
}, LM = "_wrapper_13nvf_1", EM = "_button_13nvf_8", MM = "_active_13nvf_23", kM = "_scrollable_13nvf_29", SM = "_gradientLeft_13nvf_40", AM = "_visible_13nvf_62", TM = "_gradientRight_13nvf_67", gt = {
  wrapper: LM,
  button: EM,
  active: MM,
  scrollable: kM,
  gradientLeft: SM,
  visible: AM,
  gradientRight: TM
};
function IM({
  data: e,
  currentSection: t,
  setCurrentSection: n,
  searchQuery: r
}) {
  const {
    formatMessage: a
  } = N1(), i = V1(null), l = V1(null), s = V1(null), {
    itemsEmpty: c
  } = So(e);
  _n(() => {
    var m;
    const u = s.current;
    u && u.scrollWidth > u.getBoundingClientRect().width && ((m = i.current) == null || m.classList.add(gt.visible));
  }, []);
  const p = (u, m) => {
    u.currentTarget.scrollIntoView({
      behavior: "smooth",
      block: "nearest"
    }), n(m);
  }, h = (u) => {
    var m, d, v, x;
    u.currentTarget.scrollLeft > 0 ? (m = l.current) == null || m.classList.add(gt.visible) : u.currentTarget.scrollLeft === 0 && ((d = l.current) == null || d.classList.remove(gt.visible)), u.currentTarget.scrollWidth - u.currentTarget.scrollLeft <= u.currentTarget.clientWidth + 5 ? (v = i.current) == null || v.classList.remove(gt.visible) : (x = i.current) == null || x.classList.add(gt.visible);
  };
  return /* @__PURE__ */ f.jsxs("div", { className: gt.wrapper, children: [
    d6.map((u) => /* @__PURE__ */ f.jsx("button", { className: h1(gt.button, {
      [gt.active]: t === u.id
    }), onClick: () => n(u.id), "data-id": u.id, children: a(z1[u.label]) }, u.label)),
    /* @__PURE__ */ f.jsx("div", { className: gt.scrollable, ref: s, onScroll: h, children: F0.map((u) => /* @__PURE__ */ f.jsx("button", { className: h1(gt.button, {
      [gt.active]: t === u.id
    }), onClick: (m) => p(m, u.id), disabled: !!r.length && c.includes(u.id), "data-id": u.id, children: a(z1[u.label]) }, u.label)) }),
    /* @__PURE__ */ f.jsx("div", { className: gt.gradientLeft, ref: l }),
    /* @__PURE__ */ f.jsx("div", { className: gt.gradientRight, ref: i })
  ] });
}
function RM({
  searchQuery: e,
  onHistoryApply: t,
  onRecommendedClick: n,
  currentSection: r,
  setCurrentSection: a,
  data: i,
  onLoadMore: l,
  onClickMore: s,
  onItemClick: c,
  isFetched: p,
  isFetching: h
}) {
  return (e == null ? void 0 : e.length) > 0 ? /* @__PURE__ */ f.jsxs("div", { className: c5.wrapper, children: [
    /* @__PURE__ */ f.jsx(IM, { data: i, currentSection: r, setCurrentSection: a, searchQuery: e }),
    /* @__PURE__ */ f.jsx(m6, { currentSection: r, setCurrentSection: a, data: i, onLoadMore: l, onClickMore: s, onItemClick: c, isFetched: p, isFetching: h })
  ] }) : /* @__PURE__ */ f.jsxs("div", { className: c5.wrapper, children: [
    /* @__PURE__ */ f.jsx(i6, { onHistoryApply: t }),
    /* @__PURE__ */ f.jsx(u6, { isFullscreen: !0, onRecommendedClick: n })
  ] });
}
const u5 = {
  total: 0,
  items: [],
  next: null,
  prev: null
}, NM = /^(подд|поде|сап|тех|помощ|служб|sup|tech)\w*/i, HM = /^(st[eа]|ст[ие]|val|игр|g[aа]m|маг|st[oо]|пла|кош|поп|бал|д[еe]н|wal|top)\w*/i, OM = (e) => {
  if (e.match(NM))
    return {
      name: "support",
      url: "https://support.vkplay.ru/",
      picture: "help-outline"
    };
}, jM = (e) => {
  if (e.match(HM))
    return {
      name: "steam",
      url: Hb,
      picture: "wallet-outline"
    };
}, PM = async ({
  queryKey: [e]
}) => {
  if (typeof e != "string")
    return u5;
  const t = [OM(e), jM(e)].filter((n) => n);
  return {
    ...u5,
    total: t.length,
    items: t
  };
}, DM = (e, t = 300) => {
  let n;
  return (...r) => {
    clearTimeout(n), n = setTimeout(() => e(...r), t);
  };
}, Cr = ({
  url: e,
  defaultQuerySet: t = {},
  queryLabel: n = "query",
  queryFn: r
}) => {
  const [a, i] = r1(""), l = ({
    pageParam: x
  }) => J.Backend.get(e, {
    ...t,
    [n]: a,
    page: x
  }), {
    data: s,
    fetchNextPage: c,
    isFetching: p,
    isError: h,
    isFetched: u
  } = fE({
    queryKey: [a, e],
    // тут костыль в виде pageParam = 1 для правильной типизации
    queryFn: ({
      pageParam: x = 1,
      ...k
    }) => (r || l)({
      pageParam: x,
      ...k
    }),
    initialPageParam: 1,
    getNextPageParam: (x, k, I = 1) => x != null && x.next ? I + 1 : null,
    enabled: !!a,
    staleTime: 1 / 0,
    retry: 0
  }), m = W1((x) => i(x), []), d = W1(async () => {
    c();
  }, [c]), v = Xe(() => {
    var k;
    if (!((k = s == null ? void 0 : s.pages) != null && k.length))
      return null;
    const x = s.pages[s.pages.length - 1];
    return Array.isArray(s.pages[0]) ? {
      items: s.pages[0],
      total: s.pages[0].length,
      next: null,
      prev: null
    } : {
      ...x,
      items: s.pages.reduce((I, T) => (I.push(...T.items), I), [])
    };
  }, [s]);
  return {
    searchData: v,
    handleSearch: m,
    loadMore: d,
    hasNextPage: !!(v != null && v.next),
    isFetching: p,
    isFetched: u,
    isError: h
  };
}, C6 = window.location.hostname === "localhost", Oa = C6 ? "common-api.gm3.dev-vkplay.ru" : Kt, VM = C6 ? "api.dev-vkplay.ru" : Kt, BM = () => {
  const [e, t] = r1(""), n = Cr({
    url: `https://${Oa}/catalog/v1/search`,
    queryLabel: "q",
    defaultQuerySet: {
      pageSize: "6"
    }
  }), r = Cr({
    url: "",
    queryFn: PM
  }), a = Cr({
    url: `https://${Oa}/play/search/`,
    defaultQuerySet: {
      is_dev: "1"
    }
  }), i = Cr({
    url: `https://${Oa}/pc/v4/search/`,
    defaultQuerySet: {
      pageSize: "6"
    }
  }), l = Cr({
    url: `https://${VM}/market/v1/search/`,
    queryLabel: "q",
    defaultQuerySet: {
      pageSize: "8"
    }
  }), s = (h) => {
    t(h);
  }, c = W1(DM(async (h) => {
    n.handleSearch(h), r.handleSearch(h), i.handleSearch(h), l.handleSearch(h);
  }), [n.handleSearch, r.handleSearch, a.handleSearch, i.handleSearch, l.handleSearch]), p = async (h) => {
    h === "games" && await n.loadMore(), h === "dev" && await a.loadMore(), h === "media" && await i.loadMore(), h === "market" && await l.loadMore();
  };
  return u1(() => {
    c(e);
  }, [e]), {
    searchQuery: e,
    setSearchQuery: s,
    loadMore: p,
    isFetching: n.isFetching || r.isFetching || i.isFetching || l.isFetching,
    isFetched: n.isFetched || r.isFetching || i.isFetched || l.isFetched,
    data: {
      dev: a,
      games: n,
      media: i,
      services: r,
      market: l
    }
  };
}, FM = "_overlay_aq7a3_1", ZM = "_main_aq7a3_19", GM = "_nav_aq7a3_25", p0 = {
  overlay: FM,
  main: ZM,
  nav: GM
}, WM = ({
  onClick: e
}) => /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
  /* @__PURE__ */ f.jsx(Je, { className: `${p0.overlay} ${p0.main}`, onClick: e, "aria-label": "close search" }),
  /* @__PURE__ */ f.jsx(Z2, { into: "#search-overlay-root", shouldDisableBodyScroll: !0, children: /* @__PURE__ */ f.jsx(Je, { className: `${p0.overlay} ${p0.nav}`, onClick: e, "aria-label": "close search" }) })
] }), UM = "_root_xje59_1", zM = "_focused_xje59_11", qM = "_label_xje59_15", $M = "_fullscreen_xje59_21", YM = "_labelWrap_xje59_25", KM = "_icon_xje59_59", QM = "_input_xje59_71", XM = "_select_xje59_105", JM = "_selectInputWrapper_xje59_118", ek = "_clearButton_xje59_127", tk = "_cancelButton_xje59_147", It = {
  root: UM,
  focused: zM,
  label: qM,
  fullscreen: $M,
  labelWrap: YM,
  icon: KM,
  input: QM,
  select: XM,
  selectInputWrapper: JM,
  clearButton: ek,
  cancelButton: tk
}, nk = "_root_1pfxb_1", rk = "_button_1pfxb_7", ak = "_active_1pfxb_35", ik = "_icon_1pfxb_38", ok = "_disabled_1pfxb_43", gr = {
  root: nk,
  button: rk,
  active: ak,
  icon: ik,
  disabled: ok
}, sk = ({
  current: e,
  disabled: t,
  onChange: n
}) => {
  const {
    formatMessage: r
  } = N1();
  function a(i) {
    const {
      id: l
    } = i.currentTarget.dataset;
    n(l || "all");
  }
  return /* @__PURE__ */ f.jsx("nav", { className: gr.root, children: f6.map((i) => /* @__PURE__ */ f.jsxs("button", { "data-id": i.id, type: "button", className: h1(gr.button, {
    [gr.active]: i.id === e,
    [gr.disabled]: t.length && t.includes(i.id)
  }), onClick: a, children: [
    /* @__PURE__ */ f.jsx(b1, { className: gr.icon, name: i.icon }),
    r(z1[i.label])
  ] }, i.id)) });
}, lk = "_root_1pi00_1", ck = "_fullscreen_1pi00_28", uk = "_main_1pi00_36", dk = "_aside_1pi00_67", vr = {
  root: lk,
  fullscreen: ck,
  main: uk,
  aside: dk
}, fk = "_root_1sa6k_1", hk = "_loader_1sa6k_14", d5 = {
  root: fk,
  loader: hk
}, pk = (e) => /* @__PURE__ */ o.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, viewBox: "0 0 48 48", fill: "currentColor", ...e }, /* @__PURE__ */ o.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.0401 4.78585C14.0977 1.83781 18.9845 0.25 24 0.25C29.0155 0.25 33.9023 1.83781 37.9599 4.78585C42.0175 7.73389 45.0377 11.8908 46.5876 16.6608C48.1375 21.4309 48.1375 26.5691 46.5876 31.3392C45.0377 36.1092 42.0175 40.2661 37.9599 43.2142C33.9023 46.1622 29.0155 47.75 24 47.75C22.8954 47.75 22 46.8546 22 45.75C22 44.6454 22.8954 43.75 24 43.75C28.1708 43.75 32.2345 42.4296 35.6088 39.9781C38.983 37.5266 41.4945 34.0697 42.7834 30.1031C44.0722 26.1364 44.0722 21.8636 42.7834 17.8969C41.4945 13.9303 38.983 10.4734 35.6088 8.02191C32.2345 5.57039 28.1708 4.25 24 4.25C19.8292 4.25 15.7655 5.57038 12.3912 8.02191C9.017 10.4734 6.50548 13.9303 5.21663 17.8969C3.92779 21.8636 3.92779 26.1364 5.21663 30.1031C5.55796 31.1536 4.98306 32.2819 3.93255 32.6232C2.88205 32.9646 1.75374 32.3897 1.41241 31.3392C-0.137469 26.5691 -0.137469 21.4309 1.41241 16.6608C2.96229 11.8908 5.98247 7.73389 10.0401 4.78585Z", fill: "inherit" })), mk = ({
  isFetching: e,
  onHistoryApply: t,
  onRecommendedClick: n
}) => e ? /* @__PURE__ */ f.jsx("div", { className: d5.root, children: /* @__PURE__ */ f.jsx("div", { className: d5.loader, children: /* @__PURE__ */ f.jsx(pk, {}) }) }, "placeholder") : /* @__PURE__ */ f.jsxs("div", { children: [
  /* @__PURE__ */ f.jsx(i6, { onHistoryApply: t }),
  /* @__PURE__ */ f.jsx(u6, { onRecommendedClick: n })
] }, "placeholder"), Ck = ({
  data: e,
  searchQuery: t,
  onHistoryApply: n,
  onRecommendedClick: r,
  currentSection: a,
  setCurrentSection: i,
  isFetching: l,
  onLoadMore: s,
  onClickMore: c,
  onItemClick: p,
  isFetched: h
}) => {
  const {
    size: u
  } = p6(), m = V1(null);
  u1(() => {
    m.current && (m.current.scrollTop = 0);
  }, [a]);
  const {
    itemsEmpty: d
  } = So(e);
  return /* @__PURE__ */ f.jsxs("div", { "data-id": "search-dropdown", className: h1(vr.root, {
    [vr.fullscreen]: u === "fullscreen"
  }), children: [
    /* @__PURE__ */ f.jsx("main", { className: h1(vr.main, {
      [vr.overflow]: !J.isWindows
    }), ref: m, children: t != null && t.length ? /* @__PURE__ */ f.jsx(m6, { currentSection: a, setCurrentSection: i, data: e, onLoadMore: s, onClickMore: c, onItemClick: p, isFetching: l, isFetched: h }) : /* @__PURE__ */ f.jsx(mk, { isFetching: l, onHistoryApply: n, onRecommendedClick: r }) }),
    /* @__PURE__ */ f.jsx("aside", { className: vr.aside, children: /* @__PURE__ */ f.jsx(sk, { current: a, disabled: t != null && t.length ? d : [], onChange: i }) })
  ] });
}, g6 = ({
  className: e,
  onClose: t,
  onToggle: n,
  onEvent: r = () => {
  },
  size: a = "default"
}) => {
  const {
    formatMessage: i
  } = N1(), [l, s] = r1(!1), [c, p] = r1("all"), {
    setHistory: h
  } = a6(), u = V1(null), m = Xe(() => f6.map((H) => ({
    text: i(z1[H.label]),
    value: H.id
  })), []), {
    searchQuery: d,
    data: v,
    isFetching: x,
    isFetched: k,
    setSearchQuery: I,
    loadMore: T
  } = BM();
  u1(() => {
    if (x || !(d != null && d.length))
      return;
    const H = Object.values(v).reduce((Z, z) => {
      var K;
      return Z + (((K = z.searchData) == null ? void 0 : K.total) || 0);
    }, 0);
    r({
      type: "search",
      params: {
        query: d,
        isFound: !!H,
        currentSection: c
      }
    });
  }, [x]), u1(() => {
    r({
      type: "search-section",
      params: {
        currentSection: c
      }
    });
  }, [c]);
  const L = () => {
    r({
      type: "search-click",
      params: {
        currentSection: c
      }
    });
  }, S = W1((H) => {
    T(H);
  }, []), E = W1((H) => {
    r({
      type: "more-click",
      params: {
        query: d,
        section: H,
        currentSection: c
      }
    });
  }, [d]), j = W1((H, Z, z) => {
    h(d), r({
      type: "item-click",
      params: {
        query: d,
        url: H,
        index: Z,
        section: z,
        currentSection: c
      }
    });
  }, [d]), g = (H) => {
    I(H.target.value);
  }, w = (H, Z) => {
    I(H), r({
      type: "search-history",
      params: {
        query: H,
        index: Z,
        currentSection: c
      }
    });
  }, C = (H, Z) => {
    r({
      type: "item-recommended-click",
      params: {
        url: H,
        index: Z,
        currentSection: c
      }
    });
  }, b = (H) => {
    l || H.target.id === "section-select" || a !== "fullscreen" && s(!0);
  }, M = () => {
    I("");
  }, R = (H) => {
    H.stopPropagation();
  }, O = (H, Z) => {
    Z.preventDefault(), p(H);
  }, N = (H) => {
    H.preventDefault(), s(!1);
  };
  return u1(() => {
    n && n(l);
  }, [l]), /* @__PURE__ */ f.jsxs(wM, { size: a, children: [
    a === "default" && l && /* @__PURE__ */ f.jsx(WM, { onClick: N }),
    /* @__PURE__ */ f.jsxs("div", { className: h1(It.root, {
      [It.fullscreen]: a === "fullscreen",
      [It.focused]: l
    }, e), "data-id": "search", children: [
      /* @__PURE__ */ f.jsxs("div", { className: It.labelWrap, ref: u, children: [
        /* @__PURE__ */ f.jsxs("label", { onFocus: b, htmlFor: "eva-search-input", className: It.label, children: [
          /* @__PURE__ */ f.jsx(b1, { className: It.icon, name: "search-outline-20" }),
          /* @__PURE__ */ f.jsx("input", { id: "eva-search-input", type: "search", autoComplete: "off", className: It.input, onClick: L, onChange: g, value: d, placeholder: `${i(z1.placeholderInput)}` }),
          d.length > 0 && /* @__PURE__ */ f.jsx("button", { className: It.clearButton, onClick: M, onFocus: R, children: /* @__PURE__ */ f.jsx(b1, { name: "cancel-outline-28" }) }),
          l ? /* @__PURE__ */ f.jsx(q1, { size: "md", onClick: N, className: It.cancelButton, appearance: "neutral", children: i(z1.controlCancel) }) : a !== "fullscreen" && /* @__PURE__ */ f.jsx(xn.Select, { id: "section-select", name: "section-select", className: It.select, wrapperClassName: It.selectInputWrapper, value: c, onSelectOption: O, align: "right", autoWidth: !0, options: m })
        ] }),
        l && a !== "fullscreen" && /* @__PURE__ */ f.jsx(Ck, { onLoadMore: S, onClickMore: E, onItemClick: j, data: v, currentSection: c, setCurrentSection: p, searchQuery: d, onHistoryApply: w, onRecommendedClick: C, isFetching: x, isFetched: k })
      ] }),
      t && /* @__PURE__ */ f.jsx(q1, { size: "md", appearance: "overlay", mode: "link", onClick: t, children: i(z1.controlCancel) })
    ] }),
    a === "fullscreen" && /* @__PURE__ */ f.jsx(RM, { onLoadMore: S, onClickMore: E, onItemClick: j, data: v, currentSection: c, setCurrentSection: p, searchQuery: d, onHistoryApply: w, onRecommendedClick: C, isFetching: x, isFetched: k })
  ] });
}, v6 = o2({
  sidebarState: J.getCookie("sidebar_state") || void 0,
  setState: () => {
  }
}), gk = window.location.hostname === "localhost", vk = gk ? "localhost" : J.DOMAIN, wk = ({
  children: e
}) => {
  const [t, n] = r1(() => J.getCookie("sidebar_state") || void 0);
  return u1(() => {
    t && J.setCookie("sidebar_state", t, {
      expires: 365 * 86400,
      domain: vk,
      path: "/"
    });
  }, [t]), /* @__PURE__ */ f.jsx(v6.Provider, { value: {
    sidebarState: t,
    setState: n
  }, children: e });
}, Ao = () => {
  const e = D1(v6);
  if (!e)
    throw new Error("useSidebarContext must be used within SidebarProvider");
  return e;
}, yk = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Armored%20warfare'%3e%3cg%20id='Vector'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M20.148%2012.5849C19.368%2012.5849%2018.578%2012.5849%2017.798%2012.5849C17.698%2012.5849%2017.568%2012.5349%2017.508%2012.6049C17.448%2012.6749%2017.488%2012.8049%2017.488%2012.9149C17.488%2013.1349%2017.518%2013.3749%2017.468%2013.5849C17.298%2014.3449%2017.108%2015.0949%2016.928%2015.8449C16.908%2015.9349%2016.878%2015.9449%2016.798%2015.9449C16.298%2015.9449%2015.808%2015.9449%2015.308%2015.9449C15.218%2015.9449%2015.178%2015.9749%2015.158%2016.0649C15.008%2016.6649%2014.848%2017.2549%2014.688%2017.8749C14.608%2017.6549%2014.538%2017.4549%2014.468%2017.2549C14.188%2016.4749%2013.908%2015.6949%2013.628%2014.9149C13.598%2014.8249%2013.568%2014.8049%2013.478%2014.8049C12.508%2014.8049%2011.548%2014.8049%2010.578%2014.8049C10.478%2014.8049%2010.438%2014.8349%2010.408%2014.9349C10.158%2015.7849%209.89805%2016.6349%209.64805%2017.4849C9.60805%2017.6049%209.59805%2017.7349%209.51805%2017.8549C9.35805%2017.2449%209.18805%2016.6549%209.03805%2016.0549C9.01805%2015.9649%208.98805%2015.9449%208.89805%2015.9449C8.32805%2015.9449%207.74805%2015.9449%207.17805%2015.9449C7.09805%2015.9449%207.05805%2015.9349%207.03805%2015.8349C6.90805%2015.3449%206.76805%2014.8549%206.63805%2014.3549C6.48805%2013.8049%206.29805%2013.2649%206.35805%2012.6749C6.36805%2012.5849%206.32805%2012.5749%206.24805%2012.5749C5.60805%2012.5749%204.96805%2012.5749%204.31805%2012.5749H3.74805C3.74805%2012.5749%203.74805%2012.6149%203.75805%2012.6349C3.86805%2013.0549%203.97805%2013.4749%204.07805%2013.8849C4.35805%2014.9849%204.63805%2016.0849%204.91805%2017.1849C5.19805%2018.2849%205.47805%2019.3749%205.75805%2020.4749C6.04805%2021.6149%206.33805%2022.7449%206.62805%2023.8849C6.64805%2023.9849%206.68805%2023.9949%206.77805%2023.9949C7.22805%2023.9949%207.67805%2023.9949%208.12805%2023.9949C9.09805%2023.9949%2010.068%2023.9949%2011.038%2023.9949C11.108%2023.9949%2011.158%2023.9949%2011.188%2023.9049C11.258%2023.6549%2011.338%2023.4049%2011.418%2023.1649C11.638%2022.4349%2011.858%2021.7049%2012.088%2020.9749C12.138%2020.9849%2012.138%2021.0149%2012.138%2021.0449C12.378%2021.9849%2012.628%2022.9249%2012.868%2023.8649C12.888%2023.9449%2012.908%2023.9949%2013.008%2023.9949C14.478%2023.9949%2015.938%2023.9949%2017.408%2023.9949C17.488%2023.9949%2017.518%2023.9649%2017.538%2023.8949C17.638%2023.4549%2017.748%2023.0149%2017.858%2022.5749C18.018%2021.9149%2018.178%2021.2449%2018.338%2020.5849C18.468%2020.0349%2018.608%2019.4849%2018.738%2018.9349C18.898%2018.2749%2019.058%2017.6049%2019.218%2016.9449C19.378%2016.2949%2019.528%2015.6549%2019.688%2015.0049C19.868%2014.2449%2020.048%2013.4849%2020.238%2012.7249C20.268%2012.6149%2020.258%2012.5849%2020.138%2012.5849H20.148Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M6.35805%2011.9849C6.34805%2011.8949%206.37805%2011.8549%206.46805%2011.8249C6.84805%2011.7149%207.22805%2011.6049%207.59805%2011.4949C7.68805%2011.4749%207.71805%2011.4349%207.69805%2011.3449C7.65805%2011.0749%207.63805%2010.8049%207.58805%2010.5449C7.57805%2010.4649%207.59805%2010.4349%207.64805%2010.3949C8.11805%2010.0549%208.58805%209.70488%209.05805%209.35488C9.10805%209.31488%209.16805%209.30488%209.22805%209.30488C9.81805%209.30488%2010.418%209.30488%2011.008%209.30488C11.098%209.30488%2011.168%209.28488%2011.238%209.21488C11.368%209.08488%2011.498%208.91488%2011.658%208.85488C11.818%208.79488%2012.018%208.83488%2012.198%208.83488C12.268%208.83488%2012.318%208.81488%2012.368%208.75488C13.398%207.58488%2014.418%206.41488%2015.448%205.24488C15.538%205.13488%2015.848%205.06488%2015.978%205.09488C16.178%205.14488%2016.298%205.26488%2016.368%205.46488C16.408%205.57488%2016.418%205.67488%2016.408%205.78488C16.398%205.96488%2016.308%206.08488%2016.178%206.19488C16.078%206.27488%2015.998%206.37488%2015.908%206.46488C15.088%207.27488%2014.278%208.08488%2013.458%208.88488C13.388%208.94488%2013.398%208.98488%2013.458%209.03488C13.548%209.11488%2013.628%209.20488%2013.708%209.29488C13.758%209.34488%2013.798%209.36488%2013.868%209.36488C14.178%209.36488%2014.488%209.36488%2014.798%209.36488C14.838%209.36488%2014.888%209.36488%2014.928%209.39488C15.388%209.74488%2015.848%2010.1049%2016.308%2010.4549C16.358%2010.4949%2016.378%2010.5249%2016.348%2010.5849C16.268%2010.8149%2016.208%2011.0549%2016.138%2011.2849C16.108%2011.3649%2016.138%2011.3849%2016.208%2011.4149C16.608%2011.5849%2016.998%2011.7649%2017.388%2011.9449C17.418%2011.9549%2017.468%2011.9549%2017.468%2011.9949C17.468%2012.1149%2017.548%2012.0849%2017.608%2012.0849C18.398%2012.0849%2019.188%2012.0849%2019.968%2012.0849C20.008%2012.0849%2020.048%2012.0949%2020.088%2012.0749C20.088%2012.0549%2020.078%2012.0249%2020.068%2012.0049C19.868%2011.4949%2019.668%2010.9749%2019.468%2010.4649C19.138%209.61488%2018.808%208.76488%2018.478%207.91488C18.148%207.07488%2017.818%206.22488%2017.488%205.38488C17.158%204.53488%2016.828%203.68488%2016.498%202.83488C16.148%201.92488%2015.788%201.01488%2015.438%200.104883C15.408%200.0248828%2015.378%200.00488281%2015.298%200.00488281C13.168%200.0148828%2011.028%200.0148828%208.87805%200.0148828C8.79805%200.0148828%208.75805%200.0348828%208.73805%200.114883C8.63805%200.384883%208.52805%200.644883%208.42805%200.904883C7.95805%202.07488%207.48805%203.25488%207.00805%204.42488C6.55805%205.55488%206.09805%206.68488%205.63805%207.81488C5.18805%208.93488%204.73805%2010.0649%204.27805%2011.1849C4.15805%2011.4849%204.03805%2011.7749%203.91805%2012.0949C4.71805%2012.0949%205.48805%2012.0949%206.25805%2012.0949C6.34805%2012.0949%206.36805%2012.0549%206.35805%2011.9749V11.9849ZM11.848%202.87488C12.388%204.11488%2012.918%205.32488%2013.458%206.53488C13.408%206.56488%2013.368%206.55488%2013.318%206.55488C12.708%206.55488%2012.108%206.55488%2011.498%206.55488C11.398%206.55488%2011.338%206.58488%2011.278%206.66488C10.928%207.17488%2010.578%207.67488%2010.228%208.18488C10.168%208.27488%2010.108%208.31488%209.99805%208.30488C9.90805%208.30488%209.81805%208.30488%209.70805%208.30488C10.418%206.49488%2011.128%204.70488%2011.838%202.88488L11.848%202.87488Z'%20fill='white'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e", bk = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOwSURBVHgB1Vn9ddpADBd9+T90gjoThE4QNgidADJB0glIJgidwMkE0AlwJyiZAGcC6ASuhH8Hws9nfJzVj997ej6f70M6SSfdmcgYRVF8IkN8IEMw8wk/EjKEqQAMWf2EDGEtQB9kBmsBEvpfNcD271Y/IUNYaiDBsw9hTGApwKWn3CmiBMA26cNAla/ICLEauGwIVNpsattw33FsoIsSoNfrvfHj0WPjiae8gwtyPMY7RaALH1gxTXUFBEpU1aCmX8r0gyLRo0iA2TXThI73fdHOhg7BzNWvUJ7w6kf7xgVFgpnYshAZF0dMOaql/FBpKoxnKA9VOQrRuxCTmMKCylV1TH9luuoBXP7MNEObFyoFzbnvlKzBk9x46oX5OdM904bpuU3AQr8l01rG9gkhY53YptsD213KdK3qlor5MQVCGEffIyHwnp4z5qkJE6zaGhPIRIJbOhMQYo1nCoGWpocgmMp+YooEGH52GqVAnLMLiZ1vpcD++VRhRvzlBa8ZnonUcdtXz3h3VG7DIzeuKdRqjT3fd2am3q9havcNYy6h1TkFImgb5QkkouYUsI8j3ZC2jw3NXjFmToEIjQPiXDsTCsxhcmo+WmZUpht5qAMf+QD28Us6hH99pk0wSUbhKzWkg2/UYavmemA+tqjbqrnc+y+J/q7jhUq8NMN1Qrh2K2oBOLT0mVAZqZ98bZGOkBK2jvEd8xg7R7/sAtK0ZWoiDzp90yDfPzKJo4vWFnrVasYdKGZHsSk2NU2E6FsUnrShZhdattiFbpl+Iq8KQqgT51Subkbl6rbBF/Sb6VSkghG1tIJoqEi8rPl2g3RgU8mbXBqyy5u09vCtgBaC85/gA40IgKKs2ozt9RtFoGI2q9jxmiZyabBLuMYon514FSqbVb6SFl3fI0G9czz7oFQldcFCgOkCQqSoS1A/LzznkHOYv65bEdQ7f2h9JoDwz+gzLTzpM4Qx/bewP1IqTawLz10PBJ4qE3RajWKyi1uJhMorkhdUTegQTV3wchqUrXKG73122DuKRBe3Enlx+BMjjAqTC1WWiOzuRod0uCNK6F8ATCat1A0QWZ2NLwt1QIcfrLtw1C5u5oZUyfVZK7LyOrJmoin1fZfzgKLQxe30wpN85Z7yDjjorGL3/FgNFMzId8+3d095D5yT/+rtdFPau1HlbcMYbxQByz80e8bgEyawFGBbeZrATADsNPpoaALr/8RyhjXVQHQkPgGx/Q0ZwloAWX2zX6x/BNYp8W9QZRaLp9sIJQAAAABJRU5ErkJggg==", _k = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='WArface'%3e%3cg%20id='Vector'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M1.125%2023.9998L9.70245%2018.6666L6.17958%2019.1369V2.97999L1.125%206.83963e-06V23.9998Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M1.125%206.83963e-06L6.17958%202.97999V19.1369L9.70245%2018.6666L1.125%2023.9998V6.83963e-06Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M17.8202%202.97998V19.2939L14.2976%2018.6666L22.8748%2023.9998V0L17.8202%202.97998Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M22.8748%200L17.8202%202.97998V19.2939L14.2976%2018.6666L22.8748%2023.9998V0Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M9.39602%209.56841H14.4503V16.6273L12%2023.6861L9.39602%2016.6273V9.56841Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M9.39602%209.56841H14.4503V16.6273L12%2023.6861L9.39602%2016.6273V9.56841Z'%20fill='white'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e", xk = "data:image/png;base64,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", m0 = {
  wf: _k,
  aw: yk,
  wtl: xk,
  rv: bk
}, Lk = [{
  name: "Warface",
  url: "https://market.vkplay.ru/game/1/",
  icon: m0.wf
}, {
  name: "Armored Warfare",
  url: "https://market.vkplay.ru/shop/3/",
  icon: m0.aw
}, {
  name: "Will To Live Online",
  url: "https://market.vkplay.ru/shop/115/",
  icon: m0.wtl
}, {
  name: "Revelation",
  url: "https://market.vkplay.ru/game/5/",
  icon: m0.rv
}], Ek = {
  title: {
    id: "menu.popular_games",
    defaultMessage: "Популярные игры"
  }
}, Mk = "_popularGames_regtu_1", kk = "_title_regtu_5", Sk = "_game_regtu_18", Ak = "_icon_regtu_50", C0 = {
  popularGames: Mk,
  title: kk,
  game: Sk,
  icon: Ak
}, Tk = () => {
  const {
    formatMessage: e
  } = N1(), {
    pushReachGoal: t
  } = le(), n = (r) => {
    t({
      params: {
        category: "header",
        action: "click",
        label: "ph-menu-market",
        entity_id: r.currentTarget.href
      }
    });
  };
  return /* @__PURE__ */ f.jsxs("div", { className: C0.popularGames, children: [
    /* @__PURE__ */ f.jsx("div", { className: C0.title, children: e(Ek.title) }),
    Lk.map((r) => /* @__PURE__ */ f.jsxs("a", { href: r.url, className: C0.game, onClick: n, rel: "noreferrer", children: [
      /* @__PURE__ */ f.jsx("span", { className: C0.icon, children: /* @__PURE__ */ f.jsx("img", { src: r.icon, alt: r.name }) }),
      r.name
    ] }, r.url))
  ] });
}, Ik = "_sidebar_lgcik_9", Rk = "_scrollable_lgcik_45", Nk = "_showTopFade_lgcik_79", Hk = "_showBottomFade_lgcik_85", Ok = "_scrollableSub_lgcik_91", jk = "_visible_lgcik_101", Pk = "_fadeIn_lgcik_106", Dk = "_container_lgcik_130", Vk = "_menuWrapper_lgcik_135", Bk = "_logo_lgcik_152", Fk = "_navLinks_lgcik_164", Zk = "_icon_lgcik_179", Gk = "_arrow_lgcik_202", Wk = "_navItem_lgcik_207", Uk = "_navItemLink_lgcik_211", zk = "_hovered_lgcik_217", qk = "_current_lgcik_235", $k = "_navItemLinkMain_lgcik_243", Yk = "_navItemLinkSub_lgcik_247", Kk = "_navItemBtn_lgcik_285", Qk = "_label_lgcik_341", Xk = "_sidebarSubNav_lgcik_366", Jk = "_subNavTitle_lgcik_374", eS = "_containerMob_lgcik_388", tS = "_navLinksMob_lgcik_406", nS = "_itemMob_lgcik_420", rS = "_itemLinkMob_lgcik_424", aS = "_search_lgcik_463", iS = "_tooltip_lgcik_469", G1 = {
  sidebar: Ik,
  scrollable: Rk,
  showTopFade: Nk,
  showBottomFade: Hk,
  scrollableSub: Ok,
  visible: jk,
  fadeIn: Pk,
  container: Dk,
  menuWrapper: Vk,
  logo: Bk,
  navLinks: Fk,
  icon: Zk,
  arrow: Gk,
  navItem: Wk,
  navItemLink: Uk,
  hovered: zk,
  current: qk,
  navItemLinkMain: $k,
  navItemLinkSub: Yk,
  navItemBtn: Kk,
  label: Qk,
  sidebarSubNav: Xk,
  subNavTitle: Jk,
  containerMob: eS,
  navLinksMob: tS,
  itemMob: nS,
  itemLinkMob: rS,
  search: aS,
  tooltip: iS
}, oS = ({
  item: e,
  onClick: t
}) => {
  const n = x2(e.label);
  return /* @__PURE__ */ f.jsx("li", { className: G1.navItem, children: /* @__PURE__ */ f.jsx("a", { href: e.href, className: h1(G1.navItemLink, G1.navItemLinkSub), "data-id": e.id, onClick: t, children: /* @__PURE__ */ f.jsx("span", { className: G1.navItemBtn, children: n }) }) }, `${e.id}_${e.href}`);
};
var w6 = {}, y6 = {}, sa = { exports: {} }, Ar = { exports: {} };
(function() {
  var e, t, n, r, a, i;
  typeof performance != "undefined" && performance !== null && performance.now ? Ar.exports = function() {
    return performance.now();
  } : typeof process != "undefined" && process !== null && process.hrtime ? (Ar.exports = function() {
    return (e() - a) / 1e6;
  }, t = process.hrtime, e = function() {
    var l;
    return l = t(), l[0] * 1e9 + l[1];
  }, r = e(), i = process.uptime() * 1e9, a = r - i) : Date.now ? (Ar.exports = function() {
    return Date.now() - n;
  }, n = Date.now()) : (Ar.exports = function() {
    return (/* @__PURE__ */ new Date()).getTime() - n;
  }, n = (/* @__PURE__ */ new Date()).getTime());
}).call(n4);
var sS = Ar.exports, lS = sS, y2 = typeof window == "undefined" ? n4 : window, g0 = ["moz", "webkit"], Vn = "AnimationFrame", lr = y2["request" + Vn], jr = y2["cancel" + Vn] || y2["cancelRequest" + Vn];
for (var wr = 0; !lr && wr < g0.length; wr++)
  lr = y2[g0[wr] + "Request" + Vn], jr = y2[g0[wr] + "Cancel" + Vn] || y2[g0[wr] + "CancelRequest" + Vn];
if (!lr || !jr) {
  var ja = 0, f5 = 0, Q2 = [], cS = 1e3 / 60;
  lr = function(e) {
    if (Q2.length === 0) {
      var t = lS(), n = Math.max(0, cS - (t - ja));
      ja = n + t, setTimeout(function() {
        var r = Q2.slice(0);
        Q2.length = 0;
        for (var a = 0; a < r.length; a++)
          if (!r[a].cancelled)
            try {
              r[a].callback(ja);
            } catch (i) {
              setTimeout(function() {
                throw i;
              }, 0);
            }
      }, Math.round(n));
    }
    return Q2.push({
      handle: ++f5,
      callback: e,
      cancelled: !1
    }), f5;
  }, jr = function(e) {
    for (var t = 0; t < Q2.length; t++)
      Q2[t].handle === e && (Q2[t].cancelled = !0);
  };
}
sa.exports = function(e) {
  return lr.call(y2, e);
};
sa.exports.cancel = function() {
  jr.apply(y2, arguments);
};
sa.exports.polyfill = function(e) {
  e || (e = y2), e.requestAnimationFrame = lr, e.cancelAnimationFrame = jr;
};
var uS = sa.exports, la = { exports: {} }, Pa = null, h5 = ["Webkit", "Moz", "O", "ms"], dS = function(t) {
  Pa || (Pa = document.createElement("div"));
  var n = Pa.style;
  if (t in n)
    return t;
  for (var r = t.charAt(0).toUpperCase() + t.slice(1), a = h5.length; a >= 0; a--) {
    var i = h5[a] + r;
    if (i in n)
      return i;
  }
  return !1;
}, fS = CS, hS = /\s/, pS = /(_|-|\.|:)/, mS = /([a-z][A-Z]|[A-Z][a-z])/;
function CS(e) {
  return hS.test(e) ? e.toLowerCase() : pS.test(e) ? (vS(e) || e).toLowerCase() : mS.test(e) ? yS(e).toLowerCase() : e.toLowerCase();
}
var gS = /[\W_]+(.|$)/g;
function vS(e) {
  return e.replace(gS, function(t, n) {
    return n ? " " + n : "";
  });
}
var wS = /(.)([A-Z]+)/g;
function yS(e) {
  return e.replace(wS, function(t, n, r) {
    return n + " " + r.toLowerCase().split("").join(" ");
  });
}
var bS = fS, _S = xS;
function xS(e) {
  return bS(e).replace(/[\W_]+(.|$)/g, function(t, n) {
    return n ? " " + n : "";
  }).trim();
}
var LS = _S, ES = MS;
function MS(e) {
  return LS(e).replace(/\s(\w)/g, function(t, n) {
    return n.toUpperCase();
  });
}
var kS = {
  animationIterationCount: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridRow: !0,
  gridColumn: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  // SVG-related properties
  fillOpacity: !0,
  stopOpacity: !0,
  strokeDashoffset: !0,
  strokeOpacity: !0,
  strokeWidth: !0
}, SS = function(e, t) {
  return typeof t == "number" && !kS[e] ? t + "px" : t;
}, AS = dS, TS = ES, S0 = { float: "cssFloat" }, IS = SS;
function Z0(e, t, n) {
  var r = S0[t];
  if (typeof r == "undefined" && (r = NS(t)), r) {
    if (n === void 0)
      return e.style[r];
    e.style[r] = IS(r, n);
  }
}
function RS(e, t) {
  for (var n in t)
    t.hasOwnProperty(n) && Z0(e, n, t[n]);
}
function NS(e) {
  var t = TS(e), n = AS(t);
  return S0[t] = S0[e] = S0[n] = n, n;
}
function b6() {
  arguments.length === 2 ? typeof arguments[1] == "string" ? arguments[0].style.cssText = arguments[1] : RS(arguments[0], arguments[1]) : Z0(arguments[0], arguments[1], arguments[2]);
}
la.exports = b6;
la.exports.set = b6;
la.exports.get = function(e, t) {
  return Array.isArray(t) ? t.reduce(function(n, r) {
    return n[r] = Z0(e, r || ""), n;
  }, {}) : Z0(e, t || "");
};
var _6 = la.exports, qi = { exports: {} }, v0 = { exports: {} }, fe = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var p5;
function HS() {
  if (p5) return fe;
  p5 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, h = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, d = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, x = e ? Symbol.for("react.block") : 60121, k = e ? Symbol.for("react.fundamental") : 60117, I = e ? Symbol.for("react.responder") : 60118, T = e ? Symbol.for("react.scope") : 60119;
  function L(E) {
    if (typeof E == "object" && E !== null) {
      var j = E.$$typeof;
      switch (j) {
        case t:
          switch (E = E.type, E) {
            case c:
            case p:
            case r:
            case i:
            case a:
            case u:
              return E;
            default:
              switch (E = E && E.$$typeof, E) {
                case s:
                case h:
                case v:
                case d:
                case l:
                  return E;
                default:
                  return j;
              }
          }
        case n:
          return j;
      }
    }
  }
  function S(E) {
    return L(E) === p;
  }
  return fe.AsyncMode = c, fe.ConcurrentMode = p, fe.ContextConsumer = s, fe.ContextProvider = l, fe.Element = t, fe.ForwardRef = h, fe.Fragment = r, fe.Lazy = v, fe.Memo = d, fe.Portal = n, fe.Profiler = i, fe.StrictMode = a, fe.Suspense = u, fe.isAsyncMode = function(E) {
    return S(E) || L(E) === c;
  }, fe.isConcurrentMode = S, fe.isContextConsumer = function(E) {
    return L(E) === s;
  }, fe.isContextProvider = function(E) {
    return L(E) === l;
  }, fe.isElement = function(E) {
    return typeof E == "object" && E !== null && E.$$typeof === t;
  }, fe.isForwardRef = function(E) {
    return L(E) === h;
  }, fe.isFragment = function(E) {
    return L(E) === r;
  }, fe.isLazy = function(E) {
    return L(E) === v;
  }, fe.isMemo = function(E) {
    return L(E) === d;
  }, fe.isPortal = function(E) {
    return L(E) === n;
  }, fe.isProfiler = function(E) {
    return L(E) === i;
  }, fe.isStrictMode = function(E) {
    return L(E) === a;
  }, fe.isSuspense = function(E) {
    return L(E) === u;
  }, fe.isValidElementType = function(E) {
    return typeof E == "string" || typeof E == "function" || E === r || E === p || E === i || E === a || E === u || E === m || typeof E == "object" && E !== null && (E.$$typeof === v || E.$$typeof === d || E.$$typeof === l || E.$$typeof === s || E.$$typeof === h || E.$$typeof === k || E.$$typeof === I || E.$$typeof === T || E.$$typeof === x);
  }, fe.typeOf = L, fe;
}
var he = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var m5;
function OS() {
  return m5 || (m5 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, h = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, m = e ? Symbol.for("react.suspense_list") : 60120, d = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, x = e ? Symbol.for("react.block") : 60121, k = e ? Symbol.for("react.fundamental") : 60117, I = e ? Symbol.for("react.responder") : 60118, T = e ? Symbol.for("react.scope") : 60119;
    function L(Y) {
      return typeof Y == "string" || typeof Y == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Y === r || Y === p || Y === i || Y === a || Y === u || Y === m || typeof Y == "object" && Y !== null && (Y.$$typeof === v || Y.$$typeof === d || Y.$$typeof === l || Y.$$typeof === s || Y.$$typeof === h || Y.$$typeof === k || Y.$$typeof === I || Y.$$typeof === T || Y.$$typeof === x);
    }
    function S(Y) {
      if (typeof Y == "object" && Y !== null) {
        var P1 = Y.$$typeof;
        switch (P1) {
          case t:
            var J1 = Y.type;
            switch (J1) {
              case c:
              case p:
              case r:
              case i:
              case a:
              case u:
                return J1;
              default:
                var I1 = J1 && J1.$$typeof;
                switch (I1) {
                  case s:
                  case h:
                  case v:
                  case d:
                  case l:
                    return I1;
                  default:
                    return P1;
                }
            }
          case n:
            return P1;
        }
      }
    }
    var E = c, j = p, g = s, w = l, C = t, b = h, M = r, R = v, O = d, N = n, H = i, Z = a, z = u, K = !1;
    function D(Y) {
      return K || (K = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), W(Y) || S(Y) === c;
    }
    function W(Y) {
      return S(Y) === p;
    }
    function q(Y) {
      return S(Y) === s;
    }
    function e1(Y) {
      return S(Y) === l;
    }
    function o1(Y) {
      return typeof Y == "object" && Y !== null && Y.$$typeof === t;
    }
    function c1(Y) {
      return S(Y) === h;
    }
    function v1(Y) {
      return S(Y) === r;
    }
    function m1(Y) {
      return S(Y) === v;
    }
    function $(Y) {
      return S(Y) === d;
    }
    function n1(Y) {
      return S(Y) === n;
    }
    function d1(Y) {
      return S(Y) === i;
    }
    function f1(Y) {
      return S(Y) === a;
    }
    function M1(Y) {
      return S(Y) === u;
    }
    he.AsyncMode = E, he.ConcurrentMode = j, he.ContextConsumer = g, he.ContextProvider = w, he.Element = C, he.ForwardRef = b, he.Fragment = M, he.Lazy = R, he.Memo = O, he.Portal = N, he.Profiler = H, he.StrictMode = Z, he.Suspense = z, he.isAsyncMode = D, he.isConcurrentMode = W, he.isContextConsumer = q, he.isContextProvider = e1, he.isElement = o1, he.isForwardRef = c1, he.isFragment = v1, he.isLazy = m1, he.isMemo = $, he.isPortal = n1, he.isProfiler = d1, he.isStrictMode = f1, he.isSuspense = M1, he.isValidElementType = L, he.typeOf = S;
  }()), he;
}
var C5;
function x6() {
  return C5 || (C5 = 1, process.env.NODE_ENV === "production" ? v0.exports = HS() : v0.exports = OS()), v0.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Da, g5;
function jS() {
  if (g5) return Da;
  g5 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var l = {}, s = 0; s < 10; s++)
        l["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(l).map(function(h) {
        return l[h];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var p = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(h) {
        p[h] = h;
      }), Object.keys(Object.assign({}, p)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Da = a() ? Object.assign : function(i, l) {
    for (var s, c = r(i), p, h = 1; h < arguments.length; h++) {
      s = Object(arguments[h]);
      for (var u in s)
        t.call(s, u) && (c[u] = s[u]);
      if (e) {
        p = e(s);
        for (var m = 0; m < p.length; m++)
          n.call(s, p[m]) && (c[p[m]] = s[p[m]]);
      }
    }
    return c;
  }, Da;
}
var Va, v5;
function To() {
  if (v5) return Va;
  v5 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Va = e, Va;
}
var Ba, w5;
function L6() {
  return w5 || (w5 = 1, Ba = Function.call.bind(Object.prototype.hasOwnProperty)), Ba;
}
var Fa, y5;
function PS() {
  if (y5) return Fa;
  y5 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = To(), n = {}, r = L6();
    e = function(i) {
      var l = "Warning: " + i;
      typeof console != "undefined" && console.error(l);
      try {
        throw new Error(l);
      } catch {
      }
    };
  }
  function a(i, l, s, c, p) {
    if (process.env.NODE_ENV !== "production") {
      for (var h in i)
        if (r(i, h)) {
          var u;
          try {
            if (typeof i[h] != "function") {
              var m = Error(
                (c || "React class") + ": " + s + " type `" + h + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[h] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw m.name = "Invariant Violation", m;
            }
            u = i[h](l, h, c, s, null, t);
          } catch (v) {
            u = v;
          }
          if (u && !(u instanceof Error) && e(
            (c || "React class") + ": type specification of " + s + " `" + h + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), u instanceof Error && !(u.message in n)) {
            n[u.message] = !0;
            var d = p ? p() : "";
            e(
              "Failed " + s + " type: " + u.message + (d != null ? d : "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Fa = a, Fa;
}
var Za, b5;
function DS() {
  if (b5) return Za;
  b5 = 1;
  var e = x6(), t = jS(), n = To(), r = L6(), a = PS(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var c = "Warning: " + s;
    typeof console != "undefined" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function l() {
    return null;
  }
  return Za = function(s, c) {
    var p = typeof Symbol == "function" && Symbol.iterator, h = "@@iterator";
    function u(W) {
      var q = W && (p && W[p] || W[h]);
      if (typeof q == "function")
        return q;
    }
    var m = "<<anonymous>>", d = {
      array: I("array"),
      bigint: I("bigint"),
      bool: I("boolean"),
      func: I("function"),
      number: I("number"),
      object: I("object"),
      string: I("string"),
      symbol: I("symbol"),
      any: T(),
      arrayOf: L,
      element: S(),
      elementType: E(),
      instanceOf: j,
      node: b(),
      objectOf: w,
      oneOf: g,
      oneOfType: C,
      shape: R,
      exact: O
    };
    function v(W, q) {
      return W === q ? W !== 0 || 1 / W === 1 / q : W !== W && q !== q;
    }
    function x(W, q) {
      this.message = W, this.data = q && typeof q == "object" ? q : {}, this.stack = "";
    }
    x.prototype = Error.prototype;
    function k(W) {
      if (process.env.NODE_ENV !== "production")
        var q = {}, e1 = 0;
      function o1(v1, m1, $, n1, d1, f1, M1) {
        if (n1 = n1 || m, f1 = f1 || $, M1 !== n) {
          if (c) {
            var Y = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw Y.name = "Invariant Violation", Y;
          } else if (process.env.NODE_ENV !== "production" && typeof console != "undefined") {
            var P1 = n1 + ":" + $;
            !q[P1] && // Avoid spamming the console because they are often not actionable except for lib authors
            e1 < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + f1 + "` prop on `" + n1 + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), q[P1] = !0, e1++);
          }
        }
        return m1[$] == null ? v1 ? m1[$] === null ? new x("The " + d1 + " `" + f1 + "` is marked as required " + ("in `" + n1 + "`, but its value is `null`.")) : new x("The " + d1 + " `" + f1 + "` is marked as required in " + ("`" + n1 + "`, but its value is `undefined`.")) : null : W(m1, $, n1, d1, f1);
      }
      var c1 = o1.bind(null, !1);
      return c1.isRequired = o1.bind(null, !0), c1;
    }
    function I(W) {
      function q(e1, o1, c1, v1, m1, $) {
        var n1 = e1[o1], d1 = Z(n1);
        if (d1 !== W) {
          var f1 = z(n1);
          return new x(
            "Invalid " + v1 + " `" + m1 + "` of type " + ("`" + f1 + "` supplied to `" + c1 + "`, expected ") + ("`" + W + "`."),
            { expectedType: W }
          );
        }
        return null;
      }
      return k(q);
    }
    function T() {
      return k(l);
    }
    function L(W) {
      function q(e1, o1, c1, v1, m1) {
        if (typeof W != "function")
          return new x("Property `" + m1 + "` of component `" + c1 + "` has invalid PropType notation inside arrayOf.");
        var $ = e1[o1];
        if (!Array.isArray($)) {
          var n1 = Z($);
          return new x("Invalid " + v1 + " `" + m1 + "` of type " + ("`" + n1 + "` supplied to `" + c1 + "`, expected an array."));
        }
        for (var d1 = 0; d1 < $.length; d1++) {
          var f1 = W($, d1, c1, v1, m1 + "[" + d1 + "]", n);
          if (f1 instanceof Error)
            return f1;
        }
        return null;
      }
      return k(q);
    }
    function S() {
      function W(q, e1, o1, c1, v1) {
        var m1 = q[e1];
        if (!s(m1)) {
          var $ = Z(m1);
          return new x("Invalid " + c1 + " `" + v1 + "` of type " + ("`" + $ + "` supplied to `" + o1 + "`, expected a single ReactElement."));
        }
        return null;
      }
      return k(W);
    }
    function E() {
      function W(q, e1, o1, c1, v1) {
        var m1 = q[e1];
        if (!e.isValidElementType(m1)) {
          var $ = Z(m1);
          return new x("Invalid " + c1 + " `" + v1 + "` of type " + ("`" + $ + "` supplied to `" + o1 + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return k(W);
    }
    function j(W) {
      function q(e1, o1, c1, v1, m1) {
        if (!(e1[o1] instanceof W)) {
          var $ = W.name || m, n1 = D(e1[o1]);
          return new x("Invalid " + v1 + " `" + m1 + "` of type " + ("`" + n1 + "` supplied to `" + c1 + "`, expected ") + ("instance of `" + $ + "`."));
        }
        return null;
      }
      return k(q);
    }
    function g(W) {
      if (!Array.isArray(W))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), l;
      function q(e1, o1, c1, v1, m1) {
        for (var $ = e1[o1], n1 = 0; n1 < W.length; n1++)
          if (v($, W[n1]))
            return null;
        var d1 = JSON.stringify(W, function(M1, Y) {
          var P1 = z(Y);
          return P1 === "symbol" ? String(Y) : Y;
        });
        return new x("Invalid " + v1 + " `" + m1 + "` of value `" + String($) + "` " + ("supplied to `" + c1 + "`, expected one of " + d1 + "."));
      }
      return k(q);
    }
    function w(W) {
      function q(e1, o1, c1, v1, m1) {
        if (typeof W != "function")
          return new x("Property `" + m1 + "` of component `" + c1 + "` has invalid PropType notation inside objectOf.");
        var $ = e1[o1], n1 = Z($);
        if (n1 !== "object")
          return new x("Invalid " + v1 + " `" + m1 + "` of type " + ("`" + n1 + "` supplied to `" + c1 + "`, expected an object."));
        for (var d1 in $)
          if (r($, d1)) {
            var f1 = W($, d1, c1, v1, m1 + "." + d1, n);
            if (f1 instanceof Error)
              return f1;
          }
        return null;
      }
      return k(q);
    }
    function C(W) {
      if (!Array.isArray(W))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), l;
      for (var q = 0; q < W.length; q++) {
        var e1 = W[q];
        if (typeof e1 != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + K(e1) + " at index " + q + "."
          ), l;
      }
      function o1(c1, v1, m1, $, n1) {
        for (var d1 = [], f1 = 0; f1 < W.length; f1++) {
          var M1 = W[f1], Y = M1(c1, v1, m1, $, n1, n);
          if (Y == null)
            return null;
          Y.data && r(Y.data, "expectedType") && d1.push(Y.data.expectedType);
        }
        var P1 = d1.length > 0 ? ", expected one of type [" + d1.join(", ") + "]" : "";
        return new x("Invalid " + $ + " `" + n1 + "` supplied to " + ("`" + m1 + "`" + P1 + "."));
      }
      return k(o1);
    }
    function b() {
      function W(q, e1, o1, c1, v1) {
        return N(q[e1]) ? null : new x("Invalid " + c1 + " `" + v1 + "` supplied to " + ("`" + o1 + "`, expected a ReactNode."));
      }
      return k(W);
    }
    function M(W, q, e1, o1, c1) {
      return new x(
        (W || "React class") + ": " + q + " type `" + e1 + "." + o1 + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + c1 + "`."
      );
    }
    function R(W) {
      function q(e1, o1, c1, v1, m1) {
        var $ = e1[o1], n1 = Z($);
        if (n1 !== "object")
          return new x("Invalid " + v1 + " `" + m1 + "` of type `" + n1 + "` " + ("supplied to `" + c1 + "`, expected `object`."));
        for (var d1 in W) {
          var f1 = W[d1];
          if (typeof f1 != "function")
            return M(c1, v1, m1, d1, z(f1));
          var M1 = f1($, d1, c1, v1, m1 + "." + d1, n);
          if (M1)
            return M1;
        }
        return null;
      }
      return k(q);
    }
    function O(W) {
      function q(e1, o1, c1, v1, m1) {
        var $ = e1[o1], n1 = Z($);
        if (n1 !== "object")
          return new x("Invalid " + v1 + " `" + m1 + "` of type `" + n1 + "` " + ("supplied to `" + c1 + "`, expected `object`."));
        var d1 = t({}, e1[o1], W);
        for (var f1 in d1) {
          var M1 = W[f1];
          if (r(W, f1) && typeof M1 != "function")
            return M(c1, v1, m1, f1, z(M1));
          if (!M1)
            return new x(
              "Invalid " + v1 + " `" + m1 + "` key `" + f1 + "` supplied to `" + c1 + "`.\nBad object: " + JSON.stringify(e1[o1], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(W), null, "  ")
            );
          var Y = M1($, f1, c1, v1, m1 + "." + f1, n);
          if (Y)
            return Y;
        }
        return null;
      }
      return k(q);
    }
    function N(W) {
      switch (typeof W) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !W;
        case "object":
          if (Array.isArray(W))
            return W.every(N);
          if (W === null || s(W))
            return !0;
          var q = u(W);
          if (q) {
            var e1 = q.call(W), o1;
            if (q !== W.entries) {
              for (; !(o1 = e1.next()).done; )
                if (!N(o1.value))
                  return !1;
            } else
              for (; !(o1 = e1.next()).done; ) {
                var c1 = o1.value;
                if (c1 && !N(c1[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function H(W, q) {
      return W === "symbol" ? !0 : q ? q["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && q instanceof Symbol : !1;
    }
    function Z(W) {
      var q = typeof W;
      return Array.isArray(W) ? "array" : W instanceof RegExp ? "object" : H(q, W) ? "symbol" : q;
    }
    function z(W) {
      if (typeof W == "undefined" || W === null)
        return "" + W;
      var q = Z(W);
      if (q === "object") {
        if (W instanceof Date)
          return "date";
        if (W instanceof RegExp)
          return "regexp";
      }
      return q;
    }
    function K(W) {
      var q = z(W);
      switch (q) {
        case "array":
        case "object":
          return "an " + q;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + q;
        default:
          return q;
      }
    }
    function D(W) {
      return !W.constructor || !W.constructor.name ? m : W.constructor.name;
    }
    return d.checkPropTypes = a, d.resetWarningCache = a.resetWarningCache, d.PropTypes = d, d;
  }, Za;
}
var Ga, _5;
function VS() {
  if (_5) return Ga;
  _5 = 1;
  var e = To();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Ga = function() {
    function r(l, s, c, p, h, u) {
      if (u !== e) {
        var m = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw m.name = "Invariant Violation", m;
      }
    }
    r.isRequired = r;
    function a() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: a,
      element: r,
      elementType: r,
      instanceOf: a,
      node: r,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, Ga;
}
if (process.env.NODE_ENV !== "production") {
  var BS = x6(), FS = !0;
  qi.exports = DS()(BS.isElement, FS);
} else
  qi.exports = VS()();
var ZS = qi.exports, E6 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = t;
  function t(n) {
    return typeof n == "string";
  }
})(E6);
var M6 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = i;
  var t = _6, n = r(t);
  function r(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var a = !1;
  function i() {
    var l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
    if (l && a !== !1) return a;
    if (typeof document != "undefined") {
      var s = document.createElement("div");
      (0, n.default)(s, {
        width: 100,
        height: 100,
        position: "absolute",
        top: -9999,
        overflow: "scroll",
        MsOverflowStyle: "scrollbar"
      }), document.body.appendChild(s), a = s.offsetWidth - s.clientWidth, document.body.removeChild(s);
    } else
      a = 0;
    return a || 0;
  }
})(M6);
var k6 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = t;
  function t() {
    return !1;
  }
})(k6);
var S6 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = t;
  function t(n) {
    var r = n.clientWidth, a = getComputedStyle(n), i = a.paddingLeft, l = a.paddingRight;
    return r - parseFloat(i) - parseFloat(l);
  }
})(S6);
var A6 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = t;
  function t(n) {
    var r = n.clientHeight, a = getComputedStyle(n), i = a.paddingTop, l = a.paddingBottom;
    return r - parseFloat(i) - parseFloat(l);
  }
})(A6);
var _t = {};
Object.defineProperty(_t, "__esModule", {
  value: !0
});
_t.containerStyleDefault = {
  position: "relative",
  overflow: "hidden",
  width: "100%",
  height: "100%"
};
_t.containerStyleAutoHeight = {
  height: "auto"
};
_t.viewStyleDefault = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  overflow: "scroll",
  WebkitOverflowScrolling: "touch"
};
_t.viewStyleAutoHeight = {
  position: "relative",
  top: void 0,
  left: void 0,
  right: void 0,
  bottom: void 0
};
_t.viewStyleUniversalInitial = {
  overflow: "hidden",
  marginRight: 0,
  marginBottom: 0
};
_t.trackHorizontalStyleDefault = {
  position: "absolute",
  height: 6
};
_t.trackVerticalStyleDefault = {
  position: "absolute",
  width: 6
};
_t.thumbHorizontalStyleDefault = {
  position: "relative",
  display: "block",
  height: "100%"
};
_t.thumbVerticalStyleDefault = {
  position: "relative",
  display: "block",
  width: "100%"
};
_t.disableSelectStyle = {
  userSelect: "none"
};
_t.disableSelectStyleReset = {
  userSelect: ""
};
var Mn = {};
Object.defineProperty(Mn, "__esModule", {
  value: !0
});
var G2 = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
  }
  return e;
};
Mn.renderViewDefault = US;
Mn.renderTrackHorizontalDefault = zS;
Mn.renderTrackVerticalDefault = qS;
Mn.renderThumbHorizontalDefault = $S;
Mn.renderThumbVerticalDefault = YS;
var GS = l1, Xr = WS(GS);
function WS(e) {
  return e && e.__esModule ? e : { default: e };
}
function ca(e, t) {
  var n = {};
  for (var r in e)
    t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
  return n;
}
function US(e) {
  return Xr.default.createElement("div", e);
}
function zS(e) {
  var t = e.style, n = ca(e, ["style"]), r = G2({}, t, {
    right: 2,
    bottom: 2,
    left: 2,
    borderRadius: 3
  });
  return Xr.default.createElement("div", G2({ style: r }, n));
}
function qS(e) {
  var t = e.style, n = ca(e, ["style"]), r = G2({}, t, {
    right: 2,
    bottom: 2,
    top: 2,
    borderRadius: 3
  });
  return Xr.default.createElement("div", G2({ style: r }, n));
}
function $S(e) {
  var t = e.style, n = ca(e, ["style"]), r = G2({}, t, {
    cursor: "pointer",
    borderRadius: "inherit",
    backgroundColor: "rgba(0,0,0,.2)"
  });
  return Xr.default.createElement("div", G2({ style: r }, n));
}
function YS(e) {
  var t = e.style, n = ca(e, ["style"]), r = G2({}, t, {
    cursor: "pointer",
    borderRadius: "inherit",
    backgroundColor: "rgba(0,0,0,.2)"
  });
  return Xr.default.createElement("div", G2({ style: r }, n));
}
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var t = Object.assign || function(R) {
    for (var O = 1; O < arguments.length; O++) {
      var N = arguments[O];
      for (var H in N)
        Object.prototype.hasOwnProperty.call(N, H) && (R[H] = N[H]);
    }
    return R;
  }, n = /* @__PURE__ */ function() {
    function R(O, N) {
      for (var H = 0; H < N.length; H++) {
        var Z = N[H];
        Z.enumerable = Z.enumerable || !1, Z.configurable = !0, "value" in Z && (Z.writable = !0), Object.defineProperty(O, Z.key, Z);
      }
    }
    return function(O, N, H) {
      return N && R(O.prototype, N), H && R(O, H), O;
    };
  }(), r = uS, a = j(r), i = _6, l = j(i), s = l1, c = ZS, p = j(c), h = E6, u = j(h), m = M6, d = j(m), v = k6, x = j(v), k = S6, I = j(k), T = A6, L = j(T), S = _t, E = Mn;
  function j(R) {
    return R && R.__esModule ? R : { default: R };
  }
  function g(R, O) {
    var N = {};
    for (var H in R)
      O.indexOf(H) >= 0 || Object.prototype.hasOwnProperty.call(R, H) && (N[H] = R[H]);
    return N;
  }
  function w(R, O) {
    if (!(R instanceof O))
      throw new TypeError("Cannot call a class as a function");
  }
  function C(R, O) {
    if (!R)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return O && (typeof O == "object" || typeof O == "function") ? O : R;
  }
  function b(R, O) {
    if (typeof O != "function" && O !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof O);
    R.prototype = Object.create(O && O.prototype, { constructor: { value: R, enumerable: !1, writable: !0, configurable: !0 } }), O && (Object.setPrototypeOf ? Object.setPrototypeOf(R, O) : R.__proto__ = O);
  }
  var M = function(R) {
    b(O, R);
    function O(N) {
      var H;
      w(this, O);
      for (var Z = arguments.length, z = Array(Z > 1 ? Z - 1 : 0), K = 1; K < Z; K++)
        z[K - 1] = arguments[K];
      var D = C(this, (H = O.__proto__ || Object.getPrototypeOf(O)).call.apply(H, [this, N].concat(z)));
      return D.getScrollLeft = D.getScrollLeft.bind(D), D.getScrollTop = D.getScrollTop.bind(D), D.getScrollWidth = D.getScrollWidth.bind(D), D.getScrollHeight = D.getScrollHeight.bind(D), D.getClientWidth = D.getClientWidth.bind(D), D.getClientHeight = D.getClientHeight.bind(D), D.getValues = D.getValues.bind(D), D.getThumbHorizontalWidth = D.getThumbHorizontalWidth.bind(D), D.getThumbVerticalHeight = D.getThumbVerticalHeight.bind(D), D.getScrollLeftForOffset = D.getScrollLeftForOffset.bind(D), D.getScrollTopForOffset = D.getScrollTopForOffset.bind(D), D.scrollLeft = D.scrollLeft.bind(D), D.scrollTop = D.scrollTop.bind(D), D.scrollToLeft = D.scrollToLeft.bind(D), D.scrollToTop = D.scrollToTop.bind(D), D.scrollToRight = D.scrollToRight.bind(D), D.scrollToBottom = D.scrollToBottom.bind(D), D.handleTrackMouseEnter = D.handleTrackMouseEnter.bind(D), D.handleTrackMouseLeave = D.handleTrackMouseLeave.bind(D), D.handleHorizontalTrackMouseDown = D.handleHorizontalTrackMouseDown.bind(D), D.handleVerticalTrackMouseDown = D.handleVerticalTrackMouseDown.bind(D), D.handleHorizontalThumbMouseDown = D.handleHorizontalThumbMouseDown.bind(D), D.handleVerticalThumbMouseDown = D.handleVerticalThumbMouseDown.bind(D), D.handleWindowResize = D.handleWindowResize.bind(D), D.handleScroll = D.handleScroll.bind(D), D.handleDrag = D.handleDrag.bind(D), D.handleDragEnd = D.handleDragEnd.bind(D), D.state = {
        didMountUniversal: !1
      }, D;
    }
    return n(O, [{
      key: "componentDidMount",
      value: function() {
        this.addListeners(), this.update(), this.componentDidMountUniversal();
      }
    }, {
      key: "componentDidMountUniversal",
      value: function() {
        var H = this.props.universal;
        H && this.setState({ didMountUniversal: !0 });
      }
    }, {
      key: "componentDidUpdate",
      value: function() {
        this.update();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.removeListeners(), (0, r.cancel)(this.requestFrame), clearTimeout(this.hideTracksTimeout), clearInterval(this.detectScrollingInterval);
      }
    }, {
      key: "getScrollLeft",
      value: function() {
        return this.view ? this.view.scrollLeft : 0;
      }
    }, {
      key: "getScrollTop",
      value: function() {
        return this.view ? this.view.scrollTop : 0;
      }
    }, {
      key: "getScrollWidth",
      value: function() {
        return this.view ? this.view.scrollWidth : 0;
      }
    }, {
      key: "getScrollHeight",
      value: function() {
        return this.view ? this.view.scrollHeight : 0;
      }
    }, {
      key: "getClientWidth",
      value: function() {
        return this.view ? this.view.clientWidth : 0;
      }
    }, {
      key: "getClientHeight",
      value: function() {
        return this.view ? this.view.clientHeight : 0;
      }
    }, {
      key: "getValues",
      value: function() {
        var H = this.view || {}, Z = H.scrollLeft, z = Z === void 0 ? 0 : Z, K = H.scrollTop, D = K === void 0 ? 0 : K, W = H.scrollWidth, q = W === void 0 ? 0 : W, e1 = H.scrollHeight, o1 = e1 === void 0 ? 0 : e1, c1 = H.clientWidth, v1 = c1 === void 0 ? 0 : c1, m1 = H.clientHeight, $ = m1 === void 0 ? 0 : m1;
        return {
          left: z / (q - v1) || 0,
          top: D / (o1 - $) || 0,
          scrollLeft: z,
          scrollTop: D,
          scrollWidth: q,
          scrollHeight: o1,
          clientWidth: v1,
          clientHeight: $
        };
      }
    }, {
      key: "getThumbHorizontalWidth",
      value: function() {
        var H = this.props, Z = H.thumbSize, z = H.thumbMinSize, K = this.view, D = K.scrollWidth, W = K.clientWidth, q = (0, I.default)(this.trackHorizontal), e1 = Math.ceil(W / D * q);
        return q <= e1 ? 0 : Z || Math.max(e1, z);
      }
    }, {
      key: "getThumbVerticalHeight",
      value: function() {
        var H = this.props, Z = H.thumbSize, z = H.thumbMinSize, K = this.view, D = K.scrollHeight, W = K.clientHeight, q = (0, L.default)(this.trackVertical), e1 = Math.ceil(W / D * q);
        return q <= e1 ? 0 : Z || Math.max(e1, z);
      }
    }, {
      key: "getScrollLeftForOffset",
      value: function(H) {
        var Z = this.view, z = Z.scrollWidth, K = Z.clientWidth, D = (0, I.default)(this.trackHorizontal), W = this.getThumbHorizontalWidth();
        return H / (D - W) * (z - K);
      }
    }, {
      key: "getScrollTopForOffset",
      value: function(H) {
        var Z = this.view, z = Z.scrollHeight, K = Z.clientHeight, D = (0, L.default)(this.trackVertical), W = this.getThumbVerticalHeight();
        return H / (D - W) * (z - K);
      }
    }, {
      key: "scrollLeft",
      value: function() {
        var H = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        this.view && (this.view.scrollLeft = H);
      }
    }, {
      key: "scrollTop",
      value: function() {
        var H = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        this.view && (this.view.scrollTop = H);
      }
    }, {
      key: "scrollToLeft",
      value: function() {
        this.view && (this.view.scrollLeft = 0);
      }
    }, {
      key: "scrollToTop",
      value: function() {
        this.view && (this.view.scrollTop = 0);
      }
    }, {
      key: "scrollToRight",
      value: function() {
        this.view && (this.view.scrollLeft = this.view.scrollWidth);
      }
    }, {
      key: "scrollToBottom",
      value: function() {
        this.view && (this.view.scrollTop = this.view.scrollHeight);
      }
    }, {
      key: "addListeners",
      value: function() {
        if (!(typeof document == "undefined" || !this.view)) {
          var H = this.view, Z = this.trackHorizontal, z = this.trackVertical, K = this.thumbHorizontal, D = this.thumbVertical;
          H.addEventListener("scroll", this.handleScroll), (0, d.default)() && (Z.addEventListener("mouseenter", this.handleTrackMouseEnter), Z.addEventListener("mouseleave", this.handleTrackMouseLeave), Z.addEventListener("mousedown", this.handleHorizontalTrackMouseDown), z.addEventListener("mouseenter", this.handleTrackMouseEnter), z.addEventListener("mouseleave", this.handleTrackMouseLeave), z.addEventListener("mousedown", this.handleVerticalTrackMouseDown), K.addEventListener("mousedown", this.handleHorizontalThumbMouseDown), D.addEventListener("mousedown", this.handleVerticalThumbMouseDown), window.addEventListener("resize", this.handleWindowResize));
        }
      }
    }, {
      key: "removeListeners",
      value: function() {
        if (!(typeof document == "undefined" || !this.view)) {
          var H = this.view, Z = this.trackHorizontal, z = this.trackVertical, K = this.thumbHorizontal, D = this.thumbVertical;
          H.removeEventListener("scroll", this.handleScroll), (0, d.default)() && (Z.removeEventListener("mouseenter", this.handleTrackMouseEnter), Z.removeEventListener("mouseleave", this.handleTrackMouseLeave), Z.removeEventListener("mousedown", this.handleHorizontalTrackMouseDown), z.removeEventListener("mouseenter", this.handleTrackMouseEnter), z.removeEventListener("mouseleave", this.handleTrackMouseLeave), z.removeEventListener("mousedown", this.handleVerticalTrackMouseDown), K.removeEventListener("mousedown", this.handleHorizontalThumbMouseDown), D.removeEventListener("mousedown", this.handleVerticalThumbMouseDown), window.removeEventListener("resize", this.handleWindowResize), this.teardownDragging());
        }
      }
    }, {
      key: "handleScroll",
      value: function(H) {
        var Z = this, z = this.props, K = z.onScroll, D = z.onScrollFrame;
        K && K(H), this.update(function(W) {
          var q = W.scrollLeft, e1 = W.scrollTop;
          Z.viewScrollLeft = q, Z.viewScrollTop = e1, D && D(W);
        }), this.detectScrolling();
      }
    }, {
      key: "handleScrollStart",
      value: function() {
        var H = this.props.onScrollStart;
        H && H(), this.handleScrollStartAutoHide();
      }
    }, {
      key: "handleScrollStartAutoHide",
      value: function() {
        var H = this.props.autoHide;
        H && this.showTracks();
      }
    }, {
      key: "handleScrollStop",
      value: function() {
        var H = this.props.onScrollStop;
        H && H(), this.handleScrollStopAutoHide();
      }
    }, {
      key: "handleScrollStopAutoHide",
      value: function() {
        var H = this.props.autoHide;
        H && this.hideTracks();
      }
    }, {
      key: "handleWindowResize",
      value: function() {
        (0, d.default)(!1), this.forceUpdate();
      }
    }, {
      key: "handleHorizontalTrackMouseDown",
      value: function(H) {
        H.preventDefault();
        var Z = H.target, z = H.clientX, K = Z.getBoundingClientRect(), D = K.left, W = this.getThumbHorizontalWidth(), q = Math.abs(D - z) - W / 2;
        this.view.scrollLeft = this.getScrollLeftForOffset(q);
      }
    }, {
      key: "handleVerticalTrackMouseDown",
      value: function(H) {
        H.preventDefault();
        var Z = H.target, z = H.clientY, K = Z.getBoundingClientRect(), D = K.top, W = this.getThumbVerticalHeight(), q = Math.abs(D - z) - W / 2;
        this.view.scrollTop = this.getScrollTopForOffset(q);
      }
    }, {
      key: "handleHorizontalThumbMouseDown",
      value: function(H) {
        H.preventDefault(), this.handleDragStart(H);
        var Z = H.target, z = H.clientX, K = Z.offsetWidth, D = Z.getBoundingClientRect(), W = D.left;
        this.prevPageX = K - (z - W);
      }
    }, {
      key: "handleVerticalThumbMouseDown",
      value: function(H) {
        H.preventDefault(), this.handleDragStart(H);
        var Z = H.target, z = H.clientY, K = Z.offsetHeight, D = Z.getBoundingClientRect(), W = D.top;
        this.prevPageY = K - (z - W);
      }
    }, {
      key: "setupDragging",
      value: function() {
        (0, l.default)(document.body, S.disableSelectStyle), document.addEventListener("mousemove", this.handleDrag), document.addEventListener("mouseup", this.handleDragEnd), document.onselectstart = x.default;
      }
    }, {
      key: "teardownDragging",
      value: function() {
        (0, l.default)(document.body, S.disableSelectStyleReset), document.removeEventListener("mousemove", this.handleDrag), document.removeEventListener("mouseup", this.handleDragEnd), document.onselectstart = void 0;
      }
    }, {
      key: "handleDragStart",
      value: function(H) {
        this.dragging = !0, H.stopImmediatePropagation(), this.setupDragging();
      }
    }, {
      key: "handleDrag",
      value: function(H) {
        if (this.prevPageX) {
          var Z = H.clientX, z = this.trackHorizontal.getBoundingClientRect(), K = z.left, D = this.getThumbHorizontalWidth(), W = D - this.prevPageX, q = -K + Z - W;
          this.view.scrollLeft = this.getScrollLeftForOffset(q);
        }
        if (this.prevPageY) {
          var e1 = H.clientY, o1 = this.trackVertical.getBoundingClientRect(), c1 = o1.top, v1 = this.getThumbVerticalHeight(), m1 = v1 - this.prevPageY, $ = -c1 + e1 - m1;
          this.view.scrollTop = this.getScrollTopForOffset($);
        }
        return !1;
      }
    }, {
      key: "handleDragEnd",
      value: function() {
        this.dragging = !1, this.prevPageX = this.prevPageY = 0, this.teardownDragging(), this.handleDragEndAutoHide();
      }
    }, {
      key: "handleDragEndAutoHide",
      value: function() {
        var H = this.props.autoHide;
        H && this.hideTracks();
      }
    }, {
      key: "handleTrackMouseEnter",
      value: function() {
        this.trackMouseOver = !0, this.handleTrackMouseEnterAutoHide();
      }
    }, {
      key: "handleTrackMouseEnterAutoHide",
      value: function() {
        var H = this.props.autoHide;
        H && this.showTracks();
      }
    }, {
      key: "handleTrackMouseLeave",
      value: function() {
        this.trackMouseOver = !1, this.handleTrackMouseLeaveAutoHide();
      }
    }, {
      key: "handleTrackMouseLeaveAutoHide",
      value: function() {
        var H = this.props.autoHide;
        H && this.hideTracks();
      }
    }, {
      key: "showTracks",
      value: function() {
        clearTimeout(this.hideTracksTimeout), (0, l.default)(this.trackHorizontal, { opacity: 1 }), (0, l.default)(this.trackVertical, { opacity: 1 });
      }
    }, {
      key: "hideTracks",
      value: function() {
        var H = this;
        if (!this.dragging && !this.scrolling && !this.trackMouseOver) {
          var Z = this.props.autoHideTimeout;
          clearTimeout(this.hideTracksTimeout), this.hideTracksTimeout = setTimeout(function() {
            (0, l.default)(H.trackHorizontal, { opacity: 0 }), (0, l.default)(H.trackVertical, { opacity: 0 });
          }, Z);
        }
      }
    }, {
      key: "detectScrolling",
      value: function() {
        var H = this;
        this.scrolling || (this.scrolling = !0, this.handleScrollStart(), this.detectScrollingInterval = setInterval(function() {
          H.lastViewScrollLeft === H.viewScrollLeft && H.lastViewScrollTop === H.viewScrollTop && (clearInterval(H.detectScrollingInterval), H.scrolling = !1, H.handleScrollStop()), H.lastViewScrollLeft = H.viewScrollLeft, H.lastViewScrollTop = H.viewScrollTop;
        }, 100));
      }
    }, {
      key: "raf",
      value: function(H) {
        var Z = this;
        this.requestFrame && a.default.cancel(this.requestFrame), this.requestFrame = (0, a.default)(function() {
          Z.requestFrame = void 0, H();
        });
      }
    }, {
      key: "update",
      value: function(H) {
        var Z = this;
        this.raf(function() {
          return Z._update(H);
        });
      }
    }, {
      key: "_update",
      value: function(H) {
        var Z = this.props, z = Z.onUpdate, K = Z.hideTracksWhenNotNeeded, D = this.getValues();
        if ((0, d.default)()) {
          var W = D.scrollLeft, q = D.clientWidth, e1 = D.scrollWidth, o1 = (0, I.default)(this.trackHorizontal), c1 = this.getThumbHorizontalWidth(), v1 = W / (e1 - q) * (o1 - c1), m1 = {
            width: c1,
            transform: "translateX(" + v1 + "px)"
          }, $ = D.scrollTop, n1 = D.clientHeight, d1 = D.scrollHeight, f1 = (0, L.default)(this.trackVertical), M1 = this.getThumbVerticalHeight(), Y = $ / (d1 - n1) * (f1 - M1), P1 = {
            height: M1,
            transform: "translateY(" + Y + "px)"
          };
          if (K) {
            var J1 = {
              visibility: e1 > q ? "visible" : "hidden"
            }, I1 = {
              visibility: d1 > n1 ? "visible" : "hidden"
            };
            (0, l.default)(this.trackHorizontal, J1), (0, l.default)(this.trackVertical, I1);
          }
          (0, l.default)(this.thumbHorizontal, m1), (0, l.default)(this.thumbVertical, P1);
        }
        z && z(D), typeof H == "function" && H(D);
      }
    }, {
      key: "render",
      value: function() {
        var H = this, Z = (0, d.default)(), z = this.props;
        z.onScroll, z.onScrollFrame, z.onScrollStart, z.onScrollStop, z.onUpdate;
        var K = z.renderView, D = z.renderTrackHorizontal, W = z.renderTrackVertical, q = z.renderThumbHorizontal, e1 = z.renderThumbVertical, o1 = z.tagName;
        z.hideTracksWhenNotNeeded;
        var c1 = z.autoHide;
        z.autoHideTimeout;
        var v1 = z.autoHideDuration;
        z.thumbSize, z.thumbMinSize;
        var m1 = z.universal, $ = z.autoHeight, n1 = z.autoHeightMin, d1 = z.autoHeightMax, f1 = z.style, M1 = z.children, Y = g(z, ["onScroll", "onScrollFrame", "onScrollStart", "onScrollStop", "onUpdate", "renderView", "renderTrackHorizontal", "renderTrackVertical", "renderThumbHorizontal", "renderThumbVertical", "tagName", "hideTracksWhenNotNeeded", "autoHide", "autoHideTimeout", "autoHideDuration", "thumbSize", "thumbMinSize", "universal", "autoHeight", "autoHeightMin", "autoHeightMax", "style", "children"]), P1 = this.state.didMountUniversal, J1 = t({}, S.containerStyleDefault, $ && t({}, S.containerStyleAutoHeight, {
          minHeight: n1,
          maxHeight: d1
        }), f1), I1 = t({}, S.viewStyleDefault, {
          // Hide scrollbars by setting a negative margin
          marginRight: Z ? -Z : 0,
          marginBottom: Z ? -Z : 0
        }, $ && t({}, S.viewStyleAutoHeight, {
          // Add scrollbarWidth to autoHeight in order to compensate negative margins
          minHeight: (0, u.default)(n1) ? "calc(" + n1 + " + " + Z + "px)" : n1 + Z,
          maxHeight: (0, u.default)(d1) ? "calc(" + d1 + " + " + Z + "px)" : d1 + Z
        }), $ && m1 && !P1 && {
          minHeight: n1,
          maxHeight: d1
        }, m1 && !P1 && S.viewStyleUniversalInitial), ce = {
          transition: "opacity " + v1 + "ms",
          opacity: 0
        }, ve = t({}, S.trackHorizontalStyleDefault, c1 && ce, (!Z || m1 && !P1) && {
          display: "none"
        }), oe = t({}, S.trackVerticalStyleDefault, c1 && ce, (!Z || m1 && !P1) && {
          display: "none"
        });
        return (0, s.createElement)(o1, t({}, Y, { style: J1, ref: function(ae) {
          H.container = ae;
        } }), [(0, s.cloneElement)(K({ style: I1 }), { key: "view", ref: function(ae) {
          H.view = ae;
        } }, M1), (0, s.cloneElement)(D({ style: ve }), { key: "trackHorizontal", ref: function(ae) {
          H.trackHorizontal = ae;
        } }, (0, s.cloneElement)(q({ style: S.thumbHorizontalStyleDefault }), { ref: function(ae) {
          H.thumbHorizontal = ae;
        } })), (0, s.cloneElement)(W({ style: oe }), { key: "trackVertical", ref: function(ae) {
          H.trackVertical = ae;
        } }, (0, s.cloneElement)(e1({ style: S.thumbVerticalStyleDefault }), { ref: function(ae) {
          H.thumbVertical = ae;
        } }))]);
      }
    }]), O;
  }(s.Component);
  e.default = M, M.propTypes = {
    onScroll: p.default.func,
    onScrollFrame: p.default.func,
    onScrollStart: p.default.func,
    onScrollStop: p.default.func,
    onUpdate: p.default.func,
    renderView: p.default.func,
    renderTrackHorizontal: p.default.func,
    renderTrackVertical: p.default.func,
    renderThumbHorizontal: p.default.func,
    renderThumbVertical: p.default.func,
    tagName: p.default.string,
    thumbSize: p.default.number,
    thumbMinSize: p.default.number,
    hideTracksWhenNotNeeded: p.default.bool,
    autoHide: p.default.bool,
    autoHideTimeout: p.default.number,
    autoHideDuration: p.default.number,
    autoHeight: p.default.bool,
    autoHeightMin: p.default.oneOfType([p.default.number, p.default.string]),
    autoHeightMax: p.default.oneOfType([p.default.number, p.default.string]),
    universal: p.default.bool,
    style: p.default.object,
    children: p.default.node
  }, M.defaultProps = {
    renderView: E.renderViewDefault,
    renderTrackHorizontal: E.renderTrackHorizontalDefault,
    renderTrackVertical: E.renderTrackVerticalDefault,
    renderThumbHorizontal: E.renderThumbHorizontalDefault,
    renderThumbVertical: E.renderThumbVerticalDefault,
    tagName: "div",
    thumbMinSize: 30,
    hideTracksWhenNotNeeded: !1,
    autoHide: !1,
    autoHideTimeout: 1e3,
    autoHideDuration: 200,
    autoHeight: !1,
    autoHeightMin: 0,
    autoHeightMax: 200,
    universal: !1
  };
})(y6);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.Scrollbars = void 0;
  var t = y6, n = r(t);
  function r(a) {
    return a && a.__esModule ? a : { default: a };
  }
  e.default = n.default, e.Scrollbars = n.default;
})(w6);
const KS = "_thumb_iz0ne_1", QS = "_vertical_iz0ne_15", XS = "_horizontal_iz0ne_19", JS = "_track_iz0ne_24", eA = "_view_iz0ne_31", tA = "_disabled_iz0ne_40", nA = "_scrollable_iz0ne_57", it = {
  thumb: KS,
  vertical: QS,
  horizontal: XS,
  track: JS,
  view: eA,
  disabled: tA,
  scrollable: nA
}, Io = (e) => {
  const {
    disableHorizontal: t,
    onUpdate: n,
    viewClassName: r,
    isDisabled: a,
    children: i,
    ...l
  } = e, [s, c] = r1(!1), [p, h] = r1(!1), [u, m] = r1(!1), d = (v) => {
    typeof n == "function" && n(v), h(v.scrollWidth > v.clientWidth), m(v.scrollHeight > v.clientHeight);
  };
  return u1(() => {
    c(u || p);
  }, [p, u]), a ? i : /* @__PURE__ */ f.jsx(
    w6.Scrollbars,
    {
      renderTrackVertical: (v) => /* @__PURE__ */ f.jsx("div", { ...v, className: h1(it.track, it.vertical) }),
      renderThumbVertical: (v) => /* @__PURE__ */ f.jsx("div", { ...v, className: h1(it.thumb, it.vertical) }),
      renderThumbHorizontal: (v) => /* @__PURE__ */ f.jsx("div", { ...v, className: h1(it.thumb, it.horizontal, {
        [it.disabled]: t
      }) }),
      renderTrackHorizontal: (v) => /* @__PURE__ */ f.jsx("div", { ...v, className: h1(it.track, it.horizontal, {
        [it.disabled]: t
      }) }),
      renderView: (v) => /* @__PURE__ */ f.jsx("div", { ...v, className: h1(it.view, r, {
        [it.scrollable]: s,
        [it.vertical]: u,
        [it.horizontal]: p,
        [it.disabled]: t
      }) }),
      onUpdate: d,
      ...l,
      children: i
    }
  );
}, rA = ({
  item: e,
  offsetLeft: t = 0,
  updateOffset: n
}) => {
  const {
    pushReachGoal: r
  } = le(), {
    tabletLgMax: a,
    tabletLgMin: i
  } = Ue(["tabletLgMax", "tabletLgMin"]), {
    onSidenavClick: l,
    preset: s
  } = D1(rt), c = x2(e.label), p = V1(null), h = V1(null), u = (x) => {
    const {
      id: k
    } = x.currentTarget.dataset;
    r({
      params: {
        category: "header",
        action: "click",
        label: e.analyticsLabel,
        entity_id: x.currentTarget.href
      }
    }), l && k && l(x, k);
  };
  let m;
  const d = () => {
    n(), clearTimeout(m);
    const x = p.current, k = h.current;
    x != null && x.classList.contains(G1.hovered) || x == null || x.classList.add(G1.hovered), k != null && k.classList.contains(G1.fadeIn) || k == null || k.classList.add(G1.fadeIn), k != null && k.classList.contains(G1.visible) || k == null || k.classList.add(G1.visible);
  }, v = () => {
    var x, k;
    clearTimeout(m), (x = p.current) == null || x.classList.remove(G1.hovered), (k = h.current) == null || k.classList.remove(G1.fadeIn), m = setTimeout(() => {
      var I;
      (I = h.current) == null || I.classList.remove(G1.visible);
    }, 300);
  };
  return /* @__PURE__ */ f.jsxs("li", { className: G1.navItem, children: [
    /* @__PURE__ */ f.jsxs("a", { href: e.href, className: h1(G1.navItemLink, G1.navItemLinkMain, {
      [G1.current]: s === e.id
    }), onMouseEnter: d, onMouseLeave: v, "data-id": e.id, onClick: u, ref: p, "data-tooltip-id": `sidebar-item-tooltip-${e.id}`, "data-tooltip-position-strategy": "fixed", children: [
      /* @__PURE__ */ f.jsxs("span", { className: G1.navItemBtn, children: [
        e.icon && /* @__PURE__ */ f.jsx("span", { className: G1.icon, children: /* @__PURE__ */ f.jsx(b1, { name: e.icon }) }),
        /* @__PURE__ */ f.jsx("span", { className: G1.label, children: c }),
        !!e.subnav.length && /* @__PURE__ */ f.jsx("span", { className: h1(G1.icon, G1.arrow), children: /* @__PURE__ */ f.jsx(b1, { name: "chevron-right" }) })
      ] }),
      a && /* @__PURE__ */ f.jsx(kt, { id: `sidebar-item-tooltip-${e.id}`, content: c, className: G1.tooltip, place: "right", delayShow: 500 })
    ] }),
    !!e.subnav.length && i && /* @__PURE__ */ f.jsx(Z2, { id: e.id, into: "#vkp-navbar", children: /* @__PURE__ */ f.jsx("div", { className: h1(G1.scrollable, G1.scrollableSub), style: {
      transform: `translateX(${t}px)`
    }, onMouseEnter: d, onMouseLeave: v, ref: h, children: /* @__PURE__ */ f.jsx(Io, { disableHorizontal: !0, children: /* @__PURE__ */ f.jsx("div", { className: h1(G1.sidebarSubNav), children: /* @__PURE__ */ f.jsxs("div", { className: G1.menuWrapper, children: [
      /* @__PURE__ */ f.jsx("div", { className: G1.subNavTitle, children: c }),
      /* @__PURE__ */ f.jsx("ul", { className: G1.navLinks, children: e.subnav.map((x) => /* @__PURE__ */ f.jsx(oS, { item: x, onClick: u }, x.id)) }),
      e.id === "market" && /* @__PURE__ */ f.jsx(Tk, {})
    ] }) }) }) }) })
  ] });
}, aA = ({
  item: e,
  onClick: t,
  openMobOverlay: n
}) => {
  const {
    pushReachGoal: r
  } = le(), {
    onSidenavClick: a,
    preset: i
  } = D1(rt), l = e.href ? "a" : "button", s = x2(e.label), h = `${window.location.origin}${window.location.pathname}` === me.main ? "main" : i, u = n ? "more" : h, m = () => {
    e.analyticsLabel && r({
      params: {
        category: "header",
        action: "click",
        label: e.analyticsLabel
      }
    });
  }, d = (v) => {
    const {
      id: x
    } = v.currentTarget.dataset;
    m(), t == null || t(), a && x && a(v, x);
  };
  return /* @__PURE__ */ f.jsx("li", { className: G1.itemMob, children: /* @__PURE__ */ f.jsxs(l, { className: h1(G1.itemLinkMob, {
    [G1.current]: u === e.id
  }), ...e.href && {
    href: e.href
  }, onClick: d, "data-id": e.id, children: [
    e.icon && /* @__PURE__ */ f.jsx("span", { className: G1.icon, children: /* @__PURE__ */ f.jsx(b1, { name: e.icon }) }),
    s
  ] }) });
};
var e2 = /* @__PURE__ */ ((e) => (e.WIDE = "wide", e.NARROW = "narrow", e))(e2 || {}), nn = /* @__PURE__ */ ((e) => (e.Notifications = "notifications", e.Search = "search", e.Favorites = "favorites", e.User = "user", e.RecPopup = "recPopup", e.Terms = "terms", e))(nn || {});
const Tr = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), x5 = {
  collapse: {
    id: "app.sidebar.collapse",
    defaultMessage: "Свернуть"
  },
  expand: {
    id: "app.sidebar.expand",
    defaultMessage: "Развернуть"
  },
  tooltipText: {
    id: "app.sidebar.tooltipText",
    defaultMessage: "Развернуть меню"
  }
}, iA = "_button_1d2dz_1", oA = "_label_1d2dz_15", sA = "_arrow_1d2dz_15", lA = "_tooltip_1d2dz_60", In = {
  button: iA,
  label: oA,
  arrow: sA,
  tooltip: lA
}, cA = () => {
  const {
    formatMessage: e
  } = N1(), {
    tabletLgMax: t
  } = Ue(["tabletLgMax"]), {
    sidebarState: n,
    setState: r
  } = Ao(), {
    pushReachGoal: a
  } = le(), i = n === e2.NARROW, l = "sidebarPersist", s = "sidebarNarrow", c = "sidebarWide";
  u1(() => {
    const {
      body: u
    } = document;
    i && u.classList.add(l);
    const m = setTimeout(() => {
      Tr || u.classList.remove(l);
    }, 10);
    return Tr && u.classList.add(l), () => {
      Tr || u.classList.remove(l), clearTimeout(m);
    };
  }, []), u1(() => {
    const {
      body: u
    } = document;
    return i ? (u.classList.add(s), u.classList.remove(c)) : (u.classList.add(c), u.classList.remove(s)), () => {
      Tr ? u.classList.remove(s, c) : u.classList.remove(s, c, l);
    };
  }, [n]);
  const {
    buttonClassName: p
  } = Xe(() => ({
    buttonClassName: n === e2.NARROW ? In.narrow : In.wide
  }), [n]), h = () => {
    const u = n === e2.NARROW ? e2.WIDE : e2.NARROW, m = u === e2.NARROW ? "collapse" : "expand";
    a({
      params: {
        category: "header",
        action: "click",
        label: m
      }
    }), r(u);
  };
  return t || J.inGamecenter ? null : /* @__PURE__ */ f.jsxs("button", { className: h1(In.button, p), type: "button", onClick: h, "data-tooltip-id": "sidebar-toogle-tooltip", "data-tooltip-position-strategy": "fixed", children: [
    /* @__PURE__ */ f.jsx(b1, { className: In.arrow, name: "arrow-left-double" }),
    /* @__PURE__ */ f.jsx("span", { className: In.label, children: e(x5.collapse) }),
    /* @__PURE__ */ f.jsx(kt, { id: "sidebar-toogle-tooltip", className: In.tooltip, content: e(x5.tooltipText), place: "right", delayShow: 500, style: {
      marginLeft: "16px"
    } })
  ] });
}, L5 = {
  btnName: {
    id: "steam.refill",
    defaultMessage: "Пополнить Steam"
  },
  btnTooltip: {
    id: "steam.refill_wallet",
    defaultMessage: "Пополнить кошелек Steam"
  }
}, uA = "_steamLink_1hp2q_1", dA = "_labelCollapsed_1hp2q_7", fA = "_steamBtn_1hp2q_10", hA = "_icon_1hp2q_97", w0 = {
  steamLink: uA,
  labelCollapsed: dA,
  steamBtn: fA,
  icon: hA
}, pA = () => {
  const {
    onSidenavClick: e
  } = D1(rt), {
    pushReachGoal: t
  } = le(), {
    tabletMdMax: n,
    tabletLgMax: r
  } = Ue(["tabletMdMax", "tabletLgMax"]), {
    formatMessage: a
  } = N1(), {
    sidebarState: i
  } = Ao(), l = (s) => {
    e && $r && (J.triggerPixel(`https://trk.mail.ru/c/${Ms}`), e(s, "payment_steam")), t({
      params: {
        category: "steam_wallet",
        action: "steam_wallet_click"
      }
    });
  };
  return u1(() => {
    t({
      params: {
        category: "steam_wallet",
        action: "steam_wallet_show"
      }
    }), Ss && (window.location.pathname.includes("/services/payment_steam") ? jb() : window.location.replace(Ob));
  }, []), /* @__PURE__ */ f.jsxs("a", { href: As, className: w0.steamLink, children: [
    /* @__PURE__ */ f.jsx(q1, { className: w0.steamBtn, appearance: "neutral", onClick: l, ...n && {
      mode: "outline"
    }, leftIcon: /* @__PURE__ */ f.jsx(b1, { className: w0.icon, name: "wallet-outline" }), children: a(L5.btnName) }),
    (i === e2.NARROW || r) && /* @__PURE__ */ f.jsx("span", { className: w0.labelCollapsed, children: a(L5.btnName) })
  ] });
}, T6 = () => {
  const {
    pushReachGoal: e
  } = le(), t = ({
    currentSection: u
  } = {
    currentSection: "all"
  }) => {
    e({
      params: {
        category: "header",
        action: "click",
        label: "ph-menu-search",
        list_id: u
      }
    });
  }, n = ({
    currentSection: u
  }) => {
    e({
      params: {
        category: "header",
        action: "click",
        label: "ph-menu-search-dropdown",
        list_id: u
      }
    });
  }, r = ({
    query: u,
    isFound: m,
    currentSection: d
  }) => {
    e({
      params: {
        category: "header",
        action: "search",
        label: u,
        other: m,
        list_id: d
      }
    });
  }, a = ({
    query: u,
    index: m,
    currentSection: d
  }) => {
    e({
      params: {
        category: "search",
        action: "click",
        label: u,
        entity_id: "history",
        value: m,
        list_id: d
      }
    });
  }, i = ({
    url: u,
    index: m,
    currentSection: d
  }) => {
    e({
      params: {
        category: "search",
        action: "click",
        label: "suggest",
        entity_id: u,
        value: m,
        list_id: d
      }
    });
  }, l = ({
    query: u,
    url: m,
    section: d,
    index: v,
    currentSection: x
  }) => {
    e({
      params: {
        category: "search",
        action: "click",
        label: u,
        entity_id: m,
        other: d,
        value: v,
        list_id: x
      }
    });
  }, s = ({
    query: u,
    section: m,
    currentSection: d
  }) => {
    e({
      params: {
        category: "header",
        action: "search_more_click",
        label: u,
        other: m,
        list_id: d
      }
    });
  }, c = () => {
    e({
      params: {
        category: "header",
        action: "click",
        label: "ph-menu-library"
      }
    });
  };
  return {
    handleSearchEvents: ({
      type: u,
      params: m
    }) => {
      u === "search" ? r(m) : u === "search-section" ? n(m) : u === "search-click" ? t(m) : u === "search-history" ? a(m) : u === "item-recommended-click" ? i(m) : u === "item-click" ? l(m) : u === "more-click" && s(m);
    },
    handlBookmarksEvents: ({
      type: u
    }) => {
      u === "bookmarks-click" && c();
    }
  };
}, mA = "data:image/svg+xml,%3csvg%20width='36'%20height='36'%20viewBox='0%200%2036%2036'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_124_10523)'%3e%3cpath%20d='M18.756%200C26.892%200%2030.96%200%2033.48%202.52C36%205.04%2036%209.108%2036%2017.244V18.756C36%2026.892%2036%2030.96%2033.48%2033.48C30.96%2036%2026.892%2036%2018.756%2036H17.244C9.108%2036%205.04%2036%202.52%2033.48C0%2030.96%200%2026.892%200%2018.756V17.244C0%209.108%200%205.04%202.52%202.52C5.04%200%209.108%200%2017.244%200H18.756Z'%20fill='%230077FF'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M35.8956%2010.1542C36%2012.0999%2036%2014.4283%2036%2017.2439V17.244V18.756V18.756C36%2020.9229%2036%2022.8013%2035.9524%2024.4387H0.0476112C0%2022.8013%200%2020.9229%200%2018.756V17.244C0%2014.4283%200%2012.0999%200.104447%2010.1542H35.8956ZM0.0474971%2024.4394L0.0479452%2024.4547C4.76004%2026.7552%2011.0876%2028.1568%2017.9898%2028.1568C24.8976%2028.1568%2031.2388%2026.7487%2035.9521%2024.4449L35.9522%2024.4394H0.0474971Z'%20fill='%230009B4'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M25.0373%2016.5811C24.1462%2016.5811%2023.4239%2017.3195%2023.4239%2018.2304C23.4239%2019.1412%2024.1462%2019.8796%2025.0373%2019.8796C25.9284%2019.8796%2026.6507%2019.1412%2026.6507%2018.2304C26.6507%2017.3195%2025.9284%2016.5811%2025.0373%2016.5811ZM19.845%2018.2304C19.845%2015.299%2022.1697%2012.9227%2025.0373%2012.9227C27.9049%2012.9227%2030.2296%2015.299%2030.2296%2018.2304C30.2296%2021.1617%2027.9049%2023.5381%2025.0373%2023.5381C22.1697%2023.5381%2019.845%2021.1617%2019.845%2018.2304Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M11.1827%2015.8495L8.48861%2013.1555L5.93991%2015.7042L8.63398%2018.3982L5.94007%2021.0921L8.48877%2023.6408L11.1827%2020.9469L13.8765%2023.6408L16.4252%2021.0921L13.7314%2018.3982L16.4254%2015.7042L13.8767%2013.1555L11.1827%2015.8495Z'%20fill='white'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_124_10523'%3e%3crect%20width='36'%20height='36'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", CA = "data:image/svg+xml,%3csvg%20width='87'%20height='24'%20viewBox='0%200%2087%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M79.8852%2014.875L83.2102%205.5H86.1352L80.8102%2020.125C79.9352%2022.55%2078.6352%2023.625%2076.2352%2023.625H74.2602L74.0102%2021H76.4352C77.3852%2021%2077.8352%2020.65%2078.2102%2019.6L78.3602%2019.2L72.5852%205.5H75.6602L79.4852%2014.875H79.8852Z'%20fill='white'/%3e%3cpath%20d='M66.1545%205.25C69.4795%205.25%2071.5295%207.425%2071.5295%2011.2V18.5H69.4045L68.8045%2016.45C68.1795%2017.525%2066.7545%2018.75%2064.6295%2018.75C61.9795%2018.75%2060.1045%2017.025%2060.1045%2014.6C60.1045%2012.2%2062.0045%2010.525%2065.8295%2010.525H68.6295C68.5045%208.825%2067.5795%207.7%2066.0045%207.7C64.7045%207.7%2063.8045%208.45%2063.4045%209.25L60.7545%208.8C61.4045%206.55%2063.6295%205.25%2066.1545%205.25ZM65.3045%2016.325C67.3045%2016.325%2068.6545%2014.9%2068.6545%2012.775H65.9295C63.7295%2012.775%2063.0045%2013.475%2063.0045%2014.475C63.0045%2015.6%2063.9045%2016.325%2065.3045%2016.325Z'%20fill='white'/%3e%3cpath%20d='M57.6824%2018.5H54.8074V0.875H57.6824V18.5Z'%20fill='white'/%3e%3cpath%20d='M42.9957%2018.5H39.9957V0.875H46.2457C49.8957%200.875%2052.6207%203.325%2052.6207%206.825C52.6207%2010.3%2049.8957%2012.775%2046.2457%2012.775H42.9957V18.5ZM42.9957%203.625V10.025H46.2457C48.1957%2010.025%2049.5457%208.725%2049.5457%206.825C49.5457%204.925%2048.1957%203.625%2046.2457%203.625H42.9957Z'%20fill='white'/%3e%3cpath%20d='M25.4043%209.375L33.5043%2018.5H29.5543L22.9543%2010.95H22.2043V18.5H19.2043V0.875H22.2043V8.05H22.9293L29.1793%200.875H32.8793L25.4043%209.375Z'%20fill='white'/%3e%3cpath%20d='M10.85%2018.5H6.475L0.25%200.875H3.475L8.45%2015.4H8.95L14.1%200.875H17.275L10.85%2018.5Z'%20fill='white'/%3e%3c/svg%3e", gA = "_logo_3vho3_1", vA = "_logoImgLg_3vho3_7", wA = "_logoText_3vho3_13", yA = "_simplified_3vho3_56", y0 = {
  logo: gA,
  logoImgLg: vA,
  logoText: wA,
  simplified: yA
}, I6 = ({
  className: e
}) => {
  const {
    simplified: t
  } = D1(rt);
  return /* @__PURE__ */ f.jsxs("span", { className: h1(y0.logo, e, {
    [y0.simplified]: t
  }), children: [
    /* @__PURE__ */ f.jsx("img", { src: mA, alt: "VK Play", width: "36", height: "36", className: y0.logoImgLg }),
    /* @__PURE__ */ f.jsx("img", { src: CA, alt: "VK Play", width: "87", height: "24", className: y0.logoText })
  ] });
}, yr = `https://${en}`, bA = {
  id: "cloud",
  label: U1.cloud,
  href: `${yr}/`,
  icon: "cloud-outline",
  analyticsLabel: "ph-menu-catalog-cloud",
  subnav: [{
    label: U1.main,
    id: "dashboard",
    href: `${yr}/`,
    analyticsLabel: "ph-subnav-cloud-dashboard"
  }, {
    label: U1.cloudPlans,
    id: "plans",
    href: `${yr}/#plans_calculator/`,
    analyticsLabel: "ph-subnav-cloud-plans"
  }, {
    label: U1.download,
    id: "download",
    href: `${yr}/dashboard/download/`,
    analyticsLabel: "ph-subnav-cloud-download"
  }, {
    label: U1.faq,
    id: "faq",
    href: `${yr}/dashboard/faq/`,
    analyticsLabel: "ph-subnav-cloud-faq"
  }]
}, Wa = `https://${Ke}`, _A = {
  id: "live",
  label: U1.live,
  href: `${Wa}/live/`,
  icon: "live-outline",
  analyticsLabel: "ph-menu-streams",
  subnav: [{
    label: U1.often,
    id: "often",
    href: `${Wa}/live/`,
    analyticsLabel: "ph-subnav-live-often"
  }, {
    label: U1.online,
    id: "online",
    href: `${Wa}/live/`,
    analyticsLabel: "ph-subnav-live-online"
  }]
}, zt = `https://${jn}`, xA = {
  id: "market",
  label: U1.market,
  href: `${zt}/`,
  icon: "market-outline",
  analyticsLabel: "ph-menu-market",
  subnav: [{
    label: U1.goods,
    id: "play",
    href: `${zt}/`,
    analyticsLabel: "ph-subnav-market-play"
  }, {
    label: U1.keys,
    id: "keys",
    href: `${zt}/game/256/`,
    include: [`${zt}/inventory/256/`, `${zt}/inventory_code/256/`, `${zt}/help/256/`],
    analyticsLabel: "ph-subnav-market-keys"
  }, {
    label: U1.refill,
    id: "refill",
    href: `${zt}/shop/255/`,
    include: [`${zt}/inventory/255/`, `${zt}/inventory_code/255/`, `${zt}/help/255/`],
    analyticsLabel: "ph-subnav-market-refill"
  }]
}, br = `https://${M2}`, LA = {
  id: "media",
  label: U1.media,
  href: `${br}/`,
  icon: "newsfeed-lines-outline",
  analyticsLabel: "ph-menu-media",
  subnav: [{
    label: U1.main,
    id: "main",
    href: `${br}/`,
    analyticsLabel: "ph-subnav-media-main"
  }, {
    label: U1.news,
    id: "news",
    href: `${br}/news/`,
    allowPartialMatch: !0,
    analyticsLabel: "ph-subnav-media-news"
  }, {
    label: U1.articles,
    id: "articles",
    href: `${br}/feat/`,
    allowPartialMatch: !0,
    analyticsLabel: "ph-subnav-media-articles"
  }, {
    label: U1.guides,
    id: "secret",
    href: `${br}/secret/`,
    allowPartialMatch: !0,
    analyticsLabel: "ph-subnav-media-secret"
  }]
}, _r = `https://${On}`, EA = {
  id: "pvp",
  label: U1.pvp,
  href: `${_r}/`,
  icon: "tournament-outline",
  analyticsLabel: "ph-menu-pvp",
  subnav: [{
    label: U1.overview,
    id: "main",
    href: `${_r}/`,
    analyticsLabel: "ph-subnav-pvp-main"
  }, {
    label: U1.tournaments,
    id: "tournaments",
    href: `${_r}/tournaments`,
    analyticsLabel: "ph-subnav-pvp-tournaments"
  }, {
    label: U1.player,
    id: "player",
    href: `${_r}/profile`,
    allowPartialMatch: !0,
    include: [`${_r}/player/`],
    analyticsLabel: "ph-subnav-pvp-player"
  }]
}, qt = `https://${Ke}`, MA = `https://${qr}`, kA = {
  id: "store",
  label: U1.store,
  href: `${qt}/play/`,
  icon: "game-outline",
  analyticsLabel: "ph-menu-catalog",
  subnav: [{
    label: U1.play,
    id: "play",
    href: `${qt}/play/`,
    allowPartialMatch: !0,
    exclude: [`${qt}/play/my`, `${qt}/play/game`, `${qt}/play/promo`, `${qt}/play/tags`, `${qt}/play/is_free/`, `${qt}/play/sale/`],
    analyticsLabel: "ph-subnav-store-play"
  }, {
    label: U1.free,
    id: "free",
    href: `${qt}/play/is_free/`,
    analyticsLabel: "ph-subnav-store-free"
  }, {
    label: U1.sale,
    id: "sale",
    href: `${qt}/play/sale/`,
    analyticsLabel: "ph-subnav-store-sale"
  }, {
    label: U1.my,
    id: "my",
    href: `${MA}/profile/games`,
    analyticsLabel: "ph-subnav-store-my"
  }]
}, R6 = {
  store: kA,
  cloud: bA,
  market: xA,
  live: _A,
  media: LA,
  pvp: EA
}, SA = ["store", "cloud", "market", "live", "media", "pvp"], AA = ({
  onSearchClick: e,
  onMoreClick: t
}) => [{
  id: "main",
  label: U1.main,
  href: `https://${Ke}/`,
  icon: "home-outline"
}, {
  id: "store",
  label: U1.store,
  href: `https://${Ke}/play`,
  icon: "game-outline",
  analyticsLabel: "ph-menu-catalog"
}, {
  id: "media",
  label: U1.media,
  href: `https://${M2}/`,
  icon: "newsfeed-lines-outline",
  analyticsLabel: "ph-menu-media"
}, {
  id: "search",
  label: U1.search,
  icon: "search",
  onClick: e
}, {
  id: "more",
  label: U1.more,
  icon: "menu",
  onClick: t
}], E5 = "mob-nav-container", TA = () => {
  const {
    handleSearchEvents: e
  } = T6(), {
    tabletMdMax: t,
    tabletLgMax: n
  } = Ue(["tabletMdMax", "tabletLgMax"]), [r, a] = r1(!1), [i, l] = r1(!1), [s, c] = r1(!1), [p, h] = r1(!1), {
    sidebarState: u
  } = Ao(), {
    pushReachGoal: m
  } = le(), {
    onMainClick: d
  } = D1(rt), v = V1(null), {
    offsetLeft: x,
    updateOffset: k
  } = _s(v), I = (w) => {
    m({
      params: {
        category: "header",
        action: "click",
        label: "logo"
      }
    }), d == null || d(w);
  }, T = W1(() => {
    a(!0);
  }, []), L = W1(() => {
    a(!1);
  }, []), S = W1(() => {
    l(!i);
  }, [i]), E = W1(() => {
    l(!1);
  }, []), j = Xe(() => AA({
    onSearchClick: T,
    onMoreClick: S
  }), [T, S]), g = W1((w) => {
    const {
      top: C,
      clientHeight: b,
      scrollHeight: M
    } = w;
    if (u === e2.WIDE && !n) {
      h(!1), c(!1);
      return;
    }
    const R = C === 0, O = C === 1, N = b === M;
    c(() => !R && !N), h(() => !O && !N);
  }, [n, u]);
  return /* @__PURE__ */ f.jsxs("nav", { className: G1.sidebar, id: "vkp-navbar", ref: v, children: [
    /* @__PURE__ */ f.jsxs("div", { className: h1(G1.scrollable, {
      [G1.showTopFade]: s,
      [G1.showBottomFade]: p
    }), children: [
      /* @__PURE__ */ f.jsx(Io, { disableHorizontal: !0, onUpdate: g, children: /* @__PURE__ */ f.jsx("div", { className: G1.container, children: /* @__PURE__ */ f.jsxs("div", { className: G1.menuWrapper, children: [
        /* @__PURE__ */ f.jsx("a", { href: me.main, className: G1.logo, onClick: I, children: /* @__PURE__ */ f.jsx(I6, {}) }),
        /* @__PURE__ */ f.jsx("ul", { className: G1.navLinks, children: SA.map((w) => {
          const C = R6[w];
          return /* @__PURE__ */ f.jsx(rA, { item: C, offsetLeft: x, updateOffset: k }, `${C.id}_${C.href}`);
        }) }),
        /* @__PURE__ */ f.jsx(pA, {}),
        /* @__PURE__ */ f.jsx(Gw, {}),
        /* @__PURE__ */ f.jsx(cA, {})
      ] }) }) }),
      /* @__PURE__ */ f.jsx("div", { id: "search-overlay-root" })
    ] }),
    /* @__PURE__ */ f.jsxs("div", { className: G1.containerMob, id: E5, children: [
      /* @__PURE__ */ f.jsx("ul", { className: G1.navLinksMob, children: j.map((w) => {
        const C = () => {
          w.id !== "more" && E(), w.onClick && w.onClick();
        };
        return /* @__PURE__ */ f.jsx(aA, { item: w, onClick: C, openMobOverlay: i }, `${w.id}_${w.href}`);
      }) }),
      r && t && /* @__PURE__ */ f.jsx(Z2, { shouldDisableBodyScroll: !0, children: /* @__PURE__ */ f.jsx(ia, { className: G1.search, children: /* @__PURE__ */ f.jsx(g6, { size: "fullscreen", onClose: L, onEvent: e }) }) }),
      i && t && /* @__PURE__ */ f.jsx(Z2, { into: `#${E5}`, shouldDisableBodyScroll: !0, children: /* @__PURE__ */ f.jsx(LL, { onClose: E }) })
    ] })
  ] });
}, $t = {
  title: {
    id: "terms.title",
    defaultMessage: "Юридическая информация"
  },
  descr: {
    id: "terms.descr",
    defaultMessage: "Перед использованием сервиса вам необходимо принять юридические документы."
  },
  vkId: {
    id: "terms.vk_id",
    defaultMessage: "Согласие с запросом данных у VK ID."
  },
  accept: {
    id: "terms.accept",
    defaultMessage: "Я соглашаюсь с применимыми правилами"
  },
  acceptHint: {
    id: "terms.accept_hint",
    defaultMessage: "Примите согласие, чтобы продолжить"
  },
  newsletter: {
    id: "terms.newsletter",
    defaultMessage: "Я соглашаюсь получать сообщения рекламного и информационного характера (необязательно)"
  },
  continue: {
    id: "app.continue",
    defaultMessage: "Продолжить"
  },
  logoutShort: {
    id: "profile.logout_short",
    defaultMessage: "Выйти"
  },
  docsCis: {
    id: "terms.docs_cis",
    defaultMessage: "Документы для пользователей из СНГ"
  },
  docsNonCis: {
    id: "terms.docs_non_cis",
    defaultMessage: "Документы для пользователей не из СНГ"
  }
}, IA = "_dialog_1s0xy_1", RA = "_wrapper_1s0xy_5", NA = "_app_1s0xy_10", HA = "_header_1s0xy_21", OA = "_subHeader_1s0xy_29", jA = "_accept_1s0xy_33", PA = "_text_1s0xy_37", DA = "_detailsGroup_1s0xy_44", VA = "_details_1s0xy_44", BA = "_summary_1s0xy_56", FA = "_checkboxes_1s0xy_106", ZA = "_actions_1s0xy_113", GA = "_bottomBtn_1s0xy_119", WA = "_termsAppWrapper_1s0xy_123", tt = {
  dialog: IA,
  wrapper: RA,
  app: NA,
  header: HA,
  subHeader: OA,
  accept: jA,
  text: PA,
  detailsGroup: DA,
  details: VA,
  summary: BA,
  checkboxes: FA,
  actions: ZA,
  bottomBtn: GA,
  termsAppWrapper: WA
};
function M5({
  cis: e = !0,
  terms: t,
  lang: n
}) {
  const {
    formatMessage: r
  } = N1();
  return /* @__PURE__ */ f.jsxs("details", { className: tt.details, children: [
    /* @__PURE__ */ f.jsxs("summary", { className: tt.summary, children: [
      r(e ? $t.docsCis : $t.docsNonCis),
      /* @__PURE__ */ f.jsx(b1, { name: "chevron-down-24" })
    ] }),
    /* @__PURE__ */ f.jsx("ul", { children: t.map((a, i) => (
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ f.jsx("li", { children: /* @__PURE__ */ f.jsx("a", { href: a.url, target: "_blank", rel: "noreferrer", children: a[n] }) }, i)
    )) })
  ] });
}
const UA = "_checkbox_15w8q_1", zA = "_label_15w8q_5", qA = "_checked_15w8q_23", $A = "_text_15w8q_41", b0 = {
  checkbox: UA,
  label: zA,
  checked: qA,
  text: $A
};
function k5({
  checked: e,
  onChange: t,
  label: n,
  labelFor: r
}) {
  const a = (i) => {
    t(i.currentTarget.checked);
  };
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    /* @__PURE__ */ f.jsxs("label", { className: b0.label, children: [
      /* @__PURE__ */ f.jsx("input", { className: b0.checkbox, type: "checkbox", id: r, onChange: a, checked: e }),
      /* @__PURE__ */ f.jsx(b1, { name: "checked", className: b0.checked }),
      /* @__PURE__ */ f.jsx("span", { className: b0.text, children: n })
    ] })
  );
}
const YA = "_tooltip_17tb9_1", KA = {
  tooltip: YA
}, QA = (e) => {
  const {
    className: t
  } = e;
  return /* @__PURE__ */ f.jsx(go, { opacity: 1, place: "bottom", noArrow: !0, ...e, className: h1(KA.tooltip, t) });
}, XA = "vkplay.com";
function N6({
  setOpen: e,
  cisTerms: t,
  worldTerms: n
}) {
  const [r, a] = r1(!1), [i, l] = r1(!1), {
    session: {
      locale: s,
      token: c
    }
  } = D1(bt), {
    formatMessage: p
  } = N1(), h = V1(s === "ru_RU" ? "ru" : "en"), u = async () => {
    try {
      window.CSRF_JWT_TOKEN || (window.CSRF_JWT_TOKEN = c);
      const d = await J.Backend.post(me.terms_accept, {
        client_id: XA,
        register: 1
      });
      if (d.status === 200 || d.status === "ok")
        e && (e(!1), window.location.reload()), J.inGamecenter && window.gc_close_window && window.gc_close_window();
      else
        throw d.status;
    } catch (d) {
      console.error(d), window.location.reload();
    }
  }, m = (d) => {
    window.gc_logout && (d.preventDefault(), d.stopPropagation(), window.gc_logout(), window.gc_close_window && window.gc_close_window());
  };
  return /* @__PURE__ */ f.jsxs("div", { className: h1(tt.wrapper, {
    [tt.app]: !e
  }), children: [
    /* @__PURE__ */ f.jsx("h4", { className: tt.header, children: p($t.title) }),
    /* @__PURE__ */ f.jsx("p", { className: h1(tt.subHeader, tt.text), children: p($t.descr) }),
    /* @__PURE__ */ f.jsxs("div", { className: tt.detailsGroup, children: [
      /* @__PURE__ */ f.jsx(M5, { terms: t, lang: h.current }),
      /* @__PURE__ */ f.jsx(M5, { terms: n, cis: !1, lang: h.current })
    ] }),
    /* @__PURE__ */ f.jsx("p", { className: h1(tt.accept, tt.text), children: p($t.vkId) }),
    /* @__PURE__ */ f.jsxs("div", { className: tt.checkboxes, children: [
      /* @__PURE__ */ f.jsx(k5, { checked: r, onChange: (d) => {
        a(d);
      }, label: p($t.accept) }),
      /* @__PURE__ */ f.jsx(k5, { checked: i, onChange: (d) => {
        l(d);
      }, label: p($t.newsletter) })
    ] }),
    /* @__PURE__ */ f.jsxs("div", { className: tt.actions, children: [
      /* @__PURE__ */ f.jsx(q1, { isDisabled: !r, onClick: u, className: tt.bottomBtn, appearance: "overlay", size: "lg", "data-tooltip-id": "accept-terms", children: p($t.continue) }),
      !r && /* @__PURE__ */ f.jsx(QA, { id: "accept-terms", content: p($t.acceptHint) }),
      /* @__PURE__ */ f.jsx(q1, { component: "a", href: lo(), className: tt.bottomBtn, appearance: "neutral", size: "lg", onClick: m, children: p($t.logoutShort) })
    ] })
  ] });
}
const JA = 4, S5 = "vkplay.com";
function H6({
  hideTerms: e,
  setOpen: t
}) {
  const {
    session: {
      session: n
    }
  } = D1(bt), [r, a] = r1([]), [i, l] = r1([]);
  return u1(() => {
    var c, p;
    if (e) return;
    const s = async () => {
      var h;
      try {
        const {
          terms: u
        } = await J.Backend.get(me.get_terms, {
          client_id: S5
        }), m = (h = u[S5]) == null ? void 0 : h.urls;
        Array.isArray(m) && (a(m.slice(0, 2)), l(m.slice(2)));
      } catch (u) {
        console.error(u);
      }
      t && t(!0);
    };
    n && +((p = (c = n == null ? void 0 : n.client_profile_fields) == null ? void 0 : c.terms_accepted) != null ? p : "0:0").split(":")[0] < JA && s();
  }, [n == null ? void 0 : n.client_profile_fields]), {
    cisTerms: r,
    worldTerms: i
  };
}
function eT() {
  const [e, t] = r1(!1), {
    hiddenElements: n
  } = D1(rt), r = n == null ? void 0 : n.includes(nn.Terms), {
    cisTerms: a,
    worldTerms: i
  } = H6({
    hideTerms: r,
    setOpen: t
  });
  return /* @__PURE__ */ f.jsx(Fr, { open: e, onClose: () => {
  }, className: tt.dialog, hideCloseIcon: !0, children: /* @__PURE__ */ f.jsx(En, { children: /* @__PURE__ */ f.jsx(N6, { setOpen: t, cisTerms: a, worldTerms: i }) }) });
}
function O6(e, t) {
  u1(() => {
    if (J.isGCUserAgent && !document.getElementById("gc-script")) {
      J.setScriptTag({
        id: "gc-script",
        src: `//${J.DOMAIN}/js/gc.js`,
        onload: () => {
          e();
        }
      });
      const n = new ResizeObserver((a) => {
        for (const i of a)
          i.target.id === t && e();
      }), r = document.getElementById(t);
      r && n.observe(r);
    }
  }, []);
}
function tT() {
  const {
    session: {
      profile: e
    }
  } = D1(bt), t = V1(!1), {
    cisTerms: n,
    worldTerms: r
  } = H6({}), [a, i] = r1(!1);
  return u1(() => {
    !e || t.current || i(!0);
  }, [e]), e ? /* @__PURE__ */ f.jsxs("div", { className: tt.termsAppWrapper, children: [
    /* @__PURE__ */ f.jsx("div", { className: "ph-form-embed js-embed" }),
    a && /* @__PURE__ */ f.jsx(Io, { autoHeightMax: 562, autoHeightMin: 562, autoHeight: !0, autoHide: !0, children: /* @__PURE__ */ f.jsx(N6, { cisTerms: n, worldTerms: r }) })
  ] }) : null;
}
const A5 = "terms-root";
function _N() {
  return O6(() => {
    var t, n;
    if (window.gc_set_window_size) {
      const r = document.getElementById(A5);
      window.gc_set_window_size(
        560,
        // TODO: Пока там некрасиво прыгает - добавил внутренний скролл, попробую покопать после релиза
        (n = (t = r == null ? void 0 : r.getBoundingClientRect()) == null ? void 0 : t.height) != null ? n : 562,
        !0
      );
    }
  }, A5), /* @__PURE__ */ f.jsx(ta, { config: {
    preset: "store"
  }, children: /* @__PURE__ */ f.jsx(En, { children: /* @__PURE__ */ f.jsx(Ht, { children: /* @__PURE__ */ f.jsx(tT, {}) }) }) });
}
const nT = "_wrapper_18rlc_1", rT = "_full_18rlc_10", aT = "_wishlist_18rlc_14", iT = "_loader_18rlc_23", oT = "_gc_18rlc_30", sT = "_button_18rlc_36", lT = "_header_18rlc_52", cT = "_title_18rlc_59", uT = "_titleSecondary_18rlc_66", Dt = {
  wrapper: nT,
  full: rT,
  wishlist: aT,
  loader: iT,
  gc: oT,
  button: sT,
  header: lT,
  title: cT,
  titleSecondary: uT
};
function j6({
  setFullsize: e
}) {
  const {
    pushReachGoal: t
  } = le(), {
    formatMessage: n
  } = N1(), {
    loading: r,
    data: a,
    count: i
  } = D1(bo), {
    session: {
      profile: l
    }
  } = D1(bt);
  u1(() => {
    e && (!r && i > 0 ? e(!1) : (r || i === 0) && e(!0));
  }, [i, r]);
  const s = () => {
    if (!l) return;
    t({
      params: {
        category: "library",
        action: "view_all_click"
      }
    });
    const p = `https://${qr}/profile/${l.slug}/games/wishlist`;
    J.inGamecenter && window.gc_open_url_mainwnd ? (window.gc_open_url_mainwnd(p), window.gc_close_window && window.gc_close_window()) : window.open(p, "_self");
  }, c = i > 24;
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx("div", { className: Dt.header, children: (r || !r && i > 0) && /* @__PURE__ */ f.jsxs("span", { className: Dt.title, children: [
      /* @__PURE__ */ f.jsx(ns, { id: "profile.favorites", defaultMessage: "Избранное" }),
      !r && /* @__PURE__ */ f.jsx("span", { className: Dt.titleSecondary, children: i })
    ] }) }),
    r && /* @__PURE__ */ f.jsx("div", { className: h1(Dt.loader, {
      [Dt.gc]: J.inGamecenter
    }), children: /* @__PURE__ */ f.jsx(nr, { size: "48" }) }),
    a.length === 0 && !r && /* @__PURE__ */ f.jsx(Vs, {}),
    a.length > 0 && !r && /* @__PURE__ */ f.jsx("div", { className: vt.customList, children: a.map((p) => /* @__PURE__ */ f.jsx(Ds, { game: p }, p.id)) }),
    c && !r && /* @__PURE__ */ f.jsxs(Je, { onClick: s, className: vt.redirectButton, children: [
      n(v2.seeAll),
      /* @__PURE__ */ f.jsx(b1, { name: "chevron-right" })
    ] })
  ] });
}
function dT() {
  const {
    pushReachGoal: e
  } = le(), {
    noSession: t,
    loaded: n
  } = D1(bt), [r, a] = r1(!0), [i, l] = r1(!1), s = W1(() => {
    t && Bs(), e({
      params: {
        category: "header",
        action: "click",
        label: "ph-menu-library"
      }
    });
  }, [n]);
  return n ? /* @__PURE__ */ f.jsxs(_o, { open: i, children: [
    /* @__PURE__ */ f.jsx(q1, { size: "lg", appearance: "neutral", onClick: s, className: Dt.button, leftIcon: /* @__PURE__ */ f.jsx(b1, { name: "bookmark-outline" }), "data-tooltip-id": "wishlist-wishlist" }),
    !t && /* @__PURE__ */ f.jsx(kt, { id: "wishlist-wishlist", place: "bottom-start", className: h1(Dt.wrapper, Dt.wishlist, vt.wishlist, {
      [Dt.full]: r
    }), afterShow: () => l(!0), afterHide: () => l(!1), opacity: 1, clickable: !0, openOnClick: !0, closeEvents: {
      click: !0
    }, middlewares: [vs(10)], children: /* @__PURE__ */ f.jsx(j6, { setFullsize: a }) })
  ] }) : null;
}
function fT() {
  const {
    unread: e
  } = D1(c2), {
    pushReachGoal: t
  } = le(), [n, r] = r1(!1), a = (l) => {
    l.stopPropagation(), r(!1);
  }, i = W1(() => {
    r(!0), t({
      params: {
        category: "header",
        action: "click",
        label: "ph-menu-notifications"
      }
    });
  }, []);
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(q1, { size: "lg", appearance: "neutral", onClick: i, className: nt.button, leftIcon: /* @__PURE__ */ f.jsxs("div", { className: nt.buttonInner, children: [
      /* @__PURE__ */ f.jsx(b1, { name: e > 0 ? "notification-subtract-outline" : "notification-outline" }),
      e > 0 && /* @__PURE__ */ f.jsx(q0, { size: "small", className: nt.counter, mode: "negative", children: e })
    ] }), "data-tooltip-id": "notification-notifications" }),
    /* @__PURE__ */ f.jsx(Ps, { onClose: a, open: n })
  ] });
}
function hT({
  hasNew: e,
  loading: t
}) {
  const {
    onCheckAll: n
  } = D1(c2), {
    formatMessage: r
  } = N1();
  return /* @__PURE__ */ f.jsxs("div", { className: nt.header, children: [
    /* @__PURE__ */ f.jsx("span", { className: nt.title, children: r(We.title) }),
    !t && /* @__PURE__ */ f.jsxs(Je, { onClick: n, className: h1(nt.checkAll, {
      [nt.hasNew]: e
    }), "data-tooltip-id": "tooltip-no-new", children: [
      /* @__PURE__ */ f.jsx(b1, { name: "list-check-outline" }),
      /* @__PURE__ */ f.jsx("span", { children: r(We.checkAll) })
    ] }),
    !e && /* @__PURE__ */ f.jsx(kt, { id: "tooltip-no-new", opacity: 1, place: "bottom", className: nt.secondaryTooltip, children: /* @__PURE__ */ f.jsx("span", { children: r(We.noNewNotifications) }) })
  ] });
}
function P6() {
  const {
    list: e,
    unread: t,
    loading: n,
    nextPage: r
  } = D1(c2);
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    !n && e.length > 0 && /* @__PURE__ */ f.jsx(hT, { hasNew: t !== 0, loading: n }),
    n && /* @__PURE__ */ f.jsx("div", { className: h1(nt.loader, {
      [nt.gc]: J.inGamecenter
    }), children: /* @__PURE__ */ f.jsx(nr, { size: "48" }) }),
    !n && e.length > 0 ? /* @__PURE__ */ f.jsxs("div", { className: h1(nt.list), children: [
      e.map((a) => /* @__PURE__ */ f.jsx(yo, { notification: a }, `${a.id}_${a.template_id}`)),
      r !== null && /* @__PURE__ */ f.jsx(nr, { size: "48" })
    ] }) : !n && /* @__PURE__ */ f.jsx(Rs, {})
  ] });
}
function pT() {
  const {
    pushReachGoal: e
  } = le(), {
    list: t,
    unread: n,
    onOpenNotification: r
  } = D1(c2), {
    noSession: a,
    loaded: i
  } = D1(bt), l = W1(() => {
    a && Bs(), e({
      params: {
        category: "header",
        action: "click",
        label: "ph-menu-notifications"
      }
    });
  }, [i]);
  return i ? /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(q1, { size: "lg", appearance: "neutral", onClick: l, className: nt.button, leftIcon: /* @__PURE__ */ f.jsxs("div", { className: nt.buttonInner, children: [
      /* @__PURE__ */ f.jsx(b1, { name: n > 0 ? "notification-subtract-outline" : "notification-outline" }),
      n > 0 && /* @__PURE__ */ f.jsx(q0, { size: "small", className: nt.counter, mode: "negative", children: n })
    ] }), "data-tooltip-id": "notification-notifications" }),
    !a && /* @__PURE__ */ f.jsx(kt, { id: "notification-notifications", place: "bottom-start", className: h1(Dt.wrapper, {
      [Dt.full]: t.length === 0
    }), afterShow: r, opacity: 1, clickable: !0, openOnClick: !0, closeEvents: {
      click: !0
    }, children: /* @__PURE__ */ f.jsx(P6, {}) })
  ] }) : null;
}
function mT() {
  const {
    tabletMdMax: e
  } = Ue(["tabletMdMax"]);
  return e && !J.inGamecenter ? /* @__PURE__ */ f.jsx(fT, {}) : /* @__PURE__ */ f.jsx(pT, {});
}
const Vt = {
  login: {
    id: "profile.login",
    defaultMessage: "Войти"
  },
  cancel: {
    id: "app.cancel",
    defaultMessage: "Отменить"
  },
  logout: {
    id: "profile.logout",
    defaultMessage: "Выйти из аккаунта"
  },
  logoutShort: {
    id: "profile.logout_short",
    defaultMessage: "Выйти"
  },
  logoutTitle: {
    id: "profile.logout.title",
    defaultMessage: "Выход из аккаунта"
  },
  logoutDescr: {
    id: "profile.logout.descr",
    defaultMessage: "Вы уверены, что хотите выйти из аккаунта?"
  },
  goToProfile: {
    id: "profile.go_to_profile",
    defaultMessage: "Перейти в профиль"
  },
  settings: {
    id: "profile.settings",
    defaultMessage: "Настройки"
  },
  support: {
    id: "profile.support",
    defaultMessage: "Служба поддержки"
  },
  copy: {
    id: "profile.id.copy",
    defaultMessage: "Скопировать ID"
  },
  copied: {
    id: "profile.id.copied",
    defaultMessage: "ID успешно скопирован"
  }
}, CT = "_loading_y7jd4_1", gT = "_wrapper_y7jd4_8", vT = "_profileButton_y7jd4_13", wT = "_nickname_y7jd4_41", yT = "_avatar_y7jd4_56", bT = "_arrow_y7jd4_67", _T = "_open_y7jd4_78", xT = "_transparent_y7jd4_82", LT = "_profilePopup_y7jd4_92", ET = "_hidden_y7jd4_102", MT = "_headInfo_y7jd4_106", kT = "_copyWrapper_y7jd4_122", ST = "_userId_y7jd4_128", AT = "_userIdWrapper_y7jd4_142", TT = "_toProfile_y7jd4_163", IT = "_profileLinks_y7jd4_168", RT = "_link_y7jd4_172", NT = "_langLink_y7jd4_172", HT = "_exit_y7jd4_172", OT = "_langList_y7jd4_197", jT = "_langItem_y7jd4_212", PT = "_selected_y7jd4_227", DT = "_icon_y7jd4_232", VT = "_selectedIcon_y7jd4_237", BT = "_divider_y7jd4_241", ge = {
  loading: CT,
  wrapper: gT,
  profileButton: vT,
  nickname: wT,
  avatar: yT,
  arrow: bT,
  open: _T,
  transparent: xT,
  profilePopup: LT,
  hidden: ET,
  headInfo: MT,
  copyWrapper: kT,
  userId: ST,
  userIdWrapper: AT,
  toProfile: TT,
  profileLinks: IT,
  link: RT,
  langLink: NT,
  exit: HT,
  langList: OT,
  langItem: jT,
  selected: PT,
  icon: DT,
  selectedIcon: VT,
  divider: BT
};
function FT({
  open: e,
  onClick: t
}) {
  const {
    session: {
      profile: n
    }
  } = D1(bt);
  return n ? /* @__PURE__ */ f.jsxs("button", { className: h1(ge.profileButton, {
    [ge.open]: e
  }), onClick: t, children: [
    /* @__PURE__ */ f.jsx("span", { className: ge.nickname, children: n.nick }),
    /* @__PURE__ */ f.jsx("img", { className: ge.avatar, src: n.avatar, alt: n.nick }),
    /* @__PURE__ */ f.jsx(b1, { name: "chevron-down-small-24", className: ge.arrow })
  ] }) : null;
}
const ZT = "_wrapperButton_1lbct_1", GT = {
  wrapperButton: ZT
};
function D6({
  children: e,
  onClick: t,
  className: n
}) {
  return /* @__PURE__ */ f.jsx("button", { onClick: t, className: h1(GT.wrapperButton, n), children: e });
}
function WT({
  ac_id: e
}) {
  const {
    pushReachGoal: t
  } = le(), {
    formatMessage: n
  } = N1(), r = () => {
    J.copyTextToClipboard(e.toString(), () => {
      P2.sendMessage({
        status: "success",
        message: n(Vt.copied)
      });
    }), t({
      params: {
        category: "header",
        action: "click",
        label: "ph-menu-profile-copy"
      }
    });
  };
  return /* @__PURE__ */ f.jsxs(D6, { className: ge.userIdWrapper, onClick: r, children: [
    /* @__PURE__ */ f.jsxs("span", { "data-tooltip-id": "copy-id-tooltip", className: ge.copyWrapper, children: [
      /* @__PURE__ */ f.jsxs("span", { className: ge.userId, children: [
        "ID:",
        " ",
        e
      ] }),
      " ",
      /* @__PURE__ */ f.jsx(b1, { name: "copy-outline" })
    ] }),
    /* @__PURE__ */ f.jsx(kt, { id: "copy-id-tooltip", content: n(Vt.copy), opacity: 1, place: "bottom" })
  ] });
}
function UT() {
  const {
    pushReachGoal: e
  } = le(), {
    formatMessage: t
  } = N1(), [n, r] = r1(!1), a = () => {
    r(!1);
  }, i = () => {
    r(!0);
  }, l = () => {
    e({
      params: {
        category: "header",
        action: "click",
        label: "ph-menu-logout"
      }
    }), window.location.href = lo();
  };
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsxs(D6, { onClick: i, className: ge.exit, children: [
      /* @__PURE__ */ f.jsx(b1, { name: "logout-outline" }),
      /* @__PURE__ */ f.jsx("span", { children: t(Vt.logout) })
    ] }),
    /* @__PURE__ */ f.jsx(Fr, { open: n, onClose: a, type: "dialog", title: t(Vt.logoutTitle), modalOptions: {
      description: t(Vt.logoutDescr),
      successText: t(Vt.logoutShort),
      noSuccessText: t(Vt.cancel),
      onSuccess: l,
      isSuccessAccent: !0
    }, zIndex: 1e6 })
  ] });
}
function zT() {
  const {
    locale: e,
    langsList: t
  } = D1(U2), {
    pushReachGoal: n
  } = le(), r = (i, l) => {
    i !== e && Li({
      lang: i,
      withSession: !0
    }), l && n({
      params: {
        category: "header",
        action: "click",
        label: `ph-menu-profile-lang-${l}`
      }
    });
  }, a = t[e] || t.ru_RU;
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsxs("span", { className: ge.langLink, "data-tooltip-id": "lang-list", children: [
      /* @__PURE__ */ f.jsx("img", { src: a.flag, alt: a.label }),
      /* @__PURE__ */ f.jsx("span", { children: a.label })
    ] }),
    /* @__PURE__ */ f.jsx(go, { id: "lang-list", noArrow: !0, className: ge.langList, place: "left-start", clickable: !0, offset: 16, opacity: 1, children: Object.entries(t).map(([i, l]) => (
      // eslint-disable-next-line max-len
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions,jsx-a11y/no-static-element-interactions
      /* @__PURE__ */ f.jsxs("span", { className: h1(ge.langItem, {
        [ge.selected]: e === i
      }), onClick: () => r(i, l.analyticsLabel), children: [
        /* @__PURE__ */ f.jsx("img", { src: l.flag, alt: i }),
        /* @__PURE__ */ f.jsx("span", { children: l.name }),
        e === i && // eslint-disable-next-line jsx-a11y/alt-text
        /* @__PURE__ */ f.jsx("img", { src: co, className: ge.selectedIcon, alt: i })
      ] }, i)
    )) })
  ] });
}
function qT() {
  const {
    pushReachGoal: e
  } = le(), {
    formatMessage: t
  } = N1(), n = () => {
    e({
      params: {
        category: "header",
        action: "click",
        label: "ph-menu-settings"
      }
    });
  }, r = () => {
    e({
      params: {
        category: "header",
        action: "click",
        label: "ph-menu-support"
      }
    });
  };
  return /* @__PURE__ */ f.jsxs("div", { className: ge.profileLinks, children: [
    /* @__PURE__ */ f.jsxs("a", { href: me.accountSettings, className: ge.link, onClick: n, children: [
      /* @__PURE__ */ f.jsx(b1, { name: "settings-outline", className: ge.icon }),
      /* @__PURE__ */ f.jsx("span", { children: t(Vt.settings) })
    ] }),
    /* @__PURE__ */ f.jsxs("a", { href: me.support, className: ge.link, onClick: r, children: [
      /* @__PURE__ */ f.jsx(b1, { name: "help-outline", className: ge.icon }),
      /* @__PURE__ */ f.jsx("span", { children: t(Vt.support) })
    ] }),
    /* @__PURE__ */ f.jsx(zT, {}),
    /* @__PURE__ */ f.jsx("div", { className: ge.divider }),
    /* @__PURE__ */ f.jsx(UT, {})
  ] });
}
function $T({
  open: e,
  onClose: t
}) {
  const {
    pushReachGoal: n
  } = le(), {
    formatMessage: r
  } = N1(), a = V1(null);
  xs(a, () => {
    setTimeout(() => {
      t();
    }, 10);
  }, "touchend");
  const {
    session: {
      profile: i
    }
  } = D1(bt), l = () => {
    n({
      params: {
        category: "header",
        action: "click",
        label: "ph-menu-profile"
      }
    });
  };
  return i ? /* @__PURE__ */ f.jsxs("div", { className: h1(ge.profilePopup, {
    [ge.hidden]: !e
  }), ref: a, children: [
    /* @__PURE__ */ f.jsxs("div", { className: ge.headInfo, children: [
      /* @__PURE__ */ f.jsx("img", { className: ge.avatar, src: i.avatar, alt: i.nick }),
      /* @__PURE__ */ f.jsx("span", { className: ge.nickname, children: i.nick }),
      /* @__PURE__ */ f.jsx(WT, { ac_id: i.ac_id }),
      /* @__PURE__ */ f.jsx(q1, { component: "a", href: me.profile, appearance: "overlay", className: ge.toProfile, onClick: l, children: r(Vt.goToProfile) })
    ] }),
    /* @__PURE__ */ f.jsx(qT, {})
  ] }) : null;
}
function T5() {
  const {
    pushReachGoal: e
  } = le(), {
    formatMessage: t
  } = N1(), n = xo(), {
    tabletMdMax: r
  } = Ue(["tabletMdMax"]), {
    loaded: a,
    noSession: i
  } = D1(bt), {
    transparent: l
  } = D1(rt), [s, c] = r1(!1), p = () => {
    s || (e({
      params: {
        category: "header",
        action: "click",
        label: "ph-menu-profile-dropdown",
        url: window.location.href
      }
    }), c(!0));
  }, h = () => {
    s && c(!1);
  }, u = () => {
    e({
      params: {
        category: "header",
        action: "click",
        label: "ph-menu-login"
      }
    });
  };
  return a ? a && i ? /* @__PURE__ */ f.jsx(q1, { component: "a", appearance: "overlay", mode: "primary", size: r ? "sm" : "md", onClick: u, href: n, leftIcon: /* @__PURE__ */ f.jsx(b1, { name: "user-outline" }), "data-id": "login-button", children: t(Vt.login) }) : /* @__PURE__ */ f.jsxs("div", { className: h1(ge.wrapper, {
    [ge.transparent]: l
  }), children: [
    /* @__PURE__ */ f.jsx(FT, { onClick: p, open: s }),
    /* @__PURE__ */ f.jsx($T, { open: s, onClose: h })
  ] }) : /* @__PURE__ */ f.jsx("div", { className: `${ge.loading} vkp-pulse-animation` });
}
const YT = "_rbBlockButton_18hqj_1", KT = {
  rbBlockButton: YT
}, QT = (e) => {
  var m, d;
  const {
    slotId: t,
    sitezone: n,
    intl: r,
    lang: a
  } = e || {}, i = J.query_string(), l = ["804455", "803510", "171697"], s = (v) => l.includes(v) && !J.isCis(), c = "2", p = a || (r == null ? void 0 : r.locale), h = window.gem_cookiebot_loaded && !((d = (m = window.Cookiebot) == null ? void 0 : m.consent) != null && d.statistics), u = {
    _SITEID: 133,
    q: t,
    _SITEZONE: n || c,
    ...i.preview && {
      preview: i.preview
    }
  };
  if (p && (u.lang = p.replace(/[_-][A-Z]+/, "")), h || s(t))
    return Promise.resolve([]);
  try {
    return J.Backend.jsonp("https://ad.mail.ru/adq/", u);
  } catch (v) {
    return console.error(v), Promise.resolve([]);
  }
}, XT = ({
  slotId: e
}) => {
  const [t, n] = r1(""), r = N1();
  return u1(() => {
    (async () => {
      const i = await QT({
        slotId: e,
        intl: r
      }), {
        html: l
      } = (i || [])[0] || {};
      l && n(l);
    })();
  }, [e]), t ? /* @__PURE__ */ f.jsx("div", { className: KT.rbBlockButton, dangerouslySetInnerHTML: {
    __html: t
  } }) : null;
}, JT = "_wrapper_x821x_1", eI = "_transparent_x821x_6", tI = "_container_x821x_11", nI = "_leftPart_x821x_35", rI = "_search_x821x_47", aI = "_leftPartButtonGroup_x821x_53", iI = "_simplified_x821x_58", oI = "_rightPart_x821x_69", sI = "_logo_x821x_82", lI = "_logoLink_x821x_98", cI = "_logoImg_x821x_109", Rt = {
  wrapper: JT,
  transparent: eI,
  container: tI,
  leftPart: nI,
  search: rI,
  leftPartButtonGroup: aI,
  simplified: iI,
  rightPart: oI,
  logo: sI,
  logoLink: lI,
  logoImg: cI
};
function I5() {
  const [e, t] = r1(!1), {
    handleSearchEvents: n
  } = T6(), {
    tabletMdMax: r,
    tabletMdMin: a
  } = Ue(["tabletMdMax", "tabletMdMin"]), {
    onMainClick: i,
    hiddenElements: l,
    simplified: s,
    transparent: c,
    // Временный флаг для спец. проекта
    // TODO: на доработку или удаление
    showMobileHeader: p
  } = D1(rt), h = `${window.location.origin}${window.location.pathname}`, u = r && h !== me.main && !s, m = l == null ? void 0 : l.includes(nn.Notifications), d = l == null ? void 0 : l.includes(nn.Search), v = l == null ? void 0 : l.includes(nn.Favorites), x = l == null ? void 0 : l.includes(nn.User);
  if (u && !p)
    return null;
  const k = (I) => {
    t(I);
  };
  return /* @__PURE__ */ f.jsx("div", { className: h1(Rt.wrapper, {
    [Rt.transparent]: c
  }), children: /* @__PURE__ */ f.jsxs("div", { className: h1(Rt.container, {
    [Rt.simplified]: s
  }), children: [
    /* @__PURE__ */ f.jsx("div", { className: Rt.logo, children: /* @__PURE__ */ f.jsx("a", { href: me.main, className: Rt.logoLink, onClick: i, ...s && {
      target: "_blank"
    }, children: /* @__PURE__ */ f.jsx(I6, { className: Rt.logoImg }) }) }),
    !s && /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      /* @__PURE__ */ f.jsxs("div", { className: Rt.leftPart, children: [
        !d && /* @__PURE__ */ f.jsx(g6, { className: Rt.search, onToggle: k, onEvent: n }),
        !e && /* @__PURE__ */ f.jsxs("div", { className: Rt.leftPartButtonGroup, children: [
          !m && /* @__PURE__ */ f.jsx(mT, {}),
          !v && /* @__PURE__ */ f.jsx(dT, {})
        ] })
      ] }),
      /* @__PURE__ */ f.jsxs("div", { className: Rt.rightPart, children: [
        a && /* @__PURE__ */ f.jsx(XT, { slotId: "1721512" }),
        !x && /* @__PURE__ */ f.jsx(T5, {})
      ] })
    ] }),
    !x && s && /* @__PURE__ */ f.jsx(T5, {})
  ] }) });
}
const Ua = "notifications-root";
function xN() {
  const e = () => {
    var t, n;
    if (window.gc_set_window_size) {
      const r = document.getElementById(Ua);
      window.gc_set_window_size(600, Math.min(456, Math.max(150, (n = (t = r == null ? void 0 : r.getBoundingClientRect()) == null ? void 0 : t.height) != null ? n : 456) + 30), !0);
    }
  };
  return u1(() => {
    if (J.isGCUserAgent && !document.getElementById("gc-script")) {
      J.setScriptTag({
        id: "gc-script",
        src: `//${J.DOMAIN}/js/gc.js`,
        onload: () => {
          e();
        }
      });
      const t = new ResizeObserver((r) => {
        for (const a of r)
          a.target.id === Ua && e();
      }), n = document.getElementById(Ua);
      n && t.observe(n);
    }
  }, []), /* @__PURE__ */ f.jsx(ta, { config: {
    preset: "store"
  }, children: /* @__PURE__ */ f.jsx(En, { children: /* @__PURE__ */ f.jsx(Is, { children: /* @__PURE__ */ f.jsx(Ht, { children: /* @__PURE__ */ f.jsx("div", { style: {
    padding: "12px 12px 0"
  }, children: /* @__PURE__ */ f.jsx(P6, {}) }) }) }) }) });
}
const R5 = "root";
function LN() {
  return O6(() => {
    var t, n;
    if (window.gc_set_window_size) {
      const r = document.getElementById(R5);
      window.gc_set_window_size(600, (n = (t = r == null ? void 0 : r.getBoundingClientRect()) == null ? void 0 : t.height) != null ? n : 520, !0);
    }
  }, R5), /* @__PURE__ */ f.jsx(ta, { config: {
    preset: "store"
  }, children: /* @__PURE__ */ f.jsx(En, { children: /* @__PURE__ */ f.jsx(Ht, { children: /* @__PURE__ */ f.jsx(_o, { open: !0, children: /* @__PURE__ */ f.jsx("div", { className: h1(vt.wishlist, vt.app), children: /* @__PURE__ */ f.jsx(j6, {}) }) }) }) }) });
}
const X = window.GameCenter || {
  /**
   * @const
   * @type {number}
   * @private
   */
  protoVersion: 3,
  /**
   * Auto timer period (ms).
   * Adjust before calling [GameCenter.init|#GameCenter.init].
   * @member {number} GameCenter.autoTimerPeriod
   */
  autoTimerPeriod: 1e3,
  /**
   * WebSocket transport enabled.
   * Adjust before calling [GameCenter.init|#GameCenter.init].
   * @member {boolean} GameCenter.wsEnabled
   */
  wsEnabled: !0,
  /**
   * WebSocket Tunnel transport enabled.
   * Adjust before calling [GameCenter.init|#GameCenter.init].
   * @member {boolean} GameCenter.wsTunEnabled
   */
  wsTunEnabled: !1,
  /**
   * CallIn enum
   * Call error
   * @const
   * @member {number} GameCenter.ciError
   */
  ciError: 0,
  /**
   * CallIn enum
   * Call success
   * @const
   * @member {number} GameCenter.ciSuccess
   */
  ciSuccess: 1,
  /**
   * PluginDetect enum
   * GameCenter not installed
   * @const
   * @member {number} GameCenter.pdError
   */
  pdError: 0,
  /**
   * PluginDetect enum
   * GameCenter installed but not launched
   * @const
   * @member {number} GameCenter.pdSuccessNotLaunched
   */
  pdSuccessNotLaunched: 1,
  /**
   * PluginDetect enum
   * GameCenter installed and launched
   * @const
   * @member {number} GameCenter.pdSuccess
   */
  pdSuccess: 2,
  /**
   * @const
   * @member {number} GameCenter.cStepStart
   * @protected
   */
  cStepStart: 0,
  /**
   * @const
   * @member {number} GameCenter.cStepInit
   * @protected
   */
  cStepInit: 1,
  /**
   * @const
   * @member {number} GameCenter.cStepDetect
   * @protected
   */
  cStepDetect: 2,
  /**
   * @const
   * @type {string}
   * @private
   */
  jsonFormat: "json",
  /**
   * @type {?function(*)}
   * @protected
   */
  onDispatch: null,
  /**
   * @type {?function()}
   * @protected
   */
  onInit: null,
  /**
   * @type {?function()}
   * @protected
   */
  onConnect: null,
  /**
   * @type {?function()}
   * @protected
   */
  onDisconnect: null,
  /**
   * @type {number}
   * @protected
   */
  step: 0,
  /**
   * @type {number}
   * @private
   */
  lastDetectState: -1,
  /**
   * @type {Object}
   * @private
   */
  wsHandle: null,
  /**
   * @type {Array<string>}
   * @private
   */
  wsQueue: [],
  /**
   * @type {Array<string>}
   * @protected
   */
  wsHost: ["127", "0", "0", "1"],
  /**
   * @type {string}
   * @protected
   */
  wsUrl: "",
  /**
   * @type {string}
   * @protected
   */
  wsTunUrlPrefix: "",
  /**
   * @type {string}
   * @private
   */
  wsTunName: "",
  /**
   * @type {number}
   * @private
   */
  wsTunPollNum: 0,
  /**
   * @type {HTMLImageElement}
   * @private
   */
  wsTunInitImg: null,
  /**
   * @type {Element}
   * @private
   */
  wsTunPollImg: null,
  /**
   * @param {string} key
   * @return {string}
   * @function
   * @protected
   */
  getCookie(e) {
    let t, n, r, a;
    for (t = `${e}=`, n = document.cookie.split(";"), r = 0; r < n.length; r++) {
      for (a = n[r]; a.charAt(0) === " "; )
        a = a.substring(1);
      if (a.indexOf(t) === 0)
        return a.substring(t.length, a.length);
    }
    return "";
  },
  /**
   * @param {HTMLImageElement} inputImage
   * @return {string}
   * @function
   * @private
   */
  decImg2Str(e) {
    let t, n, r, a, i, l, s, c, p;
    if (t = document.createElement("canvas"), t.width = e.width, t.height = e.height, n = t.getContext("2d"), n.globalCompositeOperation = "copy", n.mozImageSmoothingEnabled = !1, n.msImageSmoothingEnabled = !1, n.imageSmoothingEnabled = !1, n.drawImage(e, 0, 0), r = n.getImageData(0, 0, e.width, e.height), a = "", i = r.data.length, i < 4)
      return "";
    for (l = r.data[0] + (r.data[1] << 8) + (r.data[2] << 16), s = 4, c = 0; l > 0; ) {
      if (i <= s || (p = r.data[s++], ++c === 3 && (s++, c = 0), i <= s))
        return "";
      p += r.data[s++] << 8, ++c === 3 && (s++, c = 0), a += String.fromCharCode(p), l--;
    }
    return a;
  },
  /**
   * @param {string} inputString
   * @return {string}
   * @function
   * @private
   */
  encStr2Param(e) {
    let t, n, r, a, i;
    for (t = 0, n = ""; t < e.length; )
      r = e.charCodeAt(t), a = (r & 255).toString(16), i = (r >> 8 & 255).toString(16), a.length === 1 && (n += "0"), n += a, i.length === 1 && (n += "0"), n += i, t++;
    return n;
  },
  /**
   * @param {string} postFix
   * @param {function()} onImageLoad
   * @param {function()} onImageError
   * @return {HTMLImageElement}
   * @function
   * @private
   */
  createTunImage(e, t, n) {
    const r = new Image();
    return r.style.visibility = "hidden", r.crossOrigin = "Anonymous", r.onload = t, r.onerror = n, r.src = `${X.wsTunUrlPrefix + e}ac=${Math.random() * 1e5}`, r;
  },
  /**
   * @function
   * @private
   */
  tryTunReceive(e, t) {
    try {
      let n, r;
      n = X.decImg2Str(e), typeof n == "string" && (r = n.length > 0, r && X.wsQueue.push(n), t && X.scheduleTunPoll(r));
    } catch {
      X.wsTunName = "";
    }
  },
  /**
   * @function
   * @private
   */
  tryTunPoll(e) {
    X.wsTunName.length !== 0 && e === X.wsTunName && (X.wsTunPollImg = X.createTunImage(`${X.wsTunName}/poll.png?`, function() {
      X.tryTunReceive(this, !0);
    }, () => {
      X.wsTunName = "";
    }));
  },
  /**
   * @param {boolean} soon
   * @function
   * @private
   */
  scheduleTunPoll(e) {
    let t, n;
    n = X.wsTunName, e ? t = 100 : t = X.autoTimerPeriod, setTimeout(() => {
      X.tryTunPoll(n);
    }, t);
  },
  /**
   * @function
   * @private
   */
  tryTunInit() {
    X.wsTunInitImg = X.createTunImage("init.png?", () => {
      try {
        let e, t;
        e = X.decImg2Str(X.wsTunInitImg), t = JSON.parse(e), typeof t.Name == "string" && (X.wsTunName = t.Name, X.scheduleTunPoll(!0));
      } catch {
      }
      X.wsTunInitImg = null;
    }, () => {
      X.wsTunInitImg = null;
    });
  },
  /**
   * @function
   * @private
   */
  tryTunSend(e) {
    if (X.wsTunName.length === 0)
      return;
    const t = X.encStr2Param(e);
    X.createTunImage(`${X.wsTunName}/send.png?num=${X.wsTunPollNum.toString()}&param=${t}&`, function() {
      X.tryTunReceive(this, !1);
    }, () => {
      X.wsTunName = "";
    });
  },
  /**
   * @function
   * @private
   */
  callOut(e, t) {
    if (e === X.jsonFormat)
      try {
        const n = JSON.parse(t);
        X.onDispatch(n);
      } catch {
      }
  },
  /**
   * @return {boolean}
   * @function
   * @protected
   */
  isWSConnected() {
    return X.wsEnabled && X.wsHandle && X.wsHandle.readyState === WebSocket.OPEN;
  },
  /**
   * @return {boolean}
   * @function
   * @protected
   */
  isWSTunConnected() {
    return X.wsTunEnabled && X.wsTunName.length > 0;
  },
  /**
   * @param {string} dataType
   * @param {string} data
   * @return {number}
   * @function
   * @private
   */
  callIn(e, t) {
    if (e === X.jsonFormat) {
      if (X.isWSConnected())
        return X.wsHandle.send(t), X.ciSuccess;
      if (X.isWSTunConnected())
        return X.tryTunSend(t), X.ciSuccess;
    }
    return X.ciError;
  },
  /**
   * @function
   * @private
   */
  poll() {
    let e;
    for (; X.wsQueue.length > 0; )
      e = X.wsQueue.shift(), e.length !== 0 && X.callOut(X.jsonFormat, e);
  },
  /**
   * @function
   * @private
   */
  wsOnMessage(e) {
    try {
      e.data.length > 0 && X.wsQueue.push(e.data);
    } catch {
    }
  },
  /**
   * @function
   * @protected
   */
  autoTimer() {
    try {
      X.wsHandle ? X.wsHandle.readyState === WebSocket.CLOSED ? X.wsHandle = null : X.wsEnabled || X.wsHandle.close() : X.wsEnabled && (X.wsHandle = new WebSocket(X.wsUrl), X.wsHandle.onmessage = X.wsOnMessage);
    } catch {
    }
    try {
      X.wsTunEnabled && X.wsTunInitImg === null && X.wsTunName.length === 0 && X.tryTunInit();
    } catch {
    }
    try {
      if (X.step === X.cStepInit && (X.isWSConnected() || X.isWSTunConnected()) && (X.step = X.cStepDetect, X.onInit !== void 0 && X.onInit()), X.step === X.cStepDetect) {
        const e = X.detect();
        e !== X.lastDetectState && (X.lastDetectState = e, X.lastDetectState === X.pdSuccess ? X.onConnect !== void 0 && X.onConnect() : X.onDisconnect !== void 0 && X.onDisconnect()), X.lastDetectState === X.pdSuccess && X.poll();
      }
    } catch {
    }
    setTimeout(X.autoTimer, X.autoTimerPeriod);
  },
  /**
   * Initialize GameCenter plugin
   * @namespace GameCenter.init
   * @param {Element} detectorContainer HTML control that will contain
   *                 detector plugin instances.
   * @param {function(*)} onDispatch Callback function that receives
   *                   GameCenter messages.
   * @param {function()} onInit Called upon first success plugin init.
   * @param {function()} onConnect Called upon Gamecenter connected with plugin.
   * @param {function()} onDisconnect Called upon Gamecenter disconnected
   *                   from plugin.
   * @param {number} region 0 - vkplay.ru;
   *                 1 - my.games;
   * @function
   */
  init(e, t, n, r, a, i) {
    let l, s;
    X.step === X.cStepStart && (l = `${X.wsHost.join(".")}:`, i === 1 ? l += "51201" : l += "51200", X.wsUrl = `ws://${l}/detector`, X.wsTunUrlPrefix = `http://${l}/tun/`, typeof WebSocket != "function" && (X.wsEnabled = !1), s = document.createElement("canvas"), s.getContext && s.getContext("2d") || (X.wsTunEnabled = !1), window.location.protocol === "https:" ? X.wsEnabled = !1 : X.wsTunEnabled = !1, X.onDispatch = t, X.onInit = n, X.onConnect = r, X.onDisconnect = a, X.step = X.cStepInit, X.autoTimer());
  },
  /**
   * Detect GameCenter presence
   * @namespace GameCenter.detect
   * @return {number} refer to
   *                  [PluginDetect enum|#GameCenter.PluginDetect enum].
   * @function
   */
  detect() {
    return X.isWSConnected() || X.isWSTunConnected() ? X.pdSuccess : X.pdError;
  },
  /**
   * @param {*} obj
   * @return {number}
   * @function
   * @protected
   */
  callInJson(e) {
    const t = JSON.stringify(e);
    return X.callIn(X.jsonFormat, t);
  },
  /**
   * @param {*} obj
   * @function
   * @protected
   */
  fillCookies(e) {
    e.FirstLink = X.getCookie("mr1lad"), e.FirstLinkExt = X.getCookie("mr1lext"), e.FirstLinkUID = X.getCookie("mr1uid"), e.AdId = X.getCookie("adId"), e.FBC = X.getCookie("_fbc"), e.FBP = X.getCookie("_fbp"), e.GA = X.getCookie("_ga"), e.Cookiesync = X.getCookie("cookiesync");
  },
  // high level
  /**
   * Set Auth Code
   * @namespace GameCenter.setAuthCode
   * @param {string} code - AuthCode.
   * @param {number} force 0 - false use code only if current login is empty;
   *                       1 - true force using supplied code (replace existing login).
   * @param {number} typeId Game typeId.
   * @param {number} projectId Game projectId.
   * @param {number} remigrate 0 - false no remigration;
   *                           1 - true try remigrate to supplied game id after authorization.
   * @param {string} state - Native app auth state.
   * @return {number} refer to [CallIn enum|#GameCenter.CallIn enum].
   * @function
   * @example
   * web site should call GameCenter.setAuthCode after receiving getAuthCode
   * request object
   * {
   *   Method: 'GetAuthCode'
   * }
   */
  setAuthCode(e, t, n, r, a, i) {
    const l = {
      Method: "SetAuthCode"
    };
    return l.Code = e, l.Force = t, l.TypeId = n, l.ProjectId = r, l.Remigrate = a, l.State = i, X.callInJson(l);
  },
  /**
   * Play game
   * @namespace GameCenter.playGame
   * @param {number} typeId Game typeId.
   * @param {number} projectId Game projectId.
   * @param {number} startDownload start download (0 - false, 1 - true)
   * @param {string} adParams ad params (e.g. "_1lp=1&_1ld=123_456&mt_link_id=xxx&mt_sub1=yyy")
   * @return {number} refer to [CallIn enum|#GameCenter.CallIn enum].
   * @function
   * @example
   * upon completion "dispatch" callback will receive answer object:
   * {
   *   Method: 'PlayGame',
   *   Result: 0,
   *   ProjectId: 1177,
   *   TypeId: 0
   * }
    * Result {number} 0 - false (unable to play game);
   *                 1 - true (game launched);
   *
   */
  playGame(e, t, n, r) {
    const a = {
      Method: "PlayGame"
    };
    return a.TypeId = e, a.ProjectId = t, a.StartDownload = n, a.AdParams = r, X.fillCookies(a), X.callInJson(a);
  },
  /**
   * Show game
   * @namespace GameCenter.showGame
   * @param {number} typeId Game typeId.
   * @param {number} projectId Game projectId.
   * @param {number} startDownload start download (0 - false, 1 - true)
   * @param {string} adParams ad params (e.g. "_1lp=1&_1ld=123_456&mt_link_id=xxx&mt_sub1=yyy")
   * @return {number} refer to [CallIn enum|#GameCenter.CallIn enum].
   * @function
   * @example
   * upon completion "dispatch" callback will receive answer object:
   * {
   *   Method: 'ShowGame',
   *   Result: 0,
   *   ProjectId: 1177,
   *   TypeId: 0
   * }
    * Result {number} 0 - false (unable to show game);
   *                 1 - true (game showed);
   *
   */
  showGame(e, t, n, r) {
    const a = {
      Method: "ShowGame"
    };
    return a.TypeId = e, a.ProjectId = t, a.StartDownload = n, a.AdParams = r, X.fillCookies(a), X.callInJson(a);
  },
  /**
   * Send Support Report
   * @namespace GameCenter.sendSupportReport
   * @param {string} hash Support hash.
   * @param {number} typeId Game typeId.
   * @param {number} projectId Game projectId.
   * @return {number} refer to [CallIn enum|#GameCenter.CallIn enum].
   * @function
   * @example
   * upon completion "dispatch" callback will receive answer object:
   * {
   *   Method: 'SendSupportReport',
   *   Result: 0,
   *   Hash: '',
   *   Text: '',
   *   ProjectId: 1177,
   *   TypeId: 0
   * }
    * Result {number} 0 - false
   *                 1 - true
   *                 2 - interrupted
   *
   * Text {string}   'Game not found' - wrong TypeId+ProjectId specified
   *                 'Game not installed' - game not installed
   */
  sendSupportReport(e, t, n) {
    const r = {
      Method: "SendSupportReport"
    };
    return r.Hash = e, r.TypeId = t, r.ProjectId = n, X.callInJson(r);
  },
  /**
   * Show games showcase
   * @namespace GameCenter.showGamesShowcase
   * @return {number} refer to [CallIn enum|#GameCenter.CallIn enum].
   * @function
   */
  showGamesShowcase() {
    const e = {
      Method: "ShowGamesShowcase"
    };
    return X.fillCookies(e), X.callInJson(e);
  },
  /**
   * Set Ticket cookies
   * @namespace GameCenter.setTicket
   * @return {number} refer to [CallIn enum|#GameCenter.CallIn enum].
   * @function
   */
  setTicket() {
    const e = {
      Method: "SetTicket"
    };
    X.fillCookies(e);
    const t = X.getCookie("mr1lad_lps");
    return t.length > 0 && (e.FirstLink = t), X.callInJson(e);
  },
  /**
   * Set Stream Auth Code
   * @namespace GameCenter.setStreamAuthCode
   * @param {string} code - AuthCode.
   * @param {number} typeId Game typeId.
   * @param {number} projectId Game projectId.
   * @return {number} refer to [CallIn enum|#GameCenter.CallIn enum].
   * @function
   */
  setStreamAuthCode(e, t, n) {
    const r = {
      Method: "SetStreamAuthCode"
    };
    return r.Code = e, r.TypeId = t, r.ProjectId = n, X.callInJson(r);
  },
  /**
   * Become Streamer Finished
   * @namespace GameCenter.becomeStreamerFinished
   * @return {number} refer to [CallIn enum|#GameCenter.CallIn enum].
   * @function
   */
  becomeStreamerFinished() {
    const e = {
      Method: "BecomeStreamerFinished"
    };
    return X.callInJson(e);
  },
  /**
   * Set launcher foreground.
   * @namespace GameCenter.setForeground
   * @return {number} refer to [CallIn enum|#GameCenter.CallIn enum].
   * @function
   */
  setForeground() {
    const e = {
      Method: "SetForeground"
    };
    return X.callInJson(e);
  }
}, $i = "gc_download", uI = () => {
  window.dispatchEvent(new CustomEvent($i));
};
function X2(e, t, n) {
  return (t = dI(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function dI(e) {
  var t = fI(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function fI(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
class hI {
  constructor() {
    X2(this, "timeout", void 0), X2(this, "sessionChecked", void 0), X2(this, "gcDetected", void 0), X2(this, "toHandle", void 0), X2(this, "detectGameCenter", (t) => new Promise((r, a) => {
      typeof this.gcDetected != "undefined" && (this.gcDetected ? r() : a());
      const i = () => {
        const s = (t && t < 2 ? 2 : t) || this.timeout, c = () => {
          this.gcDetected = !0, clearTimeout(this.toHandle), r();
        }, p = () => {
          this.gcDetected = !1, clearTimeout(this.toHandle), a();
        }, h = () => {
          this.gcDetected = !1, clearTimeout(this.toHandle), a();
        }, u = () => {
          clearTimeout(this.toHandle);
        }, m = () => new Promise((x, k) => {
          this.sessionChecked ? x() : J.Backend.get(me.get_user).then(() => {
            this.sessionChecked = !0, x();
          }).catch((I) => {
            k(I);
          });
        });
        function d(x) {
          if (x.Method === "GetAuthCode") {
            const k = me.get_gc_auth;
            m().then(() => {
              J.Backend.get(k).then((I) => {
                !I.code || !I.code.length || window.GameCenter.setAuthCode(I.code);
              });
            });
          }
        }
        this.gcDetected || (this.toHandle = setTimeout(() => {
          h();
        }, s * 1e3));
        const v = document.createElement("div");
        v.style.width = "0", v.style.height = "0", v.style.visibility = "hidden", document.body.appendChild(v), window.GameCenter.wsTunEnabled = 1, window.GameCenter.init(v, d, u, c, p, 0);
      };
      window.GameCenter && i();
    })), X2(this, "detectAndDownload", (t, n, r, a) => {
      this.detectGameCenter(r).then(() => {
        this.downloadGame(t, n, a);
      }).catch((i) => {
        console.warn(i), this.downloadGame(t, n, a);
      });
    }), X2(this, "downloadGame", (t, n, r) => {
      const a = t || "";
      let i = n || "https://static.gc.vkplay.ru/VKPlayLoader.exe";
      if (!i)
        throw new Error("No gc_download_url in downloadGame");
      if (this.gcDetected && a) {
        const s = a.split("."), c = Number(s[0]), p = Number(s[1]), h = r == null ? void 0 : r.isFlash, u = r == null ? void 0 : r.adParams;
        if (Number.isNaN(c) || Number.isNaN(p))
          throw new Error("Invalid gc_id");
        return h ? (window.GameCenter.playGame(c, p, 1), !0) : (window.GameCenter.showGame(c, p, 1, u), !0);
      }
      setTimeout(() => {
        uI();
      }, 300);
      const l = document.createElement("iframe");
      return i.match(/^https:/) || (console.error(`download_url should be https: ${i}`), i = i.replace(/^\w+:/, "https:")), l.src = `${i}#${Math.random()}`, l.style.visibility = "hidden", l.style.width = "0px", l.style.height = "0px", l.style.left = "0px", l.style.bottom = "0px", l.style.position = "absolute", document.body.appendChild(l), !0;
    }), this.timeout = 3, this.gcDetected = void 0, this.sessionChecked = void 0, this.toHandle = void 0, window.GameCenter = X;
  }
}
const Yi = "show_steam_error", EN = () => {
  window.dispatchEvent(new CustomEvent(Yi));
};
function N5(e, t) {
  const n = new URL(window.location.href), r = new URLSearchParams(n.search);
  return r.set(e, t), `${n.origin}${n.pathname}?${r.toString()}`;
}
function _0(...e) {
  try {
    const t = new URL(window.location.href);
    e.forEach((n) => t.searchParams.delete(n)), window.history.pushState({}, "", t);
  } catch (t) {
    console.error("Error clearing URL params:", t);
  }
}
const pI = "_userAvatar_1x64p_1", mI = "_userName_1x64p_13", CI = "_description_1x64p_22", gI = "_licence_1x64p_41", Rn = {
  userAvatar: pI,
  userName: mI,
  description: CI,
  licence: gI
}, vI = ({
  profile: e,
  session: t
}) => {
  var n;
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx("div", { className: Rn.userAvatar, children: /* @__PURE__ */ f.jsx("img", { src: e == null ? void 0 : e.avatar, className: Rn.userAvatar, alt: "avatar" }) }),
    /* @__PURE__ */ f.jsxs("div", { className: Rn.info, children: [
      /* @__PURE__ */ f.jsxs("div", { className: Rn.userName, children: [
        "Привет,",
        " ",
        (n = t == null ? void 0 : t.profile_fields) == null ? void 0 : n.first_name
      ] }),
      /* @__PURE__ */ f.jsxs("p", { className: Rn.description, children: [
        "Вы вошли с помощью",
        " ",
        /* @__PURE__ */ f.jsx(b1, { name: "social-vk-filled" }),
        /* @__PURE__ */ f.jsx("span", { children: "ID" })
      ] }),
      /* @__PURE__ */ f.jsx("a", { href: "https://id.vk.com/terms", className: Rn.licence, target: "_blank", rel: "noopener noreferrer", children: "Пользовательское соглашение" })
    ] })
  ] });
}, H5 = {
  AUTOLOGIN_CHECK: `https://${bi}/api/v3/pub/social/vkid/autologin/check`,
  AUTH_REDIRECT: `https://${bi}/social/vkid`
}, wI = () => {
  const e = J.getCookie("noal"), t = navigator.userAgent.includes("HeadlessChrome"), n = J.query_string(window.location.href), {
    session: {
      profile: r,
      session: a
    }
  } = D1(bt), l = /^(?!https?:\/\/(?:[^/]+\.)?account\.(?:dev-)?vkplay\.ru(\/|$)).*$/i.test(window.location.href), [s, c] = r1({
    action: "",
    label: ""
  }), {
    pushReachGoal: p
  } = le(), h = ({
    action: d,
    label: v
  }) => p({
    params: {
      category: "login",
      action: d,
      ...v && {
        label: v
      }
    }
  });
  u1(() => {
    s.action && h(s);
  }, [s.action]);
  const u = W1(() => {
    try {
      const d = new URL(H5.AUTH_REDIRECT);
      d.searchParams.set("autologin", "1"), d.searchParams.set("continue", `${me.social_back}?continue=${N5("autologin", "success")}`), d.searchParams.set("failure", N5("autologin", "failure")), window.location.href = d.toString();
    } catch (d) {
      console.error(d, "Parse url error");
    }
  }, []), m = () => {
    try {
      J.Backend.get(H5.AUTOLOGIN_CHECK).then((d) => {
        d.need_autologin && n.autologin !== "failure" && u(), d.need_autologin || (c({
          action: "auto_login_failed",
          label: "sezam"
        }), _0("autologin", "error_code"));
      }).catch((d) => {
        c({
          action: "auto_login_failed",
          label: "sezam"
        }), _0("autologin", "error_code"), console.error("Autologin check failed:", d);
      });
    } catch (d) {
      console.error("Autologin check failed:", d);
    }
  };
  return u1(() => {
    !e && l && !t && m();
  }, [e, l]), u1(() => {
    n.autologin === "success" && r ? (_0("autologin"), c({
      action: "auto_login_success",
      label: ""
    }), setTimeout(() => {
      P2.sendMessage({
        content: /* @__PURE__ */ f.jsx(vI, { profile: r, session: a })
      });
    }, 300)) : n.autologin === "failure" && (c({
      action: "auto_login_failed",
      label: "vkid | sezam"
    }), _0("autologin", "error_code"));
  }, [r]), null;
}, yI = "_footer_10lag_11", bI = "_simplified_10lag_33", _I = "_container_10lag_39", xI = "_baseText_10lag_52", LI = "_baseLink_10lag_52", EI = "_link_10lag_59", MI = "_copyrightWrapper_10lag_68", kI = "_age_10lag_75", SI = "_copyright_10lag_68", AI = "_top_10lag_94", TI = "_grid_10lag_102", II = "_column_10lag_114", RI = "_title_10lag_128", NI = "_marker_10lag_129", HI = "_columnList_10lag_177", OI = "_aside_10lag_184", jI = "_langTitle_10lag_196", PI = "_social_10lag_202", DI = "_socialButtons_10lag_207", VI = "_bottom_10lag_213", BI = "_separator_10lag_222", FI = "_links_10lag_232", ZI = "_bottomContent_10lag_241", we = {
  footer: yI,
  simplified: bI,
  container: _I,
  baseText: xI,
  baseLink: LI,
  link: EI,
  copyrightWrapper: MI,
  age: kI,
  copyright: SI,
  top: AI,
  grid: TI,
  column: II,
  title: RI,
  marker: NI,
  columnList: HI,
  aside: OI,
  langTitle: jI,
  social: PI,
  socialButtons: DI,
  bottom: VI,
  separator: BI,
  links: FI,
  bottomContent: ZI
}, xr = {
  catalog: {
    id: "menu.store",
    defaultMessage: "Каталог игр"
  },
  catalogAvailable: {
    id: "menu.store.play",
    defaultMessage: "Доступно на VK Play"
  },
  catalogFree: {
    id: "menu.store.free",
    defaultMessage: "Бесплатно"
  },
  catalogDiscounts: {
    id: "menu.store.sale",
    defaultMessage: "Скидки"
  },
  catalogMyGames: {
    id: "menu.store.my",
    defaultMessage: "Мои игры"
  }
}, Lr = {
  cloud: {
    id: "menu.cloud",
    defaultMessage: "Облачный гейминг"
  },
  cloudMain: {
    id: "menu.main",
    defaultMessage: "Главная"
  },
  cloudRates: {
    id: "menu.cloud.plans",
    defaultMessage: "Тарифы"
  },
  cloudDownload: {
    id: "menu.cloud.download",
    defaultMessage: "Скачать"
  },
  cloudFAQ: {
    id: "menu.cloud.faq",
    defaultMessage: "FAQ"
  }
}, za = {
  market: {
    id: "menu.market",
    defaultMessage: "Маркет"
  },
  goods: {
    id: "menu.market.goods",
    defaultMessage: "Игровые товары"
  },
  refill: {
    id: "menu.market.refill_balance",
    defaultMessage: "Пополнение баланса"
  }
}, qa = {
  streams: {
    id: "menu.live",
    defaultMessage: "Стримы"
  },
  categories: {
    id: "menu.live.categories",
    defaultMessage: "Категории"
  },
  often: {
    id: "menu.live.often",
    defaultMessage: "Часто стримят"
  },
  chill: {
    id: "menu.live.chill",
    defaultMessage: "Ламповый поток"
  },
  online: {
    id: "menu.live.online",
    defaultMessage: "Сейчас в эфире"
  }
}, Er = {
  media: {
    id: "menu.media",
    defaultMessage: "Медиа"
  },
  allMaterials: {
    id: "menu.media.all",
    defaultMessage: "Все материалы"
  },
  gameNews: {
    id: "menu.media.game_news",
    defaultMessage: "Новости игр"
  },
  articles: {
    id: "menu.media.articles",
    defaultMessage: "Статьи"
  },
  guides: {
    id: "menu.media.guides",
    defaultMessage: "Руководства"
  }
}, $a = {
  tourney: {
    id: "menu.pvp",
    defaultMessage: "Турниры"
  },
  review: {
    id: "menu.pvp.overview",
    defaultMessage: "Обзор"
  },
  allTourneys: {
    id: "menu.pvp.tournaments",
    defaultMessage: "Все турниры"
  }
}, x0 = {
  other: {
    id: "footer.other.other",
    defaultMessage: "Другое"
  },
  developers: {
    id: "footer.other.developers",
    defaultMessage: "Разработчикам"
  },
  contacts: {
    id: "footer.other.contacts",
    defaultMessage: "Контакты"
  },
  support: {
    id: "profile.support",
    defaultMessage: "Служба поддержки"
  }
}, GI = {
  terms: {
    id: "footer.nav.terms",
    defaultMessage: "Пользовательское соглашение"
  },
  policy: {
    id: "footer.nav.policy",
    defaultMessage: "Политика конфиденциальности"
  },
  use_recs: {
    id: "footer.use_recs",
    defaultMessage: "Правила применения рекомендательных технологий"
  },
  imprint: {
    id: "footer.imprint",
    defaultMessage: "Информация о компании"
  }
}, V6 = {
  language: {
    id: "app.language",
    defaultMessage: "Язык"
  },
  social: {
    id: "footer.social",
    defaultMessage: "Социальные сети"
  }
}, WI = [{
  title: xr.catalog,
  href: `https://${Ke}/play/`
}, {
  title: xr.catalogAvailable,
  href: `https://${Ke}/play/`
}, {
  title: xr.catalogFree,
  href: `https://${Ke}/play/is_free/`
}, {
  title: xr.catalogDiscounts,
  href: `https://${Ke}/play/sale/`
}, {
  title: xr.catalogMyGames,
  href: `https://${qr}/profile/games`
}], UI = [{
  title: Lr.cloud,
  href: `https://${en}`
}, {
  title: Lr.cloudMain,
  href: `https://${en}/`
}, {
  title: Lr.cloudRates,
  href: `https://${en}/#plans_calculator`
}, {
  title: Lr.cloudDownload,
  href: `https://${en}/dashboard/download/`
}, {
  title: Lr.cloudFAQ,
  href: `https://${en}/dashboard/faq/`
}], zI = [{
  title: za.market,
  href: `https://${jn}/`
}, {
  title: za.goods,
  href: `https://${jn}/`
}, {
  title: za.refill,
  href: `https://${jn}/shop/255/`
}], qI = [{
  title: qa.streams,
  href: `https://${Ke}/live/`
}, {
  title: qa.often,
  href: `https://${Ke}/live/`
}, {
  title: qa.online,
  href: `https://${Ke}/live/`
}], $I = [{
  title: Er.media,
  href: `https://${M2}/`
}, {
  title: Er.allMaterials,
  href: `https://${M2}/`
}, {
  title: Er.gameNews,
  href: `https://${M2}/news/`
}, {
  title: Er.articles,
  href: `https://${M2}/feat/`
}, {
  title: Er.guides,
  href: `https://${M2}/secret/`
}], YI = [{
  title: $a.tourney,
  href: `https://${On}/`
}, {
  title: $a.review,
  href: `https://${On}/`
}, {
  title: $a.allTourneys,
  href: `https://${On}/tournaments`
}], KI = [{
  title: x0.other,
  href: ""
}, {
  title: x0.developers,
  href: `https://${Ew}/welcome`
}, {
  title: x0.contacts,
  href: `https://${tn}/contacts`
}, {
  title: x0.support,
  href: `https://${ea}/`
}], B6 = {
  terms: `https://${tn}/terms_vkp/tou_vkp`,
  policy: {
    ru_RU: `https://${tn}/terms_vkp/privacy_vkp`,
    en_US: `https://${tn}/terms_vkp/privacy_world_vkp`
  },
  use_recs: `https://${tn}/terms_vkp/adv_algo_rules`,
  imprint: `https://${tn}/terms_vkp/imprint_vkp`
}, QI = [{
  id: "catalog",
  data: WI
}, {
  id: "cloud",
  data: UI
}, {
  id: "market",
  data: zI
}, {
  id: "live",
  data: qI
}, {
  id: "media",
  data: $I
}, {
  id: "pvp",
  data: YI
}, {
  id: "other",
  data: KI
}], XI = [{
  href: "https://vk.com/play",
  icon: "social-vk"
}, {
  href: "https://t.me/vkplay_ru",
  icon: "social-telegram"
}, {
  href: "https://dzen.ru/vkpm",
  icon: "social-dzen"
}];
function JI({
  name: e
}) {
  const {
    locale: t
  } = D1(U2), n = B6[e], r = x2(GI[e]);
  return /* @__PURE__ */ f.jsx(
    "a",
    {
      className: h1(we.baseLink, we.link),
      href: typeof n == "string" ? n : n[t],
      children: r
    },
    r
  );
}
function eR() {
  const {
    locale: e
  } = D1(U2), t = e === "ru_RU" ? "ООО «ВК». Все права защищены. Все товарные знаки являются собственностью их владельцев." : "VK LLC. All rights reserved. All trademarks are the property of their respective owners.", n = `© ${(/* @__PURE__ */ new Date()).getFullYear()} ${t}`;
  return /* @__PURE__ */ f.jsxs("div", { className: we.bottom, children: [
    /* @__PURE__ */ f.jsx("div", { className: we.separator }),
    /* @__PURE__ */ f.jsxs("div", { className: we.bottomContent, children: [
      /* @__PURE__ */ f.jsxs("div", { className: we.copyrightWrapper, children: [
        /* @__PURE__ */ f.jsx("p", { className: we.age, children: "18+" }),
        /* @__PURE__ */ f.jsx("p", { className: h1(we.baseText, we.copyright), children: n })
      ] }),
      /* @__PURE__ */ f.jsx("div", { className: we.links, "data-id": "footer__bottom-links", children: Object.keys(B6).map((r) => /* @__PURE__ */ f.jsx(JI, { name: r }, r)) })
    ] })
  ] });
}
function tR({
  title: e,
  href: t
}) {
  const n = x2(e);
  return /* @__PURE__ */ f.jsx("a", { className: h1(we.baseText, we.link), href: t, target: "_blank", rel: "noreferrer", children: n }, n);
}
function nR({
  column: e
}) {
  const {
    tabletSmMax: t
  } = Ue(["tabletSmMax"]), [n, ...r] = e.data, a = x2(n.title), i = t ? "details" : "div";
  return /* @__PURE__ */ f.jsxs(i, { "data-id": `footer__column_${e.id}`, className: we.column, open: !t, children: [
    /* @__PURE__ */ f.jsxs("summary", { className: we.title, children: [
      !t && n.href ? /* @__PURE__ */ f.jsx("a", { href: n.href, target: "_blank", rel: "noreferrer", children: a }) : a,
      /* @__PURE__ */ f.jsx(b1, { name: "chevron-right", className: we.marker })
    ] }),
    /* @__PURE__ */ f.jsx("div", { className: we.columnList, children: r.map((l, s) => (
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ f.jsx(tR, { ...l }, `${s}-${l.href}`)
    )) })
  ] });
}
function rR() {
  return /* @__PURE__ */ f.jsx("div", { className: we.grid, children: QI.map((e) => /* @__PURE__ */ f.jsx(nR, { column: e }, e.id)) });
}
function O5() {
  const {
    formatMessage: e
  } = N1();
  return /* @__PURE__ */ f.jsxs("div", { "data-id": "footer__social", className: we.social, children: [
    /* @__PURE__ */ f.jsx("p", { className: we.baseText, children: `${e(V6.social)}:` }),
    /* @__PURE__ */ f.jsx("div", { className: we.socialButtons, children: XI.map((t) => /* @__PURE__ */ f.jsx(q1, { component: "a", href: t.href, target: "_blank", rel: "noopener noreferrer", appearance: "neutral", mode: "primary", size: "lg", leftIcon: /* @__PURE__ */ f.jsx(b1, { name: t.icon }) }, t.icon)) })
  ] });
}
function aR() {
  const {
    tabletSmMax: e
  } = Ue(["tabletSmMax"]), {
    formatMessage: t
  } = N1();
  return /* @__PURE__ */ f.jsxs("div", { className: we.top, children: [
    e && /* @__PURE__ */ f.jsx(O5, {}),
    /* @__PURE__ */ f.jsx(rR, {}),
    /* @__PURE__ */ f.jsxs("div", { className: we.aside, children: [
      /* @__PURE__ */ f.jsx(bs, { isMobile: e, tooltipId: "footer-lang", title: /* @__PURE__ */ f.jsx("p", { className: h1(we.baseText, we.langTitle), children: `${t(V6.language)}:` }) }),
      !e && /* @__PURE__ */ f.jsx(O5, {})
    ] })
  ] });
}
function j5() {
  const {
    simplified: e,
    footerSelector: t
  } = D1(rt), n = /* @__PURE__ */ f.jsx("footer", { className: h1(we.footer, {
    [we.simplified]: e
  }), children: /* @__PURE__ */ f.jsxs("div", { className: we.container, children: [
    /* @__PURE__ */ f.jsx(aR, {}),
    /* @__PURE__ */ f.jsx(eR, {})
  ] }) });
  return e && t ? /* @__PURE__ */ f.jsx(Z2, { into: t, children: /* @__PURE__ */ f.jsx(En, { children: n }) }) : n;
}
const iR = "_popupContainer_q7il7_29", oR = "_overlay_q7il7_38", sR = "_isFirefox_q7il7_57", lR = "_isOpera_q7il7_58", cR = "_isYaBrowser_q7il7_59", uR = "_isIE_q7il7_68", dR = "_isSafari_q7il7_69", fR = "_isIE11_q7il7_73", hR = "_isEdge_q7il7_74", pR = "_text_q7il7_88", mR = "_isChrome_q7il7_101", CR = "_isChromium_q7il7_102", gR = "_isChromeTopBar_q7il7_110", vR = "_isOpera12_q7il7_127", wR = "_arrow_q7il7_137", yR = "_isShaking_q7il7_159", bR = "_shake_q7il7_1", _R = "_shakeRotate_q7il7_1", p2 = {
  popupContainer: iR,
  overlay: oR,
  isFirefox: sR,
  isOpera: lR,
  isYaBrowser: cR,
  isIE: uR,
  isSafari: dR,
  isIE11: fR,
  isEdge: hR,
  text: pR,
  isChrome: mR,
  isChromium: CR,
  isChromeTopBar: gR,
  isOpera12: vR,
  arrow: wR,
  isShaking: yR,
  shake: bR,
  shakeRotate: _R
}, P5 = {
  overlayStep1: {
    id: "gc.download.steps.one",
    defaultMessage: "Кликните на файл"
  },
  overlayStep2: {
    id: "gc.download.steps.two",
    defaultMessage: "Нажмите «Запустить»"
  }
}, xR = {
  detect: function() {
    Array.prototype.map || (Array.prototype.map = function(h, u) {
      let m, d, v;
      if (this == null)
        throw new TypeError(" this is null or not defined");
      const x = Object(this), k = x.length >>> 0;
      if (typeof h != "function")
        throw new TypeError(`${h} is not a function`);
      for (u && (m = u), d = new Array(k), v = 0; v < k; ) {
        let I, T;
        v in x && (I = x[v], T = h.call(m, I, v, x), d[v] = T), v++;
      }
      return d;
    });
    const e = function() {
    }, t = {
      browser_parsers: [{
        regex: "(OPR)/(\\d+)\\.(\\d+)\\.(\\d+)",
        family_replacement: "Opera"
      }, {
        regex: "(YaBrowser)/(\\d+)\\.(\\d+)\\.(\\d+)"
      }, {
        regex: "(Edge)/(\\d+)\\.(\\d+)",
        family_replacement: "Edge"
      }, {
        regex: "(Edg)/(\\d+)\\.(\\d+)",
        family_replacement: "Edge"
      }, {
        regex: "(Namoroka|Shiretoko|Minefield)/(\\d+)\\.(\\d+)\\.(\\d+(?:pre)?)",
        family_replacement: "Firefox ($1)"
      }, {
        regex: "(Firefox)/(\\d+)\\.(\\d+)(a\\d+[a-z]*)",
        family_replacement: "Firefox Alpha"
      }, {
        regex: "(Firefox)/(\\d+)\\.(\\d+)(b\\d+[a-z]*)",
        family_replacement: "Firefox Beta"
      }, {
        regex: "(Firefox)-(?:\\d+\\.\\d+)?/(\\d+)\\.(\\d+)(a\\d+[a-z]*)",
        family_replacement: "Firefox Alpha"
      }, {
        regex: "(Firefox)-(?:\\d+\\.\\d+)?/(\\d+)\\.(\\d+)(b\\d+[a-z]*)",
        family_replacement: "Firefox Beta"
      }, {
        regex: "(Namoroka|Shiretoko|Minefield)/(\\d+)\\.(\\d+)([ab]\\d+[a-z]*)?",
        family_replacement: "Firefox ($1)"
      }, {
        regex: "(MozillaDeveloperPreview)/(\\d+)\\.(\\d+)([ab]\\d+[a-z]*)?"
      }, {
        regex: "(Firefox)/(\\d+)\\.(\\d+)\\.(\\d+(?:pre)?) \\(Swiftfox\\)",
        family_replacement: "Swiftfox",
        other: !0
      }, {
        regex: "(Firefox)/(\\d+)\\.(\\d+)([ab]\\d+[a-z]*)? \\(Swiftfox\\)",
        family_replacement: "Swiftfox",
        other: !0
      }, {
        regex: "(AdobeAIR|Chromium|FireWeb|Jasmine|ANTGalio|Midori|Fresco|Lobo|PaleMoon|Maxthon|Lynx|OmniWeb|Dillo|Camino|Demeter|Fluid|Fennec|Shiira|Sunrise|Chrome|Flock|Netscape|Lunascape|WebPilot|NetFront|Netfront|Konqueror|SeaMonkey|Kazehakase|Vienna|Iceape|Iceweasel|IceWeasel|Iron|K-Meleon|Sleipnir|Galeon|GranParadiso|Opera Mini|iCab|NetNewsWire|ThunderBrowse|Iron|Iris|UP\\.Browser|Bunjaloo|Google Earth|Raven for Mac)/(\\d+)\\.(\\d+)\\.(\\d+)"
      }, {
        regex: "(Edge|Bolt|Jasmine|IceCat|Skyfire|Midori|Maxthon|Lynx|Arora|IBrowse|Dillo|Camino|Shiira|Fennec|Phoenix|Chrome|Flock|Netscape|Lunascape|Epiphany|WebPilot|Opera Mini|Opera|NetFront|Netfront|Konqueror|Googlebot|SeaMonkey|Kazehakase|Vienna|Iceape|Iceweasel|IceWeasel|Iron|K-Meleon|Sleipnir|Galeon|GranParadiso|iCab|NetNewsWire|Iron|Space Bison|Stainless|Orca|Dolfin|BOLT|Minimo|Tizen Browser|Polaris)/(\\d+)\\.(\\d+)"
      }, {
        regex: "(iRider|Crazy Browser|SkipStone|iCab|Lunascape|Sleipnir|Maemo Browser) (\\d+)\\.(\\d+)\\.(\\d+)"
      }, {
        regex: "(iCab|Lunascape|Opera|Android|Jasmine|Polaris|BREW) (\\d+)\\.(\\d+)\\.?(\\d+)?"
      }, {
        regex: "(MSIE) (\\d+)\\.(\\d+).*XBLWP7",
        family_replacement: "IE Large Screen"
      }, {
        regex: "(Firefox)/(\\d+)\\.(\\d+)\\.(\\d+)"
      }, {
        regex: "(Firefox)/(\\d+)\\.(\\d+)(pre|[ab]\\d+[a-z]*)?"
      }, {
        regex: "(AppleWebKit)/(\\d+)\\.?(\\d+)?\\+ .* Version/\\d+\\.\\d+.\\d+ Safari/",
        family_replacement: "WebKit Nightly"
      }, {
        regex: "(Version)/(\\d+)\\.(\\d+)(?:\\.(\\d+))?.*Safari/",
        family_replacement: "Safari"
      }, {
        regex: "(Safari)/\\d+"
      }, {
        regex: "Trident(.*)rv.(\\d+)\\.(\\d+)",
        family_replacement: "IE"
      }, {
        regex: "(MSIE) (\\d+)\\.(\\d+)",
        family_replacement: "IE"
      }],
      os_parsers: [{
        regex: "(Windows (?:NT 5\\.2|NT 5\\.1))",
        os_replacement: "Windows XP"
      }, {
        regex: "(Windows NT 6\\.1)",
        os_replacement: "Windows 7"
      }, {
        regex: "(Windows NT 6\\.0)",
        os_replacement: "Windows Vista"
      }, {
        regex: "(Windows 98|Windows XP|Windows ME|Windows 95|Windows CE|Windows 7|Windows NT 4\\.0|Windows Vista|Windows 2000)"
      }, {
        regex: "(Windows NT 6\\.2)",
        os_replacement: "Windows 8"
      }, {
        regex: "(Windows NT 5\\.0)",
        os_replacement: "Windows 2000"
      }, {
        regex: "(WinNT4.0)",
        os_replacement: "Windows NT 4.0"
      }, {
        regex: "(Win98)",
        os_replacement: "Windows 98"
      }, {
        regex: "(Mac OS X) (\\d+)[_.](\\d+)(?:[_.](\\d+))?",
        manufacturer: "Apple"
      }, {
        regex: "(?:PPC|Intel) (Mac OS X)",
        manufacturer: "Apple"
      }],
      mobile_os_families: [],
      device_parsers: [],
      mobile_browser_families: []
    };
    e.parsers = ["device_parsers", "browser_parsers", "os_parsers", "mobile_os_families", "mobile_browser_families"], e.types = ["browser", "os", "device"], e.regexes = t || function() {
      const h = {};
      return e.parsers.map((u) => {
        h[u] = [];
      }), h;
    }(), e.families = function() {
      const h = {};
      return e.types.map((u) => {
        h[u] = [];
      }), h;
    }();
    const r = Array.prototype.forEach, a = function(h, u) {
      let m = {};
      for (let d = 0; d < u.length && (m = u[d](h), !m); d++)
        ;
      return m;
    }, i = function(h, u) {
      l(h, (m) => {
        l(u, (d) => {
          delete m[d];
        });
      });
    }, l = function(h, u, m) {
      if (h != null)
        if (r && h.forEach === r)
          h.forEach(u, m);
        else if (h.length === +h.length)
          for (let d = 0, v = h.length; d < v; d++)
            u.call(m, h[d], d, h);
        else
          for (const d in h)
            _.has(h, d) && u.call(m, h[d], d, h);
    }, s = function(h) {
      return !!(h && typeof h != "undefined" && h != null);
    }, c = function(h) {
      let u = "";
      return h = h || {}, s(h) && s(h.major) && (u += h.major, s(h.minor) && (u += `.${h.minor}`, s(h.patch) && (u += `.${h.patch}`))), u;
    }, p = function(h) {
      h = h || {};
      let u = c(h);
      return u && (u = ` ${u}`), h && s(h.family) ? h.family + u : "";
    };
    return e.parse = function(h) {
      const u = function(T) {
        return e.regexes[`${T}_parsers`].map((L) => {
          const S = new RegExp(L.regex), E = L[`${T === "browser" ? "family" : T}_replacement`], j = L.major_version_replacement;
          function g(w) {
            const C = w.match(S);
            if (!C) return null;
            const b = {};
            return b.family = (E ? E.replace("$1", C[1]) : C[1]) || "other", b.major = parseInt(j || C[2]) || null, b.minor = C[3] ? parseInt(C[3]) : null, b.patch = C[4] ? parseInt(C[4]) : null, b.tablet = L.tablet, b.man = L.manufacturer || null, b;
          }
          return g;
        });
      }, m = function() {
      }, d = u("browser"), v = u("os"), x = u("device"), k = new m();
      k.source = h, k.browser = a(h, d), s(k.browser) ? (k.browser.name = p(k.browser), k.browser.version = c(k.browser)) : k.browser = {}, k.os = a(h, v), s(k.os) ? (k.os.name = p(k.os), k.os.version = c(k.os)) : k.os = {}, k.device = a(h, x), s(k.device) ? (k.device.name = p(k.device), k.device.version = c(k.device)) : k.device = {
        tablet: !1,
        family: "Other"
      };
      const I = {};
      return k.browser.family === "Spider" ? k.device.type = "Spider" : k.browser.tablet || k.os.tablet || k.device.tablet ? k.device.type = "Tablet" : I.hasOwnProperty(k.browser.family) ? k.device.type = "Mobile" : k.device.type = "Desktop", k.device.manufacturer = k.browser.man || k.os.man || k.device.man || null, i([k.browser, k.os, k.device], ["tablet", "man"]), k;
    }, e;
  }
}, F6 = xR.detect().parse(navigator.userAgent), Rr = F6.browser.family, D5 = F6.browser.major, LR = () => `is${Rr}`, ER = () => Rr.toLowerCase() === "chrome" && +D5 >= 115 ? `is${Rr}TopBar` : `is${Rr}${D5}`, Ya = LR(), Ka = ER(), MR = () => {
  const [e, t] = r1(!1), {
    formatMessage: n
  } = N1(), r = () => {
    t(!0);
  }, a = () => {
    t(!1);
  };
  return u1(() => (window.addEventListener($i, r), () => {
    window.removeEventListener($i, r);
  }), []), !e || Rr.toLowerCase() === "safari" ? null : /* @__PURE__ */ f.jsx(Z2, { into: "body", children: /* @__PURE__ */ f.jsxs("div", { className: h1(p2.popupContainer, {
    [p2[Ya]]: Ya && p2[Ya],
    [p2[Ka]]: Ka && p2[Ka]
  }), children: [
    /* @__PURE__ */ f.jsx(Je, { className: p2.overlay, onMouseDown: a, onClick: () => {
    } }),
    /* @__PURE__ */ f.jsx("div", { className: h1(p2.arrow, p2.isShaking), children: /* @__PURE__ */ f.jsx(b1, { name: "arrow-down-outline" }) }),
    /* @__PURE__ */ f.jsx("div", { className: p2.text, children: /* @__PURE__ */ f.jsxs("ol", { children: [
      /* @__PURE__ */ f.jsx("li", { children: n(P5.overlayStep1) }),
      /* @__PURE__ */ f.jsx("li", { children: n(P5.overlayStep2) })
    ] }) })
  ] }) });
}, G0 = "gem_tech_popup_closed", kR = $r && !window.location.pathname.includes("about") || Iw || as || so, SR = () => {
  try {
    return window.localStorage.getItem(G0) === "1";
  } catch {
    return console.warn("Error getting storage item", G0), !1;
  }
}, AR = () => {
  try {
    window.localStorage.setItem(G0, "1");
  } catch {
    console.warn("Error setting storage item", G0);
  }
};
function TR({
  notification: e,
  onClose: t
}) {
  return /* @__PURE__ */ f.jsx(yo, { notification: e, onClose: t });
}
const IR = "_popupContainer_1udoe_1", RR = {
  popupContainer: IR
}, NR = "_wrapper_10eu7_1", HR = "_close_10eu7_10", OR = "_title_10eu7_41", jR = "_text_10eu7_50", Mr = {
  wrapper: NR,
  close: HR,
  title: OR,
  text: jR
}, PR = ({
  onClose: e
}) => {
  const t = () => {
    AR(), e();
  };
  return /* @__PURE__ */ f.jsxs("div", { className: Mr.wrapper, children: [
    /* @__PURE__ */ f.jsx("button", { className: Mr.close, onClick: t, children: /* @__PURE__ */ f.jsx(b1, { name: "close" }) }),
    /* @__PURE__ */ f.jsx("div", { className: Mr.title, children: "VK Play применяет рекомендательные технологии" }),
    /* @__PURE__ */ f.jsx("div", { className: Mr.text, children: "Вы можете ознакомиться с правилами применения рекомендательных технологий" }),
    /* @__PURE__ */ f.jsx(q1, { component: "a", href: `${me.devdocs}/terms_vkp/adv_algo_rules`, target: "_blank", rel: "noopener noreferrer", className: Mr.btn, onClick: t, appearance: "overlay", size: "sm", children: "Узнать больше" })
  ] });
};
function DR() {
  const {
    list: e,
    onReadNotification: t
  } = D1(c2), {
    hiddenElements: n
  } = D1(rt), {
    offsetLeft: r
  } = _s("#vkp-navbar"), [a, i] = r1([]), [l, s] = r1([]), {
    tabletMdMin: c
  } = Ue(["tabletMdMin"]), {
    pushReachGoal: p
  } = le();
  u1(() => {
    const m = [];
    !SR() && !(n != null && n.includes(nn.RecPopup)) && kR && m.push(/* @__PURE__ */ f.jsx(PR, { onClose: u })), i((v) => [...m, ...v]);
  }, []), u1(() => {
    if (!c) return;
    const m = [], d = [];
    e.length > 0 && m.push(...e.filter((v) => !v.is_read && !l.includes(v.id) && v.needs_bubble).map((v) => (d.push(v.id), /* @__PURE__ */ f.jsx(TR, { notification: v, onClose: h }, v.id)))), i((v) => [...v, ...m]), s((v) => [...v, ...d]);
  }, [e.length]), u1(() => {
    const m = e.findIndex((d) => d.removeBubble);
    if (m !== -1) {
      const d = l.indexOf(e[m].id);
      d !== -1 && (i((v) => v.filter((x, k) => k !== d)), s((v) => v.filter((x, k) => k !== d)));
    }
  }, [e]);
  function h(m) {
    t(m), i((d) => d.slice(1)), p({
      params: {
        category: "notifications",
        action: "close"
      }
    });
  }
  function u() {
    i((m) => m.slice(1));
  }
  return a.length === 0 ? null : /* @__PURE__ */ f.jsx("div", { className: RR.popupContainer, style: {
    transform: `translateX(${r}px)`
  }, children: a[0] });
}
const V5 = {
  text: {
    id: "app.stub.safari",
    defaultMessage: "Сервис может некорректно работать в Safari. Для стабильной работы рекомендуем использовать другой браузер."
  },
  textShort: {
    id: "app.stub.safari.short",
    defaultMessage: "Сервис может некорректно работать в Safari"
  }
}, VR = "_container_e0edg_1", BR = "_notice_e0edg_9", B5 = {
  container: VR,
  notice: BR
}, FR = () => {
  const {
    formatMessage: e
  } = N1(), {
    tabletMdMax: t
  } = Ue(["tabletMdMax"]);
  return /* @__PURE__ */ f.jsx("div", { className: B5.container, children: /* @__PURE__ */ f.jsxs("div", { className: B5.notice, children: [
    /* @__PURE__ */ f.jsx(b1, { name: "error-circle" }),
    e(t ? V5.textShort : V5.text)
  ] }) });
}, kr = {
  steamErrorDialog: {
    id: "steam.error.dialog",
    defaultMessage: "Действие недоступно"
  },
  steamErrorTitle: {
    id: "steam.error.title",
    defaultMessage: "Действие недоступно пользователям, вошедшим в VK Play через Steam."
  },
  steamErrorText: {
    id: "steam.error.text",
    defaultMessage: "Используйте другой аккаунт."
  },
  logout: {
    id: "profile.logout",
    defaultMessage: "Выйти из аккаунта"
  },
  close: {
    id: "app.close",
    defaultMessage: "Закрыть"
  }
}, ZR = () => {
  const [e, t] = r1(!1), {
    formatMessage: n
  } = N1(), r = () => {
    t(!0);
  }, a = () => {
    t(!1);
  }, i = () => {
    window.location.href = lo();
  };
  return u1(() => (window.addEventListener(Yi, r), () => {
    window.removeEventListener(Yi, r);
  }), []), /* @__PURE__ */ f.jsx(Fr, { open: e, onClose: a, type: "dialog", title: n(kr.steamErrorDialog), modalOptions: {
    description: `${n(kr.steamErrorTitle)} ${n(kr.steamErrorText)}`,
    successText: n(kr.logout),
    noSuccessText: n(kr.close),
    onSuccess: i,
    isSuccessAccent: !0
  }, zIndex: 1e6 });
};
function Z6(e) {
  return new URL(e, window.location.origin).pathname;
}
function F5(e, t) {
  const n = t === "exclude" ? e.exclude : e.include, r = e.allowPartialMatch, a = window.location.pathname;
  return n != null && n.length ? !!n.find((i) => {
    const l = Z6(i);
    return r ? a.includes(l) : l === a;
  }) : !1;
}
function GR({
  preset: e,
  subnav: t,
  currentPathname: n
}) {
  var s;
  if (!e)
    return {
      schema: [],
      label: ""
    };
  const r = (s = n || window.location.pathname) == null ? void 0 : s.replace("/gamecenter/", "/"), a = R6[e], i = a == null ? void 0 : a.label;
  return console.debug("current", r), {
    schema: (t || (a == null ? void 0 : a.subnav) || []).map((c) => {
      var d;
      const p = Z6((d = c.href) == null ? void 0 : d.replace("/gamecenter/", "/")), h = c.allowPartialMatch ? r.includes(p) : p === r, u = F5(c, "include"), m = F5(c, "exclude");
      return console.debug("current_active", h), console.debug("current_included", u), {
        ...c,
        isActive: h && !m || u
      };
    }).filter((c) => !(e === "store" && c.id === "my")),
    label: i
  };
}
function WR() {
}
const UR = "_subnav_1202q_7", zR = "_visible_1202q_26", qR = "_menu_1202q_36", $R = "_link_1202q_55", YR = "_current_1202q_78", KR = "_container_1202q_101", QR = "_title_1202q_111", XR = "_cnt_1202q_122", JR = "_slot_1202q_128", Yt = {
  subnav: UR,
  visible: zR,
  menu: qR,
  link: $R,
  current: YR,
  container: KR,
  title: QR,
  cnt: XR,
  slot: JR
}, Z5 = 36, eN = ({
  id: e,
  isActive: t,
  href: n,
  onClick: r,
  label: a
}) => {
  const i = x2(a);
  return /* @__PURE__ */ f.jsx("a", { id: `eva-subnav-${e}`, className: h1(Yt.link, {
    [Yt.current]: t
  }), href: n, onClick: r, children: i }, n);
}, tN = () => {
  const {
    preset: e,
    subnav: t,
    subnavSlot: n,
    onSubnavClick: r,
    subnavTitleCnt: a,
    currentPathname: i
  } = D1(rt), l = V1(null), {
    schema: s,
    label: c
  } = GR({
    preset: e,
    subnav: t,
    currentPathname: i
  }), p = x2(c), {
    pushReachGoal: h
  } = le();
  function u() {
    const x = l.current;
    if (!x || x.scrollWidth <= x.clientWidth)
      return;
    const k = x.getElementsByClassName(Yt.current)[0];
    if (!k)
      return;
    const I = k.getBoundingClientRect();
    if (I.left < 0) {
      x.scrollLeft = x.scrollLeft + I.left - Z5;
      return;
    }
    I.right > window.innerWidth && (x.scrollLeft = x.scrollLeft + I.right - window.innerWidth + Z5);
  }
  if (u1(() => {
    u();
  }, []), !(s != null && s.length))
    return null;
  const m = !!s.find((x) => x.isActive), d = typeof a == "number";
  function v(x) {
    return (k) => {
      if (h({
        params: {
          category: "header",
          action: "subnav_click",
          label: x.analyticsLabel || `ph-subnav-${e}-${x.id}`
        }
      }), x.onClick) {
        x.onClick(k, x.id), setTimeout(u, 0);
        return;
      }
      if (r) {
        r(k, x.id), setTimeout(u, 0);
        return;
      }
      return WR;
    };
  }
  return /* @__PURE__ */ f.jsxs("div", { className: h1(Yt.subnav, {
    [Yt.visible]: m
  }), children: [
    /* @__PURE__ */ f.jsx("div", { className: Yt.menu, ref: l, children: s.map((x) => /* @__PURE__ */ U6(eN, { ...x, key: x.href, onClick: v(x) })) }),
    /* @__PURE__ */ f.jsxs("div", { className: Yt.container, children: [
      /* @__PURE__ */ f.jsxs("span", { className: Yt.title, children: [
        p,
        d && /* @__PURE__ */ f.jsx("span", { className: Yt.cnt, children: a })
      ] }),
      /* @__PURE__ */ f.jsx("div", { className: Yt.slot, children: n })
    ] })
  ] });
}, nN = e4(tN), G6 = {
  position: "bottom-center",
  className: "snackbar-toaster",
  theme: "dark",
  offset: 24,
  visibleToasts: 3
}, rN = {
  ...G6,
  position: "top-center",
  offset: 12
}, aN = "_wrapper_f5d4j_21", iN = "_simplified_f5d4j_28", oN = "_appShell_f5d4j_34", sN = "_appGameCenter_f5d4j_51", lN = "_shellContent_f5d4j_56", cN = "_mainAppContent_f5d4j_63", L2 = {
  wrapper: aN,
  simplified: iN,
  appShell: oN,
  appGameCenter: sN,
  shellContent: lN,
  mainAppContent: cN
}, uN = () => {
  const {
    onReady: e,
    ...t
  } = D1(rt), n = D1(U2);
  return u1(() => {
    e && e({
      props: t,
      intl: n
    });
  }, []), null;
}, dN = {
  scroll_top: {
    id: "button.scroll_top",
    defaultMessage: "Подняться вверх"
  }
}, fN = "_root_o56np_1", hN = "_visible_o56np_20", pN = "_centered_o56np_26", mN = "_icon_o56np_31", L0 = {
  root: fN,
  visible: hN,
  centered: pN,
  icon: mN
};
let Qa = 0, Xa = 0;
const CN = ({
  topOffset: e = 24
}) => {
  const t = N1(), {
    simplified: n
  } = D1(rt), r = document.getElementById("custom-scroller") || window, a = J.inGamecenter, [i, l] = r1(!1);
  function s(u) {
    Qa = u <= 0 ? 0 : u;
  }
  function c(u) {
    Xa = u;
  }
  function p() {
    let u, m;
    if (a && r instanceof HTMLElement ? (u = r.scrollTop, m = r.offsetHeight) : (u = window.scrollY, m = window.innerHeight), u < m) {
      l(!1), s(u);
      return;
    }
    u > Qa ? (u > Xa && c(u), l(!1)) : u < Qa && u + 100 < Xa && (c(u), l(!0)), s(u);
  }
  u1(() => (r.addEventListener("scroll", p, {
    passive: !0
  }), () => {
    r.removeEventListener("scroll", p);
  }), []);
  function h() {
    r.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }
  return /* @__PURE__ */ f.jsx(q1, { className: h1(L0.root, {
    [L0.visible]: i,
    [L0.centered]: a || n
  }), style: {
    top: e
  }, appearance: "overlay", onClick: h, leftIcon: /* @__PURE__ */ f.jsx(b1, { className: L0.icon, name: "arrow-down-outline" }), children: t.formatMessage(dN.scroll_top) });
}, Ja = new KL(), MN = ({
  children: e,
  appNode: t,
  containerType: n,
  ...r
}) => {
  const a = V1(null), {
    simplified: i,
    scrollTopButtonOffset: l
  } = r, {
    tabletSmMax: s,
    tabletMdMax: c
  } = Ue(["tabletSmMax", "tabletMdMax"]), p = J.inGamecenter || r.hideNavGC, h = p || r.hideNav, u = p || r.hideFooter, m = r.hideNav && r.hideFooter, d = r.hideScrollTopButton;
  function v(T, L) {
    T.replaceChildren(L);
  }
  if ((J.getCookie("sidebar_state") || void 0) === e2.NARROW && document.body.classList.add("sidebarPersist", "sidebarNarrow"), u1(() => {
    !t || !a.current || v(a.current, t);
  }, [t, a]), typeof window == "undefined")
    return e;
  const k = /* @__PURE__ */ f.jsxs("div", { className: h1({
    [L2.appGameCenter]: J.inGamecenter && !m
  }), id: "vkp-app-shell", children: [
    !h && /* @__PURE__ */ f.jsx(Ht, { children: /* @__PURE__ */ f.jsx(Na, { client: Ja, children: /* @__PURE__ */ f.jsx(I5, {}) }) }),
    /* @__PURE__ */ f.jsx("main", { className: L2.mainAppContent, ref: a, children: e }),
    !u && /* @__PURE__ */ f.jsx(Ht, { children: /* @__PURE__ */ f.jsx(j5, {}) })
  ] }), I = h ? z6 : Is;
  return /* @__PURE__ */ f.jsxs(ta, { config: r, children: [
    /* @__PURE__ */ f.jsxs(En, { className: h1(L2.wrapper, {
      [L2.simplified]: i
    }), theme: "dark", children: [
      i ? k : /* @__PURE__ */ f.jsx(I, { children: /* @__PURE__ */ f.jsxs("div", { className: h1(L2.appShell, {
        [L2.appGameCenter]: J.inGamecenter && !m
      }), id: "vkp-app-shell", children: [
        !J.inGamecenter && /* @__PURE__ */ f.jsx(wI, {}),
        !h && /* @__PURE__ */ f.jsx(Ht, { children: /* @__PURE__ */ f.jsx(Na, { client: Ja, children: /* @__PURE__ */ f.jsx(wk, { children: /* @__PURE__ */ f.jsx(TA, {}) }) }) }),
        /* @__PURE__ */ f.jsxs("div", { className: L2.shellContent, children: [
          !r.hideNav && /* @__PURE__ */ f.jsxs(Ht, { children: [
            !p && Tr && !c && /* @__PURE__ */ f.jsx(FR, {}),
            !p && /* @__PURE__ */ f.jsx(Na, { client: Ja, children: /* @__PURE__ */ f.jsx(I5, {}) }),
            /* @__PURE__ */ f.jsx(nN, {})
          ] }),
          /* @__PURE__ */ f.jsx("main", { className: L2.mainAppContent, style: {
            container: `app / ${n}`
          }, ref: a, children: e }),
          !h && /* @__PURE__ */ f.jsx(Ht, { children: /* @__PURE__ */ f.jsx(DR, {}) }),
          !u && /* @__PURE__ */ f.jsx(Ht, { children: /* @__PURE__ */ f.jsx(j5, {}) })
        ] })
      ] }) }),
      /* @__PURE__ */ f.jsxs(Ht, { children: [
        /* @__PURE__ */ f.jsx(Ax, { ...G6, ...s && rN }),
        !d && /* @__PURE__ */ f.jsx(CN, { topOffset: l }),
        !p && /* @__PURE__ */ f.jsx(eT, {}),
        /* @__PURE__ */ f.jsx(ZR, {}),
        /* @__PURE__ */ f.jsx(MR, {})
      ] })
    ] }),
    /* @__PURE__ */ f.jsx(Ht, { children: /* @__PURE__ */ f.jsx(uN, {}) })
  ] });
}, gN = "1.0.33";
window.EVA_VERSION = gN;
const kN = new hI();
export {
  xN as NotificationApp,
  TA as Sidebar,
  _N as TermsDialogApp,
  I5 as TopNav,
  LN as WishlistApp,
  MN as default,
  kN as gc,
  R6 as schema,
  uI as showDownloadHint,
  Bs as showLogin,
  EN as showSteamError,
  P2 as snackbar
};
//# sourceMappingURL=index.es.js.map
